var NA = (e) => {
  throw TypeError(e);
};
var fc = (e, t, n) => t.has(e) || NA("Cannot " + n);
var N = (e, t, n) => (fc(e, t, "read from private field"), n ? n.call(e) : t.get(e)), ye = (e, t, n) => t.has(e) ? NA("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), ue = (e, t, n, r) => (fc(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), He = (e, t, n) => (fc(e, t, "access private method"), n);
var fs = (e, t, n, r) => ({
  set _(i) {
    ue(e, t, i, n);
  },
  get _() {
    return N(e, t, r);
  }
});
import { jsx as A, jsxs as D, Fragment as Be } from "react/jsx-runtime";
import * as w from "react";
import _, { forwardRef as Nt, useLayoutEffect as Kn, useEffect as Ie, useState as q, useRef as Ce, useCallback as me, useReducer as C9, useMemo as ve, createElement as bi, useContext as Oa, createContext as Ml, Component as I9, Fragment as mr, useSyncExternalStore as m0, memo as Hr, isValidElement as Kr, cloneElement as yu } from "react";
import * as zl from "react-dom";
import v0, { createPortal as E9, flushSync as x9 } from "react-dom";
function B9(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in e)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(e, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function w9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 9 12", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.31744 6.36794C8.56085 6.17515 8.56085 5.82482 8.31744 5.63203L1.3527 0.115704C1.01647 -0.150574 0.499999 0.072258 0.499999 0.483647L0.5 11.5163C0.5 11.9277 1.01647 12.1506 1.3527 11.8843L8.31744 6.36794Z" }) });
}
function P9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "none", stroke: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      d: "M8 1L0.999998 8M0.999998 8L8 15M0.999998 8L15 8",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function H9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 21", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M9.98893 18.8223C14.5914 18.8223 18.3223 15.0913 18.3223 10.4889C18.3223 5.88642 14.5914 2.15559 9.98893 2.15559C5.38643 2.15559 1.6556 5.88642 1.6556 10.4889C1.6556 15.0913 5.38643 18.8223 9.98893 18.8223ZM9.98893 14.6556C9.52893 14.6556 9.1556 14.2825 9.1556 13.8223L9.1556 9.65559L6.6556 9.65559L9.98893 6.32226L13.3223 9.65559L10.8223 9.65559L10.8223 13.8223C10.8223 14.2825 10.4489 14.6556 9.98893 14.6556Z" }) });
}
function O9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12.0104 2.66602C11.2738 2.66602 10.6771 3.26268 10.6771 3.99935V11.9993C10.6771 12.736 11.2738 13.3327 12.0104 13.3327H13.3438C14.0804 13.3327 14.6771 12.736 14.6771 11.9993V3.99935C14.6771 3.26268 14.0804 2.66602 13.3438 2.66602H12.0104ZM7.34375 5.33268C6.60708 5.33268 6.01042 5.92935 6.01042 6.66602V11.9993C6.01042 12.736 6.60708 13.3327 7.34375 13.3327H8.67708C9.41375 13.3327 10.0104 12.736 10.0104 11.9993V6.66602C10.0104 5.92935 9.41375 5.33268 8.67708 5.33268H7.34375ZM2.67708 7.99935C1.94042 7.99935 1.34375 8.59602 1.34375 9.33268V11.9993C1.34375 12.736 1.94042 13.3327 2.67708 13.3327H4.01042C4.74708 13.3327 5.34375 12.736 5.34375 11.9993V9.33268C5.34375 8.59602 4.74708 7.99935 4.01042 7.99935H2.67708Z" }) });
}
function D9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M16.1557 6.42331C16.6148 5.98332 16.6148 5.26997 16.1557 4.82999C15.6967 4.39 14.9525 4.39 14.4935 4.82999L7.84438 11.2033C7.83003 11.217 7.81614 11.231 7.80268 11.2453C7.79259 11.256 7.78275 11.2669 7.77314 11.2779C7.38661 11.7205 7.41032 12.3808 7.84427 12.7967L14.4933 19.17C14.9524 19.61 15.6966 19.61 16.1556 19.17C16.6146 18.7301 16.6146 18.0167 16.1556 17.5767L10.3377 12.0001L16.1557 6.42331Z" }) });
}
function S9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.84427 17.5767C7.38524 18.0167 7.38524 18.73 7.84427 19.17C8.30329 19.61 9.04752 19.61 9.50653 19.17L16.1556 12.7967C16.17 12.783 16.1839 12.769 16.1973 12.7547C16.2074 12.744 16.2173 12.7331 16.2269 12.7221C16.6134 12.2795 16.5897 11.6192 16.1557 11.2033L9.50665 4.82997C9.04762 4.39001 8.3034 4.39001 7.84438 4.82997C7.38535 5.26992 7.38535 5.98332 7.84438 6.42328L13.6623 11.9999L7.84427 17.5767Z" }) });
}
function N9(e) {
  return /* @__PURE__ */ A(
    "svg",
    {
      ...e,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "currentcolor",
      children: /* @__PURE__ */ A("path", { d: "M4.67064 1.99414C3.19797 1.99414 2.00397 3.18814 2.00397 4.66081V11.3275C2.00397 12.8001 3.19797 13.9941 4.67064 13.9941H11.3373C12.81 13.9941 14.004 12.8001 14.004 11.3275V4.66081C14.004 3.18814 12.81 1.99414 11.3373 1.99414H4.67064ZM6.64997 3.32747C7.01797 3.32147 7.33131 3.60547 7.33731 3.97347C7.34331 4.34147 7.05931 4.65481 6.69131 4.66081C6.30331 4.66747 6.00864 4.94547 6.00397 5.32747C6.00264 5.42081 6.0053 5.42681 6.00397 5.51481C5.99464 6.23681 5.98063 6.49414 5.89997 6.82747C5.82863 7.11947 5.6493 7.48214 5.39997 7.99414C5.65197 8.51147 5.82797 8.87081 5.89997 9.16081C5.98663 9.51147 5.9993 9.77014 6.00397 10.5775C6.00397 10.6215 6.00397 10.6155 6.00397 10.6608C6.00664 11.0635 6.2673 11.3275 6.67064 11.3275C7.03864 11.3275 7.33731 11.6261 7.33731 11.9941C7.33731 12.3621 7.03864 12.6608 6.67064 12.6608C5.52464 12.6601 4.6773 11.7881 4.67064 10.6608C4.67064 10.6155 4.67064 10.6215 4.67064 10.5775C4.66664 9.88414 4.65997 9.70281 4.60797 9.49414C4.55197 9.26814 4.44797 9.0488 4.06663 8.28613C3.97263 8.09813 3.97263 7.89015 4.06663 7.70215C4.4393 6.95748 4.55264 6.72281 4.60797 6.49414C4.65664 6.29481 4.66264 6.11081 4.67064 5.49414C4.67197 5.40681 4.6693 5.42147 4.67064 5.32747C4.68464 4.22481 5.53997 3.34614 6.64997 3.32747ZM9.33731 3.32747C10.4606 3.33747 11.3466 4.21947 11.3373 5.32747C11.3306 6.07347 11.3446 6.27614 11.4 6.49414C11.456 6.71481 11.5366 6.89282 11.9413 7.70215C12.0353 7.89015 12.0353 8.09813 11.9413 8.28613C11.5466 9.07547 11.456 9.27147 11.4 9.49414C11.3453 9.71147 11.3353 9.89814 11.3373 10.6608C11.3406 11.7935 10.4746 12.6655 9.33731 12.6608C8.96931 12.6595 8.66931 12.3621 8.67064 11.9941C8.67197 11.6261 8.96931 11.3261 9.33731 11.3275C9.73264 11.3288 10.0053 11.0555 10.004 10.6608C10.0013 9.77481 10.0153 9.52881 10.108 9.16081C10.18 8.87414 10.3513 8.51947 10.608 7.99414C10.3473 7.46281 10.1806 7.11214 10.108 6.82747C10.0133 6.45547 9.99664 6.19747 10.004 5.32747C10.0073 4.95814 9.72731 4.66414 9.33731 4.66081C8.96931 4.65747 8.66731 4.36214 8.67064 3.99414C8.67397 3.62614 8.96931 3.32414 9.33731 3.32747Z" })
    }
  );
}
function T9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12.0283 1.99805C10.3713 1.99805 9.02832 3.34105 9.02832 4.99805C9.02832 6.26605 9.86732 7.40607 11.0263 7.82507L11.0283 10.998H7.02832C6.47632 10.998 6.02832 11.446 6.02832 11.998L6.02731 16.173C4.87631 16.569 4.02832 17.73 4.02832 18.998C4.02832 20.655 5.37132 21.998 7.02832 21.998C8.68532 21.998 10.0283 20.655 10.0283 18.998C10.0283 17.73 9.23332 16.612 8.03932 16.16L8.02832 12.998H12.0283H16.0283L16.0353 16.175C14.8343 16.592 14.0283 17.73 14.0283 18.998C14.0283 20.655 15.3713 21.998 17.0283 21.998C18.6853 21.998 20.0283 20.655 20.0283 18.998C20.0283 17.73 19.2093 16.614 18.0363 16.17L18.0283 11.998C18.0283 11.446 17.5803 10.998 17.0283 10.998H13.0283L13.0253 7.82104C14.1893 7.41004 15.0283 6.26605 15.0283 4.99805C15.0283 3.34105 13.6853 1.99805 12.0283 1.99805Z" }) });
}
function R9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 18 19", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.27293 3.26461C8.46408 3.26461 8.61903 3.10949 8.61904 2.91815L8.6191 0.500008C6.2185 0.599662 4.06088 1.64036 2.50446 3.26475L8.27293 3.26461ZM10.6957 6.82116C10.6957 7.0125 10.5407 7.16762 10.3496 7.16762L0.304562 7.16782C0.613333 6.01248 1.14583 4.94828 1.85198 4.02532L10.3496 4.02518C10.5408 4.02518 10.6957 4.1803 10.6957 4.37166L10.6957 6.82116ZM15.4943 15.7353C13.9385 17.3591 11.7809 18.3997 9.37968 18.5L9.37974 16.0819C9.37974 15.8905 9.5347 15.7354 9.72585 15.7354L15.4943 15.7353ZM8.61928 18.4994C6.21868 18.3999 4.06051 17.3587 2.50477 15.735L8.2732 15.7348C8.46437 15.7348 8.61934 15.89 8.61933 16.0813L8.61928 18.4994ZM13.196 12.1777C13.196 11.9864 13.3509 11.8313 13.5421 11.8312L17.6942 11.831C17.3854 12.9863 16.8536 14.0499 16.1468 14.9735L13.5421 14.9737C13.3509 14.9737 13.1959 14.8186 13.1959 14.6272L13.196 12.1777ZM6.63574 8.26583C6.64045 8.07793 6.79397 7.92806 6.98174 7.92805L17.8631 7.92797C17.953 8.43803 18 8.96317 18 9.49919C18 10.0352 17.9529 10.5604 17.8631 11.0704L6.98317 11.07C6.79504 11.0699 6.64138 10.9195 6.63718 10.7312L6.6074 9.39625L6.63574 8.26583ZM12.5542 14.6279C12.5542 14.8192 12.3992 14.9743 12.2081 14.9743L1.85233 14.9744C1.14562 14.0509 0.613778 12.9873 0.305062 11.832L12.2081 11.8319C12.3993 11.8319 12.5543 11.987 12.5543 12.1784L12.5542 14.6279ZM0.136912 7.92839L5.5227 7.92809C5.71386 7.92809 5.86883 8.08321 5.86883 8.27457L5.86877 10.7241C5.86877 10.9154 5.71381 11.0705 5.52266 11.0706L0.136834 11.0708C0.046996 10.5608 -1.44252e-05 10.0356 -1.12058e-06 9.49961C1.02767e-05 8.9636 0.0470512 8.43845 0.136912 7.92839ZM11.4567 4.3716C11.4567 4.18026 11.6117 4.02515 11.8028 4.02514L16.1471 4.02498C16.8538 4.94851 17.3856 6.01207 17.6943 7.1674L11.8028 7.1676C11.6116 7.1676 11.4567 7.01248 11.4567 6.82112L11.4567 4.3716ZM9.3801 0.500001C11.7807 0.599542 13.9389 1.64073 15.4946 3.26444L9.72617 3.26457C9.53501 3.26458 9.38004 3.10945 9.38004 2.9181L9.3801 0.500001Z" }) });
}
function L9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.33203 1.99414C5.85936 1.99414 4.66536 3.18814 4.66536 4.66081H3.9987C2.61203 4.66081 1.50204 5.72481 1.37337 7.07747C1.71071 7.19281 6.22803 8.70282 6.22803 8.70215C7.18469 9.02148 8.8127 9.02148 9.76937 8.70215C9.76937 8.70215 13.224 7.54881 14.6447 7.07747C14.5214 5.71947 13.3887 4.66081 11.9987 4.66081H11.332C11.332 3.18814 10.138 1.99414 8.66536 1.99414H7.33203ZM7.33203 3.32747H8.66536C9.40203 3.32747 9.9987 3.92414 9.9987 4.66081H5.9987C5.9987 3.92414 6.59536 3.32747 7.33203 3.32747ZM1.33203 8.47347V11.3275C1.33203 12.8001 2.52603 13.9941 3.9987 13.9941H11.9987C13.4714 13.9941 14.6654 12.8001 14.6654 11.3275V8.47347L10.186 9.97347C8.95603 10.3835 7.04136 10.3835 5.81136 9.97347L1.33203 8.47347Z" }) });
}
function F9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.00586 2.01367C7.45356 2.01367 7.00586 2.46167 7.00586 3.01367C4.79676 3.01367 3.00576 4.80467 3.00586 7.01367V8.07568L21.0059 8.01367V7.01367C21.0059 4.80467 19.215 3.01367 17.0059 3.01367C17.0059 2.46167 16.5582 2.01367 16.0059 2.01367C15.4536 2.01367 15.0059 2.46167 15.0059 3.01367H9.00586C9.00586 2.46167 8.55816 2.01367 8.00586 2.01367ZM3.00586 10.0137V17.0137C3.00586 19.2227 4.79676 21.0137 7.00586 21.0137H17.0059C19.215 21.0137 21.006 19.2227 21.0059 17.0137V10.0137H3.00586ZM8.00586 12.0137C8.55816 12.0137 9.00586 12.4617 9.00586 13.0137C9.00586 13.5657 8.55816 14.0137 8.00586 14.0137C7.45356 14.0137 7.00586 13.5657 7.00586 13.0137C7.00586 12.4617 7.45356 12.0137 8.00586 12.0137ZM12.0059 12.0137C12.5582 12.0137 13.0059 12.4617 13.0059 13.0137C13.0059 13.5657 12.5582 14.0137 12.0059 14.0137C11.4536 14.0137 11.0059 13.5657 11.0059 13.0137C11.0059 12.4617 11.4536 12.0137 12.0059 12.0137ZM16.0059 12.0137C16.5582 12.0137 17.0059 12.4617 17.0059 13.0137C17.0059 13.5657 16.5582 14.0137 16.0059 14.0137C15.4536 14.0137 15.0059 13.5657 15.0059 13.0137C15.0059 12.4617 15.4536 12.0137 16.0059 12.0137ZM8.00586 15.0137C8.55816 15.0137 9.00586 15.4617 9.00586 16.0137C9.00586 16.5657 8.55816 17.0137 8.00586 17.0137C7.45356 17.0137 7.00586 16.5657 7.00586 16.0137C7.00586 15.4617 7.45356 15.0137 8.00586 15.0137ZM12.0059 15.0137C12.5582 15.0137 13.0059 15.4617 13.0059 16.0137C13.0059 16.5657 12.5582 17.0137 12.0059 17.0137C11.4536 17.0137 11.0059 16.5657 11.0059 16.0137C11.0059 15.4617 11.4536 15.0137 12.0059 15.0137ZM16.0059 15.0137C16.5582 15.0137 17.0059 15.4617 17.0059 16.0137C17.0059 16.5657 16.5582 17.0137 16.0059 17.0137C15.4536 17.0137 15.0059 16.5657 15.0059 16.0137C15.0059 15.4617 15.4536 15.0137 16.0059 15.0137Z" }) });
}
function Q9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.28221 5.22951C3.98888 4.9235 3.51331 4.9235 3.21999 5.22951C2.92667 5.53552 2.92667 6.03168 3.21999 6.33769L7.46885 10.7704C7.47802 10.78 7.48736 10.7892 7.49688 10.7982C7.50402 10.8049 7.51125 10.8115 7.51858 10.8179C7.81368 11.0756 8.25385 11.0598 8.53115 10.7705L12.78 6.33777C13.0733 6.03175 13.0733 5.5356 12.78 5.22958C12.4867 4.92357 12.0111 4.92357 11.7178 5.22958L8.00004 9.10822L4.28221 5.22951Z"
    }
  ) });
}
function X9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10 16L10 12.8L10 11.2L10 8L14 12L10 16Z" }) });
}
function V9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12 3C7.0293 3 3 7.0293 3 12C3 16.9707 7.0293 21 12 21C16.9707 21 21 16.9707 21 12C21 7.0293 16.9707 3 12 3ZM15.6 9.3C15.8304 9.3 16.0707 9.37741 16.2471 9.55291C16.5981 9.90481 16.5981 10.4952 16.2471 10.8471L12.8721 14.1942C11.8362 15.2292 10.2531 15.0744 9.4404 13.8558L8.54041 12.5058C8.26501 12.0927 8.38019 11.5167 8.79419 11.2404C9.20729 10.965 9.78329 11.0802 10.0596 11.4942L10.9596 12.8442C11.1414 13.1169 11.3745 13.1601 11.6058 12.9279L14.9529 9.55291C15.1293 9.37741 15.3696 9.3 15.6 9.3Z" }) });
}
function k9(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 24 24", fill: "none", children: [
    /* @__PURE__ */ A("circle", { cx: "12", cy: "12", r: "10", fill: "none" }),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M10.1575 16.8849C10.5032 16.8849 10.8257 16.7467 11.0562 16.5162L18.3142 9.25817L16.517 7.46094L10.1575 13.8204L7.48473 11.1476L5.6875 12.9448L9.25893 16.5162C9.48934 16.7467 9.81192 16.8849 10.1575 16.8849Z",
        fill: "currentcolor"
      }
    ),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M2.51367 12C2.51367 6.75314 6.76701 2.5 12.0137 2.5C17.2603 2.5 21.5137 6.75314 21.5137 12C21.5137 17.2468 17.2603 21.5 12.0137 21.5C6.76701 21.5 2.51367 17.2468 2.51367 12Z",
        stroke: "currentcolor"
      }
    )
  ] });
}
function M9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10.1575 16.8849C10.5032 16.8849 10.8257 16.7467 11.0562 16.5162L18.3142 9.25817L16.517 7.46094L10.1575 13.8204L7.48473 11.1476L5.6875 12.9448L9.25893 16.5162C9.48934 16.7467 9.81192 16.8849 10.1575 16.8849Z" }) });
}
function z9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "none", stroke: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      d: "M6 9L12 15L18 9",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function j9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("circle", { cx: "8", cy: "8", r: "6.665" }) });
}
function W9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12 3C7.02948 3 3 7.0293 3 12C3 16.9707 7.02948 21 12 21C16.9705 21 21 16.9707 21 12C21 7.0293 16.9705 3 12 3ZM12 6.6C12.4971 6.6 12.9 7.0032 12.9 7.5V11.6058L15.3469 14.0529C15.6984 14.4048 15.6984 14.9952 15.3469 15.3471C14.9954 15.6981 14.4046 15.6981 14.0531 15.3471L11.3531 12.6471C11.1843 12.4779 11.1 12.2385 11.1 12V7.5C11.1 7.0032 11.5029 6.6 12 6.6Z" }) });
}
function Z9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12.0137 3.99043C10.8277 4.00043 9.59167 4.33942 8.51367 4.95942C8.03467 5.23442 7.86367 5.85542 8.13867 6.33442C8.41367 6.81342 9.03467 6.95347 9.51367 6.67847C10.2927 6.23047 11.1717 5.99742 12.0137 5.99042C14.6947 5.96942 17.0347 8.27742 17.0137 10.9904C17.0137 11.0504 17.0137 11.8534 17.0137 12.0844C17.0137 12.5504 17.3097 12.9794 17.7637 13.0844C19.0797 13.3884 20.0137 14.3904 20.0137 15.4904C20.0137 15.8464 19.9357 16.2034 19.7637 16.5224C19.5017 17.0074 19.6837 17.6034 20.1697 17.8654C20.6557 18.1284 21.2517 17.9454 21.5137 17.4594C21.8417 16.8524 22.0137 16.1824 22.0137 15.4904C22.0137 13.6764 20.8217 12.1095 19.0097 11.3765C19.0117 11.1985 19.0137 11.0174 19.0137 10.9904C19.0437 7.15542 15.8047 3.96143 12.0137 3.99043ZM5.01367 5.99042C4.75767 5.99042 4.48968 6.07647 4.29468 6.27247C3.90468 6.66247 3.90468 7.31941 4.29468 7.70941L5.40268 8.80542C5.29468 9.03042 5.24667 9.28445 5.19067 9.54345C3.28667 10.3735 2.01367 12.2084 2.01367 14.3654C2.01367 17.3754 4.38968 19.9904 7.32568 19.9904H16.5757L17.2947 20.7094C17.6857 21.1004 18.3417 21.1004 18.7327 20.7094C19.1227 20.3194 19.1227 19.6624 18.7327 19.2724L17.7327 18.2724L5.73267 6.27247C5.53667 6.07647 5.26967 5.99042 5.01367 5.99042ZM7.04169 10.4495L14.5757 17.9904H7.32568C5.53868 17.9904 4.01367 16.3124 4.01367 14.3654C4.01367 12.8734 4.94767 11.6624 6.35767 11.2404C6.71567 11.1334 6.99369 10.8025 7.04169 10.4495Z" }) });
}
function G9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M13.3351 1.99414C13.1645 1.99414 12.9858 2.05148 12.8558 2.18148L10.1891 4.84814L8.66847 3.32747V7.32747H12.6685L11.1478 5.8068L13.8145 3.14014C14.0745 2.87947 14.0745 2.44214 13.8145 2.18148C13.6845 2.05148 13.5058 1.99414 13.3351 1.99414ZM3.33514 8.66081L4.85581 10.1815L2.18914 12.8481C1.92914 13.1088 1.92914 13.5461 2.18914 13.8068C2.31914 13.9368 2.4978 13.9941 2.66847 13.9941C2.83914 13.9941 3.0178 13.9368 3.1478 13.8068L5.81446 11.1401L7.33513 12.6608V8.66081H3.33514Z" }) });
}
function q9(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 242 62", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M29.2499 16.0724C29.526 16.0724 29.7499 15.8485 29.7499 15.5724L29.75 9.45358C23.9969 9.69217 18.8261 12.1837 15.0961 16.0727L29.2499 16.0724ZM21.6271 24.9167C21.6271 25.1928 21.4033 25.4167 21.1271 25.4167L9.82394 25.4172C10.5639 22.6511 11.8401 20.1033 13.5324 17.8936L21.1272 17.8933C21.4034 17.8933 21.6272 18.1171 21.6272 18.3933L21.6271 24.9167ZM46.2267 45.9287C42.4981 49.8163 37.3274 52.3078 31.5728 52.5478L31.5729 46.4291C31.5729 46.1529 31.7968 45.9291 32.0729 45.9291L46.2267 45.9287ZM29.7504 52.5464C23.9973 52.3081 18.8252 49.8154 15.0968 45.928L29.2506 45.9277C29.5267 45.9277 29.7506 46.1516 29.7506 46.4277L29.7504 52.5464ZM24.1289 37.082C24.1289 36.8059 24.3527 36.582 24.6289 36.582L51.4988 36.5814C50.7589 39.3474 49.4842 41.8938 47.7904 44.1049L24.6287 44.1055C24.3526 44.1055 24.1287 43.8816 24.1287 43.6054L24.1289 37.082ZM41.5947 27.7247C41.6015 27.4536 41.8233 27.2373 42.0945 27.2373L51.9037 27.2371C52.119 28.4582 52.2317 29.7155 52.2317 30.9988C52.2316 32.282 52.1189 33.5393 51.9035 34.7605L42.0971 34.7593C41.8253 34.7593 41.6033 34.5422 41.5973 34.2705L41.5187 30.7523L41.5947 27.7247ZM22.5908 43.607C22.5908 43.8831 22.3669 44.107 22.0908 44.107L13.5332 44.1071C11.8396 41.8961 10.565 39.3498 9.82514 36.5838L22.0909 36.5835C22.3671 36.5835 22.591 36.8074 22.5909 37.0835L22.5908 43.607ZM9.42216 27.2381L39.2487 27.2373C39.5249 27.2373 39.7487 27.4612 39.7487 27.7374L39.7486 34.2608C39.7486 34.5369 39.5247 34.7608 39.2486 34.7608L9.42197 34.7615C9.20667 33.5404 9.094 32.2831 9.09403 30.9998C9.09406 29.7165 9.2068 28.4592 9.42216 27.2381ZM23.451 18.3932C23.451 18.1171 23.6749 17.8932 23.951 17.8932L47.791 17.8928C49.4847 20.1039 50.7593 22.6502 51.4991 25.4162L23.9509 25.4166C23.6747 25.4167 23.4509 25.1928 23.4509 24.9166L23.451 18.3932ZM31.5738 9.45357C37.3269 9.69188 42.499 12.1846 46.2274 16.072L32.0737 16.0723C31.7975 16.0723 31.5736 15.8484 31.5736 15.5723L31.5738 9.45357Z" }),
    /* @__PURE__ */ A("path", { d: "M66.6074 31.1806C66.6074 28.1869 67.2536 25.5242 68.5459 23.1925C69.8382 20.8321 71.6331 19.0042 73.9306 17.7089C76.2568 16.3847 78.8845 15.7227 81.8138 15.7227C85.4036 15.7227 88.4765 16.6726 91.0324 18.5724C93.5884 20.4723 95.2971 23.063 96.1587 26.3446H88.0601C87.457 25.078 86.5954 24.1137 85.4754 23.4516C84.3841 22.7895 83.1349 22.4585 81.7277 22.4585C79.4589 22.4585 77.6209 23.2501 76.2137 24.8333C74.8065 26.4165 74.1029 28.5323 74.1029 31.1806C74.1029 33.8289 74.8065 35.9446 76.2137 37.5278C77.6209 39.111 79.4589 39.9027 81.7277 39.9027C83.1349 39.9027 84.3841 39.5716 85.4754 38.9095C86.5954 38.2475 87.457 37.2832 88.0601 36.0166H96.1587C95.2971 39.2982 93.5884 41.8889 91.0324 43.7887C88.4765 45.6598 85.4036 46.5953 81.8138 46.5953C78.8845 46.5953 76.2568 45.9477 73.9306 44.6523C71.6331 43.3282 69.8382 41.5003 68.5459 39.1686C67.2536 36.837 66.6074 34.1743 66.6074 31.1806Z" }),
    /* @__PURE__ */ A("path", { d: "M109.888 46.7249C107.533 46.7249 105.408 46.2211 103.513 45.2136C101.646 44.2061 100.167 42.7668 99.0758 40.8958C98.0132 39.0247 97.4819 36.837 97.4819 34.3326C97.4819 31.857 98.0276 29.6837 99.1189 27.8127C100.21 25.9128 101.704 24.4591 103.599 23.4516C105.494 22.4441 107.62 21.9404 109.974 21.9404C112.329 21.9404 114.455 22.4441 116.35 23.4516C118.245 24.4591 119.739 25.9128 120.83 27.8127C121.921 29.6837 122.467 31.857 122.467 34.3326C122.467 36.8082 121.907 38.9959 120.787 40.8958C119.696 42.7668 118.188 44.2061 116.264 45.2136C114.368 46.2211 112.243 46.7249 109.888 46.7249ZM109.888 40.3344C111.295 40.3344 112.487 39.8163 113.464 38.78C114.469 37.7437 114.971 36.2613 114.971 34.3326C114.971 32.404 114.483 30.9215 113.507 29.8852C112.559 28.8489 111.382 28.3308 109.974 28.3308C108.539 28.3308 107.347 28.8489 106.399 29.8852C105.451 30.8927 104.977 32.3752 104.977 34.3326C104.977 36.2613 105.437 37.7437 106.356 38.78C107.304 39.8163 108.481 40.3344 109.888 40.3344Z" }),
    /* @__PURE__ */ A("path", { d: "M139.298 22.0267C142.113 22.0267 144.353 22.9479 146.018 24.7902C147.713 26.6037 148.56 29.108 148.56 32.3032V46.3794H141.237V33.2963C141.237 31.6843 140.82 30.4322 139.987 29.5398C139.155 28.6474 138.035 28.2013 136.627 28.2013C135.22 28.2013 134.1 28.6474 133.267 29.5398C132.434 30.4322 132.018 31.6843 132.018 33.2963V46.3794H124.652V22.2858H132.018V25.481C132.765 24.4159 133.77 23.5812 135.033 22.9767C136.297 22.3434 137.719 22.0267 139.298 22.0267Z" }),
    /* @__PURE__ */ A("path", { d: "M166.602 22.0267C169.416 22.0267 171.656 22.9479 173.322 24.7902C175.016 26.6037 175.864 29.108 175.864 32.3032V46.3794H168.54V33.2963C168.54 31.6843 168.124 30.4322 167.291 29.5398C166.458 28.6474 165.338 28.2013 163.931 28.2013C162.524 28.2013 161.404 28.6474 160.571 29.5398C159.738 30.4322 159.322 31.6843 159.322 33.2963V46.3794H151.956V22.2858H159.322V25.481C160.069 24.4159 161.074 23.5812 162.337 22.9767C163.601 22.3434 165.022 22.0267 166.602 22.0267Z" }),
    /* @__PURE__ */ A("path", { d: "M201.918 33.944C201.918 34.6349 201.875 35.3545 201.789 36.1029H185.118C185.233 37.5998 185.707 38.7512 186.539 39.5572C187.401 40.3344 188.449 40.723 189.684 40.723C191.522 40.723 192.8 39.9458 193.518 38.3914H201.358C200.956 39.9746 200.224 41.3995 199.161 42.6661C198.127 43.9327 196.821 44.9258 195.241 45.6454C193.662 46.365 191.895 46.7249 189.943 46.7249C187.588 46.7249 185.491 46.2211 183.653 45.2136C181.815 44.2061 180.379 42.7668 179.346 40.8958C178.312 39.0247 177.795 36.837 177.795 34.3326C177.795 31.8283 178.297 29.6405 179.302 27.7695C180.336 25.8984 181.772 24.4591 183.61 23.4516C185.448 22.4441 187.559 21.9404 189.943 21.9404C192.269 21.9404 194.337 22.4297 196.146 23.4084C197.955 24.3872 199.362 25.7833 200.367 27.5968C201.401 29.4103 201.918 31.526 201.918 33.944ZM194.38 32.001C194.38 30.7344 193.949 29.7269 193.087 28.9785C192.226 28.23 191.149 27.8558 189.856 27.8558C188.622 27.8558 187.573 28.2157 186.712 28.9353C185.879 29.6549 185.362 30.6768 185.161 32.001H194.38Z" }),
    /* @__PURE__ */ A("path", { d: "M202.617 34.3326C202.617 31.8283 203.119 29.6405 204.124 27.7695C205.158 25.8984 206.58 24.4591 208.389 23.4516C210.227 22.4441 212.323 21.9404 214.678 21.9404C217.694 21.9404 220.207 22.732 222.217 24.3152C224.256 25.8984 225.591 28.1293 226.223 31.0079H218.383C217.722 29.1656 216.444 28.2444 214.549 28.2444C213.199 28.2444 212.122 28.777 211.318 29.842C210.514 30.8783 210.112 32.3752 210.112 34.3326C210.112 36.29 210.514 37.8013 211.318 38.8664C212.122 39.9027 213.199 40.4208 214.549 40.4208C216.444 40.4208 217.722 39.4997 218.383 37.6574H226.223C225.591 40.4784 224.256 42.6949 222.217 44.3069C220.178 45.9189 217.665 46.7249 214.678 46.7249C212.323 46.7249 210.227 46.2211 208.389 45.2136C206.58 44.2061 205.158 42.7668 204.124 40.8958C203.119 39.0247 202.617 36.837 202.617 34.3326Z" }),
    /* @__PURE__ */ A("path", { d: "M241.837 40.1185V46.3794H238.09C235.419 46.3794 233.337 45.7318 231.843 44.4364C230.35 43.1123 229.603 40.9677 229.603 38.0028V28.4172H226.674V22.2858H229.603V16.4135H236.97V22.2858H241.794V28.4172H236.97V38.0892C236.97 38.8088 237.142 39.3269 237.486 39.6436C237.831 39.9602 238.405 40.1185 239.21 40.1185H241.837Z" })
  ] });
}
function Y9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M20 1.84472C20 1.46377 19.7836 1.11591 19.4418 0.94761L18.088 0.28089C17.7399 0.109485 17.3242 0.154861 17.0213 0.397305L10.9046 5.29345L13.3938 7.26606L16.9338 4.43246V11.5763L2.94616 0.468456C2.64307 0.227771 2.22832 0.183587 1.88133 0.355019L0.557054 1.00929C0.215927 1.17782 0 1.52534 0 1.90583V14.1546C0 14.5354 0.216328 14.8832 0.557941 15.0516L1.9119 15.7189C2.26 15.8904 2.67592 15.8451 2.97888 15.6026L9.05159 10.7415L6.56234 8.76886L3.06621 11.5675V4.48484L17.0477 15.5957C17.3508 15.8366 17.7658 15.8809 18.1129 15.7093L19.4431 15.0519C19.7841 14.8833 20 14.5358 20 14.1554V1.84472Z" }) });
}
function U9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 10 2", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M1 0C1.552 0 2 0.448 2 1C2 1.552 1.552 2 1 2C0.448 2 0 1.552 0 1C0 0.448 0.448 0 1 0ZM5 0C5.552 0 6 0.448 6 1C6 1.552 5.552 2 5 2C4.448 2 4 1.552 4 1C4 0.448 4.448 0 5 0ZM9 0C9.552 0 10 0.448 10 1C10 1.552 9.552 2 9 2C8.448 2 8 1.552 8 1C8 0.448 8.448 0 9 0Z" }) });
}
function J9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.00846 1.33203C4.32646 1.33203 1.3418 4.3167 1.3418 7.9987C1.3418 11.6807 4.32646 14.6654 8.00846 14.6654C11.6905 14.6654 14.6751 11.6807 14.6751 7.9987C14.6751 4.3167 11.6905 1.33203 8.00846 1.33203ZM8.00846 4.66536C8.37646 4.66536 8.67513 4.96403 8.67513 5.33203V8.66536C8.67513 9.03336 8.37646 9.33203 8.00846 9.33203C7.64046 9.33203 7.3418 9.03336 7.3418 8.66536V5.33203C7.3418 4.96403 7.64046 4.66536 8.00846 4.66536ZM8.00846 9.9987C8.37646 9.9987 8.67513 10.2974 8.67513 10.6654C8.67513 11.0334 8.37646 11.332 8.00846 11.332C7.64046 11.332 7.3418 11.0334 7.3418 10.6654C7.3418 10.2974 7.64046 9.9987 8.00846 9.9987Z" }) });
}
function K9(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M9 4C9 3.448 8.552 3 8 3C7.448 3 7 3.448 7 4V9C7 9.552 7.448 10 8 10C8.552 10 9 9.552 9 9V4Z" }),
    /* @__PURE__ */ A("path", { d: "M9 12C9 11.448 8.552 11 8 11C7.448 11 7 11.448 7 12C7 12.552 7.448 13 8 13C8.552 13 9 12.552 9 12Z" })
  ] });
}
function _9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 20", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.33139 1.67773C5.36388 1.67773 2.49805 4.5159 2.49805 7.48507C2.49805 7.49365 2.49805 7.5024 2.49805 7.51107C2.49805 9.56107 2.49805 12.008 2.49805 12.2246C2.49805 13.7777 3.84056 15.0111 5.46639 15.0111H5.83139V15.5579C5.83139 17.1111 7.1739 18.3444 8.79973 18.3444H14.5297C16.1556 18.3444 17.4981 17.1111 17.4981 15.5579V7.79757C17.4981 6.2444 16.1556 5.01107 14.5297 5.01107H14.1647V4.46423C14.1647 2.91107 12.8222 1.67773 11.1964 1.67773C11.0181 1.67773 11.0097 1.67773 8.33139 1.67773ZM7.49805 3.55273V5.5579C7.49805 6.15257 6.93638 6.67773 6.19638 6.67773H4.34721C4.72971 5.20507 6.02139 3.94473 7.49805 3.55273ZM14.1647 6.67773H14.5297C15.2697 6.67773 15.8314 7.2029 15.8314 7.79757V15.5579C15.8314 16.1526 15.2697 16.6777 14.5297 16.6777H8.79973C8.05973 16.6777 7.49805 16.1526 7.49805 15.5579V15.0111H11.1964C12.8222 15.0111 14.1647 13.7777 14.1647 12.2246V6.67773Z" }) });
}
function $9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 18 19", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      d: "M2.99829 0.682129C1.24429 0.683129 0.008291 1.90913 -0.00170898 3.68213V5.68213C-0.000708986 5.72213 -0.00170898 14.6821 -0.00170898 14.6821C-0.00170898 16.8911 1.78929 18.6821 3.99828 18.6821H13.9983C16.2073 18.6821 17.9983 16.8911 17.9983 14.6821V8.68213C17.9973 8.59713 17.9983 6.84013 17.9983 6.71313C18.0053 4.97213 16.7203 3.68913 14.9983 3.68213C14.7263 3.68113 14.0513 3.68113 14.0613 3.68213C13.1383 3.67913 12.9253 3.49513 12.3423 2.62013C11.4253 1.24513 10.6533 0.682129 8.99828 0.682129H2.99829ZM2.99829 2.68213H8.99828C9.84328 2.68213 10.0713 2.86913 10.6543 3.74413C11.5713 5.11913 12.3433 5.68213 13.9983 5.68213C13.9723 5.68313 14.7223 5.68113 14.9983 5.68213C15.6223 5.68513 16.0013 6.08313 15.9983 6.71313C15.9983 6.77713 15.9973 7.21813 15.9983 7.68213C15.3583 7.68213 15.1983 7.68213 11.9983 7.68213C11.1533 7.68213 10.9253 7.49513 10.3423 6.62013C9.42527 5.24513 8.65328 4.68213 6.99828 4.68213C6.11328 4.68213 3.43429 4.68213 1.99829 4.68213V3.68213C2.00229 3.01813 2.34029 2.68213 2.99829 2.68213Z",
      fill: "#6C7275"
    }
  ) });
}
function ev(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 19", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M2.99829 0.68213C1.38729 0.68213 0.0122901 1.96913 -0.00170994 3.68213V14.6821C-0.00170994 15.7961 0.45129 16.8001 1.18629 17.5261C1.54429 17.8791 1.96529 18.1711 2.43629 18.3701C2.91929 18.5731 3.45429 18.6821 3.99829 18.6821H5.99829H12.9983C14.0523 18.6821 15.0383 18.2771 15.7793 17.5571C16.1773 17.1711 16.6333 16.0351 17.4363 13.6821C17.5003 13.4921 18.9473 9.0291 18.9673 8.9631C19.1653 8.3201 18.6713 7.6821 17.9983 7.6821C17.8733 7.6821 17.2123 7.6821 16.9983 7.6821V6.68213C16.9983 5.02513 15.6553 3.68213 13.9983 3.68213H11.9983C11.1533 3.68213 10.9253 3.49513 10.3423 2.62013C9.4253 1.24513 8.6533 0.68213 6.99829 0.68213C6.12329 0.68213 3.87329 0.68213 2.99829 0.68213ZM2.99829 2.68213C3.87329 2.68213 6.12329 2.68213 6.99829 2.68213C7.8433 2.68213 8.0713 2.86913 8.6543 3.74413C9.5713 5.11913 10.3433 5.68213 11.9983 5.68213H13.9983C14.5503 5.68213 14.9983 6.13013 14.9983 6.68213V7.6821C11.5293 7.6821 6.24829 7.6821 4.99829 7.6821C4.58429 7.6821 4.20929 7.9511 4.06029 8.3381C4.06029 8.3381 2.90229 11.3631 1.99829 13.7131V3.68213C2.00329 3.10513 2.45829 2.68213 2.99829 2.68213Z" }) });
}
function tv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M5.99804 2.99023C4.34104 2.99023 2.99805 4.33333 2.99805 5.99023V7.99023V16.9902C2.99805 19.1992 4.78904 20.9902 6.99804 20.9902H16.998C19.207 20.9902 20.998 19.1992 20.998 16.9902V7.99023C20.998 7.43793 20.55 6.99023 19.998 6.99023C19.998 6.99023 17.095 6.99023 14.998 6.99023C14.243 6.99023 14 6.74533 13.404 5.55273C12.501 3.74533 11.743 2.99023 9.99804 2.99023H5.99804ZM5.99804 4.99023H9.99804C10.753 4.99023 10.996 5.23513 11.592 6.42773C11.722 6.68883 11.776 6.77213 11.904 6.99023C8.45804 6.99023 5.98304 6.99023 4.99804 6.99023V5.99023C4.99804 5.43793 5.44604 4.99023 5.99804 4.99023ZM11.998 10.9902C12.55 10.9902 12.998 11.4382 12.998 11.9902V12.9902H13.998C14.55 12.9902 14.998 13.4382 14.998 13.9902C14.998 14.5422 14.55 14.9902 13.998 14.9902H12.998V15.9902C12.998 16.5422 12.55 16.9902 11.998 16.9902C11.446 16.9902 10.998 16.5422 10.998 15.9902V14.9902H9.99804C9.44604 14.9902 8.99804 14.5422 8.99804 13.9902C8.99804 13.4382 9.44604 12.9902 9.99804 12.9902H10.998V11.9902C10.998 11.4382 11.446 10.9902 11.998 10.9902Z" }) });
}
function nv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M5.97803 1.63718C5.03269 1.93652 4.21736 2.42652 3.4987 3.09519C3.2767 3.30252 3.2087 3.64052 3.3527 3.90785C3.8867 4.89519 3.32802 5.95119 2.12402 6.01186C1.82869 6.02719 1.56803 6.24518 1.4987 6.53252C1.37936 7.02918 1.33203 7.44519 1.33203 7.99118C1.33203 8.44918 1.38136 8.96719 1.47803 9.42852C1.53803 9.71652 1.7887 9.92385 2.08203 9.94985C3.29403 10.0545 3.89404 10.9785 3.3527 12.1578C3.2327 12.4198 3.28736 12.7332 3.4987 12.9285C4.2067 13.5839 5.02003 14.0452 5.97803 14.3452C6.25136 14.4312 6.56003 14.3279 6.72803 14.0952C7.46936 13.0699 8.5447 13.0659 9.2487 14.0952C9.4147 14.3379 9.7187 14.4545 9.9987 14.3658C10.9234 14.0752 11.7847 13.5799 12.4987 12.9285C12.7187 12.7285 12.7767 12.4038 12.6447 12.1372C12.09 11.0178 12.728 9.98985 13.8734 9.97051C14.1774 9.96518 14.448 9.76518 14.5194 9.47051C14.6347 8.99251 14.6654 8.57585 14.6654 7.99118C14.6654 7.48852 14.606 6.99319 14.4987 6.51186C14.4307 6.20786 14.1647 5.99185 13.8527 5.99119C12.7254 5.98919 12.0934 4.88119 12.6447 3.90785C12.798 3.63652 12.75 3.30452 12.5194 3.09519C11.7927 2.43519 10.9067 1.91985 9.97803 1.63718C9.69269 1.55052 9.38936 1.65719 9.22803 1.90785C8.58403 2.90785 7.38136 2.92586 6.7487 1.92853C6.5867 1.67319 6.26603 1.54518 5.97803 1.63718ZM7.9987 5.32452C9.47136 5.32452 10.6654 6.51852 10.6654 7.99118C10.6654 9.46385 9.47136 10.6579 7.9987 10.6579C6.52603 10.6579 5.33203 9.46385 5.33203 7.99118C5.33203 6.51852 6.52603 5.32452 7.9987 5.32452Z" }) });
}
function rv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.9987 1.34375C4.31683 1.34375 1.33203 4.32842 1.33203 8.01042C1.33203 9.08775 1.5899 10.1018 2.04343 11.0024C3.14036 13.1804 5.32943 14.6764 7.9987 14.6771C11.6806 14.6777 14.6654 11.6924 14.6654 8.01042C14.6654 4.32842 11.6806 1.34375 7.9987 1.34375ZM7.9987 2.67708C8.61997 2.67708 9.33403 3.73641 9.68937 5.29441C9.14997 5.32908 8.5851 5.34375 7.9987 5.34375C7.40983 5.34375 6.8449 5.32175 6.30477 5.28575C6.65983 3.78575 7.37743 2.67708 7.9987 2.67708ZM5.6419 3.22575C5.33797 3.78508 5.11463 4.49575 4.96296 5.16575C4.46976 5.09908 4.0233 5.00242 3.64763 4.90708C4.16463 4.19975 4.85216 3.60308 5.6419 3.22575ZM10.365 3.22174C11.0894 3.59641 11.82 4.19109 12.3484 4.91909C11.9732 5.01309 11.5143 5.09643 11.0237 5.16109C10.872 4.49109 10.6166 3.74641 10.365 3.22174ZM3.01483 6.11041C3.52043 6.26441 4.04203 6.37908 4.74337 6.47308C4.68583 6.98042 4.66536 7.46708 4.66536 8.01042C4.66536 8.55375 4.6907 9.04908 4.74823 9.55642C4.03343 9.65242 3.5151 9.74575 3.00183 9.90175C2.7663 9.29975 2.66536 8.69575 2.66536 8.01042C2.66536 7.32508 2.7793 6.71241 3.01483 6.11041ZM12.9766 6.11375C13.2122 6.71575 13.332 7.32508 13.332 8.01042C13.332 8.69575 13.2171 9.30175 12.9816 9.90375C12.4697 9.74775 11.9517 9.64308 11.2396 9.54775C11.2957 9.04575 11.332 8.54642 11.332 8.01042C11.332 7.46708 11.2956 6.97107 11.238 6.46307C11.9378 6.36641 12.4709 6.26708 12.9766 6.11375ZM6.08396 6.60175C6.7019 6.64641 7.3245 6.67708 7.9987 6.67708C8.6691 6.67708 9.30243 6.64642 9.9175 6.59975C9.97377 7.06842 9.9987 7.49575 9.9987 8.01042C9.9987 8.52508 9.98077 8.94108 9.92457 9.40908C9.30743 9.36374 8.67077 9.34375 7.9987 9.34375C7.3249 9.34375 6.69417 9.36776 6.07457 9.41376C6.01677 8.93976 5.9987 8.53308 5.9987 8.01042C5.9987 7.49575 6.0277 7.06975 6.08396 6.60175ZM7.9987 10.6771C8.58423 10.6771 9.1457 10.6991 9.6849 10.7337C9.30983 12.2944 8.62263 13.3437 7.9987 13.3437C7.37743 13.3437 6.67576 12.2438 6.2909 10.7324C6.83176 10.6964 7.4089 10.6771 7.9987 10.6771ZM4.96603 10.8624C5.11763 11.5324 5.3815 12.2678 5.6331 12.7931C4.89496 12.4424 4.18623 11.8384 3.6459 11.1144C4.0279 11.0178 4.46037 10.9298 4.96603 10.8624ZM11.0257 10.8611C11.5274 10.9264 11.9618 11.0211 12.3431 11.1164C11.86 11.7657 11.1508 12.4084 10.3716 12.7844C10.6558 12.2044 10.874 11.5311 11.0257 10.8611Z" }) });
}
function iv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 25", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.24956 4.68945C5.17156 4.68945 3.27058 6.40045 2.93758 8.53345L1.99956 15.5645C1.98756 15.6545 2.05058 15.7285 2.06258 15.8145C2.04858 15.9415 1.99956 16.0585 1.99956 16.1895V17.1895C1.99956 19.1225 3.56656 20.6895 5.49956 20.6895H18.4996C20.4326 20.6895 21.9996 19.1225 21.9996 17.1895V16.1895C21.9996 16.0585 21.9516 15.9415 21.9376 15.8145C21.9496 15.7285 22.0126 15.6545 21.9996 15.5645L20.9996 8.56445C20.6646 6.41545 18.7966 4.68945 16.7186 4.68945H7.24956ZM5.49956 14.6895H18.4996C19.3286 14.6895 19.9996 15.3615 19.9996 16.1895V17.1895C19.9996 18.0175 19.3286 18.6895 18.4996 18.6895H5.49956C4.67156 18.6895 3.99956 18.0175 3.99956 17.1895V16.1895C3.99956 15.3615 4.67156 14.6895 5.49956 14.6895ZM5.99956 15.6895C5.44756 15.6895 4.99956 16.1375 4.99956 16.6895C4.99956 17.2415 5.44756 17.6895 5.99956 17.6895C6.55256 17.6895 6.99956 17.2415 6.99956 16.6895C6.99956 16.1375 6.55256 15.6895 5.99956 15.6895ZM8.99956 15.6895C8.44756 15.6895 7.99956 16.1375 7.99956 16.6895C7.99956 17.2415 8.44756 17.6895 8.99956 17.6895C9.55256 17.6895 9.99956 17.2415 9.99956 16.6895C9.99956 16.1375 9.55256 15.6895 8.99956 15.6895Z" }) });
}
function ov(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.02812 1.33301C4.33612 1.33301 1.34277 4.317 1.34277 7.99833C1.34277 11.6797 4.33612 14.6643 8.02812 14.6643C9.83012 14.6643 11.5248 13.9537 12.7708 12.7063C13.0314 12.445 13.0328 12.0283 12.7708 11.769C12.5094 11.509 12.0914 11.5077 11.8308 11.769C10.8334 12.7677 9.47078 13.331 8.02812 13.331C5.07478 13.331 2.68011 10.9437 2.68011 7.99833C2.68011 5.05366 5.07478 2.66634 8.02812 2.66634C8.39745 2.66634 8.69678 2.36767 8.69678 1.99967C8.69678 1.63167 8.39745 1.33301 8.02812 1.33301ZM10.4728 1.93701C10.3108 1.99035 10.1781 2.10501 10.0968 2.27034C9.93412 2.60101 10.0581 3.00367 10.3894 3.16634C10.5674 3.25301 10.7241 3.35102 10.8908 3.45768C11.2014 3.65568 11.6321 3.55967 11.8308 3.24967C12.0294 2.93901 11.9328 2.53101 11.6221 2.33301C11.4128 2.19967 11.1968 2.08767 10.9741 1.979C10.8088 1.89767 10.6354 1.88434 10.4728 1.93701ZM12.8334 3.58236C12.6641 3.56236 12.4774 3.61502 12.3321 3.72835C12.0421 3.95569 11.9994 4.37636 12.2281 4.66569C12.3501 4.82102 12.4781 4.97702 12.5828 5.14502C12.7774 5.45769 13.1888 5.54703 13.5021 5.35303C13.8161 5.15903 13.9054 4.77035 13.7114 4.45768C13.5808 4.24768 13.4254 4.02702 13.2721 3.83236C13.1581 3.68769 13.0034 3.60302 12.8334 3.58236ZM8.02812 3.99902C7.65945 3.99902 7.36011 4.29769 7.36011 4.66569V7.99833C7.36011 8.17566 7.44343 8.35233 7.56877 8.47766L9.5741 10.477C9.83543 10.7377 10.2534 10.7377 10.5148 10.477C10.7754 10.217 10.7754 9.77967 10.5148 9.519L8.69678 7.70699V4.66569C8.69678 4.29769 8.39745 3.99902 8.02812 3.99902ZM13.7528 6.01969C13.3921 6.09903 13.1714 6.45166 13.2514 6.81099C13.2941 7.00366 13.3354 7.19766 13.3561 7.39433C13.3948 7.76033 13.7201 8.01633 14.0874 7.97766C14.4541 7.93899 14.7114 7.61502 14.6721 7.24902C14.6461 7.00236 14.6214 6.76036 14.5674 6.51969C14.4881 6.16036 14.1134 5.94036 13.7528 6.01969ZM14.0454 8.72766C13.6868 8.64099 13.3174 8.86966 13.2308 9.22766C13.1841 9.42033 13.1101 9.60501 13.0428 9.78967C12.9161 10.1357 13.1134 10.497 13.4608 10.623C13.8074 10.749 14.1701 10.5943 14.2961 10.2483C14.3808 10.0163 14.4674 9.78101 14.5261 9.53967C14.6128 9.18234 14.4041 8.81433 14.0454 8.72766Z" }) });
}
function sv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M4.66557 1.99414C3.1929 1.99414 1.9989 3.18815 1.9989 4.66082V11.3275C1.9989 12.8002 3.1929 13.9942 4.66557 13.9942H11.3322C12.8049 13.9942 13.9989 12.8002 13.9989 11.3275V4.66082C13.9989 3.18815 12.8049 1.99414 11.3322 1.99414H4.66557ZM7.9989 4.66082C8.3669 4.66082 8.66556 4.95949 8.66556 5.32749C8.66556 5.6955 8.3669 5.99416 7.9989 5.99416C7.6309 5.99416 7.33223 5.6955 7.33223 5.32749C7.33223 4.95949 7.6309 4.66082 7.9989 4.66082ZM7.9989 6.66083C8.3669 6.66083 8.66556 6.9595 8.66556 7.32751V10.6609C8.66556 11.0289 8.3669 11.3275 7.9989 11.3275C7.6309 11.3275 7.33223 11.0289 7.33223 10.6609V7.32751C7.33223 6.9595 7.6309 6.66083 7.9989 6.66083Z" }) });
}
function av(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7562 4.74381C17.0977 3.0854 14.4088 3.0854 12.7503 4.74381L9.74749 7.74664C8.08906 9.40505 8.08941 12.0937 9.74786 13.7521C10.1625 14.1667 10.8347 14.1667 11.2493 13.7521C11.6639 13.3375 11.6639 12.6653 11.2493 12.2507L11.2322 12.2339C10.4197 11.4035 10.4253 10.0716 11.2489 9.24805L14.2518 6.24522C15.0811 5.41601 16.4255 5.41603 17.2547 6.24522C18.0839 7.07443 18.0839 8.41884 17.2547 9.24805L16.1917 10.3111C16.5282 11.17 16.6325 12.099 16.5043 13.0012L18.7562 10.7495C20.4146 9.09106 20.4146 6.40223 18.7562 4.74381ZM5.24383 18.2562C6.90228 19.9146 9.59115 19.9146 11.2496 18.2562L14.2525 15.2534C15.911 13.595 15.911 10.9061 14.2525 9.24768C13.8378 8.83308 13.1657 8.83308 12.7511 9.24768C12.3364 9.66229 12.3364 10.3345 12.7511 10.7491C13.5803 11.5783 13.5803 12.9227 12.7511 13.7519L9.74815 16.7548C8.91894 17.5839 7.5745 17.5839 6.74528 16.7548C5.91605 15.9255 5.91605 14.5811 6.74528 13.7519L7.80833 12.6888C7.47174 11.83 7.36751 10.901 7.49563 9.99875L5.24383 12.2505C3.58539 13.9089 3.58539 16.5978 5.24383 18.2562Z"
    }
  ) });
}
function cv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.998 1.95312C9.23705 1.95312 6.99805 4.19213 6.99805 6.95312V8.95312C5.34105 8.95312 3.99805 10.2961 3.99805 11.9531V18.9531C3.99805 20.6101 5.34105 21.9531 6.99805 21.9531H16.998C18.655 21.9531 19.998 20.6101 19.998 18.9531V11.9531C19.998 10.2961 18.655 8.95312 16.998 8.95312V6.95312C16.998 4.19213 14.759 1.95312 11.998 1.95312ZM11.998 3.95312C13.655 3.95312 14.998 5.29612 14.998 6.95312V8.95312H8.99805V6.95312C8.99805 5.29612 10.341 3.95312 11.998 3.95312ZM11.998 11.9531C13.103 11.9531 13.998 12.8481 13.998 13.9531C13.998 14.6631 13.555 15.1611 12.998 15.5151V17.9531C12.998 18.5051 12.55 18.9531 11.998 18.9531C11.446 18.9531 10.998 18.5051 10.998 17.9531V15.5151C10.441 15.1601 9.99805 14.6631 9.99805 13.9531C9.99805 12.8481 10.893 11.9531 11.998 11.9531Z" }) });
}
function uv(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 24 24", fill: "none", children: [
    /* @__PURE__ */ A(
      "path",
      {
        d: "M1.88134 8.65644V18.3251H0V7.09336C0 6.19326 1.03474 5.68003 1.75748 6.22134L10.6938 12.912C10.9698 13.1179 11.1313 13.4409 11.1313 13.784V18.3235H9.24992V14.174L1.88134 8.65644Z",
        fill: "currentcolor"
      }
    ),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M22.0605 18.3251V8.65599L14.4616 14.1738V18.3251H12.5215V13.7854C12.5215 13.4422 12.688 13.1193 12.9726 12.9133L22.1882 6.22233C22.9335 5.67944 24.0006 6.19269 24.0006 7.09283V18.3251H22.0605Z",
        fill: "currentcolor"
      }
    )
  ] });
}
function lv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M16.9951 1.95312C16.7301 1.95312 16.4641 2.04713 16.2761 2.23413C15.7201 2.79013 13.7191 4.79115 13.2751 5.23615L4.26978 14.2412L3.26928 15.2412C3.12958 15.3812 3.05788 15.5792 3.01918 15.7732L2.01858 20.7762C1.87858 21.4762 2.47538 22.0721 3.17548 21.9331C3.80078 21.8071 7.55288 21.0572 8.17818 20.9322C8.37188 20.8932 8.57008 20.8212 8.70968 20.6822L9.71027 19.6812L18.7151 10.6762C19.1601 10.2322 21.1611 8.23012 21.7171 7.67512C21.9041 7.48712 21.9981 7.22113 21.9981 6.95613C21.9981 5.31912 21.5811 4.14912 20.7161 3.26612C19.8431 2.37511 18.6771 1.95312 16.9951 1.95312ZM17.3891 3.97211C18.2921 4.02511 18.8771 4.23216 19.2781 4.64216C19.6881 5.06016 19.9471 5.64015 20.0031 6.52516C19.4551 7.07216 18.6531 7.86212 17.9961 8.51912C17.2031 7.72612 16.2251 6.74815 15.4321 5.95515C16.0901 5.29815 16.8421 4.51911 17.3891 3.97211ZM4.98898 16.3982L7.55288 18.9621L7.45908 19.0562C6.79908 19.1882 5.46628 19.4672 4.23858 19.7132L4.89518 16.4922L4.98898 16.3982Z" }) });
}
function dv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M15.498 2.92969C13.0127 2.92969 10.998 4.94469 10.998 7.42969C10.998 9.91469 13.0127 11.9297 15.498 11.9297C17.9833 11.9297 19.998 9.91469 19.998 7.42969C19.998 4.94469 17.9833 2.92969 15.498 2.92969ZM7.99805 3.92969C5.78895 3.92969 3.99805 5.72069 3.99805 7.92969C3.99805 10.1387 5.78895 11.9297 7.99805 11.9297C8.82745 11.9297 9.58455 11.7017 10.2508 11.2357C8.54205 8.69572 8.78425 6.26369 9.71555 4.30469C9.18365 4.05269 8.59945 3.92969 7.99805 3.92969ZM5.06055 13.2737C3.22645 14.0307 1.99805 15.8857 1.99805 17.9297V19.9297C1.99805 20.4817 2.44575 20.9297 2.99805 20.9297L7.15085 20.9317C6.91685 20.1717 6.98565 18.9397 7.00105 17.9427C7.03355 15.8257 7.90905 14.3157 8.25195 13.9177C7.62175 13.9127 6.86545 13.7597 6.31055 13.5237C6.17655 13.4667 6.09875 13.4217 5.84185 13.3047C5.58995 13.1897 5.31635 13.1677 5.06055 13.2737ZM12.0605 13.2737C10.2264 14.0307 8.99805 15.8857 8.99805 17.9297V19.9297C8.99805 20.4817 9.44575 20.9297 9.99805 20.9297H20.998C21.5503 20.9297 21.998 20.4817 21.998 19.9297V17.9297C21.998 15.9337 20.7628 14.1237 18.9355 13.3357C18.6783 13.2247 18.3786 13.2217 18.123 13.3357C17.2382 13.7327 16.3762 13.9297 15.498 13.9297C14.6228 13.9297 13.7578 13.7217 12.8418 13.3047C12.5899 13.1897 12.3163 13.1677 12.0605 13.2737Z" }) });
}
function Av(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.9974 1.30273C6.15646 1.30273 4.66406 2.79513 4.66406 4.63607C4.66406 6.477 6.15646 7.9694 7.9974 7.9694C9.83833 7.9694 11.3307 6.477 11.3307 4.63607C11.3307 2.79513 9.83833 1.30273 7.9974 1.30273ZM5.64326 8.8444C3.9004 9.32073 2.66406 10.8362 2.66406 12.6361V13.9694C2.66406 14.3376 2.96253 14.6361 3.33073 14.6361H12.6641C13.0323 14.6361 13.3307 14.3376 13.3307 13.9694V12.6361C13.3307 10.8362 12.0944 9.32073 10.3515 8.8444C10.2021 8.80353 10.0553 8.8224 9.91406 8.88607C9.30373 9.16113 8.654 9.30273 7.9974 9.30273C7.3408 9.30273 6.69106 9.16113 6.08073 8.88607C5.93946 8.8224 5.79266 8.80353 5.64326 8.8444Z" }) });
}
function fv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.00846 1.30273C4.3266 1.30273 1.3418 4.2874 1.3418 7.9694C1.3418 11.6514 4.3266 14.6361 8.00846 14.6361C11.6903 14.6361 14.6751 11.6514 14.6751 7.9694C14.6751 4.2874 11.6903 1.30273 8.00846 1.30273ZM8.00846 4.63607C8.37667 4.63607 8.67513 4.93473 8.67513 5.30273V7.30273H10.6751C11.0433 7.30273 11.3418 7.6014 11.3418 7.9694C11.3418 8.3374 11.0433 8.63606 10.6751 8.63606H8.67513V10.6361C8.67513 11.0041 8.37667 11.3027 8.00846 11.3027C7.64026 11.3027 7.3418 11.0041 7.3418 10.6361V8.63606H5.3418C4.9736 8.63606 4.67513 8.3374 4.67513 7.9694C4.67513 7.6014 4.9736 7.30273 5.3418 7.30273H7.3418V5.30273C7.3418 4.93473 7.64026 4.63607 8.00846 4.63607Z" }) });
}
function gv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 18 19", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.99072 0.929749C8.43872 0.929749 7.99072 1.37775 7.99072 1.92975V8.92975H0.990723C0.438723 8.92975 -0.00927734 9.37775 -0.00927734 9.92975C-0.00927734 10.4817 0.438723 10.9297 0.990723 10.9297H7.99072V17.9297C7.99072 18.4817 8.43872 18.9297 8.99072 18.9297C9.54272 18.9297 9.99072 18.4817 9.99072 17.9297V10.9297H16.9907C17.5427 10.9297 17.9907 10.4817 17.9907 9.92975C17.9907 9.37775 17.5427 8.92975 16.9907 8.92975H9.99072V1.92975C9.99072 1.37775 9.54272 0.929749 8.99072 0.929749Z" }) });
}
function hv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0059 0L3.41636 5.45646C2.44979 6.25682 2.3795 7.71452 3.26456 8.60418L5.54425 10.8957C6.21311 11.568 6.35783 12.6012 5.89944 13.4314L4.48126 16H2.13333C0.955126 16 0 15.0449 0 13.8667V2.13333C0 0.955126 0.955126 0 2.13333 0H10.0059ZM11.2436 0L10.0128 2.24221C9.55899 3.06891 9.70183 4.09549 10.3641 4.7669L12.7825 7.21868C13.6656 8.11402 13.5866 9.57512 12.612 10.37L5.70922 16H13.8667C15.0449 16 16 15.0449 16 13.8667V2.13333C16 0.955126 15.0449 0 13.8667 0H11.2436Z"
    }
  ) });
}
function pv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.4561 1.95312C12.8734 1.95312 13.998 3.15579 13.998 4.61979V11.2865C13.998 12.7505 12.8734 13.9531 11.4561 13.9531H11.3314V1.95312H11.4561ZM9.99805 1.95312V13.9531H4.53939C3.12272 13.9531 1.99805 12.7505 1.99805 11.2865V4.61979C1.99805 3.15579 3.12272 1.95312 4.53939 1.95312H9.99805ZM7.33138 4.61979H4.66471C4.29671 4.61979 3.99805 4.91846 3.99805 5.28646C3.99805 5.65446 4.29671 5.95312 4.66471 5.95312H7.33138C7.69938 5.95312 7.99805 5.65446 7.99805 5.28646C7.99805 4.91846 7.69938 4.61979 7.33138 4.61979ZM7.33138 7.28646H4.66471C4.29671 7.28646 3.99805 7.58512 3.99805 7.95312C3.99805 8.32112 4.29671 8.61979 4.66471 8.61979H7.33138C7.69938 8.61979 7.99805 8.32112 7.99805 7.95312C7.99805 7.58512 7.69938 7.28646 7.33138 7.28646ZM7.33138 9.95312H4.66471C4.29671 9.95312 3.99805 10.2518 3.99805 10.6198C3.99805 10.9878 4.29671 11.2865 4.66471 11.2865H7.33138C7.69938 11.2865 7.99805 10.9878 7.99805 10.6198C7.99805 10.2518 7.69938 9.95312 7.33138 9.95312Z" }) });
}
function mv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 21 17", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10.9863 4.90607C10.6036 4.90607 8.3471 4.87807 7.9863 4.90607C2.04289 5.36307 0.986294 9.90607 0.986294 14.9061V15.9061C2.85309 13.9911 3.9863 12.9061 7.9863 12.9061C8.7319 12.9061 10.0809 12.9061 10.9863 12.9061L11.0166 15.4801C11.0166 16.9001 11.8933 17.3321 12.9747 16.4451L20.1554 10.5521C21.2633 9.64306 21.2633 8.16907 20.1554 7.26007L12.9747 1.36707C11.8933 0.480072 11.0166 0.912068 11.0166 2.33207L10.9863 4.90607Z" }) });
}
function vv(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 71 19", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M53.6211 18.4887V9.0342H56.435V10.8096H56.4923C56.7377 10.181 57.1085 9.70244 57.6047 9.37398C58.101 9.03986 58.6981 8.8728 59.3962 8.8728C60.4105 8.8728 61.2039 9.1871 61.7765 9.8157C62.3546 10.4443 62.6436 11.3164 62.6436 12.432V18.4887H59.7397V13.0776C59.7397 12.5283 59.6007 12.1007 59.3225 11.7949C59.0499 11.4835 58.6654 11.3277 58.1692 11.3277C57.6784 11.3277 57.2803 11.4976 56.9749 11.8374C56.6695 12.1772 56.5168 12.6161 56.5168 13.1541V18.4887H53.6211Z" }),
    /* @__PURE__ */ A("path", { d: "M53.097 9.03394L50.7412 18.4884H47.6164L46.1522 12.075H46.0949L44.6389 18.4884H41.5632L39.1992 9.03394H42.1195L43.3056 15.7532H43.3628L44.7861 9.03394H47.551L48.9906 15.7532H49.0479L50.234 9.03394H53.097Z" }),
    /* @__PURE__ */ A("path", { d: "M37.8661 17.3926C37.0427 18.2591 35.9084 18.6923 34.4632 18.6923C33.0181 18.6923 31.8838 18.2591 31.0604 17.3926C30.2369 16.5205 29.8252 15.3086 29.8252 13.7569C29.8252 12.2336 30.2424 11.033 31.0767 10.1552C31.9111 9.2718 33.0399 8.83008 34.4632 8.83008C35.892 8.83008 37.0208 9.26896 37.8497 10.1467C38.6841 11.0188 39.1013 12.2222 39.1013 13.7569C39.1013 15.3143 38.6896 16.5262 37.8661 17.3926ZM33.2117 15.7702C33.5116 16.2402 33.9288 16.4752 34.4632 16.4752C34.9977 16.4752 35.4148 16.2402 35.7148 15.7702C36.0147 15.2945 36.1647 14.6234 36.1647 13.7569C36.1647 12.9131 36.012 12.2506 35.7066 11.7692C35.4012 11.2878 34.9868 11.0472 34.4632 11.0472C33.9343 11.0472 33.5171 11.2878 33.2117 11.7692C32.9118 12.2449 32.7618 12.9075 32.7618 13.7569C32.7618 14.6234 32.9118 15.2945 33.2117 15.7702Z" }),
    /* @__PURE__ */ A("path", { d: "M20.0088 18.4887V9.0342H22.8227V10.8096H22.88C23.1254 10.181 23.4962 9.70244 23.9924 9.37398C24.4887 9.03986 25.0858 8.8728 25.7838 8.8728C26.7982 8.8728 27.5916 9.1871 28.1642 9.8157C28.7423 10.4443 29.0313 11.3164 29.0313 12.432V18.4887H26.1274V13.0776C26.1274 12.5283 25.9883 12.1007 25.7102 11.7949C25.4376 11.4835 25.0531 11.3277 24.5569 11.3277C24.0661 11.3277 23.668 11.4976 23.3626 11.8374C23.0572 12.1772 22.9045 12.6161 22.9045 13.1541V18.4887H20.0088Z" }),
    /* @__PURE__ */ A("path", { d: "M14.7486 10.9707C14.2851 10.9707 13.8952 11.1321 13.5789 11.4549C13.2626 11.7777 13.0854 12.1911 13.0472 12.6951H16.4337C16.4064 12.1741 16.2374 11.7579 15.9265 11.4464C15.6212 11.1293 15.2285 10.9707 14.7486 10.9707ZM16.4991 15.5153H19.1167C18.9749 16.4837 18.5141 17.2567 17.7343 17.8343C16.9599 18.4063 15.9838 18.6923 14.8059 18.6923C13.3662 18.6923 12.2374 18.2591 11.4194 17.3926C10.6014 16.5262 10.1924 15.3313 10.1924 13.8079C10.1924 12.2845 10.5987 11.0755 11.4112 10.1807C12.2237 9.28029 13.3226 8.83008 14.7077 8.83008C16.0656 8.83008 17.1481 9.26047 17.9552 10.1213C18.7677 10.9764 19.174 12.1231 19.174 13.5616V14.4195H13.0145V14.6064C13.0145 15.184 13.1835 15.6541 13.5216 16.0165C13.8597 16.3733 14.3015 16.5517 14.8468 16.5517C15.2503 16.5517 15.5993 16.461 15.8938 16.2798C16.1883 16.0929 16.3901 15.8381 16.4991 15.5153Z" }),
    /* @__PURE__ */ A("path", { d: "M3.00205 8.58396V12.0667H4.7771C5.32789 12.0667 5.7587 11.911 6.06954 11.5995C6.38038 11.2881 6.5358 10.8662 6.5358 10.3338C6.5358 9.80718 6.37492 9.38528 6.05318 9.06815C5.73143 8.74535 5.30335 8.58396 4.76892 8.58396H3.00205ZM3.00205 14.1989V18.4886H0V6.23096H5.07158C6.53307 6.23096 7.65373 6.5849 8.43355 7.29278C9.21337 8.00066 9.60328 8.99453 9.60328 10.2744C9.60328 11.0446 9.42605 11.7439 9.07159 12.3725C8.71712 12.9955 8.2236 13.4514 7.59101 13.7402L9.94684 18.4886H6.5767L4.55624 14.1989H3.00205Z" }),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M65.7255 0.211478C65.0841 2.46724 63.3737 4.2455 61.2041 4.90969C60.932 4.99366 60.932 5.39096 61.2041 5.47492C63.3725 6.13912 65.0841 7.91738 65.7255 10.1731C65.8056 10.4551 66.1932 10.4551 66.2745 10.1731C66.9159 7.91738 68.6263 6.13912 70.7959 5.47492C71.068 5.39096 71.068 4.99366 70.7959 4.90969C68.6276 4.2455 66.9159 2.46724 66.2745 0.211478C66.1944 -0.0704925 65.8068 -0.0704925 65.7255 0.211478Z",
        fill: "#21FFB4"
      }
    )
  ] });
}
function bv(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 71 19", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M53.6211 18.4887V9.0342H56.435V10.8096H56.4923C56.7377 10.181 57.1085 9.70244 57.6047 9.37398C58.101 9.03986 58.6981 8.8728 59.3962 8.8728C60.4105 8.8728 61.2039 9.1871 61.7765 9.8157C62.3546 10.4443 62.6436 11.3164 62.6436 12.432V18.4887H59.7397V13.0776C59.7397 12.5283 59.6007 12.1007 59.3225 11.7949C59.0499 11.4835 58.6654 11.3277 58.1692 11.3277C57.6784 11.3277 57.2803 11.4976 56.9749 11.8374C56.6695 12.1772 56.5168 12.6161 56.5168 13.1541V18.4887H53.6211Z" }),
    /* @__PURE__ */ A("path", { d: "M53.097 9.03394L50.7412 18.4884H47.6164L46.1522 12.075H46.0949L44.6389 18.4884H41.5632L39.1992 9.03394H42.1195L43.3056 15.7532H43.3628L44.7861 9.03394H47.551L48.9906 15.7532H49.0479L50.234 9.03394H53.097Z" }),
    /* @__PURE__ */ A("path", { d: "M37.8661 17.3926C37.0427 18.2591 35.9084 18.6923 34.4632 18.6923C33.0181 18.6923 31.8838 18.2591 31.0604 17.3926C30.2369 16.5205 29.8252 15.3086 29.8252 13.7569C29.8252 12.2336 30.2424 11.033 31.0767 10.1552C31.9111 9.2718 33.0399 8.83008 34.4632 8.83008C35.892 8.83008 37.0208 9.26896 37.8497 10.1467C38.6841 11.0188 39.1013 12.2222 39.1013 13.7569C39.1013 15.3143 38.6896 16.5262 37.8661 17.3926ZM33.2117 15.7702C33.5116 16.2402 33.9288 16.4752 34.4632 16.4752C34.9977 16.4752 35.4148 16.2402 35.7148 15.7702C36.0147 15.2945 36.1647 14.6234 36.1647 13.7569C36.1647 12.9131 36.012 12.2506 35.7066 11.7692C35.4012 11.2878 34.9868 11.0472 34.4632 11.0472C33.9343 11.0472 33.5171 11.2878 33.2117 11.7692C32.9118 12.2449 32.7618 12.9075 32.7618 13.7569C32.7618 14.6234 32.9118 15.2945 33.2117 15.7702Z" }),
    /* @__PURE__ */ A("path", { d: "M20.0088 18.4887V9.0342H22.8227V10.8096H22.88C23.1254 10.181 23.4962 9.70244 23.9924 9.37398C24.4887 9.03986 25.0858 8.8728 25.7838 8.8728C26.7982 8.8728 27.5916 9.1871 28.1642 9.8157C28.7423 10.4443 29.0313 11.3164 29.0313 12.432V18.4887H26.1274V13.0776C26.1274 12.5283 25.9883 12.1007 25.7102 11.7949C25.4376 11.4835 25.0531 11.3277 24.5569 11.3277C24.0661 11.3277 23.668 11.4976 23.3626 11.8374C23.0572 12.1772 22.9045 12.6161 22.9045 13.1541V18.4887H20.0088Z" }),
    /* @__PURE__ */ A("path", { d: "M14.7486 10.9707C14.2851 10.9707 13.8952 11.1321 13.5789 11.4549C13.2626 11.7777 13.0854 12.1911 13.0472 12.6951H16.4337C16.4064 12.1741 16.2374 11.7579 15.9265 11.4464C15.6212 11.1293 15.2285 10.9707 14.7486 10.9707ZM16.4991 15.5153H19.1167C18.9749 16.4837 18.5141 17.2567 17.7343 17.8343C16.9599 18.4063 15.9838 18.6923 14.8059 18.6923C13.3662 18.6923 12.2374 18.2591 11.4194 17.3926C10.6014 16.5262 10.1924 15.3313 10.1924 13.8079C10.1924 12.2845 10.5987 11.0755 11.4112 10.1807C12.2237 9.28029 13.3226 8.83008 14.7077 8.83008C16.0656 8.83008 17.1481 9.26047 17.9552 10.1213C18.7677 10.9764 19.174 12.1231 19.174 13.5616V14.4195H13.0145V14.6064C13.0145 15.184 13.1835 15.6541 13.5216 16.0165C13.8597 16.3733 14.3015 16.5517 14.8468 16.5517C15.2503 16.5517 15.5993 16.461 15.8938 16.2798C16.1883 16.0929 16.3901 15.8381 16.4991 15.5153Z" }),
    /* @__PURE__ */ A("path", { d: "M3.00205 8.58396V12.0667H4.7771C5.32789 12.0667 5.7587 11.911 6.06954 11.5995C6.38038 11.2881 6.5358 10.8662 6.5358 10.3338C6.5358 9.80718 6.37492 9.38528 6.05318 9.06815C5.73143 8.74535 5.30335 8.58396 4.76892 8.58396H3.00205ZM3.00205 14.1989V18.4886H0V6.23096H5.07158C6.53307 6.23096 7.65373 6.5849 8.43355 7.29278C9.21337 8.00066 9.60328 8.99453 9.60328 10.2744C9.60328 11.0446 9.42605 11.7439 9.07159 12.3725C8.71712 12.9955 8.2236 13.4514 7.59101 13.7402L9.94684 18.4886H6.5767L4.55624 14.1989H3.00205Z" }),
    /* @__PURE__ */ A("path", { d: "M65.7255 0.211478C65.0841 2.46724 63.3737 4.2455 61.2041 4.90969C60.932 4.99366 60.932 5.39096 61.2041 5.47492C63.3725 6.13912 65.0841 7.91738 65.7255 10.1731C65.8056 10.4551 66.1932 10.4551 66.2745 10.1731C66.9159 7.91738 68.6263 6.13912 70.7959 5.47492C71.068 5.39096 71.068 4.99366 70.7959 4.90969C68.6276 4.2455 66.9159 2.46724 66.2745 0.211478C66.1944 -0.0704925 65.8068 -0.0704925 65.7255 0.211478Z" })
  ] });
}
function yv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.99853 2.60352C5.0532 2.60352 2.66519 4.99152 2.66519 7.93685C2.66519 10.8822 5.0532 13.2702 7.99853 13.2702C10.9439 13.2702 13.3319 10.8822 13.3319 7.93685C13.3319 4.99152 10.9439 2.60352 7.99853 2.60352ZM7.99853 3.93685C10.2079 3.93685 11.9985 5.72752 11.9985 7.93685C11.9985 10.1462 10.2079 11.9368 7.99853 11.9368C5.7892 11.9368 3.99853 10.1462 3.99853 7.93685C3.99853 5.72752 5.7892 3.93685 7.99853 3.93685Z" }) });
}
function Cv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M2 4.66667C2 3.194 3.194 2 4.66667 2H8.08333C7.64666 2.564 7.33333 3.23133 7.33333 4V8.66667H5.33333L8 11.3333L10.6667 8.66667H8.66666V4C8.66666 2.89533 9.562 2 10.6667 2H11.3333C12.806 2 14 3.194 14 4.66667V11.3333C14 12.806 12.806 14 11.3333 14H4.66667C3.194 14 2 12.806 2 11.3333V4.66667Z" }) });
}
function Iv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10.0137 1.95312C5.59537 1.95312 2.01367 5.53513 2.01367 9.95314C2.01367 14.3712 5.59537 17.9532 10.0137 17.9532C11.8504 17.9532 13.5913 17.3222 14.9416 16.2822L19.2949 20.6722C19.6855 21.0622 20.3419 21.0622 20.7325 20.6722C21.123 20.2812 21.123 19.6252 20.7325 19.2342L16.349 14.8741C17.3898 13.5241 18.0137 11.7901 18.0137 9.95314C18.0137 5.53513 14.432 1.95312 10.0137 1.95312ZM10.0137 3.95313C13.3274 3.95313 16.0137 6.63914 16.0137 9.95314C16.0137 13.2672 13.3274 15.9532 10.0137 15.9532C6.69997 15.9532 4.01367 13.2672 4.01367 9.95314C4.01367 6.63914 6.69997 3.95313 10.0137 3.95313Z" }) });
}
function Ev(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.998 1.95312C7.63605 1.95312 3.99805 3.51213 3.99805 5.95312C3.99805 8.39412 7.63605 9.95312 11.998 9.95312C16.36 9.95312 19.998 8.39412 19.998 5.95312C19.998 3.51213 16.36 1.95312 11.998 1.95312ZM3.99805 9.57812V11.9531C3.99805 14.3941 7.63605 15.9531 11.998 15.9531C16.36 15.9531 19.998 14.3941 19.998 11.9531V9.57812C18.184 11.0681 15.356 11.9531 11.998 11.9531C8.64005 11.9531 5.81205 11.0681 3.99805 9.57812ZM3.99805 15.5781V17.9531C3.99805 20.3941 7.63605 21.9531 11.998 21.9531C16.36 21.9531 19.998 20.3941 19.998 17.9531V15.5781C18.184 17.0681 15.356 17.9531 11.998 17.9531C8.64005 17.9531 5.81205 17.0681 3.99805 15.5781Z" }) });
}
function xv(e) {
  return /* @__PURE__ */ D("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: [
    /* @__PURE__ */ A(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 2C13.1894 2 13.8136 2.27905 14.2659 2.73036C14.2834 2.74784 14.3007 2.76559 14.3177 2.78358C14.7174 3.20678 14.971 3.76953 14.9977 4.39107L14.9985 4.41205C14.9995 4.44124 15 4.47056 15 4.5L15 4.51426C15 4.55491 15.0247 4.59145 15.0623 4.60702C15.0998 4.62261 15.1431 4.61423 15.1719 4.58546L15.182 4.57538C15.2028 4.55456 15.2239 4.53419 15.2452 4.51426L15.2607 4.5C15.719 4.07934 16.2962 3.86073 16.8782 3.84417C16.9029 3.84346 16.9277 3.84312 16.9524 3.84315C17.5913 3.84382 18.23 4.0879 18.7175 4.57538L19.4246 5.28249C19.9121 5.76997 20.1562 6.40868 20.1569 7.0476C20.1569 7.07234 20.1565 7.09709 20.1558 7.12182C20.1393 7.70375 19.9207 8.281 19.5 8.73935L19.4857 8.75476C19.4658 8.77611 19.4454 8.7972 19.4246 8.81802L19.4145 8.82811C19.3858 8.85687 19.3774 8.90017 19.393 8.93775C19.4085 8.97529 19.4451 9 19.4857 9L19.5 9C19.5294 9 19.5588 9.00051 19.5879 9.00152L19.6089 9.00233C20.2305 9.02898 20.7932 9.28257 21.2164 9.68233C21.2344 9.69933 21.2522 9.71659 21.2696 9.73411C21.721 10.1864 22 10.8106 22 11.5L22 12.5C22 13.1894 21.721 13.8136 21.2696 14.2659C21.2522 14.2834 21.2344 14.3007 21.2164 14.3177C20.7932 14.7174 20.2305 14.971 19.6089 14.9977L19.5879 14.9985C19.5588 14.9995 19.5294 15 19.5 15L19.4857 15C19.4451 15 19.4085 15.0247 19.393 15.0623C19.3774 15.0998 19.3858 15.1431 19.4145 15.1719L19.4246 15.182C19.4454 15.2028 19.4658 15.2239 19.4857 15.2452L19.5 15.2607C19.9207 15.719 20.1393 16.2962 20.1558 16.8782C20.1565 16.9029 20.1569 16.9277 20.1569 16.9524C20.1562 17.5913 19.9121 18.23 19.4246 18.7175L18.7175 19.4246C18.23 19.9121 17.5913 20.1562 16.9524 20.1568C16.9277 20.1569 16.9029 20.1565 16.8782 20.1558C16.2963 20.1393 15.719 19.9207 15.2607 19.5L15.2452 19.4857C15.2239 19.4658 15.2028 19.4454 15.182 19.4246L15.1719 19.4145C15.1431 19.3858 15.0998 19.3774 15.0623 19.393C15.0247 19.4085 15 19.4451 15 19.4857L15 19.5C15 19.5294 14.9995 19.5588 14.9985 19.5879L14.9977 19.6089C14.971 20.2305 14.7174 20.7932 14.3177 21.2164C14.3007 21.2344 14.2834 21.2522 14.2659 21.2696C13.8136 21.7209 13.1894 22 12.5 22L11.5 22C10.8106 22 10.1864 21.7209 9.73411 21.2696C9.71659 21.2522 9.69933 21.2344 9.68233 21.2164C9.28257 20.7932 9.02898 20.2305 9.00233 19.6089L9.00152 19.5879C9.00051 19.5588 9 19.5294 9 19.5L9 19.4857C9 19.4451 8.97529 19.4085 8.93774 19.393C8.90017 19.3774 8.85687 19.3858 8.8281 19.4145L8.81802 19.4246C8.7972 19.4454 8.77611 19.4658 8.75475 19.4857L8.73934 19.5C8.281 19.9207 7.70375 20.1393 7.12182 20.1558C7.09708 20.1565 7.07234 20.1569 7.0476 20.1568C6.40868 20.1562 5.76997 19.9121 5.28249 19.4246L4.57538 18.7175C4.0879 18.23 3.84382 17.5913 3.84315 16.9524C3.84312 16.9277 3.84346 16.9029 3.84417 16.8782C3.86073 16.2962 4.07934 15.719 4.5 15.2607L4.51426 15.2452C4.53419 15.2239 4.55456 15.2028 4.57538 15.182L4.58546 15.1719C4.61423 15.1431 4.62261 15.0998 4.60702 15.0623C4.59145 15.0247 4.55491 15 4.51426 15L4.5 15C4.47056 15 4.44125 14.9995 4.41205 14.9985L4.39107 14.9977C3.76953 14.971 3.20678 14.7174 2.78358 14.3177C2.76558 14.3007 2.74784 14.2834 2.73036 14.2659C2.27905 13.8136 2 13.1894 2 12.5L2 11.5C2 10.8106 2.27905 10.1864 2.73036 9.73411C2.74784 9.71659 2.76558 9.69933 2.78358 9.68233C3.20678 9.28257 3.76953 9.02898 4.39107 9.00233L4.41205 9.00152C4.44125 9.00051 4.47056 9 4.5 9L4.51426 9C4.55491 9 4.59145 8.97529 4.60702 8.93775C4.62261 8.90017 4.61423 8.85687 4.58546 8.82811L4.57538 8.81802C4.55456 8.7972 4.53419 8.77611 4.51426 8.75476L4.5 8.73935C4.07934 8.281 3.86073 7.70375 3.84417 7.12182C3.84346 7.09709 3.84312 7.07234 3.84315 7.0476C3.84382 6.40868 4.0879 5.76997 4.57538 5.28249L5.28249 4.57538C5.76997 4.0879 6.40868 3.84382 7.0476 3.84315C7.07234 3.84312 7.09709 3.84346 7.12182 3.84417C7.70375 3.86073 8.281 4.07934 8.73934 4.5L8.75476 4.51426C8.77611 4.53419 8.7972 4.55456 8.81802 4.57538L8.8281 4.58546C8.85687 4.61423 8.90017 4.62261 8.93775 4.60702C8.97529 4.59145 9 4.55491 9 4.51426L9 4.5C9 4.47056 9.00051 4.44124 9.00152 4.41205L9.00233 4.39107C9.02898 3.76953 9.28257 3.20678 9.68233 2.78358C9.69933 2.76559 9.71659 2.74784 9.73411 2.73036C10.1864 2.27905 10.8106 2 11.5 2L12.5 2ZM11 19.5C11 19.7761 11.2239 20 11.5 20L12.5 20C12.7761 20 13 19.7761 13 19.5L13 19.4857C13 18.6262 13.5212 17.8669 14.2962 17.5455C15.0727 17.2235 15.9787 17.3929 16.5861 18.0003L16.5962 18.0104C16.7915 18.2057 17.108 18.2057 17.3033 18.0104L18.0104 17.3033C18.2057 17.108 18.2057 16.7915 18.0104 16.5962L18.0003 16.5861C17.3929 15.9787 17.2235 15.0727 17.5455 14.2961C17.8669 13.5212 18.6262 13 19.4857 13L19.5 13C19.7761 13 20 12.7761 20 12.5L20 11.5C20 11.2239 19.7761 11 19.5 11L19.4857 11C18.6262 11 17.8669 10.4788 17.5455 9.70385C17.2235 8.92727 17.3929 8.02132 18.0003 7.41389L18.0104 7.40381C18.2057 7.20854 18.2057 6.89196 18.0104 6.6967L17.3033 5.98959C17.108 5.79433 16.7915 5.79433 16.5962 5.98959L16.5861 5.99968C15.9787 6.60711 15.0727 6.77651 14.2962 6.45448C13.5212 6.13311 13 5.37381 13 4.51426L13 4.5C13 4.22386 12.7761 4 12.5 4L11.5 4C11.2239 4 11 4.22386 11 4.5L11 4.51426C11 5.37381 10.4788 6.13311 9.70384 6.45448C8.92725 6.77651 8.02132 6.60711 7.41389 5.99968L7.40381 5.98959C7.20854 5.79433 6.89196 5.79433 6.6967 5.98959L5.98959 6.6967C5.79433 6.89196 5.79433 7.20854 5.98959 7.40381L5.99967 7.41389C6.60711 8.02132 6.77651 8.92727 6.45448 9.70385C6.13311 10.4788 5.37382 11 4.51426 11L4.5 11C4.22386 11 4 11.2239 4 11.5L4 12.5C4 12.7761 4.22386 13 4.5 13L4.51426 13C5.37382 13 6.13311 13.5212 6.45447 14.2961C6.77651 15.0727 6.60711 15.9787 5.99968 16.5861L5.98959 16.5962C5.79433 16.7915 5.79433 17.108 5.98959 17.3033L6.6967 18.0104C6.89196 18.2057 7.20854 18.2057 7.4038 18.0104L7.41389 18.0003C8.02132 17.3929 8.92726 17.2235 9.70384 17.5455C10.4788 17.8669 11 18.6262 11 19.4857L11 19.5Z"
      }
    ),
    /* @__PURE__ */ A(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      }
    )
  ] });
}
function Bv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.01042 1.3418C4.32842 1.3418 1.34375 4.3266 1.34375 8.00847C1.34375 11.6905 4.32842 14.6751 8.01042 14.6751C11.6924 14.6751 14.6771 11.6905 14.6771 8.00847C14.6771 4.3266 11.6924 1.3418 8.01042 1.3418ZM8.01042 4.67513C8.37842 4.67513 8.67708 4.9736 8.67708 5.3418V8.67514H10.6771L8.01042 11.3418L5.34375 8.67514H7.34375V5.3418C7.34375 4.9736 7.64242 4.67513 8.01042 4.67513Z" }) });
}
function wv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.81333 1.33662C6.07787 1.38545 4.42992 2.10935 3.21991 3.35437C2.0099 4.59939 1.3333 6.26732 1.33398 8.00346C1.33478 9.7711 2.03752 11.4661 3.28771 12.7157C4.5379 13.9653 6.23319 14.6673 8.00083 14.6673C9.76847 14.6673 11.4638 13.9653 12.714 12.7157C13.9641 11.4661 14.6669 9.7711 14.6677 8.00346C14.668 7.11195 14.4896 6.22943 14.1429 5.4081C13.7962 4.58678 13.2883 3.84332 12.6492 3.22173C12.0101 2.60015 11.2529 2.11306 10.4222 1.78926C9.59161 1.46547 8.70448 1.31155 7.81333 1.33662ZM8.00083 4.67003C8.92086 4.67003 9.75038 5.00753 10.3551 5.60755L11.3343 4.67003V7.33679H11.2718H10.2093H8.66755L9.62591 6.33676C9.21457 5.93674 8.64705 5.67005 8.0217 5.67005C6.98901 5.67005 6.13082 6.4034 5.83414 7.33679H4.72995C5.04062 5.80341 6.39012 4.67003 8.00083 4.67003ZM4.66741 8.67016H4.72988H5.79241H7.33412L6.37576 9.60768C6.7871 10.0077 7.35461 10.2744 7.97997 10.2744C9.01266 10.2744 9.87085 9.60351 10.1675 8.67016H11.2717C10.961 10.1368 9.61151 11.3369 8.0008 11.3369C7.08078 11.3369 6.25125 10.9369 5.64657 10.3369L4.66738 11.3369L4.66741 8.67016Z" }) });
}
function Pv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.9981 4.46484C11.1693 4.46484 10.4981 5.13609 10.4981 5.96484H6.74805C6.33405 5.96484 5.99805 6.30084 5.99805 6.71484C5.99805 7.12884 6.33405 7.46483 6.74805 7.46483H17.2481C17.6621 7.46483 17.9981 7.12884 17.9981 6.71484C17.9981 6.30084 17.6621 5.96484 17.2481 5.96484H13.4981C13.4981 5.13609 12.8268 4.46484 11.9981 4.46484ZM6.74805 8.96483V16.4648C6.74805 18.1073 8.1018 19.4415 9.74805 19.4415L14.2713 19.4648C15.9176 19.4648 17.2481 18.1111 17.2481 16.4648V8.96483H6.74805ZM10.4981 11.2148C10.9121 11.2148 11.2481 11.5508 11.2481 11.9648V16.4648C11.2481 16.8788 10.9121 17.2148 10.4981 17.2148C10.0841 17.2148 9.74805 16.8788 9.74805 16.4648V11.9648C9.74805 11.5508 10.0841 11.2148 10.4981 11.2148ZM13.4981 11.2148C13.9121 11.2148 14.2481 11.5508 14.2481 11.9648V16.4648C14.2481 16.8788 13.9121 17.2148 13.4981 17.2148C13.0841 17.2148 12.7481 16.8788 12.7481 16.4648V11.9648C12.7481 11.5508 13.0841 11.2148 13.4981 11.2148Z" }) });
}
function Hv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.99935 1.30273C7.26269 1.30273 6.66602 1.8994 6.66602 2.63606H3.33268C2.96468 2.63606 2.66602 2.93473 2.66602 3.30273C2.66602 3.67073 2.96468 3.96939 3.33268 3.96939H12.666C13.034 3.96939 13.3327 3.67073 13.3327 3.30273C13.3327 2.93473 13.034 2.63606 12.666 2.63606H9.33269C9.33269 1.8994 8.73602 1.30273 7.99935 1.30273ZM3.33268 5.30272V11.9694C3.33268 13.4294 4.53602 14.6154 5.99935 14.6154L10.02 14.636C11.4834 14.636 12.666 13.4327 12.666 11.9694V5.30272H3.33268ZM6.66602 7.30272C7.03402 7.30272 7.33269 7.60138 7.33269 7.96938V11.9694C7.33269 12.3374 7.03402 12.636 6.66602 12.636C6.29802 12.636 5.99935 12.3374 5.99935 11.9694V7.96938C5.99935 7.60138 6.29802 7.30272 6.66602 7.30272ZM9.33269 7.30272C9.70069 7.30272 9.99936 7.60138 9.99936 7.96938V11.9694C9.99936 12.3374 9.70069 12.636 9.33269 12.636C8.96469 12.636 8.66602 12.3374 8.66602 11.9694V7.96938C8.66602 7.60138 8.96469 7.30272 9.33269 7.30272Z" }) });
}
function Ov(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M4.09245 12.0893L4 11.9998L4.09245 11.9103L4.66414 11.3568L4.66493 11.356L9.81374 6.37154C10.1808 6.01623 10.7758 6.01623 11.1428 6.37154C11.5098 6.72685 11.5098 7.30291 11.1428 7.65822L7.59798 11.09L19.0602 11.09C19.5792 11.09 20 11.4973 20 11.9998C20 12.5023 19.5792 12.9096 19.0602 12.9096L7.59798 12.9096L11.1428 16.3413C11.5098 16.6967 11.5098 17.2727 11.1428 17.628C10.7758 17.9834 10.1808 17.9834 9.81375 17.628L4.66493 12.6435L4.66414 12.6427L4.09245 12.0893Z" }) });
}
function Dv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M14.0098 3.95312C14.0098 2.84812 13.1144 1.95312 12.0098 1.95312C10.9052 1.95312 10.0098 2.84812 10.0098 3.95312C10.0098 5.05812 10.9052 5.95311 12.0098 5.95311C13.1144 5.95311 14.0098 5.05812 14.0098 3.95312ZM14.0098 11.9531C14.0098 10.8481 13.1144 9.9531 12.0098 9.9531C10.9052 9.9531 10.0098 10.8481 10.0098 11.9531C10.0098 13.0581 10.9052 13.9531 12.0098 13.9531C13.1144 13.9531 14.0098 13.0581 14.0098 11.9531ZM14.0098 19.9531C14.0098 18.8481 13.1144 17.9531 12.0098 17.9531C10.9052 17.9531 10.0098 18.8481 10.0098 19.9531C10.0098 21.0581 10.9052 21.9531 12.0098 21.9531C13.1144 21.9531 14.0098 21.0581 14.0098 19.9531Z" }) });
}
function Sv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12 3C7.0293 3 3 7.0293 3 12C3 16.9707 7.0293 21 12 21C16.9707 21 21 16.9707 21 12C21 7.0293 16.9707 3 12 3ZM12 7.5C12.4968 7.5 12.9 7.9032 12.9 8.4V12.9C12.9 13.3968 12.4968 13.8 12 13.8C11.5032 13.8 11.1 13.3968 11.1 12.9V8.4C11.1 7.9032 11.5032 7.5 12 7.5ZM12 14.7C12.4968 14.7 12.9 15.1032 12.9 15.6C12.9 16.0968 12.4968 16.5 12 16.5C11.5032 16.5 11.1 16.0968 11.1 15.6C11.1 15.1032 11.5032 14.7 12 14.7Z" }) });
}
function Nv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M3.32875 2.60352C3.15815 2.60352 2.97975 2.66085 2.84955 2.79085C2.58921 3.05152 2.58921 3.48884 2.84955 3.74951L7.03708 7.93685L2.84955 12.1242C2.58921 12.3849 2.58921 12.8222 2.84955 13.0828C3.10995 13.3428 3.54755 13.3428 3.80795 13.0828L7.99541 8.89552L12.1829 13.0828C12.4433 13.3428 12.8809 13.3428 13.1413 13.0828C13.4016 12.8222 13.4016 12.3849 13.1413 12.1242L8.95375 7.93685L13.1413 3.74951C13.4016 3.48884 13.4016 3.05152 13.1413 2.79085C13.0111 2.66085 12.8326 2.60352 12.6621 2.60352C12.4915 2.60352 12.3131 2.66085 12.1829 2.79085L7.99541 6.97818L3.80795 2.79085C3.67775 2.66085 3.49935 2.60352 3.32875 2.60352Z" }) });
}
function Tv(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.9993 8.51506L15.4844 7L11.9994 10.4852L8.51497 7.00057L7 8.51562L10.4844 12.0003L7.00056 15.4843L8.51552 16.9994L11.9994 13.5153L15.4838 17L16.9988 15.4849L13.5144 12.0003L16.9993 8.51506Z"
    }
  ) });
}
const Rv = {
  ArrowFilledRight: w9,
  ArrowLeft: P9,
  ArrowUp: H9,
  BarChart: O9,
  BaseArrowLeft: D9,
  BaseArrowRight: S9,
  Braces: N9,
  Branch: T9,
  BrickGlobe: R9,
  Briefcase: L9,
  Calendar: F9,
  CaretDown: Q9,
  Caret: X9,
  CheckCircleFill: V9,
  CheckCircle: k9,
  Check: M9,
  ChevronDown: z9,
  Circle: j9,
  ClockFill: W9,
  CloudSlash: Z9,
  Collapse: G9,
  Connect: q9,
  Drive: Y9,
  Ellipsis: U9,
  Error: J9,
  Exclamation: K9,
  FilesEarmark: _9,
  FolderClose: $9,
  FolderOpen: ev,
  FolderPlus: tv,
  Gear: nv,
  Globe: rv,
  Hdd: iv,
  History: ov,
  InfoSquare: sv,
  Link: av,
  Lock: cv,
  M: uv,
  Pencil: lv,
  People: dv,
  Person: Av,
  PlusCircle: fv,
  Plus: gv,
  PowerhouseLogoSmall: hv,
  Project: pv,
  RedoArrow: mv,
  RenownHover: vv,
  Renown: bv,
  Ring: yv,
  Save: Cv,
  Search: Iv,
  Server: Ev,
  Settings: xv,
  Synced: Bv,
  Syncing: wv,
  TrashFill: Pv,
  Trash: Hv,
  VariantArrowLeft: Ov,
  VerticalDots: Dv,
  WarningFill: Sv,
  XmarkLight: Nv,
  Xmark: Tv
}, Lv = "data:image/png;base64,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", jl = "-", Fv = (e) => {
  const t = Xv(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(jl);
      return a[0] === "" && a.length !== 1 && a.shift(), b0(a, t) || Qv(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const c = n[s] || [];
      return a && r[s] ? [...c, ...r[s]] : c;
    }
  };
}, b0 = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? b0(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(jl);
  return (s = t.validators.find(({
    validator: a
  }) => a(o))) == null ? void 0 : s.classGroupId;
}, TA = /^\[(.+)\]$/, Qv = (e) => {
  if (TA.test(e)) {
    const t = TA.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Xv = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return kv(Object.entries(e.classGroups), n).forEach(([o, s]) => {
    Cu(s, r, o, t);
  }), r;
}, Cu = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : RA(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (Vv(i)) {
        Cu(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, s]) => {
      Cu(s, RA(t, o), n, r);
    });
  });
}, RA = (e, t) => {
  let n = e;
  return t.split(jl).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Vv = (e) => e.isThemeGetter, kv = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([s, a]) => [t + s, a])) : o);
  return [n, i];
}) : e, Mv = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, s) => {
    n.set(o, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}, y0 = "!", zv = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length, s = (a) => {
    const c = [];
    let u = 0, l = 0, d;
    for (let p = 0; p < a.length; p++) {
      let v = a[p];
      if (u === 0) {
        if (v === i && (r || a.slice(p, p + o) === t)) {
          c.push(a.slice(l, p)), l = p + o;
          continue;
        }
        if (v === "/") {
          d = p;
          continue;
        }
      }
      v === "[" ? u++ : v === "]" && u--;
    }
    const f = c.length === 0 ? a : a.substring(l), h = f.startsWith(y0), g = h ? f.substring(1) : f, m = d && d > l ? d - l : void 0;
    return {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, jv = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Wv = (e) => ({
  cache: Mv(e.cacheSize),
  parseClassName: zv(e),
  ...Fv(e)
}), Zv = /\s+/, Gv = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = [], s = e.trim().split(Zv);
  let a = "";
  for (let c = s.length - 1; c >= 0; c -= 1) {
    const u = s[c], {
      modifiers: l,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: h
    } = n(u);
    let g = !!h, m = r(g ? f.substring(0, h) : f);
    if (!m) {
      if (!g) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (m = r(f), !m) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      g = !1;
    }
    const p = jv(l).join(":"), v = d ? p + y0 : p, b = v + m;
    if (o.includes(b))
      continue;
    o.push(b);
    const y = i(m, g);
    for (let E = 0; E < y.length; ++E) {
      const C = y[E];
      o.push(v + C);
    }
    a = u + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function Or() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = C0(t)) && (r && (r += " "), r += n);
  return r;
}
const C0 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = C0(e[r])) && (n && (n += " "), n += t);
  return n;
};
function qv(e, ...t) {
  let n, r, i, o = s;
  function s(c) {
    const u = t.reduce((l, d) => d(l), e());
    return n = Wv(u), r = n.cache.get, i = n.cache.set, o = a, a(c);
  }
  function a(c) {
    const u = r(c);
    if (u)
      return u;
    const l = Gv(c, n);
    return i(c, l), l;
  }
  return function() {
    return o(Or.apply(null, arguments));
  };
}
const ze = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, I0 = /^\[(?:([a-z-]+):)?(.+)\]$/i, Yv = /^\d+\/\d+$/, Uv = /* @__PURE__ */ new Set(["px", "full", "screen"]), Jv = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Kv = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, _v = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, $v = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, e2 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, pn = (e) => _r(e) || Uv.has(e) || Yv.test(e), wn = (e) => Si(e, "length", c2), _r = (e) => !!e && !Number.isNaN(Number(e)), gc = (e) => Si(e, "number", _r), Gi = (e) => !!e && Number.isInteger(Number(e)), t2 = (e) => e.endsWith("%") && _r(e.slice(0, -1)), xe = (e) => I0.test(e), Pn = (e) => Jv.test(e), n2 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), r2 = (e) => Si(e, n2, E0), i2 = (e) => Si(e, "position", E0), o2 = /* @__PURE__ */ new Set(["image", "url"]), s2 = (e) => Si(e, o2, l2), a2 = (e) => Si(e, "", u2), qi = () => !0, Si = (e, t, n) => {
  const r = I0.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, c2 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Kv.test(e) && !_v.test(e)
), E0 = () => !1, u2 = (e) => $v.test(e), l2 = (e) => e2.test(e), d2 = () => {
  const e = ze("colors"), t = ze("spacing"), n = ze("blur"), r = ze("brightness"), i = ze("borderColor"), o = ze("borderRadius"), s = ze("borderSpacing"), a = ze("borderWidth"), c = ze("contrast"), u = ze("grayscale"), l = ze("hueRotate"), d = ze("invert"), f = ze("gap"), h = ze("gradientColorStops"), g = ze("gradientColorStopPositions"), m = ze("inset"), p = ze("margin"), v = ze("opacity"), b = ze("padding"), y = ze("saturate"), E = ze("scale"), C = ze("sepia"), B = ze("skew"), I = ze("space"), x = ze("translate"), O = () => ["auto", "contain", "none"], k = () => ["auto", "hidden", "clip", "visible", "scroll"], Q = () => ["auto", xe, t], F = () => [xe, t], M = () => ["", pn, wn], H = () => ["auto", _r, xe], T = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], R = () => ["solid", "dashed", "dotted", "double", "none"], z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], L = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], X = () => ["", "0", xe], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], U = () => [_r, xe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [qi],
      spacing: [pn, wn],
      blur: ["none", "", Pn, xe],
      brightness: U(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Pn, xe],
      borderSpacing: F(),
      borderWidth: M(),
      contrast: U(),
      grayscale: X(),
      hueRotate: U(),
      invert: X(),
      gap: F(),
      gradientColorStops: [e],
      gradientColorStopPositions: [t2, wn],
      inset: Q(),
      margin: Q(),
      opacity: U(),
      padding: F(),
      saturate: U(),
      scale: U(),
      sepia: X(),
      skew: U(),
      space: F(),
      translate: F()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", xe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Pn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...T(), xe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Gi, xe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: Q()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", xe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: X()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: X()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Gi, xe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [qi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Gi, xe]
        }, xe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": H()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": H()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [qi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Gi, xe]
        }, xe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": H()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": H()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", xe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", xe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...L()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...L(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...L(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [p]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [p]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [p]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [p]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [p]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [p]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [p]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [p]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [p]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", xe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [xe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [xe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Pn]
        }, Pn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [xe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [xe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [xe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [xe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Pn, wn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", gc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [qi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", xe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", _r, gc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", pn, xe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", xe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", xe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...R(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", pn, wn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", pn, xe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", xe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", xe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...T(), i2]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", r2]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, s2]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...R(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: R()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...R()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [pn, xe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [pn, wn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: M()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [pn, wn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Pn, a2]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [qi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Pn, xe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [l]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [C]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [l]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [C]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", xe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: U()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", xe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: U()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", xe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [E]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [E]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [E]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Gi, xe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [x]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [x]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [B]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [B]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", xe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", xe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", xe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [pn, wn, gc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, $ = /* @__PURE__ */ qv(d2), Et = Nt(function(t, n) {
  const {
    color: r = "dark",
    size: i = "medium",
    className: o = "",
    children: s,
    icon: a,
    iconPosition: c = "left",
    ...u
  } = t, l = {
    small: "px-2 py-1.5 text-xs rounded-md font-medium",
    medium: "px-6 py-3 text-base rounded-xl font-semibold tracking-wide"
  }, f = Or({
    light: "bg-gray-200 text-gray-600 hover:text-gray-700 hover:border-gray-300 active:border-slate-100 active:text-gray-600 disabled:text-gray-400",
    dark: "bg-gray-800 text-slate-50 hover:bg-slate-800 active:border-slate-700 disabled:bg-gray-300 disabled:text-slate-100",
    red: "bg-red-900 text-slate-50 hover:opacity-80 active:border-red-800 disabled:text-red-400 disabled:opacity-100",
    blue: "bg-blue-900 text-slate-50 hover:opacity-80 active:border-blue-800 disabled:text-blue-400 disabled:opacity-100"
  }[r], l[i]), h = $(
    "flex items-center justify-center gap-2 border border-none outline-none transition disabled:cursor-not-allowed",
    f,
    o
  );
  return /* @__PURE__ */ D("button", { ref: n, className: h, ...u, children: [
    c === "left" && a,
    s,
    c === "right" && a
  ] });
});
function he(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function A2(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Da(...e) {
  return (t) => e.forEach((n) => A2(n, t));
}
function $e(...e) {
  return w.useCallback(Da(...e), e);
}
function f2(e, t) {
  const n = w.createContext(t);
  function r(o) {
    const { children: s, ...a } = o, c = w.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ A(n.Provider, { value: c, children: s });
  }
  function i(o) {
    const s = w.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, i];
}
function _n(e, t = []) {
  let n = [];
  function r(o, s) {
    const a = w.createContext(s), c = n.length;
    n = [...n, s];
    function u(d) {
      const { scope: f, children: h, ...g } = d, m = (f == null ? void 0 : f[e][c]) || a, p = w.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ A(m.Provider, { value: p, children: h });
    }
    function l(d, f) {
      const h = (f == null ? void 0 : f[e][c]) || a, g = w.useContext(h);
      if (g) return g;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [u, l];
  }
  const i = () => {
    const o = n.map((s) => w.createContext(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || o;
      return w.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: c } }),
        [a, c]
      );
    };
  };
  return i.scopeName = e, [r, g2(i, ...t)];
}
function g2(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const s = r.reduce((a, { useScope: c, scopeName: u }) => {
        const d = c(o)[`__scope${u}`];
        return { ...a, ...d };
      }, {});
      return w.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Yt(e) {
  const t = w.useRef(e);
  return w.useEffect(() => {
    t.current = e;
  }), w.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function $o({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = h2({ defaultProp: t, onChange: n }), o = e !== void 0, s = o ? e : r, a = Yt(n), c = w.useCallback(
    (u) => {
      if (o) {
        const d = typeof u == "function" ? u(e) : u;
        d !== e && a(d);
      } else
        i(u);
    },
    [o, e, i, a]
  );
  return [s, c];
}
function h2({
  defaultProp: e,
  onChange: t
}) {
  const n = w.useState(e), [r] = n, i = w.useRef(r), o = Yt(t);
  return w.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var yi = w.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = w.Children.toArray(n), o = i.find(p2);
  if (o) {
    const s = o.props.children, a = i.map((c) => c === o ? w.Children.count(s) > 1 ? w.Children.only(null) : w.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ A(Iu, { ...r, ref: t, children: w.isValidElement(s) ? w.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ A(Iu, { ...r, ref: t, children: n });
});
yi.displayName = "Slot";
var Iu = w.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (w.isValidElement(n)) {
    const i = v2(n);
    return w.cloneElement(n, {
      ...m2(r, n.props),
      // @ts-ignore
      ref: t ? Da(t, i) : i
    });
  }
  return w.Children.count(n) > 1 ? w.Children.only(null) : null;
});
Iu.displayName = "SlotClone";
var x0 = ({ children: e }) => /* @__PURE__ */ A(Be, { children: e });
function p2(e) {
  return w.isValidElement(e) && e.type === x0;
}
function m2(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function v2(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var b2 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Me = b2.reduce((e, t) => {
  const n = w.forwardRef((r, i) => {
    const { asChild: o, ...s } = r, a = o ? yi : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(a, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function B0(e, t) {
  e && zl.flushSync(() => e.dispatchEvent(t));
}
function w0(e) {
  const t = e + "CollectionProvider", [n, r] = _n(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: m } = h, p = _.useRef(null), v = _.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ A(i, { scope: g, itemMap: v, collectionRef: p, children: m });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", c = _.forwardRef(
    (h, g) => {
      const { scope: m, children: p } = h, v = o(a, m), b = $e(g, v.collectionRef);
      return /* @__PURE__ */ A(yi, { ref: b, children: p });
    }
  );
  c.displayName = a;
  const u = e + "CollectionItemSlot", l = "data-radix-collection-item", d = _.forwardRef(
    (h, g) => {
      const { scope: m, children: p, ...v } = h, b = _.useRef(null), y = $e(g, b), E = o(u, m);
      return _.useEffect(() => (E.itemMap.set(b, { ref: b, ...v }), () => void E.itemMap.delete(b))), /* @__PURE__ */ A(yi, { [l]: "", ref: y, children: p });
    }
  );
  d.displayName = u;
  function f(h) {
    const g = o(e + "CollectionConsumer", h);
    return _.useCallback(() => {
      const p = g.collectionRef.current;
      if (!p) return [];
      const v = Array.from(p.querySelectorAll(`[${l}]`));
      return Array.from(g.itemMap.values()).sort(
        (E, C) => v.indexOf(E.ref.current) - v.indexOf(C.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: d },
    f,
    r
  ];
}
var y2 = w.createContext(void 0);
function Wl(e) {
  const t = w.useContext(y2);
  return e || t || "ltr";
}
function C2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Yt(e);
  w.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var I2 = "DismissableLayer", Eu = "dismissableLayer.update", E2 = "dismissableLayer.pointerDownOutside", x2 = "dismissableLayer.focusOutside", LA, P0 = w.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Sa = w.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: s,
      onDismiss: a,
      ...c
    } = e, u = w.useContext(P0), [l, d] = w.useState(null), f = (l == null ? void 0 : l.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = w.useState({}), g = $e(t, (I) => d(I)), m = Array.from(u.layers), [p] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = m.indexOf(p), b = l ? m.indexOf(l) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, E = b >= v, C = P2((I) => {
      const x = I.target, O = [...u.branches].some((k) => k.contains(x));
      !E || O || (i == null || i(I), s == null || s(I), I.defaultPrevented || a == null || a());
    }, f), B = H2((I) => {
      const x = I.target;
      [...u.branches].some((k) => k.contains(x)) || (o == null || o(I), s == null || s(I), I.defaultPrevented || a == null || a());
    }, f);
    return C2((I) => {
      b === u.layers.size - 1 && (r == null || r(I), !I.defaultPrevented && a && (I.preventDefault(), a()));
    }, f), w.useEffect(() => {
      if (l)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (LA = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(l)), u.layers.add(l), FA(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = LA);
        };
    }, [l, f, n, u]), w.useEffect(() => () => {
      l && (u.layers.delete(l), u.layersWithOutsidePointerEventsDisabled.delete(l), FA());
    }, [l, u]), w.useEffect(() => {
      const I = () => h({});
      return document.addEventListener(Eu, I), () => document.removeEventListener(Eu, I);
    }, []), /* @__PURE__ */ A(
      Me.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: y ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: he(e.onFocusCapture, B.onFocusCapture),
        onBlurCapture: he(e.onBlurCapture, B.onBlurCapture),
        onPointerDownCapture: he(
          e.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
Sa.displayName = I2;
var B2 = "DismissableLayerBranch", w2 = w.forwardRef((e, t) => {
  const n = w.useContext(P0), r = w.useRef(null), i = $e(t, r);
  return w.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ A(Me.div, { ...e, ref: i });
});
w2.displayName = B2;
function P2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Yt(e), r = w.useRef(!1), i = w.useRef(() => {
  });
  return w.useEffect(() => {
    const o = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          H0(
            E2,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function H2(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Yt(e), r = w.useRef(!1);
  return w.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && H0(x2, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function FA() {
  const e = new CustomEvent(Eu);
  document.dispatchEvent(e);
}
function H0(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? B0(i, o) : i.dispatchEvent(o);
}
var hc = 0;
function O0() {
  w.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? QA()), document.body.insertAdjacentElement("beforeend", e[1] ?? QA()), hc++, () => {
      hc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), hc--;
    };
  }, []);
}
function QA() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var pc = "focusScope.autoFocusOnMount", mc = "focusScope.autoFocusOnUnmount", XA = { bubbles: !1, cancelable: !0 }, O2 = "FocusScope", Zl = w.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...s
  } = e, [a, c] = w.useState(null), u = Yt(i), l = Yt(o), d = w.useRef(null), f = $e(t, (m) => c(m)), h = w.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  w.useEffect(() => {
    if (r) {
      let m = function(y) {
        if (h.paused || !a) return;
        const E = y.target;
        a.contains(E) ? d.current = E : Dn(d.current, { select: !0 });
      }, p = function(y) {
        if (h.paused || !a) return;
        const E = y.relatedTarget;
        E !== null && (a.contains(E) || Dn(d.current, { select: !0 }));
      }, v = function(y) {
        if (document.activeElement === document.body)
          for (const C of y)
            C.removedNodes.length > 0 && Dn(a);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", p);
      const b = new MutationObserver(v);
      return a && b.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", p), b.disconnect();
      };
    }
  }, [r, a, h.paused]), w.useEffect(() => {
    if (a) {
      kA.add(h);
      const m = document.activeElement;
      if (!a.contains(m)) {
        const v = new CustomEvent(pc, XA);
        a.addEventListener(pc, u), a.dispatchEvent(v), v.defaultPrevented || (D2(L2(D0(a)), { select: !0 }), document.activeElement === m && Dn(a));
      }
      return () => {
        a.removeEventListener(pc, u), setTimeout(() => {
          const v = new CustomEvent(mc, XA);
          a.addEventListener(mc, l), a.dispatchEvent(v), v.defaultPrevented || Dn(m ?? document.body, { select: !0 }), a.removeEventListener(mc, l), kA.remove(h);
        }, 0);
      };
    }
  }, [a, u, l, h]);
  const g = w.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const p = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, v = document.activeElement;
      if (p && v) {
        const b = m.currentTarget, [y, E] = S2(b);
        y && E ? !m.shiftKey && v === E ? (m.preventDefault(), n && Dn(y, { select: !0 })) : m.shiftKey && v === y && (m.preventDefault(), n && Dn(E, { select: !0 })) : v === b && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ A(Me.div, { tabIndex: -1, ...s, ref: f, onKeyDown: g });
});
Zl.displayName = O2;
function D2(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Dn(r, { select: t }), document.activeElement !== n) return;
}
function S2(e) {
  const t = D0(e), n = VA(t, e), r = VA(t.reverse(), e);
  return [n, r];
}
function D0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function VA(e, t) {
  for (const n of e)
    if (!N2(n, { upTo: t })) return n;
}
function N2(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function T2(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Dn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && T2(e) && t && e.select();
  }
}
var kA = R2();
function R2() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = MA(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = MA(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function MA(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function L2(e) {
  return e.filter((t) => t.tagName !== "A");
}
var vr = globalThis != null && globalThis.document ? w.useLayoutEffect : () => {
}, F2 = w.useId || (() => {
}), Q2 = 0;
function Mn(e) {
  const [t, n] = w.useState(F2());
  return vr(() => {
    e || n((r) => r ?? String(Q2++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const X2 = ["top", "right", "bottom", "left"], Gn = Math.min, Pt = Math.max, _s = Math.round, gs = Math.floor, qn = (e) => ({
  x: e,
  y: e
}), V2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, k2 = {
  start: "end",
  end: "start"
};
function xu(e, t, n) {
  return Pt(e, Gn(t, n));
}
function En(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function xn(e) {
  return e.split("-")[0];
}
function Ni(e) {
  return e.split("-")[1];
}
function Gl(e) {
  return e === "x" ? "y" : "x";
}
function ql(e) {
  return e === "y" ? "height" : "width";
}
function Yn(e) {
  return ["top", "bottom"].includes(xn(e)) ? "y" : "x";
}
function Yl(e) {
  return Gl(Yn(e));
}
function M2(e, t, n) {
  n === void 0 && (n = !1);
  const r = Ni(e), i = Yl(e), o = ql(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = $s(s)), [s, $s(s)];
}
function z2(e) {
  const t = $s(e);
  return [Bu(e), t, Bu(t)];
}
function Bu(e) {
  return e.replace(/start|end/g, (t) => k2[t]);
}
function j2(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function W2(e, t, n, r) {
  const i = Ni(e);
  let o = j2(xn(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(Bu)))), o;
}
function $s(e) {
  return e.replace(/left|right|bottom|top/g, (t) => V2[t]);
}
function Z2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function S0(e) {
  return typeof e != "number" ? Z2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ea(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function zA(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = Yn(t), s = Yl(t), a = ql(s), c = xn(t), u = o === "y", l = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ni(t)) {
    case "start":
      h[s] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const G2 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: d
  } = zA(u, r, c), f = r, h = {}, g = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: p,
      fn: v
    } = a[m], {
      x: b,
      y,
      data: E,
      reset: C
    } = await v({
      x: l,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = b ?? l, d = y ?? d, h = {
      ...h,
      [p]: {
        ...h[p],
        ...E
      }
    }, C && g <= 50 && (g++, typeof C == "object" && (C.placement && (f = C.placement), C.rects && (u = C.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : C.rects), {
      x: l,
      y: d
    } = zA(u, f, c)), m = -1);
  }
  return {
    x: l,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function ho(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = En(t, e), g = S0(h), p = a[f ? d === "floating" ? "reference" : "floating" : d], v = ea(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(p))) == null || n ? p : p.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), b = d === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), E = await (o.isElement == null ? void 0 : o.isElement(y)) ? await (o.getScale == null ? void 0 : o.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = ea(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: b,
    offsetParent: y,
    strategy: c
  }) : b);
  return {
    top: (v.top - C.top + g.top) / E.y,
    bottom: (C.bottom - v.bottom + g.bottom) / E.y,
    left: (v.left - C.left + g.left) / E.x,
    right: (C.right - v.right + g.right) / E.x
  };
}
const q2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: c
    } = t, {
      element: u,
      padding: l = 0
    } = En(e, t) || {};
    if (u == null)
      return {};
    const d = S0(l), f = {
      x: n,
      y: r
    }, h = Yl(i), g = ql(h), m = await s.getDimensions(u), p = h === "y", v = p ? "top" : "left", b = p ? "bottom" : "right", y = p ? "clientHeight" : "clientWidth", E = o.reference[g] + o.reference[h] - f[h] - o.floating[g], C = f[h] - o.reference[h], B = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let I = B ? B[y] : 0;
    (!I || !await (s.isElement == null ? void 0 : s.isElement(B))) && (I = a.floating[y] || o.floating[g]);
    const x = E / 2 - C / 2, O = I / 2 - m[g] / 2 - 1, k = Gn(d[v], O), Q = Gn(d[b], O), F = k, M = I - m[g] - Q, H = I / 2 - m[g] / 2 + x, T = xu(F, H, M), R = !c.arrow && Ni(i) != null && H !== T && o.reference[g] / 2 - (H < F ? k : Q) - m[g] / 2 < 0, z = R ? H < F ? H - F : H - M : 0;
    return {
      [h]: f[h] + z,
      data: {
        [h]: T,
        centerOffset: H - T - z,
        ...R && {
          alignmentOffset: z
        }
      },
      reset: R
    };
  }
}), Y2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: u
      } = t, {
        mainAxis: l = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...p
      } = En(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const v = xn(i), b = Yn(a), y = xn(a) === a, E = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), C = f || (y || !m ? [$s(a)] : z2(a)), B = g !== "none";
      !f && B && C.push(...W2(a, m, g, E));
      const I = [a, ...C], x = await ho(t, p), O = [];
      let k = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (l && O.push(x[v]), d) {
        const H = M2(i, s, E);
        O.push(x[H[0]], x[H[1]]);
      }
      if (k = [...k, {
        placement: i,
        overflows: O
      }], !O.every((H) => H <= 0)) {
        var Q, F;
        const H = (((Q = o.flip) == null ? void 0 : Q.index) || 0) + 1, T = I[H];
        if (T)
          return {
            data: {
              index: H,
              overflows: k
            },
            reset: {
              placement: T
            }
          };
        let R = (F = k.filter((z) => z.overflows[0] <= 0).sort((z, L) => z.overflows[1] - L.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!R)
          switch (h) {
            case "bestFit": {
              var M;
              const z = (M = k.filter((L) => {
                if (B) {
                  const X = Yn(L.placement);
                  return X === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  X === "y";
                }
                return !0;
              }).map((L) => [L.placement, L.overflows.filter((X) => X > 0).reduce((X, W) => X + W, 0)]).sort((L, X) => L[1] - X[1])[0]) == null ? void 0 : M[0];
              z && (R = z);
              break;
            }
            case "initialPlacement":
              R = a;
              break;
          }
        if (i !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
};
function jA(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function WA(e) {
  return X2.some((t) => e[t] >= 0);
}
const U2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = En(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await ho(t, {
            ...i,
            elementContext: "reference"
          }), s = jA(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: WA(s)
            }
          };
        }
        case "escaped": {
          const o = await ho(t, {
            ...i,
            altBoundary: !0
          }), s = jA(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: WA(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function J2(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = xn(n), a = Ni(n), c = Yn(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, l = o && c ? -1 : 1, d = En(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof g == "number" && (h = a === "end" ? g * -1 : g), c ? {
    x: h * l,
    y: f * u
  } : {
    x: f * u,
    y: h * l
  };
}
const K2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, c = await J2(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, _2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (p) => {
            let {
              x: v,
              y: b
            } = p;
            return {
              x: v,
              y: b
            };
          }
        },
        ...c
      } = En(e, t), u = {
        x: n,
        y: r
      }, l = await ho(t, c), d = Yn(xn(i)), f = Gl(d);
      let h = u[f], g = u[d];
      if (o) {
        const p = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", b = h + l[p], y = h - l[v];
        h = xu(b, h, y);
      }
      if (s) {
        const p = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", b = g + l[p], y = g - l[v];
        g = xu(b, g, y);
      }
      const m = a.fn({
        ...t,
        [f]: h,
        [d]: g
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [f]: o,
            [d]: s
          }
        }
      };
    }
  };
}, $2 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = En(e, t), l = {
        x: n,
        y: r
      }, d = Yn(i), f = Gl(d);
      let h = l[f], g = l[d];
      const m = En(a, t), p = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const y = f === "y" ? "height" : "width", E = o.reference[f] - o.floating[y] + p.mainAxis, C = o.reference[f] + o.reference[y] - p.mainAxis;
        h < E ? h = E : h > C && (h = C);
      }
      if (u) {
        var v, b;
        const y = f === "y" ? "width" : "height", E = ["top", "left"].includes(xn(i)), C = o.reference[d] - o.floating[y] + (E && ((v = s.offset) == null ? void 0 : v[d]) || 0) + (E ? 0 : p.crossAxis), B = o.reference[d] + o.reference[y] + (E ? 0 : ((b = s.offset) == null ? void 0 : b[d]) || 0) - (E ? p.crossAxis : 0);
        g < C ? g = C : g > B && (g = B);
      }
      return {
        [f]: h,
        [d]: g
      };
    }
  };
}, eb = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: s,
        elements: a
      } = t, {
        apply: c = () => {
        },
        ...u
      } = En(e, t), l = await ho(t, u), d = xn(i), f = Ni(i), h = Yn(i) === "y", {
        width: g,
        height: m
      } = o.floating;
      let p, v;
      d === "top" || d === "bottom" ? (p = d, v = f === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (v = d, p = f === "end" ? "top" : "bottom");
      const b = m - l.top - l.bottom, y = g - l.left - l.right, E = Gn(m - l[p], b), C = Gn(g - l[v], y), B = !t.middlewareData.shift;
      let I = E, x = C;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (x = y), (r = t.middlewareData.shift) != null && r.enabled.y && (I = b), B && !f) {
        const k = Pt(l.left, 0), Q = Pt(l.right, 0), F = Pt(l.top, 0), M = Pt(l.bottom, 0);
        h ? x = g - 2 * (k !== 0 || Q !== 0 ? k + Q : Pt(l.left, l.right)) : I = m - 2 * (F !== 0 || M !== 0 ? F + M : Pt(l.top, l.bottom));
      }
      await c({
        ...t,
        availableWidth: x,
        availableHeight: I
      });
      const O = await s.getDimensions(a.floating);
      return g !== O.width || m !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Na() {
  return typeof window < "u";
}
function Ti(e) {
  return N0(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Dt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function fn(e) {
  var t;
  return (t = (N0(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function N0(e) {
  return Na() ? e instanceof Node || e instanceof Dt(e).Node : !1;
}
function Ut(e) {
  return Na() ? e instanceof Element || e instanceof Dt(e).Element : !1;
}
function An(e) {
  return Na() ? e instanceof HTMLElement || e instanceof Dt(e).HTMLElement : !1;
}
function ZA(e) {
  return !Na() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Dt(e).ShadowRoot;
}
function es(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = Jt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function tb(e) {
  return ["table", "td", "th"].includes(Ti(e));
}
function Ta(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ul(e) {
  const t = Jl(), n = Ut(e) ? Jt(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function nb(e) {
  let t = Un(e);
  for (; An(t) && !Ci(t); ) {
    if (Ul(t))
      return t;
    if (Ta(t))
      return null;
    t = Un(t);
  }
  return null;
}
function Jl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ci(e) {
  return ["html", "body", "#document"].includes(Ti(e));
}
function Jt(e) {
  return Dt(e).getComputedStyle(e);
}
function Ra(e) {
  return Ut(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Un(e) {
  if (Ti(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ZA(e) && e.host || // Fallback.
    fn(e)
  );
  return ZA(t) ? t.host : t;
}
function T0(e) {
  const t = Un(e);
  return Ci(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : An(t) && es(t) ? t : T0(t);
}
function po(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = T0(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Dt(i);
  if (o) {
    const a = wu(s);
    return t.concat(s, s.visualViewport || [], es(i) ? i : [], a && n ? po(a) : []);
  }
  return t.concat(i, po(i, [], n));
}
function wu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function R0(e) {
  const t = Jt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = An(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, a = _s(n) !== o || _s(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Kl(e) {
  return Ut(e) ? e : e.contextElement;
}
function $r(e) {
  const t = Kl(e);
  if (!An(t))
    return qn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = R0(t);
  let s = (o ? _s(n.width) : n.width) / r, a = (o ? _s(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const rb = /* @__PURE__ */ qn(0);
function L0(e) {
  const t = Dt(e);
  return !Jl() || !t.visualViewport ? rb : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ib(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Dt(e) ? !1 : t;
}
function br(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = Kl(e);
  let s = qn(1);
  t && (r ? Ut(r) && (s = $r(r)) : s = $r(e));
  const a = ib(o, n, r) ? L0(o) : qn(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, l = i.width / s.x, d = i.height / s.y;
  if (o) {
    const f = Dt(o), h = r && Ut(r) ? Dt(r) : r;
    let g = f, m = wu(g);
    for (; m && r && h !== g; ) {
      const p = $r(m), v = m.getBoundingClientRect(), b = Jt(m), y = v.left + (m.clientLeft + parseFloat(b.paddingLeft)) * p.x, E = v.top + (m.clientTop + parseFloat(b.paddingTop)) * p.y;
      c *= p.x, u *= p.y, l *= p.x, d *= p.y, c += y, u += E, g = Dt(m), m = wu(g);
    }
  }
  return ea({
    width: l,
    height: d,
    x: c,
    y: u
  });
}
function ob(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", s = fn(r), a = t ? Ta(t.floating) : !1;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = qn(1);
  const l = qn(0), d = An(r);
  if ((d || !d && !o) && ((Ti(r) !== "body" || es(s)) && (c = Ra(r)), An(r))) {
    const f = br(r);
    u = $r(r), l.x = f.x + r.clientLeft, l.y = f.y + r.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + l.x,
    y: n.y * u.y - c.scrollTop * u.y + l.y
  };
}
function sb(e) {
  return Array.from(e.getClientRects());
}
function Pu(e, t) {
  const n = Ra(e).scrollLeft;
  return t ? t.left + n : br(fn(e)).left + n;
}
function ab(e) {
  const t = fn(e), n = Ra(e), r = e.ownerDocument.body, i = Pt(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Pt(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Pu(e);
  const a = -n.scrollTop;
  return Jt(r).direction === "rtl" && (s += Pt(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function cb(e, t) {
  const n = Dt(e), r = fn(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const u = Jl();
    (!u || u && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function ub(e, t) {
  const n = br(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = An(e) ? $r(e) : qn(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function GA(e, t, n) {
  let r;
  if (t === "viewport")
    r = cb(e, n);
  else if (t === "document")
    r = ab(fn(e));
  else if (Ut(t))
    r = ub(t, n);
  else {
    const i = L0(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return ea(r);
}
function F0(e, t) {
  const n = Un(e);
  return n === t || !Ut(n) || Ci(n) ? !1 : Jt(n).position === "fixed" || F0(n, t);
}
function lb(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = po(e, [], !1).filter((a) => Ut(a) && Ti(a) !== "body"), i = null;
  const o = Jt(e).position === "fixed";
  let s = o ? Un(e) : e;
  for (; Ut(s) && !Ci(s); ) {
    const a = Jt(s), c = Ul(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || es(s) && !c && F0(e, s)) ? r = r.filter((l) => l !== s) : i = a, s = Un(s);
  }
  return t.set(e, r), r;
}
function db(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? Ta(t) ? [] : lb(t, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, l) => {
    const d = GA(t, l, i);
    return u.top = Pt(d.top, u.top), u.right = Gn(d.right, u.right), u.bottom = Gn(d.bottom, u.bottom), u.left = Pt(d.left, u.left), u;
  }, GA(t, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Ab(e) {
  const {
    width: t,
    height: n
  } = R0(e);
  return {
    width: t,
    height: n
  };
}
function fb(e, t, n) {
  const r = An(t), i = fn(t), o = n === "fixed", s = br(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = qn(0);
  if (r || !r && !o)
    if ((Ti(t) !== "body" || es(i)) && (a = Ra(t)), r) {
      const h = br(t, !0, o, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else i && (c.x = Pu(i));
  let u = 0, l = 0;
  if (i && !r && !o) {
    const h = i.getBoundingClientRect();
    l = h.top + a.scrollTop, u = h.left + a.scrollLeft - // RTL <body> scrollbar.
    Pu(i, h);
  }
  const d = s.left + a.scrollLeft - c.x - u, f = s.top + a.scrollTop - c.y - l;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function vc(e) {
  return Jt(e).position === "static";
}
function qA(e, t) {
  if (!An(e) || Jt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return fn(e) === n && (n = n.ownerDocument.body), n;
}
function Q0(e, t) {
  const n = Dt(e);
  if (Ta(e))
    return n;
  if (!An(e)) {
    let i = Un(e);
    for (; i && !Ci(i); ) {
      if (Ut(i) && !vc(i))
        return i;
      i = Un(i);
    }
    return n;
  }
  let r = qA(e, t);
  for (; r && tb(r) && vc(r); )
    r = qA(r, t);
  return r && Ci(r) && vc(r) && !Ul(r) ? n : r || nb(e) || n;
}
const gb = async function(e) {
  const t = this.getOffsetParent || Q0, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: fb(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function hb(e) {
  return Jt(e).direction === "rtl";
}
const pb = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ob,
  getDocumentElement: fn,
  getClippingRect: db,
  getOffsetParent: Q0,
  getElementRects: gb,
  getClientRects: sb,
  getDimensions: Ab,
  getScale: $r,
  isElement: Ut,
  isRTL: hb
};
function mb(e, t) {
  let n = null, r;
  const i = fn(e);
  function o() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const {
      left: u,
      top: l,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !d || !f)
      return;
    const h = gs(l), g = gs(i.clientWidth - (u + d)), m = gs(i.clientHeight - (l + f)), p = gs(u), b = {
      rootMargin: -h + "px " + -g + "px " + -m + "px " + -p + "px",
      threshold: Pt(0, Gn(1, c)) || 1
    };
    let y = !0;
    function E(C) {
      const B = C[0].intersectionRatio;
      if (B !== c) {
        if (!y)
          return s();
        B ? s(!1, B) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      y = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...b,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, b);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function X0(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = Kl(e), l = i || o ? [...u ? po(u) : [], ...po(t)] : [];
  l.forEach((v) => {
    i && v.addEventListener("scroll", n, {
      passive: !0
    }), o && v.addEventListener("resize", n);
  });
  const d = u && a ? mb(u, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === u && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = h) == null || y.observe(t);
    })), n();
  }), u && !c && h.observe(u), h.observe(t));
  let g, m = c ? br(e) : null;
  c && p();
  function p() {
    const v = br(e);
    m && (v.x !== m.x || v.y !== m.y || v.width !== m.width || v.height !== m.height) && n(), m = v, g = requestAnimationFrame(p);
  }
  return n(), () => {
    var v;
    l.forEach((b) => {
      i && b.removeEventListener("scroll", n), o && b.removeEventListener("resize", n);
    }), d == null || d(), (v = h) == null || v.disconnect(), h = null, c && cancelAnimationFrame(g);
  };
}
const vb = K2, bb = _2, yb = Y2, Cb = eb, Ib = U2, YA = q2, Eb = $2, xb = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: pb,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return G2(e, t, {
    ...i,
    platform: o
  });
};
var Xs = typeof document < "u" ? Kn : Ie;
function ta(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!ta(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !ta(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function V0(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function UA(e, t) {
  const n = V0(e);
  return Math.round(t * n) / n;
}
function bc(e) {
  const t = w.useRef(e);
  return Xs(() => {
    t.current = e;
  }), t;
}
function Bb(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: u
  } = e, [l, d] = w.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = w.useState(r);
  ta(f, r) || h(r);
  const [g, m] = w.useState(null), [p, v] = w.useState(null), b = w.useCallback((L) => {
    L !== B.current && (B.current = L, m(L));
  }, []), y = w.useCallback((L) => {
    L !== I.current && (I.current = L, v(L));
  }, []), E = o || g, C = s || p, B = w.useRef(null), I = w.useRef(null), x = w.useRef(l), O = c != null, k = bc(c), Q = bc(i), F = bc(u), M = w.useCallback(() => {
    if (!B.current || !I.current)
      return;
    const L = {
      placement: t,
      strategy: n,
      middleware: f
    };
    Q.current && (L.platform = Q.current), xb(B.current, I.current, L).then((X) => {
      const W = {
        ...X,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      H.current && !ta(x.current, W) && (x.current = W, zl.flushSync(() => {
        d(W);
      }));
    });
  }, [f, t, n, Q, F]);
  Xs(() => {
    u === !1 && x.current.isPositioned && (x.current.isPositioned = !1, d((L) => ({
      ...L,
      isPositioned: !1
    })));
  }, [u]);
  const H = w.useRef(!1);
  Xs(() => (H.current = !0, () => {
    H.current = !1;
  }), []), Xs(() => {
    if (E && (B.current = E), C && (I.current = C), E && C) {
      if (k.current)
        return k.current(E, C, M);
      M();
    }
  }, [E, C, M, k, O]);
  const T = w.useMemo(() => ({
    reference: B,
    floating: I,
    setReference: b,
    setFloating: y
  }), [b, y]), R = w.useMemo(() => ({
    reference: E,
    floating: C
  }), [E, C]), z = w.useMemo(() => {
    const L = {
      position: n,
      left: 0,
      top: 0
    };
    if (!R.floating)
      return L;
    const X = UA(R.floating, l.x), W = UA(R.floating, l.y);
    return a ? {
      ...L,
      transform: "translate(" + X + "px, " + W + "px)",
      ...V0(R.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: X,
      top: W
    };
  }, [n, a, R.floating, l.x, l.y]);
  return w.useMemo(() => ({
    ...l,
    update: M,
    refs: T,
    elements: R,
    floatingStyles: z
  }), [l, M, T, R, z]);
}
const wb = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? YA({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? YA({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, Pb = (e, t) => ({
  ...vb(e),
  options: [e, t]
}), Hb = (e, t) => ({
  ...bb(e),
  options: [e, t]
}), Ob = (e, t) => ({
  ...Eb(e),
  options: [e, t]
}), Db = (e, t) => ({
  ...yb(e),
  options: [e, t]
}), Sb = (e, t) => ({
  ...Cb(e),
  options: [e, t]
}), Nb = (e, t) => ({
  ...Ib(e),
  options: [e, t]
}), Tb = (e, t) => ({
  ...wb(e),
  options: [e, t]
});
var Rb = "Arrow", k0 = w.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ A(
    Me.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ A("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
k0.displayName = Rb;
var Lb = k0;
function Fb(e) {
  const [t, n] = w.useState(void 0);
  return vr(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let s, a;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          s = u.inlineSize, a = u.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var _l = "Popper", [M0, La] = _n(_l), [Qb, z0] = M0(_l), j0 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = w.useState(null);
  return /* @__PURE__ */ A(Qb, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
j0.displayName = _l;
var W0 = "PopperAnchor", Z0 = w.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = z0(W0, n), s = w.useRef(null), a = $e(t, s);
    return w.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ A(Me.div, { ...i, ref: a });
  }
);
Z0.displayName = W0;
var $l = "PopperContent", [Xb, Vb] = M0($l), G0 = w.forwardRef(
  (e, t) => {
    var pe, Pe, Qe, et, st, re;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: l = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: g,
      ...m
    } = e, p = z0($l, n), [v, b] = w.useState(null), y = $e(t, (Ge) => b(Ge)), [E, C] = w.useState(null), B = Fb(E), I = (B == null ? void 0 : B.width) ?? 0, x = (B == null ? void 0 : B.height) ?? 0, O = r + (o !== "center" ? "-" + o : ""), k = typeof l == "number" ? l : { top: 0, right: 0, bottom: 0, left: 0, ...l }, Q = Array.isArray(u) ? u : [u], F = Q.length > 0, M = {
      padding: k,
      boundary: Q.filter(Mb),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: H, floatingStyles: T, placement: R, isPositioned: z, middlewareData: L } = Bb({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: O,
      whileElementsMounted: (...Ge) => X0(...Ge, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: p.anchor
      },
      middleware: [
        Pb({ mainAxis: i + x, alignmentAxis: s }),
        c && Hb({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? Ob() : void 0,
          ...M
        }),
        c && Db({ ...M }),
        Sb({
          ...M,
          apply: ({ elements: Ge, rects: tt, availableWidth: at, availableHeight: tr }) => {
            const { width: se, height: P } = tt.reference, S = Ge.floating.style;
            S.setProperty("--radix-popper-available-width", `${at}px`), S.setProperty("--radix-popper-available-height", `${tr}px`), S.setProperty("--radix-popper-anchor-width", `${se}px`), S.setProperty("--radix-popper-anchor-height", `${P}px`);
          }
        }),
        E && Tb({ element: E, padding: a }),
        zb({ arrowWidth: I, arrowHeight: x }),
        f && Nb({ strategy: "referenceHidden", ...M })
      ]
    }), [X, W] = U0(R), U = Yt(g);
    vr(() => {
      z && (U == null || U());
    }, [z, U]);
    const ee = (pe = L.arrow) == null ? void 0 : pe.x, Ae = (Pe = L.arrow) == null ? void 0 : Pe.y, ne = ((Qe = L.arrow) == null ? void 0 : Qe.centerOffset) !== 0, [K, ae] = w.useState();
    return vr(() => {
      v && ae(window.getComputedStyle(v).zIndex);
    }, [v]), /* @__PURE__ */ A(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...T,
          transform: z ? T.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: K,
          "--radix-popper-transform-origin": [
            (et = L.transformOrigin) == null ? void 0 : et.x,
            (st = L.transformOrigin) == null ? void 0 : st.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((re = L.hide) == null ? void 0 : re.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ A(
          Xb,
          {
            scope: n,
            placedSide: X,
            onArrowChange: C,
            arrowX: ee,
            arrowY: Ae,
            shouldHideArrow: ne,
            children: /* @__PURE__ */ A(
              Me.div,
              {
                "data-side": X,
                "data-align": W,
                ...m,
                ref: y,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
G0.displayName = $l;
var q0 = "PopperArrow", kb = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Y0 = w.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = Vb(q0, r), s = kb[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ A(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ A(
          Lb,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Y0.displayName = q0;
function Mb(e) {
  return e !== null;
}
var zb = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var p, v, b;
    const { placement: n, rects: r, middlewareData: i } = t, s = ((p = i.arrow) == null ? void 0 : p.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [u, l] = U0(n), d = { start: "0%", center: "50%", end: "100%" }[l], f = (((v = i.arrow) == null ? void 0 : v.x) ?? 0) + a / 2, h = (((b = i.arrow) == null ? void 0 : b.y) ?? 0) + c / 2;
    let g = "", m = "";
    return u === "bottom" ? (g = s ? d : `${f}px`, m = `${-c}px`) : u === "top" ? (g = s ? d : `${f}px`, m = `${r.floating.height + c}px`) : u === "right" ? (g = `${-c}px`, m = s ? d : `${h}px`) : u === "left" && (g = `${r.floating.width + c}px`, m = s ? d : `${h}px`), { data: { x: g, y: m } };
  }
});
function U0(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var J0 = j0, K0 = Z0, _0 = G0, $0 = Y0, jb = "Portal", Fa = w.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [i, o] = w.useState(!1);
  vr(() => o(!0), []);
  const s = n || i && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? v0.createPortal(/* @__PURE__ */ A(Me.div, { ...r, ref: t }), s) : null;
});
Fa.displayName = jb;
function Wb(e, t) {
  return w.useReducer((n, r) => t[n][r] ?? n, e);
}
var Kt = (e) => {
  const { present: t, children: n } = e, r = Zb(t), i = typeof n == "function" ? n({ present: r.isPresent }) : w.Children.only(n), o = $e(r.ref, Gb(i));
  return typeof n == "function" || r.isPresent ? w.cloneElement(i, { ref: o }) : null;
};
Kt.displayName = "Presence";
function Zb(e) {
  const [t, n] = w.useState(), r = w.useRef({}), i = w.useRef(e), o = w.useRef("none"), s = e ? "mounted" : "unmounted", [a, c] = Wb(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return w.useEffect(() => {
    const u = hs(r.current);
    o.current = a === "mounted" ? u : "none";
  }, [a]), vr(() => {
    const u = r.current, l = i.current;
    if (l !== e) {
      const f = o.current, h = hs(u);
      e ? c("MOUNT") : h === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(l && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), vr(() => {
    if (t) {
      const u = (d) => {
        const h = hs(r.current).includes(d.animationName);
        d.target === t && h && zl.flushSync(() => c("ANIMATION_END"));
      }, l = (d) => {
        d.target === t && (o.current = hs(r.current));
      };
      return t.addEventListener("animationstart", l), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", l), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: w.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function hs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Gb(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var yc = "rovingFocusGroup.onEntryFocus", qb = { bubbles: !1, cancelable: !0 }, Qa = "RovingFocusGroup", [Hu, eg, Yb] = w0(Qa), [Ub, Xa] = _n(
  Qa,
  [Yb]
), [Jb, Kb] = Ub(Qa), tg = w.forwardRef(
  (e, t) => /* @__PURE__ */ A(Hu.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ A(Hu.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ A(_b, { ...e, ref: t }) }) })
);
tg.displayName = Qa;
var _b = w.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: l = !1,
    ...d
  } = e, f = w.useRef(null), h = $e(t, f), g = Wl(o), [m = null, p] = $o({
    prop: s,
    defaultProp: a,
    onChange: c
  }), [v, b] = w.useState(!1), y = Yt(u), E = eg(n), C = w.useRef(!1), [B, I] = w.useState(0);
  return w.useEffect(() => {
    const x = f.current;
    if (x)
      return x.addEventListener(yc, y), () => x.removeEventListener(yc, y);
  }, [y]), /* @__PURE__ */ A(
    Jb,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: i,
      currentTabStopId: m,
      onItemFocus: w.useCallback(
        (x) => p(x),
        [p]
      ),
      onItemShiftTab: w.useCallback(() => b(!0), []),
      onFocusableItemAdd: w.useCallback(
        () => I((x) => x + 1),
        []
      ),
      onFocusableItemRemove: w.useCallback(
        () => I((x) => x - 1),
        []
      ),
      children: /* @__PURE__ */ A(
        Me.div,
        {
          tabIndex: v || B === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: he(e.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: he(e.onFocus, (x) => {
            const O = !C.current;
            if (x.target === x.currentTarget && O && !v) {
              const k = new CustomEvent(yc, qb);
              if (x.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
                const Q = E().filter((R) => R.focusable), F = Q.find((R) => R.active), M = Q.find((R) => R.id === m), T = [F, M, ...Q].filter(
                  Boolean
                ).map((R) => R.ref.current);
                ig(T, l);
              }
            }
            C.current = !1;
          }),
          onBlur: he(e.onBlur, () => b(!1))
        }
      )
    }
  );
}), ng = "RovingFocusGroupItem", rg = w.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...s
    } = e, a = Mn(), c = o || a, u = Kb(ng, n), l = u.currentTabStopId === c, d = eg(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = u;
    return w.useEffect(() => {
      if (r)
        return f(), () => h();
    }, [r, f, h]), /* @__PURE__ */ A(
      Hu.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ A(
          Me.span,
          {
            tabIndex: l ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: he(e.onMouseDown, (g) => {
              r ? u.onItemFocus(c) : g.preventDefault();
            }),
            onFocus: he(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: he(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget) return;
              const m = t7(g, u.orientation, u.dir);
              if (m !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey) return;
                g.preventDefault();
                let v = d().filter((b) => b.focusable).map((b) => b.ref.current);
                if (m === "last") v.reverse();
                else if (m === "prev" || m === "next") {
                  m === "prev" && v.reverse();
                  const b = v.indexOf(g.currentTarget);
                  v = u.loop ? n7(v, b + 1) : v.slice(b + 1);
                }
                setTimeout(() => ig(v));
              }
            })
          }
        )
      }
    );
  }
);
rg.displayName = ng;
var $b = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function e7(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function t7(e, t, n) {
  const r = e7(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return $b[r];
}
function ig(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function n7(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var og = tg, sg = rg, r7 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Qr = /* @__PURE__ */ new WeakMap(), ps = /* @__PURE__ */ new WeakMap(), ms = {}, Cc = 0, ag = function(e) {
  return e && (e.host || ag(e.parentNode));
}, i7 = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = ag(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, o7 = function(e, t, n, r) {
  var i = i7(t, Array.isArray(e) ? e : [e]);
  ms[n] || (ms[n] = /* @__PURE__ */ new WeakMap());
  var o = ms[n], s = [], a = /* @__PURE__ */ new Set(), c = new Set(i), u = function(d) {
    !d || a.has(d) || (a.add(d), u(d.parentNode));
  };
  i.forEach(u);
  var l = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        l(f);
      else
        try {
          var h = f.getAttribute(r), g = h !== null && h !== "false", m = (Qr.get(f) || 0) + 1, p = (o.get(f) || 0) + 1;
          Qr.set(f, m), o.set(f, p), s.push(f), m === 1 && g && ps.set(f, !0), p === 1 && f.setAttribute(n, "true"), g || f.setAttribute(r, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", f, v);
        }
    });
  };
  return l(t), a.clear(), Cc++, function() {
    s.forEach(function(d) {
      var f = Qr.get(d) - 1, h = o.get(d) - 1;
      Qr.set(d, f), o.set(d, h), f || (ps.has(d) || d.removeAttribute(r), ps.delete(d)), h || d.removeAttribute(n);
    }), Cc--, Cc || (Qr = /* @__PURE__ */ new WeakMap(), Qr = /* @__PURE__ */ new WeakMap(), ps = /* @__PURE__ */ new WeakMap(), ms = {});
  };
}, cg = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = r7(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), o7(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, cn = function() {
  return cn = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, cn.apply(this, arguments);
};
function ug(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function s7(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Vs = "right-scroll-bar-position", ks = "width-before-scroll-bar", a7 = "with-scroll-bars-hidden", c7 = "--removed-body-scroll-bar-size";
function Ic(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function u7(e, t) {
  var n = q(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var l7 = typeof window < "u" ? w.useLayoutEffect : w.useEffect, JA = /* @__PURE__ */ new WeakMap();
function d7(e, t) {
  var n = u7(null, function(r) {
    return e.forEach(function(i) {
      return Ic(i, r);
    });
  });
  return l7(function() {
    var r = JA.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), s = n.current;
      i.forEach(function(a) {
        o.has(a) || Ic(a, null);
      }), o.forEach(function(a) {
        i.has(a) || Ic(a, s);
      });
    }
    JA.set(n, e);
  }, [e]), n;
}
function A7(e) {
  return e;
}
function f7(e, t) {
  t === void 0 && (t = A7);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var s = t(o, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(o);
      }
      n = {
        push: function(a) {
          return o(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(o), s = n;
      }
      var c = function() {
        var l = s;
        s = [], l.forEach(o);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(l) {
          s.push(l), u();
        },
        filter: function(l) {
          return s = s.filter(l), n;
        }
      };
    }
  };
  return i;
}
function g7(e) {
  e === void 0 && (e = {});
  var t = f7(null);
  return t.options = cn({ async: !0, ssr: !1 }, e), t;
}
var lg = function(e) {
  var t = e.sideCar, n = ug(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return w.createElement(r, cn({}, n));
};
lg.isSideCarExport = !0;
function h7(e, t) {
  return e.useMedium(t), lg;
}
var dg = g7(), Ec = function() {
}, Va = w.forwardRef(function(e, t) {
  var n = w.useRef(null), r = w.useState({
    onScrollCapture: Ec,
    onWheelCapture: Ec,
    onTouchMoveCapture: Ec
  }), i = r[0], o = r[1], s = e.forwardProps, a = e.children, c = e.className, u = e.removeScrollBar, l = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, g = e.inert, m = e.allowPinchZoom, p = e.as, v = p === void 0 ? "div" : p, b = e.gapMode, y = ug(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = f, C = d7([n, t]), B = cn(cn({}, y), i);
  return w.createElement(
    w.Fragment,
    null,
    l && w.createElement(E, { sideCar: dg, removeScrollBar: u, shards: d, noIsolation: h, inert: g, setCallbacks: o, allowPinchZoom: !!m, lockRef: n, gapMode: b }),
    s ? w.cloneElement(w.Children.only(a), cn(cn({}, B), { ref: C })) : w.createElement(v, cn({}, B, { className: c, ref: C }), a)
  );
});
Va.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Va.classNames = {
  fullWidth: ks,
  zeroRight: Vs
};
var p7 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function m7() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = p7();
  return t && e.setAttribute("nonce", t), e;
}
function v7(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function b7(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var y7 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = m7()) && (v7(t, n), b7(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, C7 = function() {
  var e = y7();
  return function(t, n) {
    w.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Ag = function() {
  var e = C7(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, I7 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, xc = function(e) {
  return parseInt(e || "", 10) || 0;
}, E7 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [xc(n), xc(r), xc(i)];
}, x7 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return I7;
  var t = E7(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, B7 = Ag(), ei = "data-scroll-locked", w7 = function(e, t, n, r) {
  var i = e.left, o = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(a7, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(ei, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Vs, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ks, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Vs, " .").concat(Vs, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ks, " .").concat(ks, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ei, `] {
    `).concat(c7, ": ").concat(a, `px;
  }
`);
}, KA = function() {
  var e = parseInt(document.body.getAttribute(ei) || "0", 10);
  return isFinite(e) ? e : 0;
}, P7 = function() {
  w.useEffect(function() {
    return document.body.setAttribute(ei, (KA() + 1).toString()), function() {
      var e = KA() - 1;
      e <= 0 ? document.body.removeAttribute(ei) : document.body.setAttribute(ei, e.toString());
    };
  }, []);
}, H7 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  P7();
  var o = w.useMemo(function() {
    return x7(i);
  }, [i]);
  return w.createElement(B7, { styles: w7(o, !t, i, n ? "" : "!important") });
}, Ou = !1;
if (typeof window < "u")
  try {
    var vs = Object.defineProperty({}, "passive", {
      get: function() {
        return Ou = !0, !0;
      }
    });
    window.addEventListener("test", vs, vs), window.removeEventListener("test", vs, vs);
  } catch {
    Ou = !1;
  }
var Xr = Ou ? { passive: !1 } : !1, O7 = function(e) {
  return e.tagName === "TEXTAREA";
}, fg = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !O7(e) && n[t] === "visible")
  );
}, D7 = function(e) {
  return fg(e, "overflowY");
}, S7 = function(e) {
  return fg(e, "overflowX");
}, _A = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = gg(e, r);
    if (i) {
      var o = hg(e, r), s = o[1], a = o[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, N7 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, T7 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, gg = function(e, t) {
  return e === "v" ? D7(t) : S7(t);
}, hg = function(e, t) {
  return e === "v" ? N7(t) : T7(t);
}, R7 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, L7 = function(e, t, n, r, i) {
  var o = R7(e, window.getComputedStyle(t).direction), s = o * r, a = n.target, c = t.contains(a), u = !1, l = s > 0, d = 0, f = 0;
  do {
    var h = hg(e, a), g = h[0], m = h[1], p = h[2], v = m - p - o * g;
    (g || v) && gg(e, a) && (d += v, f += g), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (l && (Math.abs(d) < 1 || !i) || !l && (Math.abs(f) < 1 || !i)) && (u = !0), u;
}, bs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, $A = function(e) {
  return [e.deltaX, e.deltaY];
}, ef = function(e) {
  return e && "current" in e ? e.current : e;
}, F7 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Q7 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, X7 = 0, Vr = [];
function V7(e) {
  var t = w.useRef([]), n = w.useRef([0, 0]), r = w.useRef(), i = w.useState(X7++)[0], o = w.useState(Ag)[0], s = w.useRef(e);
  w.useEffect(function() {
    s.current = e;
  }, [e]), w.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var m = s7([e.lockRef.current], (e.shards || []).map(ef), !0).filter(Boolean);
      return m.forEach(function(p) {
        return p.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), m.forEach(function(p) {
          return p.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = w.useCallback(function(m, p) {
    if ("touches" in m && m.touches.length === 2)
      return !s.current.allowPinchZoom;
    var v = bs(m), b = n.current, y = "deltaX" in m ? m.deltaX : b[0] - v[0], E = "deltaY" in m ? m.deltaY : b[1] - v[1], C, B = m.target, I = Math.abs(y) > Math.abs(E) ? "h" : "v";
    if ("touches" in m && I === "h" && B.type === "range")
      return !1;
    var x = _A(I, B);
    if (!x)
      return !0;
    if (x ? C = I : (C = I === "v" ? "h" : "v", x = _A(I, B)), !x)
      return !1;
    if (!r.current && "changedTouches" in m && (y || E) && (r.current = C), !C)
      return !0;
    var O = r.current || C;
    return L7(O, p, m, O === "h" ? y : E, !0);
  }, []), c = w.useCallback(function(m) {
    var p = m;
    if (!(!Vr.length || Vr[Vr.length - 1] !== o)) {
      var v = "deltaY" in p ? $A(p) : bs(p), b = t.current.filter(function(C) {
        return C.name === p.type && (C.target === p.target || p.target === C.shadowParent) && F7(C.delta, v);
      })[0];
      if (b && b.should) {
        p.cancelable && p.preventDefault();
        return;
      }
      if (!b) {
        var y = (s.current.shards || []).map(ef).filter(Boolean).filter(function(C) {
          return C.contains(p.target);
        }), E = y.length > 0 ? a(p, y[0]) : !s.current.noIsolation;
        E && p.cancelable && p.preventDefault();
      }
    }
  }, []), u = w.useCallback(function(m, p, v, b) {
    var y = { name: m, delta: p, target: v, should: b, shadowParent: k7(v) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== y;
      });
    }, 1);
  }, []), l = w.useCallback(function(m) {
    n.current = bs(m), r.current = void 0;
  }, []), d = w.useCallback(function(m) {
    u(m.type, $A(m), m.target, a(m, e.lockRef.current));
  }, []), f = w.useCallback(function(m) {
    u(m.type, bs(m), m.target, a(m, e.lockRef.current));
  }, []);
  w.useEffect(function() {
    return Vr.push(o), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, Xr), document.addEventListener("touchmove", c, Xr), document.addEventListener("touchstart", l, Xr), function() {
      Vr = Vr.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", c, Xr), document.removeEventListener("touchmove", c, Xr), document.removeEventListener("touchstart", l, Xr);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return w.createElement(
    w.Fragment,
    null,
    g ? w.createElement(o, { styles: Q7(i) }) : null,
    h ? w.createElement(H7, { gapMode: e.gapMode }) : null
  );
}
function k7(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const M7 = h7(dg, V7);
var ed = w.forwardRef(function(e, t) {
  return w.createElement(Va, cn({}, e, { ref: t, sideCar: M7 }));
});
ed.classNames = Va.classNames;
var Du = ["Enter", " "], z7 = ["ArrowDown", "PageUp", "Home"], pg = ["ArrowUp", "PageDown", "End"], j7 = [...z7, ...pg], W7 = {
  ltr: [...Du, "ArrowRight"],
  rtl: [...Du, "ArrowLeft"]
}, Z7 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, ts = "Menu", [mo, G7, q7] = w0(ts), [Dr, mg] = _n(ts, [
  q7,
  La,
  Xa
]), ka = La(), vg = Xa(), [Y7, Sr] = Dr(ts), [U7, ns] = Dr(ts), bg = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: s = !0 } = e, a = ka(t), [c, u] = w.useState(null), l = w.useRef(!1), d = Yt(o), f = Wl(i);
  return w.useEffect(() => {
    const h = () => {
      l.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => l.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ A(J0, { ...a, children: /* @__PURE__ */ A(
    Y7,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ A(
        U7,
        {
          scope: t,
          onClose: w.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: l,
          dir: f,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
bg.displayName = ts;
var J7 = "MenuAnchor", td = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = ka(n);
    return /* @__PURE__ */ A(K0, { ...i, ...r, ref: t });
  }
);
td.displayName = J7;
var nd = "MenuPortal", [K7, yg] = Dr(nd, {
  forceMount: void 0
}), Cg = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Sr(nd, t);
  return /* @__PURE__ */ A(K7, { scope: t, forceMount: n, children: /* @__PURE__ */ A(Kt, { present: n || o.open, children: /* @__PURE__ */ A(Fa, { asChild: !0, container: i, children: r }) }) });
};
Cg.displayName = nd;
var Xt = "MenuContent", [_7, rd] = Dr(Xt), Ig = w.forwardRef(
  (e, t) => {
    const n = yg(Xt, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Sr(Xt, e.__scopeMenu), s = ns(Xt, e.__scopeMenu);
    return /* @__PURE__ */ A(mo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(Kt, { present: r || o.open, children: /* @__PURE__ */ A(mo.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ A($7, { ...i, ref: t }) : /* @__PURE__ */ A(e4, { ...i, ref: t }) }) }) });
  }
), $7 = w.forwardRef(
  (e, t) => {
    const n = Sr(Xt, e.__scopeMenu), r = w.useRef(null), i = $e(t, r);
    return w.useEffect(() => {
      const o = r.current;
      if (o) return cg(o);
    }, []), /* @__PURE__ */ A(
      id,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: he(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), e4 = w.forwardRef((e, t) => {
  const n = Sr(Xt, e.__scopeMenu);
  return /* @__PURE__ */ A(
    id,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), id = w.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: o,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: l,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: g,
      ...m
    } = e, p = Sr(Xt, n), v = ns(Xt, n), b = ka(n), y = vg(n), E = G7(n), [C, B] = w.useState(null), I = w.useRef(null), x = $e(t, I, p.onContentChange), O = w.useRef(0), k = w.useRef(""), Q = w.useRef(0), F = w.useRef(null), M = w.useRef("right"), H = w.useRef(0), T = g ? ed : w.Fragment, R = g ? { as: yi, allowPinchZoom: !0 } : void 0, z = (X) => {
      var pe, Pe;
      const W = k.current + X, U = E().filter((Qe) => !Qe.disabled), ee = document.activeElement, Ae = (pe = U.find((Qe) => Qe.ref.current === ee)) == null ? void 0 : pe.textValue, ne = U.map((Qe) => Qe.textValue), K = A4(ne, W, Ae), ae = (Pe = U.find((Qe) => Qe.textValue === K)) == null ? void 0 : Pe.ref.current;
      (function Qe(et) {
        k.current = et, window.clearTimeout(O.current), et !== "" && (O.current = window.setTimeout(() => Qe(""), 1e3));
      })(W), ae && setTimeout(() => ae.focus());
    };
    w.useEffect(() => () => window.clearTimeout(O.current), []), O0();
    const L = w.useCallback((X) => {
      var U, ee;
      return M.current === ((U = F.current) == null ? void 0 : U.side) && g4(X, (ee = F.current) == null ? void 0 : ee.area);
    }, []);
    return /* @__PURE__ */ A(
      _7,
      {
        scope: n,
        searchRef: k,
        onItemEnter: w.useCallback(
          (X) => {
            L(X) && X.preventDefault();
          },
          [L]
        ),
        onItemLeave: w.useCallback(
          (X) => {
            var W;
            L(X) || ((W = I.current) == null || W.focus(), B(null));
          },
          [L]
        ),
        onTriggerLeave: w.useCallback(
          (X) => {
            L(X) && X.preventDefault();
          },
          [L]
        ),
        pointerGraceTimerRef: Q,
        onPointerGraceIntentChange: w.useCallback((X) => {
          F.current = X;
        }, []),
        children: /* @__PURE__ */ A(T, { ...R, children: /* @__PURE__ */ A(
          Zl,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: he(o, (X) => {
              var W;
              X.preventDefault(), (W = I.current) == null || W.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ A(
              Sa,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: u,
                onPointerDownOutside: l,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ A(
                  og,
                  {
                    asChild: !0,
                    ...y,
                    dir: v.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: C,
                    onCurrentTabStopIdChange: B,
                    onEntryFocus: he(c, (X) => {
                      v.isUsingKeyboardRef.current || X.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ A(
                      _0,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Xg(p.open),
                        "data-radix-menu-content": "",
                        dir: v.dir,
                        ...b,
                        ...m,
                        ref: x,
                        style: { outline: "none", ...m.style },
                        onKeyDown: he(m.onKeyDown, (X) => {
                          const U = X.target.closest("[data-radix-menu-content]") === X.currentTarget, ee = X.ctrlKey || X.altKey || X.metaKey, Ae = X.key.length === 1;
                          U && (X.key === "Tab" && X.preventDefault(), !ee && Ae && z(X.key));
                          const ne = I.current;
                          if (X.target !== ne || !j7.includes(X.key)) return;
                          X.preventDefault();
                          const ae = E().filter((pe) => !pe.disabled).map((pe) => pe.ref.current);
                          pg.includes(X.key) && ae.reverse(), l4(ae);
                        }),
                        onBlur: he(e.onBlur, (X) => {
                          X.currentTarget.contains(X.target) || (window.clearTimeout(O.current), k.current = "");
                        }),
                        onPointerMove: he(
                          e.onPointerMove,
                          vo((X) => {
                            const W = X.target, U = H.current !== X.clientX;
                            if (X.currentTarget.contains(W) && U) {
                              const ee = X.clientX > H.current ? "right" : "left";
                              M.current = ee, H.current = X.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ig.displayName = Xt;
var t4 = "MenuGroup", od = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ A(Me.div, { role: "group", ...r, ref: t });
  }
);
od.displayName = t4;
var n4 = "MenuLabel", Eg = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ A(Me.div, { ...r, ref: t });
  }
);
Eg.displayName = n4;
var na = "MenuItem", tf = "menu.itemSelect", Ma = w.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...i } = e, o = w.useRef(null), s = ns(na, e.__scopeMenu), a = rd(na, e.__scopeMenu), c = $e(t, o), u = w.useRef(!1), l = () => {
      const d = o.current;
      if (!n && d) {
        const f = new CustomEvent(tf, { bubbles: !0, cancelable: !0 });
        d.addEventListener(tf, (h) => r == null ? void 0 : r(h), { once: !0 }), B0(d, f), f.defaultPrevented ? u.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ A(
      xg,
      {
        ...i,
        ref: c,
        disabled: n,
        onClick: he(e.onClick, l),
        onPointerDown: (d) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, d), u.current = !0;
        },
        onPointerUp: he(e.onPointerUp, (d) => {
          var f;
          u.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: he(e.onKeyDown, (d) => {
          const f = a.searchRef.current !== "";
          n || f && d.key === " " || Du.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
Ma.displayName = na;
var xg = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, s = rd(na, n), a = vg(n), c = w.useRef(null), u = $e(t, c), [l, d] = w.useState(!1), [f, h] = w.useState("");
    return w.useEffect(() => {
      const g = c.current;
      g && h((g.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ A(
      mo.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: i ?? f,
        children: /* @__PURE__ */ A(sg, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ A(
          Me.div,
          {
            role: "menuitem",
            "data-highlighted": l ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...o,
            ref: u,
            onPointerMove: he(
              e.onPointerMove,
              vo((g) => {
                r ? s.onItemLeave(g) : (s.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: he(
              e.onPointerLeave,
              vo((g) => s.onItemLeave(g))
            ),
            onFocus: he(e.onFocus, () => d(!0)),
            onBlur: he(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), r4 = "MenuCheckboxItem", Bg = w.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...i } = e;
    return /* @__PURE__ */ A(Dg, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ A(
      Ma,
      {
        role: "menuitemcheckbox",
        "aria-checked": ra(n) ? "mixed" : n,
        ...i,
        ref: t,
        "data-state": ad(n),
        onSelect: he(
          i.onSelect,
          () => r == null ? void 0 : r(ra(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Bg.displayName = r4;
var wg = "MenuRadioGroup", [i4, o4] = Dr(
  wg,
  { value: void 0, onValueChange: () => {
  } }
), Pg = w.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...i } = e, o = Yt(r);
    return /* @__PURE__ */ A(i4, { scope: e.__scopeMenu, value: n, onValueChange: o, children: /* @__PURE__ */ A(od, { ...i, ref: t }) });
  }
);
Pg.displayName = wg;
var Hg = "MenuRadioItem", Og = w.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = o4(Hg, e.__scopeMenu), o = n === i.value;
    return /* @__PURE__ */ A(Dg, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ A(
      Ma,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...r,
        ref: t,
        "data-state": ad(o),
        onSelect: he(
          r.onSelect,
          () => {
            var s;
            return (s = i.onValueChange) == null ? void 0 : s.call(i, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Og.displayName = Hg;
var sd = "MenuItemIndicator", [Dg, s4] = Dr(
  sd,
  { checked: !1 }
), Sg = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...i } = e, o = s4(sd, n);
    return /* @__PURE__ */ A(
      Kt,
      {
        present: r || ra(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ A(
          Me.span,
          {
            ...i,
            ref: t,
            "data-state": ad(o.checked)
          }
        )
      }
    );
  }
);
Sg.displayName = sd;
var a4 = "MenuSeparator", Ng = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ A(
      Me.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Ng.displayName = a4;
var c4 = "MenuArrow", Tg = w.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = ka(n);
    return /* @__PURE__ */ A($0, { ...i, ...r, ref: t });
  }
);
Tg.displayName = c4;
var u4 = "MenuSub", [PR, Rg] = Dr(u4), io = "MenuSubTrigger", Lg = w.forwardRef(
  (e, t) => {
    const n = Sr(io, e.__scopeMenu), r = ns(io, e.__scopeMenu), i = Rg(io, e.__scopeMenu), o = rd(io, e.__scopeMenu), s = w.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: c } = o, u = { __scopeMenu: e.__scopeMenu }, l = w.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return w.useEffect(() => l, [l]), w.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), c(null);
      };
    }, [a, c]), /* @__PURE__ */ A(td, { asChild: !0, ...u, children: /* @__PURE__ */ A(
      xg,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": i.contentId,
        "data-state": Xg(n.open),
        ...e,
        ref: Da(t, i.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = e.onClick) == null || f.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: he(
          e.onPointerMove,
          vo((d) => {
            o.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !s.current && (o.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), l();
            }, 100));
          })
        ),
        onPointerLeave: he(
          e.onPointerLeave,
          vo((d) => {
            var h, g;
            l();
            const f = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (f) {
              const m = (g = n.content) == null ? void 0 : g.dataset.side, p = m === "right", v = p ? -5 : 5, b = f[p ? "left" : "right"], y = f[p ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + v, y: d.clientY },
                  { x: b, y: f.top },
                  { x: y, y: f.top },
                  { x: y, y: f.bottom },
                  { x: b, y: f.bottom }
                ],
                side: m
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(d), d.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: he(e.onKeyDown, (d) => {
          var h;
          const f = o.searchRef.current !== "";
          e.disabled || f && d.key === " " || W7[r.dir].includes(d.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
Lg.displayName = io;
var Fg = "MenuSubContent", Qg = w.forwardRef(
  (e, t) => {
    const n = yg(Xt, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Sr(Xt, e.__scopeMenu), s = ns(Xt, e.__scopeMenu), a = Rg(Fg, e.__scopeMenu), c = w.useRef(null), u = $e(t, c);
    return /* @__PURE__ */ A(mo.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(Kt, { present: r || o.open, children: /* @__PURE__ */ A(mo.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(
      id,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...i,
        ref: u,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (l) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = c.current) == null || d.focus()), l.preventDefault();
        },
        onCloseAutoFocus: (l) => l.preventDefault(),
        onFocusOutside: he(e.onFocusOutside, (l) => {
          l.target !== a.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: he(e.onEscapeKeyDown, (l) => {
          s.onClose(), l.preventDefault();
        }),
        onKeyDown: he(e.onKeyDown, (l) => {
          var h;
          const d = l.currentTarget.contains(l.target), f = Z7[s.dir].includes(l.key);
          d && f && (o.onOpenChange(!1), (h = a.trigger) == null || h.focus(), l.preventDefault());
        })
      }
    ) }) }) });
  }
);
Qg.displayName = Fg;
function Xg(e) {
  return e ? "open" : "closed";
}
function ra(e) {
  return e === "indeterminate";
}
function ad(e) {
  return ra(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function l4(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function d4(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function A4(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let s = d4(e, Math.max(o, 0));
  i.length === 1 && (s = s.filter((u) => u !== n));
  const c = s.find(
    (u) => u.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function f4(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const a = t[o].x, c = t[o].y, u = t[s].x, l = t[s].y;
    c > r != l > r && n < (u - a) * (r - c) / (l - c) + a && (i = !i);
  }
  return i;
}
function g4(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return f4(n, t);
}
function vo(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var h4 = bg, p4 = td, m4 = Cg, v4 = Ig, b4 = od, y4 = Eg, C4 = Ma, I4 = Bg, E4 = Pg, x4 = Og, B4 = Sg, w4 = Ng, P4 = Tg, H4 = Lg, O4 = Qg, cd = "DropdownMenu", [D4, HR] = _n(
  cd,
  [mg]
), vt = mg(), [S4, Vg] = D4(cd), kg = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: i,
    defaultOpen: o,
    onOpenChange: s,
    modal: a = !0
  } = e, c = vt(t), u = w.useRef(null), [l = !1, d] = $o({
    prop: i,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ A(
    S4,
    {
      scope: t,
      triggerId: Mn(),
      triggerRef: u,
      contentId: Mn(),
      open: l,
      onOpenChange: d,
      onOpenToggle: w.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: /* @__PURE__ */ A(h4, { ...c, open: l, onOpenChange: d, dir: r, modal: a, children: n })
    }
  );
};
kg.displayName = cd;
var Mg = "DropdownMenuTrigger", zg = w.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, o = Vg(Mg, n), s = vt(n);
    return /* @__PURE__ */ A(p4, { asChild: !0, ...s, children: /* @__PURE__ */ A(
      Me.button,
      {
        type: "button",
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": o.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...i,
        ref: Da(t, o.triggerRef),
        onPointerDown: he(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (o.onOpenToggle(), o.open || a.preventDefault());
        }),
        onKeyDown: he(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && o.onOpenToggle(), a.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
zg.displayName = Mg;
var N4 = "DropdownMenuPortal", jg = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = vt(t);
  return /* @__PURE__ */ A(m4, { ...r, ...n });
};
jg.displayName = N4;
var Wg = "DropdownMenuContent", Zg = w.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = Vg(Wg, n), o = vt(n), s = w.useRef(!1);
    return /* @__PURE__ */ A(
      v4,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ...r,
        ref: t,
        onCloseAutoFocus: he(e.onCloseAutoFocus, (a) => {
          var c;
          s.current || (c = i.triggerRef.current) == null || c.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: he(e.onInteractOutside, (a) => {
          const c = a.detail.originalEvent, u = c.button === 0 && c.ctrlKey === !0, l = c.button === 2 || u;
          (!i.modal || l) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Zg.displayName = Wg;
var T4 = "DropdownMenuGroup", R4 = w.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
    return /* @__PURE__ */ A(b4, { ...i, ...r, ref: t });
  }
);
R4.displayName = T4;
var L4 = "DropdownMenuLabel", Gg = w.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
    return /* @__PURE__ */ A(y4, { ...i, ...r, ref: t });
  }
);
Gg.displayName = L4;
var F4 = "DropdownMenuItem", qg = w.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
    return /* @__PURE__ */ A(C4, { ...i, ...r, ref: t });
  }
);
qg.displayName = F4;
var Q4 = "DropdownMenuCheckboxItem", X4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(I4, { ...i, ...r, ref: t });
});
X4.displayName = Q4;
var V4 = "DropdownMenuRadioGroup", k4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(E4, { ...i, ...r, ref: t });
});
k4.displayName = V4;
var M4 = "DropdownMenuRadioItem", z4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(x4, { ...i, ...r, ref: t });
});
z4.displayName = M4;
var j4 = "DropdownMenuItemIndicator", W4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(B4, { ...i, ...r, ref: t });
});
W4.displayName = j4;
var Z4 = "DropdownMenuSeparator", G4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(w4, { ...i, ...r, ref: t });
});
G4.displayName = Z4;
var q4 = "DropdownMenuArrow", Y4 = w.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
    return /* @__PURE__ */ A(P4, { ...i, ...r, ref: t });
  }
);
Y4.displayName = q4;
var U4 = "DropdownMenuSubTrigger", J4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(H4, { ...i, ...r, ref: t });
});
J4.displayName = U4;
var K4 = "DropdownMenuSubContent", _4 = w.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = vt(n);
  return /* @__PURE__ */ A(
    O4,
    {
      ...i,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
_4.displayName = K4;
var $4 = kg, e6 = zg, t6 = jg, n6 = Zg, r6 = Gg, i6 = qg;
const Yg = $4, Ug = e6, Jg = Nt(function({ children: t, ...n }, r) {
  return /* @__PURE__ */ A(t6, { children: /* @__PURE__ */ A(n6, { ...n, ref: r, children: t }) });
}), OR = r6, Kg = i6;
function Y({ name: e, size: t = 24, color: n, style: r, ...i }) {
  const o = hh(t), s = {
    color: n,
    ...o,
    style: r
  }, a = Rv[e];
  return /* @__PURE__ */ A(a, { ...i, style: s });
}
function o6(e) {
  const t = ["document-editor", `${e.mode}-mode`];
  return /* @__PURE__ */ A("div", { className: t.join(" "), children: e.children });
}
function s6(e) {
  const t = e.left || [], n = e.center || [], r = e.right || [];
  return /* @__PURE__ */ D("div", { className: "editor-toolbar", children: [
    /* @__PURE__ */ A("div", { className: "editor-toolbar--column editor-toolbar--left", children: t }),
    /* @__PURE__ */ A("div", { className: "editor-toolbar--column editor-toolbar--center", children: n }),
    /* @__PURE__ */ A("div", { className: "editor-toolbar--column editor-toolbar--right", children: r })
  ] });
}
function a6(e) {
  return /* @__PURE__ */ A("div", { className: "editor-worksheet", children: /* @__PURE__ */ A("div", { className: "editor-worksheet--page", children: e.children }) });
}
const _g = {
  light: {
    color: "#222222",
    bgColor: "#FFFFFF",
    border: "#EEEEEE",
    shadow: "rgba(128,128,128,0.65)",
    inputColor: "#222222",
    inputBg: "#F6F6F6"
  },
  dark: {
    color: "#E6E6E6",
    bgColor: "#181818",
    border: "#181818",
    shadow: "rgba(0, 0, 0, 0.25)",
    inputColor: "#E6E6E6",
    inputBg: "#222222"
  }
}, $g = {
  huge: {
    fontSize: "36pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "30pt 0 0 0"
  },
  larger: {
    fontSize: "24pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "18pt 0 0 0"
  },
  large: {
    fontSize: "18pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "12pt 0 0 0"
  },
  medium: {
    fontSize: "11pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "5pt 0 0 0"
  },
  small: {
    fontSize: "10pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0"
  },
  smaller: {
    fontSize: "9pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0"
  },
  tiny: {
    fontSize: "8pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0"
  }
}, Su = (e = "light", t = !1) => {
  const n = _g[e];
  return {
    width: "100%",
    border: "none",
    boxSizing: "border-box",
    backgroundColor: t ? n.inputBg : n.bgColor,
    outline: "none",
    color: n.inputColor,
    resize: "none",
    fontFamily: "Roboto, sans-serif",
    overflow: "hidden",
    lineHeight: "1.5"
  };
}, c6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  colorScheme: _g,
  inputStyle: Su,
  typographySizes: $g
}, Symbol.toStringTag, { value: "Module" })), eh = {
  light: {
    color: "#222222",
    bgColor: "#FFFFFF",
    border: "#EEEEEE",
    shadow: "rgba(128,128,128,0.65)",
    inputColor: "#222222",
    inputBg: "#F6F6F6"
  },
  dark: {
    color: "#CCCCCC",
    bgColor: "#0A0A0A",
    border: "#181818",
    shadow: "rgba(255, 255, 255, 0.25)",
    inputColor: "#CCCCCC",
    inputBg: "#1A1D1F"
  }
}, th = {
  chapter: {
    fontSize: "64pt",
    fontWeight: "bold",
    padding: "6pt 24pt",
    margin: "0",
    lineHeight: 1,
    textAlign: "right",
    borderLeft: "4px solid"
  },
  huge: {
    fontSize: "32pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0 0 0 -6pt",
    lineHeight: 1
  },
  larger: {
    fontSize: "24pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "-12pt 0 0 0"
  },
  large: {
    fontSize: "18pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "-10.5pt 0 0 0"
  },
  medium: {
    fontSize: "11pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "-8pt 0 0 0"
  },
  small: {
    fontSize: "10pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "-6pt 0 0 0"
  },
  smaller: {
    fontSize: "9pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "-5pt 0 0 0"
  },
  tiny: {
    fontSize: "8pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "-8pt 0 0 0"
  }
}, Nu = (e = "light", t = !1) => {
  const n = eh[e];
  return {
    width: "100%",
    border: "none",
    boxSizing: "border-box",
    backgroundColor: t ? n.inputBg : n.bgColor,
    outline: "none",
    color: n.inputColor,
    resize: "none",
    fontFamily: "Roboto, sans-serif",
    overflow: "hidden",
    lineHeight: "1.5"
  };
}, u6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  colorScheme: eh,
  inputStyle: Nu,
  typographySizes: th
}, Symbol.toStringTag, { value: "Module" }));
function l6(e) {
  const [t, n] = q({
    value: e.value || "",
    hasFocus: !1,
    pressingEnter: !1
  });
  Ie(() => {
    n({ ...t, value: e.value || "" });
  }, [e]);
  const r = (u) => {
    u.key === "Enter" && (n({ ...t, pressingEnter: !0 }), u.preventDefault());
  }, i = (u) => {
    u.key === "Enter" && (e.onSubmit && e.onSubmit(u.target.value), e.clearOnSubmit ? n({ ...t, value: "", pressingEnter: !1 }) : n({ ...t, pressingEnter: !1 }), u.preventDefault()), (u.key === "Backspace" || u.key === "Delete") && (e.onEmpty && u.target.value.length < 1 && e.onEmpty(e.id || ""), u.preventDefault());
  }, o = (u) => {
    if (!t.pressingEnter) {
      const l = u.target;
      n({ ...t, value: l.value }), l.style.height = "1px", l.style.height = l.scrollHeight + "px";
    }
  }, s = (u) => {
    var l;
    if (n({ ...t, hasFocus: u }), !u) {
      const d = ((l = a.current) == null ? void 0 : l.value) || "", f = e.value || "";
      d !== f && e.onSubmit && e.onSubmit(d);
    }
  }, a = Ce(null);
  Ie(() => {
    const u = () => {
      a.current && (a.current.style.height = "1px", a.current.style.height = a.current.scrollHeight + "px");
    };
    return window.addEventListener("resize", u), u(), () => {
      window.removeEventListener("resize", u);
    };
  });
  const c = {
    ...Su(e.theme, t.hasFocus),
    ...$g[e.size || "small"]
  };
  return /* @__PURE__ */ D("div", { children: [
    e.horizontalLine ? /* @__PURE__ */ A(
      "hr",
      {
        style: {
          borderColor: Su(e.theme, !1).backgroundColor
        }
      },
      "line"
    ) : "",
    /* @__PURE__ */ A(
      "textarea",
      {
        ref: a,
        placeholder: e.placeholder || "",
        autoFocus: e.autoFocus || !1,
        onInput: o,
        onKeyDown: r,
        onKeyUp: i,
        style: c,
        value: t.value,
        onFocus: () => s(!0),
        onBlur: () => s(!1)
      },
      "text"
    )
  ] });
}
function d6(e) {
  const [t, n] = q({
    value: e.value || "",
    hasFocus: !1,
    pressingEnter: !1
  });
  Ie(() => {
    n({ ...t, value: e.value || "" });
  }, [e.value]);
  const r = (u) => {
    u.key === "Enter" && (n({ ...t, pressingEnter: !0 }), u.preventDefault());
  }, i = (u) => {
    u.key === "Enter" && (e.onSubmit && e.onSubmit(u.target.value), e.clearOnSubmit ? n({ ...t, value: "", pressingEnter: !1 }) : n({ ...t, pressingEnter: !1 }), u.preventDefault()), (u.key === "Backspace" || u.key === "Delete") && (e.onEmpty && u.target.value.length < 1 && e.onEmpty(e.id || ""), u.preventDefault());
  }, o = (u) => {
    if (!t.pressingEnter) {
      const l = u.target;
      n({ ...t, value: l.value }), l.style.height = "1px", l.style.height = `${l.scrollHeight}px`;
    }
  }, s = (u) => {
    var l;
    if (n({ ...t, hasFocus: u }), !u) {
      const d = ((l = a.current) == null ? void 0 : l.value) || "", f = e.value || "";
      d !== f && e.onSubmit && e.onSubmit(d);
    }
  }, a = Ce(null);
  Ie(() => {
    const u = () => {
      a.current && (a.current.style.height = "1px", a.current.style.height = `${a.current.scrollHeight}px`);
    };
    return window.addEventListener("resize", u), u(), () => {
      window.removeEventListener("resize", u);
    };
  });
  const c = {
    ...Nu(e.theme, t.hasFocus),
    ...th[e.size || "small"]
  };
  return e.labelStyle && (c.textAlign = "center", c.textTransform = "uppercase", c.backgroundColor = "rgba(0, 0, 255, 0.05)", c.borderRadius = "8px", c.padding = "1px 0 4px 0", c.margin = "0", c.fontWeight = "bold", c.fontSize = "8pt", c.color = "#518EBE", c.border = "2px solid #518EBE", c.cursor = "pointer", c.lineHeight = "1.5"), /* @__PURE__ */ D("div", { children: [
    e.horizontalLine ? /* @__PURE__ */ A(
      "hr",
      {
        style: {
          borderColor: Nu(e.theme, !1).backgroundColor
        }
      },
      "line"
    ) : "",
    /* @__PURE__ */ A(
      "textarea",
      {
        ref: a,
        placeholder: e.placeholder || "",
        autoFocus: e.autoFocus || !1,
        onInput: o,
        onKeyDown: r,
        onKeyUp: i,
        style: c,
        value: t.value,
        onFocus: () => s(!0),
        onBlur: () => s(!1),
        tabIndex: e.labelStyle ? -1 : 1,
        spellCheck: t.hasFocus
      },
      "text"
    )
  ] });
}
function A6(e) {
  const t = e.onClick || (() => {
    console.log("No onClick handler attached to button.");
  });
  return /* @__PURE__ */ A(
    "div",
    {
      onClick: t,
      className: "toolbar-button",
      style: { userSelect: "none" },
      children: e.children
    }
  );
}
const DR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DocumentEditor: o6,
  EditorToolbar: s6,
  EditorWorksheet: a6,
  TextInput: l6,
  TextInputVariant: d6,
  ToolbarButton: A6,
  styles: c6,
  stylesVariant: u6
}, Symbol.toStringTag, { value: "Module" }));
var ud = "Dialog", [nh, SR] = _n(ud), [f6, _t] = nh(ud), rh = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = e, a = w.useRef(null), c = w.useRef(null), [u = !1, l] = $o({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ A(
    f6,
    {
      scope: t,
      triggerRef: a,
      contentRef: c,
      contentId: Mn(),
      titleId: Mn(),
      descriptionId: Mn(),
      open: u,
      onOpenChange: l,
      onOpenToggle: w.useCallback(() => l((d) => !d), [l]),
      modal: s,
      children: n
    }
  );
};
rh.displayName = ud;
var ih = "DialogTrigger", g6 = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = _t(ih, n), o = $e(t, i.triggerRef);
    return /* @__PURE__ */ A(
      Me.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Ad(i.open),
        ...r,
        ref: o,
        onClick: he(e.onClick, i.onOpenToggle)
      }
    );
  }
);
g6.displayName = ih;
var ld = "DialogPortal", [h6, oh] = nh(ld, {
  forceMount: void 0
}), sh = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = _t(ld, t);
  return /* @__PURE__ */ A(h6, { scope: t, forceMount: n, children: w.Children.map(r, (s) => /* @__PURE__ */ A(Kt, { present: n || o.open, children: /* @__PURE__ */ A(Fa, { asChild: !0, container: i, children: s }) })) });
};
sh.displayName = ld;
var ia = "DialogOverlay", ah = w.forwardRef(
  (e, t) => {
    const n = oh(ia, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = _t(ia, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ A(Kt, { present: r || o.open, children: /* @__PURE__ */ A(p6, { ...i, ref: t }) }) : null;
  }
);
ah.displayName = ia;
var p6 = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = _t(ia, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ A(ed, { as: yi, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ A(
        Me.div,
        {
          "data-state": Ad(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), yr = "DialogContent", ch = w.forwardRef(
  (e, t) => {
    const n = oh(yr, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = _t(yr, e.__scopeDialog);
    return /* @__PURE__ */ A(Kt, { present: r || o.open, children: o.modal ? /* @__PURE__ */ A(m6, { ...i, ref: t }) : /* @__PURE__ */ A(v6, { ...i, ref: t }) });
  }
);
ch.displayName = yr;
var m6 = w.forwardRef(
  (e, t) => {
    const n = _t(yr, e.__scopeDialog), r = w.useRef(null), i = $e(t, n.contentRef, r);
    return w.useEffect(() => {
      const o = r.current;
      if (o) return cg(o);
    }, []), /* @__PURE__ */ A(
      uh,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: he(e.onCloseAutoFocus, (o) => {
          var s;
          o.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: he(e.onPointerDownOutside, (o) => {
          const s = o.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && o.preventDefault();
        }),
        onFocusOutside: he(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), v6 = w.forwardRef(
  (e, t) => {
    const n = _t(yr, e.__scopeDialog), r = w.useRef(!1), i = w.useRef(!1);
    return /* @__PURE__ */ A(
      uh,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, o), o.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const s = o.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), uh = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...s } = e, a = _t(yr, n), c = w.useRef(null), u = $e(t, c);
    return O0(), /* @__PURE__ */ D(Be, { children: [
      /* @__PURE__ */ A(
        Zl,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ A(
            Sa,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": Ad(a.open),
              ...s,
              ref: u,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ D(Be, { children: [
        /* @__PURE__ */ A(I6, { titleId: a.titleId }),
        /* @__PURE__ */ A(x6, { contentRef: c, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), dd = "DialogTitle", b6 = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = _t(dd, n);
    return /* @__PURE__ */ A(Me.h2, { id: i.titleId, ...r, ref: t });
  }
);
b6.displayName = dd;
var lh = "DialogDescription", y6 = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = _t(lh, n);
    return /* @__PURE__ */ A(Me.p, { id: i.descriptionId, ...r, ref: t });
  }
);
y6.displayName = lh;
var dh = "DialogClose", C6 = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = _t(dh, n);
    return /* @__PURE__ */ A(
      Me.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: he(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
C6.displayName = dh;
function Ad(e) {
  return e ? "open" : "closed";
}
var Ah = "DialogTitleWarning", [NR, fh] = f2(Ah, {
  contentName: yr,
  titleName: dd,
  docsSlug: "dialog"
}), I6 = ({ titleId: e }) => {
  const t = fh(Ah), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return w.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, E6 = "DialogDescriptionWarning", x6 = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${fh(E6).contentName}}.`;
  return w.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, B6 = rh, w6 = sh, P6 = ah, H6 = ch;
function gn(e) {
  const {
    open: t,
    onOpenChange: n,
    contentProps: r,
    overlayProps: i,
    children: o,
    ...s
  } = e;
  return /* @__PURE__ */ A(B6, { open: t, defaultOpen: t, onOpenChange: n, children: /* @__PURE__ */ A(w6, { children: /* @__PURE__ */ A(
    P6,
    {
      ...i,
      className: $(
        "fixed inset-0 grid place-items-center overflow-y-auto bg-slate-900/50 data-[state=closed]:animate-fade-out data-[state=open]:animate-fade-in",
        i == null ? void 0 : i.className
      ),
      children: /* @__PURE__ */ A(
        H6,
        {
          ...s,
          ...r,
          className: $(
            "bg-white data-[state=closed]:animate-zoom-out data-[state=open]:animate-zoom-in",
            r == null ? void 0 : r.className
          ),
          children: o
        }
      )
    }
  ) }) });
}
const Yi = ({
  active: e = !1,
  ...t
}) => {
  const n = $(
    "h-8 min-w-8 border border-solid border-gray-300 bg-white px-3 py-1 text-xs text-gray-900 hover:bg-gray-100",
    !e && "border-0"
  );
  return /* @__PURE__ */ A(
    Et,
    {
      color: "light",
      size: "small",
      ...rt(t, n),
      children: t.children
    }
  );
}, fd = (e) => {
  const {
    pages: t = [],
    goToFirstPage: n,
    goToLastPage: r,
    goToNextPage: i,
    goToPreviousPage: o,
    goToPage: s,
    isNextPageAvailable: a,
    isPreviousPageAvailable: c,
    hiddenNextPages: u,
    firstPageLabel: l,
    lastPageLabel: d,
    nextPageLabel: f,
    previousPageLabel: h
  } = e;
  return /* @__PURE__ */ D("div", { className: "flex gap-x-1", children: [
    l && /* @__PURE__ */ A(
      Yi,
      {
        onClick: () => n(),
        disabled: !c,
        children: l
      }
    ),
    h && /* @__PURE__ */ D(
      Yi,
      {
        onClick: () => o(),
        disabled: !c,
        children: [
          /* @__PURE__ */ A(Y, { name: "ChevronDown", size: 16, className: "rotate-90" }),
          h
        ]
      }
    ),
    t.map((g) => /* @__PURE__ */ A(
      Yi,
      {
        active: g.active,
        onClick: () => s(g.index),
        children: g.number
      },
      g.index
    )),
    u && /* @__PURE__ */ A("span", { className: "flex items-center justify-center px-2", children: "..." }),
    f && /* @__PURE__ */ D(
      Yi,
      {
        onClick: () => i(),
        disabled: !a,
        children: [
          f,
          /* @__PURE__ */ A(Y, { name: "ChevronDown", size: 16, className: "-rotate-90" })
        ]
      }
    ),
    d && /* @__PURE__ */ A(
      Yi,
      {
        onClick: () => r(),
        disabled: !a,
        children: d
      }
    )
  ] });
};
function O6({ className: e, ...t }) {
  return /* @__PURE__ */ A("div", { className: $("flex-shrink-0", e), ...t });
}
function D6({ className: e, ...t }) {
  return /* @__PURE__ */ A("div", { className: $("flex-shrink-0", e), ...t });
}
const S6 = ({
  collapsed: e = !1,
  maxWidth: t = "304px",
  minWidth: n = "80px",
  className: r,
  children: i,
  ...o
}) => {
  const s = Ce(null), [a, c] = q(
    e ? "collapsed" : "expanded"
  );
  return gd(s, ["collapsing", "expanding"].includes(a), () => {
    c(
      (u) => u === "collapsing" ? "collapsed" : u === "expanding" ? "expanded" : u
    );
  }), Ie(() => {
    e && a !== "collapsed" ? c("collapsing") : !e && a !== "expanded" && c("expanding");
  }, [e]), /* @__PURE__ */ A(
    "div",
    {
      ...o,
      ref: s,
      className: $(
        ` group ${a} flex
                 h-full flex-col overflow-hidden transition-none duration-300`,
        r,
        ["collapsing", "expanding"].includes(a) && "animate-out fade-out",
        ["collapsed", "expanded"].includes(a) && "animate-in fade-in",
        a === "collapsed" && "bg-transparent shadow-none",
        a === "expanded" && "shadow-sidebar"
      ),
      style: {
        width: ["collapsed", "expanding"].includes(a) ? n : t
      },
      children: i
    }
  );
};
function N6({
  className: e,
  children: t,
  ...n
}) {
  const [r, i] = q(!1);
  function o(a) {
    i(
      a.scrollHeight - a.scrollTop - a.clientHeight > 1
    );
  }
  const s = Ce(null);
  return Ie(() => {
    if (!s.current)
      return;
    const a = new ResizeObserver(
      (c) => {
        const u = c.pop();
        if (!u)
          return;
        const { target: l } = u;
        o(l);
      }
    );
    return a.observe(s.current), () => {
      a.disconnect();
    };
  }, [s.current]), /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      "div",
      {
        className: $(
          "no-scrollbar flex-1 overflow-auto text-gray-900 transition-shadow",
          e
        ),
        ref: s,
        onScroll: (a) => o(a.currentTarget),
        ...n,
        children: t
      }
    ),
    r && /* @__PURE__ */ A(
      "div",
      {
        className: "pointer-events-none z-10 -mt-12 h-12 w-full",
        style: {
          boxShadow: "inset 0px -33px 32px -16px rgba(0,0,0,0.1)"
        }
      }
    )
  ] });
}
function TR(e, t = !0) {
  const [n, r] = q(!0);
  return gd(
    e,
    n && t,
    me(() => r(!1), [])
  ), n && t;
}
function RR(e, t) {
  const [n, r] = q(!1), [i, o] = q("idle");
  return !t && e.current && i === "idle" && (r(!0), o("exiting")), !e.current && i === "exited" && o("idle"), gd(
    e,
    n,
    me(() => {
      o("exited"), r(!1);
    }, [])
  ), n;
}
function gd(e, t, n) {
  const r = Ce(null);
  t && e.current && (r.current = window.getComputedStyle(e.current).animation), Kn(() => {
    if (t && e.current) {
      const i = window.getComputedStyle(e.current);
      if (i.animationName !== "none" && i.animation !== r.current) {
        const o = (a) => {
          a.target === e.current && (s.removeEventListener(
            "animationend",
            o
          ), v0.flushSync(() => {
            n();
          }));
        }, s = e.current;
        return s.addEventListener("animationend", o), () => {
          s.removeEventListener("animationend", o);
        };
      } else
        n();
    }
  }, [e, t, n]);
}
function T6(e, t) {
  return (n, r) => {
    try {
      return e(n, r);
    } catch (i) {
      return t == null || t(i), n;
    }
  };
}
function LR(e, t) {
  return (n, r) => R6(e, t(n), r);
}
function R6(e, t, n) {
  const [r, i] = C9(
    T6(e, n),
    t
  );
  return [r, i];
}
function hd(e, t) {
  const { itemsPerPage: n = 10, initialPage: r = 0, pageRange: i = 5 } = t || {}, [o, s] = q(r), a = Math.ceil(e.length / n), c = o < a - 1, u = o > 0, l = me(() => {
    c && s((B) => B + 1);
  }, [c, s]), d = me(() => {
    u && s((B) => B - 1);
  }, [u, s]), f = me(() => {
    s(a - 1);
  }, [a]), h = me(() => {
    s(0);
  }, []), g = me(
    (B) => {
      B >= 0 && B < a && s(B);
    },
    [a]
  ), m = Math.floor((i - 1) / 2), p = Math.min(i, a), v = Math.max(a - p), b = Math.min(
    v,
    Math.max(o - m, 0)
  ), y = ve(() => {
    const B = [];
    for (let I = b; I < p + b; I++)
      B.push({
        index: I,
        active: I === o,
        number: I + 1
      });
    return B;
  }, [p, b, o]), E = e.slice(
    o * n,
    (o + 1) * n
  ), C = y.length > 0 && y.slice(-1)[0].index < a - 1;
  return {
    pages: y,
    goToPage: g,
    pageItems: E,
    pageCount: a,
    currentPage: o,
    goToLastPage: f,
    goToFirstPage: h,
    goToNextPage: l,
    hiddenNextPages: C,
    goToPreviousPage: d,
    isNextPageAvailable: c,
    isPreviousPageAvailable: u
  };
}
function gh(e) {
  return Nt(e);
}
function hh(e) {
  return e ? typeof e == "number" ? {
    width: e.toString() + "px",
    height: e.toString() + "px"
  } : {
    width: e,
    height: e
  } : {};
}
function rt(e, t) {
  const { className: n, ...r } = e;
  return {
    className: $(
      t,
      typeof n == "string" && n
    ),
    ...r
  };
}
function ph(e) {
  const { style: t, size: n = 100, alt: r = "Loading...", ...i } = e, s = {
    objectFit: "contain",
    ...hh(n),
    ...t
  };
  return /* @__PURE__ */ A(
    "img",
    {
      ...i,
      src: Lv,
      alt: r,
      style: s
    }
  );
}
function FR(e) {
  const {
    selectedNodePath: t,
    isAllowedToCreateDocuments: n,
    onAddAndSelectNewFolder: r
  } = e, [i, o] = q(!1);
  function s() {
    o(!0);
  }
  async function a(u) {
    await r(u), o(!1);
  }
  function c() {
    o(!1);
  }
  return /* @__PURE__ */ D("div", { className: "flex h-9 flex-row items-center gap-2 p-6 text-gray-500", children: [
    t.map((u) => /* @__PURE__ */ bi(L6, { ...e, key: u.id, node: u })),
    /* @__PURE__ */ A(Be, { children: n && /* @__PURE__ */ A(Be, { children: i ? /* @__PURE__ */ A(
      Mo,
      {
        defaultValue: "New Folder",
        placeholder: "New Folder",
        className: "text-gray-800",
        onSubmit: a,
        onCancel: c
      }
    ) : /* @__PURE__ */ D(
      "button",
      {
        onClick: s,
        className: "ml-1 flex items-center justify-center gap-2 rounded-md bg-gray-50 px-2 py-1.5 transition-colors hover:bg-gray-200 hover:text-gray-800",
        children: [
          /* @__PURE__ */ A(Y, { name: "Plus", size: 14 }),
          "Add new"
        ]
      }
    ) }) })
  ] });
}
function L6(e) {
  const { node: t, setSelectedNode: n } = e;
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      "div",
      {
        role: "button",
        className: "transition-colors last-of-type:text-gray-800 hover:text-gray-800",
        onClick: () => n(t),
        children: t.name
      }
    ),
    "/"
  ] });
}
function Cr(e) {
  "@babel/helpers - typeof";
  return Cr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cr(e);
}
function F6(e, t) {
  if (Cr(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Cr(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mh(e) {
  var t = F6(e, "string");
  return Cr(t) == "symbol" ? t : t + "";
}
function oo(e, t, n) {
  return (t = mh(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function nf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nf(Object(n), !0).forEach(function(r) {
      oo(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Q6(e) {
  if (Array.isArray(e)) return e;
}
function X6(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, s, a = [], c = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = o.call(n)).done) && (a.push(r.value), a.length !== t); c = !0) ;
    } catch (l) {
      u = !0, i = l;
    } finally {
      try {
        if (!c && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw i;
      }
    }
    return a;
  }
}
function Tu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function vh(e, t) {
  if (e) {
    if (typeof e == "string") return Tu(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Tu(e, t) : void 0;
  }
}
function V6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cn(e, t) {
  return Q6(e) || X6(e, t) || vh(e, t) || V6();
}
function k6(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function Bn(e, t) {
  if (e == null) return {};
  var n, r, i = k6(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++) n = o[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
var M6 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function z6(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, i = r === void 0 ? !1 : r, o = e.defaultValue, s = o === void 0 ? null : o, a = e.inputValue, c = e.menuIsOpen, u = e.onChange, l = e.onInputChange, d = e.onMenuClose, f = e.onMenuOpen, h = e.value, g = Bn(e, M6), m = q(a !== void 0 ? a : n), p = Cn(m, 2), v = p[0], b = p[1], y = q(c !== void 0 ? c : i), E = Cn(y, 2), C = E[0], B = E[1], I = q(h !== void 0 ? h : s), x = Cn(I, 2), O = x[0], k = x[1], Q = me(function(L, X) {
    typeof u == "function" && u(L, X), k(L);
  }, [u]), F = me(function(L, X) {
    var W;
    typeof l == "function" && (W = l(L, X)), b(W !== void 0 ? W : L);
  }, [l]), M = me(function() {
    typeof f == "function" && f(), B(!0);
  }, [f]), H = me(function() {
    typeof d == "function" && d(), B(!1);
  }, [d]), T = a !== void 0 ? a : v, R = c !== void 0 ? c : C, z = h !== void 0 ? h : O;
  return de(de({}, g), {}, {
    inputValue: T,
    menuIsOpen: R,
    onChange: Q,
    onInputChange: F,
    onMenuClose: H,
    onMenuOpen: M,
    value: z
  });
}
function fe() {
  return fe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fe.apply(null, arguments);
}
function j6(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function rf(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mh(r.key), r);
  }
}
function W6(e, t, n) {
  return t && rf(e.prototype, t), n && rf(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ru(e, t) {
  return Ru = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Ru(e, t);
}
function Z6(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ru(e, t);
}
function oa(e) {
  return oa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, oa(e);
}
function bh() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bh = function() {
    return !!e;
  })();
}
function G6(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function q6(e, t) {
  if (t && (Cr(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return G6(e);
}
function Y6(e) {
  var t = bh();
  return function() {
    var n, r = oa(e);
    if (t) {
      var i = oa(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return q6(this, n);
  };
}
function U6(e) {
  if (Array.isArray(e)) return Tu(e);
}
function J6(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function K6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pd(e) {
  return U6(e) || J6(e) || vh(e) || K6();
}
var _6 = !1;
function $6(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function e5(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var t5 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var o;
      r.tags.length === 0 ? r.insertionPoint ? o = r.insertionPoint.nextSibling : r.prepend ? o = r.container.firstChild : o = r.before : o = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, o), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !_6 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(e5(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = $6(i);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), ct = "-ms-", sa = "-moz-", De = "-webkit-", yh = "comm", md = "rule", vd = "decl", n5 = "@import", Ch = "@keyframes", r5 = "@layer", i5 = Math.abs, za = String.fromCharCode, o5 = Object.assign;
function s5(e, t) {
  return it(e, 0) ^ 45 ? (((t << 2 ^ it(e, 0)) << 2 ^ it(e, 1)) << 2 ^ it(e, 2)) << 2 ^ it(e, 3) : 0;
}
function Ih(e) {
  return e.trim();
}
function a5(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Se(e, t, n) {
  return e.replace(t, n);
}
function Lu(e, t) {
  return e.indexOf(t);
}
function it(e, t) {
  return e.charCodeAt(t) | 0;
}
function bo(e, t, n) {
  return e.slice(t, n);
}
function sn(e) {
  return e.length;
}
function bd(e) {
  return e.length;
}
function ys(e, t) {
  return t.push(e), e;
}
function c5(e, t) {
  return e.map(t).join("");
}
var ja = 1, Ii = 1, Eh = 0, xt = 0, Ue = 0, Ri = "";
function Wa(e, t, n, r, i, o, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: ja, column: Ii, length: s, return: "" };
}
function Ui(e, t) {
  return o5(Wa("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function u5() {
  return Ue;
}
function l5() {
  return Ue = xt > 0 ? it(Ri, --xt) : 0, Ii--, Ue === 10 && (Ii = 1, ja--), Ue;
}
function St() {
  return Ue = xt < Eh ? it(Ri, xt++) : 0, Ii++, Ue === 10 && (Ii = 1, ja++), Ue;
}
function dn() {
  return it(Ri, xt);
}
function Ms() {
  return xt;
}
function rs(e, t) {
  return bo(Ri, e, t);
}
function yo(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function xh(e) {
  return ja = Ii = 1, Eh = sn(Ri = e), xt = 0, [];
}
function Bh(e) {
  return Ri = "", e;
}
function zs(e) {
  return Ih(rs(xt - 1, Fu(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function d5(e) {
  for (; (Ue = dn()) && Ue < 33; )
    St();
  return yo(e) > 2 || yo(Ue) > 3 ? "" : " ";
}
function A5(e, t) {
  for (; --t && St() && !(Ue < 48 || Ue > 102 || Ue > 57 && Ue < 65 || Ue > 70 && Ue < 97); )
    ;
  return rs(e, Ms() + (t < 6 && dn() == 32 && St() == 32));
}
function Fu(e) {
  for (; St(); )
    switch (Ue) {
      case e:
        return xt;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Fu(Ue);
        break;
      case 40:
        e === 41 && Fu(e);
        break;
      case 92:
        St();
        break;
    }
  return xt;
}
function f5(e, t) {
  for (; St() && e + Ue !== 57; )
    if (e + Ue === 84 && dn() === 47)
      break;
  return "/*" + rs(t, xt - 1) + "*" + za(e === 47 ? e : St());
}
function g5(e) {
  for (; !yo(dn()); )
    St();
  return rs(e, xt);
}
function h5(e) {
  return Bh(js("", null, null, null, [""], e = xh(e), 0, [0], e));
}
function js(e, t, n, r, i, o, s, a, c) {
  for (var u = 0, l = 0, d = s, f = 0, h = 0, g = 0, m = 1, p = 1, v = 1, b = 0, y = "", E = i, C = o, B = r, I = y; p; )
    switch (g = b, b = St()) {
      case 40:
        if (g != 108 && it(I, d - 1) == 58) {
          Lu(I += Se(zs(b), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        I += zs(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        I += d5(g);
        break;
      case 92:
        I += A5(Ms() - 1, 7);
        continue;
      case 47:
        switch (dn()) {
          case 42:
          case 47:
            ys(p5(f5(St(), Ms()), t, n), c);
            break;
          default:
            I += "/";
        }
        break;
      case 123 * m:
        a[u++] = sn(I) * v;
      case 125 * m:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            p = 0;
          case 59 + l:
            v == -1 && (I = Se(I, /\f/g, "")), h > 0 && sn(I) - d && ys(h > 32 ? sf(I + ";", r, n, d - 1) : sf(Se(I, " ", "") + ";", r, n, d - 2), c);
            break;
          case 59:
            I += ";";
          default:
            if (ys(B = of(I, t, n, u, l, i, a, y, E = [], C = [], d), o), b === 123)
              if (l === 0)
                js(I, t, B, B, E, o, d, a, C);
              else
                switch (f === 99 && it(I, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    js(e, B, B, r && ys(of(e, B, B, 0, 0, i, a, y, i, E = [], d), C), i, C, d, a, r ? E : C);
                    break;
                  default:
                    js(I, B, B, B, [""], C, 0, a, C);
                }
        }
        u = l = h = 0, m = v = 1, y = I = "", d = s;
        break;
      case 58:
        d = 1 + sn(I), h = g;
      default:
        if (m < 1) {
          if (b == 123)
            --m;
          else if (b == 125 && m++ == 0 && l5() == 125)
            continue;
        }
        switch (I += za(b), b * m) {
          case 38:
            v = l > 0 ? 1 : (I += "\f", -1);
            break;
          case 44:
            a[u++] = (sn(I) - 1) * v, v = 1;
            break;
          case 64:
            dn() === 45 && (I += zs(St())), f = dn(), l = d = sn(y = I += g5(Ms())), b++;
            break;
          case 45:
            g === 45 && sn(I) == 2 && (m = 0);
        }
    }
  return o;
}
function of(e, t, n, r, i, o, s, a, c, u, l) {
  for (var d = i - 1, f = i === 0 ? o : [""], h = bd(f), g = 0, m = 0, p = 0; g < r; ++g)
    for (var v = 0, b = bo(e, d + 1, d = i5(m = s[g])), y = e; v < h; ++v)
      (y = Ih(m > 0 ? f[v] + " " + b : Se(b, /&\f/g, f[v]))) && (c[p++] = y);
  return Wa(e, t, n, i === 0 ? md : a, c, u, l);
}
function p5(e, t, n) {
  return Wa(e, t, n, yh, za(u5()), bo(e, 2, -2), 0);
}
function sf(e, t, n, r) {
  return Wa(e, t, n, vd, bo(e, 0, r), bo(e, r + 1, -1), r);
}
function ti(e, t) {
  for (var n = "", r = bd(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function m5(e, t, n, r) {
  switch (e.type) {
    case r5:
      if (e.children.length) break;
    case n5:
    case vd:
      return e.return = e.return || e.value;
    case yh:
      return "";
    case Ch:
      return e.return = e.value + "{" + ti(e.children, r) + "}";
    case md:
      e.value = e.props.join(",");
  }
  return sn(n = ti(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function v5(e) {
  var t = bd(e);
  return function(n, r, i, o) {
    for (var s = "", a = 0; a < t; a++)
      s += e[a](n, r, i, o) || "";
    return s;
  };
}
function b5(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function y5(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var C5 = function(t, n, r) {
  for (var i = 0, o = 0; i = o, o = dn(), i === 38 && o === 12 && (n[r] = 1), !yo(o); )
    St();
  return rs(t, xt);
}, I5 = function(t, n) {
  var r = -1, i = 44;
  do
    switch (yo(i)) {
      case 0:
        i === 38 && dn() === 12 && (n[r] = 1), t[r] += C5(xt - 1, n, r);
        break;
      case 2:
        t[r] += zs(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = dn() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += za(i);
    }
  while (i = St());
  return t;
}, E5 = function(t, n) {
  return Bh(I5(xh(t), n));
}, af = /* @__PURE__ */ new WeakMap(), x5 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !af.get(r)) && !i) {
      af.set(t, !0);
      for (var o = [], s = E5(n, o), a = r.props, c = 0, u = 0; c < s.length; c++)
        for (var l = 0; l < a.length; l++, u++)
          t.props[u] = o[c] ? s[c].replace(/&\f/g, a[l]) : a[l] + " " + s[c];
    }
  }
}, B5 = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function wh(e, t) {
  switch (s5(e, t)) {
    case 5103:
      return De + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return De + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return De + e + sa + e + ct + e + e;
    case 6828:
    case 4268:
      return De + e + ct + e + e;
    case 6165:
      return De + e + ct + "flex-" + e + e;
    case 5187:
      return De + e + Se(e, /(\w+).+(:[^]+)/, De + "box-$1$2" + ct + "flex-$1$2") + e;
    case 5443:
      return De + e + ct + "flex-item-" + Se(e, /flex-|-self/, "") + e;
    case 4675:
      return De + e + ct + "flex-line-pack" + Se(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return De + e + ct + Se(e, "shrink", "negative") + e;
    case 5292:
      return De + e + ct + Se(e, "basis", "preferred-size") + e;
    case 6060:
      return De + "box-" + Se(e, "-grow", "") + De + e + ct + Se(e, "grow", "positive") + e;
    case 4554:
      return De + Se(e, /([^-])(transform)/g, "$1" + De + "$2") + e;
    case 6187:
      return Se(Se(Se(e, /(zoom-|grab)/, De + "$1"), /(image-set)/, De + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Se(e, /(image-set\([^]*)/, De + "$1$`$1");
    case 4968:
      return Se(Se(e, /(.+:)(flex-)?(.*)/, De + "box-pack:$3" + ct + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + De + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Se(e, /(.+)-inline(.+)/, De + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (sn(e) - 1 - t > 6) switch (it(e, t + 1)) {
        case 109:
          if (it(e, t + 4) !== 45) break;
        case 102:
          return Se(e, /(.+:)(.+)-([^]+)/, "$1" + De + "$2-$3$1" + sa + (it(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Lu(e, "stretch") ? wh(Se(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (it(e, t + 1) !== 115) break;
    case 6444:
      switch (it(e, sn(e) - 3 - (~Lu(e, "!important") && 10))) {
        case 107:
          return Se(e, ":", ":" + De) + e;
        case 101:
          return Se(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + De + (it(e, 14) === 45 ? "inline-" : "") + "box$3$1" + De + "$2$3$1" + ct + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (it(e, t + 11)) {
        case 114:
          return De + e + ct + Se(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return De + e + ct + Se(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return De + e + ct + Se(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return De + e + ct + e + e;
  }
  return e;
}
var w5 = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case vd:
      t.return = wh(t.value, t.length);
      break;
    case Ch:
      return ti([Ui(t, {
        value: Se(t.value, "@", "@" + De)
      })], i);
    case md:
      if (t.length) return c5(t.props, function(o) {
        switch (a5(o, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return ti([Ui(t, {
              props: [Se(o, /:(read-\w+)/, ":" + sa + "$1")]
            })], i);
          case "::placeholder":
            return ti([Ui(t, {
              props: [Se(o, /:(plac\w+)/, ":" + De + "input-$1")]
            }), Ui(t, {
              props: [Se(o, /:(plac\w+)/, ":" + sa + "$1")]
            }), Ui(t, {
              props: [Se(o, /:(plac\w+)/, ct + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, P5 = [w5], H5 = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(m) {
      var p = m.getAttribute("data-emotion");
      p.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || P5, o = {}, s, a = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(m) {
      for (var p = m.getAttribute("data-emotion").split(" "), v = 1; v < p.length; v++)
        o[p[v]] = !0;
      a.push(m);
    }
  );
  var c, u = [x5, B5];
  {
    var l, d = [m5, b5(function(m) {
      l.insert(m);
    })], f = v5(u.concat(i, d)), h = function(p) {
      return ti(h5(p), f);
    };
    c = function(p, v, b, y) {
      l = b, h(p ? p + "{" + v.styles + "}" : v.styles), y && (g.inserted[v.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new t5({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: c
  };
  return g.sheet.hydrate(a), g;
}, so = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Li(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qu = { exports: {} }, Ne = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cf;
function O5() {
  if (cf) return Ne;
  cf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function y(C) {
    if (typeof C == "object" && C !== null) {
      var B = C.$$typeof;
      switch (B) {
        case t:
          switch (C = C.type, C) {
            case c:
            case u:
            case r:
            case o:
            case i:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case a:
                case l:
                case g:
                case h:
                case s:
                  return C;
                default:
                  return B;
              }
          }
        case n:
          return B;
      }
    }
  }
  function E(C) {
    return y(C) === u;
  }
  return Ne.AsyncMode = c, Ne.ConcurrentMode = u, Ne.ContextConsumer = a, Ne.ContextProvider = s, Ne.Element = t, Ne.ForwardRef = l, Ne.Fragment = r, Ne.Lazy = g, Ne.Memo = h, Ne.Portal = n, Ne.Profiler = o, Ne.StrictMode = i, Ne.Suspense = d, Ne.isAsyncMode = function(C) {
    return E(C) || y(C) === c;
  }, Ne.isConcurrentMode = E, Ne.isContextConsumer = function(C) {
    return y(C) === a;
  }, Ne.isContextProvider = function(C) {
    return y(C) === s;
  }, Ne.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Ne.isForwardRef = function(C) {
    return y(C) === l;
  }, Ne.isFragment = function(C) {
    return y(C) === r;
  }, Ne.isLazy = function(C) {
    return y(C) === g;
  }, Ne.isMemo = function(C) {
    return y(C) === h;
  }, Ne.isPortal = function(C) {
    return y(C) === n;
  }, Ne.isProfiler = function(C) {
    return y(C) === o;
  }, Ne.isStrictMode = function(C) {
    return y(C) === i;
  }, Ne.isSuspense = function(C) {
    return y(C) === d;
  }, Ne.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === r || C === u || C === o || C === i || C === d || C === f || typeof C == "object" && C !== null && (C.$$typeof === g || C.$$typeof === h || C.$$typeof === s || C.$$typeof === a || C.$$typeof === l || C.$$typeof === p || C.$$typeof === v || C.$$typeof === b || C.$$typeof === m);
  }, Ne.typeOf = y, Ne;
}
var Te = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uf;
function D5() {
  return uf || (uf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function y(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === r || re === u || re === o || re === i || re === d || re === f || typeof re == "object" && re !== null && (re.$$typeof === g || re.$$typeof === h || re.$$typeof === s || re.$$typeof === a || re.$$typeof === l || re.$$typeof === p || re.$$typeof === v || re.$$typeof === b || re.$$typeof === m);
    }
    function E(re) {
      if (typeof re == "object" && re !== null) {
        var Ge = re.$$typeof;
        switch (Ge) {
          case t:
            var tt = re.type;
            switch (tt) {
              case c:
              case u:
              case r:
              case o:
              case i:
              case d:
                return tt;
              default:
                var at = tt && tt.$$typeof;
                switch (at) {
                  case a:
                  case l:
                  case g:
                  case h:
                  case s:
                    return at;
                  default:
                    return Ge;
                }
            }
          case n:
            return Ge;
        }
      }
    }
    var C = c, B = u, I = a, x = s, O = t, k = l, Q = r, F = g, M = h, H = n, T = o, R = i, z = d, L = !1;
    function X(re) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(re) || E(re) === c;
    }
    function W(re) {
      return E(re) === u;
    }
    function U(re) {
      return E(re) === a;
    }
    function ee(re) {
      return E(re) === s;
    }
    function Ae(re) {
      return typeof re == "object" && re !== null && re.$$typeof === t;
    }
    function ne(re) {
      return E(re) === l;
    }
    function K(re) {
      return E(re) === r;
    }
    function ae(re) {
      return E(re) === g;
    }
    function pe(re) {
      return E(re) === h;
    }
    function Pe(re) {
      return E(re) === n;
    }
    function Qe(re) {
      return E(re) === o;
    }
    function et(re) {
      return E(re) === i;
    }
    function st(re) {
      return E(re) === d;
    }
    Te.AsyncMode = C, Te.ConcurrentMode = B, Te.ContextConsumer = I, Te.ContextProvider = x, Te.Element = O, Te.ForwardRef = k, Te.Fragment = Q, Te.Lazy = F, Te.Memo = M, Te.Portal = H, Te.Profiler = T, Te.StrictMode = R, Te.Suspense = z, Te.isAsyncMode = X, Te.isConcurrentMode = W, Te.isContextConsumer = U, Te.isContextProvider = ee, Te.isElement = Ae, Te.isForwardRef = ne, Te.isFragment = K, Te.isLazy = ae, Te.isMemo = pe, Te.isPortal = Pe, Te.isProfiler = Qe, Te.isStrictMode = et, Te.isSuspense = st, Te.isValidElementType = y, Te.typeOf = E;
  }()), Te;
}
process.env.NODE_ENV === "production" ? Qu.exports = O5() : Qu.exports = D5();
var S5 = Qu.exports, Ph = S5, N5 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, T5 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Hh = {};
Hh[Ph.ForwardRef] = N5;
Hh[Ph.Memo] = T5;
var R5 = !0;
function L5(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : r += i + " ";
  }), r;
}
var Oh = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  R5 === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, F5 = function(t, n, r) {
  Oh(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var o = n;
    do
      t.insert(n === o ? "." + i : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function Q5(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var X5 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, V5 = !1, k5 = /[A-Z]|^ms/g, M5 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Dh = function(t) {
  return t.charCodeAt(1) === 45;
}, lf = function(t) {
  return t != null && typeof t != "boolean";
}, Bc = /* @__PURE__ */ y5(function(e) {
  return Dh(e) ? e : e.replace(k5, "-$&").toLowerCase();
}), df = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(M5, function(r, i, o) {
          return an = {
            name: i,
            styles: o,
            next: an
          }, i;
        });
  }
  return X5[t] !== 1 && !Dh(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, z5 = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Co(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return an = {
          name: i.name,
          styles: i.styles,
          next: an
        }, i.name;
      var o = n;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            an = {
              name: s.name,
              styles: s.styles,
              next: an
            }, s = s.next;
        var a = o.styles + ";";
        return a;
      }
      return j5(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = an, u = n(e);
        return an = c, Co(e, t, u);
      }
      break;
    }
  }
  var l = n;
  return l;
}
function j5(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += Co(e, t, n[i]) + ";";
  else
    for (var o in n) {
      var s = n[o];
      if (typeof s != "object") {
        var a = s;
        lf(a) && (r += Bc(o) + ":" + df(o, a) + ";");
      } else {
        if (o === "NO_COMPONENT_SELECTOR" && V5)
          throw new Error(z5);
        if (Array.isArray(s) && typeof s[0] == "string" && t == null)
          for (var c = 0; c < s.length; c++)
            lf(s[c]) && (r += Bc(o) + ":" + df(o, s[c]) + ";");
        else {
          var u = Co(e, t, s);
          switch (o) {
            case "animation":
            case "animationName": {
              r += Bc(o) + ":" + u + ";";
              break;
            }
            default:
              r += o + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var Af = /label:\s*([^\s;\n{]+)\s*(;|$)/g, an;
function Sh(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  an = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    r = !1, i += Co(n, t, o);
  else {
    var s = o;
    i += s[0];
  }
  for (var a = 1; a < e.length; a++)
    if (i += Co(n, t, e[a]), r) {
      var c = o;
      i += c[a];
    }
  Af.lastIndex = 0;
  for (var u = "", l; (l = Af.exec(i)) !== null; )
    u += "-" + l[1];
  var d = Q5(i) + u;
  return {
    name: d,
    styles: i,
    next: an
  };
}
var W5 = function(t) {
  return t();
}, Z5 = w.useInsertionEffect ? w.useInsertionEffect : !1, G5 = Z5 || W5, q5 = !1, Nh = /* @__PURE__ */ w.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ H5({
    key: "css"
  }) : null
);
Nh.Provider;
var Y5 = function(t) {
  return /* @__PURE__ */ Nt(function(n, r) {
    var i = Oa(Nh);
    return t(n, i, r);
  });
}, U5 = /* @__PURE__ */ w.createContext({}), yd = {}.hasOwnProperty, Xu = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", J5 = function(t, n) {
  var r = {};
  for (var i in n)
    yd.call(n, i) && (r[i] = n[i]);
  return r[Xu] = t, r;
}, K5 = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return Oh(n, r, i), G5(function() {
    return F5(n, r, i);
  }), null;
}, _5 = /* @__PURE__ */ Y5(
  /* <any, any> */
  function(e, t, n) {
    var r = e.css;
    typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
    var i = e[Xu], o = [r], s = "";
    typeof e.className == "string" ? s = L5(t.registered, o, e.className) : e.className != null && (s = e.className + " ");
    var a = Sh(o, void 0, w.useContext(U5));
    s += t.key + "-" + a.name;
    var c = {};
    for (var u in e)
      yd.call(e, u) && u !== "css" && u !== Xu && !q5 && (c[u] = e[u]);
    return c.className = s, n && (c.ref = n), /* @__PURE__ */ w.createElement(w.Fragment, null, /* @__PURE__ */ w.createElement(K5, {
      cache: t,
      serialized: a,
      isStringTag: typeof i == "string"
    }), /* @__PURE__ */ w.createElement(i, c));
  }
), $5 = _5, le = function(t, n) {
  var r = arguments;
  if (n == null || !yd.call(n, "css"))
    return w.createElement.apply(void 0, r);
  var i = r.length, o = new Array(i);
  o[0] = $5, o[1] = J5(t, n);
  for (var s = 2; s < i; s++)
    o[s] = r[s];
  return w.createElement.apply(null, o);
};
function Cd() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Sh(t);
}
var e8 = function() {
  var t = Cd.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function t8(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
var Vu = Kn, n8 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], aa = function() {
};
function r8(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function i8(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var o = [].concat(r);
  if (t && e)
    for (var s in t)
      t.hasOwnProperty(s) && t[s] && o.push("".concat(r8(e, s)));
  return o.filter(function(a) {
    return a;
  }).map(function(a) {
    return String(a).trim();
  }).join(" ");
}
var ff = function(t) {
  return f8(t) ? t.filter(Boolean) : Cr(t) === "object" && t !== null ? [t] : [];
}, Th = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Bn(t, n8);
  return de({}, n);
}, Ze = function(t, n, r) {
  var i = t.cx, o = t.getStyles, s = t.getClassNames, a = t.className;
  return {
    css: o(n, t),
    className: i(r ?? {}, s(n, t), a)
  };
};
function Za(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function o8(e) {
  return Za(e) ? window.innerHeight : e.clientHeight;
}
function Rh(e) {
  return Za(e) ? window.pageYOffset : e.scrollTop;
}
function ca(e, t) {
  if (Za(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function s8(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var i = e; i = i.parentElement; )
    if (t = getComputedStyle(i), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return i;
  return document.documentElement;
}
function a8(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function Cs(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : aa, i = Rh(e), o = t - i, s = 10, a = 0;
  function c() {
    a += s;
    var u = a8(a, i, o, n);
    ca(e, u), a < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function gf(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = t.offsetHeight / 3;
  r.bottom + i > n.bottom ? ca(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + i, e.scrollHeight)) : r.top - i < n.top && ca(e, Math.max(t.offsetTop - i, 0));
}
function c8(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function hf() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function u8() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var Lh = !1, l8 = {
  get passive() {
    return Lh = !0;
  }
}, Is = typeof window < "u" ? window : {};
Is.addEventListener && Is.removeEventListener && (Is.addEventListener("p", aa, l8), Is.removeEventListener("p", aa, !1));
var d8 = Lh;
function A8(e) {
  return e != null;
}
function f8(e) {
  return Array.isArray(e);
}
function Es(e, t, n) {
  return e ? t : n;
}
var g8 = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  var o = Object.entries(t).filter(function(s) {
    var a = Cn(s, 1), c = a[0];
    return !r.includes(c);
  });
  return o.reduce(function(s, a) {
    var c = Cn(a, 2), u = c[0], l = c[1];
    return s[u] = l, s;
  }, {});
}, h8 = ["children", "innerProps"], p8 = ["children", "innerProps"];
function m8(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, i = e.placement, o = e.shouldScroll, s = e.isFixedPosition, a = e.controlHeight, c = s8(n), u = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent) return u;
  var l = c.getBoundingClientRect(), d = l.height, f = n.getBoundingClientRect(), h = f.bottom, g = f.height, m = f.top, p = n.offsetParent.getBoundingClientRect(), v = p.top, b = s ? window.innerHeight : o8(c), y = Rh(c), E = parseInt(getComputedStyle(n).marginBottom, 10), C = parseInt(getComputedStyle(n).marginTop, 10), B = v - C, I = b - m, x = B + y, O = d - y - m, k = h - b + y + E, Q = y + m - C, F = 160;
  switch (i) {
    case "auto":
    case "bottom":
      if (I >= g)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (O >= g && !s)
        return o && Cs(c, k, F), {
          placement: "bottom",
          maxHeight: t
        };
      if (!s && O >= r || s && I >= r) {
        o && Cs(c, k, F);
        var M = s ? I - E : O - E;
        return {
          placement: "bottom",
          maxHeight: M
        };
      }
      if (i === "auto" || s) {
        var H = t, T = s ? B : x;
        return T >= r && (H = Math.min(T - E - a, t)), {
          placement: "top",
          maxHeight: H
        };
      }
      if (i === "bottom")
        return o && ca(c, k), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (B >= g)
        return {
          placement: "top",
          maxHeight: t
        };
      if (x >= g && !s)
        return o && Cs(c, Q, F), {
          placement: "top",
          maxHeight: t
        };
      if (!s && x >= r || s && B >= r) {
        var R = t;
        return (!s && x >= r || s && B >= r) && (R = s ? B - C : x - C), o && Cs(c, Q, F), {
          placement: "top",
          maxHeight: R
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(i, '".'));
  }
  return u;
}
function v8(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var Fh = function(t) {
  return t === "auto" ? "bottom" : t;
}, b8 = function(t, n) {
  var r, i = t.placement, o = t.theme, s = o.borderRadius, a = o.spacing, c = o.colors;
  return de((r = {
    label: "menu"
  }, oo(r, v8(i), "100%"), oo(r, "position", "absolute"), oo(r, "width", "100%"), oo(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: s,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: a.menuGutter,
    marginTop: a.menuGutter
  });
}, Qh = /* @__PURE__ */ Ml(null), y8 = function(t) {
  var n = t.children, r = t.minMenuHeight, i = t.maxMenuHeight, o = t.menuPlacement, s = t.menuPosition, a = t.menuShouldScrollIntoView, c = t.theme, u = Oa(Qh) || {}, l = u.setPortalPlacement, d = Ce(null), f = q(i), h = Cn(f, 2), g = h[0], m = h[1], p = q(null), v = Cn(p, 2), b = v[0], y = v[1], E = c.spacing.controlHeight;
  return Vu(function() {
    var C = d.current;
    if (C) {
      var B = s === "fixed", I = a && !B, x = m8({
        maxHeight: i,
        menuEl: C,
        minHeight: r,
        placement: o,
        shouldScroll: I,
        isFixedPosition: B,
        controlHeight: E
      });
      m(x.maxHeight), y(x.placement), l == null || l(x.placement);
    }
  }, [i, o, s, a, r, l, E]), n({
    ref: d,
    placerProps: de(de({}, t), {}, {
      placement: b || Fh(o),
      maxHeight: g
    })
  });
}, C8 = function(t) {
  var n = t.children, r = t.innerRef, i = t.innerProps;
  return le("div", fe({}, Ze(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, i), n);
}, I8 = C8, E8 = function(t, n) {
  var r = t.maxHeight, i = t.theme.spacing.baseUnit;
  return de({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: i,
    paddingTop: i
  });
}, x8 = function(t) {
  var n = t.children, r = t.innerProps, i = t.innerRef, o = t.isMulti;
  return le("div", fe({}, Ze(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": o
  }), {
    ref: i
  }, r), n);
}, Xh = function(t, n) {
  var r = t.theme, i = r.spacing.baseUnit, o = r.colors;
  return de({
    textAlign: "center"
  }, n ? {} : {
    color: o.neutral40,
    padding: "".concat(i * 2, "px ").concat(i * 3, "px")
  });
}, B8 = Xh, w8 = Xh, P8 = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, i = t.innerProps, o = Bn(t, h8);
  return le("div", fe({}, Ze(de(de({}, o), {}, {
    children: r,
    innerProps: i
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), i), r);
}, H8 = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, i = t.innerProps, o = Bn(t, p8);
  return le("div", fe({}, Ze(de(de({}, o), {}, {
    children: r,
    innerProps: i
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), i), r);
}, O8 = function(t) {
  var n = t.rect, r = t.offset, i = t.position;
  return {
    left: n.left,
    position: i,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, D8 = function(t) {
  var n = t.appendTo, r = t.children, i = t.controlElement, o = t.innerProps, s = t.menuPlacement, a = t.menuPosition, c = Ce(null), u = Ce(null), l = q(Fh(s)), d = Cn(l, 2), f = d[0], h = d[1], g = ve(function() {
    return {
      setPortalPlacement: h
    };
  }, []), m = q(null), p = Cn(m, 2), v = p[0], b = p[1], y = me(function() {
    if (i) {
      var I = c8(i), x = a === "fixed" ? 0 : window.pageYOffset, O = I[f] + x;
      (O !== (v == null ? void 0 : v.offset) || I.left !== (v == null ? void 0 : v.rect.left) || I.width !== (v == null ? void 0 : v.rect.width)) && b({
        offset: O,
        rect: I
      });
    }
  }, [i, a, f, v == null ? void 0 : v.offset, v == null ? void 0 : v.rect.left, v == null ? void 0 : v.rect.width]);
  Vu(function() {
    y();
  }, [y]);
  var E = me(function() {
    typeof u.current == "function" && (u.current(), u.current = null), i && c.current && (u.current = X0(i, c.current, y, {
      elementResize: "ResizeObserver" in window
    }));
  }, [i, y]);
  Vu(function() {
    E();
  }, [E]);
  var C = me(function(I) {
    c.current = I, E();
  }, [E]);
  if (!n && a !== "fixed" || !v) return null;
  var B = le("div", fe({
    ref: C
  }, Ze(de(de({}, t), {}, {
    offset: v.offset,
    position: a,
    rect: v.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), o), r);
  return le(Qh.Provider, {
    value: g
  }, n ? /* @__PURE__ */ E9(B, n) : B);
}, S8 = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, N8 = function(t) {
  var n = t.children, r = t.innerProps, i = t.isDisabled, o = t.isRtl;
  return le("div", fe({}, Ze(t, "container", {
    "--is-disabled": i,
    "--is-rtl": o
  }), r), n);
}, T8 = function(t, n) {
  var r = t.theme.spacing, i = t.isMulti, o = t.hasValue, s = t.selectProps.controlShouldRenderValue;
  return de({
    alignItems: "center",
    display: i && o && s ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, R8 = function(t) {
  var n = t.children, r = t.innerProps, i = t.isMulti, o = t.hasValue;
  return le("div", fe({}, Ze(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": i,
    "value-container--has-value": o
  }), r), n);
}, L8 = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, F8 = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", fe({}, Ze(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, pf, Q8 = ["size"], X8 = ["innerProps", "isRtl", "size"];
function V8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var k8 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: V8
}, Vh = function(t) {
  var n = t.size, r = Bn(t, Q8);
  return le("svg", fe({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: k8
  }, r));
}, Id = function(t) {
  return le(Vh, fe({
    size: 20
  }, t), le("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, kh = function(t) {
  return le(Vh, fe({
    size: 20
  }, t), le("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Mh = function(t, n) {
  var r = t.isFocused, i = t.theme, o = i.spacing.baseUnit, s = i.colors;
  return de({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: o * 2,
    ":hover": {
      color: r ? s.neutral80 : s.neutral40
    }
  });
}, M8 = Mh, z8 = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", fe({}, Ze(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || le(kh, null));
}, j8 = Mh, W8 = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", fe({}, Ze(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || le(Id, null));
}, Z8 = function(t, n) {
  var r = t.isDisabled, i = t.theme, o = i.spacing.baseUnit, s = i.colors;
  return de({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? s.neutral10 : s.neutral20,
    marginBottom: o * 2,
    marginTop: o * 2
  });
}, G8 = function(t) {
  var n = t.innerProps;
  return le("span", fe({}, n, Ze(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, q8 = e8(pf || (pf = t8([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Y8 = function(t, n) {
  var r = t.isFocused, i = t.size, o = t.theme, s = o.colors, a = o.spacing.baseUnit;
  return de({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: i,
    lineHeight: 1,
    marginRight: i,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: a * 2
  });
}, wc = function(t) {
  var n = t.delay, r = t.offset;
  return le("span", {
    css: /* @__PURE__ */ Cd({
      animation: "".concat(q8, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, U8 = function(t) {
  var n = t.innerProps, r = t.isRtl, i = t.size, o = i === void 0 ? 4 : i, s = Bn(t, X8);
  return le("div", fe({}, Ze(de(de({}, s), {}, {
    innerProps: n,
    isRtl: r,
    size: o
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), le(wc, {
    delay: 0,
    offset: r
  }), le(wc, {
    delay: 160,
    offset: !0
  }), le(wc, {
    delay: 320,
    offset: !r
  }));
}, J8 = function(t, n) {
  var r = t.isDisabled, i = t.isFocused, o = t.theme, s = o.colors, a = o.borderRadius, c = o.spacing;
  return de({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? s.neutral5 : s.neutral0,
    borderColor: r ? s.neutral10 : i ? s.primary : s.neutral20,
    borderRadius: a,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: i ? "0 0 0 1px ".concat(s.primary) : void 0,
    "&:hover": {
      borderColor: i ? s.primary : s.neutral30
    }
  });
}, K8 = function(t) {
  var n = t.children, r = t.isDisabled, i = t.isFocused, o = t.innerRef, s = t.innerProps, a = t.menuIsOpen;
  return le("div", fe({
    ref: o
  }, Ze(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": i,
    "control--menu-is-open": a
  }), s, {
    "aria-disabled": r || void 0
  }), n);
}, _8 = K8, $8 = ["data"], ey = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, ty = function(t) {
  var n = t.children, r = t.cx, i = t.getStyles, o = t.getClassNames, s = t.Heading, a = t.headingProps, c = t.innerProps, u = t.label, l = t.theme, d = t.selectProps;
  return le("div", fe({}, Ze(t, "group", {
    group: !0
  }), c), le(s, fe({}, a, {
    selectProps: d,
    theme: l,
    getStyles: i,
    getClassNames: o,
    cx: r
  }), u), le("div", null, n));
}, ny = function(t, n) {
  var r = t.theme, i = r.colors, o = r.spacing;
  return de({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: i.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: o.baseUnit * 3,
    paddingRight: o.baseUnit * 3,
    textTransform: "uppercase"
  });
}, ry = function(t) {
  var n = Th(t);
  n.data;
  var r = Bn(n, $8);
  return le("div", fe({}, Ze(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, iy = ty, oy = ["innerRef", "isDisabled", "isHidden", "inputClassName"], sy = function(t, n) {
  var r = t.isDisabled, i = t.value, o = t.theme, s = o.spacing, a = o.colors;
  return de(de({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: i ? "translateZ(0)" : ""
  }, ay), n ? {} : {
    margin: s.baseUnit / 2,
    paddingBottom: s.baseUnit / 2,
    paddingTop: s.baseUnit / 2,
    color: a.neutral80
  });
}, zh = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, ay = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": de({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, zh)
}, cy = function(t) {
  return de({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, zh);
}, uy = function(t) {
  var n = t.cx, r = t.value, i = Th(t), o = i.innerRef, s = i.isDisabled, a = i.isHidden, c = i.inputClassName, u = Bn(i, oy);
  return le("div", fe({}, Ze(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), le("input", fe({
    className: n({
      input: !0
    }, c),
    ref: o,
    style: cy(a),
    disabled: s
  }, u)));
}, ly = uy, dy = function(t, n) {
  var r = t.theme, i = r.spacing, o = r.borderRadius, s = r.colors;
  return de({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: s.neutral10,
    borderRadius: o / 2,
    margin: i.baseUnit / 2
  });
}, Ay = function(t, n) {
  var r = t.theme, i = r.borderRadius, o = r.colors, s = t.cropWithEllipsis;
  return de({
    overflow: "hidden",
    textOverflow: s || s === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: i / 2,
    color: o.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, fy = function(t, n) {
  var r = t.theme, i = r.spacing, o = r.borderRadius, s = r.colors, a = t.isFocused;
  return de({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: o / 2,
    backgroundColor: a ? s.dangerLight : void 0,
    paddingLeft: i.baseUnit,
    paddingRight: i.baseUnit,
    ":hover": {
      backgroundColor: s.dangerLight,
      color: s.danger
    }
  });
}, jh = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", r, n);
}, gy = jh, hy = jh;
function py(e) {
  var t = e.children, n = e.innerProps;
  return le("div", fe({
    role: "button"
  }, n), t || le(Id, {
    size: 14
  }));
}
var my = function(t) {
  var n = t.children, r = t.components, i = t.data, o = t.innerProps, s = t.isDisabled, a = t.removeProps, c = t.selectProps, u = r.Container, l = r.Label, d = r.Remove;
  return le(u, {
    data: i,
    innerProps: de(de({}, Ze(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": s
    })), o),
    selectProps: c
  }, le(l, {
    data: i,
    innerProps: de({}, Ze(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), le(d, {
    data: i,
    innerProps: de(de({}, Ze(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, a),
    selectProps: c
  }));
}, vy = my, by = function(t, n) {
  var r = t.isDisabled, i = t.isFocused, o = t.isSelected, s = t.theme, a = s.spacing, c = s.colors;
  return de({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: o ? c.primary : i ? c.primary25 : "transparent",
    color: r ? c.neutral20 : o ? c.neutral0 : "inherit",
    padding: "".concat(a.baseUnit * 2, "px ").concat(a.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : o ? c.primary : c.primary50
    }
  });
}, yy = function(t) {
  var n = t.children, r = t.isDisabled, i = t.isFocused, o = t.isSelected, s = t.innerRef, a = t.innerProps;
  return le("div", fe({}, Ze(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": i,
    "option--is-selected": o
  }), {
    ref: s,
    "aria-disabled": r
  }, a), n);
}, Cy = yy, Iy = function(t, n) {
  var r = t.theme, i = r.spacing, o = r.colors;
  return de({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: o.neutral50,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, Ey = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", fe({}, Ze(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, xy = Ey, By = function(t, n) {
  var r = t.isDisabled, i = t.theme, o = i.spacing, s = i.colors;
  return de({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? s.neutral40 : s.neutral80,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, wy = function(t) {
  var n = t.children, r = t.isDisabled, i = t.innerProps;
  return le("div", fe({}, Ze(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), i), n);
}, Py = wy, Ga = {
  ClearIndicator: W8,
  Control: _8,
  DropdownIndicator: z8,
  DownChevron: kh,
  CrossIcon: Id,
  Group: iy,
  GroupHeading: ry,
  IndicatorsContainer: F8,
  IndicatorSeparator: G8,
  Input: ly,
  LoadingIndicator: U8,
  Menu: I8,
  MenuList: x8,
  MenuPortal: D8,
  LoadingMessage: H8,
  NoOptionsMessage: P8,
  MultiValue: vy,
  MultiValueContainer: gy,
  MultiValueLabel: hy,
  MultiValueRemove: py,
  Option: Cy,
  Placeholder: xy,
  SelectContainer: N8,
  SingleValue: Py,
  ValueContainer: R8
}, Hy = function(t) {
  return de(de({}, Ga), t.components);
}, mf = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Oy(e, t) {
  return !!(e === t || mf(e) && mf(t));
}
function Dy(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Oy(e[n], t[n]))
      return !1;
  return !0;
}
function Sy(e, t) {
  t === void 0 && (t = Dy);
  var n = null;
  function r() {
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    if (n && n.lastThis === this && t(i, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, i);
    return n = {
      lastResult: s,
      lastArgs: i,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function Ny() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ty = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Ny
}, Ry = function(t) {
  return le("span", fe({
    css: Ty
  }, t));
}, vf = Ry, Ly = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, i = t.tabSelectsValue, o = t.context, s = t.isInitialFocus;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return s ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, i = r === void 0 ? "" : r, o = t.labels, s = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(i, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
      case "select-option":
        return s ? "option ".concat(i, " is disabled. Select another option.") : "option ".concat(i, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, i = t.options, o = t.label, s = o === void 0 ? "" : o, a = t.selectValue, c = t.isDisabled, u = t.isSelected, l = t.isAppleDevice, d = function(m, p) {
      return m && m.length ? "".concat(m.indexOf(p) + 1, " of ").concat(m.length) : "";
    };
    if (n === "value" && a)
      return "value ".concat(s, " focused, ").concat(d(a, r), ".");
    if (n === "menu" && l) {
      var f = c ? " disabled" : "", h = "".concat(u ? " selected" : "").concat(f);
      return "".concat(s).concat(h, ", ").concat(d(i, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, Fy = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, i = t.focusedValue, o = t.focusableOptions, s = t.isFocused, a = t.selectValue, c = t.selectProps, u = t.id, l = t.isAppleDevice, d = c.ariaLiveMessages, f = c.getOptionLabel, h = c.inputValue, g = c.isMulti, m = c.isOptionDisabled, p = c.isSearchable, v = c.menuIsOpen, b = c.options, y = c.screenReaderStatus, E = c.tabSelectsValue, C = c.isLoading, B = c["aria-label"], I = c["aria-live"], x = ve(function() {
    return de(de({}, Ly), d || {});
  }, [d]), O = ve(function() {
    var T = "";
    if (n && x.onChange) {
      var R = n.option, z = n.options, L = n.removedValue, X = n.removedValues, W = n.value, U = function(Pe) {
        return Array.isArray(Pe) ? null : Pe;
      }, ee = L || R || U(W), Ae = ee ? f(ee) : "", ne = z || X || void 0, K = ne ? ne.map(f) : [], ae = de({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ee && m(ee, a),
        label: Ae,
        labels: K
      }, n);
      T = x.onChange(ae);
    }
    return T;
  }, [n, x, m, a, f]), k = ve(function() {
    var T = "", R = r || i, z = !!(r && a && a.includes(r));
    if (R && x.onFocus) {
      var L = {
        focused: R,
        label: f(R),
        isDisabled: m(R, a),
        isSelected: z,
        options: o,
        context: R === r ? "menu" : "value",
        selectValue: a,
        isAppleDevice: l
      };
      T = x.onFocus(L);
    }
    return T;
  }, [r, i, f, m, x, o, a, l]), Q = ve(function() {
    var T = "";
    if (v && b.length && !C && x.onFilter) {
      var R = y({
        count: o.length
      });
      T = x.onFilter({
        inputValue: h,
        resultsMessage: R
      });
    }
    return T;
  }, [o, h, v, x, b, y, C]), F = (n == null ? void 0 : n.action) === "initial-input-focus", M = ve(function() {
    var T = "";
    if (x.guidance) {
      var R = i ? "value" : v ? "menu" : "input";
      T = x.guidance({
        "aria-label": B,
        context: R,
        isDisabled: r && m(r, a),
        isMulti: g,
        isSearchable: p,
        tabSelectsValue: E,
        isInitialFocus: F
      });
    }
    return T;
  }, [B, r, i, g, m, p, v, x, a, E, F]), H = le(mr, null, le("span", {
    id: "aria-selection"
  }, O), le("span", {
    id: "aria-focused"
  }, k), le("span", {
    id: "aria-results"
  }, Q), le("span", {
    id: "aria-guidance"
  }, M));
  return le(mr, null, le(vf, {
    id: u
  }, F && H), le(vf, {
    "aria-live": I,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, s && !F && H));
}, Qy = Fy, ku = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Xy = new RegExp("[" + ku.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), Wh = {};
for (var Pc = 0; Pc < ku.length; Pc++)
  for (var Hc = ku[Pc], Oc = 0; Oc < Hc.letters.length; Oc++)
    Wh[Hc.letters[Oc]] = Hc.base;
var Zh = function(t) {
  return t.replace(Xy, function(n) {
    return Wh[n];
  });
}, Vy = Sy(Zh), bf = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, ky = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, My = function(t) {
  return function(n, r) {
    if (n.data.__isNew__) return !0;
    var i = de({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: ky,
      trim: !0,
      matchFrom: "any"
    }, t), o = i.ignoreCase, s = i.ignoreAccents, a = i.stringify, c = i.trim, u = i.matchFrom, l = c ? bf(r) : r, d = c ? bf(a(n)) : a(n);
    return o && (l = l.toLowerCase(), d = d.toLowerCase()), s && (l = Vy(l), d = Zh(d)), u === "start" ? d.substr(0, l.length) === l : d.indexOf(l) > -1;
  };
}, zy = ["innerRef"];
function jy(e) {
  var t = e.innerRef, n = Bn(e, zy), r = g8(n, "onExited", "in", "enter", "exit", "appear");
  return le("input", fe({
    ref: t
  }, r, {
    css: /* @__PURE__ */ Cd({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Wy = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function Zy(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, i = e.onTopArrive, o = e.onTopLeave, s = Ce(!1), a = Ce(!1), c = Ce(0), u = Ce(null), l = me(function(p, v) {
    if (u.current !== null) {
      var b = u.current, y = b.scrollTop, E = b.scrollHeight, C = b.clientHeight, B = u.current, I = v > 0, x = E - C - y, O = !1;
      x > v && s.current && (r && r(p), s.current = !1), I && a.current && (o && o(p), a.current = !1), I && v > x ? (n && !s.current && n(p), B.scrollTop = E, O = !0, s.current = !0) : !I && -v > y && (i && !a.current && i(p), B.scrollTop = 0, O = !0, a.current = !0), O && Wy(p);
    }
  }, [n, r, i, o]), d = me(function(p) {
    l(p, p.deltaY);
  }, [l]), f = me(function(p) {
    c.current = p.changedTouches[0].clientY;
  }, []), h = me(function(p) {
    var v = c.current - p.changedTouches[0].clientY;
    l(p, v);
  }, [l]), g = me(function(p) {
    if (p) {
      var v = d8 ? {
        passive: !1
      } : !1;
      p.addEventListener("wheel", d, v), p.addEventListener("touchstart", f, v), p.addEventListener("touchmove", h, v);
    }
  }, [h, f, d]), m = me(function(p) {
    p && (p.removeEventListener("wheel", d, !1), p.removeEventListener("touchstart", f, !1), p.removeEventListener("touchmove", h, !1));
  }, [h, f, d]);
  return Ie(function() {
    if (t) {
      var p = u.current;
      return g(p), function() {
        m(p);
      };
    }
  }, [t, g, m]), function(p) {
    u.current = p;
  };
}
var yf = ["boxSizing", "height", "overflow", "paddingRight", "position"], Cf = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function If(e) {
  e.preventDefault();
}
function Ef(e) {
  e.stopPropagation();
}
function xf() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function Bf() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var wf = !!(typeof window < "u" && window.document && window.document.createElement), Ji = 0, kr = {
  capture: !1,
  passive: !1
};
function Gy(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, i = Ce({}), o = Ce(null), s = me(function(c) {
    if (wf) {
      var u = document.body, l = u && u.style;
      if (r && yf.forEach(function(g) {
        var m = l && l[g];
        i.current[g] = m;
      }), r && Ji < 1) {
        var d = parseInt(i.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, h = window.innerWidth - f + d || 0;
        Object.keys(Cf).forEach(function(g) {
          var m = Cf[g];
          l && (l[g] = m);
        }), l && (l.paddingRight = "".concat(h, "px"));
      }
      u && Bf() && (u.addEventListener("touchmove", If, kr), c && (c.addEventListener("touchstart", xf, kr), c.addEventListener("touchmove", Ef, kr))), Ji += 1;
    }
  }, [r]), a = me(function(c) {
    if (wf) {
      var u = document.body, l = u && u.style;
      Ji = Math.max(Ji - 1, 0), r && Ji < 1 && yf.forEach(function(d) {
        var f = i.current[d];
        l && (l[d] = f);
      }), u && Bf() && (u.removeEventListener("touchmove", If, kr), c && (c.removeEventListener("touchstart", xf, kr), c.removeEventListener("touchmove", Ef, kr)));
    }
  }, [r]);
  return Ie(function() {
    if (t) {
      var c = o.current;
      return s(c), function() {
        a(c);
      };
    }
  }, [t, s, a]), function(c) {
    o.current = c;
  };
}
function qy() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Yy = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, Uy = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: qy
};
function Jy(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, i = r === void 0 ? !0 : r, o = e.onBottomArrive, s = e.onBottomLeave, a = e.onTopArrive, c = e.onTopLeave, u = Zy({
    isEnabled: i,
    onBottomArrive: o,
    onBottomLeave: s,
    onTopArrive: a,
    onTopLeave: c
  }), l = Gy({
    isEnabled: n
  }), d = function(h) {
    u(h), l(h);
  };
  return le(mr, null, n && le("div", {
    onClick: Yy,
    css: Uy
  }), t(d));
}
function Ky() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _y = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Ky
}, $y = function(t) {
  var n = t.name, r = t.onFocus;
  return le("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: _y,
    value: "",
    onChange: function() {
    }
  });
}, eC = $y;
function Ed(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function tC() {
  return Ed(/^iPhone/i);
}
function Gh() {
  return Ed(/^Mac/i);
}
function nC() {
  return Ed(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Gh() && navigator.maxTouchPoints > 1;
}
function rC() {
  return tC() || nC();
}
function iC() {
  return Gh() || rC();
}
var oC = function(t) {
  return t.label;
}, sC = function(t) {
  return t.label;
}, aC = function(t) {
  return t.value;
}, cC = function(t) {
  return !!t.isDisabled;
}, uC = {
  clearIndicator: j8,
  container: S8,
  control: J8,
  dropdownIndicator: M8,
  group: ey,
  groupHeading: ny,
  indicatorsContainer: L8,
  indicatorSeparator: Z8,
  input: sy,
  loadingIndicator: Y8,
  loadingMessage: w8,
  menu: b8,
  menuList: E8,
  menuPortal: O8,
  multiValue: dy,
  multiValueLabel: Ay,
  multiValueRemove: fy,
  noOptionsMessage: B8,
  option: by,
  placeholder: Iy,
  singleValue: By,
  valueContainer: T8
}, lC = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, dC = 4, qh = 4, AC = 38, fC = qh * 2, gC = {
  baseUnit: qh,
  controlHeight: AC,
  menuGutter: fC
}, Dc = {
  borderRadius: dC,
  colors: lC,
  spacing: gC
}, hC = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: hf(),
  captureMenuScroll: !hf(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: My(),
  formatGroupLabel: oC,
  getOptionLabel: sC,
  getOptionValue: aC,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: cC,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !u8(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Pf(e, t, n, r) {
  var i = Jh(e, t, n), o = Kh(e, t, n), s = Uh(e, t), a = ua(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: i,
    isSelected: o,
    label: s,
    value: a,
    index: r
  };
}
function Ws(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var i = n.options.map(function(s, a) {
        return Pf(e, s, t, a);
      }).filter(function(s) {
        return Of(e, s);
      });
      return i.length > 0 ? {
        type: "group",
        data: n,
        options: i,
        index: r
      } : void 0;
    }
    var o = Pf(e, n, t, r);
    return Of(e, o) ? o : void 0;
  }).filter(A8);
}
function Yh(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, pd(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function Hf(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, pd(r.options.map(function(i) {
      return {
        data: i.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(i.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function pC(e, t) {
  return Yh(Ws(e, t));
}
function Of(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, i = t.data, o = t.isSelected, s = t.label, a = t.value;
  return (!$h(e) || !o) && _h(e, {
    label: s,
    value: a,
    data: i
  }, r);
}
function mC(e, t) {
  var n = e.focusedValue, r = e.selectValue, i = r.indexOf(n);
  if (i > -1) {
    var o = t.indexOf(n);
    if (o > -1)
      return n;
    if (i < t.length)
      return t[i];
  }
  return null;
}
function vC(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var Sc = function(t, n) {
  var r, i = (r = t.find(function(o) {
    return o.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return i || null;
}, Uh = function(t, n) {
  return t.getOptionLabel(n);
}, ua = function(t, n) {
  return t.getOptionValue(n);
};
function Jh(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Kh(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = ua(e, t);
  return n.some(function(i) {
    return ua(e, i) === r;
  });
}
function _h(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var $h = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, bC = 1, e3 = /* @__PURE__ */ function(e) {
  Z6(n, e);
  var t = Y6(n);
  function n(r) {
    var i;
    if (j6(this, n), i = t.call(this, r), i.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, i.blockOptionHover = !1, i.isComposing = !1, i.commonProps = void 0, i.initialTouchX = 0, i.initialTouchY = 0, i.openAfterFocus = !1, i.scrollToFocusedOptionOnUpdate = !1, i.userIsDragging = void 0, i.isAppleDevice = iC(), i.controlRef = null, i.getControlRef = function(c) {
      i.controlRef = c;
    }, i.focusedOptionRef = null, i.getFocusedOptionRef = function(c) {
      i.focusedOptionRef = c;
    }, i.menuListRef = null, i.getMenuListRef = function(c) {
      i.menuListRef = c;
    }, i.inputRef = null, i.getInputRef = function(c) {
      i.inputRef = c;
    }, i.focus = i.focusInput, i.blur = i.blurInput, i.onChange = function(c, u) {
      var l = i.props, d = l.onChange, f = l.name;
      u.name = f, i.ariaOnChange(c, u), d(c, u);
    }, i.setValue = function(c, u, l) {
      var d = i.props, f = d.closeMenuOnSelect, h = d.isMulti, g = d.inputValue;
      i.onInputChange("", {
        action: "set-value",
        prevInputValue: g
      }), f && (i.setState({
        inputIsHiddenAfterUpdate: !h
      }), i.onMenuClose()), i.setState({
        clearFocusValueOnUpdate: !0
      }), i.onChange(c, {
        action: u,
        option: l
      });
    }, i.selectOption = function(c) {
      var u = i.props, l = u.blurInputOnSelect, d = u.isMulti, f = u.name, h = i.state.selectValue, g = d && i.isOptionSelected(c, h), m = i.isOptionDisabled(c, h);
      if (g) {
        var p = i.getOptionValue(c);
        i.setValue(h.filter(function(v) {
          return i.getOptionValue(v) !== p;
        }), "deselect-option", c);
      } else if (!m)
        d ? i.setValue([].concat(pd(h), [c]), "select-option", c) : i.setValue(c, "select-option");
      else {
        i.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: f
        });
        return;
      }
      l && i.blurInput();
    }, i.removeValue = function(c) {
      var u = i.props.isMulti, l = i.state.selectValue, d = i.getOptionValue(c), f = l.filter(function(g) {
        return i.getOptionValue(g) !== d;
      }), h = Es(u, f, f[0] || null);
      i.onChange(h, {
        action: "remove-value",
        removedValue: c
      }), i.focusInput();
    }, i.clearValue = function() {
      var c = i.state.selectValue;
      i.onChange(Es(i.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, i.popValue = function() {
      var c = i.props.isMulti, u = i.state.selectValue, l = u[u.length - 1], d = u.slice(0, u.length - 1), f = Es(c, d, d[0] || null);
      i.onChange(f, {
        action: "pop-value",
        removedValue: l
      });
    }, i.getFocusedOptionId = function(c) {
      return Sc(i.state.focusableOptionsWithIds, c);
    }, i.getFocusableOptionsWithIds = function() {
      return Hf(Ws(i.props, i.state.selectValue), i.getElementId("option"));
    }, i.getValue = function() {
      return i.state.selectValue;
    }, i.cx = function() {
      for (var c = arguments.length, u = new Array(c), l = 0; l < c; l++)
        u[l] = arguments[l];
      return i8.apply(void 0, [i.props.classNamePrefix].concat(u));
    }, i.getOptionLabel = function(c) {
      return Uh(i.props, c);
    }, i.getOptionValue = function(c) {
      return ua(i.props, c);
    }, i.getStyles = function(c, u) {
      var l = i.props.unstyled, d = uC[c](u, l);
      d.boxSizing = "border-box";
      var f = i.props.styles[c];
      return f ? f(d, u) : d;
    }, i.getClassNames = function(c, u) {
      var l, d;
      return (l = (d = i.props.classNames)[c]) === null || l === void 0 ? void 0 : l.call(d, u);
    }, i.getElementId = function(c) {
      return "".concat(i.state.instancePrefix, "-").concat(c);
    }, i.getComponents = function() {
      return Hy(i.props);
    }, i.buildCategorizedOptions = function() {
      return Ws(i.props, i.state.selectValue);
    }, i.getCategorizedOptions = function() {
      return i.props.menuIsOpen ? i.buildCategorizedOptions() : [];
    }, i.buildFocusableOptions = function() {
      return Yh(i.buildCategorizedOptions());
    }, i.getFocusableOptions = function() {
      return i.props.menuIsOpen ? i.buildFocusableOptions() : [];
    }, i.ariaOnChange = function(c, u) {
      i.setState({
        ariaSelection: de({
          value: c
        }, u)
      });
    }, i.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), i.focusInput());
    }, i.onMenuMouseMove = function(c) {
      i.blockOptionHover = !1;
    }, i.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var u = i.props.openMenuOnClick;
        i.state.isFocused ? i.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && i.onMenuClose() : u && i.openMenu("first") : (u && (i.openAfterFocus = !0), i.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, i.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !i.props.isDisabled) {
        var u = i.props, l = u.isMulti, d = u.menuIsOpen;
        i.focusInput(), d ? (i.setState({
          inputIsHiddenAfterUpdate: !l
        }), i.onMenuClose()) : i.openMenu("first"), c.preventDefault();
      }
    }, i.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (i.clearValue(), c.preventDefault(), i.openAfterFocus = !1, c.type === "touchend" ? i.focusInput() : setTimeout(function() {
        return i.focusInput();
      }));
    }, i.onScroll = function(c) {
      typeof i.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && Za(c.target) && i.props.onMenuClose() : typeof i.props.closeMenuOnScroll == "function" && i.props.closeMenuOnScroll(c) && i.props.onMenuClose();
    }, i.onCompositionStart = function() {
      i.isComposing = !0;
    }, i.onCompositionEnd = function() {
      i.isComposing = !1;
    }, i.onTouchStart = function(c) {
      var u = c.touches, l = u && u.item(0);
      l && (i.initialTouchX = l.clientX, i.initialTouchY = l.clientY, i.userIsDragging = !1);
    }, i.onTouchMove = function(c) {
      var u = c.touches, l = u && u.item(0);
      if (l) {
        var d = Math.abs(l.clientX - i.initialTouchX), f = Math.abs(l.clientY - i.initialTouchY), h = 5;
        i.userIsDragging = d > h || f > h;
      }
    }, i.onTouchEnd = function(c) {
      i.userIsDragging || (i.controlRef && !i.controlRef.contains(c.target) && i.menuListRef && !i.menuListRef.contains(c.target) && i.blurInput(), i.initialTouchX = 0, i.initialTouchY = 0);
    }, i.onControlTouchEnd = function(c) {
      i.userIsDragging || i.onControlMouseDown(c);
    }, i.onClearIndicatorTouchEnd = function(c) {
      i.userIsDragging || i.onClearIndicatorMouseDown(c);
    }, i.onDropdownIndicatorTouchEnd = function(c) {
      i.userIsDragging || i.onDropdownIndicatorMouseDown(c);
    }, i.handleInputChange = function(c) {
      var u = i.props.inputValue, l = c.currentTarget.value;
      i.setState({
        inputIsHiddenAfterUpdate: !1
      }), i.onInputChange(l, {
        action: "input-change",
        prevInputValue: u
      }), i.props.menuIsOpen || i.onMenuOpen();
    }, i.onInputFocus = function(c) {
      i.props.onFocus && i.props.onFocus(c), i.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (i.openAfterFocus || i.props.openMenuOnFocus) && i.openMenu("first"), i.openAfterFocus = !1;
    }, i.onInputBlur = function(c) {
      var u = i.props.inputValue;
      if (i.menuListRef && i.menuListRef.contains(document.activeElement)) {
        i.inputRef.focus();
        return;
      }
      i.props.onBlur && i.props.onBlur(c), i.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), i.onMenuClose(), i.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, i.onOptionHover = function(c) {
      if (!(i.blockOptionHover || i.state.focusedOption === c)) {
        var u = i.getFocusableOptions(), l = u.indexOf(c);
        i.setState({
          focusedOption: c,
          focusedOptionId: l > -1 ? i.getFocusedOptionId(c) : null
        });
      }
    }, i.shouldHideSelectedOptions = function() {
      return $h(i.props);
    }, i.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), i.focus();
    }, i.onKeyDown = function(c) {
      var u = i.props, l = u.isMulti, d = u.backspaceRemovesValue, f = u.escapeClearsValue, h = u.inputValue, g = u.isClearable, m = u.isDisabled, p = u.menuIsOpen, v = u.onKeyDown, b = u.tabSelectsValue, y = u.openMenuOnFocus, E = i.state, C = E.focusedOption, B = E.focusedValue, I = E.selectValue;
      if (!m && !(typeof v == "function" && (v(c), c.defaultPrevented))) {
        switch (i.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!l || h) return;
            i.focusValue("previous");
            break;
          case "ArrowRight":
            if (!l || h) return;
            i.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (h) return;
            if (B)
              i.removeValue(B);
            else {
              if (!d) return;
              l ? i.popValue() : g && i.clearValue();
            }
            break;
          case "Tab":
            if (i.isComposing || c.shiftKey || !p || !b || !C || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            y && i.isOptionSelected(C, I))
              return;
            i.selectOption(C);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (p) {
              if (!C || i.isComposing) return;
              i.selectOption(C);
              break;
            }
            return;
          case "Escape":
            p ? (i.setState({
              inputIsHiddenAfterUpdate: !1
            }), i.onInputChange("", {
              action: "menu-close",
              prevInputValue: h
            }), i.onMenuClose()) : g && f && i.clearValue();
            break;
          case " ":
            if (h)
              return;
            if (!p) {
              i.openMenu("first");
              break;
            }
            if (!C) return;
            i.selectOption(C);
            break;
          case "ArrowUp":
            p ? i.focusOption("up") : i.openMenu("last");
            break;
          case "ArrowDown":
            p ? i.focusOption("down") : i.openMenu("first");
            break;
          case "PageUp":
            if (!p) return;
            i.focusOption("pageup");
            break;
          case "PageDown":
            if (!p) return;
            i.focusOption("pagedown");
            break;
          case "Home":
            if (!p) return;
            i.focusOption("first");
            break;
          case "End":
            if (!p) return;
            i.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, i.state.instancePrefix = "react-select-" + (i.props.instanceId || ++bC), i.state.selectValue = ff(r.value), r.menuIsOpen && i.state.selectValue.length) {
      var o = i.getFocusableOptionsWithIds(), s = i.buildFocusableOptions(), a = s.indexOf(i.state.selectValue[0]);
      i.state.focusableOptionsWithIds = o, i.state.focusedOption = s[a], i.state.focusedOptionId = Sc(o, s[a]);
    }
    return i;
  }
  return W6(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && gf(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var o = this.props, s = o.isDisabled, a = o.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !s && i.isDisabled || // ensure focus is on the Input when the menu opens
      c && a && !i.menuIsOpen) && this.focusInput(), c && s && !i.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !s && i.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (gf(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(i, o) {
      this.props.onInputChange(i, o);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(i) {
      var o = this, s = this.state, a = s.selectValue, c = s.isFocused, u = this.buildFocusableOptions(), l = i === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var d = u.indexOf(a[0]);
        d > -1 && (l = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[l],
        focusedOptionId: this.getFocusedOptionId(u[l])
      }, function() {
        return o.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(i) {
      var o = this.state, s = o.selectValue, a = o.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = s.indexOf(a);
        a || (c = -1);
        var u = s.length - 1, l = -1;
        if (s.length) {
          switch (i) {
            case "previous":
              c === 0 ? l = 0 : c === -1 ? l = u : l = c - 1;
              break;
            case "next":
              c > -1 && c < u && (l = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: l !== -1,
            focusedValue: s[l]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", o = this.props.pageSize, s = this.state.focusedOption, a = this.getFocusableOptions();
      if (a.length) {
        var c = 0, u = a.indexOf(s);
        s || (u = -1), i === "up" ? c = u > 0 ? u - 1 : a.length - 1 : i === "down" ? c = (u + 1) % a.length : i === "pageup" ? (c = u - o, c < 0 && (c = 0)) : i === "pagedown" ? (c = u + o, c > a.length - 1 && (c = a.length - 1)) : i === "last" && (c = a.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: a[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(a[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Dc) : de(de({}, Dc), this.props.theme) : Dc;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var i = this.clearValue, o = this.cx, s = this.getStyles, a = this.getClassNames, c = this.getValue, u = this.selectOption, l = this.setValue, d = this.props, f = d.isMulti, h = d.isRtl, g = d.options, m = this.hasValue();
      return {
        clearValue: i,
        cx: o,
        getStyles: s,
        getClassNames: a,
        getValue: c,
        hasValue: m,
        isMulti: f,
        isRtl: h,
        options: g,
        selectOption: u,
        selectProps: d,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var i = this.state.selectValue;
      return i.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var i = this.props, o = i.isClearable, s = i.isMulti;
      return o === void 0 ? s : o;
    }
  }, {
    key: "isOptionDisabled",
    value: function(i, o) {
      return Jh(this.props, i, o);
    }
  }, {
    key: "isOptionSelected",
    value: function(i, o) {
      return Kh(this.props, i, o);
    }
  }, {
    key: "filterOption",
    value: function(i, o) {
      return _h(this.props, i, o);
    }
  }, {
    key: "formatOptionLabel",
    value: function(i, o) {
      if (typeof this.props.formatOptionLabel == "function") {
        var s = this.props.inputValue, a = this.state.selectValue;
        return this.props.formatOptionLabel(i, {
          context: o,
          inputValue: s,
          selectValue: a
        });
      } else
        return this.getOptionLabel(i);
    }
  }, {
    key: "formatGroupLabel",
    value: function(i) {
      return this.props.formatGroupLabel(i);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var i = this.props, o = i.isDisabled, s = i.isSearchable, a = i.inputId, c = i.inputValue, u = i.tabIndex, l = i.form, d = i.menuIsOpen, f = i.required, h = this.getComponents(), g = h.Input, m = this.state, p = m.inputIsHidden, v = m.ariaSelection, b = this.commonProps, y = a || this.getElementId("input"), E = de(de(de({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": f,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, d && {
          "aria-controls": this.getElementId("listbox")
        }), !s && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return s ? /* @__PURE__ */ w.createElement(g, fe({}, b, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: y,
          innerRef: this.getInputRef,
          isDisabled: o,
          isHidden: p,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: l,
          type: "text",
          value: c
        }, E)) : /* @__PURE__ */ w.createElement(jy, fe({
          id: y,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: aa,
          onFocus: this.onInputFocus,
          disabled: o,
          tabIndex: u,
          inputMode: "none",
          form: l,
          value: ""
        }, E));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var i = this, o = this.getComponents(), s = o.MultiValue, a = o.MultiValueContainer, c = o.MultiValueLabel, u = o.MultiValueRemove, l = o.SingleValue, d = o.Placeholder, f = this.commonProps, h = this.props, g = h.controlShouldRenderValue, m = h.isDisabled, p = h.isMulti, v = h.inputValue, b = h.placeholder, y = this.state, E = y.selectValue, C = y.focusedValue, B = y.isFocused;
      if (!this.hasValue() || !g)
        return v ? null : /* @__PURE__ */ w.createElement(d, fe({}, f, {
          key: "placeholder",
          isDisabled: m,
          isFocused: B,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), b);
      if (p)
        return E.map(function(x, O) {
          var k = x === C, Q = "".concat(i.getOptionLabel(x), "-").concat(i.getOptionValue(x));
          return /* @__PURE__ */ w.createElement(s, fe({}, f, {
            components: {
              Container: a,
              Label: c,
              Remove: u
            },
            isFocused: k,
            isDisabled: m,
            key: Q,
            index: O,
            removeProps: {
              onClick: function() {
                return i.removeValue(x);
              },
              onTouchEnd: function() {
                return i.removeValue(x);
              },
              onMouseDown: function(M) {
                M.preventDefault();
              }
            },
            data: x
          }), i.formatOptionLabel(x, "value"));
        });
      if (v)
        return null;
      var I = E[0];
      return /* @__PURE__ */ w.createElement(l, fe({}, f, {
        data: I,
        isDisabled: m
      }), this.formatOptionLabel(I, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var i = this.getComponents(), o = i.ClearIndicator, s = this.commonProps, a = this.props, c = a.isDisabled, u = a.isLoading, l = this.state.isFocused;
      if (!this.isClearable() || !o || c || !this.hasValue() || u)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ w.createElement(o, fe({}, s, {
        innerProps: d,
        isFocused: l
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var i = this.getComponents(), o = i.LoadingIndicator, s = this.commonProps, a = this.props, c = a.isDisabled, u = a.isLoading, l = this.state.isFocused;
      if (!o || !u) return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ w.createElement(o, fe({}, s, {
        innerProps: d,
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var i = this.getComponents(), o = i.DropdownIndicator, s = i.IndicatorSeparator;
      if (!o || !s) return null;
      var a = this.commonProps, c = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ w.createElement(s, fe({}, a, {
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var i = this.getComponents(), o = i.DropdownIndicator;
      if (!o) return null;
      var s = this.commonProps, a = this.props.isDisabled, c = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ w.createElement(o, fe({}, s, {
        innerProps: u,
        isDisabled: a,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var i = this, o = this.getComponents(), s = o.Group, a = o.GroupHeading, c = o.Menu, u = o.MenuList, l = o.MenuPortal, d = o.LoadingMessage, f = o.NoOptionsMessage, h = o.Option, g = this.commonProps, m = this.state.focusedOption, p = this.props, v = p.captureMenuScroll, b = p.inputValue, y = p.isLoading, E = p.loadingMessage, C = p.minMenuHeight, B = p.maxMenuHeight, I = p.menuIsOpen, x = p.menuPlacement, O = p.menuPosition, k = p.menuPortalTarget, Q = p.menuShouldBlockScroll, F = p.menuShouldScrollIntoView, M = p.noOptionsMessage, H = p.onMenuScrollToTop, T = p.onMenuScrollToBottom;
      if (!I) return null;
      var R = function(Ae, ne) {
        var K = Ae.type, ae = Ae.data, pe = Ae.isDisabled, Pe = Ae.isSelected, Qe = Ae.label, et = Ae.value, st = m === ae, re = pe ? void 0 : function() {
          return i.onOptionHover(ae);
        }, Ge = pe ? void 0 : function() {
          return i.selectOption(ae);
        }, tt = "".concat(i.getElementId("option"), "-").concat(ne), at = {
          id: tt,
          onClick: Ge,
          onMouseMove: re,
          onMouseOver: re,
          tabIndex: -1,
          role: "option",
          "aria-selected": i.isAppleDevice ? void 0 : Pe
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ w.createElement(h, fe({}, g, {
          innerProps: at,
          data: ae,
          isDisabled: pe,
          isSelected: Pe,
          key: tt,
          label: Qe,
          type: K,
          value: et,
          isFocused: st,
          innerRef: st ? i.getFocusedOptionRef : void 0
        }), i.formatOptionLabel(Ae.data, "menu"));
      }, z;
      if (this.hasOptions())
        z = this.getCategorizedOptions().map(function(ee) {
          if (ee.type === "group") {
            var Ae = ee.data, ne = ee.options, K = ee.index, ae = "".concat(i.getElementId("group"), "-").concat(K), pe = "".concat(ae, "-heading");
            return /* @__PURE__ */ w.createElement(s, fe({}, g, {
              key: ae,
              data: Ae,
              options: ne,
              Heading: a,
              headingProps: {
                id: pe,
                data: ee.data
              },
              label: i.formatGroupLabel(ee.data)
            }), ee.options.map(function(Pe) {
              return R(Pe, "".concat(K, "-").concat(Pe.index));
            }));
          } else if (ee.type === "option")
            return R(ee, "".concat(ee.index));
        });
      else if (y) {
        var L = E({
          inputValue: b
        });
        if (L === null) return null;
        z = /* @__PURE__ */ w.createElement(d, g, L);
      } else {
        var X = M({
          inputValue: b
        });
        if (X === null) return null;
        z = /* @__PURE__ */ w.createElement(f, g, X);
      }
      var W = {
        minMenuHeight: C,
        maxMenuHeight: B,
        menuPlacement: x,
        menuPosition: O,
        menuShouldScrollIntoView: F
      }, U = /* @__PURE__ */ w.createElement(y8, fe({}, g, W), function(ee) {
        var Ae = ee.ref, ne = ee.placerProps, K = ne.placement, ae = ne.maxHeight;
        return /* @__PURE__ */ w.createElement(c, fe({}, g, W, {
          innerRef: Ae,
          innerProps: {
            onMouseDown: i.onMenuMouseDown,
            onMouseMove: i.onMenuMouseMove
          },
          isLoading: y,
          placement: K
        }), /* @__PURE__ */ w.createElement(Jy, {
          captureEnabled: v,
          onTopArrive: H,
          onBottomArrive: T,
          lockEnabled: Q
        }, function(pe) {
          return /* @__PURE__ */ w.createElement(u, fe({}, g, {
            innerRef: function(Qe) {
              i.getMenuListRef(Qe), pe(Qe);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": g.isMulti,
              id: i.getElementId("listbox")
            },
            isLoading: y,
            maxHeight: ae,
            focusedOption: m
          }), z);
        }));
      });
      return k || O === "fixed" ? /* @__PURE__ */ w.createElement(l, fe({}, g, {
        appendTo: k,
        controlElement: this.controlRef,
        menuPlacement: x,
        menuPosition: O
      }), U) : U;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var i = this, o = this.props, s = o.delimiter, a = o.isDisabled, c = o.isMulti, u = o.name, l = o.required, d = this.state.selectValue;
      if (l && !this.hasValue() && !a)
        return /* @__PURE__ */ w.createElement(eC, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || a))
        if (c)
          if (s) {
            var f = d.map(function(m) {
              return i.getOptionValue(m);
            }).join(s);
            return /* @__PURE__ */ w.createElement("input", {
              name: u,
              type: "hidden",
              value: f
            });
          } else {
            var h = d.length > 0 ? d.map(function(m, p) {
              return /* @__PURE__ */ w.createElement("input", {
                key: "i-".concat(p),
                name: u,
                type: "hidden",
                value: i.getOptionValue(m)
              });
            }) : /* @__PURE__ */ w.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ w.createElement("div", null, h);
          }
        else {
          var g = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ w.createElement("input", {
            name: u,
            type: "hidden",
            value: g
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var i = this.commonProps, o = this.state, s = o.ariaSelection, a = o.focusedOption, c = o.focusedValue, u = o.isFocused, l = o.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ w.createElement(Qy, fe({}, i, {
        id: this.getElementId("live-region"),
        ariaSelection: s,
        focusedOption: a,
        focusedValue: c,
        isFocused: u,
        selectValue: l,
        focusableOptions: d,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var i = this.getComponents(), o = i.Control, s = i.IndicatorsContainer, a = i.SelectContainer, c = i.ValueContainer, u = this.props, l = u.className, d = u.id, f = u.isDisabled, h = u.menuIsOpen, g = this.state.isFocused, m = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ w.createElement(a, fe({}, m, {
        className: l,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: g
      }), this.renderLiveRegion(), /* @__PURE__ */ w.createElement(o, fe({}, m, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: f,
        isFocused: g,
        menuIsOpen: h
      }), /* @__PURE__ */ w.createElement(c, fe({}, m, {
        isDisabled: f
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ w.createElement(s, fe({}, m, {
        isDisabled: f
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      var s = o.prevProps, a = o.clearFocusValueOnUpdate, c = o.inputIsHiddenAfterUpdate, u = o.ariaSelection, l = o.isFocused, d = o.prevWasFocused, f = o.instancePrefix, h = i.options, g = i.value, m = i.menuIsOpen, p = i.inputValue, v = i.isMulti, b = ff(g), y = {};
      if (s && (g !== s.value || h !== s.options || m !== s.menuIsOpen || p !== s.inputValue)) {
        var E = m ? pC(i, b) : [], C = m ? Hf(Ws(i, b), "".concat(f, "-option")) : [], B = a ? mC(o, b) : null, I = vC(o, E), x = Sc(C, I);
        y = {
          selectValue: b,
          focusedOption: I,
          focusedOptionId: x,
          focusableOptionsWithIds: C,
          focusedValue: B,
          clearFocusValueOnUpdate: !1
        };
      }
      var O = c != null && i !== s ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, k = u, Q = l && d;
      return l && !Q && (k = {
        value: Es(v, b, b[0] || null),
        options: b,
        action: "initial-input-focus"
      }, Q = !d), (u == null ? void 0 : u.action) === "initial-input-focus" && (k = null), de(de(de({}, y), O), {}, {
        prevProps: i,
        ariaSelection: k,
        prevWasFocused: Q
      });
    }
  }]), n;
}(I9);
e3.defaultProps = hC;
var yC = /* @__PURE__ */ Nt(function(e, t) {
  var n = z6(e);
  return /* @__PURE__ */ w.createElement(e3, fe({
    ref: t
  }, n));
}), CC = yC;
function IC(e) {
  return /* @__PURE__ */ A(Ga.DropdownIndicator, { ...e, children: /* @__PURE__ */ A(Y, { name: "ChevronDown", size: 16 }) });
}
function EC(e) {
  return /* @__PURE__ */ A(Ga.ClearIndicator, { ...e, children: /* @__PURE__ */ A(Y, { name: "Xmark", size: 16 }) });
}
function xC(e) {
  const { label: t, onClick: n, ...r } = e, i = !!t && !!n;
  return /* @__PURE__ */ D(Ga.MenuList, { ...r, children: [
    e.children,
    i && /* @__PURE__ */ A(
      "button",
      {
        onClick: n,
        className: "w-full px-2 py-3 hover:bg-slate-50",
        children: t
      }
    )
  ] });
}
function Mu(e) {
  const t = e["aria-invalid"] === "true", { addItemButtonProps: n, ...r } = e;
  return /* @__PURE__ */ A(
    CC,
    {
      ...r,
      components: {
        DropdownIndicator: IC,
        ClearIndicator: EC,
        MenuList: (i) => xC({ ...i, ...n })
      },
      styles: {
        dropdownIndicator: () => ({
          label: "indicatorContainer",
          display: "flex",
          transition: "color 150ms",
          color: "var(--gray-900)",
          padding: 8,
          boxSizing: "border-box"
        }),
        clearIndicator: (i) => ({
          ...i,
          color: "var(--gray-900)"
        }),
        container: (i) => ({
          ...i,
          borderColor: "var(--gray-200)",
          fontSize: 12
        }),
        placeholder: (i) => ({
          ...i,
          color: t ? "var(--red-800)" : "var(--gray-500)"
        }),
        control: () => ({
          label: "control",
          alignItems: "center",
          cursor: "default",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          minHeight: 32,
          outline: "0 !important",
          position: "relative",
          transition: "all 100ms",
          backgroundColor: "var(--white)",
          borderColor: t ? "var(--red-900)" : "var(--gray-200)",
          borderStyle: "solid",
          borderWidth: 1,
          borderRadius: "6px",
          boxSizing: "border-box"
        }),
        option: (i, o) => ({
          ...i,
          backgroundColor: o.isSelected ? "var(--slate-50)" : "var(--white)",
          color: "var(--gray-800)",
          ":hover": {
            backgroundColor: "var(--slate-50)"
          }
        }),
        menuList: (i) => ({
          ...i,
          padding: 0,
          borderRadius: "6px"
        })
      },
      theme: (i) => ({
        ...i,
        colors: {
          ...i.colors,
          primary: "var(--slate-100)",
          primary25: "var(--slate-50)",
          primary50: "var(--slate-100)",
          primary75: "var(--slate-100)",
          danger: "var(--red-900)",
          dangerLight: "var(--red-100)",
          neutral0: "var(--white)",
          neutral5: "var(--gray-50)",
          neutral10: "var(--gray-100)",
          neutral20: "var(--gray-200)",
          neutral30: "var(--gray-300)",
          neutral40: "var(--gray-400)",
          neutral50: "var(--gray-500)",
          neutral60: "var(--gray-600)",
          neutral70: "var(--gray-700)",
          neutral80: "var(--gray-800)",
          neutral90: "var(--gray-900)"
        }
      })
    }
  );
}
const QR = (e) => {
  const {
    children: t,
    cookies: n,
    submitLabel: r,
    rejectLabel: i,
    onSubmit: o = () => {
    },
    onReject: s = () => {
    },
    ...a
  } = e, [c, u] = q(n), l = (f) => {
    const { id: h, checked: g } = f.target;
    u(
      (m) => m.map(
        (p) => p.id === h ? { ...p, value: g } : p
      )
    );
  }, d = "min-w-64 h-8 text-base";
  return /* @__PURE__ */ D("div", { ...rt(a, "flex flex-col items-center"), children: [
    /* @__PURE__ */ A("div", { className: "text-center", children: t }),
    /* @__PURE__ */ A("div", { className: "my-8 flex gap-x-16 text-sm font-medium", children: c.map((f) => /* @__PURE__ */ D("div", { className: "cursor-pointer", children: [
      /* @__PURE__ */ A(
        "input",
        {
          type: "checkbox",
          id: f.id,
          checked: f.value,
          onChange: l,
          className: "mr-1 size-3 cursor-pointer rounded-sm border-2 border-gray-900 accent-gray-900 focus:outline-none"
        }
      ),
      /* @__PURE__ */ A(
        "label",
        {
          className: "cursor-pointer select-none",
          htmlFor: f.id,
          children: f.label
        }
      )
    ] }, f.id)) }),
    /* @__PURE__ */ D("div", { className: "flex gap-x-8", children: [
      /* @__PURE__ */ A(
        Et,
        {
          className: d,
          size: "small",
          color: "light",
          onClick: () => s(),
          children: i
        }
      ),
      /* @__PURE__ */ A(
        Et,
        {
          className: d,
          size: "small",
          onClick: () => o(c),
          children: r
        }
      )
    ] })
  ] });
}, t3 = Nt(function(t, n) {
  const { inputType: r = "datetime-local", ...i } = t;
  return /* @__PURE__ */ A(
    "input",
    {
      ...i,
      className: $(
        "h-8 w-full rounded-md bg-gray-100 px-3 disabled:bg-transparent disabled:p-0",
        t.className
      ),
      type: r,
      ref: n,
      step: t.step ?? "1"
    }
  );
});
function XR(e) {
  const { message: t = "Loading editor", ...n } = e;
  return /* @__PURE__ */ A("div", { className: "grid h-full place-items-center", ...n, children: /* @__PURE__ */ D("div", { className: "-mt-20 grid place-items-center", children: [
    /* @__PURE__ */ A("h3", { className: "mb-4 text-xl", children: t }),
    /* @__PURE__ */ A(ph, {})
  ] }) });
}
function Ei(e) {
  const { title: t, isOpen: n, onOpenChange: r, children: i, className: o, ...s } = e;
  return /* @__PURE__ */ D("div", { ...s, children: [
    /* @__PURE__ */ D(
      "div",
      {
        className: "flex cursor-pointer justify-between text-gray-500",
        onClick: r,
        children: [
          /* @__PURE__ */ A("h2", { className: " font-semibold text-gray-500", children: t }),
          /* @__PURE__ */ A(
            Y,
            {
              name: "ChevronDown",
              className: Or("transition", n ? "" : "-rotate-90")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ A(
      "div",
      {
        className: $(
          "max-h-0 overflow-hidden transition-[max-height] duration-300 ease-in-out",
          n && "max-h-screen",
          o
        ),
        children: i
      }
    )
  ] });
}
function Ct(e) {
  return /* @__PURE__ */ A(
    "div",
    {
      ...e,
      className: $("h-px bg-gray-200", e.className)
    }
  );
}
function VR(e) {
  const {
    driveNodes: t,
    selectedDriveNode: n,
    label: r,
    groupSharingType: i,
    className: o,
    disableAddDrives: s,
    isAllowedToCreateDocuments: a,
    showAddDriveModal: c
  } = e, u = t.length > 0, l = (n == null ? void 0 : n.sharingType) === i;
  function d() {
    c(i);
  }
  return /* @__PURE__ */ D(
    "div",
    {
      className: $(
        "border-y border-gray-100 pl-4 pr-1 first-of-type:border-b-0 last-of-type:border-t-0",
        u && "pb-2",
        l && "bg-gray-100",
        o
      ),
      children: [
        /* @__PURE__ */ D(
          "div",
          {
            className: Or(
              "flex items-center justify-between py-1.5 pr-2"
            ),
            children: [
              /* @__PURE__ */ A("p", { className: "text-sm font-medium leading-6 text-gray-500", children: r }),
              /* @__PURE__ */ A("div", { className: "size-4 text-gray-600", children: !s && a && /* @__PURE__ */ A(
                "button",
                {
                  onClick: d,
                  className: $(
                    "mr-2 transition hover:text-gray-800"
                  ),
                  children: /* @__PURE__ */ A(Y, { name: "PlusCircle", size: 16 })
                }
              ) })
            ]
          }
        ),
        t.map((f) => /* @__PURE__ */ bi(
          bm,
          {
            ...e,
            key: f.id,
            uiNode: f
          }
        ))
      ]
    }
  );
}
function xd(e) {
  const { children: t, items: n, open: r, onItemClick: i, onOpenChange: o } = e;
  return /* @__PURE__ */ D(Yg, { open: r, onOpenChange: o, children: [
    /* @__PURE__ */ A(Ug, { asChild: !0, className: "outline-none", children: t }),
    /* @__PURE__ */ A(Jg, { className: "modal-shadow cursor-pointer rounded-2xl bg-white text-sm font-medium text-slate-200", children: n.map(({ id: s, label: a, icon: c, className: u }) => /* @__PURE__ */ D(
      Kg,
      {
        onClick: (l) => l.stopPropagation(),
        onSelect: () => i(s),
        className: $(
          "flex items-center px-5 py-2 outline-none first-of-type:rounded-t-2xl first-of-type:pt-3 last-of-type:rounded-b-2xl last-of-type:pb-3 hover:bg-slate-50",
          u
        ),
        children: [
          c && /* @__PURE__ */ A("span", { className: "mr-2 inline-block", children: c }),
          a
        ]
      },
      s
    )) })
  ] });
}
function BC(e) {
  const { onSwitchboardLinkClick: t, onExport: n, onClose: r, onShowRevisionHistory: i } = e;
  return /* @__PURE__ */ D("div", { className: "flex gap-x-2", children: [
    t && /* @__PURE__ */ A(
      "button",
      {
        className: "flex h-8 items-center gap-x-2 rounded border border-gray-200 px-3 text-sm font-semibold text-gray-900 active:opacity-50",
        onClick: t,
        children: /* @__PURE__ */ A(Y, { name: "Drive", size: 16 })
      }
    ),
    /* @__PURE__ */ D(
      "button",
      {
        className: "flex h-8 items-center gap-x-2 rounded border border-gray-200 px-3 text-sm font-semibold text-gray-900 active:opacity-50",
        onClick: n,
        children: [
          "Export ",
          /* @__PURE__ */ A(Y, { name: "Save", size: 16 })
        ]
      }
    ),
    /* @__PURE__ */ D(
      "button",
      {
        className: "flex h-8 items-center gap-x-2 whitespace-nowrap rounded border border-gray-200 px-3 text-sm font-semibold text-gray-900 active:opacity-50",
        onClick: i,
        children: [
          "Revision history ",
          /* @__PURE__ */ A(Y, { name: "History", size: 16 })
        ]
      }
    ),
    /* @__PURE__ */ A(
      "button",
      {
        className: "grid size-8 place-items-center rounded border border-gray-200 active:opacity-50",
        onClick: r,
        children: /* @__PURE__ */ A(Y, { name: "Xmark" })
      }
    )
  ] });
}
function kR(e) {
  const { canUndo: t, canRedo: n, undo: r, redo: i } = e, o = "w-8 h-8 tab-shadow rounded-lg flex justify-center items-center";
  return /* @__PURE__ */ D("div", { className: "flex gap-x-2 text-gray-500", children: [
    /* @__PURE__ */ A("button", { onClick: r, disabled: !t, className: o, children: /* @__PURE__ */ A(
      Y,
      {
        name: "RedoArrow",
        className: $(
          "scale-x-[-1]",
          t ? "active:opacity-50" : "text-gray-500"
        )
      }
    ) }),
    /* @__PURE__ */ A("button", { onClick: i, disabled: !n, className: o, children: /* @__PURE__ */ A(
      Y,
      {
        name: "RedoArrow",
        className: $(
          n ? "active:opacity-50" : "text-gray-500"
        )
      }
    ) })
  ] });
}
const wC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABUHSURBVHgBxZwLsBTVmcf/X8+VN+EiT+XhuGo2aojomhQxqIMpS+NuIrqP6K6bYGk2tSYG0FR2XUHErCVruQKL+EiZCDFiJXEX7pYmbtzIGETxfUW0QKIODwHFxyW85d4+Oaf7PL5zuufembkD+aihT5/uOX36N//v+06f7r6EP6EVJ5ZaC0BJyKJcPY0IRSGSMiDLEMnSWIf8VEjIZYSKiLEpAsqdQHulvdyBP5ERjqAxYOfK1amqCtRzF/geIrM1qVFgy3LZ1iWhHkmgRwTgiRNLCtp0+SnJQ7b6R6XM/17JFLQaHUBhl4KvyoKEuUQW2t5qL6/AYbbDBlCpTbrYdHlCM4Co1R0tBEa8mvWMk8sx4RdEsNRUlTLnHiVVub69XMFhsKYDdOAgwaE1OYSFYWDJpSB39EBu7n/hll5PHSThARasjitTVOT3l7z9cnkummxNBSjhTZPw5shmi7Z5MjjkPwPSUyLrQjfxMNwiSGi+amnUp//X5ISFaIBLRRLmvvVyeQmaZE0BKMEVZUMPSBgl06yDRRoSX0/3ybq0XwKFHRSBQ4tgS0Z5DmOyKd0u21xxVIyZzXDrXgP8s8+VposIN5NKDiamkYNj4ZFWG/l+a3F66gyVqf4LYemSl0FcJIQFl8KLDWBhFdohm53ZWzU2DDCJdTHmiIhm+BAMJArc1qjQKZCMAikPmKoRVXvrQeQq8yDGDrAsxD7AtBxhwdsvlmeiQWsIYOKyAsvl1yeScVHywVnXTY4Q6YORc2Hr2npLZtwShkSeSATC4YyLeByoXncxkEFk2+VgXHThkkoDLl03QA1vpUoURJE+ySirOk9xzKUpx61ZVyhIJHkQuZuqJBK6rQImAje2S8Fd29XJqorogymVNfVBrAtgCo9WqmIKL3BZVeetq2VkwVCQlREoMq33e0aszHOtiYt+8jBAhWYTe/sk6waiCCCm36ngqPog1gzQwiOpPA+OLEdGaRFz3Xx4PCM7pYKp1HUqPYbwABIx9yXBIp6D5bmyiDMqdBDjQIVyGUuIdSixJoAGnjyholEaX6ZgosB1o3xwFKgvyLpEbI2CXhJLHEaBxNwzqYuzEOOYqVDtGzMVxjrfGKCqKpYQqSaIEWowCW95Fp6BEMG6c7JNlQt6P7MtSrclLi6nE6hgv5fsg4L+jqxXZUSsrUj/OGY/1z5FkV2ioJfJp8DKsq92G+mP/nHVNlWf/N7ak5LDynM9JJarkUZPbAo97SDHefPlQaZaWBZi5OBBA9HwdC9kPwrWlUl/OHBK9nGx1Ko4InuC0OswY0sinbOMgiPdNUoUSHw/YmEiMvXwtqcKIZ2cvBgyGlHcr2Pbpv9DowCLE0rTqEDzDBCrpqRnBasOdyIFu18UGRWRU5RRjIWl2+LuTy6WGqWTBpEqJoAYcUjwIDmYsJA5MBY/0u08P6WlSa2ji7s6tlfWVGNEVeHJuBcJekUetdXGM+ZWVllWQRE7YXcmdpuOfSbj+jHRnJc7IWInZntKJqHoeEc6rhHLwKTSSZxJJN4QJzbZWCeRmNWpZWwSSrLsQAtOrxYPW1DFIhHNR3J5FsY3piymSB4bBw0chLPPOg1nTPhz9O3XhxEwJcr9CanbyhTenj37sXjpf+OTQ4cSiGd9fgK+PPlMuL3MWDGV0/4DB/Haho148vkXsGffXj0KIj3yidIkkp6xLqvziO1oScJsRScekKUpyLFcBRYnnjctEvJLHqCCVk7BuqyLaU6B5517Jq675nKMPXYkmm3b3/sQN9x6L9a/tdmq7ed334LiuGN6/O7Ojz7GLXf/CE+9+JJVoc3CcaDCrtgpUNcBXVdWXli1JGw3NwYOHXX88mRyINKQoDOelziy8M4563QsuG0mPjV4IJptGzZuxoybFmHT1vds/Jp6wdn46vlfqun7A/v3x0XnTMaGyia8s22bn0CY8atvMlNmqU1sHXn80o4dlQN8/8wwRmbdOfKrRZNVfXhhBjbwIgwaNBCzf3AlDof9pvwCrvnX+Xhv58cW3hD5I111+V+hXrt+2j9isOwrvGFNlQ/P3qCiDHgzwvY8gCpxCIqmgY3ziPgVhomDrmxATjn7LzBi2FA02+5/8FHMvX0J9u8/aBOQKvz9JedjZAPHGzd6FM4584wAlh4vGqje0IeVIaaHY8NAgVFJkSZ2bQuqAo/cuFDVTzj5BDTTPt61B9+/6R78ZNmvbGIwbnfMyGHSdSejUTv95M+4gTP5iqNwnUMkGdYCFXoApcvP8WZLzFDEDaRgxm1uKJLW9e/fF82yd7fvxLdm3IHVL6yzihP6o8qXfe08HN06GI1a3759sipzVyG+8uxHb0vv91izAE+Y8OWpiZ+DWKwjO96zv47nzuxXa5K99sY7Et5/JhCV2Ul4HfsGDuyHiy9oXH2pMSB2AK6uZAKX9a5eLMjW4pmlkmnJjgPlkOhinlEtnDxgTJF8iqq31var1bjz7l/ik85O3aZxXT3jIsufPnE8+vXtpdoNPDMzHWuIgtwO6dSP3o+SoWE6kFegY6XCstozUaAKjHLTtFB9/J8HzHNhf4qqEYvlWOu+pY/itgUP4+ChTjfvx5o0sy8D+/dDU0yryruE9JIGsi5slgIlk0wSBRa6CiWhrxPt/xk1umvY1AMI8D6N2e7d+/HDO36K3z2zlimZz/npjwa6sbI1GQD3OmxohQsDxZQjfVBBgeuSVWCSTPqopyywItlduW/QW+ea5sPc2oNGQKMAN23egauuvR1PrV5rE4R3RW/AmXOSi+0ffIjXN1bQNMvGOF9tvMzOU16klNQyBQhR8uIbBSCtm5opH/KP3gC/VWvW4erpd8ori/ft9wXC6RChs6+bPFDLux76H3R2daFhy4XmIJkZIG8aDb4iZSRMRBcpX5arRQNJwEH0lrYM+PdCeK9qs2WPPInvz74Xu3bvzWzz7nCw3ympo7T+pTfexG0/ehC9MUFk2xfEvEm7sCAmjrxYCCoqdjIGtkz0rgCtVIOPV4+AV+3w7rjrl/j58nL6LQ0m05Qncq1L5tpKkW3l1eg/oB+u/8bXexcPlSjs7QDtZZTGWLsMBvK2nzIOtkSISwhuS3o7BSuur9zFe7b9Bz7BTbc9gPLTa+3XzUjB3CziSYTv40HUJ6JO+OHH/z8ZwH/n7y5BvUb6ZJIZGdLnoUES+bNe4OdskomyGHLOFFTMNh1cjZCDJeC1WLPd8+P/lfBeZb1PzesomKsSm9tj8c9OnuoJ0vvbHsWCh3+Bek14xzbK0xXQs+A2HprhDmsg7dNpkfz2cSa25btnaMRKtYHcvuNDtP16dXdN6ZMSCLOw8NZFADWFsOSxx/EfDy5DXRY4WuIFduiia8mf3gobUOJTAFszDQumvibY+o1bsE/OpqTti7Af2eybLHkSEb4izfQ927bsiSew8BePoFajHtZtPUswTKDaRFHNYxe9QatdETnNU889ybGdH+4K9hWZss2I5h+/30FmP7KwXVZ29uPHHsM9y2t7qtdLXpSzkRc1ubzwpZJ2qxeAqrCivJZrFOjggf3zN4QuTH62s9nPYXX76T2ca6d2T9sKPPTEb9CTJfFcoAYTPKeFLl2MuvueV6S89Zp6gM+eUkShELnd7Xf9rGoDu0FFruwlErhEg6A/qrx4+XLs2ru3pr6xg+ZsABOKsEX+u0fezuihMW31RsdxY0bi3LM+h0wjXusBTA0ruSFJzm3tPl6fOAWB3Xv3ofzKy+jWRB0bhL/CH+qMEJ5E0BmzyO1ubQJM7Mbrr0Bx/Ci/X5R1W5ccmAsT/KGN3h6C5N3Z9sEH6M5E6L8ie07eehWlynEgKpnGUY2NSAabRHWQ0/apwQPwX/O+i/HjHESX1fTwxSQFDpXX6f2FFyOF7w5mN6oenTKJkq9zDYnMF7xt8kfoiMiPOtm93N5uK/9pRHXcoR0zahjuvWMGTigem361myTi3FX4617/3KrfA4ETx4xBjyZc/4UQOWDNueuye0jdLCuRPIlKoioDKQSVSVXcZepX4ohhQ7Bo3rUYlyiRfd9zYa0ssEELG9aAcn4yVjF62DCcftJJqNk8NxVGXeDwBNtH2HWpQFnaBPs9d5kE+zwJ4LZ4rfhHrsOtFcT7bp+B8WO1O+e4adIqy7xWjfZ4QaM6U/Y96ih899K/xrAhQ9CtGS8ywrNPq7p6DtSes7BfTp5oVYGi3bmpaZwPV2P4bsyVkVV9raYgLr71Wow9dgQ8ILnjUOEOz6pcMf3XR8K75eqrcfHkWm46ifQRGO51Go4IXNaCM8q022mTupSrcCUJDgw+/VCF6XHjetlZS2LivBnJMMdANLEuEx68ATZYf9O1McOH42ezZ+OiSZNQkwnvF0h1giDe6XoOlBiXKIrLEQooC/agtaPMoPkBAC6YZnRYt40ecTQWzb0WgwYNQHYyIRjSwJegWTv1+OPxkxtuwMnHHYeaLThP71npOAAJf7tNop0t7ZF6tzZJJFZ5bimCpc1Y8JfInFx9NvaYEbjsq1P8QTTC6SuwowqbwadOPhtLZ92YKLAu85TGFZcDlG83SpSeq9iZe1BtFopwH/fF2GalVKUxy1KiN+ysXWIf1WAK5M7KB9vKfeQ471/+4XL88J+uThJHXWbVB60XDSuEF/vwePwT/L4wRFfZ0jWAPPUJ/TRnEB89FfbOhh89xJ8kyJy0+6GOHT4M99/wA1xx4QVozKq4LnvtwT4XaFw65vtJcDHaVEvpkwmFQll0ig65V2t6I8lATGctoOvUP1L16h6xjo/pdFmMppl+cNKeqKdEOUAeOxYLr/sexo3qxQOcRiz8Ud7gI/g+sfE89kFLWTWVKFD5sgRR9lQlhK8+mHcrYg03tkpthgrflDfMvbEku2Qzv2HpjIl4cO6s3sFLLFSUr74MUGGgai8gscT8XQb3jLToWiigXmeI3Y0eQQmoZD1Wjz50yfVCGkRJKzRpP/LHaA3YiidWpQUb55z6lBdc9bWL8O1LL0bfPnXGu2oWumeiEe66sQ+ZxcNIRG2mGXvFXVn3dFlu7bBS1cozH6NAq77YV2dvFLhl+/to++3TqZaZqtXxBg3oj1u/8y1877K/aSI8MKXFDlwc1jl47LUwmX1X2Wlv//lAiIWerIOEwl03hksqqu7gwU/QqC1+aDkOdh4Cj3XKjj92FJbOvRF/OfmLaKbt239AOhwDZSAxcBaaVV7aLVk7l7flz/m0tCxIVGhUZ1/Uk7iY8ixEk5nlAV5+bQMasVfX/x6Pr3rOtmPi6Rknfxo//ffZOHFcDbMqddraDW+CP52PrtgNWUKIPBtL9RXQp8zb8gAmyUSp0LqQVpiBmUDsSg7iQ+zC7555CVu2vYd67fb7lmWGEn97fgl3/dtMDBnU/Kf93//oI/x2zXPMbWMNKU5AuriXgiPfI5eGL2VnZx2VCtX1sVWfeojHh5i4s4GIFOLu3Xtw5+KfoR57bOWzWPf7tyDMeFMmjeu+8XXM+vY0DOzXpOcAA5tz193Ys2dPCq+LuW1X8L6IXrIEUtnc/szNYXuZ90TUexBDR47dJdPsVHMrL505TtOjvZlO7k6deQ7nnU3v4o0Nb+PzZ5yKgQP6d3sihzo7cf2ti/CHPXuT744eMQyLZs3EV85ubrwztnn7DsxauAhPPvu8dV8LJ/aVp9yZ2PWwfvxj5h92bGkP26VqBzzus19aieTPmLD35PhrXeTXE7mnVtXEwJRzvoAJp5yE/v36InMDVi7Wrt+IR3690o73rrniUhwzcrjL5d7sM7LTW6EJXtQnL/9Tye2l19/AU8+/KG827XGZlg9VgqSRujRSj0tGG1ix5dVnch/AqQqw+JlJRdFSeAXe+3LuRRvz/hwxeHZ78Ois/wyeLrOHX/mNo+w0vgMogixtl0JvMdesZqAMlkFj9vpW5hLNJJHY254oUTplRPHplfY1lTxOVV937fhga8fQEeMPypO6kDuvvRFkzf30ZEbW5lQVB70e7u+mrvI/3mQFvHEYcy0wQMJC8IYe2kVF7IPMXGH42dbtL+J/3rx2TRlVrNv3hTt2blkzZPi4oRLYJDYRksIKtOs9+GCuX8mBhAfSLUU1gBYehwUfYsyXImd77C7LkFUdV6SnPKtkLNz62rPz0I31+Mb60DEnrEFX14VSiaMztyF4nMpVmwZLsDCI8qDpNhDnKM+dmHNJXzHeNLvNpExlQazjFwsu3jGQSFy3fcvaZ3t88LBHgElWHjZGvfY+VajnaIhlYmEgpSsOB5v6TsxNg7nt5jsBTAYqMwNitpnZktgHKgJImVgXM3B6jEdMsQ6eqEQRvtKxY2uPf8iRUKMlSSWilYKoGD6M7t5SB0sU5o/y8IQCbyl4UNW7JID5zfJEvSls+7vpdbNklQjjpKdScAUiV8HSQxS8KdWSRsMAsxAZHA4JDpzLzAygGUDaD3mwBFliOb1zedgC82Kl/i92MEUOUHuPJ2ZloZVXqB1ebhd7shQiVspJnaIB4D/VD6tMmNcFkB3OJJg4RL2bt0zKIoiqwluY+GshWfcH/IwtdCjmsQ42LJB6yuCQhLe+dnhhV2u2BGKBlstjT8wAMxEyT3XgEOGAg7LwyMXTrIkMQD549tQGwM/mPuh0sEDtUZe4pF54vLsN2fhTvqhmb6YjT3lAVoG6COS4M5CvwIyxoVGyDNxXr4ugPlScFXJMC1v29b25UmnsL//2CqCycadOmiZjx3zpj62+4hgNW+3q0/cv3C5uSTm9YyoUQUG4bYIr0HNlOHB6XR69Q84lzH339ecWoBfWa4DKdHKZL2dVpnpuag5RFaarznTFW81xYyZD302Z+my98BUr7/8UOunKRlw2tKYANJaoUYg5slhEbnwLfJR4tV+XZwYXH9mIMKl42Zl/Mb0ZLrP83C2vr1mCJllTARobe8qkm6WLfJM0SEFcZIE6e+iNCDZltMjVxmGyeuWuMgTKWDdgQaOxrpodFoDKlFt3FVBCokhRDORmi34crKU7ottVnnFl+4cNnLHDBpDbuAlfmIpOeSlI+CbDl6/E7nok9HYvDbNtMNCojIgWbl1XfRalWXZEABorFkutXYP3lRRMeabnikSZeZ2wlKqsO9NMK0JQG7WIcmH3gPLhUlueHVGAoSmgnYMOTJQTASU5YjxOzvkVpXJaVewUwStoClL6dx/UXyOP5AevikjeJTvCwEL7I6IVG2Tw6vcCAAAAAElFTkSuQmCC", n3 = "2.21.9";
let xs = {
  getDocsUrl: ({ docsBaseUrl: e, docsPath: t = "", docsSlug: n }) => t ? `${e ?? "https://viem.sh"}${t}${n ? `#${n}` : ""}` : void 0,
  version: n3
}, ie = class zu extends Error {
  constructor(t, n = {}) {
    var a;
    const r = (() => {
      var c;
      return n.cause instanceof zu ? n.cause.details : (c = n.cause) != null && c.message ? n.cause.message : n.details;
    })(), i = n.cause instanceof zu && n.cause.docsPath || n.docsPath, o = (a = xs.getDocsUrl) == null ? void 0 : a.call(xs, { ...n, docsPath: i }), s = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...o ? [`Docs: ${o}`] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${xs.version}`
    ].join(`
`);
    super(s, n.cause ? { cause: n.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.name = n.name ?? this.name, this.shortMessage = t, this.version = n3;
  }
  walk(t) {
    return r3(this, t);
  }
};
function r3(e, t) {
  return t != null && t(e) ? e : e && typeof e == "object" && "cause" in e ? r3(e.cause, t) : t ? null : e;
}
class PC extends ie {
  constructor({ max: t, min: n, signed: r, size: i, value: o }) {
    super(`Number "${o}" is not in safe ${i ? `${i * 8}-bit ${r ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${n} to ${t})` : `(above ${n})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class HC extends ie {
  constructor(t) {
    super(`Bytes value "${t}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
      name: "InvalidBytesBooleanError"
    });
  }
}
class OC extends ie {
  constructor({ givenSize: t, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${t} bytes.`, { name: "SizeOverflowError" });
  }
}
class i3 extends ie {
  constructor({ offset: t, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${r}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
class o3 extends ie {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (${t}) exceeds padding size (${n}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
class Df extends ie {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} is expected to be ${n} ${r} long, but is ${t} ${r} long.`, { name: "InvalidBytesLengthError" });
  }
}
function Fi(e, { dir: t, size: n = 32 } = {}) {
  return typeof e == "string" ? zn(e, { dir: t, size: n }) : DC(e, { dir: t, size: n });
}
function zn(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  const r = e.replace("0x", "");
  if (r.length > n * 2)
    throw new o3({
      size: Math.ceil(r.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${r[t === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function DC(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  if (e.length > n)
    throw new o3({
      size: e.length,
      targetSize: n,
      type: "bytes"
    });
  const r = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    const o = t === "right";
    r[o ? i : n - i - 1] = e[o ? i : e.length - i - 1];
  }
  return r;
}
function Qi(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function lt(e) {
  return Qi(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function Bd(e, { dir: t = "left" } = {}) {
  let n = typeof e == "string" ? e.replace("0x", "") : e, r = 0;
  for (let i = 0; i < n.length - 1 && n[t === "left" ? i : n.length - i - 1].toString() === "0"; i++)
    r++;
  return n = t === "left" ? n.slice(r) : n.slice(0, n.length - r), typeof e == "string" ? (n.length === 1 && t === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
const SC = /* @__PURE__ */ new TextEncoder();
function wd(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? TC(e, t) : typeof e == "boolean" ? NC(e, t) : Qi(e) ? Pd(e, t) : fr(e, t);
}
function NC(e, t = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(e), typeof t.size == "number" ? (hn(n, { size: t.size }), Fi(n, { size: t.size })) : n;
}
const mn = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function Sf(e) {
  if (e >= mn.zero && e <= mn.nine)
    return e - mn.zero;
  if (e >= mn.A && e <= mn.F)
    return e - (mn.A - 10);
  if (e >= mn.a && e <= mn.f)
    return e - (mn.a - 10);
}
function Pd(e, t = {}) {
  let n = e;
  t.size && (hn(n, { size: t.size }), n = Fi(n, { dir: "right", size: t.size }));
  let r = n.slice(2);
  r.length % 2 && (r = `0${r}`);
  const i = r.length / 2, o = new Uint8Array(i);
  for (let s = 0, a = 0; s < i; s++) {
    const c = Sf(r.charCodeAt(a++)), u = Sf(r.charCodeAt(a++));
    if (c === void 0 || u === void 0)
      throw new ie(`Invalid byte sequence ("${r[a - 2]}${r[a - 1]}" in "${r}").`);
    o[s] = c * 16 + u;
  }
  return o;
}
function TC(e, t) {
  const n = je(e, t);
  return Pd(n);
}
function fr(e, t = {}) {
  const n = SC.encode(e);
  return typeof t.size == "number" ? (hn(n, { size: t.size }), Fi(n, { dir: "right", size: t.size })) : n;
}
function hn(e, { size: t }) {
  if (lt(e) > t)
    throw new OC({
      givenSize: lt(e),
      maxSize: t
    });
}
function s3(e, t = {}) {
  const { signed: n } = t;
  t.size && hn(e, { size: t.size });
  const r = BigInt(e);
  if (!n)
    return r;
  const i = (e.length - 2) / 2, o = (1n << BigInt(i) * 8n - 1n) - 1n;
  return r <= o ? r : r - BigInt(`0x${"f".padStart(i * 2, "f")}`) - 1n;
}
function RC(e, t = {}) {
  return Number(s3(e, t));
}
const LC = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Hd(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? je(e, t) : typeof e == "string" ? Od(e, t) : typeof e == "boolean" ? a3(e, t) : Vt(e, t);
}
function a3(e, t = {}) {
  const n = `0x${Number(e)}`;
  return typeof t.size == "number" ? (hn(n, { size: t.size }), Fi(n, { size: t.size })) : n;
}
function Vt(e, t = {}) {
  let n = "";
  for (let i = 0; i < e.length; i++)
    n += LC[e[i]];
  const r = `0x${n}`;
  return typeof t.size == "number" ? (hn(r, { size: t.size }), Fi(r, { dir: "right", size: t.size })) : r;
}
function je(e, t = {}) {
  const { signed: n, size: r } = t, i = BigInt(e);
  let o;
  r ? n ? o = (1n << BigInt(r) * 8n - 1n) - 1n : o = 2n ** (BigInt(r) * 8n) - 1n : typeof e == "number" && (o = BigInt(Number.MAX_SAFE_INTEGER));
  const s = typeof o == "bigint" && n ? -o - 1n : 0;
  if (o && i > o || i < s) {
    const c = typeof e == "bigint" ? "n" : "";
    throw new PC({
      max: o ? `${o}${c}` : void 0,
      min: `${s}${c}`,
      signed: n,
      size: r,
      value: `${e}${c}`
    });
  }
  const a = `0x${(n && i < 0 ? (1n << BigInt(r * 8)) + BigInt(i) : i).toString(16)}`;
  return r ? Fi(a, { size: r }) : a;
}
const FC = /* @__PURE__ */ new TextEncoder();
function Od(e, t = {}) {
  const n = FC.encode(e);
  return Vt(n, t);
}
function xi(e, { includeName: t = !1 } = {}) {
  if (e.type !== "function" && e.type !== "event" && e.type !== "error")
    throw new YC(e.type);
  return `${e.name}(${Dd(e.inputs, { includeName: t })})`;
}
function Dd(e, { includeName: t = !1 } = {}) {
  return e ? e.map((n) => QC(n, { includeName: t })).join(t ? ", " : ",") : "";
}
function QC(e, { includeName: t }) {
  return e.type.startsWith("tuple") ? `(${Dd(e.components, { includeName: t })})${e.type.slice(5)}` : e.type + (t && e.name ? ` ${e.name}` : "");
}
class XC extends ie {
  constructor({ docsPath: t }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: t,
      name: "AbiConstructorNotFoundError"
    });
  }
}
class Nf extends ie {
  constructor({ docsPath: t }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: t,
      name: "AbiConstructorParamsNotFoundError"
    });
  }
}
class VC extends ie {
  constructor({ data: t, params: n, size: r }) {
    super([`Data size of ${r} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${Dd(n, { includeName: !0 })})`,
        `Data:   ${t} (${r} bytes)`
      ],
      name: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t, this.params = n, this.size = r;
  }
}
class Sd extends ie {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.', {
      name: "AbiDecodingZeroDataError"
    });
  }
}
class kC extends ie {
  constructor({ expectedLength: t, givenLength: n, type: r }) {
    super([
      `ABI encoding array length mismatch for type ${r}.`,
      `Expected length: ${t}`,
      `Given length: ${n}`
    ].join(`
`), { name: "AbiEncodingArrayLengthMismatchError" });
  }
}
class MC extends ie {
  constructor({ expectedSize: t, value: n }) {
    super(`Size of bytes "${n}" (bytes${lt(n)}) does not match expected size (bytes${t}).`, { name: "AbiEncodingBytesSizeMismatchError" });
  }
}
class zC extends ie {
  constructor({ expectedLength: t, givenLength: n }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${t}`,
      `Given length (values): ${n}`
    ].join(`
`), { name: "AbiEncodingLengthMismatchError" });
  }
}
class c3 extends ie {
  constructor(t, { docsPath: n }) {
    super([
      `Encoded error signature "${t}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${t}.`
    ].join(`
`), {
      docsPath: n,
      name: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = t;
  }
}
class la extends ie {
  constructor(t, { docsPath: n } = {}) {
    super([
      `Function ${t ? `"${t}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionNotFoundError"
    });
  }
}
class jC extends ie {
  constructor(t, { docsPath: n }) {
    super([
      `Function "${t}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class WC extends ie {
  constructor(t, n) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${t.type}\` in \`${xi(t.abiItem)}\`, and`,
        `\`${n.type}\` in \`${xi(n.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ],
      name: "AbiItemAmbiguityError"
    });
  }
}
class ZC extends ie {
  constructor(t, { docsPath: n }) {
    super([
      `Type "${t}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiEncodingType" });
  }
}
class GC extends ie {
  constructor(t, { docsPath: n }) {
    super([
      `Type "${t}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiDecodingType" });
  }
}
class qC extends ie {
  constructor(t) {
    super([`Value "${t}" is not a valid array.`].join(`
`), {
      name: "InvalidArrayError"
    });
  }
}
class YC extends ie {
  constructor(t) {
    super([
      `"${t}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`), { name: "InvalidDefinitionTypeError" });
  }
}
function Ir(e) {
  return typeof e[0] == "string" ? Nd(e) : UC(e);
}
function UC(e) {
  let t = 0;
  for (const i of e)
    t += i.length;
  const n = new Uint8Array(t);
  let r = 0;
  for (const i of e)
    n.set(i, r), r += i.length;
  return n;
}
function Nd(e) {
  return `0x${e.reduce((t, n) => t + n.replace("0x", ""), "")}`;
}
class Io extends ie {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class Td extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  get(t) {
    const n = super.get(t);
    return super.has(t) && n !== void 0 && (this.delete(t), super.set(t, n)), n;
  }
  set(t, n) {
    if (super.set(t, n), this.maxSize && this.size > this.maxSize) {
      const r = this.keys().next().value;
      r && this.delete(r);
    }
    return this;
  }
}
function Tf(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function JC(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function Rd(e, ...t) {
  if (!JC(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function Rf(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function KC(e, t) {
  Rd(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Bs = /* @__PURE__ */ BigInt(2 ** 32 - 1), Lf = /* @__PURE__ */ BigInt(32);
function _C(e, t = !1) {
  return t ? { h: Number(e & Bs), l: Number(e >> Lf & Bs) } : { h: Number(e >> Lf & Bs) | 0, l: Number(e & Bs) | 0 };
}
function $C(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: o, l: s } = _C(e[i], t);
    [n[i], r[i]] = [o, s];
  }
  return [n, r];
}
const eI = (e, t, n) => e << n | t >>> 32 - n, tI = (e, t, n) => t << n | e >>> 32 - n, nI = (e, t, n) => t << n - 32 | e >>> 64 - n, rI = (e, t, n) => e << n - 32 | t >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const iI = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), Ff = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, oI = (e) => e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
function Qf(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = oI(e[t]);
}
function sI(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function u3(e) {
  return typeof e == "string" && (e = sI(e)), Rd(e), e;
}
class aI {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function cI(e) {
  const t = (r) => e().update(u3(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
const l3 = [], d3 = [], A3 = [], uI = /* @__PURE__ */ BigInt(0), Ki = /* @__PURE__ */ BigInt(1), lI = /* @__PURE__ */ BigInt(2), dI = /* @__PURE__ */ BigInt(7), AI = /* @__PURE__ */ BigInt(256), fI = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = Ki, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], l3.push(2 * (5 * r + n)), d3.push((e + 1) * (e + 2) / 2 % 64);
  let i = uI;
  for (let o = 0; o < 7; o++)
    t = (t << Ki ^ (t >> dI) * fI) % AI, t & lI && (i ^= Ki << (Ki << /* @__PURE__ */ BigInt(o)) - Ki);
  A3.push(i);
}
const [gI, hI] = /* @__PURE__ */ $C(A3, !0), Xf = (e, t, n) => n > 32 ? nI(e, t, n) : eI(e, t, n), Vf = (e, t, n) => n > 32 ? rI(e, t, n) : tI(e, t, n);
function pI(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let s = 0; s < 10; s++)
      n[s] = e[s] ^ e[s + 10] ^ e[s + 20] ^ e[s + 30] ^ e[s + 40];
    for (let s = 0; s < 10; s += 2) {
      const a = (s + 8) % 10, c = (s + 2) % 10, u = n[c], l = n[c + 1], d = Xf(u, l, 1) ^ n[a], f = Vf(u, l, 1) ^ n[a + 1];
      for (let h = 0; h < 50; h += 10)
        e[s + h] ^= d, e[s + h + 1] ^= f;
    }
    let i = e[2], o = e[3];
    for (let s = 0; s < 24; s++) {
      const a = d3[s], c = Xf(i, o, a), u = Vf(i, o, a), l = l3[s];
      i = e[l], o = e[l + 1], e[l] = c, e[l + 1] = u;
    }
    for (let s = 0; s < 50; s += 10) {
      for (let a = 0; a < 10; a++)
        n[a] = e[s + a];
      for (let a = 0; a < 10; a++)
        e[s + a] ^= ~n[(a + 2) % 10] & n[(a + 4) % 10];
    }
    e[0] ^= gI[r], e[1] ^= hI[r];
  }
  n.fill(0);
}
class Ld extends aI {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, o = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Tf(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = iI(this.state);
  }
  keccak() {
    Ff || Qf(this.state32), pI(this.state32, this.rounds), Ff || Qf(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    Rf(this);
    const { blockLen: n, state: r } = this;
    t = u3(t);
    const i = t.length;
    for (let o = 0; o < i; ) {
      const s = Math.min(n - this.pos, i - o);
      for (let a = 0; a < s; a++)
        r[this.pos++] ^= t[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    Rf(this, !1), Rd(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, o = t.length; i < o; ) {
      this.posOut >= r && this.keccak();
      const s = Math.min(r - this.posOut, o - i);
      t.set(n.subarray(this.posOut, this.posOut + s), i), this.posOut += s, i += s;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return Tf(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (KC(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: o, enableXOF: s } = this;
    return t || (t = new Ld(n, r, i, s, o)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = o, t.suffix = r, t.outputLen = i, t.enableXOF = s, t.destroyed = this.destroyed, t;
  }
}
const mI = (e, t, n) => cI(() => new Ld(t, e, n)), vI = /* @__PURE__ */ mI(1, 136, 256 / 8);
function Bi(e, t) {
  const n = t || "hex", r = vI(Qi(e, { strict: !1 }) ? wd(e) : e);
  return n === "bytes" ? r : Hd(r);
}
const Nc = /* @__PURE__ */ new Td(8192);
function Fd(e, t) {
  if (Nc.has(`${e}.${t}`))
    return Nc.get(`${e}.${t}`);
  const n = e.substring(2).toLowerCase(), r = Bi(fr(n), "bytes"), i = n.split("");
  for (let s = 0; s < 40; s += 2)
    r[s >> 1] >> 4 >= 8 && i[s] && (i[s] = i[s].toUpperCase()), (r[s >> 1] & 15) >= 8 && i[s + 1] && (i[s + 1] = i[s + 1].toUpperCase());
  const o = `0x${i.join("")}`;
  return Nc.set(`${e}.${t}`, o), o;
}
function ws(e, t) {
  if (!Jn(e, { strict: !1 }))
    throw new Io({ address: e });
  return Fd(e, t);
}
const bI = /^0x[a-fA-F0-9]{40}$/, Tc = /* @__PURE__ */ new Td(8192);
function Jn(e, t) {
  const { strict: n = !0 } = t ?? {}, r = `${e}.${n}`;
  if (Tc.has(r))
    return Tc.get(r);
  const i = bI.test(e) ? e.toLowerCase() === e ? !0 : n ? Fd(e) === e : !0 : !1;
  return Tc.set(r, i), i;
}
function da(e, t, n, { strict: r } = {}) {
  return Qi(e, { strict: !1 }) ? yI(e, t, n, {
    strict: r
  }) : h3(e, t, n, {
    strict: r
  });
}
function f3(e, t) {
  if (typeof t == "number" && t > 0 && t > lt(e) - 1)
    throw new i3({
      offset: t,
      position: "start",
      size: lt(e)
    });
}
function g3(e, t, n) {
  if (typeof t == "number" && typeof n == "number" && lt(e) !== n - t)
    throw new i3({
      offset: n,
      position: "end",
      size: lt(e)
    });
}
function h3(e, t, n, { strict: r } = {}) {
  f3(e, t);
  const i = e.slice(t, n);
  return r && g3(i, t, n), i;
}
function yI(e, t, n, { strict: r } = {}) {
  f3(e, t);
  const i = `0x${e.replace("0x", "").slice((t ?? 0) * 2, (n ?? e.length) * 2)}`;
  return r && g3(i, t, n), i;
}
function p3(e, t) {
  if (e.length !== t.length)
    throw new zC({
      expectedLength: e.length,
      givenLength: t.length
    });
  const n = CI({
    params: e,
    values: t
  }), r = Xd(n);
  return r.length === 0 ? "0x" : r;
}
function CI({ params: e, values: t }) {
  const n = [];
  for (let r = 0; r < e.length; r++)
    n.push(Qd({ param: e[r], value: t[r] }));
  return n;
}
function Qd({ param: e, value: t }) {
  const n = Vd(e.type);
  if (n) {
    const [r, i] = n;
    return EI(t, { length: r, param: { ...e, type: i } });
  }
  if (e.type === "tuple")
    return HI(t, {
      param: e
    });
  if (e.type === "address")
    return II(t);
  if (e.type === "bool")
    return BI(t);
  if (e.type.startsWith("uint") || e.type.startsWith("int")) {
    const r = e.type.startsWith("int");
    return wI(t, { signed: r });
  }
  if (e.type.startsWith("bytes"))
    return xI(t, { param: e });
  if (e.type === "string")
    return PI(t);
  throw new ZC(e.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function Xd(e) {
  let t = 0;
  for (let o = 0; o < e.length; o++) {
    const { dynamic: s, encoded: a } = e[o];
    s ? t += 32 : t += lt(a);
  }
  const n = [], r = [];
  let i = 0;
  for (let o = 0; o < e.length; o++) {
    const { dynamic: s, encoded: a } = e[o];
    s ? (n.push(je(t + i, { size: 32 })), r.push(a), i += lt(a)) : n.push(a);
  }
  return Ir([...n, ...r]);
}
function II(e) {
  if (!Jn(e))
    throw new Io({ address: e });
  return { dynamic: !1, encoded: zn(e.toLowerCase()) };
}
function EI(e, { length: t, param: n }) {
  const r = t === null;
  if (!Array.isArray(e))
    throw new qC(e);
  if (!r && e.length !== t)
    throw new kC({
      expectedLength: t,
      givenLength: e.length,
      type: `${n.type}[${t}]`
    });
  let i = !1;
  const o = [];
  for (let s = 0; s < e.length; s++) {
    const a = Qd({ param: n, value: e[s] });
    a.dynamic && (i = !0), o.push(a);
  }
  if (r || i) {
    const s = Xd(o);
    if (r) {
      const a = je(o.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: o.length > 0 ? Ir([a, s]) : a
      };
    }
    if (i)
      return { dynamic: !0, encoded: s };
  }
  return {
    dynamic: !1,
    encoded: Ir(o.map(({ encoded: s }) => s))
  };
}
function xI(e, { param: t }) {
  const [, n] = t.type.split("bytes"), r = lt(e);
  if (!n) {
    let i = e;
    return r % 32 !== 0 && (i = zn(i, {
      dir: "right",
      size: Math.ceil((e.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: Ir([zn(je(r, { size: 32 })), i])
    };
  }
  if (r !== Number.parseInt(n))
    throw new MC({
      expectedSize: Number.parseInt(n),
      value: e
    });
  return { dynamic: !1, encoded: zn(e, { dir: "right" }) };
}
function BI(e) {
  if (typeof e != "boolean")
    throw new ie(`Invalid boolean value: "${e}" (type: ${typeof e}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: zn(a3(e)) };
}
function wI(e, { signed: t }) {
  return {
    dynamic: !1,
    encoded: je(e, {
      size: 32,
      signed: t
    })
  };
}
function PI(e) {
  const t = Od(e), n = Math.ceil(lt(t) / 32), r = [];
  for (let i = 0; i < n; i++)
    r.push(zn(da(t, i * 32, (i + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: Ir([
      zn(je(lt(t), { size: 32 })),
      ...r
    ])
  };
}
function HI(e, { param: t }) {
  let n = !1;
  const r = [];
  for (let i = 0; i < t.components.length; i++) {
    const o = t.components[i], s = Array.isArray(e) ? i : o.name, a = Qd({
      param: o,
      value: e[s]
    });
    r.push(a), a.dynamic && (n = !0);
  }
  return {
    dynamic: n,
    encoded: n ? Xd(r) : Ir(r.map(({ encoded: i }) => i))
  };
}
function Vd(e) {
  const t = e.match(/^(.*)\[(\d+)?\]$/);
  return t ? (
    // Return `null` if the array is dynamic.
    [t[2] ? Number(t[2]) : null, t[1]]
  ) : void 0;
}
const Rc = "/docs/contract/encodeDeployData";
function m3(e) {
  const { abi: t, args: n, bytecode: r } = e;
  if (!n || n.length === 0)
    return r;
  const i = t.find((s) => "type" in s && s.type === "constructor");
  if (!i)
    throw new XC({ docsPath: Rc });
  if (!("inputs" in i))
    throw new Nf({ docsPath: Rc });
  if (!i.inputs || i.inputs.length === 0)
    throw new Nf({ docsPath: Rc });
  const o = p3(i.inputs, n);
  return Nd([r, o]);
}
function qa(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
class kf extends ie {
  constructor({ offset: t }) {
    super(`Offset \`${t}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class OI extends ie {
  constructor({ length: t, position: n }) {
    super(`Position \`${n}\` is out of bounds (\`0 < position < ${t}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class DI extends ie {
  constructor({ count: t, limit: n }) {
    super(`Recursive read limit of \`${n}\` exceeded (recursive read count: \`${t}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const SI = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new DI({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new OI({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new kf({ offset: e });
    const t = this.position - e;
    this.assertPosition(t), this.position = t;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new kf({ offset: e });
    const t = this.position + e;
    this.assertPosition(t), this.position = t;
  },
  inspectByte(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectBytes(e, t) {
    const n = t ?? this.position;
    return this.assertPosition(n + e - 1), this.bytes.subarray(n, n + e);
  },
  inspectUint8(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectUint16(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 1), this.dataView.getUint16(t);
  },
  inspectUint24(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 2), (this.dataView.getUint16(t) << 8) + this.dataView.getUint8(t + 2);
  },
  inspectUint32(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 3), this.dataView.getUint32(t);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, t) {
    this.assertReadLimit(), this._touch();
    const n = this.inspectBytes(e);
    return this.position += t ?? e, n;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const t = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = t;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function NI(e, { recursiveReadLimit: t = 8192 } = {}) {
  const n = Object.create(SI);
  return n.bytes = e, n.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), n.positionReadCount = /* @__PURE__ */ new Map(), n.recursiveReadLimit = t, n;
}
class ju extends ie {
  constructor({ blockNumber: t, chain: n, contract: r }) {
    super(`Chain "${n.name}" does not support contract "${r.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...t && r.blockCreated && r.blockCreated > t ? [
          `- The contract "${r.name}" was not deployed until block ${r.blockCreated} (current block ${t}).`
        ] : [
          `- The chain does not have the contract "${r.name}" configured.`
        ]
      ],
      name: "ChainDoesNotSupportContract"
    });
  }
}
class v3 extends ie {
  constructor() {
    super("No chain was provided to the Client.", {
      name: "ClientChainNotConfiguredError"
    });
  }
}
const TI = {
  gwei: 9,
  wei: 18
}, RI = {
  ether: -9,
  wei: 9
};
function b3(e, t) {
  let n = e.toString();
  const r = n.startsWith("-");
  r && (n = n.slice(1)), n = n.padStart(t, "0");
  let [i, o] = [
    n.slice(0, n.length - t),
    n.slice(n.length - t)
  ];
  return o = o.replace(/(0+)$/, ""), `${r ? "-" : ""}${i || "0"}${o ? `.${o}` : ""}`;
}
function gr(e, t = "wei") {
  return b3(e, RI[t]);
}
class qr extends ie {
  constructor({ cause: t, message: n } = {}) {
    var i;
    const r = (i = n == null ? void 0 : n.replace("execution reverted: ", "")) == null ? void 0 : i.replace("execution reverted", "");
    super(`Execution reverted ${r ? `with reason: ${r}` : "for an unknown reason"}.`, {
      cause: t,
      name: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(qr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(qr, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class Aa extends ie {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${gr(n)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: t,
      name: "FeeCapTooHighError"
    });
  }
}
Object.defineProperty(Aa, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class Wu extends ie {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${gr(n)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: t,
      name: "FeeCapTooLowError"
    });
  }
}
Object.defineProperty(Wu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class Zu extends ie {
  constructor({ cause: t, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}is higher than the next one expected.`, { cause: t, name: "NonceTooHighError" });
  }
}
Object.defineProperty(Zu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class Gu extends ie {
  constructor({ cause: t, nonce: n } = {}) {
    super([
      `Nonce provided for the transaction ${n ? `(${n}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: t, name: "NonceTooLowError" });
  }
}
Object.defineProperty(Gu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class qu extends ie {
  constructor({ cause: t, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}exceeds the maximum allowed nonce.`, { cause: t, name: "NonceMaxValueError" });
  }
}
Object.defineProperty(qu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class Yu extends ie {
  constructor({ cause: t } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: t,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(Yu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds|exceeds transaction sender account balance/
});
class Uu extends ie {
  constructor({ cause: t, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: t,
      name: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(Uu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class Ju extends ie {
  constructor({ cause: t, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction is too low.`, {
      cause: t,
      name: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(Ju, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class Ku extends ie {
  constructor({ cause: t }) {
    super("The transaction type is not supported for this chain.", {
      cause: t,
      name: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(Ku, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class fa extends ie {
  constructor({ cause: t, maxPriorityFeePerGas: n, maxFeePerGas: r } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${n ? ` = ${gr(n)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${r ? ` = ${gr(r)} gwei` : ""}).`
    ].join(`
`), {
      cause: t,
      name: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(fa, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class y3 extends ie {
  constructor({ cause: t }) {
    super(`An error occurred while executing: ${t == null ? void 0 : t.shortMessage}`, {
      cause: t,
      name: "UnknownNodeError"
    });
  }
}
function LI(e, t = "wei") {
  return b3(e, TI[t]);
}
function C3(e) {
  const t = Object.entries(e).map(([r, i]) => i === void 0 || i === !1 ? null : [r, i]).filter(Boolean), n = t.reduce((r, [i]) => Math.max(r, i.length), 0);
  return t.map(([r, i]) => `  ${`${r}:`.padEnd(n + 1)}  ${i}`).join(`
`);
}
class FI extends ie {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`), { name: "FeeConflictError" });
  }
}
const jn = (e, t, n) => JSON.stringify(e, (r, i) => typeof i == "bigint" ? i.toString() : i, n), QI = (e) => e, kd = (e) => e;
class lo extends ie {
  constructor({ body: t, cause: n, details: r, headers: i, status: o, url: s }) {
    super("HTTP request failed.", {
      cause: n,
      details: r,
      metaMessages: [
        o && `Status: ${o}`,
        `URL: ${kd(s)}`,
        t && `Request body: ${jn(t)}`
      ].filter(Boolean),
      name: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = t, this.headers = i, this.status = o, this.url = s;
  }
}
class I3 extends ie {
  constructor({ body: t, error: n, url: r }) {
    super("RPC Request failed.", {
      cause: n,
      details: n.message,
      metaMessages: [`URL: ${kd(r)}`, `Request body: ${jn(t)}`],
      name: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = n.code;
  }
}
class Mf extends ie {
  constructor({ body: t, url: n }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${kd(n)}`, `Request body: ${jn(t)}`],
      name: "TimeoutError"
    });
  }
}
const XI = -1;
class Bt extends ie {
  constructor(t, { code: n, docsPath: r, metaMessages: i, name: o, shortMessage: s }) {
    super(s, {
      cause: t,
      docsPath: r,
      metaMessages: i || (t == null ? void 0 : t.metaMessages),
      name: o || "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = o || t.name, this.code = t instanceof I3 ? t.code : n ?? XI;
  }
}
class Xi extends Bt {
  constructor(t, n) {
    super(t, n), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = n.data;
  }
}
class Eo extends Bt {
  constructor(t) {
    super(t, {
      code: Eo.code,
      name: "ParseRpcError",
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    });
  }
}
Object.defineProperty(Eo, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class xo extends Bt {
  constructor(t) {
    super(t, {
      code: xo.code,
      name: "InvalidRequestRpcError",
      shortMessage: "JSON is not a valid request object."
    });
  }
}
Object.defineProperty(xo, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class Bo extends Bt {
  constructor(t, { method: n } = {}) {
    super(t, {
      code: Bo.code,
      name: "MethodNotFoundRpcError",
      shortMessage: `The method${n ? ` "${n}"` : ""} does not exist / is not available.`
    });
  }
}
Object.defineProperty(Bo, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class wo extends Bt {
  constructor(t) {
    super(t, {
      code: wo.code,
      name: "InvalidParamsRpcError",
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(wo, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class Er extends Bt {
  constructor(t) {
    super(t, {
      code: Er.code,
      name: "InternalRpcError",
      shortMessage: "An internal error was received."
    });
  }
}
Object.defineProperty(Er, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class Po extends Bt {
  constructor(t) {
    super(t, {
      code: Po.code,
      name: "InvalidInputRpcError",
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(Po, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class Ho extends Bt {
  constructor(t) {
    super(t, {
      code: Ho.code,
      name: "ResourceNotFoundRpcError",
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(Ho, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class Wn extends Bt {
  constructor(t) {
    super(t, {
      code: Wn.code,
      name: "ResourceUnavailableRpcError",
      shortMessage: "Requested resource not available."
    });
  }
}
Object.defineProperty(Wn, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class Oo extends Bt {
  constructor(t) {
    super(t, {
      code: Oo.code,
      name: "TransactionRejectedRpcError",
      shortMessage: "Transaction creation failed."
    });
  }
}
Object.defineProperty(Oo, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class Do extends Bt {
  constructor(t, { method: n } = {}) {
    super(t, {
      code: Do.code,
      name: "MethodNotSupportedRpcError",
      shortMessage: `Method${n ? ` "${n}"` : ""} is not implemented.`
    });
  }
}
Object.defineProperty(Do, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class wi extends Bt {
  constructor(t) {
    super(t, {
      code: wi.code,
      name: "LimitExceededRpcError",
      shortMessage: "Request exceeds defined limit."
    });
  }
}
Object.defineProperty(wi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class So extends Bt {
  constructor(t) {
    super(t, {
      code: So.code,
      name: "JsonRpcVersionUnsupportedError",
      shortMessage: "Version of JSON-RPC protocol is not supported."
    });
  }
}
Object.defineProperty(So, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class gt extends Xi {
  constructor(t) {
    super(t, {
      code: gt.code,
      name: "UserRejectedRequestError",
      shortMessage: "User rejected the request."
    });
  }
}
Object.defineProperty(gt, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class No extends Xi {
  constructor(t) {
    super(t, {
      code: No.code,
      name: "UnauthorizedProviderError",
      shortMessage: "The requested method and/or account has not been authorized by the user."
    });
  }
}
Object.defineProperty(No, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class To extends Xi {
  constructor(t, { method: n } = {}) {
    super(t, {
      code: To.code,
      name: "UnsupportedProviderMethodError",
      shortMessage: `The Provider does not support the requested method${n ? ` " ${n}"` : ""}.`
    });
  }
}
Object.defineProperty(To, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class Ro extends Xi {
  constructor(t) {
    super(t, {
      code: Ro.code,
      name: "ProviderDisconnectedError",
      shortMessage: "The Provider is disconnected from all chains."
    });
  }
}
Object.defineProperty(Ro, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class Lo extends Xi {
  constructor(t) {
    super(t, {
      code: Lo.code,
      name: "ChainDisconnectedError",
      shortMessage: "The Provider is not connected to the requested chain."
    });
  }
}
Object.defineProperty(Lo, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class xr extends Xi {
  constructor(t) {
    super(t, {
      code: xr.code,
      name: "SwitchChainError",
      shortMessage: "An error occurred when attempting to switch chain."
    });
  }
}
Object.defineProperty(xr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class VI extends Bt {
  constructor(t) {
    super(t, {
      name: "UnknownRpcError",
      shortMessage: "An unknown RPC error occurred."
    });
  }
}
function kI(e, t) {
  const n = (e.details || "").toLowerCase(), r = e instanceof ie ? e.walk((i) => i.code === qr.code) : e;
  return r instanceof ie ? new qr({
    cause: e,
    message: r.details
  }) : qr.nodeMessage.test(n) ? new qr({
    cause: e,
    message: e.details
  }) : Aa.nodeMessage.test(n) ? new Aa({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : Wu.nodeMessage.test(n) ? new Wu({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : Zu.nodeMessage.test(n) ? new Zu({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Gu.nodeMessage.test(n) ? new Gu({ cause: e, nonce: t == null ? void 0 : t.nonce }) : qu.nodeMessage.test(n) ? new qu({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Yu.nodeMessage.test(n) ? new Yu({ cause: e }) : Uu.nodeMessage.test(n) ? new Uu({ cause: e, gas: t == null ? void 0 : t.gas }) : Ju.nodeMessage.test(n) ? new Ju({ cause: e, gas: t == null ? void 0 : t.gas }) : Ku.nodeMessage.test(n) ? new Ku({ cause: e }) : fa.nodeMessage.test(n) ? new fa({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas,
    maxPriorityFeePerGas: t == null ? void 0 : t.maxPriorityFeePerGas
  }) : new y3({
    cause: e
  });
}
function MI(e, { format: t }) {
  if (!t)
    return {};
  const n = {};
  function r(o) {
    const s = Object.keys(o);
    for (const a of s)
      a in e && (n[a] = e[a]), o[a] && typeof o[a] == "object" && !Array.isArray(o[a]) && r(o[a]);
  }
  const i = t(e || {});
  return r(i), n;
}
const zI = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3",
  eip7702: "0x4"
};
function jI(e) {
  const t = {};
  return typeof e.authorizationList < "u" && (t.authorizationList = WI(e.authorizationList)), typeof e.accessList < "u" && (t.accessList = e.accessList), typeof e.blobVersionedHashes < "u" && (t.blobVersionedHashes = e.blobVersionedHashes), typeof e.blobs < "u" && (typeof e.blobs[0] != "string" ? t.blobs = e.blobs.map((n) => Vt(n)) : t.blobs = e.blobs), typeof e.data < "u" && (t.data = e.data), typeof e.from < "u" && (t.from = e.from), typeof e.gas < "u" && (t.gas = je(e.gas)), typeof e.gasPrice < "u" && (t.gasPrice = je(e.gasPrice)), typeof e.maxFeePerBlobGas < "u" && (t.maxFeePerBlobGas = je(e.maxFeePerBlobGas)), typeof e.maxFeePerGas < "u" && (t.maxFeePerGas = je(e.maxFeePerGas)), typeof e.maxPriorityFeePerGas < "u" && (t.maxPriorityFeePerGas = je(e.maxPriorityFeePerGas)), typeof e.nonce < "u" && (t.nonce = je(e.nonce)), typeof e.to < "u" && (t.to = e.to), typeof e.type < "u" && (t.type = zI[e.type]), typeof e.value < "u" && (t.value = je(e.value)), t;
}
function WI(e) {
  return e.map((t) => ({
    address: t.contractAddress,
    r: t.r,
    s: t.s,
    chainId: je(t.chainId),
    nonce: je(t.nonce),
    ...typeof t.yParity < "u" ? { yParity: je(t.yParity) } : {},
    ...typeof t.v < "u" && typeof t.yParity > "u" ? { v: je(t.v) } : {}
  }));
}
function Ya(e, t, n) {
  const r = e[t.name];
  if (typeof r == "function")
    return r;
  const i = e[n];
  return typeof i == "function" ? i : (o) => t(e, o);
}
const ZI = 2n ** 256n - 1n;
function GI(e) {
  const { account: t, gasPrice: n, maxFeePerGas: r, maxPriorityFeePerGas: i, to: o } = e, s = t ? qa(t) : void 0;
  if (s && !Jn(s.address))
    throw new Io({ address: s.address });
  if (o && !Jn(o))
    throw new Io({ address: o });
  if (typeof n < "u" && (typeof r < "u" || typeof i < "u"))
    throw new FI();
  if (r && r > ZI)
    throw new Aa({ maxFeePerGas: r });
  if (i && r && i > r)
    throw new fa({ maxFeePerGas: r, maxPriorityFeePerGas: i });
}
class qI extends ie {
  constructor({ address: t }) {
    super(`State for account "${t}" is set multiple times.`, {
      name: "AccountStateConflictError"
    });
  }
}
class YI extends ie {
  constructor() {
    super("state and stateDiff are set on the same account.", {
      name: "StateAssignmentConflictError"
    });
  }
}
function zf(e) {
  return e.reduce((t, { slot: n, value: r }) => `${t}        ${n}: ${r}
`, "");
}
function UI(e) {
  return e.reduce((t, { address: n, ...r }) => {
    let i = `${t}    ${n}:
`;
    return r.nonce && (i += `      nonce: ${r.nonce}
`), r.balance && (i += `      balance: ${r.balance}
`), r.code && (i += `      code: ${r.code}
`), r.state && (i += `      state:
`, i += zf(r.state)), r.stateDiff && (i += `      stateDiff:
`, i += zf(r.stateDiff)), i;
  }, `  State Override:
`).slice(0, -1);
}
function jf(e) {
  if (!(!e || e.length === 0))
    return e.reduce((t, { slot: n, value: r }) => {
      if (n.length !== 66)
        throw new Df({
          size: n.length,
          targetSize: 66,
          type: "hex"
        });
      if (r.length !== 66)
        throw new Df({
          size: r.length,
          targetSize: 66,
          type: "hex"
        });
      return t[n] = r, t;
    }, {});
}
function JI(e) {
  const { balance: t, nonce: n, state: r, stateDiff: i, code: o } = e, s = {};
  if (o !== void 0 && (s.code = o), t !== void 0 && (s.balance = je(t)), n !== void 0 && (s.nonce = je(n)), r !== void 0 && (s.state = jf(r)), i !== void 0) {
    if (s.state)
      throw new YI();
    s.stateDiff = jf(i);
  }
  return s;
}
function KI(e) {
  if (!e)
    return;
  const t = {};
  for (const { address: n, ...r } of e) {
    if (!Jn(n, { strict: !1 }))
      throw new Io({ address: n });
    if (t[n])
      throw new qI({ address: n });
    t[n] = JI(r);
  }
  return t;
}
const Wf = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], E3 = [
  {
    inputs: [],
    name: "ResolverNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverWildcardNotSupported",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverNotContract",
    type: "error"
  },
  {
    inputs: [
      {
        name: "returnData",
        type: "bytes"
      }
    ],
    name: "ResolverError",
    type: "error"
  },
  {
    inputs: [
      {
        components: [
          {
            name: "status",
            type: "uint16"
          },
          {
            name: "message",
            type: "string"
          }
        ],
        name: "errors",
        type: "tuple[]"
      }
    ],
    name: "HttpError",
    type: "error"
  }
], _I = [
  ...E3,
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  },
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" },
      { name: "gateways", type: "string[]" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  }
], $I = [
  ...E3,
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "bytes", name: "reverseName" }],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  },
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [
      { type: "bytes", name: "reverseName" },
      { type: "string[]", name: "gateways" }
    ],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  }
], Zf = [
  {
    name: "text",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "key", type: "string" }
    ],
    outputs: [{ name: "", type: "string" }]
  }
];
function eE(e, t = {}) {
  typeof t.size < "u" && hn(e, { size: t.size });
  const n = Vt(e, t);
  return s3(n, t);
}
function tE(e, t = {}) {
  let n = e;
  if (typeof t.size < "u" && (hn(n, { size: t.size }), n = Bd(n)), n.length > 1 || n[0] > 1)
    throw new HC(n);
  return !!n[0];
}
function In(e, t = {}) {
  typeof t.size < "u" && hn(e, { size: t.size });
  const n = Vt(e, t);
  return RC(n, t);
}
function nE(e, t = {}) {
  let n = e;
  return typeof t.size < "u" && (hn(n, { size: t.size }), n = Bd(n, { dir: "right" })), new TextDecoder().decode(n);
}
function x3(e, t) {
  const n = typeof t == "string" ? Pd(t) : t, r = NI(n);
  if (lt(n) === 0 && e.length > 0)
    throw new Sd();
  if (lt(t) && lt(t) < 32)
    throw new VC({
      data: typeof t == "string" ? t : Vt(t),
      params: e,
      size: lt(t)
    });
  let i = 0;
  const o = [];
  for (let s = 0; s < e.length; ++s) {
    const a = e[s];
    r.setPosition(i);
    const [c, u] = ni(r, a, {
      staticPosition: 0
    });
    i += u, o.push(c);
  }
  return o;
}
function ni(e, t, { staticPosition: n }) {
  const r = Vd(t.type);
  if (r) {
    const [i, o] = r;
    return iE(e, { ...t, type: o }, { length: i, staticPosition: n });
  }
  if (t.type === "tuple")
    return cE(e, t, { staticPosition: n });
  if (t.type === "address")
    return rE(e);
  if (t.type === "bool")
    return oE(e);
  if (t.type.startsWith("bytes"))
    return sE(e, t, { staticPosition: n });
  if (t.type.startsWith("uint") || t.type.startsWith("int"))
    return aE(e, t);
  if (t.type === "string")
    return uE(e, { staticPosition: n });
  throw new GC(t.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const Gf = 32, _u = 32;
function rE(e) {
  const t = e.readBytes(32);
  return [Fd(Vt(h3(t, -20))), 32];
}
function iE(e, t, { length: n, staticPosition: r }) {
  if (!n) {
    const s = In(e.readBytes(_u)), a = r + s, c = a + Gf;
    e.setPosition(a);
    const u = In(e.readBytes(Gf)), l = Fo(t);
    let d = 0;
    const f = [];
    for (let h = 0; h < u; ++h) {
      e.setPosition(c + (l ? h * 32 : d));
      const [g, m] = ni(e, t, {
        staticPosition: c
      });
      d += m, f.push(g);
    }
    return e.setPosition(r + 32), [f, 32];
  }
  if (Fo(t)) {
    const s = In(e.readBytes(_u)), a = r + s, c = [];
    for (let u = 0; u < n; ++u) {
      e.setPosition(a + u * 32);
      const [l] = ni(e, t, {
        staticPosition: a
      });
      c.push(l);
    }
    return e.setPosition(r + 32), [c, 32];
  }
  let i = 0;
  const o = [];
  for (let s = 0; s < n; ++s) {
    const [a, c] = ni(e, t, {
      staticPosition: r + i
    });
    i += c, o.push(a);
  }
  return [o, i];
}
function oE(e) {
  return [tE(e.readBytes(32), { size: 32 }), 32];
}
function sE(e, t, { staticPosition: n }) {
  const [r, i] = t.type.split("bytes");
  if (!i) {
    const s = In(e.readBytes(32));
    e.setPosition(n + s);
    const a = In(e.readBytes(32));
    if (a === 0)
      return e.setPosition(n + 32), ["0x", 32];
    const c = e.readBytes(a);
    return e.setPosition(n + 32), [Vt(c), 32];
  }
  return [Vt(e.readBytes(Number.parseInt(i), 32)), 32];
}
function aE(e, t) {
  const n = t.type.startsWith("int"), r = Number.parseInt(t.type.split("int")[1] || "256"), i = e.readBytes(32);
  return [
    r > 48 ? eE(i, { signed: n }) : In(i, { signed: n }),
    32
  ];
}
function cE(e, t, { staticPosition: n }) {
  const r = t.components.length === 0 || t.components.some(({ name: s }) => !s), i = r ? [] : {};
  let o = 0;
  if (Fo(t)) {
    const s = In(e.readBytes(_u)), a = n + s;
    for (let c = 0; c < t.components.length; ++c) {
      const u = t.components[c];
      e.setPosition(a + o);
      const [l, d] = ni(e, u, {
        staticPosition: a
      });
      o += d, i[r ? c : u == null ? void 0 : u.name] = l;
    }
    return e.setPosition(n + 32), [i, 32];
  }
  for (let s = 0; s < t.components.length; ++s) {
    const a = t.components[s], [c, u] = ni(e, a, {
      staticPosition: n
    });
    i[r ? s : a == null ? void 0 : a.name] = c, o += u;
  }
  return [i, o];
}
function uE(e, { staticPosition: t }) {
  const n = In(e.readBytes(32)), r = t + n;
  e.setPosition(r);
  const i = In(e.readBytes(32));
  if (i === 0)
    return e.setPosition(t + 32), ["", 32];
  const o = e.readBytes(i, 32), s = nE(Bd(o));
  return e.setPosition(t + 32), [s, 32];
}
function Fo(e) {
  var r;
  const { type: t } = e;
  if (t === "string" || t === "bytes" || t.endsWith("[]"))
    return !0;
  if (t === "tuple")
    return (r = e.components) == null ? void 0 : r.some(Fo);
  const n = Vd(e.type);
  return !!(n && Fo({ ...e, type: n[1] }));
}
const lE = (e) => Bi(wd(e));
function dE(e) {
  return lE(e);
}
const AE = "1.0.5";
let kt = class $u extends Error {
  constructor(t, n = {}) {
    var s;
    const r = n.cause instanceof $u ? n.cause.details : (s = n.cause) != null && s.message ? n.cause.message : n.details, i = n.cause instanceof $u && n.cause.docsPath || n.docsPath, o = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [`Docs: https://abitype.dev${i}`] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: abitype@${AE}`
    ].join(`
`);
    super(o), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiTypeError"
    }), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
};
function $n(e, t) {
  const n = e.exec(t);
  return n == null ? void 0 : n.groups;
}
const B3 = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, w3 = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/, P3 = /^\(.+?\).*?$/, qf = /^tuple(?<array>(\[(\d*)\])*)$/;
function el(e) {
  let t = e.type;
  if (qf.test(e.type) && "components" in e) {
    t = "(";
    const n = e.components.length;
    for (let i = 0; i < n; i++) {
      const o = e.components[i];
      t += el(o), i < n - 1 && (t += ", ");
    }
    const r = $n(qf, e.type);
    return t += `)${(r == null ? void 0 : r.array) ?? ""}`, el({
      ...e,
      type: t
    });
  }
  return "indexed" in e && e.indexed && (t = `${t} indexed`), e.name ? `${t} ${e.name}` : t;
}
function _i(e) {
  let t = "";
  const n = e.length;
  for (let r = 0; r < n; r++) {
    const i = e[r];
    t += el(i), r !== n - 1 && (t += ", ");
  }
  return t;
}
function fE(e) {
  return e.type === "function" ? `function ${e.name}(${_i(e.inputs)})${e.stateMutability && e.stateMutability !== "nonpayable" ? ` ${e.stateMutability}` : ""}${e.outputs.length ? ` returns (${_i(e.outputs)})` : ""}` : e.type === "event" ? `event ${e.name}(${_i(e.inputs)})` : e.type === "error" ? `error ${e.name}(${_i(e.inputs)})` : e.type === "constructor" ? `constructor(${_i(e.inputs)})${e.stateMutability === "payable" ? " payable" : ""}` : e.type === "fallback" ? "fallback()" : "receive() external payable";
}
const H3 = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function gE(e) {
  return H3.test(e);
}
function hE(e) {
  return $n(H3, e);
}
const O3 = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function pE(e) {
  return O3.test(e);
}
function mE(e) {
  return $n(O3, e);
}
const D3 = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function vE(e) {
  return D3.test(e);
}
function bE(e) {
  return $n(D3, e);
}
const S3 = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function N3(e) {
  return S3.test(e);
}
function yE(e) {
  return $n(S3, e);
}
const T3 = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function CE(e) {
  return T3.test(e);
}
function IE(e) {
  return $n(T3, e);
}
const EE = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function xE(e) {
  return EE.test(e);
}
const BE = /^receive\(\) external payable$/;
function wE(e) {
  return BE.test(e);
}
const PE = /* @__PURE__ */ new Set(["indexed"]), tl = /* @__PURE__ */ new Set([
  "calldata",
  "memory",
  "storage"
]);
class HE extends kt {
  constructor({ type: t }) {
    super("Unknown type.", {
      metaMessages: [
        `Type "${t}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownTypeError"
    });
  }
}
class OE extends kt {
  constructor({ type: t }) {
    super("Unknown type.", {
      metaMessages: [`Type "${t}" is not a valid ABI type.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSolidityTypeError"
    });
  }
}
class DE extends kt {
  constructor({ param: t }) {
    super("Invalid ABI parameter.", {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParameterError"
    });
  }
}
class SE extends kt {
  constructor({ param: t, name: n }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `"${n}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SolidityProtectedKeywordError"
    });
  }
}
class NE extends kt {
  constructor({ param: t, type: n, modifier: r }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `Modifier "${r}" not allowed${n ? ` in "${n}" type` : ""}.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidModifierError"
    });
  }
}
class TE extends kt {
  constructor({ param: t, type: n, modifier: r }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `Modifier "${r}" not allowed${n ? ` in "${n}" type` : ""}.`,
        `Data location can only be specified for array, struct, or mapping types, but "${r}" was given.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidFunctionModifierError"
    });
  }
}
class RE extends kt {
  constructor({ abiParameter: t }) {
    super("Invalid ABI parameter.", {
      details: JSON.stringify(t, null, 2),
      metaMessages: ["ABI parameter type is invalid."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiTypeParameterError"
    });
  }
}
class ao extends kt {
  constructor({ signature: t, type: n }) {
    super(`Invalid ${n} signature.`, {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSignatureError"
    });
  }
}
class LE extends kt {
  constructor({ signature: t }) {
    super("Unknown signature.", {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSignatureError"
    });
  }
}
class FE extends kt {
  constructor({ signature: t }) {
    super("Invalid struct signature.", {
      details: t,
      metaMessages: ["No properties exist."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStructSignatureError"
    });
  }
}
class QE extends kt {
  constructor({ type: t }) {
    super("Circular reference detected.", {
      metaMessages: [`Struct "${t}" is a circular reference.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CircularReferenceError"
    });
  }
}
class XE extends kt {
  constructor({ current: t, depth: n }) {
    super("Unbalanced parentheses.", {
      metaMessages: [
        `"${t.trim()}" has too many ${n > 0 ? "opening" : "closing"} parentheses.`
      ],
      details: `Depth "${n}"`
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParenthesisError"
    });
  }
}
function VE(e, t) {
  return t ? `${t}:${e}` : e;
}
const Lc = /* @__PURE__ */ new Map([
  // Unnamed
  ["address", { type: "address" }],
  ["bool", { type: "bool" }],
  ["bytes", { type: "bytes" }],
  ["bytes32", { type: "bytes32" }],
  ["int", { type: "int256" }],
  ["int256", { type: "int256" }],
  ["string", { type: "string" }],
  ["uint", { type: "uint256" }],
  ["uint8", { type: "uint8" }],
  ["uint16", { type: "uint16" }],
  ["uint24", { type: "uint24" }],
  ["uint32", { type: "uint32" }],
  ["uint64", { type: "uint64" }],
  ["uint96", { type: "uint96" }],
  ["uint112", { type: "uint112" }],
  ["uint160", { type: "uint160" }],
  ["uint192", { type: "uint192" }],
  ["uint256", { type: "uint256" }],
  // Named
  ["address owner", { type: "address", name: "owner" }],
  ["address to", { type: "address", name: "to" }],
  ["bool approved", { type: "bool", name: "approved" }],
  ["bytes _data", { type: "bytes", name: "_data" }],
  ["bytes data", { type: "bytes", name: "data" }],
  ["bytes signature", { type: "bytes", name: "signature" }],
  ["bytes32 hash", { type: "bytes32", name: "hash" }],
  ["bytes32 r", { type: "bytes32", name: "r" }],
  ["bytes32 root", { type: "bytes32", name: "root" }],
  ["bytes32 s", { type: "bytes32", name: "s" }],
  ["string name", { type: "string", name: "name" }],
  ["string symbol", { type: "string", name: "symbol" }],
  ["string tokenURI", { type: "string", name: "tokenURI" }],
  ["uint tokenId", { type: "uint256", name: "tokenId" }],
  ["uint8 v", { type: "uint8", name: "v" }],
  ["uint256 balance", { type: "uint256", name: "balance" }],
  ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
  ["uint256 value", { type: "uint256", name: "value" }],
  // Indexed
  [
    "event:address indexed from",
    { type: "address", name: "from", indexed: !0 }
  ],
  ["event:address indexed to", { type: "address", name: "to", indexed: !0 }],
  [
    "event:uint indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ],
  [
    "event:uint256 indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ]
]);
function kE(e, t = {}) {
  if (vE(e)) {
    const n = bE(e);
    if (!n)
      throw new ao({ signature: e, type: "function" });
    const r = Zt(n.parameters), i = [], o = r.length;
    for (let a = 0; a < o; a++)
      i.push(ir(r[a], {
        modifiers: tl,
        structs: t,
        type: "function"
      }));
    const s = [];
    if (n.returns) {
      const a = Zt(n.returns), c = a.length;
      for (let u = 0; u < c; u++)
        s.push(ir(a[u], {
          modifiers: tl,
          structs: t,
          type: "function"
        }));
    }
    return {
      name: n.name,
      type: "function",
      stateMutability: n.stateMutability ?? "nonpayable",
      inputs: i,
      outputs: s
    };
  }
  if (pE(e)) {
    const n = mE(e);
    if (!n)
      throw new ao({ signature: e, type: "event" });
    const r = Zt(n.parameters), i = [], o = r.length;
    for (let s = 0; s < o; s++)
      i.push(ir(r[s], {
        modifiers: PE,
        structs: t,
        type: "event"
      }));
    return { name: n.name, type: "event", inputs: i };
  }
  if (gE(e)) {
    const n = hE(e);
    if (!n)
      throw new ao({ signature: e, type: "error" });
    const r = Zt(n.parameters), i = [], o = r.length;
    for (let s = 0; s < o; s++)
      i.push(ir(r[s], { structs: t, type: "error" }));
    return { name: n.name, type: "error", inputs: i };
  }
  if (CE(e)) {
    const n = IE(e);
    if (!n)
      throw new ao({ signature: e, type: "constructor" });
    const r = Zt(n.parameters), i = [], o = r.length;
    for (let s = 0; s < o; s++)
      i.push(ir(r[s], { structs: t, type: "constructor" }));
    return {
      type: "constructor",
      stateMutability: n.stateMutability ?? "nonpayable",
      inputs: i
    };
  }
  if (xE(e))
    return { type: "fallback" };
  if (wE(e))
    return {
      type: "receive",
      stateMutability: "payable"
    };
  throw new LE({ signature: e });
}
const ME = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, zE = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, jE = /^u?int$/;
function ir(e, t) {
  var d, f;
  const n = VE(e, t == null ? void 0 : t.type);
  if (Lc.has(n))
    return Lc.get(n);
  const r = P3.test(e), i = $n(r ? zE : ME, e);
  if (!i)
    throw new DE({ param: e });
  if (i.name && ZE(i.name))
    throw new SE({ param: e, name: i.name });
  const o = i.name ? { name: i.name } : {}, s = i.modifier === "indexed" ? { indexed: !0 } : {}, a = (t == null ? void 0 : t.structs) ?? {};
  let c, u = {};
  if (r) {
    c = "tuple";
    const h = Zt(i.type), g = [], m = h.length;
    for (let p = 0; p < m; p++)
      g.push(ir(h[p], { structs: a }));
    u = { components: g };
  } else if (i.type in a)
    c = "tuple", u = { components: a[i.type] };
  else if (jE.test(i.type))
    c = `${i.type}256`;
  else if (c = i.type, (t == null ? void 0 : t.type) !== "struct" && !R3(c))
    throw new OE({ type: c });
  if (i.modifier) {
    if (!((f = (d = t == null ? void 0 : t.modifiers) == null ? void 0 : d.has) != null && f.call(d, i.modifier)))
      throw new NE({
        param: e,
        type: t == null ? void 0 : t.type,
        modifier: i.modifier
      });
    if (tl.has(i.modifier) && !GE(c, !!i.array))
      throw new TE({
        param: e,
        type: t == null ? void 0 : t.type,
        modifier: i.modifier
      });
  }
  const l = {
    type: `${c}${i.array ?? ""}`,
    ...o,
    ...s,
    ...u
  };
  return Lc.set(n, l), l;
}
function Zt(e, t = [], n = "", r = 0) {
  const i = e.trim().length;
  for (let o = 0; o < i; o++) {
    const s = e[o], a = e.slice(o + 1);
    switch (s) {
      case ",":
        return r === 0 ? Zt(a, [...t, n.trim()]) : Zt(a, t, `${n}${s}`, r);
      case "(":
        return Zt(a, t, `${n}${s}`, r + 1);
      case ")":
        return Zt(a, t, `${n}${s}`, r - 1);
      default:
        return Zt(a, t, `${n}${s}`, r);
    }
  }
  if (n === "")
    return t;
  if (r !== 0)
    throw new XE({ current: n, depth: r });
  return t.push(n.trim()), t;
}
function R3(e) {
  return e === "address" || e === "bool" || e === "function" || e === "string" || B3.test(e) || w3.test(e);
}
const WE = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function ZE(e) {
  return e === "address" || e === "bool" || e === "function" || e === "string" || e === "tuple" || B3.test(e) || w3.test(e) || WE.test(e);
}
function GE(e, t) {
  return t || e === "bytes" || e === "string" || e === "tuple";
}
function qE(e) {
  const t = {}, n = e.length;
  for (let s = 0; s < n; s++) {
    const a = e[s];
    if (!N3(a))
      continue;
    const c = yE(a);
    if (!c)
      throw new ao({ signature: a, type: "struct" });
    const u = c.properties.split(";"), l = [], d = u.length;
    for (let f = 0; f < d; f++) {
      const g = u[f].trim();
      if (!g)
        continue;
      const m = ir(g, {
        type: "struct"
      });
      l.push(m);
    }
    if (!l.length)
      throw new FE({ signature: a });
    t[c.name] = l;
  }
  const r = {}, i = Object.entries(t), o = i.length;
  for (let s = 0; s < o; s++) {
    const [a, c] = i[s];
    r[a] = L3(c, t);
  }
  return r;
}
const YE = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function L3(e, t, n = /* @__PURE__ */ new Set()) {
  const r = [], i = e.length;
  for (let o = 0; o < i; o++) {
    const s = e[o];
    if (P3.test(s.type))
      r.push(s);
    else {
      const c = $n(YE, s.type);
      if (!(c != null && c.type))
        throw new RE({ abiParameter: s });
      const { array: u, type: l } = c;
      if (l in t) {
        if (n.has(l))
          throw new QE({ type: l });
        r.push({
          ...s,
          type: `tuple${u ?? ""}`,
          components: L3(t[l] ?? [], t, /* @__PURE__ */ new Set([...n, l]))
        });
      } else if (R3(l))
        r.push(s);
      else
        throw new HE({ type: l });
    }
  }
  return r;
}
function F3(e) {
  const t = qE(e), n = [], r = e.length;
  for (let i = 0; i < r; i++) {
    const o = e[i];
    N3(o) || n.push(kE(o, t));
  }
  return n;
}
function UE(e) {
  let t = !0, n = "", r = 0, i = "", o = !1;
  for (let s = 0; s < e.length; s++) {
    const a = e[s];
    if (["(", ")", ","].includes(a) && (t = !0), a === "(" && r++, a === ")" && r--, !!t) {
      if (r === 0) {
        if (a === " " && ["event", "function", ""].includes(i))
          i = "";
        else if (i += a, a === ")") {
          o = !0;
          break;
        }
        continue;
      }
      if (a === " ") {
        e[s - 1] !== "," && n !== "," && n !== ",(" && (n = "", t = !1);
        continue;
      }
      i += a, n += a;
    }
  }
  if (!o)
    throw new ie("Unable to normalize signature.");
  return i;
}
const JE = (e) => {
  const t = typeof e == "string" ? e : fE(e);
  return UE(t);
};
function Q3(e) {
  return dE(JE(e));
}
const KE = Q3, Md = (e) => da(Q3(e), 0, 4);
function zd(e) {
  const { abi: t, args: n = [], name: r } = e, i = Qi(r, { strict: !1 }), o = t.filter((a) => i ? a.type === "function" ? Md(a) === r : a.type === "event" ? KE(a) === r : !1 : "name" in a && a.name === r);
  if (o.length === 0)
    return;
  if (o.length === 1)
    return o[0];
  let s;
  for (const a of o) {
    if (!("inputs" in a))
      continue;
    if (!n || n.length === 0) {
      if (!a.inputs || a.inputs.length === 0)
        return a;
      continue;
    }
    if (!a.inputs || a.inputs.length === 0 || a.inputs.length !== n.length)
      continue;
    if (n.every((u, l) => {
      const d = "inputs" in a && a.inputs[l];
      return d ? nl(u, d) : !1;
    })) {
      if (s && "inputs" in s && s.inputs) {
        const u = X3(a.inputs, s.inputs, n);
        if (u)
          throw new WC({
            abiItem: a,
            type: u[0]
          }, {
            abiItem: s,
            type: u[1]
          });
      }
      s = a;
    }
  }
  return s || o[0];
}
function nl(e, t) {
  const n = typeof e, r = t.type;
  switch (r) {
    case "address":
      return Jn(e, { strict: !1 });
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return r === "tuple" && "components" in t ? Object.values(t.components).every((i, o) => nl(Object.values(e)[o], i)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(r) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(r) ? n === "string" || e instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(r) ? Array.isArray(e) && e.every((i) => nl(i, {
        ...t,
        // Pop off `[]` or `[M]` from end of type
        type: r.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function X3(e, t, n) {
  for (const r in e) {
    const i = e[r], o = t[r];
    if (i.type === "tuple" && o.type === "tuple" && "components" in i && "components" in o)
      return X3(i.components, o.components, n[r]);
    const s = [i.type, o.type];
    if (s.includes("address") && s.includes("bytes20") ? !0 : s.includes("address") && s.includes("string") ? Jn(n[r], { strict: !1 }) : s.includes("address") && s.includes("bytes") ? Jn(n[r], { strict: !1 }) : !1)
      return s;
  }
}
const Fc = "/docs/contract/decodeFunctionResult";
function jd(e) {
  const { abi: t, args: n, functionName: r, data: i } = e;
  let o = t[0];
  if (r) {
    const a = zd({ abi: t, args: n, name: r });
    if (!a)
      throw new la(r, { docsPath: Fc });
    o = a;
  }
  if (o.type !== "function")
    throw new la(void 0, { docsPath: Fc });
  if (!o.outputs)
    throw new jC(o.name, { docsPath: Fc });
  const s = x3(o.outputs, i);
  if (s && s.length > 1)
    return s;
  if (s && s.length === 1)
    return s[0];
}
const Yf = "/docs/contract/encodeFunctionData";
function _E(e) {
  const { abi: t, args: n, functionName: r } = e;
  let i = t[0];
  if (r) {
    const o = zd({
      abi: t,
      args: n,
      name: r
    });
    if (!o)
      throw new la(r, { docsPath: Yf });
    i = o;
  }
  if (i.type !== "function")
    throw new la(void 0, { docsPath: Yf });
  return {
    abi: [i],
    functionName: Md(xi(i))
  };
}
function Wd(e) {
  const { args: t } = e, { abi: n, functionName: r } = (() => {
    var a;
    return e.abi.length === 1 && ((a = e.functionName) != null && a.startsWith("0x")) ? e : _E(e);
  })(), i = n[0], o = r, s = "inputs" in i && i.inputs ? p3(i.inputs, t ?? []) : void 0;
  return Nd([o, s ?? "0x"]);
}
function Zd({ blockNumber: e, chain: t, contract: n }) {
  var i;
  const r = (i = t == null ? void 0 : t.contracts) == null ? void 0 : i[n];
  if (!r)
    throw new ju({
      chain: t,
      contract: { name: n }
    });
  if (e && r.blockCreated && r.blockCreated > e)
    throw new ju({
      blockNumber: e,
      chain: t,
      contract: {
        name: n,
        blockCreated: r.blockCreated
      }
    });
  return r.address;
}
const V3 = {
  1: "An `assert` condition failed.",
  17: "Arithmetic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, $E = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, ex = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
function tx(e) {
  const { abi: t, data: n } = e, r = da(n, 0, 4);
  if (r === "0x")
    throw new Sd();
  const o = [...t || [], $E, ex].find((s) => s.type === "error" && r === Md(xi(s)));
  if (!o)
    throw new c3(r, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: o,
    args: "inputs" in o && o.inputs && o.inputs.length > 0 ? x3(o.inputs, da(n, 4)) : void 0,
    errorName: o.name
  };
}
function k3({ abiItem: e, args: t, includeFunctionName: n = !0, includeName: r = !1 }) {
  if ("name" in e && "inputs" in e && e.inputs)
    return `${n ? e.name : ""}(${e.inputs.map((i, o) => `${r && i.name ? `${i.name}: ` : ""}${typeof t[o] == "object" ? jn(t[o]) : t[o]}`).join(", ")})`;
}
class nx extends ie {
  constructor(t, { account: n, docsPath: r, chain: i, data: o, gas: s, gasPrice: a, maxFeePerGas: c, maxPriorityFeePerGas: u, nonce: l, to: d, value: f, stateOverride: h }) {
    var p;
    const g = n ? qa(n) : void 0;
    let m = C3({
      from: g == null ? void 0 : g.address,
      to: d,
      value: typeof f < "u" && `${LI(f)} ${((p = i == null ? void 0 : i.nativeCurrency) == null ? void 0 : p.symbol) || "ETH"}`,
      data: o,
      gas: s,
      gasPrice: typeof a < "u" && `${gr(a)} gwei`,
      maxFeePerGas: typeof c < "u" && `${gr(c)} gwei`,
      maxPriorityFeePerGas: typeof u < "u" && `${gr(u)} gwei`,
      nonce: l
    });
    h && (m += `
${UI(h)}`), super(t.shortMessage, {
      cause: t,
      docsPath: r,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Raw Call Arguments:",
        m
      ].filter(Boolean),
      name: "CallExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = t;
  }
}
class rx extends ie {
  constructor(t, { abi: n, args: r, contractAddress: i, docsPath: o, functionName: s, sender: a }) {
    const c = zd({ abi: n, args: r, name: s }), u = c ? k3({
      abiItem: c,
      args: r,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, l = c ? xi(c, { includeName: !0 }) : void 0, d = C3({
      address: i && QI(i),
      function: l,
      args: u && u !== "()" && `${[...Array((s == null ? void 0 : s.length) ?? 0).keys()].map(() => " ").join("")}${u}`,
      sender: a
    });
    super(t.shortMessage || `An unknown error occurred while executing the contract function "${s}".`, {
      cause: t,
      docsPath: o,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        d && "Contract Call:",
        d
      ].filter(Boolean),
      name: "ContractFunctionExecutionError"
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abi = n, this.args = r, this.cause = t, this.contractAddress = i, this.functionName = s, this.sender = a;
  }
}
class rl extends ie {
  constructor({ abi: t, data: n, functionName: r, message: i }) {
    let o, s, a, c;
    if (n && n !== "0x")
      try {
        s = tx({ abi: t, data: n });
        const { abiItem: l, errorName: d, args: f } = s;
        if (d === "Error")
          c = f[0];
        else if (d === "Panic") {
          const [h] = f;
          c = V3[h];
        } else {
          const h = l ? xi(l, { includeName: !0 }) : void 0, g = l && f ? k3({
            abiItem: l,
            args: f,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          a = [
            h ? `Error: ${h}` : "",
            g && g !== "()" ? `       ${[...Array((d == null ? void 0 : d.length) ?? 0).keys()].map(() => " ").join("")}${g}` : ""
          ];
        }
      } catch (l) {
        o = l;
      }
    else i && (c = i);
    let u;
    o instanceof c3 && (u = o.signature, a = [
      `Unable to decode signature "${u}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${u}.`
    ]), super(c && c !== "execution reverted" || u ? [
      `The contract function "${r}" reverted with the following ${u ? "signature" : "reason"}:`,
      c || u
    ].join(`
`) : `The contract function "${r}" reverted.`, {
      cause: o,
      metaMessages: a,
      name: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = s, this.reason = c, this.signature = u;
  }
}
class ix extends ie {
  constructor({ functionName: t }) {
    super(`The contract function "${t}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${t}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ],
      name: "ContractFunctionZeroDataError"
    });
  }
}
class ox extends ie {
  constructor({ factory: t }) {
    super(`Deployment for counterfactual contract call failed${t ? ` for factory "${t}".` : ""}`, {
      metaMessages: [
        "Please ensure:",
        "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
        "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
      ],
      name: "CounterfactualDeploymentFailedError"
    });
  }
}
class M3 extends ie {
  constructor({ data: t, message: n }) {
    super(n || "", { name: "RawContractError" }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t;
  }
}
function z3(e, t) {
  var r, i, o, s, a, c;
  if (!(e instanceof ie))
    return !1;
  const n = e.walk((u) => u instanceof rl);
  return n instanceof rl ? !!(((r = n.data) == null ? void 0 : r.errorName) === "ResolverNotFound" || ((i = n.data) == null ? void 0 : i.errorName) === "ResolverWildcardNotSupported" || ((o = n.data) == null ? void 0 : o.errorName) === "ResolverNotContract" || ((s = n.data) == null ? void 0 : s.errorName) === "ResolverError" || ((a = n.data) == null ? void 0 : a.errorName) === "HttpError" || (c = n.reason) != null && c.includes("Wildcard on non-extended resolvers is not supported") || t === "reverse" && n.reason === V3[50]) : !1;
}
function j3(e) {
  if (e.length !== 66 || e.indexOf("[") !== 0 || e.indexOf("]") !== 65)
    return null;
  const t = `0x${e.slice(1, 65)}`;
  return Qi(t) ? t : null;
}
function sx(e) {
  let t = new Uint8Array(32).fill(0);
  if (!e)
    return Vt(t);
  const n = e.split(".");
  for (let r = n.length - 1; r >= 0; r -= 1) {
    const i = j3(n[r]), o = i ? wd(i) : Bi(fr(n[r]), "bytes");
    t = Bi(Ir([t, o]), "bytes");
  }
  return Vt(t);
}
function ax(e) {
  return `[${e.slice(2)}]`;
}
function cx(e) {
  const t = new Uint8Array(32).fill(0);
  return e ? j3(e) || Bi(fr(e)) : Vt(t);
}
function W3(e) {
  const t = e.replace(/^\.|\.$/gm, "");
  if (t.length === 0)
    return new Uint8Array(1);
  const n = new Uint8Array(fr(t).byteLength + 2);
  let r = 0;
  const i = t.split(".");
  for (let o = 0; o < i.length; o++) {
    let s = fr(i[o]);
    s.byteLength > 255 && (s = fr(ax(cx(i[o])))), n[r] = s.length, n.set(s, r + 1), r += s.length + 1;
  }
  return n.byteLength !== r + 1 ? n.slice(0, r + 1) : n;
}
const ux = 3;
function lx(e, { abi: t, address: n, args: r, docsPath: i, functionName: o, sender: s }) {
  const { code: a, data: c, message: u, shortMessage: l } = e instanceof M3 ? e : e instanceof ie ? e.walk((f) => "data" in f) || e.walk() : {}, d = e instanceof Sd ? new ix({ functionName: o }) : [ux, Er.code].includes(a) && (c || u || l) ? new rl({
    abi: t,
    data: typeof c == "object" ? c.data : c,
    functionName: o,
    message: l ?? u
  }) : e;
  return new rx(d, {
    abi: t,
    args: r,
    contractAddress: n,
    docsPath: i,
    functionName: o,
    sender: s
  });
}
const dx = "0x82ad56cb", Ax = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe", fx = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
function gx(e, { docsPath: t, ...n }) {
  const r = (() => {
    const i = kI(e, n);
    return i instanceof y3 ? e : i;
  })();
  return new nx(r, {
    docsPath: t,
    ...n
  });
}
const Qc = /* @__PURE__ */ new Map();
function Z3({ fn: e, id: t, shouldSplitBatch: n, wait: r = 0, sort: i }) {
  const o = async () => {
    const l = c();
    s();
    const d = l.map(({ args: f }) => f);
    d.length !== 0 && e(d).then((f) => {
      var h;
      i && Array.isArray(f) && f.sort(i);
      for (let g = 0; g < l.length; g++) {
        const { pendingPromise: m } = l[g];
        (h = m.resolve) == null || h.call(m, [f[g], f]);
      }
    }).catch((f) => {
      var h;
      for (let g = 0; g < l.length; g++) {
        const { pendingPromise: m } = l[g];
        (h = m.reject) == null || h.call(m, f);
      }
    });
  }, s = () => Qc.delete(t), a = () => c().map(({ args: l }) => l), c = () => Qc.get(t) || [], u = (l) => Qc.set(t, [...c(), l]);
  return {
    flush: s,
    async schedule(l) {
      const d = {}, f = new Promise((m, p) => {
        d.resolve = m, d.reject = p;
      });
      return (n == null ? void 0 : n([...a(), l])) && o(), c().length > 0 ? (u({ args: l, pendingPromise: d }), f) : (u({ args: l, pendingPromise: d }), setTimeout(o, r), f);
    }
  };
}
async function hx(e, t) {
  var Q, F, M, H;
  const { account: n = e.account, batch: r = !!((Q = e.batch) != null && Q.multicall), blockNumber: i, blockTag: o = "latest", accessList: s, blobs: a, code: c, data: u, factory: l, factoryData: d, gas: f, gasPrice: h, maxFeePerBlobGas: g, maxFeePerGas: m, maxPriorityFeePerGas: p, nonce: v, to: b, value: y, stateOverride: E, ...C } = t, B = n ? qa(n) : void 0;
  if (c && (l || d))
    throw new ie("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
  if (c && b)
    throw new ie("Cannot provide both `code` & `to` as parameters.");
  const I = c && u, x = l && d && b && u, O = I || x, k = I ? vx({
    code: c,
    data: u
  }) : x ? bx({
    data: u,
    factory: l,
    factoryData: d,
    to: b
  }) : u;
  try {
    GI(t);
    const R = (i ? je(i) : void 0) || o, z = KI(E), L = (H = (M = (F = e.chain) == null ? void 0 : F.formatters) == null ? void 0 : M.transactionRequest) == null ? void 0 : H.format, W = (L || jI)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...MI(C, { format: L }),
      from: B == null ? void 0 : B.address,
      accessList: s,
      blobs: a,
      data: k,
      gas: f,
      gasPrice: h,
      maxFeePerBlobGas: g,
      maxFeePerGas: m,
      maxPriorityFeePerGas: p,
      nonce: v,
      to: O ? void 0 : b,
      value: y
    });
    if (r && px({ request: W }) && !z)
      try {
        return await mx(e, {
          ...W,
          blockNumber: i,
          blockTag: o
        });
      } catch (ee) {
        if (!(ee instanceof v3) && !(ee instanceof ju))
          throw ee;
      }
    const U = await e.request({
      method: "eth_call",
      params: z ? [
        W,
        R,
        z
      ] : [W, R]
    });
    return U === "0x" ? { data: void 0 } : { data: U };
  } catch (T) {
    const R = yx(T), { offchainLookup: z, offchainLookupSignature: L } = await import("./ccip-Bh88BZ5I.js");
    if (e.ccipRead !== !1 && (R == null ? void 0 : R.slice(0, 10)) === L && b)
      return { data: await z(e, { data: R, to: b }) };
    throw O && (R == null ? void 0 : R.slice(0, 10)) === "0x101bb98d" ? new ox({ factory: l }) : gx(T, {
      ...t,
      account: B,
      chain: e.chain
    });
  }
}
function px({ request: e }) {
  const { data: t, to: n, ...r } = e;
  return !(!t || t.startsWith(dx) || !n || Object.values(r).filter((i) => typeof i < "u").length > 0);
}
async function mx(e, t) {
  var m;
  const { batchSize: n = 1024, wait: r = 0 } = typeof ((m = e.batch) == null ? void 0 : m.multicall) == "object" ? e.batch.multicall : {}, { blockNumber: i, blockTag: o = "latest", data: s, multicallAddress: a, to: c } = t;
  let u = a;
  if (!u) {
    if (!e.chain)
      throw new v3();
    u = Zd({
      blockNumber: i,
      chain: e.chain,
      contract: "multicall3"
    });
  }
  const d = (i ? je(i) : void 0) || o, { schedule: f } = Z3({
    id: `${e.uid}.${d}`,
    wait: r,
    shouldSplitBatch(p) {
      return p.reduce((b, { data: y }) => b + (y.length - 2), 0) > n * 2;
    },
    fn: async (p) => {
      const v = p.map((E) => ({
        allowFailure: !0,
        callData: E.data,
        target: E.to
      })), b = Wd({
        abi: Wf,
        args: [v],
        functionName: "aggregate3"
      }), y = await e.request({
        method: "eth_call",
        params: [
          {
            data: b,
            to: u
          },
          d
        ]
      });
      return jd({
        abi: Wf,
        args: [v],
        functionName: "aggregate3",
        data: y || "0x"
      });
    }
  }), [{ returnData: h, success: g }] = await f({ data: s, to: c });
  if (!g)
    throw new M3({ data: h });
  return h === "0x" ? { data: void 0 } : { data: h };
}
function vx(e) {
  const { code: t, data: n } = e;
  return m3({
    abi: F3(["constructor(bytes, bytes)"]),
    bytecode: Ax,
    args: [t, n]
  });
}
function bx(e) {
  const { data: t, factory: n, factoryData: r, to: i } = e;
  return m3({
    abi: F3(["constructor(address, bytes, address, bytes)"]),
    bytecode: fx,
    args: [i, t, n, r]
  });
}
function yx(e) {
  var n;
  if (!(e instanceof ie))
    return;
  const t = e.walk();
  return typeof (t == null ? void 0 : t.data) == "object" ? (n = t.data) == null ? void 0 : n.data : t.data;
}
async function ga(e, t) {
  const { abi: n, address: r, args: i, functionName: o, ...s } = t, a = Wd({
    abi: n,
    args: i,
    functionName: o
  });
  try {
    const { data: c } = await Ya(e, hx, "call")({
      ...s,
      data: a,
      to: r
    });
    return jd({
      abi: n,
      args: i,
      functionName: o,
      data: c || "0x"
    });
  } catch (c) {
    throw lx(c, {
      abi: n,
      address: r,
      args: i,
      docsPath: "/docs/contract/readContract",
      functionName: o
    });
  }
}
class Cx extends ie {
  constructor({ data: t }) {
    super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
      metaMessages: [
        "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
        "",
        `Provided data: ${JSON.stringify(t)}`
      ],
      name: "EnsAvatarInvalidMetadataError"
    });
  }
}
class $i extends ie {
  constructor({ reason: t }) {
    super(`ENS NFT avatar URI is invalid. ${t}`, {
      name: "EnsAvatarInvalidNftUriError"
    });
  }
}
class Gd extends ie {
  constructor({ uri: t }) {
    super(`Unable to resolve ENS avatar URI "${t}". The URI may be malformed, invalid, or does not respond with a valid image.`, { name: "EnsAvatarUriResolutionError" });
  }
}
class Ix extends ie {
  constructor({ namespace: t }) {
    super(`ENS NFT avatar namespace "${t}" is not supported. Must be "erc721" or "erc1155".`, { name: "EnsAvatarUnsupportedNamespaceError" });
  }
}
const Ex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/, xx = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/, Bx = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/, wx = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function Px(e) {
  try {
    const t = await fetch(e, { method: "HEAD" });
    if (t.status === 200) {
      const n = t.headers.get("content-type");
      return n == null ? void 0 : n.startsWith("image/");
    }
    return !1;
  } catch (t) {
    return typeof t == "object" && typeof t.response < "u" || !globalThis.hasOwnProperty("Image") ? !1 : new Promise((n) => {
      const r = new Image();
      r.onload = () => {
        n(!0);
      }, r.onerror = () => {
        n(!1);
      }, r.src = e;
    });
  }
}
function Uf(e, t) {
  return e ? e.endsWith("/") ? e.slice(0, -1) : e : t;
}
function G3({ uri: e, gatewayUrls: t }) {
  const n = Bx.test(e);
  if (n)
    return { uri: e, isOnChain: !0, isEncoded: n };
  const r = Uf(t == null ? void 0 : t.ipfs, "https://ipfs.io"), i = Uf(t == null ? void 0 : t.arweave, "https://arweave.net"), o = e.match(Ex), { protocol: s, subpath: a, target: c, subtarget: u = "" } = (o == null ? void 0 : o.groups) || {}, l = s === "ipns:/" || a === "ipns/", d = s === "ipfs:/" || a === "ipfs/" || xx.test(e);
  if (e.startsWith("http") && !l && !d) {
    let h = e;
    return t != null && t.arweave && (h = e.replace(/https:\/\/arweave.net/g, t == null ? void 0 : t.arweave)), { uri: h, isOnChain: !1, isEncoded: !1 };
  }
  if ((l || d) && c)
    return {
      uri: `${r}/${l ? "ipns" : "ipfs"}/${c}${u}`,
      isOnChain: !1,
      isEncoded: !1
    };
  if (s === "ar:/" && c)
    return {
      uri: `${i}/${c}${u || ""}`,
      isOnChain: !1,
      isEncoded: !1
    };
  let f = e.replace(wx, "");
  if (f.startsWith("<svg") && (f = `data:image/svg+xml;base64,${btoa(f)}`), f.startsWith("data:") || f.startsWith("{"))
    return {
      uri: f,
      isOnChain: !0,
      isEncoded: !1
    };
  throw new Gd({ uri: e });
}
function q3(e) {
  if (typeof e != "object" || !("image" in e) && !("image_url" in e) && !("image_data" in e))
    throw new Cx({ data: e });
  return e.image || e.image_url || e.image_data;
}
async function Hx({ gatewayUrls: e, uri: t }) {
  try {
    const n = await fetch(t).then((i) => i.json());
    return await qd({
      gatewayUrls: e,
      uri: q3(n)
    });
  } catch {
    throw new Gd({ uri: t });
  }
}
async function qd({ gatewayUrls: e, uri: t }) {
  const { uri: n, isOnChain: r } = G3({ uri: t, gatewayUrls: e });
  if (r || await Px(n))
    return n;
  throw new Gd({ uri: t });
}
function Ox(e) {
  let t = e;
  t.startsWith("did:nft:") && (t = t.replace("did:nft:", "").replace(/_/g, "/"));
  const [n, r, i] = t.split("/"), [o, s] = n.split(":"), [a, c] = r.split(":");
  if (!o || o.toLowerCase() !== "eip155")
    throw new $i({ reason: "Only EIP-155 supported" });
  if (!s)
    throw new $i({ reason: "Chain ID not found" });
  if (!c)
    throw new $i({
      reason: "Contract address not found"
    });
  if (!i)
    throw new $i({ reason: "Token ID not found" });
  if (!a)
    throw new $i({ reason: "ERC namespace not found" });
  return {
    chainID: Number.parseInt(s),
    namespace: a.toLowerCase(),
    contractAddress: c,
    tokenID: i
  };
}
async function Dx(e, { nft: t }) {
  if (t.namespace === "erc721")
    return ga(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "tokenURI",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "tokenId", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "tokenURI",
      args: [BigInt(t.tokenID)]
    });
  if (t.namespace === "erc1155")
    return ga(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "uri",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "_id", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "uri",
      args: [BigInt(t.tokenID)]
    });
  throw new Ix({ namespace: t.namespace });
}
async function Sx(e, { gatewayUrls: t, record: n }) {
  return /eip155:/i.test(n) ? Nx(e, { gatewayUrls: t, record: n }) : qd({ uri: n, gatewayUrls: t });
}
async function Nx(e, { gatewayUrls: t, record: n }) {
  const r = Ox(n), i = await Dx(e, { nft: r }), { uri: o, isOnChain: s, isEncoded: a } = G3({ uri: i, gatewayUrls: t });
  if (s && (o.includes("data:application/json;base64,") || o.startsWith("{"))) {
    const u = a ? (
      // if it is encoded, decode it
      atob(o.replace("data:application/json;base64,", ""))
    ) : (
      // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
      o
    ), l = JSON.parse(u);
    return qd({ uri: q3(l), gatewayUrls: t });
  }
  let c = r.tokenID;
  return r.namespace === "erc1155" && (c = c.replace("0x", "").padStart(64, "0")), Hx({
    gatewayUrls: t,
    uri: o.replace(/(?:0x)?{id}/, c)
  });
}
async function Tx(e, { blockNumber: t, blockTag: n, name: r, key: i, gatewayUrls: o, strict: s, universalResolverAddress: a }) {
  let c = a;
  if (!c) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    c = Zd({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const u = {
      address: c,
      abi: _I,
      functionName: "resolve",
      args: [
        Hd(W3(r)),
        Wd({
          abi: Zf,
          functionName: "text",
          args: [sx(r), i]
        })
      ],
      blockNumber: t,
      blockTag: n
    }, l = Ya(e, ga, "readContract"), d = o ? await l({
      ...u,
      args: [...u.args, o]
    }) : await l(u);
    if (d[0] === "0x")
      return null;
    const f = jd({
      abi: Zf,
      functionName: "text",
      data: d[0]
    });
    return f === "" ? null : f;
  } catch (u) {
    if (s)
      throw u;
    if (z3(u, "resolve"))
      return null;
    throw u;
  }
}
async function Rx(e, { blockNumber: t, blockTag: n, assetGatewayUrls: r, name: i, gatewayUrls: o, strict: s, universalResolverAddress: a }) {
  const c = await Ya(e, Tx, "getEnsText")({
    blockNumber: t,
    blockTag: n,
    key: "avatar",
    name: i,
    universalResolverAddress: a,
    gatewayUrls: o,
    strict: s
  });
  if (!c)
    return null;
  try {
    return await Sx(e, {
      record: c,
      gatewayUrls: r
    });
  } catch {
    return null;
  }
}
async function Lx(e, { address: t, blockNumber: n, blockTag: r, gatewayUrls: i, strict: o, universalResolverAddress: s }) {
  let a = s;
  if (!a) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    a = Zd({
      blockNumber: n,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  const c = `${t.toLowerCase().substring(2)}.addr.reverse`;
  try {
    const u = {
      address: a,
      abi: $I,
      functionName: "reverse",
      args: [Hd(W3(c))],
      blockNumber: n,
      blockTag: r
    }, l = Ya(e, ga, "readContract"), [d, f] = i ? await l({
      ...u,
      args: [...u.args, i]
    }) : await l(u);
    return t.toLowerCase() !== f.toLowerCase() ? null : d;
  } catch (u) {
    if (o)
      throw u;
    if (z3(u, "reverse"))
      return null;
    throw u;
  }
}
async function Fx(e) {
  return new Promise((t) => setTimeout(t, e));
}
const Ps = /* @__PURE__ */ new Td(8192);
function Qx(e, { enabled: t = !0, id: n }) {
  if (!t || !n)
    return e();
  if (Ps.get(n))
    return Ps.get(n);
  const r = e().finally(() => Ps.delete(n));
  return Ps.set(n, r), r;
}
function Y3(e, { delay: t = 100, retryCount: n = 2, shouldRetry: r = () => !0 } = {}) {
  return new Promise((i, o) => {
    const s = async ({ count: a = 0 } = {}) => {
      const c = async ({ error: u }) => {
        const l = typeof t == "function" ? t({ count: a, error: u }) : t;
        l && await Fx(l), s({ count: a + 1 });
      };
      try {
        const u = await e();
        i(u);
      } catch (u) {
        if (a < n && await r({ count: a, error: u }))
          return c({ error: u });
        o(u);
      }
    };
    s();
  });
}
function Xx(e, t = {}) {
  return async (n, r = {}) => {
    const { dedupe: i = !1, retryDelay: o = 150, retryCount: s = 3, uid: a } = {
      ...t,
      ...r
    }, c = i ? Bi(Od(`${a}.${jn(n)}`)) : void 0;
    return Qx(() => Y3(async () => {
      try {
        return await e(n);
      } catch (u) {
        const l = u;
        switch (l.code) {
          case Eo.code:
            throw new Eo(l);
          case xo.code:
            throw new xo(l);
          case Bo.code:
            throw new Bo(l, { method: n.method });
          case wo.code:
            throw new wo(l);
          case Er.code:
            throw new Er(l);
          case Po.code:
            throw new Po(l);
          case Ho.code:
            throw new Ho(l);
          case Wn.code:
            throw new Wn(l);
          case Oo.code:
            throw new Oo(l);
          case Do.code:
            throw new Do(l, {
              method: n.method
            });
          case wi.code:
            throw new wi(l);
          case So.code:
            throw new So(l);
          case gt.code:
            throw new gt(l);
          case No.code:
            throw new No(l);
          case To.code:
            throw new To(l);
          case Ro.code:
            throw new Ro(l);
          case Lo.code:
            throw new Lo(l);
          case xr.code:
            throw new xr(l);
          case 5e3:
            throw new gt(l);
          default:
            throw u instanceof ie ? u : new VI(l);
        }
      }
    }, {
      delay: ({ count: u, error: l }) => {
        var d;
        if (l && l instanceof lo) {
          const f = (d = l == null ? void 0 : l.headers) == null ? void 0 : d.get("Retry-After");
          if (f != null && f.match(/\d/))
            return Number.parseInt(f) * 1e3;
        }
        return ~~(1 << u) * o;
      },
      retryCount: s,
      shouldRetry: ({ error: u }) => Vx(u)
    }), { enabled: i, id: c });
  };
}
function Vx(e) {
  return "code" in e && typeof e.code == "number" ? e.code === -1 || e.code === wi.code || e.code === Er.code : e instanceof lo && e.status ? e.status === 403 || e.status === 408 || e.status === 413 || e.status === 429 || e.status === 500 || e.status === 502 || e.status === 503 || e.status === 504 : !0;
}
function kx(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
function U3(e, { errorInstance: t = new Error("timed out"), timeout: n, signal: r }) {
  return new Promise((i, o) => {
    (async () => {
      let s;
      try {
        const a = new AbortController();
        n > 0 && (s = setTimeout(() => {
          r ? a.abort() : o(t);
        }, n)), i(await e({ signal: (a == null ? void 0 : a.signal) || null }));
      } catch (a) {
        (a == null ? void 0 : a.name) === "AbortError" && o(t), o(a);
      } finally {
        clearTimeout(s);
      }
    })();
  });
}
function Mx() {
  return {
    current: 0,
    take() {
      return this.current++;
    },
    reset() {
      this.current = 0;
    }
  };
}
const Jf = /* @__PURE__ */ Mx();
function zx(e, t = {}) {
  return {
    async request(n) {
      var d;
      const { body: r, onRequest: i = t.onRequest, onResponse: o = t.onResponse, timeout: s = t.timeout ?? 1e4 } = n, a = {
        ...t.fetchOptions ?? {},
        ...n.fetchOptions ?? {}
      }, { headers: c, method: u, signal: l } = a;
      try {
        const f = await U3(async ({ signal: g }) => {
          const m = {
            ...a,
            body: Array.isArray(r) ? jn(r.map((b) => ({
              jsonrpc: "2.0",
              id: b.id ?? Jf.take(),
              ...b
            }))) : jn({
              jsonrpc: "2.0",
              id: r.id ?? Jf.take(),
              ...r
            }),
            headers: {
              "Content-Type": "application/json",
              ...c
            },
            method: u || "POST",
            signal: l || (s > 0 ? g : null)
          }, p = new Request(e, m);
          return i && await i(p), await fetch(e, m);
        }, {
          errorInstance: new Mf({ body: r, url: e }),
          timeout: s,
          signal: !0
        });
        o && await o(f);
        let h;
        if ((d = f.headers.get("Content-Type")) != null && d.startsWith("application/json") ? h = await f.json() : (h = await f.text(), h = JSON.parse(h || "{}")), !f.ok)
          throw new lo({
            body: r,
            details: jn(h.error) || f.statusText,
            headers: f.headers,
            status: f.status,
            url: e
          });
        return h;
      } catch (f) {
        throw f instanceof lo || f instanceof Mf ? f : new lo({
          body: r,
          cause: f,
          url: e
        });
      }
    }
  };
}
function J3(e, t, n) {
  const r = e[t.name];
  if (typeof r == "function")
    return r;
  const i = e[n];
  return typeof i == "function" ? i : (o) => t(e, o);
}
const Zs = "2.13.5", jx = () => `@wagmi/core@${Zs}`;
var K3 = function(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, ha, _3;
let Yd = class il extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return jx();
  }
  constructor(t, n = {}) {
    var o;
    super(), ha.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const r = n.cause instanceof il ? n.cause.details : (o = n.cause) != null && o.message ? n.cause.message : n.details, i = n.cause instanceof il && n.cause.docsPath || n.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [
        `Docs: ${this.docsBaseUrl}${i}.html${n.docsSlug ? `#${n.docsSlug}` : ""}`
      ] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${this.version}`
    ].join(`
`), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = i, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return K3(this, ha, "m", _3).call(this, this, t);
  }
};
ha = /* @__PURE__ */ new WeakSet(), _3 = function e(t, n) {
  return n != null && n(t) ? t : t.cause ? K3(this, ha, "m", e).call(this, t.cause, n) : t;
};
class ol extends Yd {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
const sl = 256;
let Hs = sl, Os;
function $3(e = 11) {
  if (!Os || Hs + e > sl * 2) {
    Os = "", Hs = 0;
    for (let t = 0; t < sl; t++)
      Os += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return Os.substring(Hs, Hs++ + e);
}
function Wx(e) {
  const { batch: t, cacheTime: n = e.pollingInterval ?? 4e3, ccipRead: r, key: i = "base", name: o = "Base Client", pollingInterval: s = 4e3, type: a = "base" } = e, c = e.chain, u = e.account ? qa(e.account) : void 0, { config: l, request: d, value: f } = e.transport({
    chain: c,
    pollingInterval: s
  }), h = { ...l, ...f }, g = {
    account: u,
    batch: t,
    cacheTime: n,
    ccipRead: r,
    chain: c,
    key: i,
    name: o,
    pollingInterval: s,
    request: d,
    transport: h,
    type: a,
    uid: $3()
  };
  function m(p) {
    return (v) => {
      const b = v(p);
      for (const E in g)
        delete b[E];
      const y = { ...p, ...b };
      return Object.assign(y, { extend: m(y) });
    };
  }
  return Object.assign(g, { extend: m(g) });
}
function Zx({ key: e, name: t, request: n, retryCount: r = 3, retryDelay: i = 150, timeout: o, type: s }, a) {
  const c = $3();
  return {
    config: {
      key: e,
      name: t,
      request: n,
      retryCount: r,
      retryDelay: i,
      timeout: o,
      type: s
    },
    request: Xx(n, { retryCount: r, retryDelay: i, uid: c }),
    value: a
  };
}
class Gx extends ie {
  constructor() {
    super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
      docsPath: "/docs/clients/intro",
      name: "UrlRequiredError"
    });
  }
}
function qx(e, t = {}) {
  const { batch: n, fetchOptions: r, key: i = "http", name: o = "HTTP JSON-RPC", onFetchRequest: s, onFetchResponse: a, retryDelay: c } = t;
  return ({ chain: u, retryCount: l, timeout: d }) => {
    const { batchSize: f = 1e3, wait: h = 0 } = typeof n == "object" ? n : {}, g = t.retryCount ?? l, m = d ?? t.timeout ?? 1e4, p = u == null ? void 0 : u.rpcUrls.default.http[0];
    if (!p)
      throw new Gx();
    const v = zx(p, {
      fetchOptions: r,
      onRequest: s,
      onResponse: a,
      timeout: m
    });
    return Zx({
      key: i,
      name: o,
      async request({ method: b, params: y }) {
        const E = { method: b, params: y }, { schedule: C } = Z3({
          id: p,
          wait: h,
          shouldSplitBatch(O) {
            return O.length > f;
          },
          fn: (O) => v.request({
            body: O
          }),
          sort: (O, k) => O.id - k.id
        }), B = async (O) => n ? C(O) : [
          await v.request({
            body: O
          })
        ], [{ error: I, result: x }] = await B(E);
        if (I)
          throw new I3({
            body: E,
            error: I,
            url: p
          });
        return x;
      },
      retryCount: g,
      retryDelay: c,
      timeout: m,
      type: "http"
    }, {
      fetchOptions: r,
      url: p
    });
  };
}
function Kf(e) {
  return e.state.chainId;
}
function Yx(e, t) {
  const { chainId: n, ...r } = t, i = e.getClient({ chainId: n });
  return J3(i, Rx, "getEnsAvatar")(r);
}
function Ux(e, t) {
  const { chainId: n, ...r } = t, i = e.getClient({ chainId: n });
  return J3(i, Lx, "getEnsName")(r);
}
let Xc = !1;
async function Jx(e, t = {}) {
  var u, l;
  if (Xc)
    return [];
  Xc = !0, e.setState((d) => ({
    ...d,
    status: d.current ? "reconnecting" : "connecting"
  }));
  const n = [];
  if ((u = t.connectors) != null && u.length)
    for (const d of t.connectors) {
      let f;
      typeof d == "function" ? f = e._internal.connectors.setup(d) : f = d, n.push(f);
    }
  else
    n.push(...e.connectors);
  let r;
  try {
    r = await ((l = e.storage) == null ? void 0 : l.getItem("recentConnectorId"));
  } catch {
  }
  const i = {};
  for (const [, d] of e.state.connections)
    i[d.connector.id] = 1;
  r && (i[r] = 0);
  const o = Object.keys(i).length > 0 ? (
    // .toSorted()
    [...n].sort((d, f) => (i[d.id] ?? 10) - (i[f.id] ?? 10))
  ) : n;
  let s = !1;
  const a = [], c = [];
  for (const d of o) {
    const f = await d.getProvider().catch(() => {
    });
    if (!f || c.some((m) => m === f) || !await d.isAuthorized())
      continue;
    const g = await d.connect({ isReconnecting: !0 }).catch(() => null);
    g && (d.emitter.off("connect", e._internal.events.connect), d.emitter.on("change", e._internal.events.change), d.emitter.on("disconnect", e._internal.events.disconnect), e.setState((m) => {
      const p = new Map(s ? m.connections : /* @__PURE__ */ new Map()).set(d.uid, { accounts: g.accounts, chainId: g.chainId, connector: d });
      return {
        ...m,
        current: s ? m.current : d.uid,
        connections: p
      };
    }), a.push({
      accounts: g.accounts,
      chainId: g.chainId,
      connector: d
    }), c.push(f), s = !0);
  }
  return (e.state.status === "reconnecting" || e.state.status === "connecting") && (s ? e.setState((d) => ({ ...d, status: "connected" })) : e.setState((d) => ({
    ...d,
    connections: /* @__PURE__ */ new Map(),
    current: null,
    status: "disconnected"
  }))), Xc = !1, a;
}
class Mr extends Yd {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
function Kx(e, t) {
  const { onChange: n } = t;
  return e.subscribe((r) => r.chainId, n);
}
const _x = /(rabby|trustwallet)/, $x = {
  coinbaseWallet: {
    id: "coinbaseWallet",
    name: "Coinbase Wallet",
    provider(e) {
      return e != null && e.coinbaseWalletExtension ? e.coinbaseWalletExtension : Gs(e, "isCoinbaseWallet");
    }
  },
  metaMask: {
    id: "metaMask",
    name: "MetaMask",
    provider(e) {
      return Gs(e, (t) => {
        if (!t.isMetaMask || t.isBraveWallet && !t._events && !t._state)
          return !1;
        const n = [
          "isApexWallet",
          "isAvalanche",
          "isBitKeep",
          "isBlockWallet",
          "isKuCoinWallet",
          "isMathWallet",
          "isOkxWallet",
          "isOKExWallet",
          "isOneInchIOSWallet",
          "isOneInchAndroidWallet",
          "isOpera",
          "isPortal",
          "isRabby",
          "isTokenPocket",
          "isTokenary",
          "isZerion"
        ];
        for (const r of n)
          if (t[r])
            return !1;
        return !0;
      });
    }
  },
  phantom: {
    id: "phantom",
    name: "Phantom",
    provider(e) {
      var t, n;
      return (t = e == null ? void 0 : e.phantom) != null && t.ethereum ? (n = e.phantom) == null ? void 0 : n.ethereum : Gs(e, "isPhantom");
    }
  }
};
Ud.type = "injected";
function Ud(e = {}) {
  const { shimDisconnect: t = !0, unstable_shimAsyncInject: n } = e;
  function r() {
    const c = e.target;
    if (typeof c == "function") {
      const u = c();
      if (u)
        return u;
    }
    return typeof c == "object" ? c : typeof c == "string" ? {
      ...$x[c] ?? {
        id: c,
        name: `${c[0].toUpperCase()}${c.slice(1)}`,
        provider: `is${c[0].toUpperCase()}${c.slice(1)}`
      }
    } : {
      id: "injected",
      name: "Injected",
      provider(u) {
        return u == null ? void 0 : u.ethereum;
      }
    };
  }
  let i, o, s, a;
  return (c) => ({
    get icon() {
      return r().icon;
    },
    get id() {
      return r().id;
    },
    get name() {
      return r().name;
    },
    get supportsSimulation() {
      return _x.test(this.id.toLowerCase());
    },
    type: Ud.type,
    async setup() {
      const u = await this.getProvider();
      u && e.target && (s || (s = this.onConnect.bind(this), u.on("connect", s)), i || (i = this.onAccountsChanged.bind(this), u.on("accountsChanged", i)));
    },
    async connect({ chainId: u, isReconnecting: l } = {}) {
      var h, g, m, p, v, b;
      const d = await this.getProvider();
      if (!d)
        throw new Mr();
      let f = [];
      if (l)
        f = await this.getAccounts().catch(() => []);
      else if (t)
        try {
          f = (p = (m = (g = (h = (await d.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }))[0]) == null ? void 0 : h.caveats) == null ? void 0 : g[0]) == null ? void 0 : m.value) == null ? void 0 : p.map((E) => ws(E)), f.length > 0 && (f = await this.getAccounts());
        } catch (y) {
          const E = y;
          if (E.code === gt.code)
            throw new gt(E);
          if (E.code === Wn.code)
            throw E;
        }
      try {
        !(f != null && f.length) && !l && (f = (await d.request({
          method: "eth_requestAccounts"
        })).map((C) => ws(C))), s && (d.removeListener("connect", s), s = void 0), i || (i = this.onAccountsChanged.bind(this), d.on("accountsChanged", i)), o || (o = this.onChainChanged.bind(this), d.on("chainChanged", o)), a || (a = this.onDisconnect.bind(this), d.on("disconnect", a));
        let y = await this.getChainId();
        if (u && y !== u) {
          const E = await this.switchChain({ chainId: u }).catch((C) => {
            if (C.code === gt.code)
              throw C;
            return { id: y };
          });
          y = (E == null ? void 0 : E.id) ?? y;
        }
        return t && await ((v = c.storage) == null ? void 0 : v.removeItem(`${this.id}.disconnected`)), e.target || await ((b = c.storage) == null ? void 0 : b.setItem("injected.connected", !0)), { accounts: f, chainId: y };
      } catch (y) {
        const E = y;
        throw E.code === gt.code ? new gt(E) : E.code === Wn.code ? new Wn(E) : E;
      }
    },
    async disconnect() {
      var l, d;
      const u = await this.getProvider();
      if (!u)
        throw new Mr();
      o && (u.removeListener("chainChanged", o), o = void 0), a && (u.removeListener("disconnect", a), a = void 0), s || (s = this.onConnect.bind(this), u.on("connect", s));
      try {
        await U3(() => (
          // TODO: Remove explicit type for viem@3
          u.request({
            // `'wallet_revokePermissions'` added in `viem@2.10.3`
            method: "wallet_revokePermissions",
            params: [{ eth_accounts: {} }]
          })
        ), { timeout: 100 });
      } catch {
      }
      t && await ((l = c.storage) == null ? void 0 : l.setItem(`${this.id}.disconnected`, !0)), e.target || await ((d = c.storage) == null ? void 0 : d.removeItem("injected.connected"));
    },
    async getAccounts() {
      const u = await this.getProvider();
      if (!u)
        throw new Mr();
      return (await u.request({ method: "eth_accounts" })).map((d) => ws(d));
    },
    async getChainId() {
      const u = await this.getProvider();
      if (!u)
        throw new Mr();
      const l = await u.request({ method: "eth_chainId" });
      return Number(l);
    },
    async getProvider() {
      if (typeof window > "u")
        return;
      let u;
      const l = r();
      return typeof l.provider == "function" ? u = l.provider(window) : typeof l.provider == "string" ? u = Gs(window, l.provider) : u = l.provider, u && !u.removeListener && ("off" in u && typeof u.off == "function" ? u.removeListener = u.off : u.removeListener = () => {
      }), u;
    },
    async isAuthorized() {
      var u, l;
      try {
        if (t && // If shim exists in storage, connector is disconnected
        await ((u = c.storage) == null ? void 0 : u.getItem(`${this.id}.disconnected`)) || !e.target && !await ((l = c.storage) == null ? void 0 : l.getItem("injected.connected")))
          return !1;
        if (!await this.getProvider()) {
          if (n !== void 0 && n !== !1) {
            const g = async () => (typeof window < "u" && window.removeEventListener("ethereum#initialized", g), !!await this.getProvider()), m = typeof n == "number" ? n : 1e3;
            if (await Promise.race([
              ...typeof window < "u" ? [
                new Promise((v) => window.addEventListener("ethereum#initialized", () => v(g()), { once: !0 }))
              ] : [],
              new Promise((v) => setTimeout(() => v(g()), m))
            ]))
              return !0;
          }
          throw new Mr();
        }
        return !!(await Y3(() => this.getAccounts())).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: u, chainId: l }) {
      var h, g, m, p;
      const d = await this.getProvider();
      if (!d)
        throw new Mr();
      const f = c.chains.find((v) => v.id === l);
      if (!f)
        throw new xr(new ol());
      try {
        return await Promise.all([
          d.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: je(l) }]
          }).then(async () => {
            await this.getChainId() === l && c.emitter.emit("change", { chainId: l });
          }),
          new Promise((v) => c.emitter.once("change", ({ chainId: b }) => {
            b === l && v();
          }))
        ]), f;
      } catch (v) {
        const b = v;
        if (b.code === 4902 || // Unwrapping for MetaMask Mobile
        // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
        ((g = (h = b == null ? void 0 : b.data) == null ? void 0 : h.originalError) == null ? void 0 : g.code) === 4902)
          try {
            const { default: y, ...E } = f.blockExplorers ?? {};
            let C;
            u != null && u.blockExplorerUrls ? C = u.blockExplorerUrls : y && (C = [
              y.url,
              ...Object.values(E).map((O) => O.url)
            ]);
            let B;
            (m = u == null ? void 0 : u.rpcUrls) != null && m.length ? B = u.rpcUrls : B = [((p = f.rpcUrls.default) == null ? void 0 : p.http[0]) ?? ""];
            const I = {
              blockExplorerUrls: C,
              chainId: je(l),
              chainName: (u == null ? void 0 : u.chainName) ?? f.name,
              iconUrls: u == null ? void 0 : u.iconUrls,
              nativeCurrency: (u == null ? void 0 : u.nativeCurrency) ?? f.nativeCurrency,
              rpcUrls: B
            };
            if (await d.request({
              method: "wallet_addEthereumChain",
              params: [I]
            }), await this.getChainId() !== l)
              throw new gt(new Error("User rejected switch after adding network."));
            return f;
          } catch (y) {
            throw new gt(y);
          }
        throw b.code === gt.code ? new gt(b) : new xr(b);
      }
    },
    async onAccountsChanged(u) {
      var l;
      if (u.length === 0)
        this.onDisconnect();
      else if (c.emitter.listenerCount("connect")) {
        const d = (await this.getChainId()).toString();
        this.onConnect({ chainId: d }), t && await ((l = c.storage) == null ? void 0 : l.removeItem(`${this.id}.disconnected`));
      } else
        c.emitter.emit("change", {
          accounts: u.map((d) => ws(d))
        });
    },
    onChainChanged(u) {
      const l = Number(u);
      c.emitter.emit("change", { chainId: l });
    },
    async onConnect(u) {
      const l = await this.getAccounts();
      if (l.length === 0)
        return;
      const d = Number(u.chainId);
      c.emitter.emit("connect", { accounts: l, chainId: d });
      const f = await this.getProvider();
      f && (s && (f.removeListener("connect", s), s = void 0), i || (i = this.onAccountsChanged.bind(this), f.on("accountsChanged", i)), o || (o = this.onChainChanged.bind(this), f.on("chainChanged", o)), a || (a = this.onDisconnect.bind(this), f.on("disconnect", a)));
    },
    async onDisconnect(u) {
      const l = await this.getProvider();
      u && u.code === 1013 && l && (await this.getAccounts()).length || (c.emitter.emit("disconnect"), l && (o && (l.removeListener("chainChanged", o), o = void 0), a && (l.removeListener("disconnect", a), a = void 0), s || (s = this.onConnect.bind(this), l.on("connect", s))));
    }
  });
}
function Gs(e, t) {
  function n(i) {
    return typeof t == "function" ? t(i) : typeof t == "string" ? i[t] : !0;
  }
  const r = e.ethereum;
  if (r != null && r.providers)
    return r.providers.find((i) => n(i));
  if (r && n(r))
    return r;
}
function eB(e) {
  if (typeof window > "u")
    return;
  const t = (n) => e(n.detail);
  return window.addEventListener("eip6963:announceProvider", t), window.dispatchEvent(new CustomEvent("eip6963:requestProvider")), () => window.removeEventListener("eip6963:announceProvider", t);
}
function tB() {
  const e = /* @__PURE__ */ new Set();
  let t = [];
  const n = () => eB((i) => {
    t.some(({ info: o }) => o.uuid === i.info.uuid) || (t = [...t, i], e.forEach((o) => o(t, { added: [i] })));
  });
  let r = n();
  return {
    _listeners() {
      return e;
    },
    clear() {
      e.forEach((i) => i([], { removed: [...t] })), t = [];
    },
    destroy() {
      this.clear(), e.clear(), r == null || r();
    },
    findProvider({ rdns: i }) {
      return t.find((o) => o.info.rdns === i);
    },
    getProviders() {
      return t;
    },
    reset() {
      this.clear(), r == null || r(), r = n();
    },
    subscribe(i, { emitImmediately: o } = {}) {
      return e.add(i), o && i(t, { added: t }), () => e.delete(i);
    }
  };
}
const nB = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, rB = (e) => (t, n, r) => {
  const i = r.subscribe;
  return r.subscribe = (s, a, c) => {
    let u = s;
    if (a) {
      const l = (c == null ? void 0 : c.equalityFn) || Object.is;
      let d = s(r.getState());
      u = (f) => {
        const h = s(f);
        if (!l(d, h)) {
          const g = d;
          a(d = h, g);
        }
      }, c != null && c.fireImmediately && a(d, d);
    }
    return i(u);
  }, e(t, n, r);
}, iB = rB;
function oB(e, t) {
  let n;
  try {
    n = e();
  } catch {
    return;
  }
  return {
    getItem: (i) => {
      var o;
      const s = (c) => c === null ? null : JSON.parse(c, void 0), a = (o = n.getItem(i)) != null ? o : null;
      return a instanceof Promise ? a.then(s) : s(a);
    },
    setItem: (i, o) => n.setItem(
      i,
      JSON.stringify(o, void 0)
    ),
    removeItem: (i) => n.removeItem(i)
  };
}
const Qo = (e) => (t) => {
  try {
    const n = e(t);
    return n instanceof Promise ? n : {
      then(r) {
        return Qo(r)(n);
      },
      catch(r) {
        return this;
      }
    };
  } catch (n) {
    return {
      then(r) {
        return this;
      },
      catch(r) {
        return Qo(r)(n);
      }
    };
  }
}, sB = (e, t) => (n, r, i) => {
  let o = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: (p) => p,
    version: 0,
    merge: (p, v) => ({
      ...v,
      ...p
    }),
    ...t
  }, s = !1;
  const a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let u;
  try {
    u = o.getStorage();
  } catch {
  }
  if (!u)
    return e(
      (...p) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${o.name}', the given storage is currently unavailable.`
        ), n(...p);
      },
      r,
      i
    );
  const l = Qo(o.serialize), d = () => {
    const p = o.partialize({ ...r() });
    let v;
    const b = l({ state: p, version: o.version }).then(
      (y) => u.setItem(o.name, y)
    ).catch((y) => {
      v = y;
    });
    if (v)
      throw v;
    return b;
  }, f = i.setState;
  i.setState = (p, v) => {
    f(p, v), d();
  };
  const h = e(
    (...p) => {
      n(...p), d();
    },
    r,
    i
  );
  let g;
  const m = () => {
    var p;
    if (!u)
      return;
    s = !1, a.forEach((b) => b(r()));
    const v = ((p = o.onRehydrateStorage) == null ? void 0 : p.call(o, r())) || void 0;
    return Qo(u.getItem.bind(u))(o.name).then((b) => {
      if (b)
        return o.deserialize(b);
    }).then((b) => {
      if (b)
        if (typeof b.version == "number" && b.version !== o.version) {
          if (o.migrate)
            return o.migrate(
              b.state,
              b.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return b.state;
    }).then((b) => {
      var y;
      return g = o.merge(
        b,
        (y = r()) != null ? y : h
      ), n(g, !0), d();
    }).then(() => {
      v == null || v(g, void 0), s = !0, c.forEach((b) => b(g));
    }).catch((b) => {
      v == null || v(void 0, b);
    });
  };
  return i.persist = {
    setOptions: (p) => {
      o = {
        ...o,
        ...p
      }, p.getStorage && (u = p.getStorage());
    },
    clearStorage: () => {
      u == null || u.removeItem(o.name);
    },
    getOptions: () => o,
    rehydrate: () => m(),
    hasHydrated: () => s,
    onHydrate: (p) => (a.add(p), () => {
      a.delete(p);
    }),
    onFinishHydration: (p) => (c.add(p), () => {
      c.delete(p);
    })
  }, m(), g || h;
}, aB = (e, t) => (n, r, i) => {
  let o = {
    storage: oB(() => localStorage),
    partialize: (m) => m,
    version: 0,
    merge: (m, p) => ({
      ...p,
      ...m
    }),
    ...t
  }, s = !1;
  const a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let u = o.storage;
  if (!u)
    return e(
      (...m) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${o.name}', the given storage is currently unavailable.`
        ), n(...m);
      },
      r,
      i
    );
  const l = () => {
    const m = o.partialize({ ...r() });
    return u.setItem(o.name, {
      state: m,
      version: o.version
    });
  }, d = i.setState;
  i.setState = (m, p) => {
    d(m, p), l();
  };
  const f = e(
    (...m) => {
      n(...m), l();
    },
    r,
    i
  );
  let h;
  const g = () => {
    var m, p;
    if (!u)
      return;
    s = !1, a.forEach((b) => {
      var y;
      return b((y = r()) != null ? y : f);
    });
    const v = ((p = o.onRehydrateStorage) == null ? void 0 : p.call(o, (m = r()) != null ? m : f)) || void 0;
    return Qo(u.getItem.bind(u))(o.name).then((b) => {
      if (b)
        if (typeof b.version == "number" && b.version !== o.version) {
          if (o.migrate)
            return o.migrate(
              b.state,
              b.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return b.state;
    }).then((b) => {
      var y;
      return h = o.merge(
        b,
        (y = r()) != null ? y : f
      ), n(h, !0), l();
    }).then(() => {
      v == null || v(h, void 0), h = r(), s = !0, c.forEach((b) => b(h));
    }).catch((b) => {
      v == null || v(void 0, b);
    });
  };
  return i.persist = {
    setOptions: (m) => {
      o = {
        ...o,
        ...m
      }, m.storage && (u = m.storage);
    },
    clearStorage: () => {
      u == null || u.removeItem(o.name);
    },
    getOptions: () => o,
    rehydrate: () => g(),
    hasHydrated: () => s,
    onHydrate: (m) => (a.add(m), () => {
      a.delete(m);
    }),
    onFinishHydration: (m) => (c.add(m), () => {
      c.delete(m);
    })
  }, o.skipHydration || g(), h || f;
}, cB = (e, t) => "getStorage" in t || "serialize" in t || "deserialize" in t ? ((nB ? "production" : void 0) !== "production" && console.warn(
  "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
), sB(e, t)) : aB(e, t), uB = cB, lB = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, _f = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, u) => {
    const l = typeof c == "function" ? c(t) : c;
    if (!Object.is(l, t)) {
      const d = t;
      t = u ?? typeof l != "object" ? l : Object.assign({}, t, l), n.forEach((f) => f(t, d));
    }
  }, i = () => t, a = { setState: r, getState: i, subscribe: (c) => (n.add(c), () => n.delete(c)), destroy: () => {
    (lB ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } };
  return t = e(r, i, a), a;
}, Vc = (e) => e ? _f(e) : _f;
var ep = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(c, u, l) {
    this.fn = c, this.context = u, this.once = l || !1;
  }
  function o(c, u, l, d, f) {
    if (typeof l != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(l, d || c, f), g = n ? n + u : u;
    return c._events[g] ? c._events[g].fn ? c._events[g] = [c._events[g], h] : c._events[g].push(h) : (c._events[g] = h, c._eventsCount++), c;
  }
  function s(c, u) {
    --c._eventsCount === 0 ? c._events = new r() : delete c._events[u];
  }
  function a() {
    this._events = new r(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var u = [], l, d;
    if (this._eventsCount === 0) return u;
    for (d in l = this._events)
      t.call(l, d) && u.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(l)) : u;
  }, a.prototype.listeners = function(u) {
    var l = n ? n + u : u, d = this._events[l];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var f = 0, h = d.length, g = new Array(h); f < h; f++)
      g[f] = d[f].fn;
    return g;
  }, a.prototype.listenerCount = function(u) {
    var l = n ? n + u : u, d = this._events[l];
    return d ? d.fn ? 1 : d.length : 0;
  }, a.prototype.emit = function(u, l, d, f, h, g) {
    var m = n ? n + u : u;
    if (!this._events[m]) return !1;
    var p = this._events[m], v = arguments.length, b, y;
    if (p.fn) {
      switch (p.once && this.removeListener(u, p.fn, void 0, !0), v) {
        case 1:
          return p.fn.call(p.context), !0;
        case 2:
          return p.fn.call(p.context, l), !0;
        case 3:
          return p.fn.call(p.context, l, d), !0;
        case 4:
          return p.fn.call(p.context, l, d, f), !0;
        case 5:
          return p.fn.call(p.context, l, d, f, h), !0;
        case 6:
          return p.fn.call(p.context, l, d, f, h, g), !0;
      }
      for (y = 1, b = new Array(v - 1); y < v; y++)
        b[y - 1] = arguments[y];
      p.fn.apply(p.context, b);
    } else {
      var E = p.length, C;
      for (y = 0; y < E; y++)
        switch (p[y].once && this.removeListener(u, p[y].fn, void 0, !0), v) {
          case 1:
            p[y].fn.call(p[y].context);
            break;
          case 2:
            p[y].fn.call(p[y].context, l);
            break;
          case 3:
            p[y].fn.call(p[y].context, l, d);
            break;
          case 4:
            p[y].fn.call(p[y].context, l, d, f);
            break;
          default:
            if (!b) for (C = 1, b = new Array(v - 1); C < v; C++)
              b[C - 1] = arguments[C];
            p[y].fn.apply(p[y].context, b);
        }
    }
    return !0;
  }, a.prototype.on = function(u, l, d) {
    return o(this, u, l, d, !1);
  }, a.prototype.once = function(u, l, d) {
    return o(this, u, l, d, !0);
  }, a.prototype.removeListener = function(u, l, d, f) {
    var h = n ? n + u : u;
    if (!this._events[h]) return this;
    if (!l)
      return s(this, h), this;
    var g = this._events[h];
    if (g.fn)
      g.fn === l && (!f || g.once) && (!d || g.context === d) && s(this, h);
    else {
      for (var m = 0, p = [], v = g.length; m < v; m++)
        (g[m].fn !== l || f && !g[m].once || d && g[m].context !== d) && p.push(g[m]);
      p.length ? this._events[h] = p.length === 1 ? p[0] : p : s(this, h);
    }
    return this;
  }, a.prototype.removeAllListeners = function(u) {
    var l;
    return u ? (l = n ? n + u : u, this._events[l] && s(this, l)) : (this._events = new r(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = n, a.EventEmitter = a, e.exports = a;
})(ep);
var dB = ep.exports;
const AB = /* @__PURE__ */ Li(dB);
class fB {
  constructor(t) {
    Object.defineProperty(this, "uid", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }), Object.defineProperty(this, "_emitter", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: new AB()
    });
  }
  on(t, n) {
    this._emitter.on(t, n);
  }
  once(t, n) {
    this._emitter.once(t, n);
  }
  off(t, n) {
    this._emitter.off(t, n);
  }
  emit(t, ...n) {
    const r = n[0];
    this._emitter.emit(t, { uid: this.uid, ...r });
  }
  listenerCount(t) {
    return this._emitter.listenerCount(t);
  }
}
function gB(e) {
  return new fB(e);
}
function hB(e, t) {
  return JSON.parse(e, (n, r) => {
    let i = r;
    return (i == null ? void 0 : i.__type) === "bigint" && (i = BigInt(i.value)), (i == null ? void 0 : i.__type) === "Map" && (i = new Map(i.value)), (t == null ? void 0 : t(n, i)) ?? i;
  });
}
function $f(e, t) {
  return e.slice(0, t).join(".") || ".";
}
function e1(e, t) {
  const { length: n } = e;
  for (let r = 0; r < n; ++r)
    if (e[r] === t)
      return r + 1;
  return 0;
}
function pB(e, t) {
  const n = typeof e == "function", r = typeof t == "function", i = [], o = [];
  return function(a, c) {
    if (typeof c == "object")
      if (i.length) {
        const u = e1(i, this);
        u === 0 ? i[i.length] = this : (i.splice(u), o.splice(u)), o[o.length] = a;
        const l = e1(i, c);
        if (l !== 0)
          return r ? t.call(this, a, c, $f(o, l)) : `[ref=${$f(o, l)}]`;
      } else
        i[0] = c, o[0] = a;
    return n ? e.call(this, a, c) : c;
  };
}
function mB(e, t, n, r) {
  return JSON.stringify(e, pB((i, o) => {
    let s = o;
    return typeof s == "bigint" && (s = { __type: "bigint", value: o.toString() }), s instanceof Map && (s = { __type: "Map", value: Array.from(o.entries()) }), (t == null ? void 0 : t(i, s)) ?? s;
  }, r), n ?? void 0);
}
function vB(e) {
  const { deserialize: t = hB, key: n = "wagmi", serialize: r = mB, storage: i = tp } = e;
  function o(s) {
    return s instanceof Promise ? s.then((a) => a).catch(() => null) : s;
  }
  return {
    ...i,
    key: n,
    async getItem(s, a) {
      const c = i.getItem(`${n}.${s}`), u = await o(c);
      return u ? t(u) ?? null : a ?? null;
    },
    async setItem(s, a) {
      const c = `${n}.${s}`;
      a === null ? await o(i.removeItem(c)) : await o(i.setItem(c, r(a)));
    },
    async removeItem(s) {
      await o(i.removeItem(`${n}.${s}`));
    }
  };
}
const tp = {
  getItem: () => null,
  setItem: () => {
  },
  removeItem: () => {
  }
}, al = 256;
let Ds = al, Ss;
function bB(e = 11) {
  if (!Ss || Ds + e > al * 2) {
    Ss = "", Ds = 0;
    for (let t = 0; t < al; t++)
      Ss += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return Ss.substring(Ds, Ds++ + e);
}
function yB(e) {
  const { multiInjectedProviderDiscovery: t = !0, storage: n = vB({
    storage: typeof window < "u" && window.localStorage ? window.localStorage : tp
  }), syncConnectedChain: r = !0, ssr: i = !1, ...o } = e, s = typeof window < "u" && t ? tB() : void 0, a = Vc(() => o.chains), c = Vc(() => [
    ...o.connectors ?? [],
    ...i ? [] : (s == null ? void 0 : s.getProviders().map(l)) ?? []
  ].map(u));
  function u(C) {
    var x;
    const B = gB(bB()), I = {
      ...C({
        emitter: B,
        chains: a.getState(),
        storage: n,
        transports: o.transports
      }),
      emitter: B,
      uid: B.uid
    };
    return B.on("connect", y), (x = I.setup) == null || x.call(I), I;
  }
  function l(C) {
    const { info: B } = C, I = C.provider;
    return Ud({ target: { ...B, id: B.rdns, provider: I } });
  }
  const d = /* @__PURE__ */ new Map();
  function f(C = {}) {
    const B = C.chainId ?? p.getState().chainId, I = a.getState().find((O) => O.id === B);
    if (C.chainId && !I)
      throw new ol();
    {
      const O = d.get(p.getState().chainId);
      if (O && !I)
        return O;
      if (!I)
        throw new ol();
    }
    {
      const O = d.get(B);
      if (O)
        return O;
    }
    let x;
    if (o.client)
      x = o.client({ chain: I });
    else {
      const O = I.id, k = a.getState().map((M) => M.id), Q = {}, F = Object.entries(o);
      for (const [M, H] of F)
        if (!(M === "chains" || M === "client" || M === "connectors" || M === "transports"))
          if (typeof H == "object")
            if (O in H)
              Q[M] = H[O];
            else {
              if (k.some((R) => R in H))
                continue;
              Q[M] = H;
            }
          else
            Q[M] = H;
      x = Wx({
        ...Q,
        chain: I,
        batch: Q.batch ?? { multicall: !0 },
        transport: (M) => o.transports[O]({ ...M, connectors: c })
      });
    }
    return d.set(B, x), x;
  }
  function h() {
    return {
      chainId: a.getState()[0].id,
      connections: /* @__PURE__ */ new Map(),
      current: null,
      status: "disconnected"
    };
  }
  let g;
  const m = "0.0.0-canary-";
  Zs.startsWith(m) ? g = Number.parseInt(Zs.replace(m, "")) : g = Number.parseInt(Zs.split(".")[0] ?? "0");
  const p = Vc(iB(
    // only use persist middleware if storage exists
    n ? uB(h, {
      migrate(C, B) {
        if (B === g)
          return C;
        const I = h(), x = v(C, I.chainId);
        return { ...I, chainId: x };
      },
      name: "store",
      partialize(C) {
        return {
          connections: {
            __type: "Map",
            value: Array.from(C.connections.entries()).map(([B, I]) => {
              const { id: x, name: O, type: k, uid: Q } = I.connector;
              return [B, { ...I, connector: { id: x, name: O, type: k, uid: Q } }];
            })
          },
          chainId: C.chainId,
          current: C.current
        };
      },
      merge(C, B) {
        typeof C == "object" && C && "status" in C && delete C.status;
        const I = v(C, B.chainId);
        return {
          ...B,
          ...C,
          chainId: I
        };
      },
      skipHydration: i,
      storage: n,
      version: g
    }) : h
  ));
  function v(C, B) {
    return C && typeof C == "object" && "chainId" in C && typeof C.chainId == "number" && a.getState().some((I) => I.id === C.chainId) ? C.chainId : B;
  }
  r && p.subscribe(({ connections: C, current: B }) => {
    var I;
    return B ? (I = C.get(B)) == null ? void 0 : I.chainId : void 0;
  }, (C) => {
    if (a.getState().some((I) => I.id === C))
      return p.setState((I) => ({
        ...I,
        chainId: C ?? I.chainId
      }));
  }), s == null || s.subscribe((C) => {
    const B = /* @__PURE__ */ new Map();
    for (const x of c.getState())
      B.set(x.id, !0);
    const I = [];
    for (const x of C) {
      const O = u(l(x));
      B.has(O.id) || I.push(O);
    }
    n && !p.persist.hasHydrated() || c.setState((x) => [...x, ...I], !0);
  });
  function b(C) {
    p.setState((B) => {
      const I = B.connections.get(C.uid);
      return I ? {
        ...B,
        connections: new Map(B.connections).set(C.uid, {
          accounts: C.accounts ?? I.accounts,
          chainId: C.chainId ?? I.chainId,
          connector: I.connector
        })
      } : B;
    });
  }
  function y(C) {
    p.getState().status === "connecting" || p.getState().status === "reconnecting" || p.setState((B) => {
      const I = c.getState().find((x) => x.uid === C.uid);
      return I ? (I.emitter.listenerCount("connect") && I.emitter.off("connect", b), I.emitter.listenerCount("change") || I.emitter.on("change", b), I.emitter.listenerCount("disconnect") || I.emitter.on("disconnect", E), {
        ...B,
        connections: new Map(B.connections).set(C.uid, {
          accounts: C.accounts,
          chainId: C.chainId,
          connector: I
        }),
        current: C.uid,
        status: "connected"
      }) : B;
    });
  }
  function E(C) {
    p.setState((B) => {
      const I = B.connections.get(C.uid);
      if (I) {
        const O = I.connector;
        O.emitter.listenerCount("change") && I.connector.emitter.off("change", b), O.emitter.listenerCount("disconnect") && I.connector.emitter.off("disconnect", E), O.emitter.listenerCount("connect") || I.connector.emitter.on("connect", y);
      }
      if (B.connections.delete(C.uid), B.connections.size === 0)
        return {
          ...B,
          connections: /* @__PURE__ */ new Map(),
          current: null,
          status: "disconnected"
        };
      const x = B.connections.values().next().value;
      return {
        ...B,
        connections: new Map(B.connections),
        current: x.connector.uid
      };
    });
  }
  return {
    get chains() {
      return a.getState();
    },
    get connectors() {
      return c.getState();
    },
    storage: n,
    getClient: f,
    get state() {
      return p.getState();
    },
    setState(C) {
      let B;
      typeof C == "function" ? B = C(p.getState()) : B = C;
      const I = h();
      typeof B != "object" && (B = I), Object.keys(I).some((O) => !(O in B)) && (B = I), p.setState(B, !0);
    },
    subscribe(C, B, I) {
      return p.subscribe(C, B, I ? {
        ...I,
        fireImmediately: I.emitImmediately
        // Workaround cast since Zustand does not support `'exactOptionalPropertyTypes'`
      } : void 0);
    },
    _internal: {
      mipd: s,
      store: p,
      ssr: !!i,
      syncConnectedChain: r,
      transports: o.transports,
      chains: {
        setState(C) {
          const B = typeof C == "function" ? C(a.getState()) : C;
          if (B.length !== 0)
            return a.setState(B, !0);
        },
        subscribe(C) {
          return a.subscribe(C);
        }
      },
      connectors: {
        providerDetailToConnector: l,
        setup: u,
        setState(C) {
          return c.setState(typeof C == "function" ? C(c.getState()) : C, !0);
        },
        subscribe(C) {
          return c.subscribe(C);
        }
      },
      events: { change: b, connect: y, disconnect: E }
    }
  };
}
function CB(e, t) {
  const { initialState: n, reconnectOnMount: r } = t;
  return n && !e._internal.store.persist.hasHydrated() && e.setState({
    ...n,
    chainId: e.chains.some((i) => i.id === n.chainId) ? n.chainId : e.chains[0].id,
    connections: r ? n.connections : /* @__PURE__ */ new Map(),
    status: r ? "reconnecting" : "disconnected"
  }), {
    async onMount() {
      var i;
      if (e._internal.ssr) {
        await e._internal.store.persist.rehydrate();
        const o = (i = e._internal.mipd) == null ? void 0 : i.getProviders().map(e._internal.connectors.providerDetailToConnector).map(e._internal.connectors.setup);
        e._internal.connectors.setState((s) => [
          ...s,
          ...o ?? []
        ]);
      }
      r ? Jx(e) : e.storage && e.setState((o) => ({
        ...o,
        connections: /* @__PURE__ */ new Map()
      }));
    }
  };
}
function IB(e) {
  const { children: t, config: n, initialState: r, reconnectOnMount: i = !0 } = e, { onMount: o } = CB(n, {
    initialState: r,
    reconnectOnMount: i
  });
  n._internal.ssr || o();
  const s = Ce(!0);
  return Ie(() => {
    if (s.current && n._internal.ssr)
      return o(), () => {
        s.current = !1;
      };
  }, []), t;
}
const np = Ml(void 0);
function EB(e) {
  const { children: t, config: n } = e, r = { value: n };
  return bi(IB, e, bi(np.Provider, r, t));
}
const xB = "2.12.12", BB = () => `wagmi@${xB}`;
class wB extends Yd {
  constructor() {
    super(...arguments), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiError"
    });
  }
  get docsBaseUrl() {
    return "https://wagmi.sh/react";
  }
  get version() {
    return BB();
  }
}
class PB extends wB {
  constructor() {
    super("`useConfig` must be used within `WagmiProvider`.", {
      docsPath: "/api/WagmiProvider"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiProviderNotFoundError"
    });
  }
}
function Jd(e = {}) {
  const t = e.config ?? Oa(np);
  if (!t)
    throw new PB();
  return t;
}
var is = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Pi = typeof window > "u" || "Deno" in globalThis;
function Lt() {
}
function HB(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function cl(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function rp(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function ri(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function jt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function t1(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: a
  } = e;
  if (s) {
    if (r) {
      if (t.queryHash !== Kd(s, t.options))
        return !1;
    } else if (!Vo(t.queryKey, s))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof a == "boolean" && t.isStale() !== a || i && i !== t.state.fetchStatus || o && !o(t));
}
function n1(e, t) {
  const { exact: n, status: r, predicate: i, mutationKey: o } = e;
  if (o) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Xo(t.options.mutationKey) !== Xo(o))
        return !1;
    } else if (!Vo(t.options.mutationKey, o))
      return !1;
  }
  return !(r && t.state.status !== r || i && !i(t));
}
function Kd(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Xo)(e);
}
function Xo(e) {
  return JSON.stringify(
    e,
    (t, n) => dl(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
function Vo(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !Vo(e[n], t[n])) : !1;
}
function ul(e, t) {
  if (e === t)
    return e;
  const n = r1(e) && r1(t);
  if (n || dl(e) && dl(t)) {
    const r = n ? e : Object.keys(e), i = r.length, o = n ? t : Object.keys(t), s = o.length, a = n ? [] : {};
    let c = 0;
    for (let u = 0; u < s; u++) {
      const l = n ? u : o[u];
      (!n && r.includes(l) || n) && e[l] === void 0 && t[l] === void 0 ? (a[l] = void 0, c++) : (a[l] = ul(e[l], t[l]), a[l] === e[l] && e[l] !== void 0 && c++);
    }
    return i === s && c === i ? e : a;
  }
  return t;
}
function ll(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function r1(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function dl(e) {
  if (!i1(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!i1(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function i1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function OB(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Al(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return ul(e, t);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        );
      }
    return ul(e, t);
  }
  return t;
}
function DB(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function SB(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var fl = Symbol();
function ip(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === fl && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === fl ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var sr, Rn, si, c0, NB = (c0 = class extends is {
  constructor() {
    super();
    ye(this, sr);
    ye(this, Rn);
    ye(this, si);
    ue(this, si, (t) => {
      if (!Pi && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    N(this, Rn) || this.setEventListener(N(this, si));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = N(this, Rn)) == null || t.call(this), ue(this, Rn, void 0));
  }
  setEventListener(t) {
    var n;
    ue(this, si, t), (n = N(this, Rn)) == null || n.call(this), ue(this, Rn, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    N(this, sr) !== t && (ue(this, sr, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof N(this, sr) == "boolean" ? N(this, sr) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, sr = new WeakMap(), Rn = new WeakMap(), si = new WeakMap(), c0), _d = new NB(), ai, Ln, ci, u0, TB = (u0 = class extends is {
  constructor() {
    super();
    ye(this, ai, !0);
    ye(this, Ln);
    ye(this, ci);
    ue(this, ci, (t) => {
      if (!Pi && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    N(this, Ln) || this.setEventListener(N(this, ci));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = N(this, Ln)) == null || t.call(this), ue(this, Ln, void 0));
  }
  setEventListener(t) {
    var n;
    ue(this, ci, t), (n = N(this, Ln)) == null || n.call(this), ue(this, Ln, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    N(this, ai) !== t && (ue(this, ai, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return N(this, ai);
  }
}, ai = new WeakMap(), Ln = new WeakMap(), ci = new WeakMap(), u0), pa = new TB();
function RB(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function op(e) {
  return (e ?? "online") === "online" ? pa.isOnline() : !0;
}
var sp = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function kc(e) {
  return e instanceof sp;
}
function ap(e) {
  let t = !1, n = 0, r = !1, i, o, s;
  const a = new Promise((v, b) => {
    o = v, s = b;
  }), c = (v) => {
    var b;
    r || (g(new sp(v)), (b = e.abort) == null || b.call(e));
  }, u = () => {
    t = !0;
  }, l = () => {
    t = !1;
  }, d = () => _d.isFocused() && (e.networkMode === "always" || pa.isOnline()) && e.canRun(), f = () => op(e.networkMode) && e.canRun(), h = (v) => {
    var b;
    r || (r = !0, (b = e.onSuccess) == null || b.call(e, v), i == null || i(), o(v));
  }, g = (v) => {
    var b;
    r || (r = !0, (b = e.onError) == null || b.call(e, v), i == null || i(), s(v));
  }, m = () => new Promise((v) => {
    var b;
    i = (y) => {
      (r || d()) && v(y);
    }, (b = e.onPause) == null || b.call(e);
  }).then(() => {
    var v;
    i = void 0, r || (v = e.onContinue) == null || v.call(e);
  }), p = () => {
    if (r)
      return;
    let v;
    const b = n === 0 ? e.initialPromise : void 0;
    try {
      v = b ?? e.fn();
    } catch (y) {
      v = Promise.reject(y);
    }
    Promise.resolve(v).then(h).catch((y) => {
      var x;
      if (r)
        return;
      const E = e.retry ?? (Pi ? 0 : 3), C = e.retryDelay ?? RB, B = typeof C == "function" ? C(n, y) : C, I = E === !0 || typeof E == "number" && n < E || typeof E == "function" && E(n, y);
      if (t || !I) {
        g(y);
        return;
      }
      n++, (x = e.onFail) == null || x.call(e, n, y), OB(B).then(() => d() ? void 0 : m()).then(() => {
        t ? g(y) : p();
      });
    });
  };
  return {
    promise: a,
    cancel: c,
    continue: () => (i == null || i(), a),
    cancelRetry: u,
    continueRetry: l,
    canStart: f,
    start: () => (f() ? p() : m().then(p), a)
  };
}
function LB() {
  let e = [], t = 0, n = (a) => {
    a();
  }, r = (a) => {
    a();
  }, i = (a) => setTimeout(a, 0);
  const o = (a) => {
    t ? e.push(a) : i(() => {
      n(a);
    });
  }, s = () => {
    const a = e;
    e = [], a.length && i(() => {
      r(() => {
        a.forEach((c) => {
          n(c);
        });
      });
    });
  };
  return {
    batch: (a) => {
      let c;
      t++;
      try {
        c = a();
      } finally {
        t--, t || s();
      }
      return c;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (a) => (...c) => {
      o(() => {
        a(...c);
      });
    },
    schedule: o,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (a) => {
      n = a;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (a) => {
      r = a;
    },
    setScheduler: (a) => {
      i = a;
    }
  };
}
var ot = LB(), ar, l0, cp = (l0 = class {
  constructor() {
    ye(this, ar);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), cl(this.gcTime) && ue(this, ar, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (Pi ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    N(this, ar) && (clearTimeout(N(this, ar)), ue(this, ar, void 0));
  }
}, ar = new WeakMap(), l0), ui, li, Rt, ut, Uo, cr, zt, bn, d0, FB = (d0 = class extends cp {
  constructor(t) {
    super();
    ye(this, zt);
    ye(this, ui);
    ye(this, li);
    ye(this, Rt);
    ye(this, ut);
    ye(this, Uo);
    ye(this, cr);
    ue(this, cr, !1), ue(this, Uo, t.defaultOptions), this.setOptions(t.options), this.observers = [], ue(this, Rt, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, ue(this, ui, QB(this.options)), this.state = t.state ?? N(this, ui), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = N(this, ut)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...N(this, Uo), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && N(this, Rt).remove(this);
  }
  setData(t, n) {
    const r = Al(this.state.data, t, this.options);
    return He(this, zt, bn).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    He(this, zt, bn).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, i;
    const n = (r = N(this, ut)) == null ? void 0 : r.promise;
    return (i = N(this, ut)) == null || i.cancel(t), n ? n.then(Lt).catch(Lt) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(N(this, ui));
  }
  isActive() {
    return this.observers.some(
      (t) => jt(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !rp(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = N(this, ut)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = N(this, ut)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), N(this, Rt).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (N(this, ut) && (N(this, cr) ? N(this, ut).cancel({ revert: !0 }) : N(this, ut).cancelRetry()), this.scheduleGc()), N(this, Rt).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || He(this, zt, bn).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var c, u, l;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (N(this, ut))
        return N(this, ut).continueRetry(), N(this, ut).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const d = this.observers.find((f) => f.options.queryFn);
      d && this.setOptions(d.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), i = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => (ue(this, cr, !0), r.signal)
      });
    }, o = () => {
      const d = ip(this.options, n), f = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return i(f), ue(this, cr, !1), this.options.persister ? this.options.persister(
        d,
        f,
        this
      ) : d(f);
    }, s = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: o
    };
    i(s), (c = this.options.behavior) == null || c.onFetch(
      s,
      this
    ), ue(this, li, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = s.fetchOptions) == null ? void 0 : u.meta)) && He(this, zt, bn).call(this, { type: "fetch", meta: (l = s.fetchOptions) == null ? void 0 : l.meta });
    const a = (d) => {
      var f, h, g, m;
      kc(d) && d.silent || He(this, zt, bn).call(this, {
        type: "error",
        error: d
      }), kc(d) || ((h = (f = N(this, Rt).config).onError) == null || h.call(
        f,
        d,
        this
      ), (m = (g = N(this, Rt).config).onSettled) == null || m.call(
        g,
        this.state.data,
        d,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return ue(this, ut, ap({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: s.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (d) => {
        var f, h, g, m;
        if (d === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), a(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(d);
        } catch (p) {
          a(p);
          return;
        }
        (h = (f = N(this, Rt).config).onSuccess) == null || h.call(f, d, this), (m = (g = N(this, Rt).config).onSettled) == null || m.call(
          g,
          d,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: a,
      onFail: (d, f) => {
        He(this, zt, bn).call(this, { type: "failed", failureCount: d, error: f });
      },
      onPause: () => {
        He(this, zt, bn).call(this, { type: "pause" });
      },
      onContinue: () => {
        He(this, zt, bn).call(this, { type: "continue" });
      },
      retry: s.options.retry,
      retryDelay: s.options.retryDelay,
      networkMode: s.options.networkMode,
      canRun: () => !0
    })), N(this, ut).start();
  }
}, ui = new WeakMap(), li = new WeakMap(), Rt = new WeakMap(), ut = new WeakMap(), Uo = new WeakMap(), cr = new WeakMap(), zt = new WeakSet(), bn = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...up(r.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const i = t.error;
        return kc(i) && i.revert && N(this, li) ? { ...N(this, li), fetchStatus: "idle" } : {
          ...r,
          error: i,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: i,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = n(this.state), ot.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), N(this, Rt).notify({ query: this, type: "updated", action: t });
  });
}, d0);
function up(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: op(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function QB(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var tn, A0, XB = (A0 = class extends is {
  constructor(t = {}) {
    super();
    ye(this, tn);
    this.config = t, ue(this, tn, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    const i = n.queryKey, o = n.queryHash ?? Kd(i, n);
    let s = this.get(o);
    return s || (s = new FB({
      cache: this,
      queryKey: i,
      queryHash: o,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(i)
    }), this.add(s)), s;
  }
  add(t) {
    N(this, tn).has(t.queryHash) || (N(this, tn).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = N(this, tn).get(t.queryHash);
    n && (t.destroy(), n === t && N(this, tn).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return N(this, tn).get(t);
  }
  getAll() {
    return [...N(this, tn).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => t1(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => t1(t, r)) : n;
  }
  notify(t) {
    ot.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, tn = new WeakMap(), A0), nn, dt, ur, rn, Sn, f0, VB = (f0 = class extends cp {
  constructor(t) {
    super();
    ye(this, rn);
    ye(this, nn);
    ye(this, dt);
    ye(this, ur);
    this.mutationId = t.mutationId, ue(this, dt, t.mutationCache), ue(this, nn, []), this.state = t.state || kB(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    N(this, nn).includes(t) || (N(this, nn).push(t), this.clearGcTimeout(), N(this, dt).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    ue(this, nn, N(this, nn).filter((n) => n !== t)), this.scheduleGc(), N(this, dt).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    N(this, nn).length || (this.state.status === "pending" ? this.scheduleGc() : N(this, dt).remove(this));
  }
  continue() {
    var t;
    return ((t = N(this, ur)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var i, o, s, a, c, u, l, d, f, h, g, m, p, v, b, y, E, C, B, I;
    ue(this, ur, ap({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (x, O) => {
        He(this, rn, Sn).call(this, { type: "failed", failureCount: x, error: O });
      },
      onPause: () => {
        He(this, rn, Sn).call(this, { type: "pause" });
      },
      onContinue: () => {
        He(this, rn, Sn).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => N(this, dt).canRun(this)
    }));
    const n = this.state.status === "pending", r = !N(this, ur).canStart();
    try {
      if (!n) {
        He(this, rn, Sn).call(this, { type: "pending", variables: t, isPaused: r }), await ((o = (i = N(this, dt).config).onMutate) == null ? void 0 : o.call(
          i,
          t,
          this
        ));
        const O = await ((a = (s = this.options).onMutate) == null ? void 0 : a.call(s, t));
        O !== this.state.context && He(this, rn, Sn).call(this, {
          type: "pending",
          context: O,
          variables: t,
          isPaused: r
        });
      }
      const x = await N(this, ur).start();
      return await ((u = (c = N(this, dt).config).onSuccess) == null ? void 0 : u.call(
        c,
        x,
        t,
        this.state.context,
        this
      )), await ((d = (l = this.options).onSuccess) == null ? void 0 : d.call(l, x, t, this.state.context)), await ((h = (f = N(this, dt).config).onSettled) == null ? void 0 : h.call(
        f,
        x,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((m = (g = this.options).onSettled) == null ? void 0 : m.call(g, x, null, t, this.state.context)), He(this, rn, Sn).call(this, { type: "success", data: x }), x;
    } catch (x) {
      try {
        throw await ((v = (p = N(this, dt).config).onError) == null ? void 0 : v.call(
          p,
          x,
          t,
          this.state.context,
          this
        )), await ((y = (b = this.options).onError) == null ? void 0 : y.call(
          b,
          x,
          t,
          this.state.context
        )), await ((C = (E = N(this, dt).config).onSettled) == null ? void 0 : C.call(
          E,
          void 0,
          x,
          this.state.variables,
          this.state.context,
          this
        )), await ((I = (B = this.options).onSettled) == null ? void 0 : I.call(
          B,
          void 0,
          x,
          t,
          this.state.context
        )), x;
      } finally {
        He(this, rn, Sn).call(this, { type: "error", error: x });
      }
    } finally {
      N(this, dt).runNext(this);
    }
  }
}, nn = new WeakMap(), dt = new WeakMap(), ur = new WeakMap(), rn = new WeakSet(), Sn = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), ot.batch(() => {
    N(this, nn).forEach((r) => {
      r.onMutationUpdate(t);
    }), N(this, dt).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, f0);
function kB() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var wt, Jo, g0, MB = (g0 = class extends is {
  constructor(t = {}) {
    super();
    ye(this, wt);
    ye(this, Jo);
    this.config = t, ue(this, wt, /* @__PURE__ */ new Map()), ue(this, Jo, Date.now());
  }
  build(t, n, r) {
    const i = new VB({
      mutationCache: this,
      mutationId: ++fs(this, Jo)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(i), i;
  }
  add(t) {
    const n = Ns(t), r = N(this, wt).get(n) ?? [];
    r.push(t), N(this, wt).set(n, r), this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    var r;
    const n = Ns(t);
    if (N(this, wt).has(n)) {
      const i = (r = N(this, wt).get(n)) == null ? void 0 : r.filter((o) => o !== t);
      i && (i.length === 0 ? N(this, wt).delete(n) : N(this, wt).set(n, i));
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    var r;
    const n = (r = N(this, wt).get(Ns(t))) == null ? void 0 : r.find((i) => i.state.status === "pending");
    return !n || n === t;
  }
  runNext(t) {
    var r;
    const n = (r = N(this, wt).get(Ns(t))) == null ? void 0 : r.find((i) => i !== t && i.state.isPaused);
    return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
  }
  clear() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return [...N(this, wt).values()].flat();
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => n1(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => n1(t, n));
  }
  notify(t) {
    ot.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return ot.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(Lt))
      )
    );
  }
}, wt = new WeakMap(), Jo = new WeakMap(), g0);
function Ns(e) {
  var t;
  return ((t = e.options.scope) == null ? void 0 : t.id) ?? String(e.mutationId);
}
function o1(e) {
  return {
    onFetch: (t, n) => {
      var l, d, f, h, g;
      const r = t.options, i = (f = (d = (l = t.fetchOptions) == null ? void 0 : l.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : f.direction, o = ((h = t.state.data) == null ? void 0 : h.pages) || [], s = ((g = t.state.data) == null ? void 0 : g.pageParams) || [];
      let a = { pages: [], pageParams: [] }, c = 0;
      const u = async () => {
        let m = !1;
        const p = (y) => {
          Object.defineProperty(y, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? m = !0 : t.signal.addEventListener("abort", () => {
              m = !0;
            }), t.signal)
          });
        }, v = ip(t.options, t.fetchOptions), b = async (y, E, C) => {
          if (m)
            return Promise.reject();
          if (E == null && y.pages.length)
            return Promise.resolve(y);
          const B = {
            queryKey: t.queryKey,
            pageParam: E,
            direction: C ? "backward" : "forward",
            meta: t.options.meta
          };
          p(B);
          const I = await v(
            B
          ), { maxPages: x } = t.options, O = C ? SB : DB;
          return {
            pages: O(y.pages, I, x),
            pageParams: O(y.pageParams, E, x)
          };
        };
        if (i && o.length) {
          const y = i === "backward", E = y ? zB : s1, C = {
            pages: o,
            pageParams: s
          }, B = E(r, C);
          a = await b(C, B, y);
        } else {
          const y = e ?? o.length;
          do {
            const E = c === 0 ? s[0] ?? r.initialPageParam : s1(r, a);
            if (c > 0 && E == null)
              break;
            a = await b(a, E), c++;
          } while (c < y);
        }
        return a;
      };
      t.options.persister ? t.fetchFn = () => {
        var m, p;
        return (p = (m = t.options).persister) == null ? void 0 : p.call(
          m,
          u,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = u;
    }
  };
}
function s1(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function zB(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var We, Fn, Qn, di, Ai, Xn, fi, gi, h0, jB = (h0 = class {
  constructor(e = {}) {
    ye(this, We);
    ye(this, Fn);
    ye(this, Qn);
    ye(this, di);
    ye(this, Ai);
    ye(this, Xn);
    ye(this, fi);
    ye(this, gi);
    ue(this, We, e.queryCache || new XB()), ue(this, Fn, e.mutationCache || new MB()), ue(this, Qn, e.defaultOptions || {}), ue(this, di, /* @__PURE__ */ new Map()), ue(this, Ai, /* @__PURE__ */ new Map()), ue(this, Xn, 0);
  }
  mount() {
    fs(this, Xn)._++, N(this, Xn) === 1 && (ue(this, fi, _d.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), N(this, We).onFocus());
    })), ue(this, gi, pa.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), N(this, We).onOnline());
    })));
  }
  unmount() {
    var e, t;
    fs(this, Xn)._--, N(this, Xn) === 0 && ((e = N(this, fi)) == null || e.call(this), ue(this, fi, void 0), (t = N(this, gi)) == null || t.call(this), ue(this, gi, void 0));
  }
  isFetching(e) {
    return N(this, We).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return N(this, Fn).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = N(this, We).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    if (t === void 0)
      return this.fetchQuery(e);
    {
      const n = this.defaultQueryOptions(e), r = N(this, We).build(this, n);
      return e.revalidateIfStale && r.isStaleByTime(ri(n.staleTime, r)) && this.prefetchQuery(n), Promise.resolve(t);
    }
  }
  getQueriesData(e) {
    return N(this, We).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), i = N(this, We).get(
      r.queryHash
    ), o = i == null ? void 0 : i.state.data, s = HB(t, o);
    if (s !== void 0)
      return N(this, We).build(this, r).setData(s, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return ot.batch(
      () => N(this, We).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = N(this, We).get(t.queryHash)) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = N(this, We);
    ot.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = N(this, We), r = {
      type: "active",
      ...e
    };
    return ot.batch(() => (n.findAll(e).forEach((i) => {
      i.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, r = ot.batch(
      () => N(this, We).findAll(e).map((i) => i.cancel(n))
    );
    return Promise.all(r).then(Lt).catch(Lt);
  }
  invalidateQueries(e = {}, t = {}) {
    return ot.batch(() => {
      if (N(this, We).findAll(e).forEach((r) => {
        r.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, r = ot.batch(
      () => N(this, We).findAll(e).filter((i) => !i.isDisabled()).map((i) => {
        let o = i.fetch(void 0, n);
        return n.throwOnError || (o = o.catch(Lt)), i.state.fetchStatus === "paused" ? Promise.resolve() : o;
      })
    );
    return Promise.all(r).then(Lt);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = N(this, We).build(this, t);
    return n.isStaleByTime(
      ri(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Lt).catch(Lt);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = o1(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Lt).catch(Lt);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = o1(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return pa.isOnline() ? N(this, Fn).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return N(this, We);
  }
  getMutationCache() {
    return N(this, Fn);
  }
  getDefaultOptions() {
    return N(this, Qn);
  }
  setDefaultOptions(e) {
    ue(this, Qn, e);
  }
  setQueryDefaults(e, t) {
    N(this, di).set(Xo(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...N(this, di).values()];
    let n = {};
    return t.forEach((r) => {
      Vo(e, r.queryKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    N(this, Ai).set(Xo(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...N(this, Ai).values()];
    let n = {};
    return t.forEach((r) => {
      Vo(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...N(this, Qn).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Kd(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.enabled !== !0 && t.queryFn === fl && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...N(this, Qn).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    N(this, We).clear(), N(this, Fn).clear();
  }
}, We = new WeakMap(), Fn = new WeakMap(), Qn = new WeakMap(), di = new WeakMap(), Ai = new WeakMap(), Xn = new WeakMap(), fi = new WeakMap(), gi = new WeakMap(), h0), bt, Oe, Ko, At, lr, hi, on, _o, pi, mi, dr, Ar, Vn, vi, Re, co, gl, hl, pl, ml, vl, bl, yl, lp, p0, WB = (p0 = class extends is {
  constructor(t, n) {
    super();
    ye(this, Re);
    ye(this, bt);
    ye(this, Oe);
    ye(this, Ko);
    ye(this, At);
    ye(this, lr);
    ye(this, hi);
    ye(this, on);
    ye(this, _o);
    ye(this, pi);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    ye(this, mi);
    ye(this, dr);
    ye(this, Ar);
    ye(this, Vn);
    ye(this, vi, /* @__PURE__ */ new Set());
    this.options = n, ue(this, bt, t), ue(this, on, null), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (N(this, Oe).addObserver(this), a1(N(this, Oe), this.options) ? He(this, Re, co).call(this) : this.updateResult(), He(this, Re, ml).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Cl(
      N(this, Oe),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Cl(
      N(this, Oe),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), He(this, Re, vl).call(this), He(this, Re, bl).call(this), N(this, Oe).removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, i = N(this, Oe);
    if (this.options = N(this, bt).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof jt(this.options.enabled, N(this, Oe)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    He(this, Re, yl).call(this), N(this, Oe).setOptions(this.options), r._defaulted && !ll(this.options, r) && N(this, bt).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: N(this, Oe),
      observer: this
    });
    const o = this.hasListeners();
    o && c1(
      N(this, Oe),
      i,
      this.options,
      r
    ) && He(this, Re, co).call(this), this.updateResult(n), o && (N(this, Oe) !== i || jt(this.options.enabled, N(this, Oe)) !== jt(r.enabled, N(this, Oe)) || ri(this.options.staleTime, N(this, Oe)) !== ri(r.staleTime, N(this, Oe))) && He(this, Re, gl).call(this);
    const s = He(this, Re, hl).call(this);
    o && (N(this, Oe) !== i || jt(this.options.enabled, N(this, Oe)) !== jt(r.enabled, N(this, Oe)) || s !== N(this, Vn)) && He(this, Re, pl).call(this, s);
  }
  getOptimisticResult(t) {
    const n = N(this, bt).getQueryCache().build(N(this, bt), t), r = this.createResult(n, t);
    return GB(this, r) && (ue(this, At, r), ue(this, hi, this.options), ue(this, lr, N(this, Oe).state)), r;
  }
  getCurrentResult() {
    return N(this, At);
  }
  trackResult(t, n) {
    const r = {};
    return Object.keys(t).forEach((i) => {
      Object.defineProperty(r, i, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(i), n == null || n(i), t[i])
      });
    }), r;
  }
  trackProp(t) {
    N(this, vi).add(t);
  }
  getCurrentQuery() {
    return N(this, Oe);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = N(this, bt).defaultQueryOptions(t), r = N(this, bt).getQueryCache().build(N(this, bt), n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    return He(this, Re, co).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), N(this, At)));
  }
  createResult(t, n) {
    var I;
    const r = N(this, Oe), i = this.options, o = N(this, At), s = N(this, lr), a = N(this, hi), u = t !== r ? t.state : N(this, Ko), { state: l } = t;
    let d = { ...l }, f = !1, h;
    if (n._optimisticResults) {
      const x = this.hasListeners(), O = !x && a1(t, n), k = x && c1(t, r, n, i);
      (O || k) && (d = {
        ...d,
        ...up(l.data, t.options)
      }), n._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: g, errorUpdatedAt: m, status: p } = d;
    if (n.select && d.data !== void 0)
      if (o && d.data === (s == null ? void 0 : s.data) && n.select === N(this, _o))
        h = N(this, pi);
      else
        try {
          ue(this, _o, n.select), h = n.select(d.data), h = Al(o == null ? void 0 : o.data, h, n), ue(this, pi, h), ue(this, on, null);
        } catch (x) {
          ue(this, on, x);
        }
    else
      h = d.data;
    if (n.placeholderData !== void 0 && h === void 0 && p === "pending") {
      let x;
      if (o != null && o.isPlaceholderData && n.placeholderData === (a == null ? void 0 : a.placeholderData))
        x = o.data;
      else if (x = typeof n.placeholderData == "function" ? n.placeholderData(
        (I = N(this, mi)) == null ? void 0 : I.state.data,
        N(this, mi)
      ) : n.placeholderData, n.select && x !== void 0)
        try {
          x = n.select(x), ue(this, on, null);
        } catch (O) {
          ue(this, on, O);
        }
      x !== void 0 && (p = "success", h = Al(
        o == null ? void 0 : o.data,
        x,
        n
      ), f = !0);
    }
    N(this, on) && (g = N(this, on), h = N(this, pi), m = Date.now(), p = "error");
    const v = d.fetchStatus === "fetching", b = p === "pending", y = p === "error", E = b && v, C = h !== void 0;
    return {
      status: p,
      fetchStatus: d.fetchStatus,
      isPending: b,
      isSuccess: p === "success",
      isError: y,
      isInitialLoading: E,
      isLoading: E,
      data: h,
      dataUpdatedAt: d.dataUpdatedAt,
      error: g,
      errorUpdatedAt: m,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > u.dataUpdateCount || d.errorUpdateCount > u.errorUpdateCount,
      isFetching: v,
      isRefetching: v && !b,
      isLoadingError: y && !C,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: f,
      isRefetchError: y && C,
      isStale: $d(t, n),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const n = N(this, At), r = this.createResult(N(this, Oe), this.options);
    if (ue(this, lr, N(this, Oe).state), ue(this, hi, this.options), N(this, lr).data !== void 0 && ue(this, mi, N(this, Oe)), ll(r, n))
      return;
    ue(this, At, r);
    const i = {}, o = () => {
      if (!n)
        return !0;
      const { notifyOnChangeProps: s } = this.options, a = typeof s == "function" ? s() : s;
      if (a === "all" || !a && !N(this, vi).size)
        return !0;
      const c = new Set(
        a ?? N(this, vi)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(N(this, At)).some((u) => {
        const l = u;
        return N(this, At)[l] !== n[l] && c.has(l);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && o() && (i.listeners = !0), He(this, Re, lp).call(this, { ...i, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && He(this, Re, ml).call(this);
  }
}, bt = new WeakMap(), Oe = new WeakMap(), Ko = new WeakMap(), At = new WeakMap(), lr = new WeakMap(), hi = new WeakMap(), on = new WeakMap(), _o = new WeakMap(), pi = new WeakMap(), mi = new WeakMap(), dr = new WeakMap(), Ar = new WeakMap(), Vn = new WeakMap(), vi = new WeakMap(), Re = new WeakSet(), co = function(t) {
  He(this, Re, yl).call(this);
  let n = N(this, Oe).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(Lt)), n;
}, gl = function() {
  He(this, Re, vl).call(this);
  const t = ri(
    this.options.staleTime,
    N(this, Oe)
  );
  if (Pi || N(this, At).isStale || !cl(t))
    return;
  const r = rp(N(this, At).dataUpdatedAt, t) + 1;
  ue(this, dr, setTimeout(() => {
    N(this, At).isStale || this.updateResult();
  }, r));
}, hl = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(N(this, Oe)) : this.options.refetchInterval) ?? !1;
}, pl = function(t) {
  He(this, Re, bl).call(this), ue(this, Vn, t), !(Pi || jt(this.options.enabled, N(this, Oe)) === !1 || !cl(N(this, Vn)) || N(this, Vn) === 0) && ue(this, Ar, setInterval(() => {
    (this.options.refetchIntervalInBackground || _d.isFocused()) && He(this, Re, co).call(this);
  }, N(this, Vn)));
}, ml = function() {
  He(this, Re, gl).call(this), He(this, Re, pl).call(this, He(this, Re, hl).call(this));
}, vl = function() {
  N(this, dr) && (clearTimeout(N(this, dr)), ue(this, dr, void 0));
}, bl = function() {
  N(this, Ar) && (clearInterval(N(this, Ar)), ue(this, Ar, void 0));
}, yl = function() {
  const t = N(this, bt).getQueryCache().build(N(this, bt), this.options);
  if (t === N(this, Oe))
    return;
  const n = N(this, Oe);
  ue(this, Oe, t), ue(this, Ko, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, lp = function(t) {
  ot.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(N(this, At));
    }), N(this, bt).getQueryCache().notify({
      query: N(this, Oe),
      type: "observerResultsUpdated"
    });
  });
}, p0);
function ZB(e, t) {
  return jt(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function a1(e, t) {
  return ZB(e, t) || e.state.data !== void 0 && Cl(e, t, t.refetchOnMount);
}
function Cl(e, t, n) {
  if (jt(t.enabled, e) !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && $d(e, t);
  }
  return !1;
}
function c1(e, t, n, r) {
  return (e !== t || jt(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && $d(e, n);
}
function $d(e, t) {
  return jt(t.enabled, e) !== !1 && e.isStaleByTime(ri(t.staleTime, e));
}
function GB(e, t) {
  return !ll(e.getCurrentResult(), t);
}
function qB(e) {
  return JSON.stringify(e, (t, n) => YB(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : typeof n == "bigint" ? n.toString() : n);
}
function YB(e) {
  if (!u1(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!u1(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function u1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function dp(e) {
  const {
    // import('@tanstack/query-core').QueryOptions
    _defaulted: t,
    behavior: n,
    gcTime: r,
    initialData: i,
    initialDataUpdatedAt: o,
    maxPages: s,
    meta: a,
    networkMode: c,
    queryFn: u,
    queryHash: l,
    queryKey: d,
    queryKeyHashFn: f,
    retry: h,
    retryDelay: g,
    structuralSharing: m,
    // import('@tanstack/query-core').InfiniteQueryObserverOptions
    getPreviousPageParam: p,
    getNextPageParam: v,
    initialPageParam: b,
    // import('@tanstack/react-query').UseQueryOptions
    _optimisticResults: y,
    enabled: E,
    notifyOnChangeProps: C,
    placeholderData: B,
    refetchInterval: I,
    refetchIntervalInBackground: x,
    refetchOnMount: O,
    refetchOnReconnect: k,
    refetchOnWindowFocus: Q,
    retryOnMount: F,
    select: M,
    staleTime: H,
    suspense: T,
    throwOnError: R,
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // wagmi
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    config: z,
    connector: L,
    query: X,
    ...W
  } = e;
  return W;
}
function UB(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { name: r, scopeKey: i, ...o } = n[1];
      if (!r)
        throw new Error("name is required");
      return Yx(e, { ...o, name: r });
    },
    queryKey: JB(t)
  };
}
function JB(e = {}) {
  return ["ensAvatar", dp(e)];
}
function KB(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { address: r, scopeKey: i, ...o } = n[1];
      if (!r)
        throw new Error("address is required");
      return Ux(e, { ...o, address: r });
    },
    queryKey: _B(t)
  };
}
function _B(e = {}) {
  return ["ensName", dp(e)];
}
var Ap = w.createContext(
  void 0
), $B = (e) => {
  const t = w.useContext(Ap);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, ew = ({
  client: e,
  children: t
}) => (w.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ A(Ap.Provider, { value: e, children: t })), fp = w.createContext(!1), tw = () => w.useContext(fp);
fp.Provider;
function nw() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var rw = w.createContext(nw()), iw = () => w.useContext(rw);
function ow(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var sw = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, aw = (e) => {
  w.useEffect(() => {
    e.clearReset();
  }, [e]);
}, cw = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && r && ow(n, [e.error, r]), uw = (e) => {
  e.suspense && (typeof e.staleTime != "number" && (e.staleTime = 1e3), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3)));
}, lw = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, dw = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function Aw(e, t, n) {
  var u, l, d, f;
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = $B(), i = tw(), o = iw(), s = r.defaultQueryOptions(e);
  (l = (u = r.getDefaultOptions().queries) == null ? void 0 : u._experimental_beforeQuery) == null || l.call(
    u,
    s
  ), s._optimisticResults = i ? "isRestoring" : "optimistic", uw(s), sw(s, o), aw(o);
  const [a] = w.useState(
    () => new t(
      r,
      s
    )
  ), c = a.getOptimisticResult(s);
  if (w.useSyncExternalStore(
    w.useCallback(
      (h) => {
        const g = i ? () => {
        } : a.subscribe(ot.batchCalls(h));
        return a.updateResult(), g;
      },
      [a, i]
    ),
    () => a.getCurrentResult(),
    () => a.getCurrentResult()
  ), w.useEffect(() => {
    a.setOptions(s, { listeners: !1 });
  }, [s, a]), lw(s, c))
    throw dw(s, a, o);
  if (cw({
    result: c,
    errorResetBoundary: o,
    throwOnError: s.throwOnError,
    query: r.getQueryCache().get(s.queryHash)
  }))
    throw c.error;
  return (f = (d = r.getDefaultOptions().queries) == null ? void 0 : d._experimental_afterQuery) == null || f.call(
    d,
    s,
    c
  ), s.notifyOnChangeProps ? c : a.trackResult(c);
}
function fw(e, t) {
  return Aw(e, WB);
}
function gp(e) {
  const t = fw({
    ...e,
    queryKeyHashFn: qB
    // for bigint support
  });
  return t.queryKey = e.queryKey, t;
}
function hp(e = {}) {
  const t = Jd(e);
  return m0((n) => Kx(t, { onChange: n }), () => Kf(t), () => Kf(t));
}
function gw(e = {}) {
  const { name: t, query: n = {} } = e, r = Jd(e), i = hp({ config: r }), o = UB(r, {
    ...e,
    chainId: e.chainId ?? i
  }), s = !!(t && (n.enabled ?? !0));
  return gp({ ...n, ...o, enabled: s });
}
function pp(e = {}) {
  const { address: t, query: n = {} } = e, r = Jd(e), i = hp({ config: r }), o = KB(r, {
    ...e,
    chainId: e.chainId ?? i
  }), s = !!(t && (n.enabled ?? !0));
  return gp({ ...n, ...o, enabled: s });
}
function mp(e) {
  const { address: t, chainId: n = 1, size: r = "14px" } = e, i = {
    width: r,
    height: r
  }, o = pp({ address: t, chainId: n }), s = o.data ?? void 0, a = gw({ name: s }), c = a.data ?? wC;
  return o.isLoading || a.isLoading ? /* @__PURE__ */ A(
    "div",
    {
      style: i,
      className: "flex-none animate-pulse rounded-full bg-gray-400 fade-out"
    }
  ) : /* @__PURE__ */ A(
    "img",
    {
      src: c,
      style: i,
      className: "flex-none rounded-full object-contain",
      alt: "ENS Avatar"
    }
  );
}
const hw = {
  SYNCING: "Syncing",
  SUCCESS: "Synced",
  CONFLICT: "Error",
  MISSING: "Circle",
  ERROR: "Error",
  INITIAL_SYNC: "Syncing"
};
function vp(e) {
  const {
    syncStatus: t,
    className: n,
    overrideSyncIcons: r = {},
    ...i
  } = e, o = { ...hw, ...r };
  return {
    [Fl]: /* @__PURE__ */ A(
      Y,
      {
        size: 16,
        ...i,
        className: $("text-blue-900", n),
        name: o[Fl]
      }
    ),
    [Tl]: /* @__PURE__ */ A(
      Y,
      {
        size: 16,
        ...i,
        className: $("text-blue-900", n),
        name: o[Tl]
      }
    ),
    [Pr]: /* @__PURE__ */ A(
      Y,
      {
        size: 16,
        ...i,
        className: $("text-green-900", n),
        name: o[Pr]
      }
    ),
    [Rl]: /* @__PURE__ */ A(
      Y,
      {
        size: 16,
        ...i,
        className: $("text-orange-900", n),
        name: o[Rl]
      }
    ),
    [Ll]: /* @__PURE__ */ A(
      Y,
      {
        size: 16,
        ...i,
        className: $("text-red-900", n),
        name: o[Ll]
      }
    ),
    [Pa]: /* @__PURE__ */ A(
      Y,
      {
        size: 16,
        ...i,
        className: $("text-red-900", n),
        name: o[Pa]
      }
    )
  }[t];
}
function MR(e) {
  var z;
  const {
    uiNode: t,
    selectedNodePath: n,
    nodeOptions: r,
    isAllowedToCreateDocuments: i,
    isRemoteDrive: o,
    customDocumentIconSrc: s,
    className: a,
    setSelectedNode: c,
    onRenameNode: u,
    onDuplicateNode: l,
    onDeleteNode: d,
    onAddTrigger: f,
    onRemoveTrigger: h,
    onAddInvalidTrigger: g
  } = e, [m, p] = q(Gt), [v, b] = q(!1), { dragProps: y } = gA(e), E = m === Gt, C = $(
    "group flex h-12 cursor-pointer select-none items-center rounded-lg bg-gray-200 px-2 text-gray-600 hover:text-gray-800",
    a
  ), B = {
    [Rr]: () => l(t),
    [er]: () => p(Jr),
    [Lr]: () => d(t),
    [ds]: () => f(t.driveId),
    [ls]: () => h(t.driveId),
    [As]: () => g(t.driveId)
  }, I = r[t.sharingType][Je], x = Object.entries(fA).map(([L, X]) => ({
    ...X,
    id: L
  })).filter((L) => I.includes(L.id));
  function O(L) {
    u(L, t), p(Gt);
  }
  function k() {
    p(Gt);
  }
  function Q() {
    c(t);
  }
  function F(L) {
    const X = B[L];
    if (!X) {
      console.error(`No handler found for dropdown menu item: ${L}`);
      return;
    }
    X(t), b(!1);
  }
  const M = Bm(
    t.documentType,
    s
  ), H = /* @__PURE__ */ D("div", { className: "relative", children: [
    /* @__PURE__ */ A(
      "img",
      {
        src: M,
        alt: "file icon",
        className: "max-w-none",
        width: 32,
        height: 34
      }
    ),
    E && o && t.syncStatus && /* @__PURE__ */ A("div", { className: "absolute bottom-[-2px] right-0 size-3 rounded-full bg-white", children: /* @__PURE__ */ A("div", { className: "absolute left-[-2px] top-[-2px]", children: /* @__PURE__ */ A(
      vp,
      {
        syncStatus: t.syncStatus,
        overrideSyncIcons: { SUCCESS: "CheckCircleFill" }
      }
    ) }) })
  ] }), T = ((z = n.at(-1)) == null ? void 0 : z.kind) === "FILE" ? n.slice(0, -1) : n, R = E ? /* @__PURE__ */ D("div", { className: "flex w-52 items-center justify-between", children: [
    /* @__PURE__ */ D("div", { className: "mr-2 truncate group-hover:mr-0", children: [
      /* @__PURE__ */ A("div", { className: "max-h-6 truncate text-sm font-medium group-hover:text-gray-800", children: t.name }),
      /* @__PURE__ */ A("div", { className: "max-h-6 truncate text-xs font-medium text-gray-600 group-hover:text-gray-800", children: T.map((L) => L.name).join(" / ") })
    ] }),
    i && /* @__PURE__ */ A(
      xd,
      {
        open: v,
        onOpenChange: b,
        onItemClick: F,
        items: x,
        children: /* @__PURE__ */ A(
          "button",
          {
            onClick: (L) => {
              L.stopPropagation(), b(!0);
            },
            className: $(
              "hidden group-hover:block",
              v && "block"
            ),
            children: /* @__PURE__ */ A(Y, { name: "VerticalDots", className: "text-gray-600" })
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ A(
    Mo,
    {
      className: "ml-3 flex-1 font-medium",
      defaultValue: t.name,
      onCancel: k,
      onSubmit: O
    }
  );
  return /* @__PURE__ */ A("div", { onClick: Q, className: "relative w-64", children: /* @__PURE__ */ A("div", { ...y, className: C, children: /* @__PURE__ */ D("div", { className: "flex items-center", children: [
    /* @__PURE__ */ A("div", { className: "mr-1.5", children: H }),
    R
  ] }) }) });
}
function zR(e) {
  const {
    uiNode: t,
    isAllowedToCreateDocuments: n,
    nodeOptions: r,
    isRemoteDrive: i,
    className: o,
    setSelectedNode: s,
    onRenameNode: a,
    onDuplicateNode: c,
    onDeleteNode: u,
    onAddTrigger: l,
    onRemoveTrigger: d,
    onAddInvalidTrigger: f
  } = e, [h, g] = q(Gt), [m, p] = q(!1), { dragProps: v } = gA(e), { isDropTarget: b, dropProps: y } = hA(e), E = h === Gt;
  function C() {
    g(Gt);
  }
  function B(H) {
    a(H, t);
  }
  function I() {
    s(t);
  }
  const x = {
    [Rr]: () => c(t),
    [er]: () => g(Jr),
    [Lr]: () => u(t),
    [ds]: () => l(t.driveId),
    [ls]: () => d(t.driveId),
    [As]: () => f(t.driveId)
  }, O = r[t.sharingType][Wt], k = Object.entries(fA).map(([H, T]) => ({
    ...T,
    id: H
  })).filter((H) => O.includes(H.id));
  function Q(H) {
    const T = x[H];
    if (!T) {
      console.error(`No handler found for dropdown menu item: ${H}`);
      return;
    }
    T(), p(!1);
  }
  const F = E || !n ? /* @__PURE__ */ A("div", { className: "ml-3 max-h-6 truncate font-medium text-gray-600 group-hover:text-gray-800", children: t.name }) : /* @__PURE__ */ A(
    Mo,
    {
      className: "ml-3 font-medium",
      defaultValue: t.name,
      onCancel: C,
      onSubmit: B
    }
  ), M = $(
    "group flex h-12 cursor-pointer select-none items-center rounded-lg bg-gray-200 px-2",
    o,
    b && "bg-blue-100"
  );
  return /* @__PURE__ */ A("div", { onClick: I, className: "relative w-64", children: /* @__PURE__ */ D("div", { ...v, ...y, className: M, children: [
    /* @__PURE__ */ D("div", { className: "flex items-center overflow-hidden", children: [
      /* @__PURE__ */ A("div", { className: "p-1", children: /* @__PURE__ */ D("div", { className: "relative", children: [
        /* @__PURE__ */ A(Y, { name: "FolderClose", size: 24 }),
        E && i && t.syncStatus && /* @__PURE__ */ A("div", { className: "absolute bottom-[-3px] right-[-2px] size-3 rounded-full bg-white", children: /* @__PURE__ */ A("div", { className: "absolute left-[-2px] top-[-2px]", children: /* @__PURE__ */ A(
          vp,
          {
            syncStatus: t.syncStatus,
            overrideSyncIcons: {
              SUCCESS: "CheckCircleFill"
            }
          }
        ) }) })
      ] }) }),
      F
    ] }),
    E && n && /* @__PURE__ */ A(
      xd,
      {
        open: m,
        onOpenChange: p,
        onItemClick: Q,
        items: k,
        children: /* @__PURE__ */ A(
          "button",
          {
            onClick: (H) => {
              H.stopPropagation(), p(!0);
            },
            className: $(
              "ml-auto hidden group-hover:block",
              m && "block"
            ),
            children: /* @__PURE__ */ A(
              Y,
              {
                name: "VerticalDots",
                className: "text-gray-600"
              }
            )
          }
        )
      }
    )
  ] }) });
}
const jR = ({
  children: e,
  ...t
}) => /* @__PURE__ */ A(
  "footer",
  {
    ...rt(
      t,
      "flex items-center gap-x-6 text-xs font-medium text-[#9DA6B9]"
    ),
    children: e
  }
), WR = (e) => {
  const { as: t = "a", ...n } = e;
  return /* @__PURE__ */ A(
    t,
    {
      ...rt(
        n,
        "flex cursor-pointer items-center hover:underline"
      )
    }
  );
};
var os = (e) => e.type === "checkbox", Yr = (e) => e instanceof Date, ht = (e) => e == null;
const bp = (e) => typeof e == "object";
var Ke = (e) => !ht(e) && !Array.isArray(e) && bp(e) && !Yr(e), yp = (e) => Ke(e) && e.target ? os(e.target) ? e.target.checked : e.target.value : e, pw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Cp = (e, t) => e.has(pw(t)), mw = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Ke(t) && t.hasOwnProperty("isPrototypeOf");
}, eA = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _e(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(eA && (e instanceof Blob || e instanceof FileList)) && (n || Ke(e)))
    if (t = n ? [] : {}, !n && !mw(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = _e(e[r]));
  else
    return e;
  return t;
}
var ss = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ke = (e) => e === void 0, te = (e, t, n) => {
  if (!t || !Ke(e))
    return n;
  const r = ss(t.split(/[,[\].]+?/)).reduce((i, o) => ht(i) ? i : i[o], e);
  return ke(r) || r === e ? ke(e[t]) ? n : e[t] : r;
}, Ft = (e) => typeof e == "boolean", tA = (e) => /^\w*$/.test(e), Ip = (e) => ss(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Xe = (e, t, n) => {
  let r = -1;
  const i = tA(t) ? [t] : Ip(t), o = i.length, s = o - 1;
  for (; ++r < o; ) {
    const a = i[r];
    let c = n;
    if (r !== s) {
      const u = e[a];
      c = Ke(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (a === "__proto__")
      return;
    e[a] = c, e = e[a];
  }
  return e;
};
const ma = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Qt = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, vn = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, vw = _.createContext(null), Ua = () => _.useContext(vw);
var Ep = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const s = o;
        return t._proxyFormState[s] !== Qt.all && (t._proxyFormState[s] = !r || Qt.all), n && (n[s] = !0), e[s];
      }
    });
  return i;
}, ft = (e) => Ke(e) && !Object.keys(e).length, xp = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e;
  return ft(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((s) => t[s] === (!r || Qt.all));
}, It = (e) => Array.isArray(e) ? e : [e], Bp = (e, t, n) => !e || !t || e === t || It(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function Ja(e) {
  const t = _.useRef(e);
  t.current = e, _.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function bw(e) {
  const t = Ua(), { control: n = t.control, disabled: r, name: i, exact: o } = e || {}, [s, a] = _.useState(n._formState), c = _.useRef(!0), u = _.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), l = _.useRef(i);
  return l.current = i, Ja({
    disabled: r,
    next: (d) => c.current && Bp(l.current, d.name, o) && xp(d, u.current, n._updateFormState) && a({
      ...n._formState,
      ...d
    }),
    subject: n._subjects.state
  }), _.useEffect(() => (c.current = !0, u.current.isValid && n._updateValid(!0), () => {
    c.current = !1;
  }), [n]), Ep(s, n, u.current, !1);
}
var ln = (e) => typeof e == "string", wp = (e, t, n, r, i) => ln(e) ? (r && t.watch.add(e), te(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), te(n, o))) : (r && (t.watchAll = !0), n);
function Zn(e) {
  const t = Ua(), { control: n = t.control, name: r, defaultValue: i, disabled: o, exact: s } = e || {}, a = _.useRef(r);
  a.current = r, Ja({
    disabled: o,
    subject: n._subjects.values,
    next: (l) => {
      Bp(a.current, l.name, s) && u(_e(wp(a.current, n._names, l.values || n._formValues, !1, i)));
    }
  });
  const [c, u] = _.useState(n._getWatch(r, i));
  return _.useEffect(() => n._removeUnmounted()), c;
}
function yw(e) {
  const t = Ua(), { name: n, disabled: r, control: i = t.control, shouldUnregister: o } = e, s = Cp(i._names.array, n), a = Zn({
    control: i,
    name: n,
    defaultValue: te(i._formValues, n, te(i._defaultValues, n, e.defaultValue)),
    exact: !0
  }), c = bw({
    control: i,
    name: n,
    exact: !0
  }), u = _.useRef(i.register(n, {
    ...e.rules,
    value: a,
    ...Ft(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return _.useEffect(() => {
    const l = i._options.shouldUnregister || o, d = (f, h) => {
      const g = te(i._fields, f);
      g && g._f && (g._f.mount = h);
    };
    if (d(n, !0), l) {
      const f = _e(te(i._options.defaultValues, n));
      Xe(i._defaultValues, n, f), ke(te(i._formValues, n)) && Xe(i._formValues, n, f);
    }
    return () => {
      (s ? l && !i._state.action : l) ? i.unregister(n) : d(n, !1);
    };
  }, [n, i, s, o]), _.useEffect(() => {
    te(i._fields, n) && i._updateDisabledField({
      disabled: r,
      fields: i._fields,
      name: n,
      value: te(i._fields, n)._f.value
    });
  }, [r, n, i]), {
    field: {
      name: n,
      value: a,
      ...Ft(r) || c.disabled ? { disabled: c.disabled || r } : {},
      onChange: _.useCallback((l) => u.current.onChange({
        target: {
          value: yp(l),
          name: n
        },
        type: ma.CHANGE
      }), [n]),
      onBlur: _.useCallback(() => u.current.onBlur({
        target: {
          value: te(i._formValues, n),
          name: n
        },
        type: ma.BLUR
      }), [n, i]),
      ref: _.useCallback((l) => {
        const d = te(i._fields, n);
        d && l && (d._f.ref = {
          focus: () => l.focus(),
          select: () => l.select(),
          setCustomValidity: (f) => l.setCustomValidity(f),
          reportValidity: () => l.reportValidity()
        });
      }, [i._fields, n])
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!te(c.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!te(c.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!te(c.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!te(c.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => te(c.errors, n)
      }
    })
  };
}
const nA = (e) => e.render(yw(e));
var Cw = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, Hn = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? n : n & 3 | 8).toString(16);
  });
}, Mc = (e, t, n = {}) => n.shouldFocus || ke(n.shouldFocus) ? n.focusName || `${e}.${ke(n.focusIndex) ? t : n.focusIndex}.` : "", Ao = (e) => ({
  isOnSubmit: !e || e === Qt.onSubmit,
  isOnBlur: e === Qt.onBlur,
  isOnChange: e === Qt.onChange,
  isOnAll: e === Qt.all,
  isOnTouch: e === Qt.onTouched
}), Il = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const ii = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = te(e, i);
    if (o) {
      const { _f: s, ...a } = o;
      if (s) {
        if (s.refs && s.refs[0] && t(s.refs[0], i) && !r)
          return !0;
        if (s.ref && t(s.ref, s.name) && !r)
          return !0;
        if (ii(a, t))
          break;
      } else if (Ke(a) && ii(a, t))
        break;
    }
  }
};
var Pp = (e, t, n) => {
  const r = It(te(e, n));
  return Xe(r, "root", t[n]), Xe(e, n, r), e;
}, rA = (e) => e.type === "file", yn = (e) => typeof e == "function", va = (e) => {
  if (!eA)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, qs = (e) => ln(e), iA = (e) => e.type === "radio", ba = (e) => e instanceof RegExp;
const l1 = {
  value: !1,
  isValid: !1
}, d1 = { value: !0, isValid: !0 };
var Hp = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ke(e[0].attributes.value) ? ke(e[0].value) || e[0].value === "" ? d1 : { value: e[0].value, isValid: !0 } : d1
    ) : l1;
  }
  return l1;
};
const A1 = {
  isValid: !1,
  value: null
};
var Op = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, A1) : A1;
function f1(e, t, n = "validate") {
  if (qs(e) || Array.isArray(e) && e.every(qs) || Ft(e) && !e)
    return {
      type: n,
      message: qs(e) ? e : "",
      ref: t
    };
}
var zr = (e) => Ke(e) && !ba(e) ? e : {
  value: e,
  message: ""
}, El = async (e, t, n, r, i) => {
  const { ref: o, refs: s, required: a, maxLength: c, minLength: u, min: l, max: d, pattern: f, validate: h, name: g, valueAsNumber: m, mount: p, disabled: v } = e._f, b = te(t, g);
  if (!p || v)
    return {};
  const y = s ? s[0] : o, E = (F) => {
    r && y.reportValidity && (y.setCustomValidity(Ft(F) ? "" : F || ""), y.reportValidity());
  }, C = {}, B = iA(o), I = os(o), x = B || I, O = (m || rA(o)) && ke(o.value) && ke(b) || va(o) && o.value === "" || b === "" || Array.isArray(b) && !b.length, k = Cw.bind(null, g, n, C), Q = (F, M, H, T = vn.maxLength, R = vn.minLength) => {
    const z = F ? M : H;
    C[g] = {
      type: F ? T : R,
      message: z,
      ref: o,
      ...k(F ? T : R, z)
    };
  };
  if (i ? !Array.isArray(b) || !b.length : a && (!x && (O || ht(b)) || Ft(b) && !b || I && !Hp(s).isValid || B && !Op(s).isValid)) {
    const { value: F, message: M } = qs(a) ? { value: !!a, message: a } : zr(a);
    if (F && (C[g] = {
      type: vn.required,
      message: M,
      ref: y,
      ...k(vn.required, M)
    }, !n))
      return E(M), C;
  }
  if (!O && (!ht(l) || !ht(d))) {
    let F, M;
    const H = zr(d), T = zr(l);
    if (!ht(b) && !isNaN(b)) {
      const R = o.valueAsNumber || b && +b;
      ht(H.value) || (F = R > H.value), ht(T.value) || (M = R < T.value);
    } else {
      const R = o.valueAsDate || new Date(b), z = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), L = o.type == "time", X = o.type == "week";
      ln(H.value) && b && (F = L ? z(b) > z(H.value) : X ? b > H.value : R > new Date(H.value)), ln(T.value) && b && (M = L ? z(b) < z(T.value) : X ? b < T.value : R < new Date(T.value));
    }
    if ((F || M) && (Q(!!F, H.message, T.message, vn.max, vn.min), !n))
      return E(C[g].message), C;
  }
  if ((c || u) && !O && (ln(b) || i && Array.isArray(b))) {
    const F = zr(c), M = zr(u), H = !ht(F.value) && b.length > +F.value, T = !ht(M.value) && b.length < +M.value;
    if ((H || T) && (Q(H, F.message, M.message), !n))
      return E(C[g].message), C;
  }
  if (f && !O && ln(b)) {
    const { value: F, message: M } = zr(f);
    if (ba(F) && !b.match(F) && (C[g] = {
      type: vn.pattern,
      message: M,
      ref: o,
      ...k(vn.pattern, M)
    }, !n))
      return E(M), C;
  }
  if (h) {
    if (yn(h)) {
      const F = await h(b, t), M = f1(F, y);
      if (M && (C[g] = {
        ...M,
        ...k(vn.validate, M.message)
      }, !n))
        return E(M.message), C;
    } else if (Ke(h)) {
      let F = {};
      for (const M in h) {
        if (!ft(F) && !n)
          break;
        const H = f1(await h[M](b, t), y, M);
        H && (F = {
          ...H,
          ...k(M, H.message)
        }, E(H.message), n && (C[g] = F));
      }
      if (!ft(F) && (C[g] = {
        ref: y,
        ...F
      }, !n))
        return C;
    }
  }
  return E(!0), C;
}, zc = (e, t) => [
  ...e,
  ...It(t)
], jc = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function Wc(e, t, n) {
  return [
    ...e.slice(0, t),
    ...It(n),
    ...e.slice(t)
  ];
}
var Zc = (e, t, n) => Array.isArray(e) ? (ke(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [], Gc = (e, t) => [
  ...It(t),
  ...It(e)
];
function Iw(e, t) {
  let n = 0;
  const r = [...e];
  for (const i of t)
    r.splice(i - n, 1), n++;
  return ss(r).length ? r : [];
}
var qc = (e, t) => ke(t) ? [] : Iw(e, It(t).sort((n, r) => n - r)), Yc = (e, t, n) => {
  [e[t], e[n]] = [e[n], e[t]];
};
function Ew(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = ke(e) ? r++ : e[t[r++]];
  return e;
}
function xw(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !ke(e[t]))
      return !1;
  return !0;
}
function qe(e, t) {
  const n = Array.isArray(t) ? t : tA(t) ? [t] : Ip(t), r = n.length === 1 ? e : Ew(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (Ke(r) && ft(r) || Array.isArray(r) && xw(r)) && qe(e, n.slice(0, -1)), e;
}
var g1 = (e, t, n) => (e[t] = n, e);
function Bw(e) {
  const t = Ua(), { control: n = t.control, name: r, keyName: i = "id", shouldUnregister: o } = e, [s, a] = _.useState(n._getFieldArray(r)), c = _.useRef(n._getFieldArray(r).map(Hn)), u = _.useRef(s), l = _.useRef(r), d = _.useRef(!1);
  l.current = r, u.current = s, n._names.array.add(r), e.rules && n.register(r, e.rules), Ja({
    next: ({ values: C, name: B }) => {
      if (B === l.current || !B) {
        const I = te(C, l.current);
        Array.isArray(I) && (a(I), c.current = I.map(Hn));
      }
    },
    subject: n._subjects.array
  });
  const f = _.useCallback((C) => {
    d.current = !0, n._updateFieldArray(r, C);
  }, [n, r]), h = (C, B) => {
    const I = It(_e(C)), x = zc(n._getFieldArray(r), I);
    n._names.focus = Mc(r, x.length - 1, B), c.current = zc(c.current, I.map(Hn)), f(x), a(x), n._updateFieldArray(r, x, zc, {
      argA: jc(C)
    });
  }, g = (C, B) => {
    const I = It(_e(C)), x = Gc(n._getFieldArray(r), I);
    n._names.focus = Mc(r, 0, B), c.current = Gc(c.current, I.map(Hn)), f(x), a(x), n._updateFieldArray(r, x, Gc, {
      argA: jc(C)
    });
  }, m = (C) => {
    const B = qc(n._getFieldArray(r), C);
    c.current = qc(c.current, C), f(B), a(B), n._updateFieldArray(r, B, qc, {
      argA: C
    });
  }, p = (C, B, I) => {
    const x = It(_e(B)), O = Wc(n._getFieldArray(r), C, x);
    n._names.focus = Mc(r, C, I), c.current = Wc(c.current, C, x.map(Hn)), f(O), a(O), n._updateFieldArray(r, O, Wc, {
      argA: C,
      argB: jc(B)
    });
  }, v = (C, B) => {
    const I = n._getFieldArray(r);
    Yc(I, C, B), Yc(c.current, C, B), f(I), a(I), n._updateFieldArray(r, I, Yc, {
      argA: C,
      argB: B
    }, !1);
  }, b = (C, B) => {
    const I = n._getFieldArray(r);
    Zc(I, C, B), Zc(c.current, C, B), f(I), a(I), n._updateFieldArray(r, I, Zc, {
      argA: C,
      argB: B
    }, !1);
  }, y = (C, B) => {
    const I = _e(B), x = g1(n._getFieldArray(r), C, I);
    c.current = [...x].map((O, k) => !O || k === C ? Hn() : c.current[k]), f(x), a([...x]), n._updateFieldArray(r, x, g1, {
      argA: C,
      argB: I
    }, !0, !1);
  }, E = (C) => {
    const B = It(_e(C));
    c.current = B.map(Hn), f([...B]), a([...B]), n._updateFieldArray(r, [...B], (I) => I, {}, !0, !1);
  };
  return _.useEffect(() => {
    if (n._state.action = !1, Il(r, n._names) && n._subjects.state.next({
      ...n._formState
    }), d.current && (!Ao(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([r]).then((C) => {
          const B = te(C.errors, r), I = te(n._formState.errors, r);
          (I ? !B && I.type || B && (I.type !== B.type || I.message !== B.message) : B && B.type) && (B ? Xe(n._formState.errors, r, B) : qe(n._formState.errors, r), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const C = te(n._fields, r);
        C && C._f && !(Ao(n._options.reValidateMode).isOnSubmit && Ao(n._options.mode).isOnSubmit) && El(C, n._formValues, n._options.criteriaMode === Qt.all, n._options.shouldUseNativeValidation, !0).then((B) => !ft(B) && n._subjects.state.next({
          errors: Pp(n._formState.errors, B, r)
        }));
      }
    n._subjects.values.next({
      name: r,
      values: { ...n._formValues }
    }), n._names.focus && ii(n._fields, (C, B) => {
      if (n._names.focus && B.startsWith(n._names.focus) && C.focus)
        return C.focus(), 1;
    }), n._names.focus = "", n._updateValid(), d.current = !1;
  }, [s, r, n]), _.useEffect(() => (!te(n._formValues, r) && n._updateFieldArray(r), () => {
    (n._options.shouldUnregister || o) && n.unregister(r);
  }), [r, n, i, o]), {
    swap: _.useCallback(v, [f, r, n]),
    move: _.useCallback(b, [f, r, n]),
    prepend: _.useCallback(g, [f, r, n]),
    append: _.useCallback(h, [f, r, n]),
    remove: _.useCallback(m, [f, r, n]),
    insert: _.useCallback(p, [f, r, n]),
    update: _.useCallback(y, [f, r, n]),
    replace: _.useCallback(E, [f, r, n]),
    fields: _.useMemo(() => s.map((C, B) => ({
      ...C,
      [i]: c.current[B] || Hn()
    })), [s, i])
  };
}
var Uc = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ya = (e) => ht(e) || !bp(e);
function Nn(e, t) {
  if (ya(e) || ya(t))
    return e === t;
  if (Yr(e) && Yr(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n) {
    const o = e[i];
    if (!r.includes(i))
      return !1;
    if (i !== "ref") {
      const s = t[i];
      if (Yr(o) && Yr(s) || Ke(o) && Ke(s) || Array.isArray(o) && Array.isArray(s) ? !Nn(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Dp = (e) => e.type === "select-multiple", ww = (e) => iA(e) || os(e), Jc = (e) => va(e) && e.isConnected, Sp = (e) => {
  for (const t in e)
    if (yn(e[t]))
      return !0;
  return !1;
};
function Ca(e, t = {}) {
  const n = Array.isArray(e);
  if (Ke(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || Ke(e[r]) && !Sp(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, Ca(e[r], t[r])) : ht(e[r]) || (t[r] = !0);
  return t;
}
function Np(e, t, n) {
  const r = Array.isArray(e);
  if (Ke(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || Ke(e[i]) && !Sp(e[i]) ? ke(t) || ya(n[i]) ? n[i] = Array.isArray(e[i]) ? Ca(e[i], []) : { ...Ca(e[i]) } : Np(e[i], ht(t) ? {} : t[i], n[i]) : n[i] = !Nn(e[i], t[i]);
  return n;
}
var Ts = (e, t) => Np(e, t, Ca(t)), Tp = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => ke(e) ? e : t ? e === "" ? NaN : e && +e : n && ln(e) ? new Date(e) : r ? r(e) : e;
function Kc(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return rA(t) ? t.files : iA(t) ? Op(e.refs).value : Dp(t) ? [...t.selectedOptions].map(({ value: n }) => n) : os(t) ? Hp(e.refs).value : Tp(ke(t.value) ? e.ref.value : t.value, e);
}
var Pw = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const s = te(t, o);
    s && Xe(i, o, s._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, eo = (e) => ke(e) ? e : ba(e) ? e.source : Ke(e) ? ba(e.value) ? e.value.source : e.value : e;
const h1 = "AsyncFunction";
var Hw = (e) => (!e || !e.validate) && !!(yn(e.validate) && e.validate.constructor.name === h1 || Ke(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === h1)), Ow = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function p1(e, t, n) {
  const r = te(e, n);
  if (r || tA(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), s = te(t, o), a = te(e, o);
    if (s && !Array.isArray(s) && n !== o)
      return { name: n };
    if (a && a.type)
      return {
        name: o,
        error: a
      };
    i.pop();
  }
  return {
    name: n
  };
}
var Dw = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, Sw = (e, t) => !ss(te(e, t)).length && qe(e, t);
const Nw = {
  mode: Qt.onSubmit,
  reValidateMode: Qt.onChange,
  shouldFocusError: !0
};
function Tw(e = {}) {
  let t = {
    ...Nw,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: yn(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = Ke(t.defaultValues) || Ke(t.values) ? _e(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : _e(i), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, a = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, u = 0;
  const l = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, d = {
    values: Uc(),
    array: Uc(),
    state: Uc()
  }, f = Ao(t.mode), h = Ao(t.reValidateMode), g = t.criteriaMode === Qt.all, m = (P) => (S) => {
    clearTimeout(u), u = setTimeout(P, S);
  }, p = async (P) => {
    if (l.isValid || P) {
      const S = t.resolver ? ft((await x()).errors) : await k(r, !0);
      S !== n.isValid && d.state.next({
        isValid: S
      });
    }
  }, v = (P, S) => {
    (l.isValidating || l.validatingFields) && ((P || Array.from(a.mount)).forEach((V) => {
      V && (S ? Xe(n.validatingFields, V, S) : qe(n.validatingFields, V));
    }), d.state.next({
      validatingFields: n.validatingFields,
      isValidating: !ft(n.validatingFields)
    }));
  }, b = (P, S = [], V, J, G = !0, j = !0) => {
    if (J && V) {
      if (s.action = !0, j && Array.isArray(te(r, P))) {
        const oe = V(te(r, P), J.argA, J.argB);
        G && Xe(r, P, oe);
      }
      if (j && Array.isArray(te(n.errors, P))) {
        const oe = V(te(n.errors, P), J.argA, J.argB);
        G && Xe(n.errors, P, oe), Sw(n.errors, P);
      }
      if (l.touchedFields && j && Array.isArray(te(n.touchedFields, P))) {
        const oe = V(te(n.touchedFields, P), J.argA, J.argB);
        G && Xe(n.touchedFields, P, oe);
      }
      l.dirtyFields && (n.dirtyFields = Ts(i, o)), d.state.next({
        name: P,
        isDirty: F(P, S),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Xe(o, P, S);
  }, y = (P, S) => {
    Xe(n.errors, P, S), d.state.next({
      errors: n.errors
    });
  }, E = (P) => {
    n.errors = P, d.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, C = (P, S, V, J) => {
    const G = te(r, P);
    if (G) {
      const j = te(o, P, ke(V) ? te(i, P) : V);
      ke(j) || J && J.defaultChecked || S ? Xe(o, P, S ? j : Kc(G._f)) : T(P, j), s.mount && p();
    }
  }, B = (P, S, V, J, G) => {
    let j = !1, oe = !1;
    const Ee = {
      name: P
    }, be = !!(te(r, P) && te(r, P)._f && te(r, P)._f.disabled);
    if (!V || J) {
      l.isDirty && (oe = n.isDirty, n.isDirty = Ee.isDirty = F(), j = oe !== Ee.isDirty);
      const Le = be || Nn(te(i, P), S);
      oe = !!(!be && te(n.dirtyFields, P)), Le || be ? qe(n.dirtyFields, P) : Xe(n.dirtyFields, P, !0), Ee.dirtyFields = n.dirtyFields, j = j || l.dirtyFields && oe !== !Le;
    }
    if (V) {
      const Le = te(n.touchedFields, P);
      Le || (Xe(n.touchedFields, P, V), Ee.touchedFields = n.touchedFields, j = j || l.touchedFields && Le !== V);
    }
    return j && G && d.state.next(Ee), j ? Ee : {};
  }, I = (P, S, V, J) => {
    const G = te(n.errors, P), j = l.isValid && Ft(S) && n.isValid !== S;
    if (e.delayError && V ? (c = m(() => y(P, V)), c(e.delayError)) : (clearTimeout(u), c = null, V ? Xe(n.errors, P, V) : qe(n.errors, P)), (V ? !Nn(G, V) : G) || !ft(J) || j) {
      const oe = {
        ...J,
        ...j && Ft(S) ? { isValid: S } : {},
        errors: n.errors,
        name: P
      };
      n = {
        ...n,
        ...oe
      }, d.state.next(oe);
    }
  }, x = async (P) => {
    v(P, !0);
    const S = await t.resolver(o, t.context, Pw(P || a.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return v(P), S;
  }, O = async (P) => {
    const { errors: S } = await x(P);
    if (P)
      for (const V of P) {
        const J = te(S, V);
        J ? Xe(n.errors, V, J) : qe(n.errors, V);
      }
    else
      n.errors = S;
    return S;
  }, k = async (P, S, V = {
    valid: !0
  }) => {
    for (const J in P) {
      const G = P[J];
      if (G) {
        const { _f: j, ...oe } = G;
        if (j) {
          const Ee = a.array.has(j.name), be = G._f && Hw(G._f);
          be && l.validatingFields && v([J], !0);
          const Le = await El(G, o, g, t.shouldUseNativeValidation && !S, Ee);
          if (be && l.validatingFields && v([J]), Le[j.name] && (V.valid = !1, S))
            break;
          !S && (te(Le, j.name) ? Ee ? Pp(n.errors, Le, j.name) : Xe(n.errors, j.name, Le[j.name]) : qe(n.errors, j.name));
        }
        !ft(oe) && await k(oe, S, V);
      }
    }
    return V.valid;
  }, Q = () => {
    for (const P of a.unMount) {
      const S = te(r, P);
      S && (S._f.refs ? S._f.refs.every((V) => !Jc(V)) : !Jc(S._f.ref)) && ae(P);
    }
    a.unMount = /* @__PURE__ */ new Set();
  }, F = (P, S) => (P && S && Xe(o, P, S), !Nn(U(), i)), M = (P, S, V) => wp(P, a, {
    ...s.mount ? o : ke(S) ? i : ln(P) ? { [P]: S } : S
  }, V, S), H = (P) => ss(te(s.mount ? o : i, P, e.shouldUnregister ? te(i, P, []) : [])), T = (P, S, V = {}) => {
    const J = te(r, P);
    let G = S;
    if (J) {
      const j = J._f;
      j && (!j.disabled && Xe(o, P, Tp(S, j)), G = va(j.ref) && ht(S) ? "" : S, Dp(j.ref) ? [...j.ref.options].forEach((oe) => oe.selected = G.includes(oe.value)) : j.refs ? os(j.ref) ? j.refs.length > 1 ? j.refs.forEach((oe) => (!oe.defaultChecked || !oe.disabled) && (oe.checked = Array.isArray(G) ? !!G.find((Ee) => Ee === oe.value) : G === oe.value)) : j.refs[0] && (j.refs[0].checked = !!G) : j.refs.forEach((oe) => oe.checked = oe.value === G) : rA(j.ref) ? j.ref.value = "" : (j.ref.value = G, j.ref.type || d.values.next({
        name: P,
        values: { ...o }
      })));
    }
    (V.shouldDirty || V.shouldTouch) && B(P, G, V.shouldTouch, V.shouldDirty, !0), V.shouldValidate && W(P);
  }, R = (P, S, V) => {
    for (const J in S) {
      const G = S[J], j = `${P}.${J}`, oe = te(r, j);
      (a.array.has(P) || !ya(G) || oe && !oe._f) && !Yr(G) ? R(j, G, V) : T(j, G, V);
    }
  }, z = (P, S, V = {}) => {
    const J = te(r, P), G = a.array.has(P), j = _e(S);
    Xe(o, P, j), G ? (d.array.next({
      name: P,
      values: { ...o }
    }), (l.isDirty || l.dirtyFields) && V.shouldDirty && d.state.next({
      name: P,
      dirtyFields: Ts(i, o),
      isDirty: F(P, j)
    })) : J && !J._f && !ht(j) ? R(P, j, V) : T(P, j, V), Il(P, a) && d.state.next({ ...n }), d.values.next({
      name: s.mount ? P : void 0,
      values: { ...o }
    });
  }, L = async (P) => {
    s.mount = !0;
    const S = P.target;
    let V = S.name, J = !0;
    const G = te(r, V), j = () => S.type ? Kc(G._f) : yp(P), oe = (Ee) => {
      J = Number.isNaN(Ee) || Nn(Ee, te(o, V, Ee));
    };
    if (G) {
      let Ee, be;
      const Le = j(), nr = P.type === ma.BLUR || P.type === ma.FOCUS_OUT, v9 = !Ow(G._f) && !t.resolver && !te(n.errors, V) && !G._f.deps || Dw(nr, te(n.touchedFields, V), n.isSubmitted, h, f), dc = Il(V, a, nr);
      Xe(o, V, Le), nr ? (G._f.onBlur && G._f.onBlur(P), c && c(0)) : G._f.onChange && G._f.onChange(P);
      const Ac = B(V, Le, nr, !1), b9 = !ft(Ac) || dc;
      if (!nr && d.values.next({
        name: V,
        type: P.type,
        values: { ...o }
      }), v9)
        return l.isValid && (e.mode === "onBlur" ? nr && p() : p()), b9 && d.state.next({ name: V, ...dc ? {} : Ac });
      if (!nr && dc && d.state.next({ ...n }), t.resolver) {
        const { errors: DA } = await x([V]);
        if (oe(Le), J) {
          const y9 = p1(n.errors, r, V), SA = p1(DA, r, y9.name || V);
          Ee = SA.error, V = SA.name, be = ft(DA);
        }
      } else
        v([V], !0), Ee = (await El(G, o, g, t.shouldUseNativeValidation))[V], v([V]), oe(Le), J && (Ee ? be = !1 : l.isValid && (be = await k(r, !0)));
      J && (G._f.deps && W(G._f.deps), I(V, be, Ee, Ac));
    }
  }, X = (P, S) => {
    if (te(n.errors, S) && P.focus)
      return P.focus(), 1;
  }, W = async (P, S = {}) => {
    let V, J;
    const G = It(P);
    if (t.resolver) {
      const j = await O(ke(P) ? P : G);
      V = ft(j), J = P ? !G.some((oe) => te(j, oe)) : V;
    } else P ? (J = (await Promise.all(G.map(async (j) => {
      const oe = te(r, j);
      return await k(oe && oe._f ? { [j]: oe } : oe);
    }))).every(Boolean), !(!J && !n.isValid) && p()) : J = V = await k(r);
    return d.state.next({
      ...!ln(P) || l.isValid && V !== n.isValid ? {} : { name: P },
      ...t.resolver || !P ? { isValid: V } : {},
      errors: n.errors
    }), S.shouldFocus && !J && ii(r, X, P ? G : a.mount), J;
  }, U = (P) => {
    const S = {
      ...s.mount ? o : i
    };
    return ke(P) ? S : ln(P) ? te(S, P) : P.map((V) => te(S, V));
  }, ee = (P, S) => ({
    invalid: !!te((S || n).errors, P),
    isDirty: !!te((S || n).dirtyFields, P),
    error: te((S || n).errors, P),
    isValidating: !!te(n.validatingFields, P),
    isTouched: !!te((S || n).touchedFields, P)
  }), Ae = (P) => {
    P && It(P).forEach((S) => qe(n.errors, S)), d.state.next({
      errors: P ? n.errors : {}
    });
  }, ne = (P, S, V) => {
    const J = (te(r, P, { _f: {} })._f || {}).ref, G = te(n.errors, P) || {}, { ref: j, message: oe, type: Ee, ...be } = G;
    Xe(n.errors, P, {
      ...be,
      ...S,
      ref: J
    }), d.state.next({
      name: P,
      errors: n.errors,
      isValid: !1
    }), V && V.shouldFocus && J && J.focus && J.focus();
  }, K = (P, S) => yn(P) ? d.values.subscribe({
    next: (V) => P(M(void 0, S), V)
  }) : M(P, S, !0), ae = (P, S = {}) => {
    for (const V of P ? It(P) : a.mount)
      a.mount.delete(V), a.array.delete(V), S.keepValue || (qe(r, V), qe(o, V)), !S.keepError && qe(n.errors, V), !S.keepDirty && qe(n.dirtyFields, V), !S.keepTouched && qe(n.touchedFields, V), !S.keepIsValidating && qe(n.validatingFields, V), !t.shouldUnregister && !S.keepDefaultValue && qe(i, V);
    d.values.next({
      values: { ...o }
    }), d.state.next({
      ...n,
      ...S.keepDirty ? { isDirty: F() } : {}
    }), !S.keepIsValid && p();
  }, pe = ({ disabled: P, name: S, field: V, fields: J, value: G }) => {
    if (Ft(P) && s.mount || P) {
      const j = P ? void 0 : ke(G) ? Kc(V ? V._f : te(J, S)._f) : G;
      Xe(o, S, j), B(S, j, !1, !1, !0);
    }
  }, Pe = (P, S = {}) => {
    let V = te(r, P);
    const J = Ft(S.disabled) || Ft(e.disabled);
    return Xe(r, P, {
      ...V || {},
      _f: {
        ...V && V._f ? V._f : { ref: { name: P } },
        name: P,
        mount: !0,
        ...S
      }
    }), a.mount.add(P), V ? pe({
      field: V,
      disabled: Ft(S.disabled) ? S.disabled : e.disabled,
      name: P,
      value: S.value
    }) : C(P, !0, S.value), {
      ...J ? { disabled: S.disabled || e.disabled } : {},
      ...t.progressive ? {
        required: !!S.required,
        min: eo(S.min),
        max: eo(S.max),
        minLength: eo(S.minLength),
        maxLength: eo(S.maxLength),
        pattern: eo(S.pattern)
      } : {},
      name: P,
      onChange: L,
      onBlur: L,
      ref: (G) => {
        if (G) {
          Pe(P, S), V = te(r, P);
          const j = ke(G.value) && G.querySelectorAll && G.querySelectorAll("input,select,textarea")[0] || G, oe = ww(j), Ee = V._f.refs || [];
          if (oe ? Ee.find((be) => be === j) : j === V._f.ref)
            return;
          Xe(r, P, {
            _f: {
              ...V._f,
              ...oe ? {
                refs: [
                  ...Ee.filter(Jc),
                  j,
                  ...Array.isArray(te(i, P)) ? [{}] : []
                ],
                ref: { type: j.type, name: P }
              } : { ref: j }
            }
          }), C(P, !1, void 0, j);
        } else
          V = te(r, P, {}), V._f && (V._f.mount = !1), (t.shouldUnregister || S.shouldUnregister) && !(Cp(a.array, P) && s.action) && a.unMount.add(P);
      }
    };
  }, Qe = () => t.shouldFocusError && ii(r, X, a.mount), et = (P) => {
    Ft(P) && (d.state.next({ disabled: P }), ii(r, (S, V) => {
      const J = te(r, V);
      J && (S.disabled = J._f.disabled || P, Array.isArray(J._f.refs) && J._f.refs.forEach((G) => {
        G.disabled = J._f.disabled || P;
      }));
    }, 0, !1));
  }, st = (P, S) => async (V) => {
    let J;
    V && (V.preventDefault && V.preventDefault(), V.persist && V.persist());
    let G = _e(o);
    if (d.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: j, values: oe } = await x();
      n.errors = j, G = oe;
    } else
      await k(r);
    if (qe(n.errors, "root"), ft(n.errors)) {
      d.state.next({
        errors: {}
      });
      try {
        await P(G, V);
      } catch (j) {
        J = j;
      }
    } else
      S && await S({ ...n.errors }, V), Qe(), setTimeout(Qe);
    if (d.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ft(n.errors) && !J,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), J)
      throw J;
  }, re = (P, S = {}) => {
    te(r, P) && (ke(S.defaultValue) ? z(P, _e(te(i, P))) : (z(P, S.defaultValue), Xe(i, P, _e(S.defaultValue))), S.keepTouched || qe(n.touchedFields, P), S.keepDirty || (qe(n.dirtyFields, P), n.isDirty = S.defaultValue ? F(P, _e(te(i, P))) : F()), S.keepError || (qe(n.errors, P), l.isValid && p()), d.state.next({ ...n }));
  }, Ge = (P, S = {}) => {
    const V = P ? _e(P) : i, J = _e(V), G = ft(P), j = G ? i : J;
    if (S.keepDefaultValues || (i = V), !S.keepValues) {
      if (S.keepDirtyValues)
        for (const oe of a.mount)
          te(n.dirtyFields, oe) ? Xe(j, oe, te(o, oe)) : z(oe, te(j, oe));
      else {
        if (eA && ke(P))
          for (const oe of a.mount) {
            const Ee = te(r, oe);
            if (Ee && Ee._f) {
              const be = Array.isArray(Ee._f.refs) ? Ee._f.refs[0] : Ee._f.ref;
              if (va(be)) {
                const Le = be.closest("form");
                if (Le) {
                  Le.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      o = e.shouldUnregister ? S.keepDefaultValues ? _e(i) : {} : _e(j), d.array.next({
        values: { ...j }
      }), d.values.next({
        values: { ...j }
      });
    }
    a = {
      mount: S.keepDirtyValues ? a.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !l.isValid || !!S.keepIsValid || !!S.keepDirtyValues, s.watch = !!e.shouldUnregister, d.state.next({
      submitCount: S.keepSubmitCount ? n.submitCount : 0,
      isDirty: G ? !1 : S.keepDirty ? n.isDirty : !!(S.keepDefaultValues && !Nn(P, i)),
      isSubmitted: S.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: G ? {} : S.keepDirtyValues ? S.keepDefaultValues && o ? Ts(i, o) : n.dirtyFields : S.keepDefaultValues && P ? Ts(i, P) : S.keepDirty ? n.dirtyFields : {},
      touchedFields: S.keepTouched ? n.touchedFields : {},
      errors: S.keepErrors ? n.errors : {},
      isSubmitSuccessful: S.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, tt = (P, S) => Ge(yn(P) ? P(o) : P, S);
  return {
    control: {
      register: Pe,
      unregister: ae,
      getFieldState: ee,
      handleSubmit: st,
      setError: ne,
      _executeSchema: x,
      _getWatch: M,
      _getDirty: F,
      _updateValid: p,
      _removeUnmounted: Q,
      _updateFieldArray: b,
      _updateDisabledField: pe,
      _getFieldArray: H,
      _reset: Ge,
      _resetDefaultValues: () => yn(t.defaultValues) && t.defaultValues().then((P) => {
        tt(P, t.resetOptions), d.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (P) => {
        n = {
          ...n,
          ...P
        };
      },
      _disableForm: et,
      _subjects: d,
      _proxyFormState: l,
      _setErrors: E,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(P) {
        s = P;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return a;
      },
      set _names(P) {
        a = P;
      },
      get _formState() {
        return n;
      },
      set _formState(P) {
        n = P;
      },
      get _options() {
        return t;
      },
      set _options(P) {
        t = {
          ...t,
          ...P
        };
      }
    },
    trigger: W,
    register: Pe,
    handleSubmit: st,
    watch: K,
    setValue: z,
    getValues: U,
    reset: tt,
    resetField: re,
    clearErrors: Ae,
    unregister: ae,
    setError: ne,
    setFocus: (P, S = {}) => {
      const V = te(r, P), J = V && V._f;
      if (J) {
        const G = J.refs ? J.refs[0] : J.ref;
        G.focus && (G.focus(), S.shouldSelect && G.select());
      }
    },
    getFieldState: ee
  };
}
function Ka(e = {}) {
  const t = _.useRef(), n = _.useRef(), [r, i] = _.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: yn(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: yn(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...Tw(e),
    formState: r
  });
  const o = t.current.control;
  return o._options = e, Ja({
    subject: o._subjects.state,
    next: (s) => {
      xp(s, o._proxyFormState, o._updateFormState, !0) && i({ ...o._formState });
    }
  }), _.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), _.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== r.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, r.isDirty]), _.useEffect(() => {
    e.values && !Nn(e.values, n.current) ? (o._reset(e.values, o._options.resetOptions), n.current = e.values, i((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), _.useEffect(() => {
    e.errors && o._setErrors(e.errors);
  }, [e.errors, o]), _.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), _.useEffect(() => {
    e.shouldUnregister && o._subjects.values.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), t.current.formState = Ep(r, o), t.current;
}
function Rw(e) {
  var u;
  const [t, n] = q(!1), [r, i] = q(!1), {
    register: o,
    handleSubmit: s,
    control: a,
    formState: { errors: c }
  } = Ka({
    defaultValues: {
      name: "",
      sharingType: en,
      availableOffline: !1
    }
  });
  return /* @__PURE__ */ D("form", { onSubmit: s(e.onSubmit), children: [
    /* @__PURE__ */ A(Ea, { htmlFor: "driveName", children: "Drive Name" }),
    /* @__PURE__ */ A(
      as,
      {
        ...o("name", {
          required: "Drive name is required"
        }),
        errorMessage: (u = c.name) == null ? void 0 : u.message,
        icon: /* @__PURE__ */ A(Y, { name: "Drive" }),
        placeholder: "Drive name"
      }
    ),
    /* @__PURE__ */ A(Ct, { className: "my-4" }),
    /* @__PURE__ */ A(Ea, { htmlFor: "sharingType", children: "Sharing settings" }),
    /* @__PURE__ */ A(Gp, { control: a }),
    /* @__PURE__ */ A(Ct, { className: "my-3" }),
    /* @__PURE__ */ A(
      Ei,
      {
        title: "Upload from device",
        isOpen: r,
        onOpenChange: () => i(!r),
        children: /* @__PURE__ */ A("div", { className: "mt-3 grid h-[117px] w-full place-items-center rounded-xl bg-gray-200", children: /* @__PURE__ */ D("div", { className: "rounded-xl bg-white p-3 text-xs", children: [
          /* @__PURE__ */ A(
            Y,
            {
              name: "ArrowUp",
              size: 20,
              className: "mr-2 inline-block"
            }
          ),
          "Click or drop folder"
        ] }) })
      }
    ),
    /* @__PURE__ */ A(Ct, { className: "my-3" }),
    /* @__PURE__ */ D(
      Ei,
      {
        title: "Location",
        isOpen: t,
        onOpenChange: () => n(!t),
        children: [
          /* @__PURE__ */ A(lA, { location: Zo }),
          /* @__PURE__ */ A(uA, { ...o("availableOffline") })
        ]
      }
    ),
    /* @__PURE__ */ A(Ct, { className: "my-3" }),
    /* @__PURE__ */ A(Et, { type: "submit", className: "mb-4 w-full", children: "Create new drive" })
  ] });
}
const oA = JSON, Lw = (e) => e.toUpperCase(), Fw = (e) => {
  const t = {};
  return e.forEach((n, r) => {
    t[r] = n;
  }), t;
}, Qw = (e, t, n) => e.document ? e : {
  document: e,
  variables: t,
  requestHeaders: n,
  signal: void 0
}, Xw = (e, t, n) => e.query ? e : {
  query: e,
  variables: t,
  requestHeaders: n,
  signal: void 0
}, Vw = (e, t) => e.documents ? e : {
  documents: e,
  requestHeaders: t,
  signal: void 0
};
function Ys(e, t) {
  if (!!!e)
    throw new Error(t);
}
function kw(e) {
  return typeof e == "object" && e !== null;
}
function Mw(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const zw = /\r\n|[\n\r]/g;
function xl(e, t) {
  let n = 0, r = 1;
  for (const i of e.body.matchAll(zw)) {
    if (typeof i.index == "number" || Mw(!1), i.index >= t)
      break;
    n = i.index + i[0].length, r += 1;
  }
  return {
    line: r,
    column: t + 1 - n
  };
}
function jw(e) {
  return Rp(
    e.source,
    xl(e.source, e.start)
  );
}
function Rp(e, t) {
  const n = e.locationOffset.column - 1, r = "".padStart(n) + e.body, i = t.line - 1, o = e.locationOffset.line - 1, s = t.line + o, a = t.line === 1 ? n : 0, c = t.column + a, u = `${e.name}:${s}:${c}
`, l = r.split(/\r\n|[\n\r]/g), d = l[i];
  if (d.length > 120) {
    const f = Math.floor(c / 80), h = c % 80, g = [];
    for (let m = 0; m < d.length; m += 80)
      g.push(d.slice(m, m + 80));
    return u + m1([
      [`${s} |`, g[0]],
      ...g.slice(1, f + 1).map((m) => ["|", m]),
      ["|", "^".padStart(h)],
      ["|", g[f + 1]]
    ]);
  }
  return u + m1([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, l[i - 1]],
    [`${s} |`, d],
    ["|", "^".padStart(c)],
    [`${s + 1} |`, l[i + 1]]
  ]);
}
function m1(e) {
  const t = e.filter(([r, i]) => i !== void 0), n = Math.max(...t.map(([r]) => r.length));
  return t.map(([r, i]) => r.padStart(n) + (i ? " " + i : "")).join(`
`);
}
function Ww(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class sA extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...n) {
    var r, i, o;
    const { nodes: s, source: a, positions: c, path: u, originalError: l, extensions: d } = Ww(n);
    super(t), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = l ?? void 0, this.nodes = v1(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const f = v1(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((g) => g.loc).filter((g) => g != null)
    );
    this.source = a ?? (f == null || (i = f[0]) === null || i === void 0 ? void 0 : i.source), this.positions = c ?? (f == null ? void 0 : f.map((g) => g.start)), this.locations = c && a ? c.map((g) => xl(a, g)) : f == null ? void 0 : f.map((g) => xl(g.source, g.start));
    const h = kw(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (o = d ?? h) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, sA) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (t += `

` + jw(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        t += `

` + Rp(this.source, n);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function v1(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function nt(e, t, n) {
  return new sA(`Syntax Error: ${n}`, {
    source: e,
    positions: [t]
  });
}
class Zw {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, n, r) {
    this.start = t.start, this.end = n.end, this.startToken = t, this.endToken = n, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Lp {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, n, r, i, o, s) {
    this.kind = t, this.start = n, this.end = r, this.line = i, this.column = o, this.value = s, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Fp = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Gw = new Set(Object.keys(Fp));
function b1(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && Gw.has(t);
}
var Ur;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Ur || (Ur = {}));
var Bl;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Bl || (Bl = {}));
var ge;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(ge || (ge = {}));
function wl(e) {
  return e === 9 || e === 32;
}
function ko(e) {
  return e >= 48 && e <= 57;
}
function Qp(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function Xp(e) {
  return Qp(e) || e === 95;
}
function qw(e) {
  return Qp(e) || ko(e) || e === 95;
}
function Yw(e) {
  var t;
  let n = Number.MAX_SAFE_INTEGER, r = null, i = -1;
  for (let s = 0; s < e.length; ++s) {
    var o;
    const a = e[s], c = Uw(a);
    c !== a.length && (r = (o = r) !== null && o !== void 0 ? o : s, i = s, s !== 0 && c < n && (n = c));
  }
  return e.map((s, a) => a === 0 ? s : s.slice(n)).slice(
    (t = r) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function Uw(e) {
  let t = 0;
  for (; t < e.length && wl(e.charCodeAt(t)); )
    ++t;
  return t;
}
function Jw(e, t) {
  const n = e.replace(/"""/g, '\\"""'), r = n.split(/\r\n|[\n\r]/g), i = r.length === 1, o = r.length > 1 && r.slice(1).every((h) => h.length === 0 || wl(h.charCodeAt(0))), s = n.endsWith('\\"""'), a = e.endsWith('"') && !s, c = e.endsWith("\\"), u = a || c, l = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || u || o || s
  );
  let d = "";
  const f = i && wl(e.charCodeAt(0));
  return (l && !f || o) && (d += `
`), d += n, (l || u) && (d += `
`), '"""' + d + '"""';
}
var Z;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(Z || (Z = {}));
class Kw {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const n = new Lp(Z.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== Z.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const n = $w(this, t.end);
          t.next = n, n.prev = t, t = n;
        }
      while (t.kind === Z.COMMENT);
    return t;
  }
}
function _w(e) {
  return e === Z.BANG || e === Z.DOLLAR || e === Z.AMP || e === Z.PAREN_L || e === Z.PAREN_R || e === Z.SPREAD || e === Z.COLON || e === Z.EQUALS || e === Z.AT || e === Z.BRACKET_L || e === Z.BRACKET_R || e === Z.BRACE_L || e === Z.PIPE || e === Z.BRACE_R;
}
function Vi(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function _a(e, t) {
  return Vp(e.charCodeAt(t)) && kp(e.charCodeAt(t + 1));
}
function Vp(e) {
  return e >= 55296 && e <= 56319;
}
function kp(e) {
  return e >= 56320 && e <= 57343;
}
function Br(e, t) {
  const n = e.source.body.codePointAt(t);
  if (n === void 0)
    return Z.EOF;
  if (n >= 32 && n <= 126) {
    const r = String.fromCodePoint(n);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function Ye(e, t, n, r, i) {
  const o = e.line, s = 1 + n - e.lineStart;
  return new Lp(t, n, r, o, s, i);
}
function $w(e, t) {
  const n = e.source.body, r = n.length;
  let i = t;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return eP(e, i);
      case 33:
        return Ye(e, Z.BANG, i, i + 1);
      case 36:
        return Ye(e, Z.DOLLAR, i, i + 1);
      case 38:
        return Ye(e, Z.AMP, i, i + 1);
      case 40:
        return Ye(e, Z.PAREN_L, i, i + 1);
      case 41:
        return Ye(e, Z.PAREN_R, i, i + 1);
      case 46:
        if (n.charCodeAt(i + 1) === 46 && n.charCodeAt(i + 2) === 46)
          return Ye(e, Z.SPREAD, i, i + 3);
        break;
      case 58:
        return Ye(e, Z.COLON, i, i + 1);
      case 61:
        return Ye(e, Z.EQUALS, i, i + 1);
      case 64:
        return Ye(e, Z.AT, i, i + 1);
      case 91:
        return Ye(e, Z.BRACKET_L, i, i + 1);
      case 93:
        return Ye(e, Z.BRACKET_R, i, i + 1);
      case 123:
        return Ye(e, Z.BRACE_L, i, i + 1);
      case 124:
        return Ye(e, Z.PIPE, i, i + 1);
      case 125:
        return Ye(e, Z.BRACE_R, i, i + 1);
      case 34:
        return n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 ? sP(e, i) : nP(e, i);
    }
    if (ko(o) || o === 45)
      return tP(e, i, o);
    if (Xp(o))
      return aP(e, i);
    throw nt(
      e.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Vi(o) || _a(n, i) ? `Unexpected character: ${Br(e, i)}.` : `Invalid character: ${Br(e, i)}.`
    );
  }
  return Ye(e, Z.EOF, r, r);
}
function eP(e, t) {
  const n = e.source.body, r = n.length;
  let i = t + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (Vi(o))
      ++i;
    else if (_a(n, i))
      i += 2;
    else
      break;
  }
  return Ye(
    e,
    Z.COMMENT,
    t,
    i,
    n.slice(t + 1, i)
  );
}
function tP(e, t, n) {
  const r = e.source.body;
  let i = t, o = n, s = !1;
  if (o === 45 && (o = r.charCodeAt(++i)), o === 48) {
    if (o = r.charCodeAt(++i), ko(o))
      throw nt(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${Br(
          e,
          i
        )}.`
      );
  } else
    i = _c(e, i, o), o = r.charCodeAt(i);
  if (o === 46 && (s = !0, o = r.charCodeAt(++i), i = _c(e, i, o), o = r.charCodeAt(i)), (o === 69 || o === 101) && (s = !0, o = r.charCodeAt(++i), (o === 43 || o === 45) && (o = r.charCodeAt(++i)), i = _c(e, i, o), o = r.charCodeAt(i)), o === 46 || Xp(o))
    throw nt(
      e.source,
      i,
      `Invalid number, expected digit but got: ${Br(
        e,
        i
      )}.`
    );
  return Ye(
    e,
    s ? Z.FLOAT : Z.INT,
    t,
    i,
    r.slice(t, i)
  );
}
function _c(e, t, n) {
  if (!ko(n))
    throw nt(
      e.source,
      t,
      `Invalid number, expected digit but got: ${Br(
        e,
        t
      )}.`
    );
  const r = e.source.body;
  let i = t + 1;
  for (; ko(r.charCodeAt(i)); )
    ++i;
  return i;
}
function nP(e, t) {
  const n = e.source.body, r = n.length;
  let i = t + 1, o = i, s = "";
  for (; i < r; ) {
    const a = n.charCodeAt(i);
    if (a === 34)
      return s += n.slice(o, i), Ye(e, Z.STRING, t, i + 1, s);
    if (a === 92) {
      s += n.slice(o, i);
      const c = n.charCodeAt(i + 1) === 117 ? n.charCodeAt(i + 2) === 123 ? rP(e, i) : iP(e, i) : oP(e, i);
      s += c.value, i += c.size, o = i;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (Vi(a))
      ++i;
    else if (_a(n, i))
      i += 2;
    else
      throw nt(
        e.source,
        i,
        `Invalid character within String: ${Br(
          e,
          i
        )}.`
      );
  }
  throw nt(e.source, i, "Unterminated string.");
}
function rP(e, t) {
  const n = e.source.body;
  let r = 0, i = 3;
  for (; i < 12; ) {
    const o = n.charCodeAt(t + i++);
    if (o === 125) {
      if (i < 5 || !Vi(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: i
      };
    }
    if (r = r << 4 | uo(o), r < 0)
      break;
  }
  throw nt(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(
      t,
      t + i
    )}".`
  );
}
function iP(e, t) {
  const n = e.source.body, r = y1(n, t + 2);
  if (Vi(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (Vp(r) && n.charCodeAt(t + 6) === 92 && n.charCodeAt(t + 7) === 117) {
    const i = y1(n, t + 8);
    if (kp(i))
      return {
        value: String.fromCodePoint(r, i),
        size: 12
      };
  }
  throw nt(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(t, t + 6)}".`
  );
}
function y1(e, t) {
  return uo(e.charCodeAt(t)) << 12 | uo(e.charCodeAt(t + 1)) << 8 | uo(e.charCodeAt(t + 2)) << 4 | uo(e.charCodeAt(t + 3));
}
function uo(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function oP(e, t) {
  const n = e.source.body;
  switch (n.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw nt(
    e.source,
    t,
    `Invalid character escape sequence: "${n.slice(
      t,
      t + 2
    )}".`
  );
}
function sP(e, t) {
  const n = e.source.body, r = n.length;
  let i = e.lineStart, o = t + 3, s = o, a = "";
  const c = [];
  for (; o < r; ) {
    const u = n.charCodeAt(o);
    if (u === 34 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34) {
      a += n.slice(s, o), c.push(a);
      const l = Ye(
        e,
        Z.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        Yw(c).join(`
`)
      );
      return e.line += c.length - 1, e.lineStart = i, l;
    }
    if (u === 92 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34 && n.charCodeAt(o + 3) === 34) {
      a += n.slice(s, o), s = o + 1, o += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      a += n.slice(s, o), c.push(a), u === 13 && n.charCodeAt(o + 1) === 10 ? o += 2 : ++o, a = "", s = o, i = o;
      continue;
    }
    if (Vi(u))
      ++o;
    else if (_a(n, o))
      o += 2;
    else
      throw nt(
        e.source,
        o,
        `Invalid character within String: ${Br(
          e,
          o
        )}.`
      );
  }
  throw nt(e.source, o, "Unterminated string.");
}
function aP(e, t) {
  const n = e.source.body, r = n.length;
  let i = t + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (qw(o))
      ++i;
    else
      break;
  }
  return Ye(
    e,
    Z.NAME,
    t,
    i,
    n.slice(t, i)
  );
}
const cP = 10, Mp = 2;
function aA(e) {
  return $a(e, []);
}
function $a(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return uP(e, t);
    default:
      return String(e);
  }
}
function uP(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const n = [...t, e];
  if (lP(e)) {
    const r = e.toJSON();
    if (r !== e)
      return typeof r == "string" ? r : $a(r, n);
  } else if (Array.isArray(e))
    return AP(e, n);
  return dP(e, n);
}
function lP(e) {
  return typeof e.toJSON == "function";
}
function dP(e, t) {
  const n = Object.entries(e);
  return n.length === 0 ? "{}" : t.length > Mp ? "[" + fP(e) + "]" : "{ " + n.map(
    ([i, o]) => i + ": " + $a(o, t)
  ).join(", ") + " }";
}
function AP(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > Mp)
    return "[Array]";
  const n = Math.min(cP, e.length), r = e.length - n, i = [];
  for (let o = 0; o < n; ++o)
    i.push($a(e[o], t));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push(`... ${r} more items`), "[" + i.join(", ") + "]";
}
function fP(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
const gP = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", hP = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  gP ? function(t, n) {
    return t instanceof n;
  } : function(t, n) {
    if (t instanceof n)
      return !0;
    if (typeof t == "object" && t !== null) {
      var r;
      const i = n.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (r = t.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (i === o) {
        const s = aA(t);
        throw new Error(`Cannot use ${i} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class zp {
  constructor(t, n = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || Ys(!1, `Body must be a string. Received: ${aA(t)}.`), this.body = t, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || Ys(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Ys(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function pP(e) {
  return hP(e, zp);
}
function mP(e, t) {
  return new vP(e, t).parseDocument();
}
class vP {
  constructor(t, n = {}) {
    const r = pP(t) ? t : new zp(t);
    this._lexer = new Kw(r), this._options = n, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(Z.NAME);
    return this.node(t, {
      kind: ge.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: ge.DOCUMENT,
      definitions: this.many(
        Z.SOF,
        this.parseDefinition,
        Z.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(Z.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), n = t ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === Z.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw nt(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(Z.BRACE_L))
      return this.node(t, {
        kind: ge.OPERATION_DEFINITION,
        operation: Ur.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let r;
    return this.peek(Z.NAME) && (r = this.parseName()), this.node(t, {
      kind: ge.OPERATION_DEFINITION,
      operation: n,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(Z.NAME);
    switch (t.value) {
      case "query":
        return Ur.QUERY;
      case "mutation":
        return Ur.MUTATION;
      case "subscription":
        return Ur.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      Z.PAREN_L,
      this.parseVariableDefinition,
      Z.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: ge.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(Z.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(Z.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(Z.DOLLAR), this.node(t, {
      kind: ge.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: ge.SELECTION_SET,
      selections: this.many(
        Z.BRACE_L,
        this.parseSelection,
        Z.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(Z.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, n = this.parseName();
    let r, i;
    return this.expectOptionalToken(Z.COLON) ? (r = n, i = this.parseName()) : i = n, this.node(t, {
      kind: ge.FIELD,
      alias: r,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(Z.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const n = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(Z.PAREN_L, n, Z.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(Z.COLON), this.node(n, {
      kind: ge.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(Z.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(Z.NAME) ? this.node(t, {
      kind: ge.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: ge.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: ge.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: ge.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const n = this._lexer.token;
    switch (n.kind) {
      case Z.BRACKET_L:
        return this.parseList(t);
      case Z.BRACE_L:
        return this.parseObject(t);
      case Z.INT:
        return this.advanceLexer(), this.node(n, {
          kind: ge.INT,
          value: n.value
        });
      case Z.FLOAT:
        return this.advanceLexer(), this.node(n, {
          kind: ge.FLOAT,
          value: n.value
        });
      case Z.STRING:
      case Z.BLOCK_STRING:
        return this.parseStringLiteral();
      case Z.NAME:
        switch (this.advanceLexer(), n.value) {
          case "true":
            return this.node(n, {
              kind: ge.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: ge.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: ge.NULL
            });
          default:
            return this.node(n, {
              kind: ge.ENUM,
              value: n.value
            });
        }
      case Z.DOLLAR:
        if (t)
          if (this.expectToken(Z.DOLLAR), this._lexer.token.kind === Z.NAME) {
            const r = this._lexer.token.value;
            throw nt(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: ge.STRING,
      value: t.value,
      block: t.kind === Z.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const n = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: ge.LIST,
      values: this.any(Z.BRACKET_L, n, Z.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const n = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: ge.OBJECT,
      fields: this.any(Z.BRACE_L, n, Z.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(Z.COLON), this.node(n, {
      kind: ge.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const n = [];
    for (; this.peek(Z.AT); )
      n.push(this.parseDirective(t));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const n = this._lexer.token;
    return this.expectToken(Z.AT), this.node(n, {
      kind: ge.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let n;
    if (this.expectOptionalToken(Z.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(Z.BRACKET_R), n = this.node(t, {
        kind: ge.LIST_TYPE,
        type: r
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(Z.BANG) ? this.node(t, {
      kind: ge.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: ge.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(Z.STRING) || this.peek(Z.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), i = this.many(
      Z.BRACE_L,
      this.parseOperationTypeDefinition,
      Z.BRACE_R
    );
    return this.node(t, {
      kind: ge.SCHEMA_DEFINITION,
      description: n,
      directives: r,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, n = this.parseOperationType();
    this.expectToken(Z.COLON);
    const r = this.parseNamedType();
    return this.node(t, {
      kind: ge.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ge.SCALAR_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ge.OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(Z.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      Z.BRACE_L,
      this.parseFieldDefinition,
      Z.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(Z.COLON);
    const o = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(t, {
      kind: ge.FIELD_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      type: o,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      Z.PAREN_L,
      this.parseInputValueDef,
      Z.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseName();
    this.expectToken(Z.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(Z.EQUALS) && (o = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(t, {
      kind: ge.INPUT_VALUE_DEFINITION,
      description: n,
      name: r,
      type: i,
      defaultValue: o,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(t, {
      kind: ge.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: ge.UNION_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(Z.EQUALS) ? this.delimitedMany(Z.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: ge.ENUM_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      Z.BRACE_L,
      this.parseEnumValueDefinition,
      Z.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: ge.ENUM_VALUE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw nt(
        this._lexer.source,
        this._lexer.token.start,
        `${Rs(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: ge.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      Z.BRACE_L,
      this.parseInputValueDef,
      Z.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === Z.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), r = this.optionalMany(
      Z.BRACE_L,
      this.parseOperationTypeDefinition,
      Z.BRACE_R
    );
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.UNION_TYPE_EXTENSION,
      name: n,
      directives: r,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.ENUM_TYPE_EXTENSION,
      name: n,
      directives: r,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: ge.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: r,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(Z.AT);
    const r = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const s = this.parseDirectiveLocations();
    return this.node(t, {
      kind: ge.DIRECTIVE_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      repeatable: o,
      locations: s
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(Z.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Bl, n.value))
      return n;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, n) {
    return this._options.noLocation !== !0 && (n.loc = new Zw(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const n = this._lexer.token;
    if (n.kind === t)
      return this.advanceLexer(), n;
    throw nt(
      this._lexer.source,
      n.start,
      `Expected ${jp(t)}, found ${Rs(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const n = this._lexer.token;
    if (n.kind === Z.NAME && n.value === t)
      this.advanceLexer();
    else
      throw nt(
        this._lexer.source,
        n.start,
        `Expected "${t}", found ${Rs(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const n = this._lexer.token;
    return n.kind === Z.NAME && n.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const n = t ?? this._lexer.token;
    return nt(
      this._lexer.source,
      n.start,
      `Unexpected ${Rs(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, n, r) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(r); )
      i.push(n.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, n, r) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(n.call(this));
      while (!this.expectOptionalToken(r));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, n, r) {
    this.expectToken(t);
    const i = [];
    do
      i.push(n.call(this));
    while (!this.expectOptionalToken(r));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, n) {
    this.expectOptionalToken(t);
    const r = [];
    do
      r.push(n.call(this));
    while (this.expectOptionalToken(t));
    return r;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, n = this._lexer.advance();
    if (t !== void 0 && n.kind !== Z.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw nt(
        this._lexer.source,
        n.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function Rs(e) {
  const t = e.value;
  return jp(e.kind) + (t != null ? ` "${t}"` : "");
}
function jp(e) {
  return _w(e) ? `"${e}"` : e;
}
function bP(e) {
  return `"${e.replace(yP, CP)}"`;
}
const yP = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function CP(e) {
  return IP[e.charCodeAt(0)];
}
const IP = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], EP = Object.freeze({});
function xP(e, t, n = Fp) {
  const r = /* @__PURE__ */ new Map();
  for (const v of Object.values(ge))
    r.set(v, BP(t, v));
  let i, o = Array.isArray(e), s = [e], a = -1, c = [], u = e, l, d;
  const f = [], h = [];
  do {
    a++;
    const v = a === s.length, b = v && c.length !== 0;
    if (v) {
      if (l = h.length === 0 ? void 0 : f[f.length - 1], u = d, d = h.pop(), b)
        if (o) {
          u = u.slice();
          let E = 0;
          for (const [C, B] of c) {
            const I = C - E;
            B === null ? (u.splice(I, 1), E++) : u[I] = B;
          }
        } else {
          u = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(u)
          );
          for (const [E, C] of c)
            u[E] = C;
        }
      a = i.index, s = i.keys, c = i.edits, o = i.inArray, i = i.prev;
    } else if (d) {
      if (l = o ? a : s[a], u = d[l], u == null)
        continue;
      f.push(l);
    }
    let y;
    if (!Array.isArray(u)) {
      var g, m;
      b1(u) || Ys(!1, `Invalid AST Node: ${aA(u)}.`);
      const E = v ? (g = r.get(u.kind)) === null || g === void 0 ? void 0 : g.leave : (m = r.get(u.kind)) === null || m === void 0 ? void 0 : m.enter;
      if (y = E == null ? void 0 : E.call(t, u, l, d, f, h), y === EP)
        break;
      if (y === !1) {
        if (!v) {
          f.pop();
          continue;
        }
      } else if (y !== void 0 && (c.push([l, y]), !v))
        if (b1(y))
          u = y;
        else {
          f.pop();
          continue;
        }
    }
    if (y === void 0 && b && c.push([l, u]), v)
      f.pop();
    else {
      var p;
      i = {
        inArray: o,
        index: a,
        keys: s,
        edits: c,
        prev: i
      }, o = Array.isArray(u), s = o ? u : (p = n[u.kind]) !== null && p !== void 0 ? p : [], a = -1, c = [], d && h.push(d), d = u;
    }
  } while (i !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : e;
}
function BP(e, t) {
  const n = e[t];
  return typeof n == "object" ? n : typeof n == "function" ? {
    enter: n,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function wP(e) {
  return xP(e, HP);
}
const PP = 80, HP = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => ce(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = we("(", ce(e.variableDefinitions, ", "), ")"), n = ce(
        [
          e.operation,
          ce([e.name, t]),
          ce(e.directives, " ")
        ],
        " "
      );
      return (n === "query" ? "" : n + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: n, directives: r }) => e + ": " + t + we(" = ", n) + we(" ", ce(r, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => Mt(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: n, directives: r, selectionSet: i }) {
      const o = we("", e, ": ") + t;
      let s = o + we("(", ce(n, ", "), ")");
      return s.length > PP && (s = o + we(`(
`, Us(ce(n, `
`)), `
)`)), ce([s, ce(r, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + we(" ", ce(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: n }) => ce(
      [
        "...",
        we("on ", e),
        ce(t, " "),
        n
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: n, directives: r, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${e}${we("(", ce(n, ", "), ")")} on ${t} ${we("", ce(r, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? Jw(e) : bP(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + ce(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + ce(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + we("(", ce(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: n }) => we("", e, `
`) + ce(["schema", ce(t, " "), Mt(n)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: n }) => we("", e, `
`) + ce(["scalar", t, ce(n, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: n, directives: r, fields: i }) => we("", e, `
`) + ce(
      [
        "type",
        t,
        we("implements ", ce(n, " & ")),
        ce(r, " "),
        Mt(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: n, type: r, directives: i }) => we("", e, `
`) + t + (C1(n) ? we(`(
`, Us(ce(n, `
`)), `
)`) : we("(", ce(n, ", "), ")")) + ": " + r + we(" ", ce(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: n, defaultValue: r, directives: i }) => we("", e, `
`) + ce(
      [t + ": " + n, we("= ", r), ce(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: n, directives: r, fields: i }) => we("", e, `
`) + ce(
      [
        "interface",
        t,
        we("implements ", ce(n, " & ")),
        ce(r, " "),
        Mt(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: n, types: r }) => we("", e, `
`) + ce(
      ["union", t, ce(n, " "), we("= ", ce(r, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: n, values: r }) => we("", e, `
`) + ce(["enum", t, ce(n, " "), Mt(r)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: n }) => we("", e, `
`) + ce([t, ce(n, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: n, fields: r }) => we("", e, `
`) + ce(["input", t, ce(n, " "), Mt(r)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: n, repeatable: r, locations: i }) => we("", e, `
`) + "directive @" + t + (C1(n) ? we(`(
`, Us(ce(n, `
`)), `
)`) : we("(", ce(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + ce(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => ce(
      ["extend schema", ce(e, " "), Mt(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => ce(["extend scalar", e, ce(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: n, fields: r }) => ce(
      [
        "extend type",
        e,
        we("implements ", ce(t, " & ")),
        ce(n, " "),
        Mt(r)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: n, fields: r }) => ce(
      [
        "extend interface",
        e,
        we("implements ", ce(t, " & ")),
        ce(n, " "),
        Mt(r)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: n }) => ce(
      [
        "extend union",
        e,
        ce(t, " "),
        we("= ", ce(n, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: n }) => ce(["extend enum", e, ce(t, " "), Mt(n)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: n }) => ce(["extend input", e, ce(t, " "), Mt(n)], " ")
  }
};
function ce(e, t = "") {
  var n;
  return (n = e == null ? void 0 : e.filter((r) => r).join(t)) !== null && n !== void 0 ? n : "";
}
function Mt(e) {
  return we(`{
`, Us(ce(e, `
`)), `
}`);
}
function we(e, t, n = "") {
  return t != null && t !== "" ? e + t + n : "";
}
function Us(e) {
  return we("  ", e.replace(/\n/g, `
  `));
}
function C1(e) {
  var t;
  return (t = e == null ? void 0 : e.some((n) => n.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
const I1 = (e) => {
  var r, i;
  let t;
  const n = e.definitions.filter((o) => o.kind === "OperationDefinition");
  return n.length === 1 && (t = (i = (r = n[0]) == null ? void 0 : r.name) == null ? void 0 : i.value), t;
}, $c = (e) => {
  if (typeof e == "string") {
    let n;
    try {
      const r = mP(e);
      n = I1(r);
    } catch {
    }
    return { query: e, operationName: n };
  }
  const t = I1(e);
  return { query: wP(e), operationName: t };
};
class fo extends Error {
  constructor(t, n) {
    const r = `${fo.extractMessage(t)}: ${JSON.stringify({
      response: t,
      request: n
    })}`;
    super(r), Object.setPrototypeOf(this, fo.prototype), this.response = t, this.request = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, fo);
  }
  static extractMessage(t) {
    var n, r;
    return ((r = (n = t.errors) == null ? void 0 : n[0]) == null ? void 0 : r.message) ?? `GraphQL Error (Code: ${t.status})`;
  }
}
var Pl = { exports: {} };
(function(e, t) {
  var n = typeof self < "u" ? self : so, r = function() {
    function o() {
      this.fetch = !1, this.DOMException = n.DOMException;
    }
    return o.prototype = n, new o();
  }();
  (function(o) {
    (function(s) {
      var a = {
        searchParams: "URLSearchParams" in o,
        iterable: "Symbol" in o && "iterator" in Symbol,
        blob: "FileReader" in o && "Blob" in o && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in o,
        arrayBuffer: "ArrayBuffer" in o
      };
      function c(H) {
        return H && DataView.prototype.isPrototypeOf(H);
      }
      if (a.arrayBuffer)
        var u = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], l = ArrayBuffer.isView || function(H) {
          return H && u.indexOf(Object.prototype.toString.call(H)) > -1;
        };
      function d(H) {
        if (typeof H != "string" && (H = String(H)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(H))
          throw new TypeError("Invalid character in header field name");
        return H.toLowerCase();
      }
      function f(H) {
        return typeof H != "string" && (H = String(H)), H;
      }
      function h(H) {
        var T = {
          next: function() {
            var R = H.shift();
            return { done: R === void 0, value: R };
          }
        };
        return a.iterable && (T[Symbol.iterator] = function() {
          return T;
        }), T;
      }
      function g(H) {
        this.map = {}, H instanceof g ? H.forEach(function(T, R) {
          this.append(R, T);
        }, this) : Array.isArray(H) ? H.forEach(function(T) {
          this.append(T[0], T[1]);
        }, this) : H && Object.getOwnPropertyNames(H).forEach(function(T) {
          this.append(T, H[T]);
        }, this);
      }
      g.prototype.append = function(H, T) {
        H = d(H), T = f(T);
        var R = this.map[H];
        this.map[H] = R ? R + ", " + T : T;
      }, g.prototype.delete = function(H) {
        delete this.map[d(H)];
      }, g.prototype.get = function(H) {
        return H = d(H), this.has(H) ? this.map[H] : null;
      }, g.prototype.has = function(H) {
        return this.map.hasOwnProperty(d(H));
      }, g.prototype.set = function(H, T) {
        this.map[d(H)] = f(T);
      }, g.prototype.forEach = function(H, T) {
        for (var R in this.map)
          this.map.hasOwnProperty(R) && H.call(T, this.map[R], R, this);
      }, g.prototype.keys = function() {
        var H = [];
        return this.forEach(function(T, R) {
          H.push(R);
        }), h(H);
      }, g.prototype.values = function() {
        var H = [];
        return this.forEach(function(T) {
          H.push(T);
        }), h(H);
      }, g.prototype.entries = function() {
        var H = [];
        return this.forEach(function(T, R) {
          H.push([R, T]);
        }), h(H);
      }, a.iterable && (g.prototype[Symbol.iterator] = g.prototype.entries);
      function m(H) {
        if (H.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        H.bodyUsed = !0;
      }
      function p(H) {
        return new Promise(function(T, R) {
          H.onload = function() {
            T(H.result);
          }, H.onerror = function() {
            R(H.error);
          };
        });
      }
      function v(H) {
        var T = new FileReader(), R = p(T);
        return T.readAsArrayBuffer(H), R;
      }
      function b(H) {
        var T = new FileReader(), R = p(T);
        return T.readAsText(H), R;
      }
      function y(H) {
        for (var T = new Uint8Array(H), R = new Array(T.length), z = 0; z < T.length; z++)
          R[z] = String.fromCharCode(T[z]);
        return R.join("");
      }
      function E(H) {
        if (H.slice)
          return H.slice(0);
        var T = new Uint8Array(H.byteLength);
        return T.set(new Uint8Array(H)), T.buffer;
      }
      function C() {
        return this.bodyUsed = !1, this._initBody = function(H) {
          this._bodyInit = H, H ? typeof H == "string" ? this._bodyText = H : a.blob && Blob.prototype.isPrototypeOf(H) ? this._bodyBlob = H : a.formData && FormData.prototype.isPrototypeOf(H) ? this._bodyFormData = H : a.searchParams && URLSearchParams.prototype.isPrototypeOf(H) ? this._bodyText = H.toString() : a.arrayBuffer && a.blob && c(H) ? (this._bodyArrayBuffer = E(H.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(H) || l(H)) ? this._bodyArrayBuffer = E(H) : this._bodyText = H = Object.prototype.toString.call(H) : this._bodyText = "", this.headers.get("content-type") || (typeof H == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : a.searchParams && URLSearchParams.prototype.isPrototypeOf(H) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, a.blob && (this.blob = function() {
          var H = m(this);
          if (H)
            return H;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? m(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(v);
        }), this.text = function() {
          var H = m(this);
          if (H)
            return H;
          if (this._bodyBlob)
            return b(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(y(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, a.formData && (this.formData = function() {
          return this.text().then(O);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var B = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function I(H) {
        var T = H.toUpperCase();
        return B.indexOf(T) > -1 ? T : H;
      }
      function x(H, T) {
        T = T || {};
        var R = T.body;
        if (H instanceof x) {
          if (H.bodyUsed)
            throw new TypeError("Already read");
          this.url = H.url, this.credentials = H.credentials, T.headers || (this.headers = new g(H.headers)), this.method = H.method, this.mode = H.mode, this.signal = H.signal, !R && H._bodyInit != null && (R = H._bodyInit, H.bodyUsed = !0);
        } else
          this.url = String(H);
        if (this.credentials = T.credentials || this.credentials || "same-origin", (T.headers || !this.headers) && (this.headers = new g(T.headers)), this.method = I(T.method || this.method || "GET"), this.mode = T.mode || this.mode || null, this.signal = T.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && R)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(R);
      }
      x.prototype.clone = function() {
        return new x(this, { body: this._bodyInit });
      };
      function O(H) {
        var T = new FormData();
        return H.trim().split("&").forEach(function(R) {
          if (R) {
            var z = R.split("="), L = z.shift().replace(/\+/g, " "), X = z.join("=").replace(/\+/g, " ");
            T.append(decodeURIComponent(L), decodeURIComponent(X));
          }
        }), T;
      }
      function k(H) {
        var T = new g(), R = H.replace(/\r?\n[\t ]+/g, " ");
        return R.split(/\r?\n/).forEach(function(z) {
          var L = z.split(":"), X = L.shift().trim();
          if (X) {
            var W = L.join(":").trim();
            T.append(X, W);
          }
        }), T;
      }
      C.call(x.prototype);
      function Q(H, T) {
        T || (T = {}), this.type = "default", this.status = T.status === void 0 ? 200 : T.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in T ? T.statusText : "OK", this.headers = new g(T.headers), this.url = T.url || "", this._initBody(H);
      }
      C.call(Q.prototype), Q.prototype.clone = function() {
        return new Q(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new g(this.headers),
          url: this.url
        });
      }, Q.error = function() {
        var H = new Q(null, { status: 0, statusText: "" });
        return H.type = "error", H;
      };
      var F = [301, 302, 303, 307, 308];
      Q.redirect = function(H, T) {
        if (F.indexOf(T) === -1)
          throw new RangeError("Invalid status code");
        return new Q(null, { status: T, headers: { location: H } });
      }, s.DOMException = o.DOMException;
      try {
        new s.DOMException();
      } catch {
        s.DOMException = function(T, R) {
          this.message = T, this.name = R;
          var z = Error(T);
          this.stack = z.stack;
        }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
      }
      function M(H, T) {
        return new Promise(function(R, z) {
          var L = new x(H, T);
          if (L.signal && L.signal.aborted)
            return z(new s.DOMException("Aborted", "AbortError"));
          var X = new XMLHttpRequest();
          function W() {
            X.abort();
          }
          X.onload = function() {
            var U = {
              status: X.status,
              statusText: X.statusText,
              headers: k(X.getAllResponseHeaders() || "")
            };
            U.url = "responseURL" in X ? X.responseURL : U.headers.get("X-Request-URL");
            var ee = "response" in X ? X.response : X.responseText;
            R(new Q(ee, U));
          }, X.onerror = function() {
            z(new TypeError("Network request failed"));
          }, X.ontimeout = function() {
            z(new TypeError("Network request failed"));
          }, X.onabort = function() {
            z(new s.DOMException("Aborted", "AbortError"));
          }, X.open(L.method, L.url, !0), L.credentials === "include" ? X.withCredentials = !0 : L.credentials === "omit" && (X.withCredentials = !1), "responseType" in X && a.blob && (X.responseType = "blob"), L.headers.forEach(function(U, ee) {
            X.setRequestHeader(ee, U);
          }), L.signal && (L.signal.addEventListener("abort", W), X.onreadystatechange = function() {
            X.readyState === 4 && L.signal.removeEventListener("abort", W);
          }), X.send(typeof L._bodyInit > "u" ? null : L._bodyInit);
        });
      }
      return M.polyfill = !0, o.fetch || (o.fetch = M, o.Headers = g, o.Request = x, o.Response = Q), s.Headers = g, s.Request = x, s.Response = Q, s.fetch = M, Object.defineProperty(s, "__esModule", { value: !0 }), s;
    })({});
  })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
  var i = r;
  t = i.fetch, t.default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
})(Pl, Pl.exports);
var Ia = Pl.exports;
const Js = /* @__PURE__ */ Li(Ia), OP = /* @__PURE__ */ B9({
  __proto__: null,
  default: Js
}, [Ia]), jr = (e) => {
  let t = {};
  return e && (typeof Headers < "u" && e instanceof Headers || OP && Ia.Headers && e instanceof Ia.Headers ? t = Fw(e) : Array.isArray(e) ? e.forEach(([n, r]) => {
    n && r !== void 0 && (t[n] = r);
  }) : t = e), t;
}, E1 = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), DP = (e) => {
  if (!Array.isArray(e.query)) {
    const r = e, i = [`query=${encodeURIComponent(E1(r.query))}`];
    return e.variables && i.push(`variables=${encodeURIComponent(r.jsonSerializer.stringify(r.variables))}`), r.operationName && i.push(`operationName=${encodeURIComponent(r.operationName)}`), i.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const t = e, n = e.query.reduce((r, i, o) => (r.push({
    query: E1(i),
    variables: t.variables ? t.jsonSerializer.stringify(t.variables[o]) : void 0
  }), r), []);
  return `query=${encodeURIComponent(t.jsonSerializer.stringify(n))}`;
}, SP = (e) => async (t) => {
  const { url: n, query: r, variables: i, operationName: o, fetch: s, fetchOptions: a, middleware: c } = t, u = { ...t.headers };
  let l = "", d;
  e === "POST" ? (d = TP(r, i, o, a.jsonSerializer), typeof d == "string" && (u["Content-Type"] = "application/json")) : l = DP({
    query: r,
    variables: i,
    operationName: o,
    jsonSerializer: a.jsonSerializer ?? oA
  });
  const f = {
    method: e,
    headers: u,
    body: d,
    ...a
  };
  let h = n, g = f;
  if (c) {
    const m = await Promise.resolve(c({ ...f, url: n, operationName: o, variables: i })), { url: p, ...v } = m;
    h = p, g = v;
  }
  return l && (h = `${h}?${l}`), await s(h, g);
};
class NP {
  constructor(t, n = {}) {
    this.url = t, this.requestConfig = n, this.rawRequest = async (...r) => {
      const [i, o, s] = r, a = Xw(i, o, s), { headers: c, fetch: u = Js, method: l = "POST", requestMiddleware: d, responseMiddleware: f, ...h } = this.requestConfig, { url: g } = this;
      a.signal !== void 0 && (h.signal = a.signal);
      const { operationName: m } = $c(a.query);
      return eu({
        url: g,
        query: a.query,
        variables: a.variables,
        headers: {
          ...jr(tu(c)),
          ...jr(a.requestHeaders)
        },
        operationName: m,
        fetch: u,
        method: l,
        fetchOptions: h,
        middleware: d
      }).then((p) => (f && f(p), p)).catch((p) => {
        throw f && f(p), p;
      });
    };
  }
  async request(t, ...n) {
    const [r, i] = n, o = Qw(t, r, i), { headers: s, fetch: a = Js, method: c = "POST", requestMiddleware: u, responseMiddleware: l, ...d } = this.requestConfig, { url: f } = this;
    o.signal !== void 0 && (d.signal = o.signal);
    const { query: h, operationName: g } = $c(o.document);
    return eu({
      url: f,
      query: h,
      variables: o.variables,
      headers: {
        ...jr(tu(s)),
        ...jr(o.requestHeaders)
      },
      operationName: g,
      fetch: a,
      method: c,
      fetchOptions: d,
      middleware: u
    }).then((m) => (l && l(m), m.data)).catch((m) => {
      throw l && l(m), m;
    });
  }
  // prettier-ignore
  batchRequests(t, n) {
    const r = Vw(t, n), { headers: i, ...o } = this.requestConfig;
    r.signal !== void 0 && (o.signal = r.signal);
    const s = r.documents.map(({ document: c }) => $c(c).query), a = r.documents.map(({ variables: c }) => c);
    return eu({
      url: this.url,
      query: s,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: a,
      headers: {
        ...jr(tu(i)),
        ...jr(r.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? Js,
      method: this.requestConfig.method || "POST",
      fetchOptions: o,
      middleware: this.requestConfig.requestMiddleware
    }).then((c) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(c), c.data)).catch((c) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(c), c;
    });
  }
  setHeaders(t) {
    return this.requestConfig.headers = t, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(t, n) {
    const { headers: r } = this.requestConfig;
    return r ? r[t] = n : this.requestConfig.headers = { [t]: n }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(t) {
    return this.url = t, this;
  }
}
const eu = async (e) => {
  const { query: t, variables: n, fetchOptions: r } = e, i = SP(Lw(e.method ?? "post")), o = Array.isArray(e.query), s = await i(e), a = await RP(s, r.jsonSerializer ?? oA), c = Array.isArray(a) ? !a.some(({ data: l }) => !l) : !!a.data, u = Array.isArray(a) || !a.errors || Array.isArray(a.errors) && !a.errors.length || r.errorPolicy === "all" || r.errorPolicy === "ignore";
  if (s.ok && u && c) {
    const { errors: l, ...d } = (Array.isArray(a), a), f = r.errorPolicy === "ignore" ? d : a;
    return {
      ...o ? { data: f } : f,
      headers: s.headers,
      status: s.status
    };
  } else {
    const l = typeof a == "string" ? {
      error: a
    } : a;
    throw new fo(
      // @ts-expect-error TODO
      { ...l, status: s.status, headers: s.headers },
      { query: t, variables: n }
    );
  }
}, TP = (e, t, n, r) => {
  const i = r ?? oA;
  if (!Array.isArray(e))
    return i.stringify({ query: e, variables: t, operationName: n });
  if (typeof t < "u" && !Array.isArray(t))
    throw new Error("Cannot create request body with given variable type, array expected");
  const o = e.reduce((s, a, c) => (s.push({ query: a, variables: t ? t[c] : void 0 }), s), []);
  return i.stringify(o);
}, RP = async (e, t) => {
  let n;
  return e.headers.forEach((r, i) => {
    i.toLowerCase() === "content-type" && (n = r);
  }), n && (n.toLowerCase().startsWith("application/json") || n.toLowerCase().startsWith("application/graphql+json") || n.toLowerCase().startsWith("application/graphql-response+json")) ? t.parse(await e.text()) : e.text();
}, tu = (e) => typeof e == "function" ? e() : e, LP = (e, ...t) => e.reduce((n, r, i) => `${n}${r}${i in t ? String(t[i]) : ""}`, "");
async function FP(...e) {
  const [t, ...n] = e;
  return new NP(t, { fetch }).request(...n);
}
async function QP(e) {
  let t;
  try {
    t = (await FP(
      e,
      LP`
                query getDrive {
                    drive {
                        id
                        name
                        icon
                        slug
                    }
                }
            `
    )).drive;
  } catch (n) {
    throw console.error(n), new Error("Couldn't find drive info");
  }
  if (!t)
    throw new Error("Drive not found");
  return t;
}
var XP = "Expected a function", x1 = NaN, VP = "[object Symbol]", kP = /^\s+|\s+$/g, MP = /^[-+]0x[0-9a-f]+$/i, zP = /^0b[01]+$/i, jP = /^0o[0-7]+$/i, WP = parseInt, ZP = typeof so == "object" && so && so.Object === Object && so, GP = typeof self == "object" && self && self.Object === Object && self, qP = ZP || GP || Function("return this")(), YP = Object.prototype, UP = YP.toString, JP = Math.max, KP = Math.min, nu = function() {
  return qP.Date.now();
};
function _P(e, t, n) {
  var r, i, o, s, a, c, u = 0, l = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(XP);
  t = B1(t) || 0, Hl(n) && (l = !!n.leading, d = "maxWait" in n, o = d ? JP(B1(n.maxWait) || 0, t) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(B) {
    var I = r, x = i;
    return r = i = void 0, u = B, s = e.apply(x, I), s;
  }
  function g(B) {
    return u = B, a = setTimeout(v, t), l ? h(B) : s;
  }
  function m(B) {
    var I = B - c, x = B - u, O = t - I;
    return d ? KP(O, o - x) : O;
  }
  function p(B) {
    var I = B - c, x = B - u;
    return c === void 0 || I >= t || I < 0 || d && x >= o;
  }
  function v() {
    var B = nu();
    if (p(B))
      return b(B);
    a = setTimeout(v, m(B));
  }
  function b(B) {
    return a = void 0, f && r ? h(B) : (r = i = void 0, s);
  }
  function y() {
    a !== void 0 && clearTimeout(a), u = 0, r = c = i = a = void 0;
  }
  function E() {
    return a === void 0 ? s : b(nu());
  }
  function C() {
    var B = nu(), I = p(B);
    if (r = arguments, i = this, c = B, I) {
      if (a === void 0)
        return g(c);
      if (d)
        return a = setTimeout(v, t), h(c);
    }
    return a === void 0 && (a = setTimeout(v, t)), s;
  }
  return C.cancel = y, C.flush = E, C;
}
function Hl(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function $P(e) {
  return !!e && typeof e == "object";
}
function eH(e) {
  return typeof e == "symbol" || $P(e) && UP.call(e) == VP;
}
function B1(e) {
  if (typeof e == "number")
    return e;
  if (eH(e))
    return x1;
  if (Hl(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Hl(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(kP, "");
  var n = zP.test(e);
  return n || jP.test(e) ? WP(e.slice(2), n ? 2 : 8) : MP.test(e) ? x1 : +e;
}
var tH = _P;
const w1 = /* @__PURE__ */ Li(tH);
var nH = typeof window < "u" ? Kn : Ie;
function Wp(e, t, n, r) {
  const i = Ce(t);
  nH(() => {
    i.current = t;
  }, [t]), Ie(() => {
    const o = window;
    if (!(o && o.addEventListener))
      return;
    const s = (a) => {
      i.current(a);
    };
    return o.addEventListener(e, s, r), () => {
      o.removeEventListener(e, s, r);
    };
  }, [e, n, r]);
}
function cA() {
  const [e, t] = q(null), n = me(async (r) => {
    if (!(navigator != null && navigator.clipboard))
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(r), t(r), !0;
    } catch (i) {
      return console.warn("Copy failed", i), t(null), !1;
    }
  }, []);
  return [e, n];
}
function rH(e) {
  const t = Ce(e);
  t.current = e, Ie(
    () => () => {
      t.current();
    },
    []
  );
}
function iH(e, t = 500, n) {
  const r = Ce();
  rH(() => {
    r.current && r.current.cancel();
  });
  const i = ve(() => {
    const o = w1(e, t, n), s = (...a) => o(...a);
    return s.cancel = () => {
      o.cancel();
    }, s.isPending = () => !!r.current, s.flush = () => o.flush(), s;
  }, [e, t, n]);
  return Ie(() => {
    r.current = w1(e, t, n);
  }, [e, t, n]), i;
}
function oH(e, t, n) {
  const r = (u, l) => u === l, i = e instanceof Function ? e() : e, [o, s] = q(i), a = Ce(i), c = iH(
    s,
    t,
    n
  );
  return r(a.current, i) || (c(i), a.current = i), [o, c];
}
function sH(e, t, n = "mousedown", r = {}) {
  Wp(
    n,
    (i) => {
      const o = i.target;
      if (!o || !o.isConnected)
        return;
      (Array.isArray(e) ? e.filter((a) => !!a.current).every((a) => a.current && !a.current.contains(o)) : e.current && !e.current.contains(o)) && t(i);
    },
    void 0,
    r
  );
}
function aH(e) {
  const { sharingType: t = Tr } = e, [n, r] = q(), [i, o] = q(!1), [s, a] = q(!0), [c, u] = q(!1), [l, d] = q(""), [f, h] = q(""), [g, m] = oH(f, 500), { register: p, handleSubmit: v, setValue: b } = Ka({
    mode: "onBlur",
    defaultValues: {
      availableOffline: (n == null ? void 0 : n.availableOffline) ?? !1
    }
  });
  Ie(() => {
    m(f);
  }, [f]), Ie(() => {
    if (u(!1), g === "") return;
    E().catch(console.error);
    async function E() {
      try {
        const { id: C, name: B } = await QP(g);
        r({
          id: C,
          name: B,
          sharingType: t,
          location: Zo,
          availableOffline: !0
        }), b("availableOffline", !0), a(!0), d("");
      } catch (C) {
        r(void 0), a(!1), d(C.message);
      }
    }
  }, [g, b, t]);
  function y({ availableOffline: E }) {
    n && e.onSubmit({
      ...n,
      availableOffline: E,
      url: g
    });
  }
  return /* @__PURE__ */ D("form", { onSubmit: v(y), children: [
    /* @__PURE__ */ A(Ea, { htmlFor: "url", children: "Add existing drive" }),
    c ? /* @__PURE__ */ D(Be, { children: [
      /* @__PURE__ */ A(
        lH,
        {
          driveName: (n == null ? void 0 : n.name) ?? "New drive"
        }
      ),
      /* @__PURE__ */ A(Ct, { className: "my-3" }),
      /* @__PURE__ */ D(
        Ei,
        {
          title: "Location",
          isOpen: i,
          onOpenChange: () => o(!i),
          children: [
            /* @__PURE__ */ A(lA, { location: Zo }),
            /* @__PURE__ */ A(
              uA,
              {
                ...p("availableOffline")
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ A(Ct, { className: "my-3" }),
      /* @__PURE__ */ A(Et, { type: "submit", color: "dark", className: "mt-4 w-full", children: "Add drive" })
    ] }) : /* @__PURE__ */ D(Be, { children: [
      /* @__PURE__ */ A(
        as,
        {
          type: "url",
          icon: /* @__PURE__ */ A(Y, { name: "BrickGlobe" }),
          value: f,
          placeholder: "Drive URL",
          required: !0,
          onChange: (E) => h(E.target.value),
          errorMessage: l
        }
      ),
      /* @__PURE__ */ A(Ct, { className: "mb-3" }),
      /* @__PURE__ */ A(
        Et,
        {
          type: "button",
          color: "light",
          className: "mt-4 w-full",
          onClick: (E) => {
            E.preventDefault(), u(!0);
          },
          disabled: !s || f === "",
          children: "Confirm URL"
        }
      )
    ] })
  ] });
}
function cH(e) {
  const { uiDriveNode: t, onSubmit: n } = e, { name: r, sharingType: i, availableOffline: o } = t, [s, a] = q(!1), [c, u] = q(!1), [l, d] = q(!1), { register: f, handleSubmit: h, control: g } = Ka({
    mode: "onBlur",
    defaultValues: {
      name: r,
      sharingType: i,
      availableOffline: o
    }
  }), m = i === Tr ? Zo : i;
  return /* @__PURE__ */ D("form", { onSubmit: h(n), children: [
    /* @__PURE__ */ A(Zp, { ...f("name") }),
    /* @__PURE__ */ A(Ct, { className: "my-4" }),
    /* @__PURE__ */ A(Ea, { htmlFor: "sharingType", children: "Sharing settings" }),
    /* @__PURE__ */ A(Gp, { control: g }),
    /* @__PURE__ */ A(Ct, { className: "my-3" }),
    /* @__PURE__ */ D(
      Ei,
      {
        title: "Location",
        isOpen: s,
        onOpenChange: () => a(!s),
        children: [
          /* @__PURE__ */ A(lA, { location: m }),
          /* @__PURE__ */ A(uA, { ...f("availableOffline") })
        ]
      }
    ),
    /* @__PURE__ */ A(Ct, { className: "my-3" }),
    /* @__PURE__ */ A(
      Ei,
      {
        title: "Danger zone",
        isOpen: c,
        onOpenChange: () => u(!c),
        children: /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: "flex gap-2 py-3 font-semibold text-red-900 transition hover:brightness-125",
            onClick: () => d(!0),
            children: [
              /* @__PURE__ */ A(Y, { name: "Trash" }),
              "Delete drive"
            ]
          }
        )
      }
    ),
    l && c ? /* @__PURE__ */ A(
      uH,
      {
        ...e,
        onCancel: () => d(!1)
      }
    ) : /* @__PURE__ */ D(Be, { children: [
      /* @__PURE__ */ A(Ct, { className: "my-3" }),
      /* @__PURE__ */ A(Et, { type: "submit", className: "mb-4 w-full", children: "Confirm" })
    ] })
  ] });
}
const uA = Nt(
  function(t, n) {
    return /* @__PURE__ */ D("div", { className: "flex items-center rounded-xl bg-gray-100 p-3 text-slate-200", children: [
      /* @__PURE__ */ D("div", { className: "flex-1", children: [
        /* @__PURE__ */ A("label", { htmlFor: "availableOffline", className: "font-semibold", children: "Make available offline" }),
        /* @__PURE__ */ D("p", { className: "text-xs text-gray-500", children: [
          "Check this options if you keep a local backup",
          /* @__PURE__ */ A("br", {}),
          "available at all times."
        ] })
      ] }),
      /* @__PURE__ */ A(MD, { id: "availableOffline", ref: n, ...t })
    ] });
  }
);
function uH(e) {
  const { uiDriveNode: t, handleDeleteDrive: n, onCancel: r } = e, [i, o] = q(""), s = i === t.name;
  function a() {
    s && n();
  }
  return /* @__PURE__ */ D("div", { children: [
    /* @__PURE__ */ A("p", { className: "mb-2 rounded-md bg-slate-50 p-4 text-center text-slate-200", children: "Are you sure you want to delete this drive? All files and subfolders within it will be removed. Do you want to proceed?" }),
    /* @__PURE__ */ A(
      Zp,
      {
        value: i,
        placeholder: "Enter drive name...",
        onChange: (c) => o(c.target.value),
        icon: /* @__PURE__ */ A(Y, { name: "Lock" })
      }
    ),
    /* @__PURE__ */ D("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ A(Et, { onClick: r, color: "light", className: "w-full", children: "Cancel" }),
      /* @__PURE__ */ A(
        Et,
        {
          onClick: a,
          disabled: !s,
          color: "red",
          className: "w-full",
          children: "Delete"
        }
      )
    ] })
  ] });
}
function lH(e) {
  return /* @__PURE__ */ D("div", { className: "flex gap-2 rounded-xl bg-gray-100 p-3 font-semibold text-gray-500", children: [
    /* @__PURE__ */ A(Y, { name: "Drive", className: "text-gray-600" }),
    e.driveName
  ] });
}
const Zp = Nt(function(t, n) {
  return /* @__PURE__ */ A(
    as,
    {
      ...t,
      ref: n,
      icon: t.icon ?? /* @__PURE__ */ A(Y, { name: "Drive" }),
      id: "driveName",
      placeholder: "Drive name"
    }
  );
});
function Ea(e) {
  const { children: t, className: n, ...r } = e;
  return /* @__PURE__ */ A(
    "label",
    {
      ...r,
      className: $(
        "mb-3 block font-semibold text-gray-500",
        n
      ),
      children: t
    }
  );
}
function lA(e) {
  const { location: t, className: n, ...r } = e, i = vS[t];
  return /* @__PURE__ */ D(
    "div",
    {
      ...r,
      className: $(
        "my-3 flex items-center gap-2 rounded-xl border border-gray-100 p-3 text-gray-800 shadow",
        n
      ),
      children: [
        i.icon,
        /* @__PURE__ */ D("div", { children: [
          /* @__PURE__ */ A("p", { children: i.title }),
          /* @__PURE__ */ A("p", { className: "text-xs text-slate-200", children: i.description })
        ] })
      ]
    }
  );
}
function Gp(e) {
  const { control: t, ...n } = e;
  return /* @__PURE__ */ A(
    nA,
    {
      name: "sharingType",
      control: t,
      render: ({ field: r }) => /* @__PURE__ */ A(
        _p,
        {
          ...n,
          ...r,
          id: "sharingType",
          items: mS
        }
      )
    }
  );
}
const as = Nt(function(t, n) {
  const {
    icon: r,
    errorMessage: i,
    isDirty: o,
    containerClassName: s,
    inputClassName: a,
    errorMessageClassName: c,
    hideErrors: u = !1,
    ...l
  } = t, d = t.type ?? "text", f = !!i;
  return /* @__PURE__ */ D("div", { children: [
    /* @__PURE__ */ D(
      "div",
      {
        className: $(
          "mb-1 flex gap-2 rounded-xl border border-transparent bg-gray-100 p-3 text-gray-800 placeholder:text-gray-500",
          f && "border-red-900",
          s
        ),
        children: [
          /* @__PURE__ */ A(
            "span",
            {
              className: Or(
                (!o || f) && "text-slate-200"
              ),
              children: r
            }
          ),
          /* @__PURE__ */ A(
            "input",
            {
              ...l,
              type: d,
              ref: n,
              className: $(
                "w-full bg-transparent font-semibold outline-none",
                a
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ A(
      "p",
      {
        className: $(
          "hidden min-h-4 text-xs text-red-900",
          f && "block",
          u && "hidden",
          c
        ),
        children: i
      }
    )
  ] });
}), ZR = (e) => {
  const { showLoadingScreen: t, loadingComponent: n, size: r, className: i } = e;
  return n && t ? n : /* @__PURE__ */ A(
    "div",
    {
      className: $(
        "absolute inset-0 z-10 flex items-center justify-center bg-white",
        !t && "hidden",
        i
      ),
      children: /* @__PURE__ */ A(ph, { size: r })
    }
  );
};
function GR(e) {
  const { open: t, onOpenChange: n, onSubmit: r, modalProps: i, containerProps: o } = e;
  function s() {
    n(!1);
  }
  return /* @__PURE__ */ A(
    gn,
    {
      ...i,
      open: t,
      onOpenChange: n,
      contentProps: {
        className: "rounded-2xl"
      },
      children: /* @__PURE__ */ D(
        "div",
        {
          ...o,
          className: $(
            "max-w-[408px] rounded-2xl p-6",
            o == null ? void 0 : o.className
          ),
          children: [
            /* @__PURE__ */ D("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ A("h1", { className: "text-xl font-bold", children: "Create new drive " }),
              /* @__PURE__ */ A(
                "button",
                {
                  className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
                  onClick: s,
                  tabIndex: -1,
                  children: /* @__PURE__ */ A(Y, { name: "XmarkLight", size: 24 })
                }
              )
            ] }),
            /* @__PURE__ */ A(Ct, { className: "my-4" }),
            /* @__PURE__ */ A(
              Rw,
              {
                onSubmit: r,
                onCancel: s
              }
            )
          ]
        }
      )
    }
  );
}
function qR(e) {
  const {
    open: t,
    onOpenChange: n,
    onSubmit: r,
    sharingType: i,
    modalProps: o,
    containerProps: s
  } = e;
  function a() {
    n(!1);
  }
  return /* @__PURE__ */ A(
    gn,
    {
      ...o,
      open: t,
      onOpenChange: n,
      contentProps: {
        className: "rounded-2xl"
      },
      children: /* @__PURE__ */ D(
        "div",
        {
          ...s,
          className: $(
            "min-w-[408px] max-w-[408px] rounded-2xl p-6",
            s == null ? void 0 : s.className
          ),
          children: [
            /* @__PURE__ */ D("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ A("h1", { className: "text-xl font-bold", children: "Add drive" }),
              /* @__PURE__ */ A(
                "button",
                {
                  className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
                  onClick: a,
                  tabIndex: -1,
                  children: /* @__PURE__ */ A(Y, { name: "XmarkLight", size: 24 })
                }
              )
            ] }),
            /* @__PURE__ */ A(Ct, { className: "my-4" }),
            /* @__PURE__ */ A(
              aH,
              {
                sharingType: i,
                onSubmit: r,
                onCancel: a
              }
            )
          ]
        }
      )
    }
  );
}
const P1 = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", qp = (e) => {
  const {
    body: t,
    header: n,
    children: r,
    onCancel: i,
    onOpenChange: o,
    onContinue: s,
    cancelLabel: a,
    continueLabel: c,
    overlayProps: u,
    contentProps: l,
    bodyProps: d = {},
    headerProps: f = {},
    containerProps: h = {},
    cancelButtonProps: g = {},
    continueButtonProps: m = {},
    buttonContainerProps: p = {},
    ...v
  } = e;
  return /* @__PURE__ */ A(
    gn,
    {
      overlayProps: {
        ...u,
        className: u == null ? void 0 : u.className
      },
      contentProps: {
        ...l,
        className: $("rounded-3xl", l == null ? void 0 : l.className)
      },
      onOpenChange: o,
      ...v,
      children: /* @__PURE__ */ D(
        "div",
        {
          ...rt(
            h,
            "w-[400px] p-6 text-slate-300"
          ),
          children: [
            /* @__PURE__ */ A(
              "div",
              {
                ...rt(
                  f,
                  "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800"
                ),
                children: n
              }
            ),
            /* @__PURE__ */ D(
              "div",
              {
                ...rt(
                  d,
                  "my-6 rounded-md bg-slate-50 p-4 text-center text-slate-200"
                ),
                children: [
                  t,
                  r
                ]
              }
            ),
            /* @__PURE__ */ D(
              "div",
              {
                ...rt(
                  p,
                  "mt-8 flex justify-between gap-3"
                ),
                children: [
                  /* @__PURE__ */ A(
                    "button",
                    {
                      onClick: i,
                      ...rt(
                        g,
                        $(
                          P1,
                          "flex-1 bg-slate-50 text-slate-800"
                        )
                      ),
                      children: a
                    }
                  ),
                  /* @__PURE__ */ A(
                    "button",
                    {
                      onClick: s,
                      ...rt(
                        m,
                        $(
                          P1,
                          "flex-1 bg-gray-800 text-gray-50"
                        )
                      ),
                      children: c
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, H1 = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", YR = (e) => {
  const {
    onOpenChange: t,
    onContinue: n,
    overlayProps: r,
    contentProps: i,
    ...o
  } = e, [s, a] = q("");
  return /* @__PURE__ */ A(
    gn,
    {
      overlayProps: {
        ...r,
        className: r == null ? void 0 : r.className
      },
      contentProps: {
        ...i,
        className: $("rounded-3xl", i == null ? void 0 : i.className)
      },
      onOpenChange: t,
      ...o,
      children: /* @__PURE__ */ D("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ A("div", { className: "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800", children: "Create a new document" }),
        /* @__PURE__ */ A("div", { className: "my-6", children: /* @__PURE__ */ A(
          as,
          {
            icon: /* @__PURE__ */ A(Y, { name: "BrickGlobe" }),
            value: s,
            placeholder: "Document name",
            required: !0,
            onChange: (c) => a(c.target.value)
          }
        ) }),
        /* @__PURE__ */ D("div", { className: "mt-8 flex justify-between gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: () => t == null ? void 0 : t(!1),
              className: $(
                H1,
                "flex-1 bg-slate-50 text-slate-800"
              ),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ A(
            Et,
            {
              onClick: () => n(s),
              className: $(
                H1,
                "flex-1 bg-gray-800 text-gray-50"
              ),
              children: "Create"
            }
          )
        ] })
      ] })
    }
  );
}, UR = (e) => {
  const { inputPlaceholder: t, body: n, driveName: r, ...i } = e, [o, s] = q("");
  return /* @__PURE__ */ A(
    qp,
    {
      bodyProps: { className: "p-0 bg-white my-0" },
      containerProps: { className: "w-[450px]" },
      continueButtonProps: {
        disabled: o !== r,
        className: o !== r ? "bg-red-600 hover:scale-100 cursor-not-allowed active:opacity-100" : "bg-red-900"
      },
      ...i,
      children: /* @__PURE__ */ D("div", { children: [
        /* @__PURE__ */ A("div", { className: "my-6 rounded-md bg-slate-50 p-4 text-center text-slate-200", children: n }),
        /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(
          as,
          {
            value: o,
            icon: /* @__PURE__ */ A(Y, { name: "Lock" }),
            placeholder: t,
            onChange: (a) => s(a.target.value),
            hideErrors: !0
          }
        ) })
      ] })
    }
  );
}, JR = (e) => {
  const { onDelete: t, deleteLabel: n, ...r } = e;
  return /* @__PURE__ */ A(
    qp,
    {
      ...r,
      containerProps: { className: "w-[450px]" },
      continueButtonProps: {
        className: "bg-red-900"
      },
      onContinue: t,
      continueLabel: n
    }
  );
};
function KR(e) {
  const {
    uiDriveNode: t,
    open: n,
    onOpenChange: r,
    onDeleteDrive: i,
    onRenameDrive: o,
    onChangeSharingType: s,
    onChangeAvailableOffline: a,
    modalProps: c,
    containerProps: u
  } = e, l = (h) => {
    h.name !== t.name && o(t, h.name), h.sharingType !== t.sharingType && s(t, h.sharingType), h.availableOffline !== t.availableOffline && a(t, h.availableOffline), r(!1);
  };
  function d() {
    i(t), r(!1);
  }
  function f() {
    r(!1);
  }
  return /* @__PURE__ */ A(
    gn,
    {
      ...c,
      open: n,
      onOpenChange: r,
      contentProps: {
        className: "rounded-2xl"
      },
      children: /* @__PURE__ */ D(
        "div",
        {
          ...u,
          className: $(
            "max-w-[408px] rounded-2xl p-6",
            u == null ? void 0 : u.className
          ),
          children: [
            /* @__PURE__ */ D("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ A("h1", { className: "text-xl font-bold", children: "Drive settings" }),
              /* @__PURE__ */ A(
                "button",
                {
                  className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
                  onClick: f,
                  tabIndex: -1,
                  children: /* @__PURE__ */ A(Y, { name: "XmarkLight", size: 24 })
                }
              )
            ] }),
            /* @__PURE__ */ A(Ct, { className: "my-4" }),
            /* @__PURE__ */ A(
              cH,
              {
                uiDriveNode: t,
                onSubmit: l,
                handleDeleteDrive: d,
                handleCancel: f
              }
            )
          ]
        }
      )
    }
  );
}
const dH = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", _R = (e) => {
  const {
    body: t,
    header: n,
    children: r,
    onOpenChange: i,
    onContinue: o,
    closeLabel: s,
    overlayProps: a,
    contentProps: c,
    bodyProps: u = {},
    headerProps: l = {},
    containerProps: d = {},
    continueButtonProps: f = {},
    buttonContainerProps: h = {},
    ...g
  } = e, [m, p] = q(!0), v = Ce(null);
  return Ie(() => {
    const b = () => {
      const E = v.current;
      E && (E.scrollHeight > E.clientHeight ? (p(!0), E.addEventListener("scroll", y)) : p(!1));
    }, y = () => {
      const E = v.current;
      E && E.scrollHeight - E.scrollTop === E.clientHeight && p(!1);
    };
    return requestAnimationFrame(b), () => {
      const E = v.current;
      E && E.removeEventListener("scroll", y);
    };
  }, []), /* @__PURE__ */ A(
    gn,
    {
      overlayProps: {
        ...a,
        className: a == null ? void 0 : a.className
      },
      contentProps: {
        ...c,
        className: $(
          "rounded-3xl outline-none",
          c == null ? void 0 : c.className
        )
      },
      onOpenChange: i,
      ...g,
      children: /* @__PURE__ */ D(
        "div",
        {
          ...rt(
            d,
            "w-[500px] p-6 text-slate-300"
          ),
          children: [
            /* @__PURE__ */ A(
              "div",
              {
                ...rt(
                  l,
                  "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800"
                ),
                children: n
              }
            ),
            /* @__PURE__ */ D(
              "div",
              {
                ref: v,
                ...rt(
                  u,
                  "my-6 max-h-[245px] overflow-scroll rounded-md bg-slate-50 p-4 text-center text-slate-200"
                ),
                children: [
                  t,
                  r
                ]
              }
            ),
            /* @__PURE__ */ A(
              "div",
              {
                ...rt(
                  h,
                  "mt-8 flex justify-between gap-3"
                ),
                children: /* @__PURE__ */ A(
                  "button",
                  {
                    onClick: o,
                    disabled: m,
                    ...rt(
                      f,
                      $(
                        dH,
                        "flex-1 bg-gray-800 text-gray-50",
                        m && "cursor-not-allowed bg-gray-300 hover:scale-100"
                      )
                    ),
                    children: s
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}, Yp = (e) => {
  const { title: t, children: n, description: r, ...i } = e;
  return /* @__PURE__ */ D("div", { ...i, children: [
    t && /* @__PURE__ */ A("h2", { className: "font-semibold", children: t }),
    /* @__PURE__ */ D("div", { className: "flex items-center justify-between gap-x-12 text-sm font-medium", children: [
      /* @__PURE__ */ A("p", { children: r }),
      /* @__PURE__ */ A("div", { children: n })
    ] })
  ] });
}, $R = (e) => {
  const { onClearStorage: t, buttonLabel: n, ...r } = e;
  return /* @__PURE__ */ A(Yp, { ...r, children: /* @__PURE__ */ A(
    Et,
    {
      onClick: t,
      iconPosition: "right",
      icon: /* @__PURE__ */ A(Y, { name: "Trash", size: 18 }),
      className: "h-auto min-h-9 rounded border border-solid border-gray-300 bg-white px-3 py-0 text-sm text-red-800 hover:border-gray-500 hover:bg-white hover:text-red-900",
      children: n
    }
  ) });
};
function AH(e) {
  if (!e || typeof e != "object")
    throw new Error("Invalid package.json");
  if (!("version" in e))
    throw new Error("Missing version field in package.json");
  if (!("dependencies" in e))
    throw new Error("Missing dependencies field in package.json");
  if (!("devDependencies" in e))
    throw new Error("Missing devDependencies field in package.json");
  if (typeof e.version != "string")
    throw new Error("Invalid version field in package.json");
  if (!e.dependencies || typeof e.dependencies != "object")
    throw new Error("Invalid dependencies field in package.json");
  if (!e.devDependencies || typeof e.devDependencies != "object")
    throw new Error("Invalid devDependencies field in package.json");
  if (!("@powerhousedao/design-system" in e.dependencies) || typeof e.dependencies["@powerhousedao/design-system"] != "string")
    throw new Error("Invalid @powerhousedao/design-system dependency");
  if (!("document-drive" in e.dependencies) || typeof e.dependencies["document-drive"] != "string")
    throw new Error("Invalid document-drive dependency");
  if (!("document-model" in e.dependencies) || typeof e.dependencies["document-model"] != "string")
    throw new Error("Invalid document-model dependency");
  if (!("document-model-libs" in e.dependencies) || typeof e.dependencies["document-model-libs"] != "string")
    throw new Error("Invalid document-model-libs dependency");
}
function eL(e) {
  const [t, n] = q(!1), { packageJson: r } = e;
  try {
    AH(r);
  } catch (i) {
    return console.error(i), null;
  }
  return /* @__PURE__ */ A(
    Ei,
    {
      title: `App version: ${r.version}`,
      isOpen: t,
      onOpenChange: () => n(!t),
      children: /* @__PURE__ */ D("ul", { className: "text-gray-800", children: [
        /* @__PURE__ */ D("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "design-system:" }),
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["@powerhousedao/design-system"] })
        ] }),
        /* @__PURE__ */ D("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "document-drive:" }),
          " ",
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["document-drive"] })
        ] }),
        /* @__PURE__ */ D("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "document-model:" }),
          " ",
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["document-model"] })
        ] }),
        /* @__PURE__ */ D("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "document-model-libs:" }),
          " ",
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["document-model-libs"] })
        ] })
      ] })
    }
  );
}
function fH(e, { insertAt: t } = {}) {
  if (typeof document > "u") return;
  let n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
fH(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);
var gH = { allItemsAreSelected: "All items are selected.", clearSearch: "Clear Search", clearSelected: "Clear Selected", noOptions: "No options", search: "Search", selectAll: "Select All", selectAllFiltered: "Select All (Filtered)", selectSomeItems: "Select...", create: "Create" }, hH = { value: [], hasSelectAll: !0, className: "multi-select", debounceDuration: 200, options: [] }, Up = _.createContext({}), pH = ({ props: e, children: t }) => {
  let [n, r] = q(e.options), i = (o) => {
    var s;
    return ((s = e.overrideStrings) == null ? void 0 : s[o]) || gH[o];
  };
  return Ie(() => {
    r(e.options);
  }, [e.options]), A(Up.Provider, { value: { t: i, ...hH, ...e, options: n, setOptions: r }, children: t });
}, ec = () => _.useContext(Up);
function mH(e, t) {
  let n = Ce(!1);
  Ie(() => {
    n.current ? e() : n.current = !0;
  }, t);
}
var vH = { when: !0, eventTypes: ["keydown"] };
function xa(e, t, n) {
  let r = ve(() => Array.isArray(e) ? e : [e], [e]), i = Object.assign({}, vH, n), { when: o, eventTypes: s } = i, a = Ce(t), { target: c } = i;
  Ie(() => {
    a.current = t;
  });
  let u = me((l) => {
    r.some((d) => l.key === d || l.code === d) && a.current(l);
  }, [r]);
  Ie(() => {
    if (o && typeof window < "u") {
      let l = c ? c.current : window;
      return s.forEach((d) => {
        l && l.addEventListener(d, u);
      }), () => {
        s.forEach((d) => {
          l && l.removeEventListener(d, u);
        });
      };
    }
  }, [o, s, r, c, t]);
}
var yt = { ARROW_DOWN: "ArrowDown", ARROW_UP: "ArrowUp", ENTER: "Enter", ESCAPE: "Escape", SPACE: "Space" }, bH = (e, t) => {
  let n;
  return function(...r) {
    clearTimeout(n), n = setTimeout(() => {
      e.apply(null, r);
    }, t);
  };
};
function yH(e, t) {
  return t ? e.filter(({ label: n, value: r }) => n != null && r != null && n.toLowerCase().includes(t.toLowerCase())) : e;
}
var Jp = () => D("svg", { width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "dropdown-search-clear-icon gray", children: [A("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), A("line", { x1: "6", y1: "6", x2: "18", y2: "18" })] }), CH = ({ checked: e, option: t, onClick: n, disabled: r }) => D("div", { className: `item-renderer ${r ? "disabled" : ""}`, children: [A("input", { type: "checkbox", onChange: n, checked: e, tabIndex: -1, disabled: r }), A("span", { children: t.label })] }), IH = CH, EH = ({ itemRenderer: e = IH, option: t, checked: n, tabIndex: r, disabled: i, onSelectionChanged: o, onClick: s }) => {
  let a = Ce(), c = (d) => {
    u(), d.preventDefault();
  }, u = () => {
    i || o(!n);
  }, l = (d) => {
    u(), s(d);
  };
  return xa([yt.ENTER, yt.SPACE], c, { target: a }), A("label", { className: `select-item ${n ? "selected" : ""}`, role: "option", "aria-selected": n, tabIndex: r, ref: a, children: A(e, { option: t, checked: n, onClick: l, disabled: i }) });
}, Kp = EH, xH = ({ options: e, onClick: t, skipIndex: n }) => {
  let { disabled: r, value: i, onChange: o, ItemRenderer: s } = ec(), a = (c, u) => {
    r || o(u ? [...i, c] : i.filter((l) => l.value !== c.value));
  };
  return A(Be, { children: e.map((c, u) => {
    let l = u + n;
    return A("li", { children: A(Kp, { tabIndex: l, option: c, onSelectionChanged: (d) => a(c, d), checked: !!i.find((d) => d.value === c.value), onClick: (d) => t(d, l), itemRenderer: s, disabled: c.disabled || r }) }, (c == null ? void 0 : c.key) || u);
  }) });
}, BH = xH, wH = () => {
  let { t: e, onChange: t, options: n, setOptions: r, value: i, filterOptions: o, ItemRenderer: s, disabled: a, disableSearch: c, hasSelectAll: u, ClearIcon: l, debounceDuration: d, isCreatable: f, onCreateOption: h } = ec(), g = Ce(), m = Ce(), [p, v] = q(""), [b, y] = q(n), [E, C] = q(""), [B, I] = q(0), x = me(bH((K) => C(K), d), []), O = ve(() => {
    let K = 0;
    return c || (K += 1), u && (K += 1), K;
  }, [c, u]), k = { label: e(p ? "selectAllFiltered" : "selectAll"), value: "" }, Q = (K) => {
    let ae = b.filter((pe) => !pe.disabled).map((pe) => pe.value);
    if (K) {
      let pe = [...i.map((Pe) => Pe.value), ...ae];
      return (o ? b : n).filter((Pe) => pe.includes(Pe.value));
    }
    return i.filter((pe) => !ae.includes(pe.value));
  }, F = (K) => {
    let ae = Q(K);
    t(ae);
  }, M = (K) => {
    x(K.target.value), v(K.target.value), I(0);
  }, H = () => {
    var K;
    C(""), v(""), (K = m == null ? void 0 : m.current) == null || K.focus();
  }, T = (K) => I(K), R = (K) => {
    switch (K.code) {
      case yt.ARROW_UP:
        W(-1);
        break;
      case yt.ARROW_DOWN:
        W(1);
        break;
      default:
        return;
    }
    K.stopPropagation(), K.preventDefault();
  };
  xa([yt.ARROW_DOWN, yt.ARROW_UP], R, { target: g });
  let z = () => {
    I(0);
  }, L = async () => {
    let K = { label: p, value: p, __isNew__: !0 };
    h && (K = await h(p)), r([K, ...n]), H(), t([...i, K]);
  }, X = async () => o ? await o(n, E) : yH(n, E), W = (K) => {
    let ae = B + K;
    ae = Math.max(0, ae), ae = Math.min(ae, n.length + Math.max(O - 1, 0)), I(ae);
  };
  Ie(() => {
    var K, ae;
    (ae = (K = g == null ? void 0 : g.current) == null ? void 0 : K.querySelector(`[tabIndex='${B}']`)) == null || ae.focus();
  }, [B]);
  let [U, ee] = ve(() => {
    let K = b.filter((ae) => !ae.disabled);
    return [K.every((ae) => i.findIndex((pe) => pe.value === ae.value) !== -1), K.length !== 0];
  }, [b, i]);
  Ie(() => {
    X().then(y);
  }, [E, n]);
  let Ae = Ce();
  xa([yt.ENTER], L, { target: Ae });
  let ne = f && p && !b.some((K) => (K == null ? void 0 : K.value) === p);
  return D("div", { className: "select-panel", role: "listbox", ref: g, children: [!c && D("div", { className: "search", children: [A("input", { placeholder: e("search"), type: "text", "aria-describedby": e("search"), onChange: M, onFocus: z, value: p, ref: m, tabIndex: 0 }), A("button", { type: "button", className: "search-clear-button", hidden: !p, onClick: H, "aria-label": e("clearSearch"), children: l || A(Jp, {}) })] }), D("ul", { className: "options", children: [u && ee && A(Kp, { tabIndex: O === 1 ? 0 : 1, checked: U, option: k, onSelectionChanged: F, onClick: () => T(1), itemRenderer: s, disabled: a }), b.length ? A(BH, { skipIndex: O, options: b, onClick: (K, ae) => T(ae) }) : ne ? A("li", { onClick: L, className: "select-item creatable", tabIndex: 1, ref: Ae, children: `${e("create")} "${p}"` }) : A("li", { className: "no-options", children: e("noOptions") })] })] });
}, PH = wH, HH = ({ expanded: e }) => A("svg", { width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "dropdown-heading-dropdown-arrow gray", children: A("path", { d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9" }) }), OH = () => {
  let { t: e, value: t, options: n, valueRenderer: r } = ec(), i = t.length === 0, o = t.length === n.length, s = r && r(t, n);
  return i ? A("span", { className: "gray", children: s || e("selectSomeItems") }) : A("span", { children: s || (o ? e("allItemsAreSelected") : t.map((a) => a.label).join(", ")) });
}, DH = ({ size: e = 24 }) => A("span", { style: { width: e, marginRight: "0.2rem" }, children: A("svg", { width: e, height: e, className: "spinner", viewBox: "0 0 50 50", style: { display: "inline", verticalAlign: "middle" }, children: A("circle", { cx: "25", cy: "25", r: "20", fill: "none", className: "path" }) }) }), SH = () => {
  let { t: e, onMenuToggle: t, ArrowRenderer: n, shouldToggleOnHover: r, isLoading: i, disabled: o, onChange: s, labelledBy: a, value: c, isOpen: u, defaultIsOpen: l, ClearSelectedIcon: d, closeOnChangedValue: f } = ec();
  Ie(() => {
    f && p(!1);
  }, [c]);
  let [h, g] = q(!0), [m, p] = q(l), [v, b] = q(!1), y = n || HH, E = Ce();
  mH(() => {
    t && t(m);
  }, [m]), Ie(() => {
    l === void 0 && typeof u == "boolean" && (g(!1), p(u));
  }, [u]);
  let C = (M) => {
    var H;
    ["text", "button"].includes(M.target.type) && [yt.SPACE, yt.ENTER].includes(M.code) || (h && (M.code === yt.ESCAPE ? (p(!1), (H = E == null ? void 0 : E.current) == null || H.focus()) : p(!0)), M.preventDefault());
  };
  xa([yt.ENTER, yt.ARROW_DOWN, yt.SPACE, yt.ESCAPE], C, { target: E });
  let B = (M) => {
    h && r && p(M);
  }, I = () => !v && b(!0), x = (M) => {
    !M.currentTarget.contains(M.relatedTarget) && h && (b(!1), p(!1));
  }, O = () => B(!0), k = () => B(!1), Q = () => {
    h && p(i || o ? !1 : !m);
  }, F = (M) => {
    M.stopPropagation(), s([]), h && p(!1);
  };
  return D("div", { tabIndex: 0, className: "dropdown-container", "aria-labelledby": a, "aria-expanded": m, "aria-readonly": !0, "aria-disabled": o, ref: E, onFocus: I, onBlur: x, onMouseEnter: O, onMouseLeave: k, children: [D("div", { className: "dropdown-heading", onClick: Q, children: [A("div", { className: "dropdown-heading-value", children: A(OH, {}) }), i && A(DH, {}), c.length > 0 && d !== null && A("button", { type: "button", className: "clear-selected-button", onClick: F, disabled: o, "aria-label": e("clearSelected"), children: d || A(Jp, {}) }), A(y, { expanded: m })] }), m && A("div", { className: "dropdown-content", children: A("div", { className: "panel-content", children: A(PH, {}) }) })] });
}, NH = SH, TH = (e) => A(pH, { props: e, children: A("div", { className: `rmsc ${e.className || "multi-select"}`, children: A(NH, {}) }) }), RH = TH;
const tL = (e) => {
  const {
    options: t,
    onChange: n,
    className: r,
    selected: i = [],
    selectProps: o = {},
    ...s
  } = e;
  return /* @__PURE__ */ A(Yp, { ...s, children: /* @__PURE__ */ A(
    RH,
    {
      labelledBy: "Select",
      value: i,
      onChange: n,
      options: t,
      className: $("checkbox-container w-[200px]", r),
      ...o
    }
  ) });
}, nL = (e) => {
  const {
    body: t,
    title: n,
    onSave: r,
    children: i,
    saveLabel: o,
    cancelLabel: s,
    overlayProps: a,
    contentProps: c,
    onOpenChange: u,
    ...l
  } = e;
  return /* @__PURE__ */ A(
    gn,
    {
      overlayProps: {
        ...a,
        className: $("top-10", a == null ? void 0 : a.className)
      },
      contentProps: {
        ...c,
        className: $("rounded-2xl", c == null ? void 0 : c.className)
      },
      onOpenChange: u,
      ...l,
      children: /* @__PURE__ */ D("div", { className: "w-[432px] p-4 text-gray-900", children: [
        /* @__PURE__ */ D("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ A("h1", { className: "text-center text-xl font-bold", children: n }),
          /* @__PURE__ */ A(
            "button",
            {
              className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
              onClick: () => u == null ? void 0 : u(!1),
              children: /* @__PURE__ */ A(Y, { name: "XmarkLight", size: 24 })
            }
          )
        ] }),
        /* @__PURE__ */ A("div", { className: "mt-8 flex min-h-[50px] items-center justify-center rounded-md bg-slate-50 p-3 text-xs font-medium text-gray-600", children: t }),
        /* @__PURE__ */ A("div", { className: "mt-4 flex flex-col gap-y-4", children: i }),
        /* @__PURE__ */ D("div", { className: "mt-4 flex justify-end gap-x-4", children: [
          /* @__PURE__ */ A(
            Et,
            {
              color: "light",
              className: "text-gray-900",
              onClick: () => u == null ? void 0 : u(!1),
              children: s
            }
          ),
          /* @__PURE__ */ A(Et, { onClick: r, children: o })
        ] })
      ] })
    }
  );
}, O1 = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", rL = (e) => {
  const {
    body: t,
    header: n,
    onOpenChange: r,
    onContinue: i,
    cancelLabel: o,
    continueLabel: s,
    overlayProps: a,
    contentProps: c,
    ...u
  } = e;
  return /* @__PURE__ */ A(
    gn,
    {
      overlayProps: {
        ...a,
        className: a == null ? void 0 : a.className
      },
      contentProps: {
        ...c,
        className: $("rounded-3xl", c == null ? void 0 : c.className)
      },
      onOpenChange: r,
      ...u,
      children: /* @__PURE__ */ D("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ A("div", { className: "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800", children: n }),
        /* @__PURE__ */ A("div", { className: "my-6 rounded-md bg-slate-50 p-4 text-center text-slate-200", children: t }),
        /* @__PURE__ */ D("div", { className: "mt-8 flex justify-between gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: () => r == null ? void 0 : r(!1),
              className: $(
                O1,
                "flex-1 bg-slate-50 text-slate-800"
              ),
              children: o
            }
          ),
          /* @__PURE__ */ A(
            "button",
            {
              onClick: i,
              className: $(
                O1,
                "flex-1 bg-gray-800 text-gray-50"
              ),
              children: s
            }
          )
        ] })
      ] })
    }
  );
};
function Mo(e) {
  const {
    onSubmit: t,
    onCancel: n,
    defaultValue: r,
    className: i,
    minLength: o = 1,
    ...s
  } = e, [a, c] = q(r ?? ""), u = Ce(null);
  sH(u, l), Wp("keyup", (d) => {
    d.key === "Enter" && l(), d.key === "Escape" && n();
  }), Kn(() => {
    setTimeout(() => {
      var d, f, h;
      (d = u.current) == null || d.focus(), (f = u.current) == null || f.select(), (h = u.current) == null || h.scroll({ left: 9999 });
    }, 100);
  }, []);
  function l() {
    a.length >= o && t(a);
  }
  return /* @__PURE__ */ A(
    "input",
    {
      ...s,
      required: !0,
      autoFocus: !0,
      type: "text",
      ref: u,
      value: a,
      minLength: o,
      className: $(
        "bg-inherit text-inherit outline-none",
        i
      ),
      onChange: (d) => c(d.target.value)
    }
  );
}
function LH(e) {
  const { branch: t = "main" } = e;
  return /* @__PURE__ */ D("button", { className: "flex h-8 items-center gap-1 rounded-lg bg-slate-50 pl-1 pr-2 text-xs text-slate-100", children: [
    /* @__PURE__ */ A(Y, { name: "Branch" }),
    /* @__PURE__ */ A("span", { children: "BRANCH" }),
    /* @__PURE__ */ A("span", { className: "text-gray-900", children: t })
  ] });
}
function FH(e) {
  const { docId: t } = e, [, n] = cA();
  function r(i) {
    return () => {
      n(i).catch((o) => {
        console.error("Failed to copy!", o);
      });
    };
  }
  return /* @__PURE__ */ D(
    "button",
    {
      className: "flex h-8 items-center gap-1 rounded-lg bg-slate-50 pl-1 pr-2 text-xs text-slate-100",
      onClick: r(t),
      children: [
        /* @__PURE__ */ A(Y, { name: "Link" }),
        "DOC ID",
        /* @__PURE__ */ A("span", { className: "text-gray-900", children: t })
      ]
    }
  );
}
const _p = gh(function(t, n) {
  const {
    items: r,
    value: i,
    id: o,
    onChange: s,
    containerClassName: a,
    menuClassName: c,
    itemClassName: u,
    absolutePositionMenu: l = !1,
    borderRadius: d = "12px"
  } = t, [f, h] = q(!1), g = p(i) ?? r[0];
  function m(b) {
    b.disabled || (s(b.value), h(!1));
  }
  function p(b) {
    return r.find((y) => y.value === b);
  }
  const v = r.filter((b) => b.value !== i);
  return /* @__PURE__ */ D(
    "div",
    {
      className: $(
        "bg-gray-100 transition-[border-radius]",
        l && "relative",
        a
      ),
      ref: n,
      style: {
        borderRadius: f ? `${d} ${d} 0 0` : d
      },
      "data-open": f,
      children: [
        /* @__PURE__ */ D(
          "div",
          {
            onClick: () => h(!f),
            id: o,
            className: $(
              "flex min-w-[360px] cursor-pointer items-center justify-between pr-3 text-gray-800 outline-none",
              c
            ),
            children: [
              /* @__PURE__ */ A(D1, { ...g, className: u }),
              /* @__PURE__ */ A(
                Y,
                {
                  name: "ChevronDown",
                  className: Or(
                    "transition",
                    f ? "" : "-rotate-90"
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ A(
          "div",
          {
            style: {
              borderRadius: `0 0 ${d} ${d}`
            },
            className: $(
              "max-h-0 w-full overflow-hidden bg-inherit transition-[max-height] ease-in-out",
              f && "max-h-screen",
              l && "absolute"
            ),
            children: v.map((b) => /* @__PURE__ */ A(
              D1,
              {
                ...b,
                onItemClick: () => m(b),
                className: u
              },
              b.value
            ))
          }
        )
      ]
    }
  );
});
function D1(e) {
  const {
    className: t,
    disabled: n,
    onItemClick: r,
    icon: i,
    displayValue: o,
    value: s,
    description: a
  } = e;
  return /* @__PURE__ */ D(
    "div",
    {
      className: $(
        n ? "cursor-not-allowed text-gray-500" : "text-gray-800",
        "flex size-full cursor-pointer items-center gap-2 bg-inherit py-3 pl-3 text-start outline-none",
        t
      ),
      onClick: r,
      children: [
        i,
        /* @__PURE__ */ D("div", { children: [
          /* @__PURE__ */ A("p", { className: "capitalize text-inherit", children: o ?? s.toLowerCase() }),
          /* @__PURE__ */ A("p", { className: "text-xs text-inherit", children: a })
        ] })
      ]
    }
  );
}
function QH(e) {
  const { value: t, onChange: n } = e;
  return /* @__PURE__ */ A(
    _p,
    {
      id: "scope select",
      value: t,
      items: [
        { displayValue: "Global scope", value: "global" },
        { displayValue: "Local scope", value: "local" }
      ],
      onChange: n,
      containerClassName: "bg-slate-50 text-gray-500 rounded-lg w-fit text-xs z-10",
      menuClassName: "min-w-0 text-gray-500",
      itemClassName: "py-2 text-gray-500 grid grid-cols-[auto,auto] gap-1",
      absolutePositionMenu: !0
    }
  );
}
function XH(e) {
  const {
    title: t,
    docId: n,
    scope: r,
    onChangeScope: i,
    onClose: o,
    className: s,
    ...a
  } = e;
  return /* @__PURE__ */ D(
    "header",
    {
      className: $(
        "flex items-center justify-between bg-transparent",
        s
      ),
      ...a,
      children: [
        /* @__PURE__ */ D("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: o,
              className: "rounded-lg bg-gray-50 p-1 text-slate-100 shadow-button",
              children: /* @__PURE__ */ A(Y, { name: "VariantArrowLeft" })
            }
          ),
          /* @__PURE__ */ A("h1", { className: "text-xs", children: t })
        ] }),
        /* @__PURE__ */ D("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ A(FH, { docId: n }),
          /* @__PURE__ */ A(LH, {}),
          /* @__PURE__ */ A(QH, { value: r, onChange: i })
        ] })
      ]
    }
  );
}
function Wr(e, t, n) {
  let r = n.initialDeps ?? [], i;
  return () => {
    var o, s, a, c;
    let u;
    n.key && ((o = n.debug) != null && o.call(n)) && (u = Date.now());
    const l = e();
    if (!(l.length !== r.length || l.some((h, g) => r[g] !== h)))
      return i;
    r = l;
    let f;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (f = Date.now()), i = t(...l), n.key && ((a = n.debug) != null && a.call(n))) {
      const h = Math.round((Date.now() - u) * 100) / 100, g = Math.round((Date.now() - f) * 100) / 100, m = g / 16, p = (v, b) => {
        for (v = String(v); v.length < b; )
          v = " " + v;
        return v;
      };
      console.info(
        `%c⏱ ${p(g, 5)} /${p(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * m, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (c = n == null ? void 0 : n.onChange) == null || c.call(n, i), i;
  };
}
function ru(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const VH = (e, t) => Math.abs(e - t) < 1, kH = (e, t, n) => {
  let r;
  return function(...i) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, i), n);
  };
}, MH = (e) => e, zH = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let i = t; i <= n; i++)
    r.push(i);
  return r;
}, jH = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const i = (s) => {
    const { width: a, height: c } = s;
    t({ width: Math.round(a), height: Math.round(c) });
  };
  if (i(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const o = new r.ResizeObserver((s) => {
    const a = s[0];
    if (a != null && a.borderBoxSize) {
      const c = a.borderBoxSize[0];
      if (c) {
        i({ width: c.inlineSize, height: c.blockSize });
        return;
      }
    }
    i(n.getBoundingClientRect());
  });
  return o.observe(n, { box: "border-box" }), () => {
    o.unobserve(n);
  };
}, S1 = {
  passive: !0
}, WH = typeof window > "u" ? !0 : "onscrollend" in window, ZH = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let i = 0;
  const o = WH ? () => {
  } : kH(
    r,
    () => {
      t(i, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (u) => () => {
    const { horizontal: l, isRtl: d } = e.options;
    i = l ? n.scrollLeft * (d && -1 || 1) : n.scrollTop, o(), t(i, u);
  }, a = s(!0), c = s(!1);
  return c(), n.addEventListener("scroll", a, S1), n.addEventListener("scrollend", c, S1), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", c);
  };
}, GH = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, qH = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var i, o;
  const s = e + t;
  (o = (i = r.scrollElement) == null ? void 0 : i.scrollTo) == null || o.call(i, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class YH {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((i) => {
        i.forEach((o) => {
          this._measureElement(o.target, o);
        });
      }));
      return {
        disconnect: () => {
          var i;
          (i = r()) == null || i.disconnect(), n = null;
        },
        observe: (i) => {
          var o;
          return (o = r()) == null ? void 0 : o.observe(i, { box: "border-box" });
        },
        unobserve: (i) => {
          var o;
          return (o = r()) == null ? void 0 : o.unobserve(i);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, i]) => {
        typeof i > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: MH,
        rangeExtractor: zH,
        onChange: () => {
        },
        measureElement: GH,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, i;
      (i = (r = this.options).onChange) == null || i.call(r, this, n);
    }, this.maybeNotify = Wr(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((i) => {
          this.observer.observe(i);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (i) => {
            this.scrollRect = i, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (i, o) => {
            this.scrollAdjustments = 0, this.scrollDirection = o ? this.getScrollOffset() < i ? "forward" : "backward" : null, this.scrollOffset = i, this.isScrolling = o, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (i.has(a.lane))
          continue;
        const c = o.get(
          a.lane
        );
        if (c == null || a.end > c.end ? o.set(a.lane, a) : a.end < c.end && i.set(a.lane, !0), i.size === this.options.lanes)
          break;
      }
      return o.size === this.options.lanes ? Array.from(o.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Wr(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, i, o, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: i,
        getItemKey: o,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Wr(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: i, getItemKey: o, enabled: s }, a) => {
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((l) => {
          this.itemSizeCache.set(l.key, l.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, c);
        for (let l = c; l < n; l++) {
          const d = o(l), f = this.options.lanes === 1 ? u[l - 1] : this.getFurthestMeasurement(u, l), h = f ? f.end + this.options.gap : r + i, g = a.get(d), m = typeof g == "number" ? g : this.options.estimateSize(l), p = h + m, v = f ? f.lane : l % this.options.lanes;
          u[l] = {
            index: l,
            start: h,
            size: m,
            end: p,
            key: d,
            lane: v
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Wr(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, i) => this.range = n.length > 0 && r > 0 ? UH({
        measurements: n,
        outerSize: r,
        scrollOffset: i
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Wr(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, i, o) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: i,
        count: o
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, i = n.getAttribute(r);
      return i ? parseInt(i, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const i = this.indexFromElement(n), o = this.measurementsCache[i];
      if (!o)
        return;
      const s = o.key, a = this.elementsCache.get(s);
      a !== n && (a && this.observer.unobserve(a), this.observer.observe(n), this.elementsCache.set(s, n)), n.isConnected && this.resizeItem(i, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const i = this.measurementsCache[n];
      if (!i)
        return;
      const o = this.itemSizeCache.get(i.key) ?? i.size, s = r - o;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(i, s, this) : i.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(i.index), this.itemSizeCache = new Map(this.itemSizeCache.set(i.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, i) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(i));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Wr(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const i = [];
        for (let o = 0, s = n.length; o < s; o++) {
          const a = n[o], c = r[a];
          i.push(c);
        }
        return i;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return ru(
          r[$p(
            0,
            r.length - 1,
            (i) => ru(r[i]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const i = this.getSize(), o = this.getScrollOffset();
      r === "auto" && (n <= o ? r = "start" : n >= o + i ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - i : r === "center" && (n = n - i / 2);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - i;
      return Math.max(Math.min(c, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const i = this.measurementsCache[n];
      if (!i)
        return;
      const o = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (i.end >= s + o - this.options.scrollPaddingEnd)
          r = "end";
        else if (i.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? i.end + this.options.scrollPaddingEnd : i.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: i } = {}) => {
      this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: i
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: i } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const o = this.getOffsetForIndex(n, r);
      if (!o) return;
      const [s, a] = o;
      this._scrollToOffset(s, { adjustments: void 0, behavior: i }), i !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [u] = ru(
            this.getOffsetForIndex(n, a)
          );
          VH(u, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: i });
        } else
          this.scrollToIndex(n, { align: a, behavior: i });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let i;
      return r.length === 0 ? i = this.options.paddingStart : i = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((o) => o.end)
      ), Math.max(
        i - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: i
    }) => {
      this.options.scrollToFn(n, { behavior: i, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const $p = (e, t, n, r) => {
  for (; e <= t; ) {
    const i = (e + t) / 2 | 0, o = n(i);
    if (o < r)
      e = i + 1;
    else if (o > r)
      t = i - 1;
    else
      return i;
  }
  return e > 0 ? e - 1 : 0;
};
function UH({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, o = $p(0, r, (a) => e[a].start, n);
  let s = o;
  for (; s < r && e[s].end < n + t; )
    s++;
  return { startIndex: o, endIndex: s };
}
const JH = typeof document < "u" ? w.useLayoutEffect : w.useEffect;
function KH(e) {
  const t = w.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (i, o) => {
      var s;
      o ? x9(t) : t(), (s = e.onChange) == null || s.call(e, i, o);
    }
  }, [r] = w.useState(
    () => new YH(n)
  );
  return r.setOptions(n), w.useEffect(() => r._didMount(), []), JH(() => r._willUpdate()), r;
}
function _H(e) {
  return KH({
    observeElementRect: jH,
    observeElementOffset: ZH,
    scrollToFn: qH,
    ...e
  });
}
function $H(e) {
  const { address: t, chainId: n } = e, [, r] = cA();
  if (!t) return null;
  const i = xm(t);
  function o(a) {
    return () => {
      r(a).catch((c) => {
        console.error("Failed to copy!", c);
      });
    };
  }
  const s = /* @__PURE__ */ D(
    "button",
    {
      onClick: o(t),
      className: "flex items-center gap-1",
      children: [
        t,
        /* @__PURE__ */ A(
          Y,
          {
            name: "FilesEarmark",
            className: "inline-block text-gray-600",
            size: 16
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ A(Nr, { content: s, children: /* @__PURE__ */ D("span", { className: "flex w-fit cursor-pointer items-center gap-1 rounded-lg bg-gray-100 p-1 text-xs text-slate-100", children: [
    /* @__PURE__ */ A(mp, { address: t, chainId: n }),
    i
  ] }) });
}
function eO(e) {
  const { errors: t } = e, n = !!(t != null && t.length), r = n ? "text-red-800" : "text-green-700", i = n ? /* @__PURE__ */ A(Y, { name: "Exclamation", size: 16 }) : /* @__PURE__ */ A(Y, { name: "Check", size: 16 }), o = n ? `Error: ${t[0]}` : "No errors", s = /* @__PURE__ */ D(
    "span",
    {
      className: $(
        "flex w-fit items-center rounded-lg border border-gray-200 px-2 py-1 text-xs",
        r,
        n && "cursor-pointer"
      ),
      children: [
        i,
        /* @__PURE__ */ A("span", { className: $("inline-block max-w-36 truncate"), children: o })
      ]
    }
  ), a = t == null ? void 0 : t.map((c, u) => /* @__PURE__ */ D("p", { className: "text-red-800", children: [
    "Error: ",
    c
  ] }, u));
  return n ? /* @__PURE__ */ A(Nr, { content: a, children: s }) : s;
}
function tO(e) {
  const { operationType: t, operationInput: n } = e, r = /* @__PURE__ */ A("code", { children: /* @__PURE__ */ A("pre", { children: JSON.stringify(n, null, 2) }) });
  return /* @__PURE__ */ A(Nr, { content: r, children: /* @__PURE__ */ D("span", { className: "flex cursor-pointer items-center gap-2 text-xs", children: [
    t,
    /* @__PURE__ */ A(Y, { name: "Braces", className: "text-gray-300", size: 16 })
  ] }) });
}
function nO(e) {
  const { operationIndex: t, eventId: n, stateHash: r } = e, [, i] = cA(), o = t + 1, s = /* @__PURE__ */ D(
    "button",
    {
      onClick: a(r),
      className: "flex items-center gap-1",
      children: [
        "Revision ",
        o,
        " - Event ID: ",
        n,
        " - State Hash:",
        " ",
        r,
        /* @__PURE__ */ A(
          Y,
          {
            name: "FilesEarmark",
            className: "inline-block text-gray-600",
            size: 16
          }
        )
      ]
    }
  );
  function a(c) {
    return () => {
      i(c).catch((u) => {
        console.error("Failed to copy!", u);
      });
    };
  }
  return /* @__PURE__ */ A(Nr, { content: s, children: /* @__PURE__ */ D("span", { className: "flex cursor-pointer items-center gap-2 text-xs text-gray-600", children: [
    "Revision ",
    o,
    ".",
    /* @__PURE__ */ A("a", { children: /* @__PURE__ */ A(
      Y,
      {
        name: "Ellipsis",
        size: 14,
        className: "cursor-pointer text-slate-100"
      }
    ) })
  ] }) });
}
function rO(e) {
  const { signatures: t } = e;
  if (!(t != null && t.length)) return null;
  const n = t.length, r = t.filter(
    (a) => a.isVerified
  ).length, i = n === 1 ? "signature" : "signatures";
  function o() {
    const a = `${r}/${n} ${i} verified`;
    return /* @__PURE__ */ A("span", { className: `text-xs ${r === 0 ? "text-red-800" : r === n ? "text-green-700" : "text-orange-700"}`, children: a });
  }
  const s = /* @__PURE__ */ D("div", { className: "text-xs text-slate-300", children: [
    /* @__PURE__ */ A("h3", { className: "mb-2", children: "Signature details:" }),
    t.map((a, c) => /* @__PURE__ */ D("div", { className: "mb-2 last:mb-0", children: [
      /* @__PURE__ */ D("h4", { children: [
        "Signature #",
        c + 1,
        " -",
        " ",
        a.isVerified ? "verified" : "unverified"
      ] }),
      /* @__PURE__ */ A("code", { children: /* @__PURE__ */ A("pre", { children: JSON.stringify(a, null, 2) }) })
    ] }, a.hash))
  ] });
  return /* @__PURE__ */ A(Nr, { content: s, children: /* @__PURE__ */ D("span", { className: "flex w-fit cursor-pointer items-center gap-1 rounded-lg border border-gray-200 px-2 py-1", children: [
    /* @__PURE__ */ A(o, {}),
    " ",
    /* @__PURE__ */ A(Y, { name: "InfoSquare", className: "text-gray-300", size: 16 })
  ] }) });
}
function $t(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function wr(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
const em = 6048e5, iO = 864e5;
let oO = {};
function tc() {
  return oO;
}
function zo(e, t) {
  var a, c, u, l;
  const n = tc(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((l = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : l.weekStartsOn) ?? 0, i = $t(e), o = i.getDay(), s = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - s), i.setHours(0, 0, 0, 0), i;
}
function Ba(e) {
  return zo(e, { weekStartsOn: 1 });
}
function tm(e) {
  const t = $t(e), n = t.getFullYear(), r = wr(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Ba(r), o = wr(e, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = Ba(o);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function N1(e) {
  const t = $t(e);
  return t.setHours(0, 0, 0, 0), t;
}
function T1(e) {
  const t = $t(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function sO(e, t) {
  const n = N1(e), r = N1(t), i = +n - T1(n), o = +r - T1(r);
  return Math.round((i - o) / iO);
}
function aO(e) {
  const t = tm(e), n = wr(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Ba(n);
}
function cO(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function uO(e) {
  if (!cO(e) && typeof e != "number")
    return !1;
  const t = $t(e);
  return !isNaN(Number(t));
}
function lO(e) {
  const t = $t(e), n = wr(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const dO = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, AO = (e, t, n) => {
  let r;
  const i = dO[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function iu(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const fO = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, gO = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hO = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, pO = {
  date: iu({
    formats: fO,
    defaultWidth: "full"
  }),
  time: iu({
    formats: gO,
    defaultWidth: "full"
  }),
  dateTime: iu({
    formats: hO,
    defaultWidth: "full"
  })
}, mO = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, vO = (e, t, n, r) => mO[e];
function to(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      i = e.formattingValues[a] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[a] || e.values[s];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[o];
  };
}
const bO = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yO = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, CO = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, IO = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, EO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, xO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, BO = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, wO = {
  ordinalNumber: BO,
  era: to({
    values: bO,
    defaultWidth: "wide"
  }),
  quarter: to({
    values: yO,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: to({
    values: CO,
    defaultWidth: "wide"
  }),
  day: to({
    values: IO,
    defaultWidth: "wide"
  }),
  dayPeriod: to({
    values: EO,
    defaultWidth: "wide",
    formattingValues: xO,
    defaultFormattingWidth: "wide"
  })
};
function no(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    const s = o[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(a) ? HO(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      PO(a, (d) => d.test(s))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const l = t.slice(s.length);
    return { value: u, rest: l };
  };
}
function PO(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function HO(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function OO(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let s = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = t.slice(i.length);
    return { value: s, rest: a };
  };
}
const DO = /^(\d+)(th|st|nd|rd)?/i, SO = /\d+/i, NO = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, TO = {
  any: [/^b/i, /^(a|c)/i]
}, RO = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, LO = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, FO = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, QO = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, XO = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, VO = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, kO = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, MO = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, zO = {
  ordinalNumber: OO({
    matchPattern: DO,
    parsePattern: SO,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: no({
    matchPatterns: NO,
    defaultMatchWidth: "wide",
    parsePatterns: TO,
    defaultParseWidth: "any"
  }),
  quarter: no({
    matchPatterns: RO,
    defaultMatchWidth: "wide",
    parsePatterns: LO,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: no({
    matchPatterns: FO,
    defaultMatchWidth: "wide",
    parsePatterns: QO,
    defaultParseWidth: "any"
  }),
  day: no({
    matchPatterns: XO,
    defaultMatchWidth: "wide",
    parsePatterns: VO,
    defaultParseWidth: "any"
  }),
  dayPeriod: no({
    matchPatterns: kO,
    defaultMatchWidth: "any",
    parsePatterns: MO,
    defaultParseWidth: "any"
  })
}, jO = {
  code: "en-US",
  formatDistance: AO,
  formatLong: pO,
  formatRelative: vO,
  localize: wO,
  match: zO,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function WO(e) {
  const t = $t(e);
  return sO(t, lO(t)) + 1;
}
function ZO(e) {
  const t = $t(e), n = +Ba(t) - +aO(t);
  return Math.round(n / em) + 1;
}
function nm(e, t) {
  var l, d, f, h;
  const n = $t(e), r = n.getFullYear(), i = tc(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, s = wr(e, 0);
  s.setFullYear(r + 1, 0, o), s.setHours(0, 0, 0, 0);
  const a = zo(s, t), c = wr(e, 0);
  c.setFullYear(r, 0, o), c.setHours(0, 0, 0, 0);
  const u = zo(c, t);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function GO(e, t) {
  var a, c, u, l;
  const n = tc(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((l = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, i = nm(e, t), o = wr(e, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), zo(o, t);
}
function qO(e, t) {
  const n = $t(e), r = +zo(n, t) - +GO(n, t);
  return Math.round(r / em) + 1;
}
function Fe(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const On = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Fe(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Fe(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Fe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Fe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Fe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Fe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Fe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Fe(i, t.length);
  }
}, Zr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, R1 = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return On.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = nm(e, r), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const s = o % 100;
      return Fe(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : Fe(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = tm(e);
    return Fe(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Fe(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Fe(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Fe(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return On.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Fe(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = qO(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : Fe(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = ZO(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Fe(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : On.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = WO(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Fe(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return Fe(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return Fe(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return Fe(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = Zr.noon : r === 0 ? i = Zr.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = Zr.evening : r >= 12 ? i = Zr.afternoon : r >= 4 ? i = Zr.morning : i = Zr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return On.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : On.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Fe(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Fe(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : On.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : On.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return On.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return F1(r);
      case "XXXX":
      case "XX":
        return rr(r);
      case "XXXXX":
      case "XXX":
      default:
        return rr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return F1(r);
      case "xxxx":
      case "xx":
        return rr(r);
      case "xxxxx":
      case "xxx":
      default:
        return rr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + L1(r, ":");
      case "OOOO":
      default:
        return "GMT" + rr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + L1(r, ":");
      case "zzzz":
      default:
        return "GMT" + rr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Fe(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Fe(r, t.length);
  }
};
function L1(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + t + Fe(o, 2);
}
function F1(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Fe(Math.abs(e) / 60, 2) : rr(e, t);
}
function rr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Fe(Math.trunc(r / 60), 2), o = Fe(r % 60, 2);
  return n + i + t + o;
}
const Q1 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, rm = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, YO = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return Q1(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Q1(r, t)).replace("{{time}}", rm(i, t));
}, UO = {
  p: rm,
  P: YO
}, JO = /^D+$/, KO = /^Y+$/, _O = ["D", "DD", "YY", "YYYY"];
function $O(e) {
  return JO.test(e);
}
function eD(e) {
  return KO.test(e);
}
function tD(e, t, n) {
  const r = nD(e, t, n);
  if (console.warn(r), _O.includes(e)) throw new RangeError(r);
}
function nD(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const rD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, iD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oD = /^'([^]*?)'?$/, sD = /''/g, aD = /[a-zA-Z]/;
function Hi(e, t, n) {
  var l, d, f, h, g, m, p, v;
  const r = tc(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? jO, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((v = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : v.weekStartsOn) ?? 0, a = $t(e);
  if (!uO(a))
    throw new RangeError("Invalid time value");
  let c = t.match(iD).map((b) => {
    const y = b[0];
    if (y === "p" || y === "P") {
      const E = UO[y];
      return E(b, i.formatLong);
    }
    return b;
  }).join("").match(rD).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const y = b[0];
    if (y === "'")
      return { isToken: !1, value: cD(b) };
    if (R1[y])
      return { isToken: !0, value: b };
    if (y.match(aD))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + y + "`"
      );
    return { isToken: !1, value: b };
  });
  i.localize.preprocessor && (c = i.localize.preprocessor(a, c));
  const u = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: i
  };
  return c.map((b) => {
    if (!b.isToken) return b.value;
    const y = b.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && eD(y) || !(n != null && n.useAdditionalDayOfYearTokens) && $O(y)) && tD(y, t, String(e));
    const E = R1[y[0]];
    return E(a, y, i.localize, u);
  }).join("");
}
function cD(e) {
  const t = e.match(oD);
  return t ? t[1].replace(sD, "'") : e;
}
function uD(e) {
  const { timestamp: t } = e, n = new Date(t), r = Hi(n, "HH:mm 'UTC'"), i = Hi(n, "eee, dd MMM yyyy HH:mm:ss 'UTC'");
  return /* @__PURE__ */ A(Nr, { content: /* @__PURE__ */ A("div", { children: i }), children: /* @__PURE__ */ D("span", { className: "cursor-pointer text-xs", children: [
    "committed at ",
    r
  ] }) });
}
function lD(e) {
  return /* @__PURE__ */ D("article", { className: "flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-2", children: [
    /* @__PURE__ */ D("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ A(nO, { ...e }),
      /* @__PURE__ */ A(tO, { ...e }),
      /* @__PURE__ */ A($H, { ...e }),
      /* @__PURE__ */ A(uD, { ...e })
    ] }),
    /* @__PURE__ */ D("div", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ A(rO, { ...e }),
      /* @__PURE__ */ A(eO, { ...e })
    ] })
  ] });
}
const dD = Hr(lD);
function AD(e) {
  const { operationIndex: t, skipCount: n } = e, r = t + 1, i = n === 1 ? `${r}` : `${r} - ${r + n - 1}`;
  return /* @__PURE__ */ D("article", { className: "grid grid-cols-[1fr,auto,1fr] items-center py-2", children: [
    /* @__PURE__ */ A("div", { className: "h-px rounded-full bg-slate-100" }),
    /* @__PURE__ */ D("div", { className: "mx-3 text-xs text-slate-100", children: [
      "[Skipped Revision ",
      i,
      "]"
    ] }),
    /* @__PURE__ */ A("div", { className: "h-px rounded-full bg-slate-100" })
  ] });
}
function fD(e) {
  var o, s, a, c, u, l, d, f;
  const t = [];
  let n = 0, r = "";
  const i = /* @__PURE__ */ new Set();
  for (; n < e.length; ) {
    const h = e[n], g = h.timestamp.split("T")[0];
    if (g !== r && !i.has(g)) {
      i.add(g), t.push({
        type: "day",
        height: 32,
        timestamp: g
      }), r = g;
      continue;
    }
    if (h.skip > 0) {
      t.push({
        type: "skip",
        height: 18,
        operationIndex: h.index,
        skipCount: h.skip,
        timestamp: h.timestamp
      }), n += h.skip;
      continue;
    } else
      t.push({
        type: "revision",
        height: 46,
        operationIndex: h.index,
        eventId: h.id ?? "EVENT_ID_NOT_FOUND",
        stateHash: h.hash,
        operationType: h.type,
        operationInput: h.input ?? {},
        address: (a = (s = (o = h.context) == null ? void 0 : o.signer) == null ? void 0 : s.user) == null ? void 0 : a.address,
        chainId: (l = (u = (c = h.context) == null ? void 0 : c.signer) == null ? void 0 : u.user) == null ? void 0 : l.chainId,
        timestamp: h.timestamp,
        signatures: hD(
          (f = (d = h.context) == null ? void 0 : d.signer) == null ? void 0 : f.signatures
        ),
        errors: h.error ? [h.error] : void 0
      });
    n += 1;
  }
  return t;
}
function gD(e) {
  const [t, n, r, i] = e;
  return {
    signerAddress: t,
    hash: n,
    prevStateHash: r,
    signatureBytes: i,
    isVerified: !0
  };
}
function hD(e) {
  return e == null ? void 0 : e.map(gD);
}
function pD(e) {
  const { timestamp: t } = e, n = Hi(t, "MMM dd, yyyy");
  return /* @__PURE__ */ D("h2", { className: "-ml-6 flex items-center gap-1 bg-slate-50 py-2 text-xs text-slate-100", children: [
    /* @__PURE__ */ A(Y, { name: "Ring", size: 16 }),
    " Changes on ",
    n
  ] });
}
function mD(e) {
  const { localOperations: t, globalOperations: n, scope: r } = e, i = r === "local" ? t : n, o = 100, s = ve(() => fD(i), [i]), [a, c] = q(0), [u, l] = q(o), [d, f] = q(() => s.slice(0, u)), h = Ce(null), g = d.length < s.length, m = _H({
    count: d.length,
    getScrollElement: () => h.current,
    estimateSize: (v) => s[v].height,
    gap: 8
  });
  Ie(() => {
    if (!g) return;
    const v = Math.floor(a / 46), b = o + v;
    l(
      (y) => b > y ? b : y
    );
  }, [a, g]), Ie(() => {
    f(s.slice(0, u));
  }, [s, u]);
  const p = (v) => {
    c((b) => {
      const y = b + v.deltaY;
      return y < 0 ? 0 : y;
    });
  };
  return Ie(() => (window.addEventListener("wheel", p), () => {
    window.removeEventListener("wheel", p);
  }), []), /* @__PURE__ */ A(
    "div",
    {
      ref: h,
      style: {
        height: `${m.getTotalSize()}px`,
        width: "100%",
        position: "relative"
      },
      className: `border-l border-slate-100
            `,
      children: m.getVirtualItems().map((v) => {
        const b = d[v.index];
        return /* @__PURE__ */ A(
          "div",
          {
            style: {
              position: "absolute",
              top: 0,
              left: 16,
              width: "100%",
              height: `${v.size}px`,
              transform: `translateY(${v.start}px)`
            },
            children: /* @__PURE__ */ D(Be, { children: [
              b.type === "revision" && /* @__PURE__ */ bi(dD, { ...b, key: v.key }),
              b.type === "skip" && /* @__PURE__ */ A(AD, { ...b }, v.key),
              b.type === "day" && /* @__PURE__ */ A(pD, { ...b }, v.key)
            ] })
          },
          v.index
        );
      })
    }
  );
}
function iL(e) {
  const {
    documentTitle: t,
    documentId: n,
    globalOperations: r,
    localOperations: i,
    onClose: o,
    itemsPerPage: s = 100
  } = e, [a, c] = q("global"), u = ve(() => (a === "global" ? r : i).sort((x, O) => O.index - x.index), [r, i, a]), {
    pageItems: l,
    pages: d,
    goToPage: f,
    goToNextPage: h,
    goToPreviousPage: g,
    goToFirstPage: m,
    goToLastPage: p,
    hiddenNextPages: v,
    isNextPageAvailable: b,
    isPreviousPageAvailable: y
  } = hd(u, {
    itemsPerPage: s
  });
  function E(I) {
    m(), c(I);
  }
  const B = u.length > s ? /* @__PURE__ */ A("div", { className: "mt-4 flex w-full justify-end", children: /* @__PURE__ */ A(
    fd,
    {
      pages: d,
      hiddenNextPages: v,
      goToFirstPage: m,
      goToLastPage: p,
      goToNextPage: h,
      goToPage: f,
      goToPreviousPage: g,
      isNextPageAvailable: b,
      isPreviousPageAvailable: y,
      nextPageLabel: "Next",
      previousPageLabel: "Previous",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page"
    }
  ) }) : /* @__PURE__ */ A("hr", { className: "h-12 border-none" });
  return /* @__PURE__ */ D(vm, { children: [
    /* @__PURE__ */ A(
      XH,
      {
        title: t,
        docId: n,
        scope: a,
        onChangeScope: E,
        onClose: o
      }
    ),
    B,
    /* @__PURE__ */ A("div", { className: "mt-4 flex justify-center rounded-md bg-slate-50 p-4", children: u.length > 0 ? /* @__PURE__ */ A("div", { className: "grid grid-cols-[minmax(min-content,1018px)]", children: /* @__PURE__ */ A(
      mD,
      {
        scope: a,
        globalOperations: a === "global" ? l : [],
        localOperations: a === "local" ? l : []
      }
    ) }) : /* @__PURE__ */ A("h3", { className: "my-40 text-gray-600", children: "This document has no recorded operations yet." }) }),
    B
  ] });
}
const X1 = (e) => {
  const { item: t, ...n } = e;
  return /* @__PURE__ */ D(
    "div",
    {
      ...rt(
        n,
        "flex h-full flex-row items-center justify-between gap-x-4 px-2"
      ),
      children: [
        t.icon,
        /* @__PURE__ */ A("div", { className: "text-sm font-semibold text-slate-200", children: t.label })
      ]
    }
  );
}, oL = (e) => {
  const {
    value: t,
    onChange: n,
    placeholder: r,
    filterLabel: i,
    filterItems: o,
    selectedFilter: s,
    onFilterSelect: a = () => {
    }
  } = e, c = ve(
    () => (o == null ? void 0 : o.map((f) => ({
      id: f.id,
      content: /* @__PURE__ */ A(X1, { item: f })
    }))) ?? [],
    [o]
  ), u = o == null ? void 0 : o.find(
    (f) => f.id === s
  ), l = u ? /* @__PURE__ */ A(X1, { item: u, className: "gap-x-1" }) : i && /* @__PURE__ */ A("div", { className: "mr-2 text-sm font-semibold text-slate-200", children: i });
  function d(f) {
    n(f.target.value);
  }
  return /* @__PURE__ */ D("div", { className: "flex items-center", children: [
    /* @__PURE__ */ A(Y, { name: "Search", className: "mr-3" }),
    /* @__PURE__ */ A(
      "input",
      {
        value: t,
        onChange: d,
        placeholder: r,
        className: $(
          "flex h-[52px] min-w-0 flex-1 items-center rounded-xl border border-gray-200 bg-gray-50 px-4 text-sm text-slate-200 outline-none"
        )
      }
    ),
    /* @__PURE__ */ D(Yg, { children: [
      /* @__PURE__ */ D(Ug, { className: "ml-3 flex h-full flex-row items-center outline-none", children: [
        l,
        " ",
        /* @__PURE__ */ A(Y, { name: "ChevronDown" })
      ] }),
      /* @__PURE__ */ A(Jg, { className: "rounded-xl border border-gray-100 bg-gray-50 p-2", children: c.map((f) => /* @__PURE__ */ A(
        Kg,
        {
          id: f.id,
          className: "h-10 cursor-pointer overflow-hidden rounded-lg hover:bg-gray-100",
          onSelect: () => a(f.id),
          children: f.content
        },
        f.id
      )) })
    ] })
  ] });
}, vD = "data:image/png;base64,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", bD = "data:image/png;base64,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", yD = "data:image/png;base64,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", CD = "data:image/png;base64,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", ID = ({ onLogin: e }) => /* @__PURE__ */ D(Be, { children: [
  /* @__PURE__ */ D(
    "button",
    {
      className: "group/sidebar-footer hidden w-full cursor-pointer items-baseline justify-start text-sm font-semibold leading-10 text-gray-600 expanded:flex",
      onClick: e,
      children: [
        /* @__PURE__ */ A("span", { children: "Login with" }),
        /* @__PURE__ */ A(
          "img",
          {
            src: CD,
            className: "ml-2 h-5 group-hover/sidebar-footer:hidden"
          }
        ),
        /* @__PURE__ */ A(
          "img",
          {
            src: vD,
            className: "ml-2 hidden h-5 group-hover/sidebar-footer:block"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ D(
    "button",
    {
      className: "group/sidebar-footer hidden w-full cursor-pointer place-items-center p-1 collapsed:grid",
      onClick: e,
      "aria-label": "Login with Renown",
      children: [
        /* @__PURE__ */ A(
          "img",
          {
            src: yD,
            className: "group-hover/sidebar-footer:hidden"
          }
        ),
        /* @__PURE__ */ A(
          "img",
          {
            src: bD,
            className: "hidden group-hover/sidebar-footer:block"
          }
        )
      ]
    }
  )
] }), ED = ({ address: e }) => {
  const t = pp({ address: e }), n = t.isLoading, r = t.data ?? void 0, i = xm(e);
  return /* @__PURE__ */ D(
    "div",
    {
      className: `flex gap-2 rounded-sm py-2.5 collapsed:justify-center
            collapsed:px-1 expanding:justify-center expanding:px-1`,
      children: [
        /* @__PURE__ */ A(mp, { address: e, size: "40px" }),
        /* @__PURE__ */ D("div", { className: "grid w-full items-center font-semibold collapsed:hidden expanding:hidden", children: [
          n && /* @__PURE__ */ D(Be, { children: [
            /* @__PURE__ */ A("p", { className: "mb-2 h-4 w-4/5 animate-pulse rounded bg-gray-400" }),
            /* @__PURE__ */ A("p", { className: "h-3 w-4/5 animate-pulse rounded bg-gray-400" })
          ] }),
          !n && !!r && /* @__PURE__ */ D(Be, { children: [
            /* @__PURE__ */ A("p", { className: "mb-2 h-4 text-sm text-gray-800 duration-1000 animate-in fade-in", children: r }),
            /* @__PURE__ */ A("p", { className: "h-3 text-xs text-gray-600 duration-1000 animate-in fade-in", children: i })
          ] }),
          !n && !r && /* @__PURE__ */ A("p", { className: "text-sm text-gray-800 duration-1000 animate-in fade-in", children: i })
        ] })
      ]
    }
  );
}, xD = ({
  address: e,
  className: t,
  onLogin: n,
  onClickSettings: r,
  ...i
}) => /* @__PURE__ */ D(
  D6,
  {
    ...i,
    className: $(
      "bg-gray-50 p-4 collapsed:px-1 expanding:px-1",
      t
    ),
    children: [
      /* @__PURE__ */ A("div", { className: "collapsed:bg-transparent collapsing:bg-transparent expanding:bg-transparent", children: e ? /* @__PURE__ */ A(ED, { address: e }) : /* @__PURE__ */ A(ID, { onLogin: n }) }),
      /* @__PURE__ */ D(
        "button",
        {
          className: "mt-3 flex w-full cursor-pointer gap-3 outline-none collapsed:px-3 expanding:px-3",
          onClick: r,
          children: [
            /* @__PURE__ */ A(Y, { name: "Settings", className: "text-gray-600" }),
            /* @__PURE__ */ A("span", { className: "text-sm font-semibold leading-6 text-gray-800 collapsed:hidden expanding:hidden", children: "Settings" })
          ]
        }
      )
    ]
  }
), BD = ({
  onToggle: e,
  className: t,
  children: n,
  ...r
}) => /* @__PURE__ */ D(
  O6,
  {
    ...r,
    className: $(
      "mb-4 flex justify-between gap-4 px-4 pt-11 collapsed:justify-center",
      t
    ),
    children: [
      /* @__PURE__ */ A("div", { className: "collapsed:hidden expanding:hidden", children: n || /* @__PURE__ */ A(
        "input",
        {
          placeholder: "Create new document",
          className: "flex-1 rounded-md border border-gray-100 px-5 py-3 leading-none text-gray-600 placeholder-shown:bg-transparent"
        }
      ) }),
      /* @__PURE__ */ A(
        "button",
        {
          className: `rounded-md border border-gray-100 p-3 outline-none hover:bg-slate-50
                collapsed:rotate-180 collapsed:border-gray-100/10 collapsed:bg-gray-100
                collapsed:shadow-sidebar collapsed:hover:bg-slate-50
                expanding:hidden`,
          onClick: () => e(),
          children: /* @__PURE__ */ A(Y, { name: "ArrowLeft", size: 16, className: "text-gray-600" })
        }
      )
    ]
  }
), sL = ({
  onToggle: e,
  address: t,
  headerContent: n,
  onClickSettings: r,
  collapsed: i = !1,
  maxWidth: o = "304px",
  minWidth: s = "58px",
  onLogin: a,
  ...c
}) => /* @__PURE__ */ D(
  S6,
  {
    ...c,
    collapsed: i,
    maxWidth: o,
    minWidth: s,
    children: [
      /* @__PURE__ */ D(N6, { children: [
        /* @__PURE__ */ A(BD, { onToggle: e, children: n }),
        /* @__PURE__ */ A("div", { className: "hidden expanded:block", children: c.children })
      ] }),
      /* @__PURE__ */ A(
        xD,
        {
          address: t,
          onLogin: a,
          onClickSettings: r
        }
      )
    ]
  }
);
function im(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = im(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function kn() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = im(e)) && (r && (r += " "), r += t);
  return r;
}
const jo = (e) => typeof e == "number" && !isNaN(e), hr = (e) => typeof e == "string", Ht = (e) => typeof e == "function", Ks = (e) => hr(e) || Ht(e) ? e : null, Ol = (e) => Kr(e) || hr(e) || Ht(e) || jo(e);
function wD(e, t, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: r, style: i } = e;
  requestAnimationFrame(() => {
    i.minHeight = "initial", i.height = r + "px", i.transition = `all ${n}ms`, requestAnimationFrame(() => {
      i.height = "0", i.padding = "0", i.margin = "0", setTimeout(t, n);
    });
  });
}
function nc(e) {
  let { enter: t, exit: n, appendPosition: r = !1, collapse: i = !0, collapseDuration: o = 300 } = e;
  return function(s) {
    let { children: a, position: c, preventExitTransition: u, done: l, nodeRef: d, isIn: f, playToast: h } = s;
    const g = r ? `${t}--${c}` : t, m = r ? `${n}--${c}` : n, p = Ce(0);
    return Kn(() => {
      const v = d.current, b = g.split(" "), y = (E) => {
        E.target === d.current && (h(), v.removeEventListener("animationend", y), v.removeEventListener("animationcancel", y), p.current === 0 && E.type !== "animationcancel" && v.classList.remove(...b));
      };
      v.classList.add(...b), v.addEventListener("animationend", y), v.addEventListener("animationcancel", y);
    }, []), Ie(() => {
      const v = d.current, b = () => {
        v.removeEventListener("animationend", b), i ? wD(v, l, o) : l();
      };
      f || (u ? b() : (p.current = 1, v.className += ` ${m}`, v.addEventListener("animationend", b)));
    }, [f]), _.createElement(_.Fragment, null, a);
  };
}
function V1(e, t) {
  return e != null ? { content: e.content, containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, status: t } : {};
}
const pt = /* @__PURE__ */ new Map();
let Wo = [];
const Dl = /* @__PURE__ */ new Set(), PD = (e) => Dl.forEach((t) => t(e)), om = () => pt.size > 0;
function sm(e, t) {
  var n;
  if (t) return !((n = pt.get(t)) == null || !n.isToastActive(e));
  let r = !1;
  return pt.forEach((i) => {
    i.isToastActive(e) && (r = !0);
  }), r;
}
function am(e, t) {
  Ol(e) && (om() || Wo.push({ content: e, options: t }), pt.forEach((n) => {
    n.buildToast(e, t);
  }));
}
function k1(e, t) {
  pt.forEach((n) => {
    t != null && t != null && t.containerId ? (t == null ? void 0 : t.containerId) === n.id && n.toggle(e, t == null ? void 0 : t.id) : n.toggle(e, t == null ? void 0 : t.id);
  });
}
function HD(e) {
  const { subscribe: t, getSnapshot: n, setProps: r } = Ce(function(o) {
    const s = o.containerId || 1;
    return { subscribe(a) {
      const c = /* @__PURE__ */ function(l, d, f) {
        let h = 1, g = 0, m = [], p = [], v = [], b = d;
        const y = /* @__PURE__ */ new Map(), E = /* @__PURE__ */ new Set(), C = () => {
          v = Array.from(y.values()), E.forEach((x) => x());
        }, B = (x) => {
          p = x == null ? [] : p.filter((O) => O !== x), C();
        }, I = (x) => {
          const { toastId: O, onOpen: k, updateId: Q, children: F } = x.props, M = Q == null;
          x.staleId && y.delete(x.staleId), y.set(O, x), p = [...p, x.props.toastId].filter((H) => H !== x.staleId), C(), f(V1(x, M ? "added" : "updated")), M && Ht(k) && k(Kr(F) && F.props);
        };
        return { id: l, props: b, observe: (x) => (E.add(x), () => E.delete(x)), toggle: (x, O) => {
          y.forEach((k) => {
            O != null && O !== k.props.toastId || Ht(k.toggle) && k.toggle(x);
          });
        }, removeToast: B, toasts: y, clearQueue: () => {
          g -= m.length, m = [];
        }, buildToast: (x, O) => {
          if (((ee) => {
            let { containerId: Ae, toastId: ne, updateId: K } = ee;
            const ae = Ae ? Ae !== l : l !== 1, pe = y.has(ne) && K == null;
            return ae || pe;
          })(O)) return;
          const { toastId: k, updateId: Q, data: F, staleId: M, delay: H } = O, T = () => {
            B(k);
          }, R = Q == null;
          R && g++;
          const z = { ...b, style: b.toastStyle, key: h++, ...Object.fromEntries(Object.entries(O).filter((ee) => {
            let [Ae, ne] = ee;
            return ne != null;
          })), toastId: k, updateId: Q, data: F, closeToast: T, isIn: !1, className: Ks(O.className || b.toastClassName), bodyClassName: Ks(O.bodyClassName || b.bodyClassName), progressClassName: Ks(O.progressClassName || b.progressClassName), autoClose: !O.isLoading && (L = O.autoClose, X = b.autoClose, L === !1 || jo(L) && L > 0 ? L : X), deleteToast() {
            const ee = y.get(k), { onClose: Ae, children: ne } = ee.props;
            Ht(Ae) && Ae(Kr(ne) && ne.props), f(V1(ee, "removed")), y.delete(k), g--, g < 0 && (g = 0), m.length > 0 ? I(m.shift()) : C();
          } };
          var L, X;
          z.closeButton = b.closeButton, O.closeButton === !1 || Ol(O.closeButton) ? z.closeButton = O.closeButton : O.closeButton === !0 && (z.closeButton = !Ol(b.closeButton) || b.closeButton);
          let W = x;
          Kr(x) && !hr(x.type) ? W = yu(x, { closeToast: T, toastProps: z, data: F }) : Ht(x) && (W = x({ closeToast: T, toastProps: z, data: F }));
          const U = { content: W, props: z, staleId: M };
          b.limit && b.limit > 0 && g > b.limit && R ? m.push(U) : jo(H) ? setTimeout(() => {
            I(U);
          }, H) : I(U);
        }, setProps(x) {
          b = x;
        }, setToggle: (x, O) => {
          y.get(x).toggle = O;
        }, isToastActive: (x) => p.some((O) => O === x), getSnapshot: () => b.newestOnTop ? v.reverse() : v };
      }(s, o, PD);
      pt.set(s, c);
      const u = c.observe(a);
      return Wo.forEach((l) => am(l.content, l.options)), Wo = [], () => {
        u(), pt.delete(s);
      };
    }, setProps(a) {
      var c;
      (c = pt.get(s)) == null || c.setProps(a);
    }, getSnapshot() {
      var a;
      return (a = pt.get(s)) == null ? void 0 : a.getSnapshot();
    } };
  }(e)).current;
  r(e);
  const i = m0(t, n, n);
  return { getToastToRender: function(o) {
    if (!i) return [];
    const s = /* @__PURE__ */ new Map();
    return i.forEach((a) => {
      const { position: c } = a.props;
      s.has(c) || s.set(c, []), s.get(c).push(a);
    }), Array.from(s, (a) => o(a[0], a[1]));
  }, isToastActive: sm, count: i == null ? void 0 : i.length };
}
function OD(e) {
  const [t, n] = q(!1), [r, i] = q(!1), o = Ce(null), s = Ce({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: a, pauseOnHover: c, closeToast: u, onClick: l, closeOnClick: d } = e;
  var f, h;
  function g() {
    n(!0);
  }
  function m() {
    n(!1);
  }
  function p(y) {
    const E = o.current;
    s.canDrag && E && (s.didMove = !0, t && m(), s.delta = e.draggableDirection === "x" ? y.clientX - s.start : y.clientY - s.start, s.start !== y.clientX && (s.canCloseOnClick = !1), E.style.transform = `translate3d(${e.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`},0)`, E.style.opacity = "" + (1 - Math.abs(s.delta / s.removalDistance)));
  }
  function v() {
    document.removeEventListener("pointermove", p), document.removeEventListener("pointerup", v);
    const y = o.current;
    if (s.canDrag && s.didMove && y) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) return i(!0), e.closeToast(), void e.collapseAll();
      y.style.transition = "transform 0.2s, opacity 0.2s", y.style.removeProperty("transform"), y.style.removeProperty("opacity");
    }
  }
  (h = pt.get((f = { id: e.toastId, containerId: e.containerId, fn: n }).containerId || 1)) == null || h.setToggle(f.id, f.fn), Ie(() => {
    if (e.pauseOnFocusLoss) return document.hasFocus() || m(), window.addEventListener("focus", g), window.addEventListener("blur", m), () => {
      window.removeEventListener("focus", g), window.removeEventListener("blur", m);
    };
  }, [e.pauseOnFocusLoss]);
  const b = { onPointerDown: function(y) {
    if (e.draggable === !0 || e.draggable === y.pointerType) {
      s.didMove = !1, document.addEventListener("pointermove", p), document.addEventListener("pointerup", v);
      const E = o.current;
      s.canCloseOnClick = !0, s.canDrag = !0, E.style.transition = "none", e.draggableDirection === "x" ? (s.start = y.clientX, s.removalDistance = E.offsetWidth * (e.draggablePercent / 100)) : (s.start = y.clientY, s.removalDistance = E.offsetHeight * (e.draggablePercent === 80 ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
    }
  }, onPointerUp: function(y) {
    const { top: E, bottom: C, left: B, right: I } = o.current.getBoundingClientRect();
    y.nativeEvent.type !== "touchend" && e.pauseOnHover && y.clientX >= B && y.clientX <= I && y.clientY >= E && y.clientY <= C ? m() : g();
  } };
  return a && c && (b.onMouseEnter = m, e.stacked || (b.onMouseLeave = g)), d && (b.onClick = (y) => {
    l && l(y), s.canCloseOnClick && u();
  }), { playToast: g, pauseToast: m, isRunning: t, preventExitTransition: r, toastRef: o, eventHandlers: b };
}
function DD(e) {
  let { delay: t, isRunning: n, closeToast: r, type: i = "default", hide: o, className: s, style: a, controlledProgress: c, progress: u, rtl: l, isIn: d, theme: f } = e;
  const h = o || c && u === 0, g = { ...a, animationDuration: `${t}ms`, animationPlayState: n ? "running" : "paused" };
  c && (g.transform = `scaleX(${u})`);
  const m = kn("Toastify__progress-bar", c ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${f}`, `Toastify__progress-bar--${i}`, { "Toastify__progress-bar--rtl": l }), p = Ht(s) ? s({ rtl: l, type: i, defaultClassName: m }) : kn(m, s), v = { [c && u >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: c && u < 1 ? null : () => {
    d && r();
  } };
  return _.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": h }, _.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${f} Toastify__progress-bar--${i}` }), _.createElement("div", { role: "progressbar", "aria-hidden": h ? "true" : "false", "aria-label": "notification timer", className: p, style: g, ...v }));
}
let SD = 1;
const cm = () => "" + SD++;
function ND(e) {
  return e && (hr(e.toastId) || jo(e.toastId)) ? e.toastId : cm();
}
function go(e, t) {
  return am(e, t), t.toastId;
}
function wa(e, t) {
  return { ...t, type: t && t.type || e, toastId: ND(t) };
}
function Ls(e) {
  return (t, n) => go(t, wa(e, n));
}
function Ve(e, t) {
  return go(e, wa("default", t));
}
Ve.loading = (e, t) => go(e, wa("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t })), Ve.promise = function(e, t, n) {
  let r, { pending: i, error: o, success: s } = t;
  i && (r = hr(i) ? Ve.loading(i, n) : Ve.loading(i.render, { ...n, ...i }));
  const a = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, c = (l, d, f) => {
    if (d == null) return void Ve.dismiss(r);
    const h = { type: l, ...a, ...n, data: f }, g = hr(d) ? { render: d } : d;
    return r ? Ve.update(r, { ...h, ...g }) : Ve(g.render, { ...h, ...g }), f;
  }, u = Ht(e) ? e() : e;
  return u.then((l) => c("success", s, l)).catch((l) => c("error", o, l)), u;
}, Ve.success = Ls("success"), Ve.info = Ls("info"), Ve.error = Ls("error"), Ve.warning = Ls("warning"), Ve.warn = Ve.warning, Ve.dark = (e, t) => go(e, wa("default", { theme: "dark", ...t })), Ve.dismiss = function(e) {
  (function(t) {
    var n;
    if (om()) {
      if (t == null || hr(n = t) || jo(n)) pt.forEach((r) => {
        r.removeToast(t);
      });
      else if (t && ("containerId" in t || "id" in t)) {
        const r = pt.get(t.containerId);
        r ? r.removeToast(t.id) : pt.forEach((i) => {
          i.removeToast(t.id);
        });
      }
    } else Wo = Wo.filter((r) => t != null && r.options.toastId !== t);
  })(e);
}, Ve.clearWaitingQueue = function(e) {
  e === void 0 && (e = {}), pt.forEach((t) => {
    !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
  });
}, Ve.isActive = sm, Ve.update = function(e, t) {
  t === void 0 && (t = {});
  const n = ((r, i) => {
    var o;
    let { containerId: s } = i;
    return (o = pt.get(s || 1)) == null ? void 0 : o.toasts.get(r);
  })(e, t);
  if (n) {
    const { props: r, content: i } = n, o = { delay: 100, ...r, ...t, toastId: t.toastId || e, updateId: cm() };
    o.toastId !== e && (o.staleId = e);
    const s = o.render || i;
    delete o.render, go(s, o);
  }
}, Ve.done = (e) => {
  Ve.update(e, { progress: 1 });
}, Ve.onChange = function(e) {
  return Dl.add(e), () => {
    Dl.delete(e);
  };
}, Ve.play = (e) => k1(!0, e), Ve.pause = (e) => k1(!1, e);
const TD = typeof window < "u" ? Kn : Ie, Fs = (e) => {
  let { theme: t, type: n, isLoading: r, ...i } = e;
  return _.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...i });
}, ou = { info: function(e) {
  return _.createElement(Fs, { ...e }, _.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(e) {
  return _.createElement(Fs, { ...e }, _.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(e) {
  return _.createElement(Fs, { ...e }, _.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(e) {
  return _.createElement(Fs, { ...e }, _.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return _.createElement("div", { className: "Toastify__spinner" });
} }, RD = (e) => {
  const { isRunning: t, preventExitTransition: n, toastRef: r, eventHandlers: i, playToast: o } = OD(e), { closeButton: s, children: a, autoClose: c, onClick: u, type: l, hideProgressBar: d, closeToast: f, transition: h, position: g, className: m, style: p, bodyClassName: v, bodyStyle: b, progressClassName: y, progressStyle: E, updateId: C, role: B, progress: I, rtl: x, toastId: O, deleteToast: k, isIn: Q, isLoading: F, closeOnClick: M, theme: H } = e, T = kn("Toastify__toast", `Toastify__toast-theme--${H}`, `Toastify__toast--${l}`, { "Toastify__toast--rtl": x }, { "Toastify__toast--close-on-click": M }), R = Ht(m) ? m({ rtl: x, position: g, type: l, defaultClassName: T }) : kn(T, m), z = function(U) {
    let { theme: ee, type: Ae, isLoading: ne, icon: K } = U, ae = null;
    const pe = { theme: ee, type: Ae };
    return K === !1 || (Ht(K) ? ae = K({ ...pe, isLoading: ne }) : Kr(K) ? ae = yu(K, pe) : ne ? ae = ou.spinner() : ((Pe) => Pe in ou)(Ae) && (ae = ou[Ae](pe))), ae;
  }(e), L = !!I || !c, X = { closeToast: f, type: l, theme: H };
  let W = null;
  return s === !1 || (W = Ht(s) ? s(X) : Kr(s) ? yu(s, X) : function(U) {
    let { closeToast: ee, theme: Ae, ariaLabel: ne = "close" } = U;
    return _.createElement("button", { className: `Toastify__close-button Toastify__close-button--${Ae}`, type: "button", onClick: (K) => {
      K.stopPropagation(), ee(K);
    }, "aria-label": ne }, _.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, _.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
  }(X)), _.createElement(h, { isIn: Q, done: k, position: g, preventExitTransition: n, nodeRef: r, playToast: o }, _.createElement("div", { id: O, onClick: u, "data-in": Q, className: R, ...i, style: p, ref: r }, _.createElement("div", { ...Q && { role: B }, className: Ht(v) ? v({ type: l }) : kn("Toastify__toast-body", v), style: b }, z != null && _.createElement("div", { className: kn("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !F }) }, z), _.createElement("div", null, a)), W, _.createElement(DD, { ...C && !L ? { key: `pb-${C}` } : {}, rtl: x, theme: H, delay: c, isRunning: t, isIn: Q, closeToast: f, hide: d, type: l, style: E, className: y, controlledProgress: L, progress: I || 0 })));
}, rc = function(e, t) {
  return t === void 0 && (t = !1), { enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: t };
}, LD = nc(rc("bounce", !0));
nc(rc("slide", !0));
nc(rc("zoom"));
nc(rc("flip"));
const FD = { position: "top-right", transition: LD, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
function QD(e) {
  let t = { ...FD, ...e };
  const n = e.stacked, [r, i] = q(!0), o = Ce(null), { getToastToRender: s, isToastActive: a, count: c } = HD(t), { className: u, style: l, rtl: d, containerId: f } = t;
  function h(m) {
    const p = kn("Toastify__toast-container", `Toastify__toast-container--${m}`, { "Toastify__toast-container--rtl": d });
    return Ht(u) ? u({ position: m, rtl: d, defaultClassName: p }) : kn(p, Ks(u));
  }
  function g() {
    n && (i(!0), Ve.play());
  }
  return TD(() => {
    if (n) {
      var m;
      const p = o.current.querySelectorAll('[data-in="true"]'), v = 12, b = (m = t.position) == null ? void 0 : m.includes("top");
      let y = 0, E = 0;
      Array.from(p).reverse().forEach((C, B) => {
        const I = C;
        I.classList.add("Toastify__toast--stacked"), B > 0 && (I.dataset.collapsed = `${r}`), I.dataset.pos || (I.dataset.pos = b ? "top" : "bot");
        const x = y * (r ? 0.2 : 1) + (r ? 0 : v * B);
        I.style.setProperty("--y", `${b ? x : -1 * x}px`), I.style.setProperty("--g", `${v}`), I.style.setProperty("--s", "" + (1 - (r ? E : 0))), y += I.offsetHeight, E += 0.025;
      });
    }
  }, [r, c, n]), _.createElement("div", { ref: o, className: "Toastify", id: f, onMouseEnter: () => {
    n && (i(!1), Ve.pause());
  }, onMouseLeave: g }, s((m, p) => {
    const v = p.length ? { ...l } : { ...l, pointerEvents: "none" };
    return _.createElement("div", { className: h(m), style: v, key: `container-${m}` }, p.map((b) => {
      let { content: y, props: E } = b;
      return _.createElement(RD, { ...E, stacked: n, collapseAll: g, isIn: a(E.toastId, E.containerId), style: E.style, key: `toast-${E.key}` }, y);
    }));
  }));
}
function XD(e) {
  return e === "connect-success" || e === "connect-warning" || e === "connect-loading" || e === "connect-deleted";
}
function VD(e) {
  if (XD(e)) {
    const t = {};
    switch (e) {
      case "connect-success":
        t.type = "success", t.icon = /* @__PURE__ */ A(
          Y,
          {
            size: 24,
            name: "CheckCircleFill",
            className: "text-green-800"
          }
        );
        break;
      case "connect-warning":
        t.type = "warning", t.icon = /* @__PURE__ */ A(
          Y,
          {
            size: 24,
            name: "WarningFill",
            className: "text-gray-600"
          }
        );
        break;
      case "connect-loading":
        t.type = "default", t.icon = /* @__PURE__ */ A(
          Y,
          {
            size: 24,
            name: "ClockFill",
            className: "text-gray-600"
          }
        );
        break;
      case "connect-deleted":
        t.type = "error", t.icon = /* @__PURE__ */ A(Y, { size: 24, name: "TrashFill", className: "text-red-800" });
        break;
    }
    return t;
  }
  return { type: e };
}
function aL(e, t) {
  const { type: n = "default", ...r } = t || {}, i = VD(n);
  return Ve(e, { ...i, ...r });
}
const kD = ({ closeToast: e }) => /* @__PURE__ */ A(
  "button",
  {
    onClick: e,
    className: "flex items-center text-gray-500 hover:text-gray-600",
    children: /* @__PURE__ */ A(Y, { name: "XmarkLight", size: 16 })
  }
), cL = (e) => /* @__PURE__ */ A(QD, { closeButton: kD, ...e }), MD = Nt(function(t, n) {
  return /* @__PURE__ */ D(
    "label",
    {
      htmlFor: t.id,
      className: "relative cursor-pointer items-center",
      children: [
        /* @__PURE__ */ A(
          "input",
          {
            ref: n,
            type: "checkbox",
            value: "",
            className: "peer sr-only",
            ...t
          }
        ),
        /* @__PURE__ */ A("div", { className: "peer h-6 w-11 rounded-full bg-gray-500 after:absolute after:start-0.5 after:top-0.5 after:size-5 after:rounded-full after:border after:border-none after:bg-gray-50 after:transition-all peer-checked:bg-blue-900 peer-checked:after:translate-x-full peer-focus:outline-none" })
      ]
    }
  );
});
var zD = "VisuallyHidden", um = w.forwardRef(
  (e, t) => /* @__PURE__ */ A(
    Me.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
um.displayName = zD;
var jD = um, [ic, uL] = _n("Tooltip", [
  La
]), oc = La(), lm = "TooltipProvider", WD = 700, Sl = "tooltip.open", [ZD, dA] = ic(lm), dm = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = WD,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: o
  } = e, [s, a] = w.useState(!0), c = w.useRef(!1), u = w.useRef(0);
  return w.useEffect(() => {
    const l = u.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ A(
    ZD,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: w.useCallback(() => {
        window.clearTimeout(u.current), a(!1);
      }, []),
      onClose: w.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => a(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: w.useCallback((l) => {
        c.current = l;
      }, []),
      disableHoverableContent: i,
      children: o
    }
  );
};
dm.displayName = lm;
var sc = "Tooltip", [GD, cs] = ic(sc), Am = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i = !1,
    onOpenChange: o,
    disableHoverableContent: s,
    delayDuration: a
  } = e, c = dA(sc, e.__scopeTooltip), u = oc(t), [l, d] = w.useState(null), f = Mn(), h = w.useRef(0), g = s ?? c.disableHoverableContent, m = a ?? c.delayDuration, p = w.useRef(!1), [v = !1, b] = $o({
    prop: r,
    defaultProp: i,
    onChange: (I) => {
      I ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Sl))) : c.onClose(), o == null || o(I);
    }
  }), y = w.useMemo(() => v ? p.current ? "delayed-open" : "instant-open" : "closed", [v]), E = w.useCallback(() => {
    window.clearTimeout(h.current), p.current = !1, b(!0);
  }, [b]), C = w.useCallback(() => {
    window.clearTimeout(h.current), b(!1);
  }, [b]), B = w.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      p.current = !0, b(!0);
    }, m);
  }, [m, b]);
  return w.useEffect(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ A(J0, { ...u, children: /* @__PURE__ */ A(
    GD,
    {
      scope: t,
      contentId: f,
      open: v,
      stateAttribute: y,
      trigger: l,
      onTriggerChange: d,
      onTriggerEnter: w.useCallback(() => {
        c.isOpenDelayed ? B() : E();
      }, [c.isOpenDelayed, B, E]),
      onTriggerLeave: w.useCallback(() => {
        g ? C() : window.clearTimeout(h.current);
      }, [C, g]),
      onOpen: E,
      onClose: C,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
Am.displayName = sc;
var Nl = "TooltipTrigger", fm = w.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = cs(Nl, n), o = dA(Nl, n), s = oc(n), a = w.useRef(null), c = $e(t, a, i.onTriggerChange), u = w.useRef(!1), l = w.useRef(!1), d = w.useCallback(() => u.current = !1, []);
    return w.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ A(K0, { asChild: !0, ...s, children: /* @__PURE__ */ A(
      Me.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: he(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !l.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: he(e.onPointerLeave, () => {
          i.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: he(e.onPointerDown, () => {
          u.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: he(e.onFocus, () => {
          u.current || i.onOpen();
        }),
        onBlur: he(e.onBlur, i.onClose),
        onClick: he(e.onClick, i.onClose)
      }
    ) });
  }
);
fm.displayName = Nl;
var AA = "TooltipPortal", [qD, YD] = ic(AA, {
  forceMount: void 0
}), gm = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = cs(AA, t);
  return /* @__PURE__ */ A(qD, { scope: t, forceMount: n, children: /* @__PURE__ */ A(Kt, { present: n || o.open, children: /* @__PURE__ */ A(Fa, { asChild: !0, container: i, children: r }) }) });
};
gm.displayName = AA;
var Oi = "TooltipContent", hm = w.forwardRef(
  (e, t) => {
    const n = YD(Oi, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, s = cs(Oi, e.__scopeTooltip);
    return /* @__PURE__ */ A(Kt, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ A(pm, { side: i, ...o, ref: t }) : /* @__PURE__ */ A(UD, { side: i, ...o, ref: t }) });
  }
), UD = w.forwardRef((e, t) => {
  const n = cs(Oi, e.__scopeTooltip), r = dA(Oi, e.__scopeTooltip), i = w.useRef(null), o = $e(t, i), [s, a] = w.useState(null), { trigger: c, onClose: u } = n, l = i.current, { onPointerInTransitChange: d } = r, f = w.useCallback(() => {
    a(null), d(!1);
  }, [d]), h = w.useCallback(
    (g, m) => {
      const p = g.currentTarget, v = { x: g.clientX, y: g.clientY }, b = $D(v, p.getBoundingClientRect()), y = eS(v, b), E = tS(m.getBoundingClientRect()), C = rS([...y, ...E]);
      a(C), d(!0);
    },
    [d]
  );
  return w.useEffect(() => () => f(), [f]), w.useEffect(() => {
    if (c && l) {
      const g = (p) => h(p, l), m = (p) => h(p, c);
      return c.addEventListener("pointerleave", g), l.addEventListener("pointerleave", m), () => {
        c.removeEventListener("pointerleave", g), l.removeEventListener("pointerleave", m);
      };
    }
  }, [c, l, h, f]), w.useEffect(() => {
    if (s) {
      const g = (m) => {
        const p = m.target, v = { x: m.clientX, y: m.clientY }, b = (c == null ? void 0 : c.contains(p)) || (l == null ? void 0 : l.contains(p)), y = !nS(v, s);
        b ? f() : y && (f(), u());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [c, l, s, u, f]), /* @__PURE__ */ A(pm, { ...e, ref: o });
}), [JD, KD] = ic(sc, { isInside: !1 }), pm = w.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: o,
      onPointerDownOutside: s,
      ...a
    } = e, c = cs(Oi, n), u = oc(n), { onClose: l } = c;
    return w.useEffect(() => (document.addEventListener(Sl, l), () => document.removeEventListener(Sl, l)), [l]), w.useEffect(() => {
      if (c.trigger) {
        const d = (f) => {
          const h = f.target;
          h != null && h.contains(c.trigger) && l();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [c.trigger, l]), /* @__PURE__ */ A(
      Sa,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ D(
          _0,
          {
            "data-state": c.stateAttribute,
            ...u,
            ...a,
            ref: t,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ A(x0, { children: r }),
              /* @__PURE__ */ A(JD, { scope: n, isInside: !0, children: /* @__PURE__ */ A(jD, { id: c.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
hm.displayName = Oi;
var mm = "TooltipArrow", _D = w.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = oc(n);
    return KD(
      mm,
      n
    ).isInside ? null : /* @__PURE__ */ A($0, { ...i, ...r, ref: t });
  }
);
_D.displayName = mm;
function $D(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function eS(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function tS(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function nS(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const a = t[o].x, c = t[o].y, u = t[s].x, l = t[s].y;
    c > r != l > r && n < (u - a) * (r - c) / (l - c) + a && (i = !i);
  }
  return i;
}
function rS(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), iS(t);
}
function iS(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], s = t[t.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], s = n[n.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var oS = dm, sS = Am, aS = fm, cS = gm, uS = hm;
function Nr(e) {
  const {
    children: t,
    content: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    className: s,
    ...a
  } = e;
  return /* @__PURE__ */ D(
    sS,
    {
      open: r,
      defaultOpen: i,
      onOpenChange: o,
      delayDuration: 0,
      children: [
        /* @__PURE__ */ A(aS, { asChild: !0, children: t }),
        /* @__PURE__ */ A(cS, { children: /* @__PURE__ */ A(
          uS,
          {
            ...a,
            className: $(
              "rounded-lg border border-gray-200 bg-white p-2 text-xs shadow-tooltip",
              s
            ),
            children: n
          }
        ) })
      ]
    }
  );
}
const vm = oS;
function lS(e) {
  const { uiNode: t, position: n, className: r, getParentNode: i } = e, o = i(t), { isDropTarget: s, dropProps: a } = hA({
    ...e,
    uiNode: o
  });
  return /* @__PURE__ */ A(
    "div",
    {
      ...a,
      className: $(
        "absolute left-0 z-10 flex h-0.5 w-full",
        n === "before" ? "top-0" : "bottom-0",
        s && "bg-blue-800",
        r
      )
    }
  );
}
function bm(e) {
  const {
    uiNode: t,
    nodeOptions: n,
    level: r = 0,
    isAllowedToCreateDocuments: i,
    customDocumentIconSrc: o,
    setSelectedNode: s,
    getIsInSelectedNodePath: a,
    getIsSelected: c,
    onClick: u,
    onAddFolder: l,
    onRenameNode: d,
    onDuplicateNode: f,
    onDeleteNode: h,
    onDeleteDrive: g,
    showDriveSettingsModal: m,
    onAddTrigger: p,
    onRemoveTrigger: v,
    onAddInvalidTrigger: b
  } = e, [y, E] = q(Gt), [C, B] = q(!1), [I, x] = q(!0), [O, k] = q(!1), { dragProps: Q } = gA(e), { isDropTarget: F, dropProps: M } = hA(e), H = 10, T = t.kind !== Je ? t.children : null, R = !!T && T.length > 0, z = c(t), L = a(t), X = C ? I : L, W = t.kind === Ot, U = W && t.sharingType === en, ee = W && t.sharingType === ki, Ae = W && t.sharingType === Tr, ne = tt(), K = $(
    "text-gray-600 transition-colors group-hover/node:text-gray-900",
    z && "text-gray-900"
  ), ae = {
    [Rr]: () => f(t),
    [us]: () => {
      s(t), x(!0), E(Qs);
    },
    [er]: () => E(Jr),
    [Lr]: () => {
      t.kind === Ot ? g(t) : h(t);
    },
    [cc]: () => {
      t.kind === Ot && m(t);
    },
    [ds]: () => p(t.driveId),
    [ls]: () => v(t.driveId),
    [As]: () => b(t.driveId)
  }, pe = n[t.sharingType][t.kind], Pe = Object.entries(fA).map(([be, Le]) => ({
    ...Le,
    id: be
  })).filter((be) => pe.includes(be.id));
  function Qe(be) {
    const Le = ae[be];
    if (!Le) {
      console.error(`No handler found for dropdown menu item: ${be}`);
      return;
    }
    Le(), k(!1);
  }
  function et(be) {
    y === Qs ? (l(be, t), s(t)) : d(be, t), E(Gt);
  }
  const st = (be) => {
    if (be.stopPropagation(), u == null || u(be), y !== Jr) {
      if (s(t), !C) {
        B(!0);
        return;
      }
      x((Le) => !Le);
    }
  };
  function re() {
    E(Gt);
  }
  function Ge() {
    return Ae ? V : ee ? S : U ? P : t.kind === Je ? se : X ? tr : at;
  }
  function tt() {
    return !!(F || y === Jr || y === Qs || O || z);
  }
  const at = /* @__PURE__ */ A(Y, { name: "FolderClose", className: K, size: 20 }), tr = /* @__PURE__ */ A(Y, { name: "FolderOpen", className: K, size: 22 }), se = /* @__PURE__ */ A(
    "img",
    {
      src: Bm(
        t.kind === Je ? t.documentType : ac,
        o
      ),
      alt: "file icon",
      className: "size-7 object-contain"
    }
  ), P = /* @__PURE__ */ A(Y, { name: "Hdd" }), S = /* @__PURE__ */ A(Y, { name: "Server" }), V = "icon" in t && t.icon ? /* @__PURE__ */ A(
    "img",
    {
      src: t.icon,
      className: "size-6 object-contain",
      alt: "drive icon"
    }
  ) : /* @__PURE__ */ A(Y, { name: "M" }), J = /* @__PURE__ */ A(
    Y,
    {
      name: "Caret",
      className: $(
        X && "rotate-90",
        "ease pointer-events-none transition delay-75"
      )
    }
  ), G = /* @__PURE__ */ A("div", { className: "mr-2 w-5 flex-none", children: Ge() }), j = /* @__PURE__ */ D("div", { className: "group/node grid w-full grid-cols-[1fr,auto] items-center justify-between", children: [
    /* @__PURE__ */ A("p", { className: "mr-1 truncate", children: t.name }),
    i && /* @__PURE__ */ A(
      xd,
      {
        open: O,
        onOpenChange: k,
        onItemClick: Qe,
        items: Pe,
        children: /* @__PURE__ */ A(
          "button",
          {
            onClick: (be) => {
              be.stopPropagation(), k(!0);
            },
            className: $(
              "hidden group-hover/node:block",
              O && "block"
            ),
            children: /* @__PURE__ */ A(Y, { name: "VerticalDots", className: "text-gray-600" })
          }
        )
      }
    )
  ] }), oe = /* @__PURE__ */ A(
    Mo,
    {
      defaultValue: t.name,
      onSubmit: et,
      onCancel: re
    }
  ), Ee = /* @__PURE__ */ D(
    "div",
    {
      style: {
        paddingLeft: `${(r + 1) * H + 20}px`
      },
      className: "flex cursor-pointer items-center gap-2 px-1 py-2",
      children: [
        tr,
        /* @__PURE__ */ A(
          Mo,
          {
            defaultValue: "New Folder",
            onSubmit: et,
            onCancel: re
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ D(
      "div",
      {
        ...Q,
        ...M,
        onClick: st,
        className: $(
          "flex cursor-pointer select-none items-center rounded-lg px-1 py-2 text-gray-800 transition-colors hover:bg-gray-300",
          ne && "bg-gray-300 text-gray-900"
        ),
        style: {
          transform: "translate(0, 0)",
          position: "relative",
          paddingLeft: `${r * H + (R ? 0 : 20)}px`
        },
        children: [
          /* @__PURE__ */ A(lS, { ...e, position: "before" }),
          R && J,
          G,
          y === Gt && j,
          y === Jr && oe
        ]
      }
    ),
    /* @__PURE__ */ D(
      "div",
      {
        className: $(
          "max-h-0 overflow-hidden transition-[max-height] duration-300 ease-in-out",
          X && "max-h-screen"
        ),
        children: [
          y === Qs && Ee,
          T == null ? void 0 : T.map((be) => /* @__PURE__ */ bi(
            bm,
            {
              ...e,
              key: be.id,
              uiNode: be,
              level: r + 1
            }
          ))
        ]
      }
    )
  ] });
}
const ym = "powerhouse/budget-statement", ac = "powerhouse/default", Cm = "makerdao/rwa-portfolio", dS = [ym, ac, Cm], Zo = "SWITCHBOARD", en = "LOCAL", ki = "CLOUD", Tr = "PUBLIC", lL = [en, ki, Tr], dL = [en, ki, Zo], AS = "data:image/png;base64,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", fS = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACgCAYAAADjPOUVAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABhoSURBVHgB7V19jBzleX9ndu/D50gYgl05luzDUCWWkYJi8lft1Iji/NEKA5XPTahKVUJksFs+oqrBCr45OyKR2gbiIpcStWqIEhW7aoBKSDFRMcX8FUjrqDYEpQgcBRSfg48o9p1vd2fy/t59n7ln3p3Z752P2/cnrXZmdnZ27+a3z/fzvI7oEUEQOB/e90errnAmdgpX3CB8Z4M8fIN8ZZV8XiUsWsDxnCNHZ0RB4YgOAcJIBMGXP3+l+E31fnng90UgtguLHuDMSBJ5+N+qPfn/FQVBRwRSf+CDt1/hL44+4IrgfmElTB+hSESSaHkRiH4ZYu/uaWGJM0DUSST/30tHci6NEgmkVZXanv/CrsnxMfEf8ndxQ9L5tY2bhL9uffgcrJgQwfiEsIjiI3/9Zy3OiEgi3Idck6jMd0JJIxTz1ZcXe6fukruPSfI0SJ1gxUpR2bpDVD7zWUuWviGYDvZNCeeJOonoRyz0jz1vhCqbB/DlPM9zBfTwX0JliWnzHBBn8ZbbRGXbZ4XFAOAH07X7pkRpSZ2RNsBOx47PIOGEXpV+FvoLyj9gWhrKDeSpbNshFnfcYSVOl2itwpbgS3VGJCJJxO0jQpYSqUzk0fvqubr3jtvcoJE8l2+900qdFOFqdSYR2kRMpcWSKW24ZCzPzMzUZeS+XZOloPQv/CSorPk9+y15soBUZ770fqVZEVFdJJU0ocg+Sl29ucRo+QXrdPad/xKGmz6/52FRu/YTwiIbQBJNnztzgB8LnRwNIk/aJHL1h9a/xL4pxHkm+QlQW/7H1guLrKEM64hZwQxrkkbEKEekZGy79OHz995xDcQlf7F64zartnIEV5MI6oxJn9C9F4w0adlHikD4QuOiHBGR/lWrpbd1u7DIF0CiR6Q6w4+e20VkipAtS87RoFWa+oCFe6Ymx0fF2/yFhd33KAlk0V904sY3A7n4ca+lmQpRRvTISLCdH4T0seTJN5SLL9VZjKoKyDtjsaOB2URKhZVc56/4QUSZLYqAuouvtphNZJLK9Nj6CReJUjNJ6l+7SVgUA2RYk+0DGITBcbUzCHvINdVXTZLHv/JqYVEckGFNRrUZdBT1XFqgidVXEpVLjvNJfqC20QYMiwgdbAR7DuqgMJc8YTZW7/et8tGVHxMhkA0aFhmNEWtII54/YwZ2X4yisrTZJ3kFJTwwi8EBeUVn/qIYHJR3JsT0NFx8J0xRGSfFVGF0BddMXQTW/hkoglUfFYOHzCho70ztGR4Y6r146U4vcBs+eoWt8xkk/HUbRDqQ6ux8VJ0RpqenuW3UkypzhUWqqKbppPj1YCOruCDjWT/17pVZAqWM2vVblB2UHlRRWoM6465+LyQqC4tUAROhumWrGDn5A5EadI31ISEOUpBRG9CiV1gJlAHQxZI2eFEay9iHj24L0iyBMgAi/ZWtWdRZ1W0iMqLVESmFqDy2G5feEigjoNYqm5jbUgIWoBSH3uaZ+7YkkSVQRoAttLDn4UxIxCsbdQ+g6aG1nb23BMoQUGULd92fGYmkTfQItjWRAtruJD7kBPftipz4m799WlikC/fCeTH+5NeE+8GsSBvOkWNxQoQX5zclkpVAOQAk0fwDhzIyrKPqSquy0AZq5ZVZAuUEsIku77xTXNr/jdTLiXm2Hh4aCzK2VGOWQDmDsot23yMuHnoybGzw124YaPSaCNOqBz8O1gYaMphdIbCBWBwotn66mUFtJZCF4HEgeka0mgrPmtlBlkBDjpj6aToeemLNJJBNpg45EioWTfD26YhKsxLIokECgSjcsA5PjJFElkBDDrOmI64In04VMUVolkBDDk4WgKU0IsSKMaTVviWQhWMa0qb64vEhgi4DcSyBhhxQYbw+CCDpQ1WLJnnIFsKzJdCQg8/HBAzp45iRaW1g02hEx7rxQw5eyqH3fSEindAKNNBKS5+wLchKIAszmOg0OS8kjjpRksoSyALEEMbcRZJMsVn5yHDPoiVTnflLwlmQjw/OizSRNOYY38d972x9cRmZSc97Z6+ZTJ1Zs7lknqMlTcDKXcNqRXO7EDYQbhL6qEr//6Z8vCGyQNIPq/R/r4vxo98K9zHdpHLjNlHbvEX4VxVjzgAk0K5du5RYOXr0qK8lkmvYRqatpLZzrcJAnNEXvy8mHn1IjB7/fmbk6QSQRmPPf1dMfO0h9d3xNxQBmzdvDo4dO0ZrfDlJrr2J3BLIlSpqxWNfUcSByioi8N3xN7gpq9tOAGlD6QwtedRxuPaGHRQB2Uu5JBCRB8XmRUe9YP7R3JIIhAFZTp8+DbIIPNNx/RxRY0Qcih3ljkD4R+MfXlSpE4c8k4gIA/UF0kCVEXkA6lwFQCaKByFehOfcEWhMGqTLQfKYwN80xoztvACEIRIRSBrhQb3zPEJNMxhhJ+WKQOXXXimEodwt8LfBk8wTQAyQSG8r8kAaYZ+XeoA0VOrBVVmu4kDwtvIqfZL+L+UfvRJx41sBY5SxfFZWiIsDgTREIr4NkJFtLnRHRMqNBMIvczmqLhN5k0Lc3iEbSPeG0eGAJ1sB6tyAVMoNgcoyIDcsKJ9+TeQFRBRuB0FPUWDRjD6zc9RzbgiEANywwH3v5yIvMG0gAOQhb4wHFEEks146PwR6f3gI5GQwRKEVyBsjNUbbxoBOcuPDVRJzQ6DBDt/OF3Jm60WIgwN8m6ClT0NUupAFZVWZqMRSnEGXyUpk8kdkyABhg2EH1BW57fyYJJUwj8fVRReOQBg2gKEDPeHKq1V5xtj4RLrTUnMIIglLXVDMB1IoVF14zayPhndWuIKyfq7jmsW01LwB0oYnUQG+zWFKIKBwBOrnWmZ2XTQRUVM8hYFtM8XhGeuR5SoO1C76GYQbptBBEogwZDhDIsFaxraZWPVimg4LRyAUafXtWsf7d60ig0scKiojacTiQNygDrcLZ0QjFYCc2eKtd3Y9tQtxmJHXTy7rxG278Fg5q3bdI+UdOo0RHtcIA4mFdONVfc23vykseodWUaFEIbXFvLJIdyq3f3DMNhZamC48SaRAZ+K5FIrYP4AlkEWEQAA6M/iCLGKJPA1LaNrGwiEHN5QpJkR9zdBdPAPv1due+XvtdI5hBwgzNTXl8kpEj3VmGCv7RMa+FDIOZNF/8JiPGYWOiz7zArNC2kBw36s3bhW1td2tcV96/6wonf5xJmtT5A3eUslqpJ2HQQUWkwzpwhEIK9uoZZJ6SENU5cOV2fysFjjJE8jmYSRRgOoi0jBDmpPIKaQKuzx1T19yWLgGrmURbS7EPp4pGm2c11CdWDgCJU3JyPpaRQfvxiBj2ujOaDCGChlIxLCCfo1Q6aVTVHWRvPeuKkwrMnhnqnyoYzzBSvBihisUMpWBArDFW/pTE9RpRSKNmRn57x8sq9Zr7YWp7Zi6IMdMZxAKOaEMGfReM/I0NqaT62Bky8oDe/o2LSQvffKQOrz2x4xKUxzI7EglFNKNVySSj26N6W6K2kdeaSx9RTihtvETaqiU+V3wGag3Kr39ZmzDAIYtoLoy7cXlTMjoc5h5JzuInkkCCea+m25+oXNhWXU34KarKWRtGuGwl8wiflVR8My3REWS7PKtd4qswMlDx3hQMc724Tkxm0ztACCOWu+9Q8kHouHhyvdCcnIiQbKhLml+z/5M5isyYzng6osy8iJm4V1OqtwMVzCb/vMEqCosz92OxIFkaUUwEGj0xWcjQcy0hi7ErFhYZqWqka5UhiDpejYX1gKIfM8/eKgt8qjZiI8+pB7NoFqTEE1n68VDCuH9GSAw66INFz62lDXXI+7ygk7TJmRoKwO6hX2mFtc1SIT3Z9GnRmUc5I3BZ6eaaD6hjHemkktfWBsINyC4crXoBs7c+ZY5sF5zbmqOdYv3EolWPPZI6KnBRqpu2ZaaPUQqC9v0bI5zAagy0TSsC0cg2COXd39BtTf3AtghY89/L7Enf/GW21qSp9n86hXSTQ/GJ4S/boP02LYKf+Om2LnRikTSvsL5dE3Ep9L2zKgeiBMKMSAjeNhgCxWOQLixvZIHgB2CYF5cMBGvtYrPuL84K8a//XhTVYWAY32gVJ1c8LTibCkcw+eRdwZVhmh7GlJI570cFo0O82FIqCa58hSZLpwN1M/AGwY0xKFV+7QaQ4ypqx3GoZoNgzA/My1byPS6yPYBiDws+rzkvudtwFQWiPuFg6CtVNeo9JY6TWfATW92XbzGfxxxke9BwvTCAjNnUUeDbVQ4AvWzHTkumVpppbqk9CmfbhzHB7UKFXVp/zfEpQe/qrYVGbWXBTuoFfhnwxZKc5aiF+0Fi7zG7SCeDytkPdDYM0/1JRGp7B+jtRkSqVW8x4lRW3jfwp/XA42QJMiNYRtjaC49/PfSSH6gLdWL9/BuW5SLDBqwdcw2ZqpSNNfL0K8FbPG54hnRsDuwkEn1emlIj3dnZIIE7i/ebVBDUDMt35vgtYGQSavzVK//lGgXSM6ShEMiNslO6xe412WC10l7bLE5PuausHGgQUx19dso0ueBPwLUjSI1vLfNn5ISaEPXSz1BeglNIJB80EA5B9UCsTiP2vfYsCnAbHH28rReGER/1rMD27npqnRDkiguEFlmGXelyqRE6yRrT+8jpFG0hnIOgMeBkkij10t1cpmNxz/bLUh5KIrxKfCXBJXO0ISqR5z3dyyV0lxrjMeB8AxCocXZCCSGgxXoQG6M6NrHuuvxygKQKPC04tRZHECmFY9/JRWjuFNAhZn1QOTOt1ozDMgNgWA/dDvvJwtAlXEPqxWZIE2QOukEaUSiSYUR+Lph5JlplRZLotyoMOVCSwM0y9G73YQH4GGRl4UYlerU+NFJ6UE1Dq9CSqNVvRC3A7tNFncKGvUL1UUlrdhnwcRAq618BxIRzs9SCvU6LR9SCdJo/t6HVUAx7m9ptdo0D5SmsWgvCANbh/Z5NJq58eCJw5c5AHLX1oNfJpKlGRVWtT3yjpKwzTysbstAEPsJr7E2HbsQ0znIMGalrHwt1bAzQxj5sNzFgRA4ww3KorCK0get3G6Qh1x2WuYbsR9Kljo63REXdPSbOAv4bP6edgKbvYLqoYXOyFODIcgDYsltP+F9atnLXAYSL++s18JkQSJ0TzQjEEjmMklFy3y3g7qjMNH0swkwytNqvTYz8p7ulWdufIP9QzZRbnNhINHlHiaxdgtIlWbGtDKUuwh4ghDNykRUkpYTaGN6fftJ66bqeiC1jnzM2/I/XAHqDAXtaTffNetYVYZyhwVt7ZTHmp/ZzyUdmoFG/PKJ9ZBA1C8WAzpP2di5WjO1GVR138/eVO4xqgEHcX0e6EuqHiRACqFmB98lzmUHahs31d38T29T5a1JgORBkyGhLwvKJCCmrafkGf3wXJWx9VKVyuKpjUINV8AN4DGXfqOeEP1SaMSiXHX+ga8mutJqvhCrW1ZVAqydB258O56YWVbSStUNAjEJVLXNJ5PREDNOHjsnmgHGLQ8hgFDoX283h9WN2w7yjBulse0U8/cTZEDzIZt0TC+uSzGh8D1cCtm+MAbYXJWtS/U3qn8dN7jNCDXZapAirUgQR57Kth2p23u8pYckD1u5kE/8Dd/DSzqsBDIA768+VaNu1xCJ2pmkAbvFbaN3HvGe8X99PFKugfafy7f+qcgCun0ndryL0OUbupSj4X1WAsUA5akIDBJokgYeraRR0zzXB/XroBSEkwfGdhp98XEAOaiQzDhOmw1LfpM0AqkK44VlgbHnvhsbzOzHeBcC1Faaksf0wmbWbC7RNp8LxIKLQZPL5aciMY+AOqutW98wSYPSGPAMa9dtUjmr2AFTmEf9szdiKwsRIIXBPOia53bhJTQQCj3ehaoQSfpo78yxEqgNgAzmXJ9eAKmzuOOOprGhQSFOAnkxQzUBcuObSSFrA7UBVZKKFh0Z22mneCwOdYlzu7h46EmlsrIgTxy0ZOH7IZForQyjxzAy+tdKoC5BAxVUbkwax5j4QUFIkCUYX6EMcdUrpp/zgCQJBHisvRnPVFQWt14GwdpAXYLG1i0X8DogFhtSUshMZ/D3WRU25PAaB4oLPvKXotBxWXkcK3mf3uzxg2nnYSzShZn1d/5w6qBXXzNM7W/fvl3Mzs46R44cUeTB/okTJ9SDoFMZ+WostMgGWtpEcmFCz000B0xRDkxLJHXMEmjIEddQSETiy0B5eqgCwasvf2mXvLSIjnMh8lBfWJIHpjs1rAQadoAourkwcbwvDySai65YCTTkoE4MbMdFpD1jgRVdIxTOErISaMjhsUkbRB49L1q9rtt6GmwhO2jcQoGTh55JKrHCMr5aj9Jf4ZQym8oYLjRLpibBa5JMtSpsyEEqjK+ZSvVA2jZqVg9kVdiwQ6ulSF8YwBec84owH8giO5i5ML6tuzKUJOLemDWiLRTMlmbqVOXQZHF4/Me29VgomEt90zZAZRzN6oEsgYYcZEATgWALUZDQXPYpzhYCgeb4gTQng1qki7h7S3EffixpvbC4yfUull+LfMiCJdByRcwyDe/EpC4iRWWsB4yfE+6UAyc45QRikg5gOnqavdkW6cEcji6pocaRmDkwb2lqmWDDFcI8GKo8KH7kygOR4cVJo0osig9zpSPJjP/Fc5wBTfCi8xF5X7w67tb84FSzD7FYPjCHiFZ8/ydetGU5YuPoGdH0eqSdh7bL50r+c+sC95+XPuRNIdCeUqCh3xat4Uj1xSfAAhf82st4Dof/yNPI9tHjXRwa7yLYcCmeG3MfPFeek3sv8wtj8lYQBMJi+cCUPvL2ntp3YQRGtCrToACiLnENR73w6GGcIe3WR7pGCTR68riwWD6AMEB/P0fV9Q/TOhmmK98ktcHX01DnI5XvrD33059cPbrii3J/HAedakWqsAlRW39t0yikRf4B8mAyyMjrJyPHK4H/0FvXXP/hmTNnVPpizZo16jhUGI6BOCdOnAjQzgOOvPTSS+Kmm26KXNfR4qmEmth/u1occB1xIDxBEujil/9OtelaEhUT6iZL22fin74emYRWE87Tn5sN/oL2zQmtBBjR1B/PXPjIZ7j6AuKtix8cFiwqjajl6PFnwy9iUSzQPRvDaBojgPir6uJB83yqAeLHqHnQdOE5XEgfPJ7ZuO2CH4jD/MXRV4+Hy09bEhUHuFdKdcl7Z6oueY8PwnjGNgQHnwfN7SDW3uwkfQZQ5m8oHTt20N+7a6eMTH+Sjo//5/dEbe36yCABq9Lyichy3DKeh3sXeV1Gnv/kvFDSh2fhzWeWxggrFJkLTzXRQWRONF3w15XKH19RHnlNbq6i1ya+c1hc/OLfqDElSbrQIltw8iCWN/H0YfOUudlq5WYZpFH32lxozmOjXUgqMRc+XOrb01PK9Ot1Nx4gVbbqqWffqfjOl/jFYQ995JvTal6g7/uhiLRqLXvwe1FXW8fFyqe+3pAUXxTB3VBdRB6tvkKJwtWYkc5oGLLJx/wigFTiF92+fbsD9612766IVxZ+kS1bxcIf7BSCTelqZmRZ9B9c2oSQ2QMYzGOvvthwftUPDn3+V84MtjF5A/cX23TPxRJJwpG/RvwnMJc4CDURCISDRCL6gLpr70sSuQ0kUiPfbt4pyfR7Iq5izRJpMDAlPkkdkGb8h8/FluLAaIbdg/tKx1avXq0uxCfT8+5UAsvKh9kOjzUiAqWpqSkHF6fF51944YVQP/77JeflnSuDUyXhYJToOL0JX3TkzP+I0R+/qmb9+RjnJh8Wg0VE8kDivPyCWPmdJ9S9UMHfKOZksnSvlDzKGMJ9nZycdEAeCAsZLAx0sBBqSwUPAezLc1RgEbOBEECUxHGxLWNCkTlBAFjpMgucGu0FMRbS6Jd33Ta5ZuXoD+VXn0z646obPy6q13xcLd/tr8Ko/6sKtQpznqFmLy7Mi/L7Z0X57Z+Kkn5OQuCIU7PSGdr91ty7IAzuJRGH7i/ZOnFlHOxYaP/wWUFcnSkC0ZtMApEqI0M7yS6yyA3mEMsjVx0g8tA+eVg8686rECkWROWrNBtRvu6aA6cABBIddsGIkvWWFmJVj9I/Hjv4YdW9zg8C2/+cL8zBUH6ruvC7N78xe4h+8AAZzBycKABPqHJJxBZaaRgwFZ6DF/XiqhEjSscDFIlom6QRnp+YqEx+dGLsM67r388DjxbpAWU4qKRAGures7UPTTVFoOWczOJ5gBOG1QXRqs0Rl93TwxVIsIRLXuLCJImMeEC4liZ5aNjGl9x3aeSdz533n959Tmw5d7FynYwd3S0jRIfrtUXOO8Kin5jD/7QWiOdrQfAP0ji++/ULs6t3z4qbD/3O5pkD81fNJb2RVJYpXUjrcBuI3HdaH76VN43XfwvGZvVMUGpnZwAAAABJRU5ErkJggg==", gS = "data:image/png;base64,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", M1 = {
  [ym]: AS,
  [ac]: gS,
  [Cm]: fS
}, Ot = "DRIVE", Wt = "FOLDER", Je = "FILE", Qs = "CREATE", Jr = "WRITE", Gt = "READ", Im = "UI_NODE", AL = "NEW", Rr = "DUPLICATE", us = "NEW_FOLDER", er = "RENAME", Lr = "DELETE", cc = "SETTINGS", ls = "REMOVE_TRIGGER", ds = "ADD_TRIGGER", As = "ADD_INVALID_TRIGGER", su = [
  us,
  er,
  cc
], au = [
  er,
  Lr,
  Rr
], cu = [
  us,
  er,
  Lr,
  Rr
], hS = [
  Rr,
  us,
  er,
  Lr,
  cc
], pS = [
  ds,
  ls,
  As
], fL = [...hS, ...pS], mS = [
  {
    value: en,
    icon: /* @__PURE__ */ A(Y, { name: "Lock" }),
    description: "Only available to you"
  },
  {
    value: ki,
    icon: /* @__PURE__ */ A(Y, { name: "People" }),
    description: "Only available to people in this drive"
  },
  {
    value: Tr,
    icon: /* @__PURE__ */ A(Y, { name: "Globe" }),
    description: "Available to everyone",
    disabled: !0
  }
], vS = {
  CLOUD: {
    title: "Secure cloud",
    description: "End to end encryption between members.",
    icon: /* @__PURE__ */ A(Y, { name: "Lock" })
  },
  LOCAL: {
    title: "Local",
    description: "Private and only available to you.",
    icon: /* @__PURE__ */ A(Y, { name: "Hdd" })
  },
  SWITCHBOARD: {
    title: "Switchboard",
    description: "Public and available to everyone.",
    icon: /* @__PURE__ */ A(Y, { name: "Drive" })
  }
}, bS = {
  [ds]: {
    label: "Add Trigger",
    icon: /* @__PURE__ */ A(Y, { name: "Plus", className: "text-orange-900" })
  },
  [ls]: {
    label: "Remove Trigger",
    icon: /* @__PURE__ */ A(Y, { name: "Xmark", className: "text-orange-900" })
  },
  [As]: {
    label: "Add Trigger",
    icon: /* @__PURE__ */ A(Y, { name: "Exclamation", className: "text-orange-900" })
  }
}, yS = {
  [Rr]: {
    label: "Duplicate",
    icon: /* @__PURE__ */ A(Y, { name: "FilesEarmark" })
  },
  [us]: {
    label: "New Folder",
    icon: /* @__PURE__ */ A(Y, { name: "FolderPlus" })
  },
  [er]: {
    label: "Rename",
    icon: /* @__PURE__ */ A(Y, { name: "Pencil" })
  },
  [Lr]: {
    label: "Delete",
    icon: /* @__PURE__ */ A(Y, { name: "Trash" }),
    className: "text-red-900"
  },
  [cc]: {
    label: "Settings",
    icon: /* @__PURE__ */ A(Y, { name: "Gear" })
  }
}, fA = {
  ...bS,
  ...yS
}, Tl = "SYNCING", Pr = "SUCCESS", Rl = "CONFLICT", Ll = "MISSING", Pa = "ERROR", Fl = "INITIAL_SYNC", gL = [
  Fl,
  Tl,
  Pr,
  Rl,
  Ll,
  Pa
], CS = {
  driveNodes: [],
  selectedNode: null,
  selectedNodePath: [],
  selectedDriveNode: null,
  selectedParentNode: null,
  setDriveNodes: () => {
  },
  setSelectedNode: () => {
  },
  getNodeById: () => null,
  getParentNode: () => null,
  getIsSelected: () => !1,
  getIsInSelectedNodePath: () => !1,
  getSiblings: () => []
}, Em = Ml(
  CS
), hL = ({
  children: e
}) => {
  const [t, n] = q([]), [r, i] = q(null), [o, s] = q([]), [a, c] = q(null), [u, l] = q(null), d = me(
    (I, x) => {
      if (!(x != null && x.length)) return null;
      for (const O of x) {
        if (O.id === I) return O;
        const k = O.nodeMap[I];
        if (k) return k;
      }
      return null;
    },
    []
  ), f = me(
    (I) => d(I, t),
    [d, t]
  ), h = me(
    (I, x) => !I || !(x != null && x.length) ? null : I.kind === Ot ? I : x.find((O) => O.id === I.driveId) ?? null,
    []
  ), g = me(
    (I, x) => {
      if (!(x != null && x.length) || I.kind === Ot) return null;
      const O = d(I.parentFolder, x);
      if (!O) return null;
      if (O.kind === Je)
        throw new Error(
          `Parent node ${I.parentFolder} is a file, not a folder`
        );
      return O;
    },
    [d]
  ), m = me(
    (I) => g(I, t),
    [g, t]
  ), p = me(
    (I, x) => !I || !(x != null && x.length) ? null : I.kind === Je ? g(I, x) : I,
    [g]
  ), v = me(
    (I, x) => {
      const O = [], k = x.find((F) => F.id === I.driveId);
      let Q = I;
      for (; Q; )
        O.push(Q), Q = Q.parentFolder === (k == null ? void 0 : k.id) ? k : Q.parentFolder ? k == null ? void 0 : k.nodeMap[Q.parentFolder] : void 0;
      return O.reverse();
    },
    []
  ), b = me(
    (I) => {
      if (!I) return;
      if (i(I), c(h(I, t)), l(p(I, t)), I.kind === Ot) {
        s([I]);
        return;
      }
      const x = v(I, t);
      s(x);
    },
    [
      t,
      v,
      h,
      p
    ]
  ), y = me(
    (I) => r === I,
    [r]
  ), E = me(
    (I) => I.kind === Je ? !1 : o.includes(I),
    [o]
  ), C = me(
    (I) => {
      if (I.kind === Ot)
        return console.warn(
          "Drive nodes do not have siblings, as they are top-level nodes"
        ), [];
      const x = g(I, t);
      return (x == null ? void 0 : x.children) ?? [];
    },
    [g, t]
  );
  Ie(() => {
    if (!r) return;
    const I = d(r.id, t);
    I && b(I);
  }, [t, d, r, b]);
  const B = ve(
    () => ({
      driveNodes: t,
      selectedNode: r,
      selectedNodePath: o,
      selectedDriveNode: a,
      selectedParentNode: u,
      getNodeById: f,
      getParentNode: m,
      setDriveNodes: n,
      setSelectedNode: b,
      getIsSelected: y,
      getIsInSelectedNodePath: E,
      getSiblings: C
    }),
    [
      t,
      r,
      o,
      a,
      u,
      f,
      m,
      b,
      y,
      E,
      C
    ]
  );
  return /* @__PURE__ */ A(Em.Provider, { value: B, children: e });
}, pL = () => Oa(Em), z1 = /* @__PURE__ */ kx({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), IS = yB({
  chains: [z1],
  transports: {
    [z1.id]: qx()
  }
}), ES = new jB();
function mL(e) {
  const { children: t, wagmiProviderProps: n, queryClientProviderProps: r } = e, { config: i = IS, ...o } = n ?? {}, { client: s = ES, ...a } = r ?? {};
  return /* @__PURE__ */ A(EB, { config: i, ...o, children: /* @__PURE__ */ A(ew, { client: s, ...a, children: t }) });
}
function gA(e) {
  const { uiNode: t } = e, [n, r] = q(!1), i = me(
    (a) => {
      a.dataTransfer.setData(Im, JSON.stringify(t));
    },
    [t]
  ), o = me(() => {
    r(!1);
  }, []), s = !!t && t.kind !== Ot;
  return ve(() => ({
    isDragging: n,
    dragProps: s ? {
      draggable: !0,
      onDragStart: i,
      onDragEnd: o
    } : {
      draggable: !1,
      onDragStart: void 0,
      onDragEnd: void 0
    }
  }), [s, n, o, i]);
}
function hA(e) {
  const { uiNode: t, onAddFile: n, onCopyNode: r, onMoveNode: i } = e, [o, s] = q(!1), a = !!t && t.kind !== Je, c = me((d) => {
    d.preventDefault(), s(!0);
  }, []), u = me(() => {
    s(!1);
  }, []), l = me(
    async (d) => {
      if (d.preventDefault(), d.stopPropagation(), !t) return;
      const f = xS(d.dataTransfer.items);
      if (f.length)
        for await (const h of f)
          await n(h, t);
      else {
        const h = d.getModifierState("Alt"), g = d.dataTransfer.getData(Im), m = JSON.parse(g);
        h ? await r(m, t) : await i(m, t);
      }
      s(!1);
    },
    [n, r, i, t]
  );
  return ve(() => ({
    isDropTarget: o,
    dropProps: a ? { onDragOver: c, onDragLeave: u, onDrop: l } : {
      onDragOver: void 0,
      onDragLeave: void 0,
      onDrop: void 0
    }
  }), [a, o, u, c, l]);
}
function xS(e) {
  return Array.from(e).map((n) => n.kind === "file" ? n.getAsFile() : null).filter(Boolean);
}
function xm(e) {
  return `${e.slice(0, 7)}...${e.slice(-5)}`;
}
function Bm(e, t) {
  return t || (dS.includes(e) ? M1[e] : M1[ac]);
}
const vL = (e, t) => {
  for (const n of t)
    if (n.path.startsWith(e))
      return n.status || "SUCCESS";
  return "SUCCESS";
}, bL = (e) => e.sort((t, n) => {
  const r = [
    "ERROR",
    "CONFLICT",
    "SYNCING",
    "MISSING",
    "SYNCING",
    "SUCCESS"
  ];
  return r.indexOf(t.status || "SUCCESS") - r.indexOf(n.status || "SUCCESS");
}), yL = (e) => e.filter((t) => t.status !== "SUCCESS"), Di = "mock-drive-id", CL = {
  kind: Je,
  documentType: "makerdao/rwa-portfolio",
  id: "file-1",
  name: "Mock file in drive",
  slug: "mock-file-in-drive",
  parentFolder: Di,
  driveId: Di,
  syncStatus: Pr,
  synchronizationUnits: [{ syncId: "1", scope: "global", branch: "main" }],
  sharingType: en
}, IL = {
  kind: Wt,
  id: "folder-1",
  name: "Mock folder in drive",
  slug: "mock-folder-in-drive",
  parentFolder: Di,
  driveId: Di,
  syncStatus: Pr,
  children: [],
  sharingType: en
}, BS = (e) => [
  {
    kind: Je,
    documentType: "makerdao/rwa-portfolio",
    id: "file-1",
    name: "Mock file in drive that has a very significantly long name",
    parentFolder: e,
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Wt,
    id: "folder-1",
    name: "Mock folder in drive 1",
    parentFolder: e
  },
  {
    kind: Wt,
    id: "folder-2",
    name: "Mock folder in drive 2",
    parentFolder: e
  },
  {
    kind: Je,
    documentType: "template",
    id: "folder-1-file-1",
    name: "Mock file in folder 1",
    parentFolder: "folder-1",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Je,
    documentType: "global",
    id: "folder-2-file-2",
    name: "Mock file in folder 2",
    parentFolder: "folder-2",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Wt,
    id: "folder-1-folder-1",
    name: "Mock folder in folder 1",
    parentFolder: "folder-1"
  },
  {
    kind: Wt,
    id: "folder-2-folder-1",
    name: "Mock folder in folder 2",
    parentFolder: "folder-2"
  },
  {
    kind: Je,
    documentType: "legal",
    id: "folder-1-folder-1-file-1",
    name: "Mock file in folder 1 folder 1",
    parentFolder: "folder-1-folder-1",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Je,
    documentType: "budget",
    id: "folder-2-folder-1-file-1",
    name: "Mock file in folder 2 folder 1",
    parentFolder: "folder-2",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Wt,
    id: "folder-1-folder-1-folder-1",
    name: "Mock folder in folder 1 folder 1",
    parentFolder: "folder-1-folder-1"
  },
  {
    kind: Wt,
    id: "folder-2-folder-1-folder-1",
    name: "Mock folder in folder 2 folder 1",
    parentFolder: "folder-2-folder-1"
  }
];
function pA(e) {
  var n, r;
  return {
    state: {
      global: {
        id: ((n = e == null ? void 0 : e.global) == null ? void 0 : n.id) ?? Di,
        slug: "mock-drive",
        name: "Mock Drive",
        icon: "",
        nodes: BS(((r = e == null ? void 0 : e.global) == null ? void 0 : r.id) ?? Di),
        ...e == null ? void 0 : e.global
      },
      local: {
        sharingType: en,
        availableOffline: !1,
        ...e == null ? void 0 : e.local
      }
    }
  };
}
const wS = mA(
  pA({
    global: {
      id: "local-drive",
      name: "Local drive"
    },
    local: { sharingType: en, availableOffline: !1 }
  })
), PS = mA(
  pA({
    global: {
      id: "public-drive",
      name: "Public drive"
    },
    local: { sharingType: Tr, availableOffline: !0 }
  })
), HS = mA(
  pA({
    global: {
      id: "cloud-drive",
      name: "Cloud drive"
    },
    local: { sharingType: ki, availableOffline: !0 }
  })
), EL = [PS, HS, wS], xL = {
  [Tr]: {
    [Ot]: [...su],
    [Wt]: [...cu],
    [Je]: [...au]
  },
  [ki]: {
    [Ot]: [...su],
    [Wt]: [...cu],
    [Je]: [...au]
  },
  [en]: {
    [Ot]: [...su],
    [Wt]: [...cu],
    [Je]: [...au]
  }
};
function j1(e, t) {
  if (t !== en)
    try {
      return Pr;
    } catch (n) {
      return console.error(n), Pa;
    }
}
function mA(e) {
  const { id: t, name: n, icon: r, slug: i } = e.state.global, { sharingType: o, availableOffline: s } = e.state.local, a = j1(t, o), c = {
    id: t,
    name: n,
    slug: i || null,
    kind: Ot,
    children: [],
    nodeMap: {},
    sharingType: o,
    syncStatus: a,
    availableOffline: s,
    icon: r,
    parentFolder: null,
    driveId: t
  }, u = e.state.global.nodes.map((l) => {
    const d = {
      ...l,
      slug: l.name.toLowerCase().replace(/\s/g, "-"),
      driveId: t,
      parentFolder: l.parentFolder || t,
      syncStatus: a,
      sharingType: o
    };
    if (d.kind === Ot)
      throw new Error("Drive nodes should not be nested");
    return d.kind === Je ? d : {
      ...d,
      children: []
    };
  });
  for (const l of u)
    c.nodeMap[l.id] = l;
  for (const l of u) {
    if (l.kind === Je && (l.syncStatus = j1(
      l.synchronizationUnits[0].syncId,
      o
    )), l.parentFolder === t) {
      c.children.push(l);
      continue;
    }
    const d = c.nodeMap[l.parentFolder];
    if (d.kind === Je)
      throw new Error(
        `Parent node ${l.parentFolder} is a file, not a folder`
      );
    d.children.push(l), l.syncStatus !== Pr && (d.syncStatus = l.syncStatus);
  }
  return c;
}
const uu = (e) => /* @__PURE__ */ A(
  Et,
  {
    color: "light",
    size: "small",
    ...rt(
      e,
      "border border-solid border-gray-300 bg-white px-3 py-1 text-sm text-gray-900"
    ),
    children: e.children
  }
);
function Mi(e) {
  const { inputs: t } = e;
  return /* @__PURE__ */ A("div", { className: "bg-white text-xs font-medium", children: t.map(({ label: n, Input: r, inputLabel: i }, o) => /* @__PURE__ */ D(
    "div",
    {
      className: Or(
        "grid min-h-11 grid-cols-[208px,380px] items-center px-6 text-gray-600",
        o % 2 !== 0 && "bg-gray-50"
      ),
      children: [
        /* @__PURE__ */ A("div", { children: n }),
        /* @__PURE__ */ D("div", { className: "h-max py-2 text-gray-900", children: [
          /* @__PURE__ */ A(r, {}),
          i && /* @__PURE__ */ A("div", { className: "text-left text-gray-500", children: i })
        ] }, o)
      ]
    },
    n
  )) });
}
const BL = ({
  label: e,
  value: t,
  ...n
}) => /* @__PURE__ */ D("div", { ...rt(n, "flex items-center px-6 text-xs"), children: [
  /* @__PURE__ */ A("div", { className: "text-gray-600", children: e }),
  /* @__PURE__ */ A("div", { className: "text-gray-900", children: t || "--" })
] });
function wm(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
var Go;
(function(e) {
  e.event = "event", e.props = "prop";
})(Go || (Go = {}));
function Tn() {
}
function OS(e) {
  var t, n = void 0;
  return function() {
    for (var r = [], i = arguments.length; i--; ) r[i] = arguments[i];
    return t && r.length === t.length && r.every(function(o, s) {
      return o === t[s];
    }) || (t = r, n = e.apply(void 0, r)), n;
  };
}
function qo(e) {
  return !!(e || "").match(/\d/);
}
function oi(e) {
  return e == null;
}
function DS(e) {
  return typeof e == "number" && isNaN(e);
}
function Pm(e) {
  return oi(e) || DS(e) || typeof e == "number" && !isFinite(e);
}
function Hm(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function SS(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function NS(e, t, n) {
  var r = SS(n), i = e.search(/[1-9]/);
  return i = i === -1 ? e.length : i, e.substring(0, i) + e.substring(i, e.length).replace(r, "$1" + t);
}
function TS(e) {
  var t = Ce(e);
  t.current = e;
  var n = Ce(function() {
    for (var r = [], i = arguments.length; i--; ) r[i] = arguments[i];
    return t.current.apply(t, r);
  });
  return n.current;
}
function vA(e, t) {
  t === void 0 && (t = !0);
  var n = e[0] === "-", r = n && t;
  e = e.replace("-", "");
  var i = e.split("."), o = i[0], s = i[1] || "";
  return {
    beforeDecimal: o,
    afterDecimal: s,
    hasNegation: n,
    addNegation: r
  };
}
function RS(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var n = e.split("."), r = n[0].replace(/^0+/, "") || "0", i = n[1] || "";
  return (t ? "-" : "") + r + (i ? "." + i : "");
}
function Om(e, t, n) {
  for (var r = "", i = n ? "0" : "", o = 0; o <= t - 1; o++)
    r += e[o] || i;
  return r;
}
function W1(e, t) {
  return Array(t + 1).join(e);
}
function Dm(e) {
  var t = e + "", n = t[0] === "-" ? "-" : "";
  n && (t = t.substring(1));
  var r = t.split(/[eE]/g), i = r[0], o = r[1];
  if (o = Number(o), !o)
    return n + i;
  i = i.replace(".", "");
  var s = 1 + o, a = i.length;
  return s < 0 ? i = "0." + W1("0", Math.abs(s)) + i : s >= a ? i = i + W1("0", s - a) : i = (i.substring(0, s) || "0") + "." + i.substring(s), n + i;
}
function Z1(e, t, n) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var r = (e.indexOf(".") !== -1 || n) && t, i = vA(e), o = i.beforeDecimal, s = i.afterDecimal, a = i.hasNegation, c = parseFloat("0." + (s || "0")), u = s.length <= t ? "0." + s : c.toFixed(t), l = u.split("."), d = o;
  o && Number(l[0]) && (d = o.split("").reverse().reduce(function(m, p, v) {
    return m.length > v ? (Number(m[0]) + Number(p)).toString() + m.substring(1, m.length) : p + m;
  }, l[0]));
  var f = Om(l[1] || "", t, n), h = a ? "-" : "", g = r ? "." : "";
  return "" + h + d + g + f;
}
function or(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var n = e.createTextRange();
      return n.move("character", t), n.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var Sm = OS(function(e, t) {
  for (var n = 0, r = 0, i = e.length, o = t.length; e[n] === t[n] && n < i; )
    n++;
  for (; e[i - 1 - r] === t[o - 1 - r] && o - r > n && i - r > n; )
    r++;
  return {
    from: { start: n, end: i - r },
    to: { start: n, end: o - r }
  };
}), LS = function(e, t) {
  var n = Math.min(e.selectionStart, t);
  return {
    from: { start: n, end: e.selectionEnd },
    to: { start: n, end: t }
  };
};
function FS(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function lu(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function QS() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function XS(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function VS(e) {
  var t = e.currentValue, n = e.formattedValue, r = e.currentValueIndex, i = e.formattedValueIndex;
  return t[r] === n[i];
}
function kS(e, t, n, r, i, o, s) {
  s === void 0 && (s = VS);
  var a = i.findIndex(function(E) {
    return E;
  }), c = e.slice(0, a);
  !t && !n.startsWith(c) && (t = c, n = c + n, r = r + c.length);
  for (var u = n.length, l = e.length, d = {}, f = new Array(u), h = 0; h < u; h++) {
    f[h] = -1;
    for (var g = 0, m = l; g < m; g++) {
      var p = s({
        currentValue: n,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: h,
        formattedValueIndex: g
      });
      if (p && d[g] !== !0) {
        f[h] = g, d[g] = !0;
        break;
      }
    }
  }
  for (var v = r; v < u && (f[v] === -1 || !o(n[v])); )
    v++;
  var b = v === u || f[v] === -1 ? l : f[v];
  for (v = r - 1; v > 0 && f[v] === -1; )
    v--;
  var y = v === -1 || f[v] === -1 ? 0 : f[v] + 1;
  return y > b ? b : r - y < b - r ? y : b;
}
function G1(e, t, n, r) {
  var i = e.length;
  if (t = FS(t, 0, i), r === "left") {
    for (; t >= 0 && !n[t]; )
      t--;
    t === -1 && (t = n.indexOf(!0));
  } else {
    for (; t <= i && !n[t]; )
      t++;
    t > i && (t = n.lastIndexOf(!0));
  }
  return t === -1 && (t = i), t;
}
function MS(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), n = 0, r = t.length; n < r; n++)
    t[n] = !!(qo(e[n]) || qo(e[n - 1]));
  return t;
}
function Nm(e, t, n, r, i, o) {
  o === void 0 && (o = Tn);
  var s = TS(function(g, m) {
    var p, v;
    return Pm(g) ? (v = "", p = "") : typeof g == "number" || m ? (v = typeof g == "number" ? Dm(g) : g, p = r(v)) : (v = i(g, void 0), p = r(v)), { formattedValue: p, numAsString: v };
  }), a = q(function() {
    return s(oi(e) ? t : e, n);
  }), c = a[0], u = a[1], l = function(g, m) {
    g.formattedValue !== c.formattedValue && u({
      formattedValue: g.formattedValue,
      numAsString: g.value
    }), o(g, m);
  }, d = e, f = n;
  oi(e) && (d = c.numAsString, f = !0);
  var h = s(d, f);
  return ve(function() {
    u(h);
  }, [h.formattedValue]), [c, l];
}
function zS(e) {
  return e.replace(/[^0-9]/g, "");
}
function jS(e) {
  return e;
}
function WS(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var n = e.displayType;
  n === void 0 && (n = "input");
  var r = e.customInput, i = e.renderText, o = e.getInputRef, s = e.format;
  s === void 0 && (s = jS);
  var a = e.removeFormatting;
  a === void 0 && (a = zS);
  var c = e.defaultValue, u = e.valueIsNumericString, l = e.onValueChange, d = e.isAllowed, f = e.onChange;
  f === void 0 && (f = Tn);
  var h = e.onKeyDown;
  h === void 0 && (h = Tn);
  var g = e.onMouseUp;
  g === void 0 && (g = Tn);
  var m = e.onFocus;
  m === void 0 && (m = Tn);
  var p = e.onBlur;
  p === void 0 && (p = Tn);
  var v = e.value, b = e.getCaretBoundary;
  b === void 0 && (b = MS);
  var y = e.isValidInputCharacter;
  y === void 0 && (y = qo);
  var E = e.isCharacterSame, C = wm(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), B = Nm(v, c, !!u, s, a, l), I = B[0], x = I.formattedValue, O = I.numAsString, k = B[1], Q = Ce(), F = Ce({ formattedValue: x, numAsString: O }), M = function(se, P) {
    F.current = { formattedValue: se.formattedValue, numAsString: se.value }, k(se, P);
  }, H = q(!1), T = H[0], R = H[1], z = Ce(null), L = Ce({
    setCaretTimeout: null,
    focusTimeout: null
  });
  Ie(function() {
    return R(!0), function() {
      clearTimeout(L.current.setCaretTimeout), clearTimeout(L.current.focusTimeout);
    };
  }, []);
  var X = s, W = function(se, P) {
    var S = parseFloat(P);
    return {
      formattedValue: se,
      value: P,
      floatValue: isNaN(S) ? void 0 : S
    };
  }, U = function(se, P, S) {
    se.selectionStart === 0 && se.selectionEnd === se.value.length || (or(se, P), L.current.setCaretTimeout = setTimeout(function() {
      se.value === S && se.selectionStart !== P && or(se, P);
    }, 0));
  }, ee = function(se, P, S) {
    return G1(se, P, b(se), S);
  }, Ae = function(se, P, S) {
    var V = b(P), J = kS(P, x, se, S, V, y, E);
    return J = G1(P, J, V), J;
  }, ne = function(se) {
    var P = se.formattedValue;
    P === void 0 && (P = "");
    var S = se.input, V = se.source, J = se.event, G = se.numAsString, j;
    if (S) {
      var oe = se.inputValue || S.value, Ee = lu(S);
      S.value = P, j = Ae(oe, P, Ee), j !== void 0 && U(S, j, P);
    }
    P !== x && M(W(P, G), { event: J, source: V });
  };
  Ie(function() {
    var se = F.current, P = se.formattedValue, S = se.numAsString;
    (x !== P || O !== S) && M(W(x, O), {
      event: void 0,
      source: Go.props
    });
  }, [x, O]);
  var K = z.current ? lu(z.current) : void 0, ae = typeof window < "u" ? Kn : Ie;
  ae(function() {
    var se = z.current;
    if (x !== F.current.formattedValue && se) {
      var P = Ae(F.current.formattedValue, x, K);
      se.value = x, U(se, P, x);
    }
  }, [x]);
  var pe = function(se, P, S) {
    var V = P.target, J = Q.current ? LS(Q.current, V.selectionEnd) : Sm(x, se), G = Object.assign(Object.assign({}, J), { lastValue: x }), j = a(se, G), oe = X(j);
    if (j = a(oe, void 0), d && !d(W(oe, j))) {
      var Ee = P.target, be = lu(Ee), Le = Ae(se, x, be);
      return Ee.value = x, U(Ee, Le, x), !1;
    }
    return ne({
      formattedValue: oe,
      numAsString: j,
      inputValue: se,
      event: P,
      source: S,
      input: P.target
    }), !0;
  }, Pe = function(se, P) {
    P === void 0 && (P = 0);
    var S = se.selectionStart, V = se.selectionEnd;
    Q.current = { selectionStart: S, selectionEnd: V + P };
  }, Qe = function(se) {
    var P = se.target, S = P.value, V = pe(S, se, Go.event);
    V && f(se), Q.current = void 0;
  }, et = function(se) {
    var P = se.target, S = se.key, V = P.selectionStart, J = P.selectionEnd, G = P.value;
    G === void 0 && (G = "");
    var j;
    S === "ArrowLeft" || S === "Backspace" ? j = Math.max(V - 1, 0) : S === "ArrowRight" ? j = Math.min(V + 1, G.length) : S === "Delete" && (j = V);
    var oe = 0;
    S === "Delete" && V === J && (oe = 1);
    var Ee = S === "ArrowLeft" || S === "ArrowRight";
    if (j === void 0 || V !== J && !Ee) {
      h(se), Pe(P, oe);
      return;
    }
    var be = j;
    if (Ee) {
      var Le = S === "ArrowLeft" ? "left" : "right";
      be = ee(G, j, Le), be !== j && se.preventDefault();
    } else S === "Delete" && !y(G[j]) ? be = ee(G, j, "right") : S === "Backspace" && !y(G[j]) && (be = ee(G, j, "left"));
    be !== j && U(P, be, G), h(se), Pe(P, oe);
  }, st = function(se) {
    var P = se.target, S = function() {
      var V = P.selectionStart, J = P.selectionEnd, G = P.value;
      if (G === void 0 && (G = ""), V === J) {
        var j = ee(G, V);
        j !== V && U(P, j, G);
      }
    };
    S(), requestAnimationFrame(function() {
      S();
    }), g(se), Pe(P);
  }, re = function(se) {
    se.persist && se.persist();
    var P = se.target, S = se.currentTarget;
    z.current = P, L.current.focusTimeout = setTimeout(function() {
      var V = P.selectionStart, J = P.selectionEnd, G = P.value;
      G === void 0 && (G = "");
      var j = ee(G, V);
      j !== V && !(V === 0 && J === G.length) && U(P, j, G), m(Object.assign(Object.assign({}, se), { currentTarget: S }));
    }, 0);
  }, Ge = function(se) {
    z.current = null, clearTimeout(L.current.focusTimeout), clearTimeout(L.current.setCaretTimeout), p(se);
  }, tt = T && QS() ? "numeric" : void 0, at = Object.assign({ inputMode: tt }, C, {
    type: t,
    value: x,
    onChange: Qe,
    onKeyDown: et,
    onMouseUp: st,
    onFocus: re,
    onBlur: Ge
  });
  if (n === "text")
    return i ? _.createElement(_.Fragment, null, i(x, C) || null) : _.createElement("span", Object.assign({}, C, { ref: o }), x);
  if (r) {
    var tr = r;
    return _.createElement(tr, Object.assign({}, at, { ref: o }));
  }
  return _.createElement("input", Object.assign({}, at, { ref: o }));
}
function q1(e, t) {
  var n = t.decimalScale, r = t.fixedDecimalScale, i = t.prefix;
  i === void 0 && (i = "");
  var o = t.suffix;
  o === void 0 && (o = "");
  var s = t.allowNegative, a = t.thousandsGroupStyle;
  if (a === void 0 && (a = "thousand"), e === "" || e === "-")
    return e;
  var c = uc(t), u = c.thousandSeparator, l = c.decimalSeparator, d = n !== 0 && e.indexOf(".") !== -1 || n && r, f = vA(e, s), h = f.beforeDecimal, g = f.afterDecimal, m = f.addNegation;
  return n !== void 0 && (g = Om(g, n, !!r)), u && (h = NS(h, u, a)), i && (h = i + h), o && (g = g + o), m && (h = "-" + h), e = h + (d && l || "") + g, e;
}
function uc(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var n = e.thousandSeparator, r = e.allowedDecimalSeparators;
  return n === !0 && (n = ","), r || (r = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: n,
    allowedDecimalSeparators: r
  };
}
function ZS(e, t) {
  e === void 0 && (e = "");
  var n = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), i = n.test(e), o = r.test(e);
  return e = e.replace(/-/g, ""), i && !o && t && (e = "-" + e), e;
}
function GS(e, t) {
  return new RegExp("(^-)|[0-9]|" + Hm(e), "g");
}
function qS(e, t, n) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(n != null && n.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function YS(e, t, n) {
  var r;
  t === void 0 && (t = XS(e));
  var i = n.allowNegative, o = n.prefix;
  o === void 0 && (o = "");
  var s = n.suffix;
  s === void 0 && (s = "");
  var a = n.decimalScale, c = t.from, u = t.to, l = u.start, d = u.end, f = uc(n), h = f.allowedDecimalSeparators, g = f.decimalSeparator, m = e[d] === g;
  if (qo(e) && (e === o || e === s) && t.lastValue === "")
    return e;
  if (d - l === 1 && h.indexOf(e[l]) !== -1) {
    var p = a === 0 ? "" : g;
    e = e.substring(0, l) + p + e.substring(l + 1, e.length);
  }
  var v = function(z, L, X) {
    var W = !1, U = !1;
    o.startsWith("-") ? W = !1 : z.startsWith("--") ? (W = !1, U = !0) : s.startsWith("-") && z.length === s.length ? W = !1 : z[0] === "-" && (W = !0);
    var ee = W ? 1 : 0;
    return U && (ee = 2), ee && (z = z.substring(ee), L -= ee, X -= ee), { value: z, start: L, end: X, hasNegation: W };
  }, b = v(e, l, d), y = b.hasNegation;
  r = b, e = r.value, l = r.start, d = r.end;
  var E = v(t.lastValue, c.start, c.end), C = E.start, B = E.end, I = E.value, x = e.substring(l, d);
  e.length && I.length && (C > I.length - s.length || B < o.length) && !(x && s.startsWith(x)) && (e = I);
  var O = 0;
  e.startsWith(o) ? O += o.length : l < o.length && (O = l), e = e.substring(O), d -= O;
  var k = e.length, Q = e.length - s.length;
  e.endsWith(s) ? k = Q : (d > Q || d > e.length - s.length) && (k = d), e = e.substring(0, k), e = ZS(y ? "-" + e : e, i), e = (e.match(GS(g)) || []).join("");
  var F = e.indexOf(g);
  e = e.replace(new RegExp(Hm(g), "g"), function(z, L) {
    return L === F ? "." : "";
  });
  var M = vA(e, i), H = M.beforeDecimal, T = M.afterDecimal, R = M.addNegation;
  return u.end - u.start < c.end - c.start && H === "" && m && !parseFloat(T) && (e = R ? "-" : ""), e;
}
function US(e, t) {
  var n = t.prefix;
  n === void 0 && (n = "");
  var r = t.suffix;
  r === void 0 && (r = "");
  var i = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), o = e[0] === "-";
  i.fill(!1, 0, n.length + (o ? 1 : 0));
  var s = e.length;
  return i.fill(!1, s - r.length + 1, s + 1), i;
}
function JS(e) {
  var t = uc(e), n = t.thousandSeparator, r = t.decimalSeparator, i = e.prefix;
  i === void 0 && (i = "");
  var o = e.allowNegative;
  if (o === void 0 && (o = !0), n === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + n + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
  return i.startsWith("-") && o && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + i + `
      allowNegative: ` + o + `
    `), o = !1), Object.assign(Object.assign({}, e), { allowNegative: o });
}
function KS(e) {
  e = JS(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, n = e.allowNegative, r = e.allowLeadingZeros, i = e.onKeyDown;
  i === void 0 && (i = Tn);
  var o = e.onBlur;
  o === void 0 && (o = Tn);
  var s = e.thousandSeparator, a = e.decimalScale, c = e.fixedDecimalScale, u = e.prefix;
  u === void 0 && (u = "");
  var l = e.defaultValue, d = e.value, f = e.valueIsNumericString, h = e.onValueChange, g = wm(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), m = uc(e), p = m.decimalSeparator, v = m.allowedDecimalSeparators, b = function(R) {
    return q1(R, e);
  }, y = function(R, z) {
    return YS(R, z, e);
  }, E = oi(d) ? l : d, C = f ?? qS(E, u, t);
  oi(d) ? oi(l) || (C = C || typeof l == "number") : C = C || typeof d == "number";
  var B = function(R) {
    return Pm(R) ? R : (typeof R == "number" && (R = Dm(R)), C && typeof a == "number" ? Z1(R, a, !!c) : R);
  }, I = Nm(B(d), B(l), !!C, b, y, h), x = I[0], O = x.numAsString, k = x.formattedValue, Q = I[1], F = function(R) {
    var z = R.target, L = R.key, X = z.selectionStart, W = z.selectionEnd, U = z.value;
    if (U === void 0 && (U = ""), (L === "Backspace" || L === "Delete") && W < u.length) {
      R.preventDefault();
      return;
    }
    if (X !== W) {
      i(R);
      return;
    }
    L === "Backspace" && U[0] === "-" && X === u.length + 1 && n && or(z, 1), a && c && (L === "Backspace" && U[X - 1] === p ? (or(z, X - 1), R.preventDefault()) : L === "Delete" && U[X] === p && R.preventDefault()), v != null && v.includes(L) && U[X] === p && or(z, X + 1);
    var ee = s === !0 ? "," : s;
    L === "Backspace" && U[X - 1] === ee && or(z, X - 1), L === "Delete" && U[X] === ee && or(z, X + 1), i(R);
  }, M = function(R) {
    var z = O;
    if (z.match(/\d/g) || (z = ""), r || (z = RS(z)), c && a && (z = Z1(z, a, c)), z !== O) {
      var L = q1(z, e);
      Q({
        formattedValue: L,
        value: z,
        floatValue: parseFloat(z)
      }, {
        event: R,
        source: Go.event
      });
    }
    o(R);
  }, H = function(R) {
    return R === p ? !0 : qo(R);
  }, T = function(R) {
    var z = R.currentValue, L = R.lastValue, X = R.formattedValue, W = R.currentValueIndex, U = R.formattedValueIndex, ee = z[W], Ae = X[U], ne = Sm(L, z), K = ne.to, ae = function(pe) {
      return y(pe).indexOf(".") + u.length;
    };
    return d === 0 && c && a && z[K.start] === p && ae(z) < W && ae(X) > U ? !1 : W >= K.start && W < K.end && v && v.includes(ee) && Ae === p ? !0 : ee === Ae;
  };
  return Object.assign(Object.assign({}, g), {
    value: k,
    valueIsNumericString: !1,
    isValidInputCharacter: H,
    isCharacterSame: T,
    onValueChange: Q,
    format: b,
    removeFormatting: y,
    getCaretBoundary: function(R) {
      return US(R, e);
    },
    onKeyDown: F,
    onBlur: M
  });
}
function Tm(e) {
  var t = KS(e);
  return _.createElement(WS, Object.assign({}, t));
}
function Ql(e) {
  const {
    name: t,
    control: n,
    currency: r,
    rules: i,
    errorMessage: o,
    errorMessageClassName: s,
    numericFormatProps: a,
    value: c,
    onChange: u,
    ...l
  } = e, {
    allowNegative: d = !1,
    decimalScale: f = 2,
    thousandSeparator: h = ",",
    fixedDecimalScale: g = !0
  } = a ?? {}, m = r === "USD" ? "$" : void 0, p = e["aria-invalid"] === "true";
  return /* @__PURE__ */ A(
    nA,
    {
      name: t,
      control: n,
      rules: i,
      render: ({ field: { onChange: v, value: b, ref: y } }) => /* @__PURE__ */ D(Be, { children: [
        /* @__PURE__ */ A(
          Tm,
          {
            ...l,
            getInputRef: y,
            prefix: m,
            allowNegative: d,
            decimalScale: f,
            onValueChange: ({ floatValue: E }) => v(E),
            value: b,
            customInput: qt,
            thousandSeparator: h,
            fixedDecimalScale: g
          }
        ),
        p && !!o && /* @__PURE__ */ A(
          "p",
          {
            role: "alert",
            className: $(
              "text-sm text-red-900",
              s
            ),
            children: o
          }
        )
      ] })
    }
  );
}
function pr(e) {
  const {
    options: t,
    name: n,
    control: r,
    rules: i,
    errorMessage: o,
    errorMessageClassName: s,
    disabled: a = !1,
    ...c
  } = e, u = e["aria-invalid"] === "true";
  return /* @__PURE__ */ A(
    nA,
    {
      name: n,
      control: r,
      rules: i,
      render: ({ field: { onChange: l, onBlur: d, value: f } }) => {
        var h;
        return a ? /* @__PURE__ */ A(Be, { children: (h = t.find((g) => g.value === f)) == null ? void 0 : h.label }) : /* @__PURE__ */ D(Be, { children: [
          /* @__PURE__ */ A(
            Mu,
            {
              options: t,
              onBlur: d,
              value: t.find(
                (g) => g.value === f
              ) ?? null,
              isDisabled: a,
              onChange: (g) => !!g && typeof g == "object" && "value" in g && l(g.value),
              ...c
            }
          ),
          u && !!o && /* @__PURE__ */ A(
            "p",
            {
              role: "alert",
              className: $(
                "text-sm text-red-900",
                s
              ),
              children: o
            }
          )
        ] });
      }
    }
  );
}
const _S = Nt(function(t, n) {
  const r = t["aria-invalid"] === "true", {
    errorMessage: i,
    labelClassName: o,
    inputClassName: s,
    errorMessageClassName: a,
    ...c
  } = t;
  return /* @__PURE__ */ D("label", { className: o, children: [
    /* @__PURE__ */ A(
      "input",
      {
        ...c,
        type: "text",
        ref: n,
        className: $(
          "h-8 w-full rounded-md border border-transparent bg-gray-100 p-3 text-right placeholder:text-gray-500 disabled:bg-transparent disabled:p-0 disabled:text-left",
          r && "border-red-900 outline-red-900 placeholder:text-red-800",
          s
        )
      }
    ),
    r && !!i && /* @__PURE__ */ A(
      "p",
      {
        role: "alert",
        className: $(
          "text-sm text-red-900",
          a
        ),
        children: i
      }
    )
  ] });
}), qt = Hr(_S);
function $S(e) {
  const { inputs: t } = e;
  return /* @__PURE__ */ A("div", { className: "bg-white text-xs font-medium", children: t.map(({ label: n, Input: r }, i) => /* @__PURE__ */ D("div", { className: "mb-4 mt-2 grid gap-1", children: [
    /* @__PURE__ */ A("label", { className: "text-base", children: n }),
    /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(r, {}) }, i)
  ] }, n)) });
}
function Yo(e) {
  const {
    itemName: t,
    open: n,
    state: r,
    inputs: i,
    onOpenChange: o,
    reset: s,
    submit: a,
    ...c
  } = e;
  function u() {
    s(), o(!1);
  }
  const l = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all";
  return /* @__PURE__ */ A(
    gn,
    {
      open: n,
      overlayProps: {
        className: "top-10"
      },
      contentProps: {
        className: "rounded-3xl"
      },
      onOpenChange: o,
      ...c,
      children: /* @__PURE__ */ D("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ D("div", { className: "mb-6 flex justify-between", children: [
          /* @__PURE__ */ D("h1", { className: "text-xl font-bold", children: [
            "Create ",
            t
          ] }),
          /* @__PURE__ */ A(
            "button",
            {
              className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
              onClick: u,
              tabIndex: -1,
              children: /* @__PURE__ */ A(Y, { name: "XmarkLight", size: 24 })
            }
          )
        ] }),
        /* @__PURE__ */ A($S, { inputs: i }),
        /* @__PURE__ */ D("div", { className: "mt-8 flex justify-between gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: u,
              className: $(
                l,
                "flex-1 bg-slate-50 text-slate-800"
              ),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ A(
            "button",
            {
              onClick: a,
              className: $(
                l,
                "flex-1 bg-gray-800 text-gray-50"
              ),
              children: "Save"
            }
          )
        ] })
      ] })
    }
  );
}
const eN = (e) => {
  const {
    itemName: t,
    dependentItemName: n,
    dependentItemList: r,
    onOpenChange: i,
    onContinue: o,
    ...s
  } = e;
  return /* @__PURE__ */ A(
    gn,
    {
      overlayProps: {
        className: "top-10"
      },
      contentProps: {
        className: "rounded-3xl"
      },
      onOpenChange: i,
      ...s,
      children: /* @__PURE__ */ D("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ D("div", { className: "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800", children: [
          "Cannot delete ",
          t
        ] }),
        /* @__PURE__ */ D("div", { className: "my-6 flex gap-2 rounded-md bg-orange-100 p-4 text-orange-800", children: [
          /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(Y, { name: "Error", className: "mt-1 text-orange-800" }) }),
          /* @__PURE__ */ D("div", { children: [
            "Warning! Cannot delete this ",
            t,
            " because there are",
            " ",
            n,
            " that depend on it. Please change or delete those first."
          ] })
        ] }),
        /* @__PURE__ */ A("div", { className: "my-6 rounded-md bg-slate-50 p-4 text-slate-200", children: r.map((a, c) => /* @__PURE__ */ A(mr, { children: a }, c)) }),
        /* @__PURE__ */ A("div", { className: "mt-8 flex justify-between gap-3", children: /* @__PURE__ */ A(
          "button",
          {
            onClick: o,
            className: "min-h-12 min-w-36 flex-1 rounded-xl bg-gray-800 px-6 py-3 text-base font-semibold text-gray-50 outline-none transition-all hover:scale-105 active:opacity-75",
            children: "Back"
          }
        ) })
      ] })
    }
  );
};
function tN(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  } = e, { serviceProviderFeeTypes: a, transactions: c, principalLenderAccountId: u } = t, l = (n == null ? void 0 : n.id) === u, { submit: d, reset: f, inputs: h } = Rm({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  }), g = () => /* @__PURE__ */ A(Mi, { inputs: h }), m = !l, p = a.filter(
    ({ accountId: x }) => x === (n == null ? void 0 : n.id)
  ), v = c.map((x, O) => ({
    ...x,
    txNumber: O + 1
  })).filter(
    (x) => {
      var O, k;
      return ((O = x.cashTransaction) == null ? void 0 : O.accountId) === (n == null ? void 0 : n.id) || ((k = x.fixedIncomeTransaction) == null ? void 0 : k.accountId) === (n == null ? void 0 : n.id);
    }
  ), b = p.length && v.length ? "service providers and transactions" : p.length ? "service providers" : "transactions", y = p.length ? [
    /* @__PURE__ */ A("div", { className: "mb-0.5 font-semibold", children: "Service providers:" }, 1),
    ...p.map((x, O) => /* @__PURE__ */ A("div", { children: x.name }, O))
  ] : [], E = v.length ? [
    /* @__PURE__ */ A("div", { className: "mb-0.5 mt-1 font-semibold", children: "Transactions:" }, 5),
    ...v.map((x) => /* @__PURE__ */ D("div", { children: [
      "Transaction #",
      x.txNumber
    ] }, x.id))
  ] : [], C = [
    ...y,
    ...E
  ];
  return /* @__PURE__ */ A(ji, { ...e, ...{
    formInputs: g,
    dependentItemProps: {
      dependentItemName: b,
      dependentItemList: C
    },
    submit: d,
    reset: f,
    isAllowedToDeleteItem: m
  } });
}
const nN = Hr(tN), rN = [
  { key: "label", label: "Label", allowSorting: !0 },
  { key: "reference", label: "Reference", allowSorting: !0 }
];
function iN(e, t) {
  return Fr(e).map((i) => ({
    ...i,
    customTransform: (s, a) => {
      if (i.id === t && a === "label")
        return /* @__PURE__ */ D(Be, { children: [
          s,
          " ",
          /* @__PURE__ */ D("span", { className: "ml-2 inline-flex items-center gap-1 rounded bg-green-100 px-1 font-extralight", children: [
            "Lender ",
            /* @__PURE__ */ A(Y, { name: "CheckCircle", size: 14 })
          ] })
        ] });
    }
  }));
}
function wL(e) {
  const { state: t } = e, { accounts: n, principalLenderAccountId: r } = t, i = "Account", o = ve(
    () => iN(n, r),
    [n, r]
  ), [s, a] = q(), { operation: c, setOperation: u, showForm: l, existingState: d } = Zi({ state: t });
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      Wi,
      {
        ...e,
        itemName: i,
        tableData: o,
        columns: rN,
        selectedTableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ),
    l && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      nN,
      {
        ...e,
        itemName: i,
        state: d,
        tableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ) })
  ] });
}
function zi(e) {
  const {
    operation: t,
    createDefaultValues: n,
    editDefaultValues: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s,
    customSubmitHandler: a
  } = e, c = t === "create" ? n : r, { register: u, handleSubmit: l, reset: d, watch: f, control: h, formState: g } = Ka({
    defaultValues: c
  }), m = me(
    (v) => {
      if (!t || t === "view") return;
      if (a) {
        a(v);
        return;
      }
      const y = {
        create: i,
        edit: o,
        delete: s
      }[t];
      y == null || y(v);
    },
    [
      a,
      i,
      s,
      o,
      t
    ]
  ), p = l(m);
  return ve(
    () => ({
      register: u,
      reset: d,
      watch: f,
      control: h,
      formState: g,
      submit: p
    }),
    [h, g, u, d, p, f]
  );
}
function Rm(e) {
  var m, p, v, b;
  const { item: t, onSubmitCreate: n, onSubmitEdit: r, onSubmitDelete: i, operation: o } = e, s = {
    label: null,
    reference: null
  }, a = t ? {
    id: t.id,
    label: t.label,
    reference: t.reference
  } : s, { submit: c, reset: u, register: l, control: d, formState: f } = zi({
    operation: o,
    createDefaultValues: s,
    editDefaultValues: a,
    onSubmitCreate: n,
    onSubmitEdit: r,
    onSubmitDelete: i
  }), { errors: h } = f, g = ve(
    () => [
      {
        label: "Account Label",
        Input: () => {
          var y, E;
          return /* @__PURE__ */ A(
            qt,
            {
              ...l("label", {
                disabled: o === "view",
                required: "Account label is required"
              }),
              "aria-invalid": ((y = h.label) == null ? void 0 : y.type) === "required" ? "true" : "false",
              errorMessage: (E = h.label) == null ? void 0 : E.message,
              placeholder: "E.g. My Label"
            }
          );
        }
      },
      {
        label: "Account Reference",
        Input: () => {
          var y, E;
          return /* @__PURE__ */ A(
            qt,
            {
              ...l("reference", {
                disabled: o === "view",
                required: "Account reference is required"
              }),
              "aria-invalid": ((y = h.reference) == null ? void 0 : y.type) === "required" ? "true" : "false",
              errorMessage: (E = h.reference) == null ? void 0 : E.message,
              placeholder: "E.g. bank account number or ETH address"
            }
          );
        }
      }
    ],
    [
      (m = h.label) == null ? void 0 : m.message,
      (p = h.label) == null ? void 0 : p.type,
      (v = h.reference) == null ? void 0 : v.message,
      (b = h.reference) == null ? void 0 : b.type,
      o,
      l
    ]
  );
  return ve(() => ({
    submit: c,
    reset: u,
    register: l,
    control: d,
    inputs: g,
    formState: { errors: h }
  }), [c, u, l, d, g, h]);
}
function oN(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s,
    onSubmitCreateFixedIncomeType: a,
    onSubmitCreateSpv: c
  } = e, { transactions: u } = t, {
    submit: l,
    reset: d,
    inputs: f,
    showCreateFixedIncomeTypeModal: h,
    setShowCreateFixedIncomeTypeModal: g,
    showCreateSpvModal: m,
    setShowCreateSpvModal: p
  } = Lm({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  }), v = () => /* @__PURE__ */ A(Mi, { inputs: f }), b = Zm({
    state: t,
    operation: "create",
    onSubmitCreate: (I) => {
      a(I), g(!1);
    }
  }), y = Jm({
    state: t,
    operation: "create",
    onSubmitCreate: (I) => {
      c(I), p(!1);
    }
  }), B = {
    dependentItemName: "transactions",
    dependentItemList: u.map((I, x) => ({
      ...I,
      txNumber: x + 1
    })).filter((I) => {
      var x;
      return ((x = I.fixedIncomeTransaction) == null ? void 0 : x.assetId) === (n == null ? void 0 : n.id);
    }).map((I) => /* @__PURE__ */ D("div", { children: [
      "Transaction #",
      I.txNumber
    ] }, I.id))
  };
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      ji,
      {
        ...e,
        formInputs: v,
        dependentItemProps: B,
        submit: l,
        reset: d
      }
    ),
    h && /* @__PURE__ */ A(
      Yo,
      {
        ...b,
        state: t,
        onOpenChange: g,
        open: h,
        itemName: "Fixed Income Type"
      }
    ),
    m && /* @__PURE__ */ A(
      Yo,
      {
        ...y,
        state: t,
        onOpenChange: p,
        open: m,
        itemName: "SPV"
      }
    )
  ] });
}
const sN = Hr(oN);
function ro(e, t) {
  return e.reduce((n, r) => n + Number(r[t]), 0);
}
const aN = [
  { key: "name", label: "Name", allowSorting: !0 },
  {
    key: "purchaseDate",
    label: "Purchase Date",
    allowSorting: !0
  },
  {
    key: "maturity",
    label: "Maturity",
    allowSorting: !0,
    displayTime: !1
  },
  {
    key: "notional",
    label: "Notional",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "currentValue",
    label: "Current Value",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "purchasePrice",
    label: "Purchase Price",
    allowSorting: !0,
    isNumberColumn: !0,
    decimalScale: 6
  },
  {
    key: "purchaseProceeds",
    label: "Purchase Proceeds",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "salesProceeds",
    label: "Sales Proceeds",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "totalDiscount",
    label: "Total Discount",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "realizedSurplus",
    label: "Realized Surplus",
    allowSorting: !0,
    isNumberColumn: !0
  }
];
function cN(e, t) {
  const n = /* @__PURE__ */ new Date();
  return e.map((i) => {
    const o = t(i, n);
    return {
      ...i,
      currentValue: o
    };
  });
}
function uN(e) {
  const t = "Asset", {
    state: n,
    calculateCurrentValueCallback: r,
    itemsPerPage: i = 20,
    initialPage: o = 0,
    pageRange: s = 3
  } = e, a = lc(n), c = ve(
    () => Fr(
      cN(a, r)
    ),
    [a, r]
  ), {
    pageItems: u,
    pages: l,
    goToPage: d,
    goToNextPage: f,
    goToPreviousPage: h,
    goToFirstPage: g,
    goToLastPage: m,
    hiddenNextPages: p,
    isNextPageAvailable: v,
    isPreviousPageAvailable: b
  } = hd(c, {
    pageRange: s,
    initialPage: o,
    itemsPerPage: i
  }), [y, E] = q(), { operation: C, setOperation: B, showForm: I, existingState: x } = Zi({ state: n }), O = gR(n), k = {
    id: "special-first-row",
    name: "Cash $USD",
    fixedIncomeTypeId: "--",
    spvId: "--",
    maturity: "--",
    ISIN: "--",
    CUSIP: "--",
    coupon: null,
    notional: (O == null ? void 0 : O.balance) ?? 0,
    purchaseDate: "--",
    purchasePrice: "--",
    purchaseProceeds: "--",
    salesProceeds: "--",
    totalDiscount: "--",
    realizedSurplus: "--",
    currentValue: "--"
  };
  ro(
    [...a, k],
    "notional"
  );
  const Q = ro(
    a,
    "purchaseProceeds"
  ), F = ro(a, "salesProceeds"), M = ro(a, "totalDiscount"), H = ro(a, "realizedSurplus");
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A("div", { className: "mb-2 flex w-full justify-end", children: /* @__PURE__ */ A(
      fd,
      {
        pages: l,
        hiddenNextPages: p,
        goToFirstPage: g,
        goToLastPage: m,
        goToNextPage: f,
        goToPage: d,
        goToPreviousPage: h,
        isNextPageAvailable: v,
        isPreviousPageAvailable: b,
        nextPageLabel: "Next",
        previousPageLabel: "Previous"
      }
    ) }),
    /* @__PURE__ */ A(
      Wi,
      {
        ...e,
        itemName: t,
        tableData: u,
        columns: aN,
        selectedTableItem: y,
        operation: C,
        setSelectedTableItem: E,
        setOperation: B,
        specialFirstRow: (z) => /* @__PURE__ */ A(Xl, { children: z.map((L) => /* @__PURE__ */ D(mr, { children: [
          L.key === "name" && /* @__PURE__ */ A(Tt, { children: "Cash $USD" }),
          L.key === "notional" && /* @__PURE__ */ A(Tt, { className: "text-right", children: un(
            k[L.key]
          ) }, L.key),
          L.key !== "name" && L.key !== "notional" && /* @__PURE__ */ A(Tt, {})
        ] }, L.key)) }),
        specialLastRow: (z) => /* @__PURE__ */ A(
          Xl,
          {
            className: $(
              "sticky bottom-0",
              y !== void 0 && "hidden"
            ),
            children: z.map((L) => /* @__PURE__ */ D(mr, { children: [
              L.key === "name" && /* @__PURE__ */ A(Tt, { children: "Totals" }),
              L.key === "purchaseProceeds" && /* @__PURE__ */ A(Tt, { className: "text-right", children: un(Q) }, L.key),
              L.key === "salesProceeds" && /* @__PURE__ */ A(Tt, { className: "text-right", children: un(F) }, L.key),
              L.key === "totalDiscount" && /* @__PURE__ */ A(Tt, { className: "text-right", children: un(M) }, L.key),
              L.key === "realizedSurplus" && /* @__PURE__ */ A(Tt, { className: "text-right", children: un(H) }, L.key),
              L.key !== "name" && L.key !== "purchaseProceeds" && L.key !== "salesProceeds" && L.key !== "totalDiscount" && L.key !== "realizedSurplus" && /* @__PURE__ */ A(Tt, {})
            ] }, L.key))
          }
        )
      }
    ),
    I && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      sN,
      {
        ...e,
        itemName: t,
        state: x,
        tableItem: y,
        operation: C,
        setSelectedTableItem: E,
        setOperation: B
      }
    ) })
  ] });
}
function Lm(e) {
  var O, k;
  const [t, n] = q(!1), [r, i] = q(!1), {
    item: o,
    state: s,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u,
    operation: l
  } = e, { fixedIncomeTypes: d, spvs: f } = s, h = {
    fixedIncomeTypeId: ((O = d[0]) == null ? void 0 : O.id) ?? null,
    spvId: ((k = f[0]) == null ? void 0 : k.id) ?? null,
    name: null,
    maturity: null,
    ISIN: null,
    CUSIP: null,
    coupon: null
  }, g = o ? {
    id: o.id,
    fixedIncomeTypeId: o.fixedIncomeTypeId,
    spvId: o.spvId,
    name: o.name,
    maturity: o.maturity ? dR(o.maturity) : null,
    ISIN: o.ISIN,
    CUSIP: o.CUSIP,
    coupon: o.coupon
  } : h, { submit: m, reset: p, register: v, control: b, formState: y, watch: E } = zi({
    operation: l,
    createDefaultValues: h,
    editDefaultValues: g,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u
  }), { errors: C } = y, B = ve(
    () => l !== "create" ? [
      {
        label: "Notional",
        Input: () => /* @__PURE__ */ A(Be, { children: un(o == null ? void 0 : o.notional) })
      },
      {
        label: "Purchase Date",
        Input: () => /* @__PURE__ */ A(Be, { children: un(o == null ? void 0 : o.purchaseDate) })
      },
      {
        label: "Purchase Price",
        Input: () => /* @__PURE__ */ A(Be, { children: un(o == null ? void 0 : o.purchasePrice, 6) })
      },
      {
        label: "Purchase Proceeds",
        Input: () => /* @__PURE__ */ A(Be, { children: un(o == null ? void 0 : o.purchaseProceeds) })
      }
    ] : [],
    [
      o == null ? void 0 : o.notional,
      o == null ? void 0 : o.purchaseDate,
      o == null ? void 0 : o.purchasePrice,
      o == null ? void 0 : o.purchaseProceeds,
      l
    ]
  ), I = l === "view" ? o == null ? void 0 : o.maturity : E("maturity") || (o == null ? void 0 : o.maturity), x = ve(
    () => [
      {
        label: "Asset Name",
        Input: () => {
          var Q;
          return /* @__PURE__ */ A(
            qt,
            {
              ...v("name", {
                disabled: l === "view",
                required: "Asset name is required"
              }),
              "aria-invalid": C.name ? "true" : "false",
              errorMessage: (Q = C.name) == null ? void 0 : Q.message,
              placeholder: "E.g. My Asset",
              inputClassName: "text-left"
            }
          );
        }
      },
      {
        label: "CUSIP",
        Input: () => {
          var Q;
          return l === "view" ? (o == null ? void 0 : o.CUSIP) ?? "Not available" : /* @__PURE__ */ A(
            qt,
            {
              ...v("CUSIP", {
                maxLength: {
                  value: 9,
                  message: "CUSIP cannot be longer than 9 characters"
                },
                minLength: {
                  value: 9,
                  message: "CUSIP cannot be shorter than 9 characters"
                },
                pattern: {
                  value: /^[a-zA-Z0-9]*$/,
                  message: "CUSIP must be alphanumeric"
                }
              }),
              errorMessage: (Q = C.CUSIP) == null ? void 0 : Q.message,
              "aria-invalid": C.CUSIP ? "true" : "false",
              placeholder: "E.g. A2345B789"
            }
          );
        }
      },
      {
        label: "ISIN",
        Input: () => {
          var Q;
          return l === "view" ? (o == null ? void 0 : o.ISIN) ?? "Not available" : /* @__PURE__ */ A(
            qt,
            {
              ...v("ISIN", {
                maxLength: {
                  value: 12,
                  message: "ISIN cannot be longer than 12 characters"
                },
                minLength: {
                  value: 12,
                  message: "ISIN cannot be shorter than 12 characters"
                },
                pattern: {
                  value: /^[a-zA-Z0-9]*$/,
                  message: "ISIN must be alphanumeric"
                }
              }),
              errorMessage: (Q = C.ISIN) == null ? void 0 : Q.message,
              "aria-invalid": C.ISIN ? "true" : "false",
              placeholder: "E.g. 123456789ABC"
            }
          );
        }
      },
      {
        label: "Maturity",
        Input: () => /* @__PURE__ */ A(
          t3,
          {
            ...v("maturity", {
              disabled: l === "view",
              setValueAs: (Q) => Q === "" ? null : Q
            }),
            name: "maturity",
            inputType: "date"
          }
        ),
        inputLabel: I ? OA(I, !0) : null
      },
      {
        label: "Asset Type",
        Input: () => {
          var Q;
          return /* @__PURE__ */ A(
            pr,
            {
              control: b,
              name: "fixedIncomeTypeId",
              disabled: l === "view",
              options: d.map((F) => ({
                ...F,
                value: F.id,
                label: F.name
              })),
              addItemButtonProps: {
                onClick: () => n(!0),
                label: "Create Fixed Income Type"
              },
              rules: { required: "Asset type is required" },
              "aria-invalid": C.fixedIncomeTypeId ? "true" : "false",
              errorMessage: (Q = C.fixedIncomeTypeId) == null ? void 0 : Q.message
            }
          );
        }
      },
      {
        label: "SPV",
        Input: () => {
          var Q;
          return /* @__PURE__ */ A(
            pr,
            {
              control: b,
              name: "spvId",
              disabled: l === "view",
              options: f.map((F) => ({
                ...F,
                value: F.id,
                label: F.name
              })),
              addItemButtonProps: {
                onClick: () => i(!0),
                label: "Create SPV"
              },
              rules: { required: "SPV is required" },
              "aria-invalid": C.spvId ? "true" : "false",
              errorMessage: (Q = C.spvId) == null ? void 0 : Q.message
            }
          );
        }
      },
      ...B
    ],
    [
      I,
      B,
      v,
      l,
      C.name,
      C.CUSIP,
      C.ISIN,
      C.fixedIncomeTypeId,
      C.spvId,
      o == null ? void 0 : o.CUSIP,
      o == null ? void 0 : o.ISIN,
      b,
      d,
      f
    ]
  );
  return ve(() => ({
    submit: m,
    reset: p,
    register: v,
    control: b,
    inputs: x,
    formState: y,
    showCreateFixedIncomeTypeModal: t,
    setShowCreateFixedIncomeTypeModal: n,
    showCreateSpvModal: r,
    setShowCreateSpvModal: i
  }), [
    m,
    p,
    v,
    b,
    x,
    y,
    t,
    r
  ]);
}
function bA(e) {
  const {
    value: t,
    currency: n,
    decimalScale: r = 2,
    thousandSeparator: i = ",",
    fixedDecimalScale: o = !0
  } = e;
  return /* @__PURE__ */ A(
    Tm,
    {
      displayType: "text",
      value: t,
      prefix: n === "USD" ? "$" : void 0,
      decimalScale: r,
      thousandSeparator: i,
      fixedDecimalScale: o
    }
  );
}
const PL = (e) => {
  const { label: t, ...n } = e;
  return /* @__PURE__ */ A("th", { scope: "col", ...n, children: t });
};
function ji(e) {
  const {
    tableItem: t,
    itemName: n,
    className: r,
    operation: i = "view",
    isAllowedToCreateDocuments: o,
    isAllowedToEditDocuments: s,
    isAllowedToDeleteItem: a = !0,
    dependentItemProps: c,
    formInputs: u,
    setOperation: l,
    submit: d,
    onSubmitDelete: f,
    reset: h,
    setSelectedTableItem: g
  } = e, [m, p] = q(!1), v = !!(c != null && c.dependentItemList.length), b = i === "edit", y = i === "create", E = i === "view", C = o || s, B = !E && C, I = !E && C, x = b && s && a, O = E && s;
  function k() {
    if (i === "edit") {
      l("view");
      return;
    }
    h(), g(void 0), l(null);
  }
  function Q() {
    if (t) {
      if (v) {
        p(!0);
        return;
      }
      f(t.id), g(void 0);
    }
  }
  const F = /* @__PURE__ */ A(uu, { onClick: k, className: "text-gray-600", children: "Cancel" }), M = /* @__PURE__ */ A(
    uu,
    {
      onClick: d,
      iconPosition: "right",
      icon: /* @__PURE__ */ A(Y, { name: "Save", size: 16 }),
      children: y ? "Save" : "Save Edits"
    }
  ), H = /* @__PURE__ */ A("button", { onClick: Q, children: /* @__PURE__ */ A(Y, { name: "Trash", className: "ml-3 text-red-800", size: 22 }) }), T = /* @__PURE__ */ D(
    uu,
    {
      onClick: () => {
        g(t), l("edit");
      },
      iconPosition: "right",
      icon: /* @__PURE__ */ A(Y, { name: "Pencil", size: 16 }),
      children: [
        "Edit ",
        n
      ]
    }
  );
  return /* @__PURE__ */ D(
    "div",
    {
      className: $(
        "flex flex-col rounded-md border border-gray-300 bg-white",
        r
      ),
      children: [
        /* @__PURE__ */ D("div", { className: "flex justify-between rounded-t-md border-b border-gray-300 bg-gray-100 p-3 font-semibold text-gray-800", children: [
          /* @__PURE__ */ A("div", { className: "flex items-center", children: t != null && t.itemNumber ? `${n} #${t.itemNumber}` : `New ${n}` }),
          /* @__PURE__ */ D("div", { className: "flex gap-x-2", children: [
            B && F,
            I && M,
            x && H,
            O && T
          ] })
        ] }),
        /* @__PURE__ */ A(u, {}),
        c && /* @__PURE__ */ A(
          eN,
          {
            ...c,
            itemName: n.toLowerCase(),
            open: m,
            onContinue: () => p(!1)
          }
        )
      ]
    }
  );
}
const Xl = Nt(function(t, n) {
  const { children: r, className: i, ...o } = t;
  return /* @__PURE__ */ A(
    "tr",
    {
      ...o,
      ref: n,
      className: $("odd:bg-white even:bg-gray-50", i),
      children: r
    }
  );
}), Fm = 34, Qm = 42, lN = Fm * 20 + Qm;
function dN(e) {
  var l, d;
  const { selectedRowNumber: t, tableContainerRef: n, rowRefs: r, headerRef: i } = e, [o, s] = q(
    `${lN}px`
  ), a = ((l = r.current[1]) == null ? void 0 : l.offsetHeight) ?? Fm, c = ((d = i.current) == null ? void 0 : d.offsetHeight) ?? Qm, u = me(() => {
    var g, m;
    if (t === void 0) {
      const p = a * 20 + c;
      s(`${p}px`);
      return;
    }
    const f = (g = n.current) == null ? void 0 : g.getBoundingClientRect(), h = (m = r.current[t]) == null ? void 0 : m.getBoundingClientRect();
    if (h && f) {
      const p = h.bottom, v = f.top, b = p - v;
      s(`${b}px`);
    }
  }, [
    c,
    a,
    r,
    t,
    n
  ]);
  return Ie(() => {
    u();
  }, [u]), Ie(() => {
    const f = () => {
      u();
    }, h = n.current;
    return h && h.addEventListener("scroll", f), () => {
      h && h.removeEventListener(
        "scroll",
        f
      );
    };
  }, [n, u]), o;
}
function Wi(e) {
  const {
    itemName: t,
    columns: n,
    tableData: r,
    selectedTableItem: i,
    columnCountByTableWidth: o = EN,
    isAllowedToCreateDocuments: s,
    operation: a,
    setSelectedTableItem: c,
    setOperation: u,
    specialFirstRow: l,
    specialLastRow: d
  } = e, f = Ce(null), h = Ce([]), g = Ce(null), [m, p] = q(), { sortedItems: v, sortHandler: b } = cT(r), { columnsToShow: y } = HN({
    columns: n,
    columnCountByTableWidth: o,
    tableContainerRef: f
  }), E = dN({
    tableContainerRef: f,
    rowRefs: h,
    headerRef: g,
    selectedRowNumber: m
  });
  function C() {
    c(void 0), u("create");
  }
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      AN,
      {
        onClickSort: b,
        ref: f,
        headerRef: g,
        tableData: v,
        columns: y,
        maxHeight: E,
        hasSelectedItem: !!i,
        renderRow: (I, x, O) => {
          const k = (i == null ? void 0 : i.id) === I.id;
          return /* @__PURE__ */ A(
            Xl,
            {
              ref: (Q) => h.current[O] = Q,
              children: x.map((Q) => {
                var F;
                return /* @__PURE__ */ D(mr, { children: [
                  Q.key === "itemNumber" && /* @__PURE__ */ A(fN, { itemNumber: I.itemNumber }),
                  Q.key !== "itemNumber" && Q.key !== "moreDetails" && /* @__PURE__ */ A(
                    Tt,
                    {
                      className: Q.isNumberColumn ? "text-right" : "",
                      children: ((F = I.customTransform) == null ? void 0 : F.call(
                        I,
                        I[Q.key],
                        Q.key
                      )) ?? un(
                        I[Q.key],
                        Q.decimalScale,
                        Q.displayTime
                      )
                    },
                    Q.key
                  ),
                  Q.key === "moreDetails" && /* @__PURE__ */ A(
                    gN,
                    {
                      isSelected: k,
                      onClick: () => {
                        if (k) {
                          u(null), c(void 0), p(void 0);
                          return;
                        }
                        u("view"), c(I), p(O);
                      }
                    }
                  )
                ] }, Q.key);
              })
            },
            I.id
          );
        },
        specialFirstRow: l,
        specialLastRow: d
      }
    ),
    s && !a && /* @__PURE__ */ A(Be, { children: /* @__PURE__ */ D(
      "button",
      {
        onClick: C,
        className: "mt-4 flex h-11 w-full items-center justify-center gap-x-2 rounded-lg border border-gray-300 bg-white text-sm font-semibold text-gray-900",
        children: [
          /* @__PURE__ */ D("span", { children: [
            "Create ",
            t
          ] }),
          /* @__PURE__ */ A(Y, { name: "Plus", size: 14 })
        ]
      }
    ) })
  ] });
}
const AN = gh(function(t, n) {
  const {
    children: r,
    tableData: i,
    columns: o,
    footer: s,
    renderRow: a,
    onClickSort: c,
    specialFirstRow: u,
    specialLastRow: l,
    maxHeight: d,
    headerRef: f,
    hasSelectedItem: h,
    ...g
  } = t, [m, p] = q(
    null
  ), [v, b] = q(null);
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      "div",
      {
        ...g,
        className: $(
          "relative rounded-lg border border-gray-300 bg-white",
          h ? "overflow-hidden" : "overflow-scroll",
          g.className
        ),
        ref: n,
        style: { maxHeight: d },
        children: /* @__PURE__ */ D("table", { className: "w-full", children: [
          /* @__PURE__ */ A(
            "thead",
            {
              ref: f,
              className: "sticky top-0 isolate select-none text-nowrap border-b border-gray-300 bg-gray-100",
              children: /* @__PURE__ */ A("tr", { children: o.map((y) => /* @__PURE__ */ A(
                "th",
                {
                  className: $(
                    "group border-l border-gray-300 py-3 pl-3 text-start text-xs font-medium text-gray-600 first:border-l-0",
                    y.allowSorting && "cursor-pointer hover:text-gray-900"
                  ),
                  onClick: () => {
                    if (!y.allowSorting) return;
                    let E = "asc";
                    v === y.key && m === "asc" && (E = "desc"), p(E), b(y.key), c(y.key, E);
                  },
                  children: /* @__PURE__ */ D(
                    "div",
                    {
                      className: $(
                        "group flex items-center",
                        y.isNumberColumn && "justify-end"
                      ),
                      children: [
                        y.label,
                        y.allowSorting && /* @__PURE__ */ A(
                          Y,
                          {
                            name: "ArrowFilledRight",
                            size: 6,
                            className: $(
                              "invisible ml-1 rotate-90",
                              v === y.key && "group-hover:visible",
                              m === "asc" && "rotate-[270deg]"
                            )
                          }
                        )
                      ]
                    }
                  )
                },
                y.key
              )) })
            }
          ),
          /* @__PURE__ */ D("tbody", { children: [
            r,
            u == null ? void 0 : u(o),
            i == null ? void 0 : i.map(
              (y, E) => a(y, o, E)
            ),
            l == null ? void 0 : l(o)
          ] })
        ] })
      }
    ),
    s
  ] });
}), Tt = (e) => /* @__PURE__ */ A(
  "td",
  {
    ...e,
    className: $(
      "truncate border-l border-gray-300 px-3 py-2 text-xs font-medium text-gray-900 first:border-l-0",
      e.className
    )
  }
);
function fN(e) {
  return /* @__PURE__ */ A(Tt, { className: "w-4", children: e.itemNumber });
}
function gN(e) {
  const { isSelected: t, onClick: n } = e;
  return /* @__PURE__ */ A(Tt, { className: "w-4", children: /* @__PURE__ */ A(
    "button",
    {
      className: "flex size-full items-center justify-center",
      onClick: n,
      children: /* @__PURE__ */ A(
        Y,
        {
          name: "CaretDown",
          size: 16,
          className: $(
            "text-gray-600",
            t && "rotate-180"
          )
        }
      )
    }
  ) });
}
const hN = "ACCOUNTS", pN = "FIXED_INCOME_TYPES", mN = "SERVICE_PROVIDER_FEE_TYPES", vN = "SPVS", HL = [
  hN,
  pN,
  mN,
  vN
], Xm = "PORTFOLIO", bN = "TRANSACTIONS", yN = "OTHER", OL = [Xm, bN, yN], yA = "AssetPurchase", CA = "AssetSale", Vm = "PrincipalDraw", km = "PrincipalReturn", Mm = "InterestIncome", zm = "InterestPayment", IA = "FeesIncome", jm = "FeesPayment", CN = [
  Vm,
  km
], EA = [yA, CA], xA = [IA, jm], IN = [
  Mm,
  zm
], Vl = [
  ...CN,
  ...EA,
  ...xA,
  ...IN
], BA = {
  AssetPurchase: "Asset purchase",
  AssetSale: "Asset sale",
  PrincipalDraw: "Principal draw",
  PrincipalReturn: "Principal return",
  InterestIncome: "Interest income",
  InterestPayment: "Interest payment",
  FeesIncome: "Fees income",
  FeesPayment: "Fees payment"
}, EN = {
  1520: 10,
  1394: 9,
  1239: 8,
  1112: 7,
  984: 6
}, Wm = {
  [CA]: 1,
  [Vm]: 1,
  [yA]: -1,
  [km]: -1,
  [IA]: 1,
  [jm]: -1,
  [Mm]: 1,
  [zm]: -1
}, xN = {
  [CA]: -1,
  [yA]: 1
};
function BN(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  } = e, a = lc(t), { submit: c, reset: u, inputs: l } = Zm({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  }), d = () => /* @__PURE__ */ A(Mi, { inputs: l }), g = {
    dependentItemName: "assets",
    dependentItemList: a.filter(
      (p) => p.fixedIncomeTypeId === (n == null ? void 0 : n.id)
    ).map((p) => /* @__PURE__ */ A("div", { children: p.name }, p.id))
  };
  return /* @__PURE__ */ A(ji, { ...e, ...{
    formInputs: d,
    dependentItemProps: g,
    submit: c,
    reset: u
  } });
}
const wN = Hr(BN), PN = [{ key: "name", label: "Name", allowSorting: !0 }];
function DL(e) {
  const { state: t } = e, { fixedIncomeTypes: n } = t, r = "Fixed Income Type", i = ve(
    () => Fr(n),
    [n]
  ), [o, s] = q(), { operation: a, setOperation: c, showForm: u, existingState: l } = Zi({ state: t });
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      Wi,
      {
        ...e,
        itemName: r,
        tableData: i,
        columns: PN,
        selectedTableItem: o,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ),
    u && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      wN,
      {
        ...e,
        itemName: r,
        state: l,
        tableItem: o,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ) })
  ] });
}
function Zm(e) {
  var m, p;
  const { item: t, onSubmitCreate: n, onSubmitEdit: r, onSubmitDelete: i, operation: o } = e, s = {
    name: null
  }, a = t ? {
    id: t.id,
    name: t.name
  } : s, { submit: c, reset: u, register: l, control: d, formState: f } = zi({
    operation: o,
    createDefaultValues: s,
    editDefaultValues: a,
    onSubmitCreate: n,
    onSubmitEdit: r,
    onSubmitDelete: i
  }), { errors: h } = f, g = ve(
    () => [
      {
        label: "Fixed Income Type Name",
        Input: () => {
          var v, b;
          return /* @__PURE__ */ A(
            qt,
            {
              ...l("name", {
                disabled: o === "view",
                required: "Fixed Income Type name is required"
              }),
              "aria-invalid": ((v = h.name) == null ? void 0 : v.type) === "required" ? "true" : "false",
              errorMessage: (b = h.name) == null ? void 0 : b.message,
              placeholder: "E.g. My Fixed Income Type name"
            }
          );
        }
      }
    ],
    [(m = h.name) == null ? void 0 : m.message, (p = h.name) == null ? void 0 : p.type, o, l]
  );
  return ve(() => ({
    submit: c,
    reset: u,
    register: l,
    control: d,
    inputs: g,
    formState: { errors: h }
  }), [c, u, l, d, g, h]);
}
function HN(e) {
  const {
    columnCountByTableWidth: t,
    tableContainerRef: n,
    columns: r,
    hasItemNumberColumn: i = !0,
    hasMoreDetailsColumn: o = !0
  } = e, [s, a] = q(0), c = ve(
    () => i ? {
      key: "itemNumber",
      label: "#",
      allowSorting: !0,
      isSpecialColumn: !0
    } : void 0,
    [i]
  ), u = ve(
    () => o ? {
      key: "moreDetails",
      label: "",
      isSpecialColumn: !0
    } : void 0,
    [o]
  ), [l, d] = q([]), f = me(() => {
    var g;
    (g = n.current) != null && g.parentElement && a(n.current.parentElement.offsetWidth);
  }, [n]), h = me(() => {
    const g = ON(
      s,
      t
    ), m = (r == null ? void 0 : r.slice(0, g)) ?? [];
    d(
      [c, ...m, u].filter(
        Boolean
      )
    );
  }, [
    s,
    r,
    t,
    c,
    u
  ]);
  return Ie(() => (f(), window.addEventListener("resize", f), () => window.removeEventListener("resize", f)), [f]), Ie(() => {
    h();
  }, [h, s]), ve(() => ({ columnsToShow: l }), [l]);
}
function ON(e, t) {
  let n = 1520, r = 1 / 0;
  return Object.keys(t).forEach((o) => {
    const s = parseInt(o), a = Math.abs(e - s);
    a < r && (r = a, n = parseInt(o));
  }), t[n];
}
function Zi({ state: e }) {
  const [t, n] = q(null), [r, i] = q(() => e), o = t !== null;
  return Ie(() => {
    i(e);
  }, [t]), ve(
    () => ({
      operation: t,
      setOperation: n,
      showForm: o,
      existingState: r
    }),
    [t, n, o, r]
  );
}
/**
 * natural-orderby v3.0.2
 *
 * Copyright (c) Olaf Ennen
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var Gm = function(t, n) {
  return t < n ? -1 : t > n ? 1 : 0;
}, DN = function(t, n) {
  var r = t.localeCompare(n);
  return r ? r / Math.abs(r) : 0;
}, SN = /(^0x[\da-fA-F]+$|^([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?!\.\d+)(?=\D|\s|$))|\d+)/g, qm = /^\s+|\s+$/g, NN = /\s+/g, TN = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/, RN = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, LN = /^0+[1-9]{1}[0-9]*$/, FN = /[^\x00-\x80]/, Y1 = function(t, n) {
  return t < n ? -1 : t > n ? 1 : 0;
}, QN = function(t, n) {
  for (var r = t.length, i = n.length, o = Math.min(r, i), s = 0; s < o; s++) {
    var a = t[s], c = n[s];
    if (a.normalizedString !== c.normalizedString) {
      if (a.normalizedString === "" != (c.normalizedString === ""))
        return a.normalizedString === "" ? -1 : 1;
      if (a.parsedNumber !== void 0 && c.parsedNumber !== void 0) {
        var u = Gm(a.parsedNumber, c.parsedNumber);
        return u === 0 ? Y1(a.normalizedString, c.normalizedString) : u;
      } else return a.parsedNumber !== void 0 || c.parsedNumber !== void 0 ? a.parsedNumber !== void 0 ? -1 : 1 : FN.test(a.normalizedString + c.normalizedString) ? DN(a.normalizedString, c.normalizedString) : Y1(a.normalizedString, c.normalizedString);
    }
  }
  return r > o || i > o ? r <= o ? -1 : 1 : 0;
}, XN = function(t, n) {
  return (t.chunks ? !n.chunks : n.chunks) ? t.chunks ? -1 : 1 : (t.isNaN ? !n.isNaN : n.isNaN) ? t.isNaN ? -1 : 1 : (t.isSymbol ? !n.isSymbol : n.isSymbol) ? t.isSymbol ? -1 : 1 : (t.isObject ? !n.isObject : n.isObject) ? t.isObject ? -1 : 1 : (t.isArray ? !n.isArray : n.isArray) ? t.isArray ? -1 : 1 : (t.isFunction ? !n.isFunction : n.isFunction) ? t.isFunction ? -1 : 1 : (t.isNull ? !n.isNull : n.isNull) ? t.isNull ? -1 : 1 : 0;
}, VN = function(t, n) {
  return t.value === n.value ? 0 : t.parsedNumber !== void 0 && n.parsedNumber !== void 0 ? Gm(t.parsedNumber, n.parsedNumber) : t.chunks && n.chunks ? QN(t.chunks, n.chunks) : XN(t, n);
}, kN = function(t) {
  return t.replace(NN, " ").replace(qm, "");
}, Ym = function(t) {
  if (t.length !== 0) {
    var n = Number(t);
    if (!Number.isNaN(n))
      return n;
  }
}, MN = function(t, n, r) {
  if (TN.test(t) && (!LN.test(t) || n === 0 || r[n - 1] !== "."))
    return Ym(t) || 0;
}, zN = function(t, n, r) {
  return {
    parsedNumber: MN(t, n, r),
    normalizedString: kN(t)
  };
}, jN = function(t) {
  return t.replace(SN, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0");
}, WN = function(t) {
  var n = jN(t).map(zN);
  return n;
}, ZN = function(t) {
  return typeof t == "function";
}, U1 = function(t) {
  return Number.isNaN(t) || t instanceof Number && Number.isNaN(t.valueOf());
}, GN = function(t) {
  return t === null;
}, qN = function(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t) && !(t instanceof Number) && !(t instanceof String) && !(t instanceof Boolean) && !(t instanceof Date);
}, YN = function(t) {
  return typeof t == "symbol";
}, UN = function(t) {
  return t === void 0;
}, JN = function(t) {
  try {
    var n = Date.parse(t);
    return !Number.isNaN(n) && RN.test(t) ? n : void 0;
  } catch {
    return;
  }
}, KN = function(t) {
  var n = Ym(t);
  return n !== void 0 ? n : JN(t);
}, _N = function(t) {
  return typeof t == "boolean" || t instanceof Boolean ? Number(t).toString() : typeof t == "number" || t instanceof Number ? t.toString() : t instanceof Date ? t.getTime().toString() : typeof t == "string" || t instanceof String ? t.toLowerCase().replace(qm, "") : "";
}, $N = function(t) {
  if (typeof t == "string" || t instanceof String || (typeof t == "number" || t instanceof Number) && !U1(t) || typeof t == "boolean" || t instanceof Boolean || t instanceof Date) {
    var n = _N(t), r = KN(n), i = WN(r ? "" + r : n);
    return {
      parsedNumber: r,
      chunks: i,
      value: t
    };
  }
  return {
    isArray: Array.isArray(t),
    isFunction: ZN(t),
    isNaN: U1(t),
    isNull: GN(t),
    isObject: qN(t),
    isSymbol: YN(t),
    isUndefined: UN(t),
    value: t
  };
}, eT = function(t, n, r) {
  for (var i = t.index, o = t.values, s = n.index, a = n.values, c = o.length, u = r.length, l = 0; l < c; l++) {
    var d = l < u ? r[l] : null;
    if (d && typeof d == "function") {
      var f = d(o[l].value, a[l].value);
      if (f)
        return f;
    } else {
      var h = VN(o[l], a[l]);
      if (h)
        return h * (d === "desc" ? -1 : 1);
    }
  }
  return i - s;
}, tT = function(t) {
  return typeof t == "function" ? t : function(n) {
    if (Array.isArray(n)) {
      var r = Number(t);
      if (Number.isInteger(r))
        return n[r];
    } else if (n && typeof n == "object") {
      var i = Object.getOwnPropertyDescriptor(n, t);
      return i == null ? void 0 : i.value;
    }
    return n;
  };
}, nT = function(t, n) {
  return t[n];
}, rT = function(t, n) {
  return n(t);
}, iT = function(t, n, r) {
  var i = n.length ? n.map(tT) : [function(s) {
    return s;
  }], o = t.map(function(s, a) {
    var c = i.map(function(u) {
      return rT(s, u);
    }).map($N);
    return {
      index: a,
      values: c
    };
  });
  return o.sort(function(s, a) {
    return eT(s, a, r);
  }), o.map(function(s) {
    return nT(t, s.index);
  });
}, oT = function(t) {
  if (!t)
    return [];
  var n = Array.isArray(t) ? [].concat(t) : [t];
  return n.some(function(r) {
    return typeof r != "string" && typeof r != "number" && typeof r != "function";
  }) ? [] : n;
}, sT = function(t) {
  if (!t)
    return [];
  var n = Array.isArray(t) ? [].concat(t) : [t];
  return n.some(function(r) {
    return r !== "asc" && r !== "desc" && typeof r != "function";
  }) ? [] : n;
};
function aT(e, t, n) {
  if (!e || !Array.isArray(e))
    return [];
  var r = oT(t), i = sT(n);
  return iT(e, r, i);
}
function cT(e) {
  const [t, n] = q(e), [r, i] = q(), [o, s] = q("asc"), a = me(
    (c, u) => {
      i(c), s(u);
    },
    []
  );
  return Ie(() => {
    if (e) {
      if (!r) {
        n(e);
        return;
      }
      n(aT(e, [r], [o]));
    }
  }, [r, o, e, a]), ve(
    () => ({ sortedItems: t, sortHandler: a }),
    [t, a]
  );
}
function uT(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s,
    onSubmitCreateAccount: a
  } = e, { transactions: c } = t, {
    inputs: u,
    submit: l,
    reset: d,
    showCreateAccountModal: f,
    setShowCreateAccountModal: h
  } = Um({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  }), g = () => /* @__PURE__ */ A(Mi, { inputs: u }), m = Rm({
    state: t,
    operation: "create",
    onSubmitCreate: (b) => {
      a(b), h(!1);
    }
  }), v = {
    dependentItemName: "transactions",
    dependentItemList: c.filter(
      (b) => {
        var y;
        return (y = b.fees) == null ? void 0 : y.some((E) => E.serviceProviderFeeTypeId === (n == null ? void 0 : n.id));
      }
    ).map((b, y) => /* @__PURE__ */ D("div", { children: [
      "Transaction #",
      y + 1
    ] }, b.id))
  };
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      ji,
      {
        ...e,
        formInputs: g,
        dependentItemProps: v,
        submit: l,
        reset: d,
        onSubmitCreate: i,
        onSubmitEdit: o,
        onSubmitDelete: s
      }
    ),
    f && /* @__PURE__ */ A(
      Yo,
      {
        ...e,
        ...m,
        open: f,
        onOpenChange: h,
        itemName: "Account"
      }
    )
  ] });
}
const lT = Hr(
  uT
), dT = [
  { key: "name", label: "Name", allowSorting: !0 },
  { key: "feeType", label: "Fee Type", allowSorting: !0 },
  { key: "accountName", label: "Account Name", allowSorting: !0 },
  {
    key: "accountReference",
    label: "Account Reference",
    allowSorting: !0
  }
];
function AT(e, t) {
  if (!(e != null && e.length) || !(t != null && t.length)) return [];
  const n = e.map((r) => {
    const i = t.find(
      (o) => o.id === r.accountId
    );
    return {
      ...r,
      accountName: i == null ? void 0 : i.label,
      accountReference: i == null ? void 0 : i.reference
    };
  });
  return Fr(n);
}
function SL(e) {
  const { state: t } = e, { serviceProviderFeeTypes: n, accounts: r } = t, i = "Service Provider Fee Type", o = ve(
    () => AT(
      n,
      r
    ),
    [n, r]
  ), [s, a] = q(), { operation: c, setOperation: u, showForm: l, existingState: d } = Zi({ state: t });
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      Wi,
      {
        ...e,
        itemName: i,
        tableData: o,
        columns: dT,
        selectedTableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ),
    l && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      lT,
      {
        ...e,
        itemName: i,
        state: d,
        tableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ) })
  ] });
}
function Um(e) {
  var C, B, I;
  const [t, n] = q(!1), {
    item: r,
    state: i,
    onSubmitCreate: o,
    onSubmitEdit: s,
    onSubmitDelete: a,
    operation: c
  } = e, { accounts: u } = i, l = {
    name: null,
    feeType: null,
    accountId: ((C = u[0]) == null ? void 0 : C.id) ?? null
  }, d = r ? {
    id: r.id,
    name: r.name,
    feeType: r.feeType,
    accountId: r.accountId
  } : l, { submit: f, reset: h, register: g, control: m, formState: p } = zi({
    operation: c,
    createDefaultValues: l,
    editDefaultValues: d,
    onSubmitCreate: o,
    onSubmitEdit: s,
    onSubmitDelete: a
  }), { errors: v } = p;
  function b(x) {
    return `${x.label} (${x.reference})`;
  }
  const y = me((x) => x.map((O) => ({
    ...O,
    value: O.id,
    label: b(O)
  })), []), E = ve(
    () => [
      {
        label: "Service Provider Name",
        Input: () => {
          var x, O;
          return /* @__PURE__ */ A(
            qt,
            {
              ...g("name", {
                disabled: c === "view",
                required: "Service provider name is required"
              }),
              "aria-invalid": ((x = v.name) == null ? void 0 : x.type) === "required" ? "true" : "false",
              errorMessage: (O = v.name) == null ? void 0 : O.message,
              placeholder: "E.g. My Service Provider"
            }
          );
        }
      },
      {
        label: "Fee Type",
        Input: () => {
          var x, O;
          return /* @__PURE__ */ A(
            qt,
            {
              ...g("feeType", {
                disabled: c === "view",
                required: "Fee type is required"
              }),
              "aria-invalid": ((x = v.name) == null ? void 0 : x.type) === "required" ? "true" : "false",
              errorMessage: (O = v.name) == null ? void 0 : O.message,
              placeholder: "E.g. My Fee Type"
            }
          );
        }
      },
      {
        label: "Account",
        Input: () => {
          var x;
          return /* @__PURE__ */ A(
            pr,
            {
              control: m,
              name: "accountId",
              disabled: c === "view",
              options: y(u),
              addItemButtonProps: {
                onClick: () => n(!0),
                label: "Create Account"
              },
              rules: { required: "Account is required" },
              "aria-invalid": v.accountId ? "true" : "false",
              errorMessage: (x = v.accountId) == null ? void 0 : x.message
            }
          );
        }
      }
    ],
    [
      u,
      m,
      v.accountId,
      (B = v.name) == null ? void 0 : B.message,
      (I = v.name) == null ? void 0 : I.type,
      y,
      c,
      g
    ]
  );
  return ve(() => ({
    submit: f,
    reset: h,
    register: g,
    control: m,
    inputs: E,
    formState: { errors: v },
    showCreateAccountModal: t,
    setShowCreateAccountModal: n
  }), [
    f,
    h,
    g,
    m,
    E,
    v,
    t
  ]);
}
function fT(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  } = e, a = lc(t), { submit: c, reset: u, inputs: l } = Jm({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  }), d = () => /* @__PURE__ */ A(Mi, { inputs: l }), h = {
    dependentItemName: "assets",
    dependentItemList: a.filter(
      (m) => m.spvId === (n == null ? void 0 : n.id)
    ).map((m) => /* @__PURE__ */ A("div", { children: m.name }, m.id))
  };
  return /* @__PURE__ */ A(ji, { ...e, ...{
    formInputs: d,
    dependentItemProps: h,
    submit: c,
    reset: u
  } });
}
const gT = [{ key: "name", label: "Name", allowSorting: !0 }];
function NL(e) {
  const { state: t } = e, { spvs: n } = t, r = "SPV", i = ve(() => Fr(n), [n]), [o, s] = q(), { operation: a, setOperation: c, showForm: u, existingState: l } = Zi({ state: t });
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      Wi,
      {
        ...e,
        itemName: r,
        tableData: i,
        columns: gT,
        selectedTableItem: o,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ),
    u && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      fT,
      {
        ...e,
        itemName: r,
        state: l,
        tableItem: o,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ) })
  ] });
}
function Jm(e) {
  var m, p;
  const { item: t, onSubmitCreate: n, onSubmitEdit: r, onSubmitDelete: i, operation: o } = e, s = {
    name: null
  }, a = t ? {
    id: t.id,
    name: t.name
  } : s, { submit: c, reset: u, register: l, control: d, formState: f } = zi({
    operation: o,
    createDefaultValues: s,
    editDefaultValues: a,
    onSubmitCreate: n,
    onSubmitEdit: r,
    onSubmitDelete: i
  }), { errors: h } = f, g = ve(
    () => [
      {
        label: "SPV name",
        Input: () => {
          var v, b;
          return /* @__PURE__ */ A(
            qt,
            {
              ...l("name", {
                disabled: o === "view",
                required: "SPV name is required"
              }),
              "aria-invalid": ((v = h.name) == null ? void 0 : v.type) === "required" ? "true" : "false",
              errorMessage: (b = h.name) == null ? void 0 : b.message,
              placeholder: "E.g. My SPV name"
            }
          );
        }
      }
    ],
    [(m = h.name) == null ? void 0 : m.message, (p = h.name) == null ? void 0 : p.type, o, l]
  );
  return ve(() => ({
    submit: c,
    reset: u,
    register: l,
    control: d,
    inputs: g,
    formState: f
  }), [c, u, l, d, g, f]);
}
function hT(e) {
  const t = ["Fees", "Service Provider", "Amount", ""];
  return /* @__PURE__ */ D(Be, { children: [
    e.feeInputs.length > 0 && /* @__PURE__ */ A("div", { className: "bg-gray-50 pl-5 pt-3", children: /* @__PURE__ */ D("table", { className: "w-full border-separate text-xs font-medium", children: [
      /* @__PURE__ */ A("thead", { className: "mb-2", children: /* @__PURE__ */ A("tr", { children: t.map((n) => /* @__PURE__ */ A(
        "th",
        {
          className: $(
            "py-2 text-left font-medium text-gray-600",
            n === "Amount" && !e.isViewOnly && "text-right"
          ),
          children: n
        },
        n
      )) }) }),
      /* @__PURE__ */ A("tbody", { children: e.feeInputs.map((n, r) => {
        var i, o, s, a;
        return /* @__PURE__ */ D("tr", { children: [
          /* @__PURE__ */ A("td", { className: "w-52" }),
          /* @__PURE__ */ A("td", { className: "w-96", children: /* @__PURE__ */ A(
            pr,
            {
              rules: {
                required: "Service provider is required"
              },
              control: e.control,
              name: `fees.${r}.serviceProviderFeeTypeId`,
              disabled: e.isViewOnly,
              options: e.serviceProviderFeeTypeOptions,
              addItemButtonProps: {
                onClick: () => e.setShowServiceProviderFeeTypeModal(
                  !0
                ),
                label: "Add Service Provider"
              },
              "aria-invalid": (o = (i = e.errors.fees) == null ? void 0 : i[r]) != null && o.serviceProviderFeeTypeId ? "true" : "false"
            }
          ) }),
          /* @__PURE__ */ A("td", { className: "w-52", children: /* @__PURE__ */ A(
            Ql,
            {
              rules: {
                required: "Amount is required",
                validate: {
                  positive: (c) => !!c && Number(c) > 0 || "Fee amount must be greater than zero"
                }
              },
              name: `fees.${r}.amount`,
              control: e.control,
              disabled: e.isViewOnly,
              currency: "USD",
              "aria-invalid": (a = (s = e.errors.fees) == null ? void 0 : s[r]) != null && a.amount ? "true" : "false",
              placeholder: "E.g. $1,000.00"
            }
          ) }),
          /* @__PURE__ */ A("td", { className: "", children: !e.isViewOnly && /* @__PURE__ */ A(
            "button",
            {
              type: "button",
              onClick: () => e.remove(r),
              className: "flex items-center",
              children: /* @__PURE__ */ A(
                Y,
                {
                  name: "Xmark",
                  className: "text-gray-900"
                }
              )
            }
          ) })
        ] }, n.id);
      }) })
    ] }) }),
    !e.isViewOnly && /* @__PURE__ */ D(
      "button",
      {
        onClick: () => {
          var n;
          return e.append({
            amount: null,
            serviceProviderFeeTypeId: (n = e.serviceProviderFeeTypes[0]) == null ? void 0 : n.id
          });
        },
        className: "ml-[234px] mt-1 flex w-fit items-center justify-center gap-x-2 rounded-lg bg-white pb-6 text-sm font-semibold text-gray-900",
        children: [
          /* @__PURE__ */ A("span", { children: "Add Fee" }),
          /* @__PURE__ */ A(Y, { name: "Plus", size: 16 })
        ]
      }
    )
  ] });
}
function pT(e) {
  return mT(e) ? e.length === 66 : !1;
}
function mT(e) {
  return typeof e == "string" && e.startsWith("0x");
}
const vT = Nt(function(t, n) {
  const { control: r, disabled: i } = t, o = Zn({ control: r, name: "txRef" }), s = 46, c = typeof o == "string" && o.length >= s ? `${o.slice(0, s)}...` : o, u = pT(o), l = /* @__PURE__ */ D("div", { children: [
    /* @__PURE__ */ A("p", { children: o }),
    u && /* @__PURE__ */ A("p", { className: "mt-2 text-center", children: /* @__PURE__ */ A(
      "a",
      {
        className: "text-blue-900 underline",
        href: `https://etherscan.io/tx/${o}`,
        children: "View on Etherscan"
      }
    ) })
  ] });
  return i ? /* @__PURE__ */ A(vm, { children: /* @__PURE__ */ A(Nr, { content: l, children: /* @__PURE__ */ A("span", { children: c }) }) }) : /* @__PURE__ */ A(qt, { ...t, ref: n });
});
function bT(e) {
  const { control: t } = e, n = Zn({ control: t, name: "cashAmount" }), r = Zn({ control: t, name: "fixedIncomeAmount" }), i = OT(n, r);
  return /* @__PURE__ */ D("div", { className: $("mt-1 w-fit", !e.isViewOnly && "ml-auto"), children: [
    /* @__PURE__ */ A("span", { className: "text-gray-600", children: "Unit Price" }),
    " ",
    /* @__PURE__ */ A("span", { className: "text-gray-900", children: /* @__PURE__ */ A(bA, { value: i, decimalScale: 6 }) })
  ] });
}
function yT(e) {
  var W, U, ee, Ae;
  const [t, n] = q(!1), [
    r,
    i
  ] = q(!1), {
    item: o,
    state: s,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u,
    operation: l
  } = e, { serviceProviderFeeTypes: d, accounts: f } = s, h = ve(() => lc(s), [s]), g = Vl.map((ne) => ({
    label: BA[ne],
    value: ne
  })), m = h.map((ne) => ({
    label: Km(ne),
    value: ne.id
  })), p = {
    type: Vl[0],
    entryTime: s0(/* @__PURE__ */ new Date()),
    cashAmount: null,
    fixedIncomeId: ((W = h[0]) == null ? void 0 : W.id) ?? null,
    fixedIncomeAmount: null,
    serviceProviderFeeTypeId: null,
    fees: null,
    txRef: null
  }, v = o ? {
    id: o.id,
    type: o.type,
    entryTime: s0(o.entryTime),
    cashAmount: o.cashTransaction.amount ?? null,
    fixedIncomeId: ((U = o.fixedIncomeTransaction) == null ? void 0 : U.assetId) ?? null,
    fixedIncomeAmount: ((ee = o.fixedIncomeTransaction) == null ? void 0 : ee.amount) ?? null,
    serviceProviderFeeTypeId: o.serviceProviderFeeTypeId ?? null,
    fees: o.fees ?? null,
    txRef: o.txRef ?? null
  } : p, { submit: b, reset: y, register: E, watch: C, control: B, formState: I } = zi({
    operation: l,
    createDefaultValues: p,
    editDefaultValues: v,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u,
    customSubmitHandler: F
  }), x = Zn({ control: B, name: "type" }), O = !!x && EA.includes(x), k = !!x && xA.includes(x), Q = !k;
  function F(ne) {
    if (!l || l === "view") return;
    const K = ne.id, ae = ne.type, pe = ne.entryTime, Pe = ne.cashAmount, Qe = O ? ne.fixedIncomeId : null, et = ne.serviceProviderFeeTypeId ?? null, st = O ? ne.fixedIncomeAmount : null, re = ne.txRef ?? null, Ge = Q ? ne.fees : null, at = {
      create: a,
      edit: c,
      delete: u
    }[l];
    at == null || at({
      id: K,
      type: ae,
      entryTime: pe,
      cashAmount: Pe,
      fixedIncomeId: Qe,
      fixedIncomeAmount: st,
      serviceProviderFeeTypeId: et,
      fees: Ge,
      txRef: re
    });
  }
  const { errors: M } = I, { fields: H, append: T, remove: R } = Bw({
    control: B,
    name: "fees"
  }), z = ve(
    () => d.map((ne) => {
      var K;
      return {
        label: `${ne.name} — ${ne.feeType} — ${(K = f.find((ae) => ae.id === ne.accountId)) == null ? void 0 : K.reference}`,
        value: ne.id
      };
    }),
    [d, f]
  ), L = C("entryTime") || ((Ae = I.defaultValues) == null ? void 0 : Ae.entryTime), X = [
    {
      label: "Transaction Type",
      Input: () => {
        var ne;
        return /* @__PURE__ */ A(
          pr,
          {
            control: B,
            name: "type",
            disabled: l === "view",
            options: g,
            rules: { required: "Transaction type is required" },
            "aria-invalid": M.type ? "true" : "false",
            errorMessage: (ne = M.type) == null ? void 0 : ne.message
          }
        );
      }
    },
    {
      label: "Entry Time",
      Input: () => /* @__PURE__ */ A(
        t3,
        {
          ...E("entryTime", {
            required: !0,
            disabled: l === "view"
          }),
          name: "entryTime"
        }
      ),
      inputLabel: L ? OA(new Date(L)) : null
    },
    k ? {
      label: "Service Provider",
      Input: () => /* @__PURE__ */ A(
        pr,
        {
          control: B,
          name: "serviceProviderFeeTypeId",
          disabled: l === "view",
          options: z,
          addItemButtonProps: {
            onClick: () => i(
              !0
            ),
            label: "Add Service Provider"
          }
        }
      )
    } : null,
    O ? {
      label: "Asset name",
      Input: () => {
        var ne;
        return /* @__PURE__ */ A(
          pr,
          {
            control: B,
            name: "fixedIncomeId",
            disabled: l === "view",
            options: m,
            addItemButtonProps: {
              onClick: () => n(!0),
              label: "Create Asset"
            },
            rules: { required: "Asset name is required" },
            "aria-invalid": M.type ? "true" : "false",
            errorMessage: (ne = M.type) == null ? void 0 : ne.message
          }
        );
      }
    } : void 0,
    O ? {
      label: "Quantity",
      Input: () => {
        var ne;
        return /* @__PURE__ */ A(
          Ql,
          {
            name: "fixedIncomeAmount",
            rules: {
              required: "Quantity is required",
              validate: {
                positive: (K) => !!K && Number(K) > 0 || "Asset proceeds must be greater than zero"
              }
            },
            disabled: l === "view",
            control: B,
            "aria-invalid": M.fixedIncomeAmount ? "true" : "false",
            errorMessage: (ne = M.fixedIncomeAmount) == null ? void 0 : ne.message,
            placeholder: "E.g. 1,000.00"
          }
        );
      }
    } : void 0,
    {
      label: O ? "Asset Proceeds" : "Cash Amount",
      Input: () => {
        var ne;
        return /* @__PURE__ */ D(Be, { children: [
          /* @__PURE__ */ A(
            Ql,
            {
              name: "cashAmount",
              rules: {
                required: "Asset proceeds is required",
                validate: {
                  positive: (K) => !!K && Number(K) > 0 || "Asset proceeds must be greater than zero"
                }
              },
              currency: "USD",
              disabled: l === "view",
              control: B,
              "aria-invalid": M.cashAmount ? "true" : "false",
              errorMessage: (ne = M.cashAmount) == null ? void 0 : ne.message,
              placeholder: "E.g. $1,000.00"
            }
          ),
          O && /* @__PURE__ */ A(
            bT,
            {
              control: B,
              isViewOnly: l === "view"
            }
          )
        ] });
      }
    },
    {
      label: "Transaction reference",
      Input: () => {
        var ne;
        return /* @__PURE__ */ A(
          vT,
          {
            ...E("txRef", {
              disabled: l === "view"
            }),
            control: B,
            "aria-invalid": M.txRef ? "true" : "false",
            errorMessage: (ne = M.txRef) == null ? void 0 : ne.message,
            placeholder: "E.g. 0x123..."
          }
        );
      }
    }
  ].filter(Boolean);
  return ve(() => ({
    submit: b,
    reset: y,
    register: E,
    append: T,
    watch: C,
    fields: H,
    remove: R,
    control: B,
    inputs: X,
    formState: I,
    serviceProviderFeeTypeOptions: z,
    showCreateAssetModal: t,
    setShowCreateAssetModal: n,
    showCreateServiceProviderFeeTypeModal: r,
    setShowCreateServiceProviderFeeTypeModal: i,
    canHaveTransactionFees: Q
  }), [
    b,
    y,
    E,
    T,
    C,
    H,
    R,
    B,
    X,
    I,
    z,
    t,
    r,
    Q
  ]);
}
function CT(e) {
  const { control: t } = e, n = Zn({ control: t, name: "cashAmount" }), r = Zn({ control: t, name: "type" }), i = Zn({ control: t, name: "fees" }), o = DT(
    r,
    n,
    i
  );
  return /* @__PURE__ */ A(Be, { children: /* @__PURE__ */ D("div", { className: "flex items-center justify-between border-t border-gray-300 bg-gray-100 p-3 font-semibold text-gray-800", children: [
    /* @__PURE__ */ A("div", { className: "mr-6 text-sm text-gray-600", children: "Cash Balance Change $USD" }),
    /* @__PURE__ */ A("div", { className: "h-px flex-1 border-b border-dashed border-gray-400" }),
    /* @__PURE__ */ A("div", { className: "pl-8 text-sm text-gray-900", children: /* @__PURE__ */ A(bA, { value: o }) })
  ] }) });
}
function IT(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s,
    onSubmitCreateAsset: a,
    onSubmitCreateServiceProviderFeeType: c
  } = e, { serviceProviderFeeTypes: u } = t, {
    submit: l,
    reset: d,
    formState: f,
    inputs: h,
    register: g,
    control: m,
    watch: p,
    append: v,
    remove: b,
    fields: y,
    serviceProviderFeeTypeOptions: E,
    showCreateAssetModal: C,
    setShowCreateAssetModal: B,
    setShowCreateServiceProviderFeeTypeModal: I,
    showCreateServiceProviderFeeTypeModal: x,
    canHaveTransactionFees: O
  } = yT({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: i,
    onSubmitEdit: o,
    onSubmitDelete: s
  }), { errors: k } = f, Q = Lm({
    state: t,
    operation: "create",
    onSubmitCreate: (H) => {
      a(H), B(!1);
    }
  }), F = Um({
    state: t,
    operation: "create",
    onSubmitCreate: (H) => {
      c(H), I(!1);
    }
  });
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ A(
      ji,
      {
        ...e,
        formInputs: () => /* @__PURE__ */ D(Be, { children: [
          /* @__PURE__ */ A(Mi, { inputs: h }),
          O && /* @__PURE__ */ A(
            hT,
            {
              register: g,
              feeInputs: y,
              serviceProviderFeeTypes: u,
              serviceProviderFeeTypeOptions: E,
              setShowServiceProviderFeeTypeModal: I,
              control: m,
              watch: p,
              remove: b,
              append: v,
              errors: k,
              isViewOnly: r === "view"
            }
          ),
          /* @__PURE__ */ A(CT, { control: m })
        ] }),
        submit: l,
        reset: d
      }
    ),
    C && /* @__PURE__ */ A(
      Yo,
      {
        ...e,
        ...Q,
        open: C,
        onOpenChange: B,
        itemName: "Asset"
      }
    ),
    x && /* @__PURE__ */ A(
      Yo,
      {
        ...e,
        ...F,
        open: x,
        onOpenChange: I,
        itemName: "Service Provider Fee Type"
      }
    )
  ] });
}
const ET = Hr(IT), xT = [
  {
    key: "typeLabel",
    label: "Type",
    allowSorting: !0
  },
  {
    key: "entryTime",
    label: "Entry Time",
    allowSorting: !0
  },
  {
    key: "asset",
    label: "Asset",
    allowSorting: !0
  },
  {
    key: "quantity",
    label: "Quantity",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "cashAmount",
    label: "Cash Amount ($)",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "totalFees",
    label: "Total Fees ($)",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "cashBalanceChange",
    label: "Cash Balance Change ($)",
    allowSorting: !0,
    isNumberColumn: !0
  }
];
function du(e, t) {
  return e && e * t;
}
function BT(e, t) {
  if (!(e != null && e.length)) return [];
  const n = e.map((r) => {
    var m, p, v;
    const i = r.id, o = r.entryTime, s = (m = t == null ? void 0 : t.find(
      (b) => {
        var y;
        return b.id === ((y = r.fixedIncomeTransaction) == null ? void 0 : y.assetId);
      }
    )) == null ? void 0 : m.name, a = r.type, c = BA[a], u = Wm[a], l = AR(a) ? xN[a] : 1, d = du(
      (p = r.fixedIncomeTransaction) == null ? void 0 : p.amount,
      l
    ), f = du(
      r.cashTransaction.amount,
      u
    ), h = xA.includes(r.type) ? du(
      r.cashTransaction.amount,
      r.type === IA ? -1 : 1
    ) ?? 0 : ((v = r.fees) == null ? void 0 : v.reduce((b, y) => b + y.amount, 0)) ?? 0, g = r.cashBalanceChange;
    return {
      ...r,
      id: i,
      type: a,
      typeLabel: c,
      entryTime: o,
      asset: s,
      quantity: d,
      cashAmount: f,
      totalFees: h,
      cashBalanceChange: g
    };
  });
  return Fr(n);
}
function wT(e) {
  const t = "Group Transaction", { state: n, itemsPerPage: r = 20, initialPage: i = 0, pageRange: o = 3 } = e, [s, a] = q(), { transactions: c, portfolio: u } = n, { operation: l, setOperation: d, showForm: f, existingState: h } = Zi({ state: n }), g = u.filter((W) => A9(W)), [m, p] = q(c), [v, b] = q(), [y, E] = q([]);
  Ie(() => {
    if (!v && !y.length) {
      p(c);
      return;
    }
    p(
      c.filter((W) => {
        var U, ee;
        if (v && y.length)
          return ((U = W.fixedIncomeTransaction) == null ? void 0 : U.assetId) === v && y.includes(W.type);
        if (v)
          return ((ee = W.fixedIncomeTransaction) == null ? void 0 : ee.assetId) === v;
        if (y.length)
          return y.includes(W.type);
      })
    );
  }, [v, y, c]);
  const C = ve(
    () => g.map((W) => ({
      label: Km(W),
      value: W.id
    })),
    [g]
  ), B = ve(
    () => Vl.map((W) => ({
      label: BA[W],
      value: W
    })),
    []
  ), I = ve(
    () => Fr(
      BT(
        m,
        g
      )
    ),
    [m, g]
  ), {
    pageItems: x,
    pages: O,
    goToPage: k,
    goToNextPage: Q,
    goToPreviousPage: F,
    goToFirstPage: M,
    goToLastPage: H,
    hiddenNextPages: T,
    isNextPageAvailable: R,
    isPreviousPageAvailable: z
  } = hd(I, {
    pageRange: o,
    initialPage: i,
    itemsPerPage: r
  });
  function L(W) {
    if (!W || typeof W != "object" || !("value" in W)) {
      b(void 0);
      return;
    }
    const { value: U } = W;
    b(U);
  }
  function X(W) {
    if (!W || !Array.isArray(W)) {
      E([]);
      return;
    }
    E(W.map(({ value: ee }) => ee));
  }
  return /* @__PURE__ */ D(Be, { children: [
    /* @__PURE__ */ D("div", { className: "mb-2 flex gap-2", children: [
      /* @__PURE__ */ A("div", { className: "min-w-72 max-w-96", children: /* @__PURE__ */ A(
        Mu,
        {
          options: C,
          onChange: L,
          isClearable: !0,
          placeholder: "Filter by Asset"
        }
      ) }),
      /* @__PURE__ */ A("div", { className: "min-w-72 max-w-96", children: /* @__PURE__ */ A(
        Mu,
        {
          options: B,
          onChange: X,
          isClearable: !0,
          isMulti: !0,
          placeholder: "Filter by Type"
        }
      ) }),
      /* @__PURE__ */ A("div", { className: "flex w-full justify-end", children: /* @__PURE__ */ A(
        fd,
        {
          pages: O,
          hiddenNextPages: T,
          goToFirstPage: M,
          goToLastPage: H,
          goToNextPage: Q,
          goToPage: k,
          goToPreviousPage: F,
          isNextPageAvailable: R,
          isPreviousPageAvailable: z,
          nextPageLabel: "Next",
          previousPageLabel: "Previous"
        }
      ) })
    ] }),
    /* @__PURE__ */ A(
      Wi,
      {
        ...e,
        state: n,
        itemName: t,
        tableData: x,
        columns: xT,
        selectedTableItem: s,
        operation: l,
        setSelectedTableItem: a,
        setOperation: d
      }
    ),
    f && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      ET,
      {
        ...e,
        itemName: t,
        state: h,
        tableItem: s,
        operation: l,
        setSelectedTableItem: a,
        setOperation: d
      }
    ) })
  ] });
}
function Km(e) {
  let t = e.name;
  return e.ISIN && (t += ` - ${e.ISIN}`), e.CUSIP && (t += ` - ${e.CUSIP}`), t;
}
function PT(e) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e)) return !1;
  const t = new Date(e);
  return t instanceof Date && !isNaN(t.getTime()) && t.toISOString() === e;
}
function HT(e, t = !0) {
  if (e instanceof Date || PT(e)) {
    const r = e instanceof Date ? e.toISOString() : e;
    return OA(r, t);
  }
  return e;
}
function un(e, t = 2, n = !0) {
  return e == null ? "--" : typeof e == "number" ? /* @__PURE__ */ A(bA, { value: e, decimalScale: t }) : HT(e, n);
}
function TL(e, t) {
  return t == null ? void 0 : t.find((n) => n.id === e);
}
function Fr(e, t) {
  return e.map((n, r) => ({
    ...n,
    itemNumber: r + 1,
    customTransform: t
  }));
}
function OT(e, t) {
  return !e || !t ? 0 : e / t;
}
function DT(e, t, n) {
  if (!t || !e) return 0;
  const r = Wm[e], o = ((n == null ? void 0 : n.map((s) => s.amount).filter(Boolean)) ?? []).reduce((s, a) => s + a, 0);
  return t * r - o;
}
function RL(e) {
  const { otherTableComponents: t } = e;
  return /* @__PURE__ */ A("div", { children: t.map(
    ({ Component: n, value: r, label: i, description: o }) => /* @__PURE__ */ D("div", { children: [
      /* @__PURE__ */ A("h2", { className: "mb-2 text-lg font-bold", children: i }),
      /* @__PURE__ */ A("p", { className: "mb-4 text-xs text-gray-600", children: o }),
      /* @__PURE__ */ A(n, {})
    ] }, r)
  ) });
}
function _m(e) {
  const { label: t, description: n, children: r } = e;
  return /* @__PURE__ */ D("div", { children: [
    /* @__PURE__ */ A("h1", { className: "mb-2 text-lg font-bold", children: t }),
    /* @__PURE__ */ A("p", { className: "mb-4 text-xs text-gray-600", children: n }),
    r
  ] });
}
function LL(e) {
  return /* @__PURE__ */ A(_m, { ...{
    label: "Portfolio",
    description: "Details on the distribution of assets among different financial institutions or investment vehicles."
  }, children: /* @__PURE__ */ A(uN, { ...e }) });
}
var wA = "Tabs", [ST, FL] = _n(wA, [
  Xa
]), $m = Xa(), [NT, PA] = ST(wA), e9 = w.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: s = "horizontal",
      dir: a,
      activationMode: c = "automatic",
      ...u
    } = e, l = Wl(a), [d, f] = $o({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ A(
      NT,
      {
        scope: n,
        baseId: Mn(),
        value: d,
        onValueChange: f,
        orientation: s,
        dir: l,
        activationMode: c,
        children: /* @__PURE__ */ A(
          Me.div,
          {
            dir: l,
            "data-orientation": s,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
e9.displayName = wA;
var t9 = "TabsList", n9 = w.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = e, o = PA(t9, n), s = $m(n);
    return /* @__PURE__ */ A(
      og,
      {
        asChild: !0,
        ...s,
        orientation: o.orientation,
        dir: o.dir,
        loop: r,
        children: /* @__PURE__ */ A(
          Me.div,
          {
            role: "tablist",
            "aria-orientation": o.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
n9.displayName = t9;
var r9 = "TabsTrigger", i9 = w.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = e, s = PA(r9, n), a = $m(n), c = a9(s.baseId, r), u = c9(s.baseId, r), l = r === s.value;
    return /* @__PURE__ */ A(
      sg,
      {
        asChild: !0,
        ...a,
        focusable: !i,
        active: l,
        children: /* @__PURE__ */ A(
          Me.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": l,
            "aria-controls": u,
            "data-state": l ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: c,
            ...o,
            ref: t,
            onMouseDown: he(e.onMouseDown, (d) => {
              !i && d.button === 0 && d.ctrlKey === !1 ? s.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: he(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && s.onValueChange(r);
            }),
            onFocus: he(e.onFocus, () => {
              const d = s.activationMode !== "manual";
              !l && !i && d && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
i9.displayName = r9;
var o9 = "TabsContent", s9 = w.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: o, ...s } = e, a = PA(o9, n), c = a9(a.baseId, r), u = c9(a.baseId, r), l = r === a.value, d = w.useRef(l);
    return w.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ A(Kt, { present: i || l, children: ({ present: f }) => /* @__PURE__ */ A(
      Me.div,
      {
        "data-state": l ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !f,
        id: u,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && o
      }
    ) });
  }
);
s9.displayName = o9;
function a9(e, t) {
  return `${e}-trigger-${t}`;
}
function c9(e, t) {
  return `${e}-content-${t}`;
}
var TT = e9, RT = n9, LT = i9, FT = s9;
function QL(e) {
  const { tabComponents: t } = e;
  return /* @__PURE__ */ D(TT, { defaultValue: Xm, children: [
    /* @__PURE__ */ D("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ A(RT, { className: "flex gap-x-2 rounded-xl bg-slate-50 p-1 text-sm font-semibold text-gray-600 outline-none", children: t.map(({ value: n, label: r, disabled: i }) => /* @__PURE__ */ A(
        LT,
        {
          value: n,
          disabled: i,
          className: "data-[state='active']:tab-shadow data-disabled:cursor-not-allowed data-disabled:text-gray-400 h-7 w-32 rounded-lg  transition duration-300 data-[state='active']:bg-gray-50 data-[state='active']:text-gray-900",
          children: r
        },
        n
      )) }),
      /* @__PURE__ */ A(BC, { ...e })
    ] }),
    /* @__PURE__ */ A("div", { className: "mt-3 rounded-md bg-slate-50 p-8", children: t.map(({ value: n, Component: r }) => /* @__PURE__ */ A(FT, { value: n, children: /* @__PURE__ */ A(r, {}) }, n)) })
  ] });
}
function XL(e) {
  return /* @__PURE__ */ A(_m, { ...{
    label: "Transactions",
    description: "Details on the distribution of assets among different financial institutions or investment vehicles."
  }, children: /* @__PURE__ */ A(wT, { ...e }) });
}
function J1(e, t, n) {
  const r = VT(e, n.timeZone, n.locale);
  return "formatToParts" in r ? QT(r, t) : XT(r, t);
}
function QT(e, t) {
  const n = e.formatToParts(t);
  for (let r = n.length - 1; r >= 0; --r)
    if (n[r].type === "timeZoneName")
      return n[r].value;
}
function XT(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
  return r ? r[0].substr(1) : "";
}
function VT(e, t, n) {
  return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function kT(e, t) {
  const n = WT(t);
  return "formatToParts" in n ? zT(n, e) : jT(n, e);
}
const MT = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function zT(e, t) {
  try {
    const n = e.formatToParts(t), r = [];
    for (let i = 0; i < n.length; i++) {
      const o = MT[n[i].type];
      o !== void 0 && (r[o] = parseInt(n[i].value, 10));
    }
    return r;
  } catch (n) {
    if (n instanceof RangeError)
      return [NaN];
    throw n;
  }
}
function jT(e, t) {
  const n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [
    parseInt(r[3], 10),
    parseInt(r[1], 10),
    parseInt(r[2], 10),
    parseInt(r[4], 10),
    parseInt(r[5], 10),
    parseInt(r[6], 10)
  ];
}
const Au = {};
function WT(e) {
  if (!Au[e]) {
    const t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Au[e] = n ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Au[e];
}
function u9(e, t, n, r, i, o, s) {
  const a = /* @__PURE__ */ new Date(0);
  return a.setUTCFullYear(e, t, n), a.setUTCHours(r, i, o, s), a;
}
const K1 = 36e5, ZT = 6e4, fu = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function HA(e, t, n) {
  if (!e)
    return 0;
  let r = fu.timezoneZ.exec(e);
  if (r)
    return 0;
  let i, o;
  if (r = fu.timezoneHH.exec(e), r)
    return i = parseInt(r[1], 10), _1(i) ? -(i * K1) : NaN;
  if (r = fu.timezoneHHMM.exec(e), r) {
    i = parseInt(r[2], 10);
    const s = parseInt(r[3], 10);
    return _1(i, s) ? (o = Math.abs(i) * K1 + s * ZT, r[1] === "+" ? -o : o) : NaN;
  }
  if (YT(e)) {
    t = new Date(t || Date.now());
    const s = n ? t : GT(t), a = kl(s, e);
    return -(n ? a : qT(t, a, e));
  }
  return NaN;
}
function GT(e) {
  return u9(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function kl(e, t) {
  const n = kT(e, t), r = u9(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime();
  let i = e.getTime();
  const o = i % 1e3;
  return i -= o >= 0 ? o : 1e3 + o, r - i;
}
function qT(e, t, n) {
  let i = e.getTime() - t;
  const o = kl(new Date(i), n);
  if (t === o)
    return t;
  i -= o - t;
  const s = kl(new Date(i), n);
  return o === s ? o : Math.max(o, s);
}
function _1(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const $1 = {};
function YT(e) {
  if ($1[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), $1[e] = !0, !0;
  } catch {
    return !1;
  }
}
const UT = 60 * 1e3, JT = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = gu(n.timeZone, e);
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return e0(r);
      case "XXXX":
      case "XX":
        return Gr(r);
      case "XXXXX":
      case "XXX":
      default:
        return Gr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = gu(n.timeZone, e);
    switch (t) {
      case "x":
        return e0(r);
      case "xxxx":
      case "xx":
        return Gr(r);
      case "xxxxx":
      case "xxx":
      default:
        return Gr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = gu(n.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + KT(r, ":");
      case "OOOO":
      default:
        return "GMT" + Gr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return J1("short", e, n);
      case "zzzz":
      default:
        return J1("long", e, n);
    }
  }
};
function gu(e, t) {
  const n = e ? HA(e, t, !0) / UT : (t == null ? void 0 : t.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(n))
    throw new RangeError("Invalid time zone specified: " + e);
  return n;
}
function Ha(e, t) {
  const n = e < 0 ? "-" : "";
  let r = Math.abs(e).toString();
  for (; r.length < t; )
    r = "0" + r;
  return n + r;
}
function Gr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Ha(Math.floor(r / 60), 2), o = Ha(Math.floor(r % 60), 2);
  return n + i + t + o;
}
function e0(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ha(Math.abs(e) / 60, 2) : Gr(e, t);
}
function KT(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + t + Ha(o, 2);
}
function t0(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const _T = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, hu = 36e5, n0 = 6e4, $T = 2, mt = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: _T
};
function l9(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = t.additionalDigits == null ? $T : Number(t.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const r = eR(e), { year: i, restDateString: o } = tR(r.date, n), s = nR(o, i);
  if (s === null || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (s) {
    const a = s.getTime();
    let c = 0, u;
    if (r.time && (c = rR(r.time), c === null || isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || t.timeZone) {
      if (u = HA(r.timeZone || t.timeZone, new Date(a + c)), isNaN(u))
        return /* @__PURE__ */ new Date(NaN);
    } else
      u = t0(new Date(a + c)), u = t0(new Date(a + c + u));
    return new Date(a + c + u);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function eR(e) {
  const t = {};
  let n = mt.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = mt.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    const i = mt.timeZone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
  }
  return t;
}
function tR(e, t) {
  if (e) {
    const n = mt.YYY[t], r = mt.YYYYY[t];
    let i = mt.YYYY.exec(e) || r.exec(e);
    if (i) {
      const o = i[1];
      return {
        year: parseInt(o, 10),
        restDateString: e.slice(o.length)
      };
    }
    if (i = mt.YY.exec(e) || n.exec(e), i) {
      const o = i[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: e.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function nR(e, t) {
  if (t === null)
    return null;
  let n, r, i;
  if (!e || !e.length)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  let o = mt.MM.exec(e);
  if (o)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(o[1], 10) - 1, i0(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
  if (o = mt.DDD.exec(e), o) {
    n = /* @__PURE__ */ new Date(0);
    const s = parseInt(o[1], 10);
    return sR(t, s) ? (n.setUTCFullYear(t, 0, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = mt.MMDD.exec(e), o) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(o[1], 10) - 1;
    const s = parseInt(o[2], 10);
    return i0(t, r, s) ? (n.setUTCFullYear(t, r, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = mt.Www.exec(e), o)
    return i = parseInt(o[1], 10) - 1, o0(i) ? r0(t, i) : /* @__PURE__ */ new Date(NaN);
  if (o = mt.WwwD.exec(e), o) {
    i = parseInt(o[1], 10) - 1;
    const s = parseInt(o[2], 10) - 1;
    return o0(i, s) ? r0(t, i, s) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function rR(e) {
  let t, n, r = mt.HH.exec(e);
  if (r)
    return t = parseFloat(r[1].replace(",", ".")), pu(t) ? t % 24 * hu : NaN;
  if (r = mt.HHMM.exec(e), r)
    return t = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), pu(t, n) ? t % 24 * hu + n * n0 : NaN;
  if (r = mt.HHMMSS.exec(e), r) {
    t = parseInt(r[1], 10), n = parseInt(r[2], 10);
    const i = parseFloat(r[3].replace(",", "."));
    return pu(t, n, i) ? t % 24 * hu + n * n0 + i * 1e3 : NaN;
  }
  return null;
}
function r0(e, t, n) {
  t = t || 0, n = n || 0;
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const i = r.getUTCDay() || 7, o = t * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const iR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], oR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function d9(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function i0(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    const r = d9(e);
    if (r && n > oR[t] || !r && n > iR[t])
      return !1;
  }
  return !0;
}
function sR(e, t) {
  if (t < 1)
    return !1;
  const n = d9(e);
  return !(n && t > 366 || !n && t > 365);
}
function o0(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function pu(e, t, n) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
const aR = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function cR(e, t, n = {}) {
  t = String(t);
  const r = t.match(aR);
  if (r) {
    const i = l9(n.originalDate || e, n);
    t = r.reduce(function(o, s) {
      if (s[0] === "'")
        return o;
      const a = o.indexOf(s), c = o[a - 1] === "'", u = o.replace(s, "'" + JT[s[0]](i, s, n) + "'");
      return c ? u.substring(0, a - 1) + u.substring(a + 1) : u;
    }, t);
  }
  return Hi(e, t, n);
}
function uR(e, t, n) {
  e = l9(e, n);
  const r = HA(t, e, !0), i = new Date(e.getTime() - r), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
}
function lR(e, t, n, r) {
  return r = {
    ...r,
    timeZone: t,
    originalDate: e
  }, cR(uR(e, t, { timeZone: r.timeZone }), n, r);
}
function s0(e = /* @__PURE__ */ new Date()) {
  return Hi(e, "yyyy-MM-dd'T'HH:mm");
}
function dR(e = /* @__PURE__ */ new Date()) {
  return Hi(e, "yyyy-MM-dd");
}
function OA(e, t = !0) {
  return lR(e, "UTC", t ? "yyyy/MM/dd, HH:mm:ss zzz" : "yyyy/MM/dd");
}
function AR(e) {
  return EA.includes(e);
}
function A9(e) {
  return e ? e.type === "FixedIncome" || "fixedIncomeId" in e : !1;
}
function fR(e) {
  return e ? e.type === "Cash" || "currency" in e : !1;
}
function lc(e) {
  return e.portfolio.filter((t) => A9(t));
}
function gR(e) {
  return e.portfolio.find((t) => fR(t));
}
var f9 = {}, g9 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(r, i) {
    return {
      handler: r,
      config: i
    };
  }
  t.withOptions = function(r, i = () => ({})) {
    const o = function(s) {
      return {
        __options: s,
        handler: r(s),
        config: i(s)
      };
    };
    return o.__isOptionsFunction = !0, o.__pluginFunction = r, o.__configFunction = i, o;
  };
  const n = t;
})(g9);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const t = /* @__PURE__ */ n(g9);
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const r = t.default;
})(f9);
let mu = f9;
var h9 = (mu.__esModule ? mu : { default: mu }).default;
const hR = /* @__PURE__ */ Li(h9), pR = h9;
function a0(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t]) => t !== "DEFAULT")
  );
}
var mR = pR(
  ({ addUtilities: e, matchUtilities: t, theme: n }) => {
    e({
      "@keyframes enter": n("keyframes.enter"),
      "@keyframes exit": n("keyframes.exit"),
      ".animate-in": {
        animationName: "enter",
        animationDuration: n("animationDuration.DEFAULT"),
        "--tw-enter-opacity": "initial",
        "--tw-enter-scale": "initial",
        "--tw-enter-rotate": "initial",
        "--tw-enter-translate-x": "initial",
        "--tw-enter-translate-y": "initial"
      },
      ".animate-out": {
        animationName: "exit",
        animationDuration: n("animationDuration.DEFAULT"),
        "--tw-exit-opacity": "initial",
        "--tw-exit-scale": "initial",
        "--tw-exit-rotate": "initial",
        "--tw-exit-translate-x": "initial",
        "--tw-exit-translate-y": "initial"
      }
    }), t(
      {
        "fade-in": (r) => ({ "--tw-enter-opacity": r }),
        "fade-out": (r) => ({ "--tw-exit-opacity": r })
      },
      { values: n("animationOpacity") }
    ), t(
      {
        "zoom-in": (r) => ({ "--tw-enter-scale": r }),
        "zoom-out": (r) => ({ "--tw-exit-scale": r })
      },
      { values: n("animationScale") }
    ), t(
      {
        "spin-in": (r) => ({ "--tw-enter-rotate": r }),
        "spin-out": (r) => ({ "--tw-exit-rotate": r })
      },
      { values: n("animationRotate") }
    ), t(
      {
        "slide-in-from-top": (r) => ({
          "--tw-enter-translate-y": `-${r}`
        }),
        "slide-in-from-bottom": (r) => ({
          "--tw-enter-translate-y": r
        }),
        "slide-in-from-left": (r) => ({
          "--tw-enter-translate-x": `-${r}`
        }),
        "slide-in-from-right": (r) => ({
          "--tw-enter-translate-x": r
        }),
        "slide-out-to-top": (r) => ({
          "--tw-exit-translate-y": `-${r}`
        }),
        "slide-out-to-bottom": (r) => ({
          "--tw-exit-translate-y": r
        }),
        "slide-out-to-left": (r) => ({
          "--tw-exit-translate-x": `-${r}`
        }),
        "slide-out-to-right": (r) => ({
          "--tw-exit-translate-x": r
        })
      },
      { values: n("animationTranslate") }
    ), t(
      { duration: (r) => ({ animationDuration: r }) },
      { values: a0(n("animationDuration")) }
    ), t(
      { delay: (r) => ({ animationDelay: r }) },
      { values: n("animationDelay") }
    ), t(
      { ease: (r) => ({ animationTimingFunction: r }) },
      { values: a0(n("animationTimingFunction")) }
    ), e({
      ".running": { animationPlayState: "running" },
      ".paused": { animationPlayState: "paused" }
    }), t(
      { "fill-mode": (r) => ({ animationFillMode: r }) },
      { values: n("animationFillMode") }
    ), t(
      { direction: (r) => ({ animationDirection: r }) },
      { values: n("animationDirection") }
    ), t(
      { repeat: (r) => ({ animationIterationCount: r }) },
      { values: n("animationRepeat") }
    );
  },
  {
    theme: {
      extend: {
        animationDelay: ({ theme: e }) => ({
          ...e("transitionDelay")
        }),
        animationDuration: ({ theme: e }) => ({
          0: "0ms",
          ...e("transitionDuration")
        }),
        animationTimingFunction: ({ theme: e }) => ({
          ...e("transitionTimingFunction")
        }),
        animationFillMode: {
          none: "none",
          forwards: "forwards",
          backwards: "backwards",
          both: "both"
        },
        animationDirection: {
          normal: "normal",
          reverse: "reverse",
          alternate: "alternate",
          "alternate-reverse": "alternate-reverse"
        },
        animationOpacity: ({ theme: e }) => ({
          DEFAULT: 0,
          ...e("opacity")
        }),
        animationTranslate: ({ theme: e }) => ({
          DEFAULT: "100%",
          ...e("translate")
        }),
        animationScale: ({ theme: e }) => ({
          DEFAULT: 0,
          ...e("scale")
        }),
        animationRotate: ({ theme: e }) => ({
          DEFAULT: "30deg",
          ...e("rotate")
        }),
        animationRepeat: {
          0: "0",
          1: "1",
          infinite: "infinite"
        },
        keyframes: {
          enter: {
            from: {
              opacity: "var(--tw-enter-opacity, 1)",
              transform: "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))"
            }
          },
          exit: {
            to: {
              opacity: "var(--tw-exit-opacity, 1)",
              transform: "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))"
            }
          }
        }
      }
    }
  }
);
const vR = /* @__PURE__ */ Li(mR);
var p9 = {}, m9 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return Array.isArray(n) ? n.map((r) => t(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, i]) => [
      r,
      t(i)
    ])) : n;
  }
})(m9);
var bR = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      ...e("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  const t = m9, n = /* @__PURE__ */ r(bR);
  function r(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  const i = (0, t.cloneDeep)(n.default.theme);
})(p9);
let vu = p9;
var yR = (vu.__esModule ? vu : { default: vu }).default;
const bu = /* @__PURE__ */ Li(yR), CR = {
  fontFamily: {
    sans: ["Inter", ...bu.fontFamily.sans]
  },
  fontSize: {
    ...bu.fontSize,
    xs: ["0.75rem", "1.125rem"],
    sm: ["0.875rem", "1.5rem"],
    base: ["1rem", "1.5rem"],
    lg: ["1.125rem", "1.75rem"],
    xl: ["1.25rem", "1.875rem"],
    "2xl": ["1.5rem", "2.25rem"],
    "3xl": ["2rem", "3rem"],
    "4xl": ["2.5rem", "4rem"],
    "5xl": ["4rem", "5rem"]
  },
  colors: {
    transparent: "transparent",
    inherit: "inherit",
    white: "hsl(var(--color-white) / <alpha-value>)",
    black: "hsl(var(--color-black) / <alpha-value>)",
    "gray-50": "hsl(var(--color-gray-50) / <alpha-value>)",
    "gray-100": "hsl(var(--color-gray-100) / <alpha-value>)",
    "gray-200": "hsl(var(--color-gray-200) / <alpha-value>)",
    "gray-300": "hsl(var(--color-gray-300) / <alpha-value>)",
    "gray-400": "hsl(var(--color-gray-400) / <alpha-value>)",
    "gray-500": "hsl(var(--color-gray-500) / <alpha-value>)",
    "gray-600": "hsl(var(--color-gray-600) / <alpha-value>)",
    "gray-700": "hsl(var(--color-gray-700) / <alpha-value>)",
    "gray-800": "hsl(var(--color-gray-800) / <alpha-value>)",
    "gray-900": "hsl(var(--color-gray-900) / <alpha-value>)",
    "slate-50": "hsl(var(--color-slate-50) / <alpha-value>)",
    "slate-100": "hsl(var(--color-slate-100) / <alpha-value>)",
    "slate-200": "hsl(var(--color-slate-200) / <alpha-value>)",
    "slate-300": "hsl(var(--color-slate-300) / <alpha-value>)",
    "slate-400": "hsl(var(--color-slate-400) / <alpha-value>)",
    "slate-500": "hsl(var(--color-slate-500) / <alpha-value>)",
    "slate-600": "hsl(var(--color-slate-600) / <alpha-value>)",
    "slate-700": "hsl(var(--color-slate-700) / <alpha-value>)",
    "slate-800": "hsl(var(--color-slate-800) / <alpha-value>)",
    "slate-900": "hsl(var(--color-slate-900) / <alpha-value>)",
    "slate-950": "hsl(var(--color-slate-950) / <alpha-value>)",
    "blue-100": "hsl(var(--color-blue-100) / <alpha-value>)",
    "blue-200": "hsl(var(--color-blue-200) / <alpha-value>)",
    "blue-300": "hsl(var(--color-blue-300) / <alpha-value>)",
    "blue-400": "hsl(var(--color-blue-400) / <alpha-value>)",
    "blue-500": "hsl(var(--color-blue-500) / <alpha-value>)",
    "blue-600": "hsl(var(--color-blue-600) / <alpha-value>)",
    "blue-700": "hsl(var(--color-blue-700) / <alpha-value>)",
    "blue-800": "hsl(var(--color-blue-800) / <alpha-value>)",
    "blue-900": "hsl(var(--color-blue-900) / <alpha-value>)",
    "green-100": "hsl(var(--color-green-100) / <alpha-value>)",
    "green-200": "hsl(var(--color-green-200) / <alpha-value>)",
    "green-300": "hsl(var(--color-green-300) / <alpha-value>)",
    "green-400": "hsl(var(--color-green-400) / <alpha-value>)",
    "green-500": "hsl(var(--color-green-500) / <alpha-value>)",
    "green-600": "hsl(var(--color-green-600) / <alpha-value>)",
    "green-700": "hsl(var(--color-green-700) / <alpha-value>)",
    "green-800": "hsl(var(--color-green-800) / <alpha-value>)",
    "green-900": "hsl(var(--color-green-900) / <alpha-value>)",
    "purple-100": "hsl(var(--color-purple-100) / <alpha-value>)",
    "purple-200": "hsl(var(--color-purple-200) / <alpha-value>)",
    "purple-300": "hsl(var(--color-purple-300) / <alpha-value>)",
    "purple-400": "hsl(var(--color-purple-400) / <alpha-value>)",
    "purple-500": "hsl(var(--color-purple-500) / <alpha-value>)",
    "purple-600": "hsl(var(--color-purple-600) / <alpha-value>)",
    "purple-700": "hsl(var(--color-purple-700) / <alpha-value>)",
    "purple-800": "hsl(var(--color-purple-800) / <alpha-value>)",
    "purple-900": "hsl(var(--color-purple-900) / <alpha-value>)",
    "red-100": "hsl(var(--color-red-100) / <alpha-value>)",
    "red-200": "hsl(var(--color-red-200) / <alpha-value>)",
    "red-300": "hsl(var(--color-red-300) / <alpha-value>)",
    "red-400": "hsl(var(--color-red-400) / <alpha-value>)",
    "red-500": "hsl(var(--color-red-500) / <alpha-value>)",
    "red-600": "hsl(var(--color-red-600) / <alpha-value>)",
    "red-700": "hsl(var(--color-red-700) / <alpha-value>)",
    "red-800": "hsl(var(--color-red-800) / <alpha-value>)",
    "red-900": "hsl(var(--color-red-900) / <alpha-value>)",
    "orange-100": "hsl(var(--color-orange-100) / <alpha-value>)",
    "orange-200": "hsl(var(--color-orange-200) / <alpha-value>)",
    "orange-300": "hsl(var(--color-orange-300) / <alpha-value>)",
    "orange-400": "hsl(var(--color-orange-400) / <alpha-value>)",
    "orange-500": "hsl(var(--color-orange-500) / <alpha-value>)",
    "orange-600": "hsl(var(--color-orange-600) / <alpha-value>)",
    "orange-700": "hsl(var(--color-orange-700) / <alpha-value>)",
    "orange-800": "hsl(var(--color-orange-800) / <alpha-value>)",
    "orange-900": "hsl(var(--color-orange-900) / <alpha-value>)"
  },
  boxShadow: {
    ...bu.boxShadow,
    sidebar: "var(--shadow-sidebar)",
    tooltip: "var(--shadow-tooltip)",
    button: "var(--shadow-button)",
    DEFAULT: "0px 4px 8px -4px rgba(0, 0, 0, 0.02), 0px -1px 1px 0px rgba(0, 0, 0, 0.04) inset"
  },
  extend: {
    gridTemplateColumns: {
      "form-columns": "max-content auto"
    },
    keyframes: {
      "fade-in": {
        "0%": { opacity: "0%" },
        "100%": { opacity: "100%" }
      },
      "fade-out": {
        "0%": { opacity: "100%" },
        "100%": { opacity: "0%" }
      },
      "zoom-in": {
        "0%": { transform: "scale(0.95)" },
        "100%": { transform: "scale(1)" }
      },
      "zoom-out": {
        "0%": { transform: "scale(1)" },
        "100%": { transform: "scale(0.95)" }
      }
    },
    animation: {
      "fade-in": "fade-in 300ms ease-in",
      "fade-out": "fade-out 200ms ease-out",
      "zoom-in": "zoom-in 300ms ease-in",
      "zoom-out": "zoom-out 200ms ease-out"
    }
  }
}, IR = [
  vR,
  hR(function({ addVariant: e }) {
    e("collapsed", ":merge(.group).collapsed &"), e("collapsing", ":merge(.group).collapsing &"), e("expanded", ":merge(.group).expanded &"), e("expanding", ":merge(.group).expanding &");
  })
], VL = {
  theme: CR,
  plugins: IR
};
export {
  gv as $,
  w9 as A,
  ie as B,
  F9 as C,
  G9 as D,
  q9 as E,
  Y9 as F,
  U9 as G,
  lo as H,
  Io as I,
  J9 as J,
  K9 as K,
  _9 as L,
  $9 as M,
  ev as N,
  tv as O,
  nv as P,
  rv as Q,
  iv as R,
  ov as S,
  sv as T,
  av as U,
  cv as V,
  uv as W,
  lv as X,
  dv as Y,
  Av as Z,
  fv as _,
  Ir as a,
  nL as a$,
  hv as a0,
  pv as a1,
  mv as a2,
  vv as a3,
  bv as a4,
  yv as a5,
  Cv as a6,
  Iv as a7,
  Ev as a8,
  xv as a9,
  jR as aA,
  WR as aB,
  Rw as aC,
  aH as aD,
  cH as aE,
  uA as aF,
  uH as aG,
  lH as aH,
  Zp as aI,
  Ea as aJ,
  lA as aK,
  Gp as aL,
  as as aM,
  ZR as aN,
  GR as aO,
  qR as aP,
  qp as aQ,
  YR as aR,
  UR as aS,
  JR as aT,
  KR as aU,
  _R as aV,
  $R as aW,
  AH as aX,
  eL as aY,
  tL as aZ,
  Yp as a_,
  Bv as aa,
  wv as ab,
  Pv as ac,
  Hv as ad,
  Ov as ae,
  Dv as af,
  Sv as ag,
  Nv as ah,
  Tv as ai,
  Rv as aj,
  ph as ak,
  FR as al,
  L6 as am,
  Mu as an,
  QR as ao,
  t3 as ap,
  XR as aq,
  Ei as ar,
  Ct as as,
  VR as at,
  xd as au,
  BC as av,
  kR as aw,
  mp as ax,
  MR as ay,
  zR as az,
  Qi as b,
  hL as b$,
  rL as b0,
  Mo as b1,
  iL as b2,
  oL as b3,
  _p as b4,
  sL as b5,
  xD as b6,
  BD as b7,
  ED as b8,
  vp as b9,
  Rr as bA,
  us as bB,
  er as bC,
  Lr as bD,
  cc as bE,
  ls as bF,
  ds as bG,
  As as bH,
  su as bI,
  au as bJ,
  cu as bK,
  hS as bL,
  pS as bM,
  fL as bN,
  mS as bO,
  vS as bP,
  bS as bQ,
  yS as bR,
  fA as bS,
  Tl as bT,
  Pr as bU,
  Rl as bV,
  Ll as bW,
  Pa as bX,
  Fl as bY,
  gL as bZ,
  Em as b_,
  XD as ba,
  aL as bb,
  cL as bc,
  MD as bd,
  Nr as be,
  vm as bf,
  bm as bg,
  ym as bh,
  ac as bi,
  Cm as bj,
  dS as bk,
  Zo as bl,
  en as bm,
  ki as bn,
  Tr as bo,
  lL as bp,
  dL as bq,
  M1 as br,
  Ot as bs,
  Wt as bt,
  Je as bu,
  Qs as bv,
  Jr as bw,
  Gt as bx,
  Im as by,
  AL as bz,
  hx as c,
  PL as c$,
  pL as c0,
  mL as c1,
  gA as c2,
  hA as c3,
  xm as c4,
  Bm as c5,
  vL as c6,
  bL as c7,
  yL as c8,
  CL as c9,
  T6 as cA,
  LR as cB,
  R6 as cC,
  hd as cD,
  gh as cE,
  hh as cF,
  rt as cG,
  uu as cH,
  Mi as cI,
  BL as cJ,
  Ql as cK,
  pr as cL,
  _S as cM,
  qt as cN,
  Yo as cO,
  eN as cP,
  $S as cQ,
  tN as cR,
  nN as cS,
  wL as cT,
  Rm as cU,
  oN as cV,
  sN as cW,
  cN as cX,
  uN as cY,
  Lm as cZ,
  bA as c_,
  IL as ca,
  BS as cb,
  pA as cc,
  wS as cd,
  PS as ce,
  HS as cf,
  EL as cg,
  xL as ch,
  mA as ci,
  DR as cj,
  Et as ck,
  Yg as cl,
  Ug as cm,
  Jg as cn,
  OR as co,
  Kg as cp,
  Y as cq,
  gn as cr,
  fd as cs,
  O6 as ct,
  D6 as cu,
  S6 as cv,
  N6 as cw,
  TR as cx,
  RR as cy,
  gd as cz,
  tx as d,
  xA as d$,
  ji as d0,
  Wi as d1,
  AN as d2,
  Tt as d3,
  fN as d4,
  gN as d5,
  Xl as d6,
  EN as d7,
  Wm as d8,
  xN as d9,
  TL as dA,
  Fr as dB,
  OT as dC,
  DT as dD,
  RL as dE,
  LL as dF,
  QL as dG,
  XL as dH,
  hN as dI,
  pN as dJ,
  mN as dK,
  vN as dL,
  HL as dM,
  Xm as dN,
  bN as dO,
  yN as dP,
  OL as dQ,
  yA as dR,
  CA as dS,
  Vm as dT,
  km as dU,
  Mm as dV,
  zm as dW,
  IA as dX,
  jm as dY,
  CN as dZ,
  EA as d_,
  BN as da,
  wN as db,
  DL as dc,
  Zm as dd,
  HN as de,
  ON as df,
  Zi as dg,
  cT as dh,
  uT as di,
  lT as dj,
  AT as dk,
  SL as dl,
  Um as dm,
  fT as dn,
  NL as dp,
  Jm as dq,
  hT as dr,
  IT as ds,
  ET as dt,
  BT as du,
  wT as dv,
  Km as dw,
  PT as dx,
  HT as dy,
  un as dz,
  p3 as e,
  IN as e0,
  Vl as e1,
  BA as e2,
  s0 as e3,
  dR as e4,
  OA as e5,
  AR as e6,
  A9 as e7,
  fR as e8,
  lc as e9,
  gR as ea,
  VL as eb,
  P9 as f,
  kd as g,
  H9 as h,
  Jn as i,
  O9 as j,
  D9 as k,
  S9 as l,
  N9 as m,
  T9 as n,
  R9 as o,
  L9 as p,
  Q9 as q,
  X9 as r,
  jn as s,
  V9 as t,
  k9 as u,
  M9 as v,
  z9 as w,
  j9 as x,
  W9 as y,
  Z9 as z
};
//# sourceMappingURL=index-CiVw3DvW.js.map
